import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { cssVar, forwardRef, Box as Box$1, useStyleConfig, chakra, theme as theme$1, shouldForwardProp, Tooltip as Tooltip$1, Text as Text$1, Kbd, useMultiStyleConfig, useControllableState, useSafeLayoutEffect, VisuallyHidden, IconButton as IconButton$1, Icon, useTheme, getCSSVar, CircularProgress, Image, Badge as Badge$1, Button as Button$1, Flex, useMergeRefs, Textarea as Textarea$1, useCheckbox, useRadioGroupContext, useRadio, RadioGroup as RadioGroup$1, Stack, useCallbackRef, Avatar as Avatar$1, useToken, useModalContext, Portal as Portal$1, Popover as Popover$1, PopoverTrigger as PopoverTrigger$1, PopoverContent as PopoverContent$1, PopoverBody as PopoverBody$1, useFormControl, MenuButton as MenuButton$1, MenuItem as MenuItem$1, Menu as Menu$1, useMenuContext as useMenuContext$1, useMenuDescendantsContext, MenuList as MenuList$1, Checkbox as Checkbox$1, VStack, useClipboard, Code as Code$1, InputGroup, InputLeftElement, Input, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Drawer as Drawer$1, DrawerOverlay, DrawerContent, useOutsideClick, Heading as Heading$1, MenuOptionGroup, MenuItemOption, FormControl, FormLabel, FormHelperText, FormErrorMessage, Link as Link$1, useFormControlContext, MenuDivider as MenuDivider$1, Slider as Slider$1, SliderThumb, SliderTrack, InputLeftAddon, InputRightElement, Switch as Switch$1, useTab, useTabsStyles, TabList as TabList$1, TabIndicator, TabPanel as TabPanel$1, TabPanels as TabPanels$1, useId as useId$1, Tabs as Tabs$1, mergeThemeOverride, ChakraProvider, DrawerHeader, DrawerBody, DrawerFooter } from '@chakra-ui/react';
export { Accordion as ChakraAccordion, AccordionButton as ChakraAccordionButton, AccordionItem as ChakraAccordionItem, AccordionPanel as ChakraAccordionPanel, AspectRatio as ChakraAspectRatio, ListItem as ChakraListItem, Menu as ChakraMenu, MenuButton as ChakraMenuButton, MenuGroup as ChakraMenuGroup, MenuItem as ChakraMenuItem, MenuList as ChakraMenuList, Modal as ChakraModal, ModalBody as ChakraModalBody, ModalContent as ChakraModalContent, ModalFooter as ChakraModalFooter, ModalHeader as ChakraModalHeader, ModalOverlay as ChakraModalOverlay, OrderedList as ChakraOrderedList, ChakraProvider, Tooltip as ChakraTooltip, UnorderedList as ChakraUnorderedList, VisuallyHidden as ChakraVisuallyHidden, DrawerBody, DrawerFooter, DrawerHeader, FormErrorMessage, chakra, useBreakpointValue, useClipboard, useDisclosure, useMergeRefs, useOutsideClick, useSize, useStyleConfig, useToken } from '@chakra-ui/react';
import { motion, isValidMotionProp, AnimatePresence, useReducedMotion, LayoutGroup, MotionConfig as MotionConfig$1 } from 'motion/react';
import { useMemo, forwardRef as forwardRef$1, useState, useCallback, useEffect, isValidElement, cloneElement, useId, useRef, createContext, useContext, Children, Fragment as Fragment$1, useReducer, useLayoutEffect } from 'react';
import { debounce, isEqual, pick, omit, get } from 'lodash-es';
import { keyframes, Global } from '@emotion/react';
import BoringAvatar from 'boring-avatars';
import Prando from 'prando';
import { useMultipleSelection, useCombobox, useSelect } from 'downshift';
import { matchSorter } from 'match-sorter';
import Papa from 'papaparse';
import { useFocusRing, useFocusManager, FocusScope, useLocale, useNumberField } from 'react-aria';
import { useVirtualizer } from '@tanstack/react-virtual';
import { RemoveScroll } from 'react-remove-scroll';
import { toast, Toaster } from 'react-hot-toast';
import stripIndent from 'strip-indent';
import { Balancer, Provider } from 'react-wrap-balancer';
import prettyBytes from 'pretty-bytes';
import { useDropzone } from 'react-dropzone-esm';
import { useNProgress } from '@tanem/react-nprogress';
import delay from 'delay';
import isPromise from 'p-is-promise';
import { useNumberFieldState } from 'react-stately';
import { MotionConfig } from 'framer-motion';
import { Fireworks } from '@fireworks-js/react';

/**
 * The CSS custom property exposed to descendants that describes the semantic
 * theme of the nearest surface. Useful as an escape hatch for downstream
 * styling, e.g. via `[style*="--htui-surface: dark"]` or by reading the value
 * with `getComputedStyle`.
 */
const $surface = cssVar("htui-surface");
/**
 * Resting background for descendant form elements.
 */
const $surfaceBg = cssVar("htui-form-surface-bg");
/**
 * Hover/focus/expanded background for descendant form elements.
 *
 * - On a light surface this is white (the form element "lifts" out of the
 *   surrounding grey-ish resting state).
 * - On a dark surface this stays white as well, matching the resting state, so
 *   the hover affordance is provided by the border instead of by flipping the
 *   fill back to grey.
 */
const $surfaceBgHover = cssVar("htui-form-surface-bg-hover");
/**
 * Hover border color for descendant form elements. Defaults to
 * `base.borderHover` (gray.400) on a light surface and a slightly darker
 * `gray.500` on a dark surface so hover stays visible when the bg doesn't
 * change.
 */
const $surfaceBorderHover = cssVar("htui-form-surface-border-hover");
/**
 * Resting background for form addons (e.g. the slug input prefix).
 *
 * - Light surface: `base.background` (gray.100).
 * - Dark surface: `white`.
 */
const $surfaceAddonBg = cssVar("htui-form-surface-addon-bg");
/**
 * Text color for form addons.
 *
 * - Light surface: `text.secondary`.
 * - Dark surface: `text.tertiary`.
 */
const $surfaceAddonColor = cssVar("htui-form-surface-addon-color");
/**
 * Resting background for the rail of descendant segmented controls.
 *
 * - Light surface: `base.background` (gray.100).
 * - Dark surface: `base.backgroundHover` (gray.200), one step darker so the
 *   rail still reads against a grey surface.
 */
const $surfaceTrackBg = cssVar("htui-form-surface-track-bg");
/**
 * Background of a descendant agent card, the inverse of its surface so the
 * card stands out in chat.
 *
 * - Light surface: `base.background` (gray.100).
 * - Dark surface: `white`.
 */
const $surfaceAgentCardBg = cssVar("htui-agent-card-bg");
/**
 * Shadow of a descendant agent card.
 *
 * - Light surface: `xs`, whose inset hairline draws the card's edge.
 * - Dark surface: `sm`.
 */
const $surfaceAgentCardShadow = cssVar("htui-agent-card-shadow");
/**
 * Resting background of the choice rows inside a descendant agent card.
 *
 * - Light surface: `base.backgroundHover` (gray.200), against the gray card.
 * - Dark surface: `base.background` (gray.100), against the white card.
 */
const $surfaceAgentCardRowBg = cssVar("htui-agent-card-row-bg");
/**
 * Hover background of the choice rows inside a descendant agent card.
 *
 * - Light surface: `base.backgroundPressed` (gray.300).
 * - Dark surface: `base.backgroundHover` (gray.200).
 */
const $surfaceAgentCardRowBgHover = cssVar("htui-agent-card-row-bg-hover");
const formSurfaceVars = {
    light: {
        [$surface.variable]: "light",
        [$surfaceBg.variable]: "var(--chakra-colors-base-lightBackground)",
        [$surfaceBgHover.variable]: "var(--chakra-colors-white)",
        [$surfaceBorderHover.variable]: "var(--chakra-colors-base-borderHover)",
        [$surfaceAddonBg.variable]: "var(--chakra-colors-base-background)",
        [$surfaceAddonColor.variable]: "var(--chakra-colors-text-secondary)",
        [$surfaceTrackBg.variable]: "var(--chakra-colors-base-background)",
    },
    dark: {
        [$surface.variable]: "dark",
        [$surfaceBg.variable]: "var(--chakra-colors-white)",
        [$surfaceBgHover.variable]: "var(--chakra-colors-white)",
        [$surfaceBorderHover.variable]: "var(--chakra-colors-gray-500)",
        [$surfaceAddonBg.variable]: "var(--chakra-colors-white)",
        [$surfaceAddonColor.variable]: "var(--chakra-colors-text-tertiary)",
        [$surfaceTrackBg.variable]: "var(--chakra-colors-base-backgroundHover)",
    },
};
const agentCardInnerVariable = (variable) => `${variable}-agent-card-inner`;
// Each surface also carries the opposite surface's form values, for the agent card to hand down.
const agentCardInnerVars = (surface) => Object.fromEntries(Object.entries(formSurfaceVars[surface === "light" ? "dark" : "light"]).map(([variable, value]) => [agentCardInnerVariable(variable), value]));
/**
 * Form surface variables an agent card sets on itself, so descendant form
 * elements adapt to the card's inverted background instead of the chat's.
 */
const agentCardSurfaceVars = Object.fromEntries(Object.keys(formSurfaceVars.light).map((variable) => [
    variable,
    `var(${agentCardInnerVariable(variable)})`,
]));
/**
 * The CSS custom properties emitted on the nearest surface for each `Surface`
 * variant. Spread on `:root` to seed defaults, and onto Box/Row/Column when
 * their `bg` resolves to a recognized surface token (or when an explicit
 * `surface` prop is provided).
 */
const surfaceVars = {
    light: {
        ...formSurfaceVars.light,
        ...agentCardInnerVars("light"),
        [$surfaceAgentCardBg.variable]: "var(--chakra-colors-base-background)",
        [$surfaceAgentCardShadow.variable]: "var(--chakra-shadows-xs)",
        [$surfaceAgentCardRowBg.variable]: "var(--chakra-colors-base-backgroundHover)",
        [$surfaceAgentCardRowBgHover.variable]: "var(--chakra-colors-base-backgroundPressed)",
    },
    dark: {
        ...formSurfaceVars.dark,
        ...agentCardInnerVars("dark"),
        [$surfaceAgentCardBg.variable]: "var(--chakra-colors-white)",
        [$surfaceAgentCardShadow.variable]: "var(--chakra-shadows-sm)",
        [$surfaceAgentCardRowBg.variable]: "var(--chakra-colors-base-background)",
        [$surfaceAgentCardRowBgHover.variable]: "var(--chakra-colors-base-backgroundHover)",
    },
};
/**
 * Tokens recognised as "white-like" surfaces. When a Box/Row/Column has its
 * background set to one of these, the surface is considered `light`.
 */
const lightSurfaceTokens = new Set([
    "white",
    "base.white",
    "#fff",
    "#ffffff",
    "rgb(255,255,255)",
    "rgb(255, 255, 255)",
]);
/**
 * Tokens recognised as "grey-like" surfaces. When a Box/Row/Column has its
 * background set to one of these, the surface is considered `dark`.
 */
const darkSurfaceTokens = new Set([
    "base.lightBackground",
    "base.background",
    "base.backgroundHover",
    "base.backgroundPressed",
    "base.backgroundDisabled",
    "chakra-body-bg",
    "gray.50",
    "gray.100",
    "gray.200",
]);
const normalize = (value) => value.trim().toLowerCase();
/**
 * Maps a Chakra background token (or raw CSS color) to a semantic Surface.
 * Returns `undefined` when the value isn't recognised so the surrounding
 * surface can be inherited from an ancestor.
 */
function resolveSurface(bg) {
    if (typeof bg !== "string" || bg.length === 0) {
        return undefined;
    }
    const normalized = normalize(bg);
    if (lightSurfaceTokens.has(normalized)) {
        return "light";
    }
    if (darkSurfaceTokens.has(bg) || darkSurfaceTokens.has(normalized)) {
        return "dark";
    }
    return undefined;
}
/**
 * Returns inline style overrides that announce the surface to descendant form
 * elements via CSS custom properties. Returns `undefined` when no surface
 * could be inferred so existing inheritance is preserved.
 */
function getSurfaceStyle(bg) {
    const surface = resolveSurface(bg);
    if (!surface) {
        return undefined;
    }
    return surfaceVars[surface];
}
/**
 * Hook used by `Box`/`Row`/`Column` to merge an explicit `surface` prop or a
 * recognized `bg` token with the consumer's `style` prop into a single inline
 * style object that emits the surface CSS variables for descendants.
 */
function useSurfaceStyle({ surface, bg, bgColor, background, backgroundColor, style, }) {
    return useMemo(() => {
        const surfaceStyle = surface
            ? surfaceVars[surface]
            : getSurfaceStyle(bg ?? bgColor ?? background ?? backgroundColor);
        if (!surfaceStyle)
            return style;
        if (!style)
            return surfaceStyle;
        return { ...surfaceStyle, ...style };
    }, [surface, bg, bgColor, background, backgroundColor, style]);
}

const Box = forwardRef(function Box_({ style, surface, bg, bgColor, background, backgroundColor, ...props }, ref) {
    const mergedStyle = useSurfaceStyle({
        surface,
        bg,
        bgColor,
        background,
        backgroundColor,
        style,
    });
    return (jsx(Box$1, { ref: ref, bg: bg, bgColor: bgColor, background: background, backgroundColor: backgroundColor, ...props, style: mergedStyle }));
});
Box.displayName = "Box";

const BookIcon = forwardRef$1(function BookIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H10C10 21.5523 9.55228 22 9 22C8.44772 22 8 21.5523 8 21H7C5.34315 21 4 19.6569 4 18V6C4 4.34315 5.34315 3 7 3H18ZM7 5C6.44772 5 6 5.44772 6 6V18C6 18.5523 6.44772 19 7 19H8V5H7ZM10 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H10V19ZM15 11C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11H15ZM16 7C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H13C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7H16Z" }) });
});
BookIcon.displayName = "BookIcon";

const ActivityIcon = forwardRef$1(function ActivityIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M14 3C15.6569 3 17 4.34315 17 6V11H19C20.6569 11 22 12.3431 22 14V17.5C22 19.433 20.433 21 18.5 21H5.5C3.567 21 2 19.433 2 17.5V6C2 4.34315 3.34315 3 5 3H14ZM5 5C4.44771 5 4 5.44771 4 6V17.5C4 18.3284 4.67158 19 5.5 19H15.3369C15.1209 18.5454 15 18.0368 15 17.5V6C15 5.4477 14.5523 5 14 5H5ZM17 17.5C17 18.3284 17.6716 19 18.5 19C19.3284 19 20 18.3284 20 17.5V14C20 13.4477 19.5523 13 19 13H17V17.5ZM12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H7C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15H12ZM12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H12ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H7C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7H12Z" }) });
});
ActivityIcon.displayName = "ActivityIcon";

const AddBoxIcon = forwardRef$1(function AddBoxIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.999 2C17.5209 2.00019 21.9969 6.4772 21.9971 11.999C21.9969 17.5209 17.5209 21.9969 11.999 21.9971C6.4772 21.9969 2.00019 17.5209 2 11.999C2.00021 6.47722 6.47722 2.00021 11.999 2ZM11.999 4C7.58179 4.00021 4.00021 7.58179 4 11.999C4.00019 16.4163 7.58177 19.9969 11.999 19.9971C16.4163 19.9969 19.9969 16.4163 19.9971 11.999C19.9969 7.58177 16.4163 4.00019 11.999 4ZM11.999 7C12.5513 7 12.999 7.44772 12.999 8V10.999H15.999L16.1006 11.0039C16.6049 11.0551 16.999 11.4812 16.999 11.999C16.999 12.5165 16.6054 12.9425 16.1016 12.9941L15.999 12.999H12.999V15.999C12.9986 16.551 12.5511 16.999 11.999 16.999C11.447 16.999 10.9994 16.551 10.999 15.999V12.999H8C7.44773 12.999 7.00001 12.5513 7 11.999C7.00011 11.4468 7.44779 10.999 8 10.999H10.999V8C10.999 7.44772 11.4467 7 11.999 7Z" }) });
});
AddBoxIcon.displayName = "AddBoxIcon";

const AddFilterIcon = forwardRef$1(function AddFilterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.1025 16.0049C13.6067 16.0562 14 16.4823 14 17C14 17.5177 13.6067 17.9438 13.1025 17.9951L13 18H11C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16H13L13.1025 16.0049ZM16 9C16.5205 9.00014 16.9421 9.42195 16.9424 9.94238V11.0566H18.0576L18.0771 11.0576L18.1299 11.0596L18.1533 11.0615C18.6287 11.1101 19 11.5115 19 12C18.9999 12.4881 18.6285 12.8887 18.1533 12.9375C18.1457 12.9383 18.1375 12.9401 18.1299 12.9404L18.0771 12.9424H16.9424V14.0576C16.9419 14.5774 16.5208 14.9999 16 15C15.4791 15 15.0571 14.5775 15.0566 14.0576V12.9424H13.9424C13.4219 12.9421 13.0001 12.5204 13 12C13.0001 11.4796 13.4218 11.0569 13.9424 11.0566H15.0566V9.94238C15.0569 9.42187 15.4794 9 16 9ZM10.1025 11.0049C10.6067 11.0562 11 11.4823 11 12C11 12.5177 10.6067 12.9438 10.1025 12.9951L10 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H10L10.1025 11.0049ZM19 6C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H19Z", fill: "currentColor" }) });
});
AddFilterIcon.displayName = "AddFilterIcon";

const AddTimeRangeIcon = forwardRef$1(function AddTimeRangeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C12.5 2 13 2.5 13 3C13 3.5 12.5 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.4096 20.5 11 21 11C21.5 11 22 11.3791 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 7C12.5523 7 13 7.44772 13 8V11.5859L15.207 13.793C15.5976 14.1835 15.5976 14.8165 15.207 15.207C14.8165 15.5976 14.1835 15.5976 13.793 15.207L11.293 12.707C11.1054 12.5195 11 12.2652 11 12V8C11 7.44772 11.4477 7 12 7ZM19 1C19.5523 1 20 1.44772 20 2V4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H20V8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8V6H16C15.4477 6 15 5.55228 15 5C15 4.44772 15.4477 4 16 4H18V2C18 1.44772 18.4477 1 19 1Z", fill: "currentColor" }) });
});
AddTimeRangeIcon.displayName = "AddTimeRangeIcon";

const AdminConfigIcon = forwardRef$1(function AdminConfigIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M19.149 13C19.3928 13 19.6055 13.1659 19.6646 13.4023L19.8512 14.1484C19.9239 14.4399 20.2235 14.6129 20.5123 14.5303L21.2525 14.3193C21.4868 14.2524 21.7361 14.3534 21.858 14.5645L22.5064 15.6855C22.6282 15.8966 22.5899 16.1635 22.4146 16.333L21.8629 16.8672C21.6468 17.0759 21.6469 17.422 21.8629 17.6309L22.4166 18.167C22.5915 18.3365 22.6292 18.6035 22.5074 18.8145L21.859 19.9355C21.7371 20.1465 21.4878 20.2476 21.2535 20.1807L20.5123 19.9688C20.2235 19.8862 19.9239 20.0592 19.8512 20.3506L19.6646 21.0977C19.6056 21.3341 19.3928 21.5 19.149 21.5H17.8541C17.6104 21.5 17.3977 21.3342 17.3385 21.0977L17.1519 20.3516C17.079 20.0602 16.7785 19.8871 16.4898 19.9697L15.7506 20.1807C15.5162 20.2475 15.267 20.1466 15.1451 19.9355L14.4967 18.8145C14.3748 18.6035 14.4126 18.3365 14.5875 18.167L15.1412 17.6309C15.3569 17.4221 15.357 17.0759 15.1412 16.8672L14.5885 16.333C14.4136 16.1635 14.3759 15.8965 14.4976 15.6855L15.1461 14.5645C15.268 14.3535 15.5173 14.2525 15.7515 14.3193L16.4898 14.5303C16.7785 14.6127 17.0789 14.4396 17.1519 14.1484L17.3385 13.4023C17.3977 13.1659 17.6104 13 17.8541 13H19.149ZM12.0006 12C12.5528 12 13.0006 12.4477 13.0006 13C13.0006 13.5523 12.5528 14 12.0006 14C9.05045 14.0002 6.83762 15.7328 5.92146 18.21C5.85321 18.3946 5.88788 18.5559 6.01131 18.7031C6.14864 18.8668 6.39653 18.9999 6.69783 19H11.0006C11.5528 19 12.0006 19.4477 12.0006 20C12.0006 20.5523 11.5528 21 11.0006 21H6.69783C5.82098 20.9999 5.00637 20.6167 4.47908 19.9883C3.93823 19.3434 3.7052 18.4358 4.04549 17.5156C5.23634 14.2962 8.16912 12.0002 12.0006 12ZM18.5006 15.75C17.6722 15.75 17.0006 16.4216 17.0006 17.25C17.0006 18.0784 17.6722 18.75 18.5006 18.75C19.3289 18.7499 20.0006 18.0784 20.0006 17.25C20.0006 16.4216 19.3289 15.7501 18.5006 15.75ZM11.9996 2C14.4849 2 16.4996 4.01472 16.4996 6.5C16.4996 8.98528 14.4849 11 11.9996 11C9.51449 10.9998 7.49959 8.98515 7.49959 6.5C7.49959 4.01485 9.51449 2.00022 11.9996 2ZM11.9996 4C10.6191 4.00022 9.49959 5.11942 9.49959 6.5C9.49959 7.88058 10.6191 8.99978 11.9996 9C13.3803 9 14.4996 7.88072 14.4996 6.5C14.4996 5.11928 13.3803 4 11.9996 4Z" }) });
});
AdminConfigIcon.displayName = "AdminConfigIcon";

const AgentFileIcon = forwardRef$1(function AgentFileIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M17 2C18.6569 2 20 3.34315 20 5V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V5C18 4.44771 17.5523 4 17 4H7C6.44771 4 6 4.44771 6 5V19C6 19.5523 6.44771 20 7 20H12C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H17ZM18 14C18.241 14 18.4574 14.1482 18.5439 14.373L19.2402 16.1855C19.3417 16.4495 19.5505 16.6583 19.8145 16.7598L21.627 17.4561C21.8518 17.5426 22 17.759 22 18C22 18.241 21.8518 18.4574 21.627 18.5439L19.8145 19.2402C19.5505 19.3417 19.3417 19.5505 19.2402 19.8145L18.5439 21.627C18.4574 21.8518 18.241 22 18 22C17.759 22 17.5426 21.8518 17.4561 21.627L16.7598 19.8145C16.6583 19.5505 16.4495 19.3417 16.1855 19.2402L14.373 18.5439C14.1482 18.4574 14 18.241 14 18C14 17.759 14.1482 17.5426 14.373 17.4561L16.1855 16.7598C16.4495 16.6583 16.6583 16.4495 16.7598 16.1855L17.4561 14.373C17.5426 14.1482 17.759 14 18 14ZM12 10C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H9C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10H12ZM15 6C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H9C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6H15Z" }) });
});
AgentFileIcon.displayName = "AgentFileIcon";

const AgentsLineIcon = forwardRef$1(function AgentsLineIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M16.6315 16.201L15.6285 18.2518C15.0057 19.5255 13.1245 19.5255 13.1842 18.2518V17.1959C13.2052 16.7423 14.2712 16.2746 14.6061 16.2332L16.4926 16C16.6013 15.9866 16.6795 16.1027 16.6315 16.201Z", fill: "currentColor" }), jsx("path", { d: "M16.4926 4.95496C17.1198 3.67308 19.0143 3.68515 18.936 4.97059L18.8119 7.0077C18.7744 7.6216 18.9074 8.17787 19.1796 8.63878C19.3195 8.87567 19.0794 9.38465 18.8076 9.34169L16.2563 8.93836C15.5825 8.8317 15.1445 8.3424 15.1213 7.6922C15.0957 6.97239 16.1802 5.59346 16.4926 4.95496Z", fill: "currentColor" }), jsx("path", { d: "M12.0773 4C12.5338 4.00312 13.0333 4.15291 13.4181 4.53125C13.8176 4.9241 13.9891 5.46055 13.9571 6.02148L13.8419 8.04688C13.7828 9.08631 14.3426 9.75693 15.1944 9.90918L21.7687 11.084C22.1805 11.1576 22.5409 11.4053 22.7355 11.7939C22.9116 12.146 22.9017 12.5106 22.8321 12.7871C22.6968 13.3246 22.2399 13.8862 21.5128 14.0029L14.4298 15.1406C13.2803 15.3251 12.1103 16.2256 11.5616 17.4277L10.631 19.4658C10.1821 20.4492 9.24922 21 8.34972 21C7.89558 21 7.39791 20.8557 7.01085 20.4844C6.60853 20.0983 6.42975 19.5662 6.45421 19.0068L6.54894 16.832C6.5917 15.8507 6.0788 15.2103 5.30285 15.0264L3.31066 14.5547C2.7404 14.4197 2.29599 14.064 2.06066 13.5645C1.84036 13.0968 1.84289 12.5918 1.94933 12.166C2.15884 11.3282 2.85304 10.4828 3.92003 10.2568L6.14855 9.78516C7.25994 9.54972 8.35143 8.66846 8.87316 7.52539L9.78234 5.53418C10.2339 4.54493 11.1733 3.99393 12.0773 4ZM11.9532 6.02148C11.841 6.06055 11.6954 6.15917 11.6017 6.36426L10.6925 8.35547C9.92423 10.0387 8.33322 11.3673 6.56261 11.7422L4.3341 12.2139C4.11903 12.2596 3.94796 12.4433 3.89367 12.6367L5.76281 13.0801C7.56369 13.5064 8.62864 15.0751 8.54796 16.9199L8.45714 18.9775C8.57007 18.9386 8.71781 18.8412 8.81164 18.6357L9.74132 16.5967C10.5453 14.8352 12.2505 13.465 14.1124 13.166L18.2931 12.4941L14.8429 11.8779C12.9058 11.5318 11.7332 9.89014 11.8448 7.93262L11.9532 6.02148Z", fill: "currentColor" })] });
});
AgentsLineIcon.displayName = "AgentsLineIcon";

const AgentsIcon = forwardRef$1(function AgentsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsxs("g", { clipPath: "url(#clip0_5738_145010)", children: [jsx("path", { opacity: 0.6, d: "M16.2688 15.9118L15.2659 17.9625C14.643 19.2362 12.7619 19.2362 12.8216 17.9625L12.8803 16.693C12.8833 16.6267 12.9123 16.5639 12.963 16.5212C13.3311 16.2114 13.7833 16.0008 14.2435 15.944L16.13 15.7107C16.2386 15.6973 16.3169 15.8134 16.2688 15.9118V15.9118ZM24.6048 12.15L24.6966 12.1647L22.8069 11.8659L24.6048 12.15ZM28.0657 10.9371C28.6006 11.0265 28.3905 11.803 27.8079 11.8903L27.2713 11.9704C27.1135 11.994 26.9755 11.865 26.9621 11.706C26.9536 11.6042 26.9371 11.5048 26.9122 11.4087C26.8491 11.1651 27.0816 10.7727 27.3298 10.8142L28.0657 10.9371ZM16.3128 4.77991C16.94 3.49803 18.8345 3.5101 18.7561 4.79554L18.6321 6.83265C18.5946 7.44655 18.7276 8.00282 18.9998 8.46373C19.1397 8.70063 18.8996 9.2096 18.6278 9.16664L16.0765 8.76331C15.4027 8.65665 14.9647 8.16735 14.9415 7.51715C14.9397 7.467 14.9563 7.4182 14.9845 7.37675C15.1145 7.18631 15.232 6.98889 15.3323 6.78382L16.3128 4.77991Z", fill: "currentColor" }), jsx("path", { d: "M10.5599 5.71344C11.187 4.43117 13.0825 4.44328 13.004 5.72905L12.8795 7.76626C12.7873 9.27418 13.7214 10.438 15.2249 10.6887L22.3129 11.8706C22.8479 11.9599 22.6384 12.7366 22.0557 12.8239L14.419 13.968C12.7955 14.2112 11.2457 15.3537 10.5164 16.8448L9.51333 18.896C8.89046 20.1696 7.00878 20.1696 7.06846 18.896L7.17098 16.708C7.23762 15.2859 6.38705 14.174 4.99773 13.8671L2.85025 13.3927C1.60883 13.1185 2.09433 11.3065 3.48272 11.0323L5.88443 10.5579C7.43822 10.251 8.88465 9.13912 9.58011 7.71702L10.5599 5.71344Z", fill: "currentColor" })] }), jsx("defs", { children: jsx("clipPath", { id: "clip0_5738_145010", children: jsx("rect", { width: 24, height: 24, fill: "white" }) }) })] });
});
AgentsIcon.displayName = "AgentsIcon";

const AiSummaryIcon = forwardRef$1(function AiSummaryIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 15.9996C12.5522 15.9996 12.9998 16.4475 13 16.9996C13 17.5519 12.5523 17.9996 12 17.9996H3C2.44772 17.9996 2 17.5519 2 16.9996C2.0002 16.4475 2.44784 15.9996 3 15.9996H12ZM15.2178 6.63831C15.3989 5.79582 16.6011 5.79582 16.7822 6.63831L17.2158 8.65393C17.4454 9.72168 18.2798 10.5557 19.3477 10.7848L21.3633 11.2174C22.2061 11.3983 22.2061 12.601 21.3633 12.7819L19.3477 13.2145C18.2798 13.4435 17.4454 14.2776 17.2158 15.3453L16.7822 17.3619C16.6008 18.2039 15.3992 18.2038 15.2178 17.3619L14.7842 15.3453C14.5546 14.2776 13.7202 13.4435 12.6523 13.2145L10.6367 12.7819C9.79376 12.601 9.79376 11.3982 10.6367 11.2174L12.6523 10.7848C13.7202 10.5557 14.5546 9.72168 14.7842 8.65393L15.2178 6.63831ZM7 10.9996C7.55216 10.9996 7.9998 11.4475 8 11.9996C8 12.5519 7.55228 12.9996 7 12.9996H3C2.44772 12.9996 2 12.5519 2 11.9996C2.0002 11.4475 2.44784 10.9996 3 10.9996H7ZM12 5.99963C12.5522 5.99963 12.9998 6.44752 13 6.99963C13 7.55192 12.5523 7.99963 12 7.99963H3C2.44772 7.99963 2 7.55192 2 6.99963C2.0002 6.44752 2.44784 5.99963 3 5.99963H12Z" }) });
});
AiSummaryIcon.displayName = "AiSummaryIcon";

const AlertIcon = forwardRef$1(function AlertIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.1123 3C15.6329 3.00025 18.5351 5.76106 18.7109 9.27734L18.8701 12.4668L18.8789 12.5469C18.8912 12.6266 18.9151 12.7041 18.9512 12.7764L20.042 14.957L20.1211 15.1406C20.1891 15.3281 20.2236 15.5265 20.2236 15.7266C20.2236 16.6759 19.4542 17.4461 18.5049 17.4463H16.5566C16.1004 19.481 14.2837 21.002 12.1113 21.002C9.93917 21.0017 8.12295 19.4809 7.66699 17.4463H5.71875C4.82879 17.446 4.09676 16.7692 4.00879 15.9023L4 15.7266L4.01172 15.5273C4.0348 15.3297 4.09215 15.137 4.18164 14.958L5.27246 12.7764L5.30469 12.7021C5.33286 12.6271 5.34946 12.5481 5.35352 12.4678L5.5127 9.27734L5.53711 8.9502C5.87043 5.59118 8.70144 3.00001 12.1123 3ZM9.75977 17.4463C10.1491 18.3603 11.0551 19.0017 12.1113 19.002C13.1678 19.002 14.0753 18.3606 14.4648 17.4463H9.75977ZM12.1123 5C9.73383 5.00001 7.75963 6.807 7.52734 9.14941L7.51074 9.37695L7.35059 12.5674C7.33617 12.8554 7.27694 13.1386 7.17578 13.4072L7.06152 13.6709L6.17383 15.4463H18.0498L17.1631 13.6709C17.0341 13.413 16.9463 13.1371 16.9023 12.8535L16.873 12.5674L16.7129 9.37695C16.5902 6.92522 14.5671 5.00025 12.1123 5Z" }) });
});
AlertIcon.displayName = "AlertIcon";

const AlertingIcon = forwardRef$1(function AlertingIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M11.0007 5C14.742 5 17.9283 7.72686 18.3982 11.4014L18.9793 15.9463C19.1896 17.5922 17.8785 19 16.2468 19H5.75465C4.12297 19 2.81185 17.5922 3.02223 15.9463L3.60329 11.4014C4.07316 7.72685 7.25956 5 11.0007 5ZM11.0007 7C8.23114 7 5.92544 9.01325 5.58766 11.6553L5.00661 16.2002C4.95561 16.6005 5.27723 17 5.75465 17H16.2468C16.7243 17 17.0459 16.6004 16.9949 16.2002L16.4138 11.6553C16.076 9.01324 13.7703 7 11.0007 7Z" }), jsx("path", { fill: "currentColor", d: "M6.00075 18C6.00075 17.4477 6.44846 17 7.00075 17C7.55303 17 8.00075 17.4477 8.00075 18C8.00075 19.6568 9.3439 21 11.0007 21C12.6576 21 14.0007 19.6568 14.0007 18C14.0007 17.4477 14.4485 17 15.0007 17C15.553 17 16.0007 17.4477 16.0007 18C16.0007 20.7614 13.7621 23 11.0007 23C8.23932 23 6.00075 20.7614 6.00075 18Z" }), jsx("path", { fill: "currentColor", d: "M15.0007 3V2C15.0007 1.44772 15.4485 1 16.0007 1C16.553 1 17.0007 1.44772 17.0007 2V3C17.0007 3.55228 16.553 4 16.0007 4C15.4485 4 15.0007 3.55228 15.0007 3Z" }), jsx("path", { fill: "currentColor", d: "M19.2937 2.29289C19.6842 1.90237 20.3173 1.90237 20.7078 2.29289C21.0983 2.68342 21.0983 3.31643 20.7078 3.70696L19.7078 4.70696C19.3173 5.09748 18.6842 5.09748 18.2937 4.70696C17.9032 4.31643 17.9032 3.68342 18.2937 3.29289L19.2937 2.29289Z" }), jsx("path", { fill: "currentColor", d: "M21.0007 6C21.553 6 22.0007 6.44772 22.0007 7C22.0007 7.55228 21.553 8 21.0007 8H20.0007C19.4485 8 19.0007 7.55228 19.0007 7C19.0007 6.44772 19.4485 6 20.0007 6H21.0007Z" })] });
});
AlertingIcon.displayName = "AlertingIcon";

const AlignHorizontalBottomIcon = forwardRef$1(function AlignHorizontalBottomIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V14C15 15.6569 13.6569 17 12 17C10.3431 17 9 15.6569 9 14V6Z" }), jsx("path", { fill: "currentColor", d: "M4 19C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H4Z" })] });
});
AlignHorizontalBottomIcon.displayName = "AlignHorizontalBottomIcon";

const AlignHorizontalCenterIcon = forwardRef$1(function AlignHorizontalCenterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V16C15 17.6569 13.6569 19 12 19C10.3431 19 9 17.6569 9 16V8Z" }), jsx("path", { fill: "currentColor", d: "M4 11C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11H4Z" })] });
});
AlignHorizontalCenterIcon.displayName = "AlignHorizontalCenterIcon";

const AlignHorizontalTopIcon = forwardRef$1(function AlignHorizontalTopIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15 18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18L9 10C9 8.34314 10.3431 7 12 7C13.6569 7 15 8.34315 15 10L15 18Z" }), jsx("path", { fill: "currentColor", d: "M20 5C20.5523 5 21 4.5523 21 4C21 3.4477 20.5523 3 20 3L4 3C3.4477 3 3 3.4477 3 4C3 4.5523 3.4477 5 4 5L20 5Z" })] });
});
AlignHorizontalTopIcon.displayName = "AlignHorizontalTopIcon";

const AlignVerticalCenterIcon = forwardRef$1(function AlignVerticalCenterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M16 9C17.6569 9 19 10.3431 19 12C19 13.6569 17.6569 15 16 15L8 15C6.34315 15 5 13.6569 5 12C5 10.3431 6.34315 9 8 9L16 9Z" }), jsx("path", { fill: "currentColor", d: "M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4L11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20L13 4Z" })] });
});
AlignVerticalCenterIcon.displayName = "AlignVerticalCenterIcon";

const AlignVerticalLeftIcon = forwardRef$1(function AlignVerticalLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M18 9C19.6569 9 21 10.3431 21 12C21 13.6569 19.6569 15 18 15L10 15C8.34315 15 7 13.6569 7 12C7 10.3431 8.34315 9 10 9L18 9Z" }), jsx("path", { fill: "currentColor", d: "M5 4C5 3.44772 4.5523 3 4 3C3.4477 3 3 3.44772 3 4L3 20C3 20.5523 3.4477 21 4 21C4.5523 21 5 20.5523 5 20L5 4Z" })] });
});
AlignVerticalLeftIcon.displayName = "AlignVerticalLeftIcon";

const AlignVerticalRightIcon = forwardRef$1(function AlignVerticalRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9L14 9C15.6569 9 17 10.3431 17 12C17 13.6569 15.6569 15 14 15L6 15Z" }), jsx("path", { fill: "currentColor", d: "M19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20L21 4C21 3.4477 20.5523 3 20 3C19.4477 3 19 3.4477 19 4L19 20Z" })] });
});
AlignVerticalRightIcon.displayName = "AlignVerticalRightIcon";

const AlignmentCenterIcon = forwardRef$1(function AlignmentCenterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 18C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H20Z" }), jsx("path", { fill: "currentColor", d: "M16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H16Z" }), jsx("path", { fill: "currentColor", d: "M20 4C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5C3 4.44772 3.44772 4 4 4H20Z" })] });
});
AlignmentCenterIcon.displayName = "AlignmentCenterIcon";

const AlignmentLeftIcon = forwardRef$1(function AlignmentLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 18C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H20Z" }), jsx("path", { fill: "currentColor", d: "M12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H12Z" }), jsx("path", { fill: "currentColor", d: "M20 4C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5C3 4.44772 3.44772 4 4 4H20Z" })] });
});
AlignmentLeftIcon.displayName = "AlignmentLeftIcon";

const AlignmentRightIcon = forwardRef$1(function AlignmentRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 18C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H20Z" }), jsx("path", { fill: "currentColor", d: "M20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H12C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11H20Z" }), jsx("path", { fill: "currentColor", d: "M20 4C20.5523 4 21 4.44772 21 5C21 5.55228 20.5523 6 20 6H4C3.44772 6 3 5.55228 3 5C3 4.44772 3.44772 4 4 4H20Z" })] });
});
AlignmentRightIcon.displayName = "AlignmentRightIcon";

const AnalyticsIcon = forwardRef$1(function AnalyticsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18ZM9.70703 15.707C9.31652 16.0975 8.68348 16.0975 8.29297 15.707L7 14.4141L5.20703 16.207C5.14398 16.2701 5.07366 16.3216 5 16.3643V18C5 18.5523 5.44771 19 6 19H13V12.8252C12.9003 12.7899 12.8035 12.7493 12.709 12.7041L9.70703 15.707ZM15 7.17383C16.1647 7.58594 17 8.69415 17 10C17 11.3058 16.1645 12.413 15 12.8252V19H18C18.5523 19 19 18.5523 19 18V6C19 5.44771 18.5523 5 18 5H15V7.17383ZM6 5C5.44771 5 5 5.44771 5 6V13.5859L6.29297 12.293L6.36914 12.2236C6.76186 11.9038 7.34107 11.9271 7.70703 12.293L9 13.5859L11.2949 11.29C11.108 10.8989 11 10.4622 11 10C11 8.69415 11.8353 7.58594 13 7.17383V5H6ZM14 9C13.4477 9 13 9.44771 13 10C13 10.2764 13.1109 10.525 13.293 10.707C13.475 10.8891 13.7236 11 14 11C14.5523 11 15 10.5523 15 10C15 9.44771 14.5523 9 14 9Z" }) });
});
AnalyticsIcon.displayName = "AnalyticsIcon";

const AppleIcon = forwardRef$1(function AppleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.5596 3.38379C11.1006 3.3699 11.637 3.48942 12.1211 3.73145C12.6051 3.97354 13.0225 4.33127 13.3359 4.77246C12.8785 5.05255 12.4994 5.44378 12.2344 5.91016C11.9694 6.37662 11.8267 6.90304 11.8203 7.43945C11.8221 8.04326 12.0012 8.63355 12.335 9.13672C12.6687 9.6398 13.1427 10.0341 13.6982 10.2705C13.4792 10.9774 13.1549 11.6474 12.7363 12.2578C12.1377 13.1196 11.5119 13.9812 10.5596 13.9814C9.6069 13.9814 9.36143 13.4288 8.26367 13.4287C7.19301 13.4287 6.81151 14 5.94043 14C5.06944 13.9999 4.46136 13.2016 3.7627 12.2217C2.83976 10.849 2.33243 9.23888 2.30176 7.58496C2.30176 4.86291 4.07143 3.41996 5.81348 3.41992C6.73886 3.41992 7.51018 4.02815 8.09082 4.02832C8.64435 4.02832 9.50704 3.38379 10.5596 3.38379ZM10.7773 0C10.7962 0.0924744 10.8045 0.186871 10.8037 0.28125C10.7862 0.997212 10.5244 1.68573 10.0605 2.23145C9.82874 2.5177 9.5408 2.7541 9.21484 2.92578C8.88895 3.09741 8.5312 3.2012 8.16406 3.23047C8.10013 3.23025 8.03546 3.22379 7.97266 3.21191C7.95489 3.12846 7.94662 3.04332 7.94629 2.95801C7.97662 2.25582 8.24846 1.58555 8.7168 1.06152C9.2426 0.457591 9.98034 0.0778513 10.7773 0Z", fill: "currentColor" }) });
});
AppleIcon.displayName = "AppleIcon";

const ApproveIcon = forwardRef$1(function ApproveIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { d: "M14.043 8.543a1 1 0 1 1 1.414 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793Z" }), jsx("path", { fillRule: "evenodd", d: "M18.156 3.004A3 3 0 0 1 21.002 6v10.036a3 3 0 0 1-3 3h-2.626l-2.74 2.27a1 1 0 0 1-1.28-.004L8.65 19.036H6.002a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12l.154.004ZM6.002 5a1 1 0 0 0-1 1v10.036a1 1 0 0 0 1 1h2.65a2 2 0 0 1 1.285.467L12 19.233l2.099-1.737a2 2 0 0 1 1.276-.46h2.626l.103-.006a1 1 0 0 0 .897-.994V6a1 1 0 0 0-.897-.995L18.002 5h-12Z", clipRule: "evenodd" })] });
});
ApproveIcon.displayName = "ApproveIcon";

const ArchiveIcon = forwardRef$1(function ArchiveIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M12 12a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h4Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.086 2a2 2 0 0 1 1.414.586L12.914 4H17a2 2 0 0 1 2 2v2l-.001.01c.048.003.095.003.14.007.228.018.498.063.77.2.329.169.604.424.796.737l.077.138.087.203c.072.2.1.395.114.566.018.217.017.475.017.739v6.2c0 .543.001 1.012-.03 1.395-.033.396-.104.789-.297 1.167a3 3 0 0 1-1.31 1.31c-.379.194-.772.265-1.168.298-.383.031-.852.03-1.395.03H7.2c-.543 0-1.012.001-1.395-.03-.396-.033-.789-.104-1.167-.297a3 3 0 0 1-1.31-1.31c-.194-.379-.265-.772-.298-1.168C3 17.812 3 17.343 3 16.8v-6.2c0-.264-.001-.522.017-.739.018-.228.063-.498.2-.77a2 2 0 0 1 .875-.873c.271-.138.54-.183.77-.201.044-.004.09-.004.138-.006V4a2 2 0 0 1 2-2h3.086ZM5.6 10c-.297 0-.459.001-.576.01l-.012.002-.001.012A8.1 8.1 0 0 0 5 10.6v6.2c0 .576.001.949.024 1.232.023.272.06.373.085.422.096.188.249.34.437.437.05.025.15.062.422.085.283.023.656.024 1.232.024h9.6c.576 0 .949-.001 1.232-.024.272-.023.373-.06.422-.085a.999.999 0 0 0 .437-.437c.025-.05.062-.15.085-.422.023-.283.024-.656.024-1.232v-6.2c0-.297-.001-.46-.01-.576l-.003-.012-.011-.001A8.122 8.122 0 0 0 18.4 10H5.6ZM7 8h10V6h-4.086a2 2 0 0 1-1.414-.586L10.086 4H7v4Z", clipRule: "evenodd" })] });
});
ArchiveIcon.displayName = "ArchiveIcon";

const ArrayIcon = forwardRef$1(function ArrayIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7 3C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H6C5.44771 5 5 5.44771 5 6V18C5 18.5523 5.4477 19 6 19H7C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H7ZM18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H17C16.4477 21 16 20.5523 16 20C16 19.4477 16.4477 19 17 19H18C18.5523 19 19 18.5523 19 18V6C19 5.4477 18.5523 5 18 5H17C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3H18Z" }) });
});
ArrayIcon.displayName = "ArrayIcon";

const ArrowDiagonalUpRightIcon = forwardRef$1(function ArrowDiagonalUpRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.1014 4.00488C19.6056 4.05612 19.9998 4.48226 19.9998 5V15.7227C19.9998 16.2747 19.5517 16.7222 18.9998 16.7227C18.4476 16.7227 17.9998 16.2749 17.9998 15.7227V7.41406L5.70686 19.707C5.31639 20.0972 4.68324 20.0962 4.29279 19.7061C3.90247 19.3155 3.90233 18.6824 4.29279 18.292L16.5858 6H8.27619C7.72399 5.99992 7.27621 5.55222 7.27619 5C7.27619 4.44777 7.72398 4.00008 8.27619 4H18.9998L19.1014 4.00488Z" }) });
});
ArrowDiagonalUpRightIcon.displayName = "ArrowDiagonalUpRightIcon";

const ArrowDownIcon = forwardRef$1(function ArrowDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M16.232 12.36a1 1 0 1 1 1.536 1.28l-4.993 5.992a.998.998 0 0 1-1.537.016l-.009-.01-4.997-5.998a1 1 0 1 1 1.536-1.28L11 16.238V5a1 1 0 1 1 2 0v11.238l3.232-3.878Z" }) });
});
ArrowDownIcon.displayName = "ArrowDownIcon";

const ArrowLeftIcon = forwardRef$1(function ArrowLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.29302 5.29295C9.68354 4.90243 10.3166 4.90243 10.7071 5.29295C11.0975 5.68348 11.0976 6.31652 10.7071 6.70702L6.41411 11H20C20.5523 11 21 11.4477 21 12C21 12.5522 20.5523 12.9999 20 13H6.41411L10.7071 17.293L10.7754 17.3691C11.0957 17.7619 11.0732 18.3409 10.7071 18.707C10.341 19.0731 9.76196 19.0957 9.36919 18.7754L9.29302 18.707L3.29302 12.707C2.90249 12.3165 2.90249 11.6835 3.29302 11.293L9.29302 5.29295Z" }) });
});
ArrowLeftIcon.displayName = "ArrowLeftIcon";

const ArrowRightCircleIcon = forwardRef$1(function ArrowRightCircleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.293 8.29297C12.6835 7.90244 13.3165 7.90244 13.707 8.29297L16.707 11.293C17.0976 11.6835 17.0976 12.3165 16.707 12.707L13.707 15.707C13.3165 16.0976 12.6835 16.0976 12.293 15.707C11.9024 15.3165 11.9024 14.6835 12.293 14.293L13.5859 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H13.5859L12.293 9.70703C11.9024 9.31651 11.9024 8.68349 12.293 8.29297Z" }) });
});
ArrowRightCircleIcon.displayName = "ArrowRightCircleIcon";

const ArrowRightIcon = forwardRef$1(function ArrowRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.293 5.29298C13.6591 4.92686 14.2381 4.90427 14.6309 5.22462L14.707 5.29298L20.707 11.293C21.0974 11.6835 21.0975 12.3166 20.707 12.707L14.707 18.707C14.3165 19.0974 13.6835 19.0974 13.293 18.707C12.9025 18.3166 12.9026 17.6835 13.293 17.293L17.5859 13H4C3.44779 13 3.00013 12.5522 3 12C3 11.4477 3.44772 11 4 11H17.5859L13.293 6.70704L13.2246 6.63087C12.9043 6.23814 12.927 5.6591 13.293 5.29298Z" }) });
});
ArrowRightIcon.displayName = "ArrowRightIcon";

const ArrowUpIcon = forwardRef$1(function ArrowUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.3691 3.22462C11.7619 2.90427 12.3409 2.92686 12.707 3.29298L18.707 9.29298L18.7754 9.36915C19.0956 9.76192 19.0731 10.341 18.707 10.707C18.341 11.073 17.7619 11.0956 17.3691 10.7754L17.293 10.707L13 6.41407V20C12.9999 20.5522 12.5522 21 12 21C11.4478 21 11.0001 20.5522 11 20V6.41407L6.70704 10.707C6.31656 11.0974 5.68349 11.0974 5.29298 10.707C4.90248 10.3165 4.90253 9.68351 5.29298 9.29298L11.293 3.29298L11.3691 3.22462Z" }) });
});
ArrowUpIcon.displayName = "ArrowUpIcon";

const AspectRatioIcon = forwardRef$1(function AspectRatioIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15.2929 15.293C15.6834 14.9026 16.3164 14.9026 16.707 15.293L19.707 18.293C19.7547 18.3408 19.7975 18.3935 19.8349 18.4502C19.88 18.5186 19.9148 18.5917 19.9413 18.667C19.9461 18.6804 19.9518 18.6935 19.956 18.707C19.9622 18.7273 19.9667 18.748 19.9716 18.7686C19.9893 18.8428 19.9999 18.9202 19.9999 19C19.9999 19.0563 19.9932 19.1113 19.9843 19.165C19.9772 19.2078 19.9687 19.2503 19.956 19.292C19.9518 19.3056 19.946 19.3187 19.9413 19.332C19.9242 19.3808 19.9038 19.4285 19.8788 19.4746C19.8509 19.5262 19.8182 19.5745 19.7821 19.6201C19.7586 19.6498 19.7343 19.6796 19.707 19.707L16.707 22.707C16.3164 23.0975 15.6834 23.0975 15.2929 22.707C14.9024 22.3165 14.9024 21.6835 15.2929 21.293L16.5859 20H8.99992C8.44764 20 7.99992 19.5523 7.99992 19C7.99999 18.4478 8.44768 18 8.99992 18H16.5859L15.2929 16.707C14.9024 16.3165 14.9024 15.6835 15.2929 15.293Z" }), jsx("path", { fill: "currentColor", d: "M5.02043 4.00098C5.03797 4.00133 5.05566 4.00165 5.07316 4.00293C5.09081 4.00421 5.10852 4.00563 5.1259 4.00781C5.13763 4.0093 5.14937 4.01178 5.16105 4.01367C5.17975 4.01671 5.19838 4.02035 5.21672 4.02441C5.22777 4.02686 5.23895 4.0294 5.24992 4.03223C5.31715 4.04955 5.38134 4.07431 5.4423 4.10449C5.53755 4.15157 5.62763 4.21365 5.70695 4.29297L8.70695 7.29297C9.09733 7.68346 9.09732 8.31654 8.70695 8.70703C8.31646 9.09752 7.68343 9.09744 7.29289 8.70703L5.99992 7.41406V15C5.99992 15.5522 5.5521 15.9999 4.99992 16C4.44764 16 3.99992 15.5523 3.99992 15V7.41406L2.70695 8.70703C2.31646 9.09752 1.68343 9.09744 1.29289 8.70703C0.90237 8.31651 0.90237 7.68349 1.29289 7.29297L4.29289 4.29297C4.35004 4.23583 4.41473 4.18654 4.4843 4.14453C4.50421 4.13251 4.52431 4.12086 4.54484 4.11035C4.60714 4.07844 4.67308 4.05255 4.74211 4.03418C4.75863 4.02978 4.77522 4.02502 4.79191 4.02148C4.80283 4.01919 4.81407 4.01758 4.82512 4.01562C4.84258 4.01254 4.86028 4.00998 4.87785 4.00781C4.89557 4.00566 4.91356 4.00415 4.93156 4.00293C4.94744 4.00185 4.96349 4.00131 4.97941 4.00098C4.98617 4.00083 4.99314 4 4.99992 4C5.00673 4.00001 5.01366 4.00084 5.02043 4.00098Z" }), jsx("path", { fill: "currentColor", d: "M18.9999 10C19.5522 10 19.9999 10.4477 19.9999 11V13C19.9999 13.5523 19.5522 14 18.9999 14C18.4476 14 17.9999 13.5523 17.9999 13V11C17.9999 10.4477 18.4476 10 18.9999 10Z" }), jsx("path", { fill: "currentColor", d: "M16.9999 4C18.6567 4.00008 19.9999 5.3432 19.9999 7C19.9999 7.55223 19.5522 7.99992 18.9999 8C18.4823 8 18.0561 7.60667 18.0048 7.10254L17.995 6.89746C17.9471 6.42707 17.5729 6.05282 17.1025 6.00488L16.8974 5.99512C16.3933 5.94379 15.9999 5.51768 15.9999 5C15.9999 4.44772 16.4476 4 16.9999 4Z" }), jsx("path", { fill: "currentColor", d: "M12.9999 4C13.5522 4.00009 13.9999 4.44777 13.9999 5C13.9999 5.55223 13.5522 5.99991 12.9999 6H10.9999C10.4476 6 9.99992 5.55228 9.99992 5C9.99992 4.44772 10.4476 4 10.9999 4H12.9999Z" })] });
});
AspectRatioIcon.displayName = "AspectRatioIcon";

const AssetsIcon = forwardRef$1(function AssetsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M14 9V10H16V9H14ZM9 16H10V14H9V16ZM6.25 5.25C5.69772 5.25 5.25 5.69772 5.25 6.25C5.25 6.80228 5.69772 7.25 6.25 7.25V5.25ZM6.26 7.25C6.81228 7.25 7.26 6.80228 7.26 6.25C7.26 5.69772 6.81228 5.25 6.26 5.25V7.25ZM14 13.4L14.5795 12.585C14.2746 12.3682 13.874 12.3397 13.5415 12.5113C13.2089 12.6829 13 13.0258 13 13.4H14ZM14 16.6H13C13 16.9742 13.2089 17.3171 13.5415 17.4887C13.874 17.6603 14.2746 17.6318 14.5795 17.415L14 16.6ZM16.25 15L16.8295 15.815C17.0933 15.6274 17.25 15.3237 17.25 15C17.25 14.6763 17.0933 14.3726 16.8295 14.185L16.25 15ZM2.9453 10.8346C2.48577 11.141 2.3616 11.7618 2.66795 12.2214C2.9743 12.6809 3.59517 12.8051 4.0547 12.4987L2.9453 10.8346ZM7.9453 12.4987C8.40483 12.8051 9.0257 12.6809 9.33205 12.2214C9.6384 11.7618 9.51423 11.141 9.0547 10.8346L7.9453 12.4987ZM5 4H13V2H5V4ZM14 5V9H16V5H14ZM5 16H9V14H5V16ZM11 10H19V8H11V10ZM11 22H19V20H11V22ZM20 11V19H22V11H20ZM5.5 6.25C5.5 5.83579 5.83579 5.5 6.25 5.5V7.5C6.94036 7.5 7.5 6.94036 7.5 6.25H5.5ZM6.25 5.5C6.66421 5.5 7 5.83579 7 6.25H5C5 6.94036 5.55964 7.5 6.25 7.5V5.5ZM7 6.25C7 6.66421 6.66421 7 6.25 7V5C5.55964 5 5 5.55964 5 6.25H7ZM6.25 7C5.83579 7 5.5 6.66421 5.5 6.25H7.5C7.5 5.55964 6.94036 5 6.25 5V7ZM6.25 7.25H6.26V5.25H6.25V7.25ZM13 13.4V16.6H15V13.4H13ZM14.5795 17.415L16.8295 15.815L15.6705 14.185L13.4205 15.785L14.5795 17.415ZM16.8295 14.185L14.5795 12.585L13.4205 14.215L15.6705 15.815L16.8295 14.185ZM4.0547 12.4987L5.4453 11.5717L4.3359 9.90755L2.9453 10.8346L4.0547 12.4987ZM2 5V13H4V5H2ZM6.5547 11.5717L7.9453 12.4987L9.0547 10.8346L7.6641 9.90755L6.5547 11.5717ZM8 11V19H10V11H8ZM5.4453 11.5717C5.7812 11.3477 6.2188 11.3477 6.5547 11.5717L7.6641 9.90755C6.6564 9.23575 5.3436 9.23575 4.3359 9.90755L5.4453 11.5717ZM19 22C20.6569 22 22 20.6569 22 19H20C20 19.5523 19.5523 20 19 20V22ZM11 20C10.4477 20 10 19.5523 10 19H8C8 20.6569 9.34315 22 11 22V20ZM5 14C4.44772 14 4 13.5523 4 13H2C2 14.6569 3.34315 16 5 16V14ZM19 10C19.5523 10 20 10.4477 20 11H22C22 9.34315 20.6569 8 19 8V10ZM13 4C13.5523 4 14 4.44772 14 5H16C16 3.34315 14.6569 2 13 2V4ZM11 8C9.34315 8 8 9.34315 8 11H10C10 10.4477 10.4477 10 11 10V8ZM5 2C3.34315 2 2 3.34315 2 5H4C4 4.44772 4.44772 4 5 4V2Z" }) });
});
AssetsIcon.displayName = "AssetsIcon";

const AudienceTemplateIcon = forwardRef$1(function AudienceTemplateIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 15.6875C4.55228 15.6875 5 16.1352 5 16.6875V18C5 18.5523 5.44772 19 6 19H7.3125C7.86478 19 8.3125 19.4477 8.3125 20C8.3125 20.5523 7.86478 21 7.3125 21H6C4.34315 21 3 19.6569 3 18V16.6875C3 16.1352 3.44772 15.6875 4 15.6875ZM13.3125 19C13.8648 19 14.3125 19.4477 14.3125 20C14.3125 20.5523 13.8648 21 13.3125 21H10.6875C10.1352 21 9.6875 20.5523 9.6875 20C9.6875 19.4477 10.1352 19 10.6875 19H13.3125ZM20 15.6875C20.5523 15.6875 21 16.1352 21 16.6875V18C21 19.6569 19.6569 21 18 21H16.6875C16.1352 21 15.6875 20.5523 15.6875 20C15.6875 19.4477 16.1352 19 16.6875 19H18C18.5523 19 19 18.5523 19 18V16.6875C19 16.1352 19.4477 15.6875 20 15.6875ZM12 13C14.4244 13 16.2774 14.502 16.8428 16.5752L16.8936 16.7773L16.9111 16.8779C16.9736 17.381 16.6463 17.8592 16.1416 17.9746C15.6369 18.0899 15.1339 17.8014 14.9717 17.3213L14.9443 17.2227L14.8809 16.9902C14.5202 15.8481 13.4809 15 12 15C10.5194 15.0002 9.48078 15.8482 9.12012 16.9902L9.05664 17.2227C8.93365 17.761 8.39776 18.0975 7.85938 17.9746C7.32103 17.8516 6.98451 17.3157 7.10742 16.7773L7.1582 16.5752C7.72349 14.5021 9.57588 13.0002 12 13ZM4 9.6875C4.55228 9.6875 5 10.1352 5 10.6875V13.3125C5 13.8648 4.55228 14.3125 4 14.3125C3.44772 14.3125 3 13.8648 3 13.3125V10.6875C3 10.1352 3.44772 9.6875 4 9.6875ZM20 9.6875C20.5523 9.6875 21 10.1352 21 10.6875V13.3125C21 13.8648 20.5523 14.3125 20 14.3125C19.4477 14.3125 19 13.8648 19 13.3125V10.6875C19 10.1352 19.4477 9.6875 20 9.6875ZM12 6C13.7949 6 15.25 7.45506 15.25 9.25C15.25 11.0449 13.7949 12.5 12 12.5C10.2051 12.5 8.75 11.0449 8.75 9.25C8.75 7.45506 10.2051 6 12 6ZM12 8C11.3097 8 10.75 8.55966 10.75 9.25C10.75 9.94032 11.3097 10.5 12 10.5C12.6903 10.5 13.25 9.94032 13.25 9.25C13.25 8.55966 12.6903 8 12 8ZM7.3125 3C7.86478 3 8.3125 3.44772 8.3125 4C8.3125 4.55228 7.86478 5 7.3125 5H6C5.44772 5 5 5.44772 5 6V7.3125C5 7.86478 4.55228 8.3125 4 8.3125C3.44772 8.3125 3 7.86478 3 7.3125V6C3 4.34315 4.34315 3 6 3H7.3125ZM18 3C19.6569 3 21 4.34315 21 6V7.3125C21 7.86478 20.5523 8.3125 20 8.3125C19.4477 8.3125 19 7.86478 19 7.3125V6C19 5.44772 18.5523 5 18 5H16.6875C16.1352 5 15.6875 4.55228 15.6875 4C15.6875 3.44772 16.1352 3 16.6875 3H18ZM13.3125 3C13.8648 3 14.3125 3.44772 14.3125 4C14.3125 4.55228 13.8648 5 13.3125 5H10.6875C10.1352 5 9.6875 4.55228 9.6875 4C9.6875 3.44772 10.1352 3 10.6875 3H13.3125Z" }) });
});
AudienceTemplateIcon.displayName = "AudienceTemplateIcon";

const AudienceIcon = forwardRef$1(function AudienceIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M2.3696 15.6094C4.85763 10.5517 11.7086 10.6329 14.0561 15.8535L14.1411 16.0635C14.5184 17.1099 14.2002 18.1244 13.5493 18.835C12.8789 19.5665 11.8529 20.0019 10.7759 20.002H5.53464C4.45753 20.0019 3.43164 19.5666 2.7612 18.835C2.0669 18.077 1.75121 16.973 2.25437 15.8535L2.3696 15.6094ZM15.4809 11.999C17.7865 11.5034 20.3048 12.5144 21.6118 14.9404L21.7007 15.1152C22.117 16.001 22.1514 17.033 21.5239 17.8779C20.9227 18.6867 19.8929 19.0765 18.6909 19.1221L18.4487 19.127H17.5757C17.0238 19.1267 16.576 18.6788 16.5757 18.127C16.5757 17.5748 17.0236 17.1272 17.5757 17.127H18.4487L18.7876 17.1143C19.5159 17.0569 19.8191 16.818 19.9184 16.6846C19.9928 16.5844 20.0666 16.3862 19.9253 16.0439L19.851 15.8887C18.9719 14.2571 17.3484 13.6428 15.9009 13.9541C15.3613 14.0697 14.8295 13.7261 14.7134 13.1865C14.5973 12.6468 14.9413 12.1153 15.4809 11.999ZM12.2319 16.6738C10.607 13.0601 6.05267 12.9471 4.2446 16.335L4.07859 16.6738C3.95051 16.959 3.99803 17.2248 4.23581 17.4844C4.49777 17.7702 4.97284 18.0019 5.53464 18.002H10.7759C11.3375 18.0018 11.8127 17.7701 12.0747 17.4844C12.2826 17.2574 12.3451 17.0255 12.2719 16.7803L12.2319 16.6738ZM7.82761 4C9.7604 4.00023 11.3276 5.56715 11.3276 7.5C11.3276 9.43285 9.7604 10.9998 7.82761 11C5.89462 11 4.32761 9.43299 4.32761 7.5C4.32761 5.56701 5.89462 4 7.82761 4ZM16.2846 4.99316C17.9415 4.99316 19.2846 6.33631 19.2846 7.99316C19.2846 9.64996 17.9414 10.9932 16.2846 10.9932C14.628 10.993 13.2847 9.64987 13.2846 7.99316C13.2846 6.3364 14.6279 4.99332 16.2846 4.99316ZM7.82761 6C6.99919 6 6.32761 6.67158 6.32761 7.5C6.32761 8.32842 6.99919 9 7.82761 9C8.65583 8.99977 9.32761 8.32828 9.32761 7.5C9.32761 6.67172 8.65583 6.00023 7.82761 6ZM16.2846 6.99316C15.7325 6.99332 15.2846 7.44098 15.2846 7.99316C15.2847 8.54529 15.7325 8.99301 16.2846 8.99316C16.8369 8.99316 17.2846 8.54539 17.2846 7.99316C17.2846 7.44088 16.8369 6.99316 16.2846 6.99316Z" }) });
});
AudienceIcon.displayName = "AudienceIcon";

const BidirectionalArrowIcon = forwardRef$1(function BidirectionalArrowIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7.21596 11.2198C7.61074 10.9021 8.19013 10.9296 8.55385 11.2979C8.94169 11.6909 8.93804 12.324 8.54506 12.7119L6.10268 15.1221H19.338L19.4406 15.127C19.9447 15.1783 20.338 15.6044 20.338 16.1221C20.338 16.6397 19.9446 17.0659 19.4406 17.1172L19.338 17.1221H6.34975L8.54506 19.2881C8.93804 19.6761 8.94169 20.3091 8.55385 20.7022C8.16588 21.0949 7.53276 21.0997 7.13978 20.7119L3.44545 17.0655C2.85148 16.4787 2.85155 15.5214 3.44545 14.9346L7.13978 11.2881L7.21596 11.2198ZM15.4445 3.29789C15.8081 2.92952 16.3875 2.90223 16.7824 3.21976L16.8585 3.28812L20.5529 6.9346C21.1473 7.52144 21.1473 8.47864 20.5529 9.06546L16.8585 12.7119C16.4655 13.0995 15.8323 13.0951 15.4445 12.7022C15.0568 12.3092 15.0614 11.676 15.4542 11.2881L17.8947 8.87894H4.00014C3.44805 8.87874 3.00019 8.43105 3.00014 7.87894C3.00014 7.32678 3.44802 6.87914 4.00014 6.87894H17.6486L15.4542 4.71195L15.3849 4.63578C15.0623 4.24522 15.0812 3.66633 15.4445 3.29789Z" }) });
});
BidirectionalArrowIcon.displayName = "BidirectionalArrowIcon";

const BigIntegerIcon = forwardRef$1(function BigIntegerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4.34375 7C6.21981 7 7.68737 8.39183 7.6875 10.2744C7.68746 10.8805 7.48793 11.5327 7.20508 12.0293L4.65234 16.6123C4.51993 16.8499 4.26911 16.9971 3.99707 16.9971H3.30957C2.73135 16.9965 2.37089 16.3689 2.66211 15.8691L4.01758 13.541C2.29798 13.4384 1.00008 12.1394 1 10.2744C1.00013 8.40733 2.4393 7.00021 4.34375 7ZM12 7C13.8761 7 15.3436 8.39183 15.3438 10.2744C15.3437 10.8805 15.1442 11.5327 14.8613 12.0293L12.3086 16.6123C12.1762 16.8499 11.9254 16.9971 11.6533 16.9971H10.9658C10.3876 16.9964 10.0272 16.3689 10.3184 15.8691L11.6738 13.541C9.95426 13.4383 8.65633 12.1394 8.65625 10.2744C8.65638 8.40735 10.0956 7.00024 12 7ZM19.6572 7C21.5332 7.0001 23.0008 8.39189 23.001 10.2744C23.0009 10.8804 22.8013 11.5327 22.5186 12.0293L19.9658 16.6123C19.8334 16.8499 19.5825 16.997 19.3105 16.9971H18.623C18.0446 16.9968 17.6843 16.369 17.9756 15.8691L19.3311 13.541C17.6112 13.4386 16.3136 12.1396 16.3135 10.2744C16.3136 8.4072 17.7526 7.00001 19.6572 7ZM3.23926 16.7422L3.30957 16.7471H3.31055C3.28482 16.7471 3.2597 16.7448 3.23535 16.7412C3.23667 16.7414 3.23793 16.742 3.23926 16.7422ZM10.8955 16.7422L10.9658 16.7471H10.9668C10.9411 16.7471 10.916 16.7448 10.8916 16.7412C10.8929 16.7414 10.8942 16.742 10.8955 16.7422ZM11.999 13.4814L10.5342 15.9951L10.5029 16.0586C10.5117 16.0373 10.5231 16.0168 10.5352 15.9961L12 13.4814C12.0059 13.4713 12.01 13.4607 12.0127 13.4502L11.999 13.4814ZM4.34277 13.4814L2.87793 15.9951V15.9961L4.34375 13.4814C4.34964 13.4713 4.35373 13.4607 4.35645 13.4502L4.34277 13.4814ZM19.6143 13.3164C19.6499 13.338 19.6723 13.3773 19.6729 13.4189L19.6689 13.3877C19.6606 13.3582 19.641 13.3325 19.6143 13.3164ZM4.34375 9.03906C3.68958 9.03927 3.16613 9.51006 3.16602 10.2744C3.16605 10.6939 3.30397 10.9977 3.50684 11.1963C3.71148 11.3963 4.00312 11.5097 4.34375 11.5098C4.68452 11.5098 4.97594 11.3964 5.18066 11.1963C5.38373 10.9977 5.52145 10.6941 5.52148 10.2744C5.52137 9.5114 4.9864 9.03906 4.34375 9.03906ZM12 9.03906C11.3459 9.0393 10.8224 9.51009 10.8223 10.2744C10.8223 10.6939 10.9602 10.9977 11.1631 11.1963C11.3677 11.3963 11.6594 11.5097 12 11.5098C12.3407 11.5098 12.6322 11.3963 12.8369 11.1963C13.04 10.9977 13.1777 10.6941 13.1777 10.2744C13.1776 9.5114 12.6427 9.03906 12 9.03906ZM19.6572 9.03906C19.0029 9.03907 18.4796 9.5099 18.4795 10.2744C18.4795 10.6941 18.6173 10.9977 18.8203 11.1963C19.025 11.3964 19.3164 11.5098 19.6572 11.5098C19.998 11.5097 20.2895 11.3964 20.4941 11.1963C20.6971 10.9977 20.8349 10.694 20.835 10.2744C20.8348 9.51148 20.2998 9.03916 19.6572 9.03906ZM5.77148 10.2744L5.76562 10.4268C5.76932 10.3773 5.77246 10.3265 5.77246 10.2744C5.77246 10.2397 5.76947 10.2056 5.76758 10.1719C5.76947 10.2056 5.77148 10.2397 5.77148 10.2744ZM13.4277 10.2744L13.4219 10.4268C13.4256 10.3773 13.4287 10.3265 13.4287 10.2744C13.4287 10.2397 13.4257 10.2056 13.4238 10.1719C13.4257 10.2056 13.4277 10.2397 13.4277 10.2744ZM3.43359 9.10156C3.40666 9.12355 3.38165 9.14778 3.35645 9.17188C3.41461 9.11628 3.47694 9.06565 3.54395 9.02148L3.43359 9.10156ZM11.0898 9.10156C11.0629 9.12355 11.0379 9.14778 11.0127 9.17188C11.0709 9.11628 11.1332 9.06565 11.2002 9.02148L11.0898 9.10156ZM20.1299 8.86621C20.0689 8.84574 20.0066 8.82775 19.9424 8.81543L19.9336 8.81445C20.0009 8.82693 20.0662 8.84484 20.1299 8.86621ZM4.05469 8.81543C4.00821 8.82427 3.96264 8.83558 3.91797 8.84863L4.05469 8.81641C4.10141 8.80752 4.14894 8.80041 4.19727 8.7959L4.05469 8.81543ZM11.7109 8.81543C11.6645 8.82427 11.6189 8.83558 11.5742 8.84863L11.7109 8.81641C11.7577 8.80752 11.8052 8.80041 11.8535 8.7959L11.7109 8.81543ZM19.3682 8.81543C19.3214 8.82431 19.2754 8.83549 19.2305 8.84863L19.3682 8.81641C19.4149 8.80754 19.4624 8.80039 19.5107 8.7959L19.3682 8.81543ZM4.65137 8.82129C4.64413 8.81974 4.63717 8.81683 4.62988 8.81543L4.62109 8.81445C4.63128 8.81635 4.64127 8.81914 4.65137 8.82129ZM12.1387 8.79492C12.0934 8.79067 12.0474 8.78908 12.001 8.78906H12L12.1387 8.79492ZM11.3584 7.30957C11.2723 7.32587 11.1884 7.34743 11.1055 7.37012C11.1949 7.34564 11.2859 7.3231 11.3789 7.30566L11.3584 7.30957Z" }) });
});
BigIntegerIcon.displayName = "BigIntegerIcon";

const BigModeIcon = forwardRef$1(function BigModeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M6.99805 13.0039C9.20639 13.0039 10.9961 14.7936 10.9961 17.002C10.9959 19.2101 9.20628 21 6.99805 21C4.78996 20.9998 3.00018 19.21 3 17.002C3 14.7937 4.78985 13.0041 6.99805 13.0039ZM17.002 13.0039C19.2101 13.0041 21 14.7937 21 17.002C20.9998 19.21 19.21 20.9998 17.002 21C14.7937 21 13.0041 19.2101 13.0039 17.002C13.0039 14.7936 14.7936 13.0039 17.002 13.0039ZM6.99805 14.998C5.89166 14.9982 4.99414 15.8955 4.99414 17.002C4.99432 18.1082 5.89177 19.0057 6.99805 19.0059C8.10447 19.0059 9.00178 18.1083 9.00195 17.002C9.00195 15.8954 8.10458 14.998 6.99805 14.998ZM17.002 14.998C15.8954 14.998 14.998 15.8954 14.998 17.002C14.9982 18.1083 15.8955 19.0059 17.002 19.0059C18.1082 19.0057 19.0057 18.1082 19.0059 17.002C19.0059 15.8955 18.1083 14.9982 17.002 14.998ZM6.99805 3C9.20628 3 10.9959 4.78985 10.9961 6.99805C10.9961 9.20639 9.20639 10.9961 6.99805 10.9961C4.78985 10.9959 3 9.20628 3 6.99805C3.00018 4.78996 4.78996 3.00018 6.99805 3ZM17.002 3C19.21 3.00018 20.9998 4.78996 21 6.99805C21 9.20628 19.2101 10.9959 17.002 10.9961C14.7936 10.9961 13.0039 9.20639 13.0039 6.99805C13.0041 4.78985 14.7937 3 17.002 3ZM6.99805 4.99414C5.89177 4.99432 4.99432 5.89177 4.99414 6.99805C4.99414 8.10447 5.89166 9.00178 6.99805 9.00195C8.10458 9.00195 9.00195 8.10458 9.00195 6.99805C9.00178 5.89166 8.10447 4.99414 6.99805 4.99414ZM17.002 4.99414C15.8955 4.99414 14.9982 5.89166 14.998 6.99805C14.998 8.10458 15.8954 9.00195 17.002 9.00195C18.1083 9.00178 19.0059 8.10447 19.0059 6.99805C19.0057 5.89177 18.1082 4.99432 17.002 4.99414Z" }) });
});
BigModeIcon.displayName = "BigModeIcon";

const BlendIcon = forwardRef$1(function BlendIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M9.2998 2C12.7455 2.00013 15.6312 4.3885 16.3975 7.59961C19.6096 8.36521 21.998 11.2526 21.998 14.6992C21.9979 18.7304 18.7304 21.9979 14.6992 21.998C11.2529 21.9979 8.36633 19.6093 7.60059 16.3975C4.3891 15.6315 2.00013 12.7458 2 9.2998C2 5.26847 5.2685 2.00013 9.2998 2ZM16.584 9.74512C16.3626 13.4213 13.4221 16.3612 9.74609 16.583C10.5059 18.5792 12.4363 19.9979 14.6992 19.998C17.6258 19.9979 19.9979 17.6258 19.998 14.6992C19.998 12.4363 18.5801 10.5051 16.584 9.74512ZM14.5957 9.40137C11.7512 9.45607 9.45588 11.7512 9.40137 14.5957C12.2474 14.5422 14.542 12.2474 14.5957 9.40137ZM9.2998 4C6.37307 4.00013 4 6.37304 4 9.2998C4.00012 11.5621 5.41861 13.4918 7.41406 14.252C7.63624 10.5769 10.577 7.63643 14.252 7.41406C13.4919 5.41854 11.5621 4.00012 9.2998 4Z" }) });
});
BlendIcon.displayName = "BlendIcon";

const BlurIcon = forwardRef$1(function BlurIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M13 17.75C13 17.1977 13.4477 16.75 14 16.75C14.5523 16.75 15 17.1977 15 17.75C15 18.3023 14.5523 18.75 14 18.75C13.4477 18.75 13 18.3023 13 17.75Z", fill: "currentColor" }), jsx("path", { d: "M16.5 17.75C16.5 17.1977 16.9477 16.75 17.5 16.75C18.0523 16.75 18.5 17.1977 18.5 17.75C18.5 18.3023 18.0523 18.75 17.5 18.75C16.9477 18.75 16.5 18.3023 16.5 17.75Z", fill: "currentColor" }), jsx("path", { d: "M13 6.25C13 5.69771 13.4477 5.25 14 5.25C14.5523 5.25 15 5.69771 15 6.25C15 6.80229 14.5523 7.25 14 7.25C13.4477 7.25 13 6.80229 13 6.25Z", fill: "currentColor" }), jsx("path", { d: "M13.25 20.75C13.25 20.3358 13.5858 20 14 20C14.4142 20 14.75 20.3358 14.75 20.75C14.75 21.1642 14.4142 21.5 14 21.5C13.5858 21.5 13.25 21.1642 13.25 20.75Z", fill: "currentColor" }), jsx("path", { d: "M19.5 14C19.5 13.5858 19.8358 13.25 20.25 13.25C20.6642 13.25 21 13.5858 21 14C21 14.4142 20.6642 14.75 20.25 14.75C19.8358 14.75 19.5 14.4142 19.5 14Z", fill: "currentColor" }), jsx("path", { d: "M19.5 10C19.5 9.58579 19.8358 9.25 20.25 9.25C20.6642 9.25 21 9.58579 21 10C21 10.4142 20.6642 10.75 20.25 10.75C19.8358 10.75 19.5 10.4142 19.5 10Z", fill: "currentColor" }), jsx("path", { d: "M13.25 3.25C13.25 2.83579 13.5858 2.5 14 2.5C14.4142 2.5 14.75 2.83579 14.75 3.25C14.75 3.66421 14.4142 4 14 4C13.5858 4 13.25 3.66421 13.25 3.25Z", fill: "currentColor" }), jsx("path", { d: "M12.5 14C12.5 13.1716 13.1716 12.5 14 12.5C14.8284 12.5 15.5 13.1716 15.5 14C15.5 14.8284 14.8284 15.5 14 15.5C13.1716 15.5 12.5 14.8284 12.5 14Z", fill: "currentColor" }), jsx("path", { d: "M12.5 10C12.5 9.17157 13.1716 8.5 14 8.5C14.8284 8.5 15.5 9.17157 15.5 10C15.5 10.8284 14.8284 11.5 14 11.5C13.1716 11.5 12.5 10.8284 12.5 10Z", fill: "currentColor" }), jsx("path", { d: "M16.5 14C16.5 13.4477 16.9477 13 17.5 13C18.0523 13 18.5 13.4477 18.5 14C18.5 14.5523 18.0523 15 17.5 15C16.9477 15 16.5 14.5523 16.5 14Z", fill: "currentColor" }), jsx("path", { d: "M16.5 10C16.5 9.44771 16.9477 9 17.5 9C18.0523 9 18.5 9.44771 18.5 10C18.5 10.5523 18.0523 11 17.5 11C16.9477 11 16.5 10.5523 16.5 10Z", fill: "currentColor" }), jsx("path", { d: "M16.5 6.25C16.5 5.69771 16.9477 5.25 17.5 5.25C18.0523 5.25 18.5 5.69771 18.5 6.25C18.5 6.80229 18.0523 7.25 17.5 7.25C16.9477 7.25 16.5 6.80229 16.5 6.25Z", fill: "currentColor" }), jsx("path", { d: "M11 6.25C11 6.80228 10.5523 7.25 10 7.25C9.44772 7.25 9 6.80228 9 6.25C9 5.69772 9.44772 5.25 10 5.25C10.5523 5.25 11 5.69772 11 6.25Z", fill: "currentColor" }), jsx("path", { d: "M7.5 6.25C7.5 6.80228 7.05228 7.25 6.5 7.25C5.94772 7.25 5.5 6.80228 5.5 6.25C5.5 5.69772 5.94772 5.25 6.5 5.25C7.05228 5.25 7.5 5.69772 7.5 6.25Z", fill: "currentColor" }), jsx("path", { d: "M11 17.75C11 18.3023 10.5523 18.75 10 18.75C9.44772 18.75 9 18.3023 9 17.75C9 17.1977 9.44772 16.75 10 16.75C10.5523 16.75 11 17.1977 11 17.75Z", fill: "currentColor" }), jsx("path", { d: "M10.75 3.25C10.75 3.66421 10.4142 4 10 4C9.58579 4 9.25 3.66421 9.25 3.25C9.25 2.83579 9.58579 2.5 10 2.5C10.4142 2.5 10.75 2.83579 10.75 3.25Z", fill: "currentColor" }), jsx("path", { d: "M4.5 10C4.5 10.4142 4.16421 10.75 3.75 10.75C3.33579 10.75 3 10.4142 3 10C3 9.58579 3.33579 9.25 3.75 9.25C4.16421 9.25 4.5 9.58579 4.5 10Z", fill: "currentColor" }), jsx("path", { d: "M4.5 14C4.5 14.4142 4.16421 14.75 3.75 14.75C3.33579 14.75 3 14.4142 3 14C3 13.5858 3.33579 13.25 3.75 13.25C4.16421 13.25 4.5 13.5858 4.5 14Z", fill: "currentColor" }), jsx("path", { d: "M10.75 20.75C10.75 21.1642 10.4142 21.5 10 21.5C9.58579 21.5 9.25 21.1642 9.25 20.75C9.25 20.3358 9.58579 20 10 20C10.4142 20 10.75 20.3358 10.75 20.75Z", fill: "currentColor" }), jsx("path", { d: "M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z", fill: "currentColor" }), jsx("path", { d: "M11.5 14C11.5 14.8284 10.8284 15.5 10 15.5C9.17157 15.5 8.5 14.8284 8.5 14C8.5 13.1716 9.17157 12.5 10 12.5C10.8284 12.5 11.5 13.1716 11.5 14Z", fill: "currentColor" }), jsx("path", { d: "M7.5 10C7.5 10.5523 7.05228 11 6.5 11C5.94772 11 5.5 10.5523 5.5 10C5.5 9.44772 5.94772 9 6.5 9C7.05228 9 7.5 9.44772 7.5 10Z", fill: "currentColor" }), jsx("path", { d: "M7.5 14C7.5 14.5523 7.05228 15 6.5 15C5.94772 15 5.5 14.5523 5.5 14C5.5 13.4477 5.94772 13 6.5 13C7.05228 13 7.5 13.4477 7.5 14Z", fill: "currentColor" }), jsx("path", { d: "M7.5 17.75C7.5 18.3023 7.05228 18.75 6.5 18.75C5.94772 18.75 5.5 18.3023 5.5 17.75C5.5 17.1977 5.94772 16.75 6.5 16.75C7.05228 16.75 7.5 17.1977 7.5 17.75Z", fill: "currentColor" })] });
});
BlurIcon.displayName = "BlurIcon";

const BoldIcon = forwardRef$1(function BoldIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M12.9961 3C15.7575 3 17.9961 5.23857 17.9961 8C17.9961 9.43114 17.3934 10.7204 16.4297 11.6318C17.9606 12.4866 18.9961 14.1222 18.9961 16C18.9961 18.7614 16.7575 21 13.9961 21H7.99609C6.33925 21 4.99609 19.6569 4.99609 18V6C4.99609 4.34315 6.33924 3 7.99609 3H12.9961ZM6.99609 18C6.99609 18.5523 7.4438 19 7.99609 19H13.9961C15.6529 19 16.9961 17.6568 16.9961 16C16.9961 14.3432 15.6529 13 13.9961 13H7.99609C7.64498 13 7.30924 12.936 6.99609 12.8252V18ZM7.99609 5C7.44381 5 6.99609 5.44771 6.99609 6V10C6.99609 10.5523 7.4438 11 7.99609 11H12.9961C14.6529 11 15.9961 9.65682 15.9961 8C15.9961 6.34315 14.6529 5 12.9961 5H7.99609Z" }) });
});
BoldIcon.displayName = "BoldIcon";

const BooleanIcon = forwardRef$1(function BooleanIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.002 5C18.8685 5.00003 22.0029 8.13446 22.0029 12.001C22.0029 15.8675 18.8685 19.0019 15.002 19.002H9.00098C5.13446 19.0019 2.00003 15.8675 2 12.001C2.00001 8.13445 5.13445 5.00001 9.00098 5H15.002ZM9.00098 7C6.23902 7.00001 4.00001 9.23902 4 12.001C4.00003 14.7629 6.23903 17.0019 9.00098 17.002H15.002C17.7639 17.0019 20.0029 14.7629 20.0029 12.001C20.0029 9.23903 17.7639 7.00003 15.002 7H9.00098ZM9.00098 9.42871C10.4214 9.42874 11.5732 10.5806 11.5732 12.001C11.5732 13.4213 10.4213 14.5732 9.00098 14.5732C7.58059 14.5732 6.42874 13.4214 6.42871 12.001C6.42871 10.5806 7.58058 9.42871 9.00098 9.42871Z" }) });
});
BooleanIcon.displayName = "BooleanIcon";

const BorderRadiusAllIcon = forwardRef$1(function BorderRadiusAllIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M3 18V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44771 19 6 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6C4.34315 21 3 19.6569 3 18ZM19 18V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V18C21 19.6569 19.6569 21 18 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H18C18.5523 19 19 18.5523 19 18ZM3 8V6C3 4.34315 4.34315 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6C5.44771 5 5 5.44771 5 6V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8ZM19 8V6C19 5.44771 18.5523 5 18 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H18C19.6569 3 21 4.34315 21 6V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8Z" }) });
});
BorderRadiusAllIcon.displayName = "BorderRadiusAllIcon";

const BorderRadiusBottomLeftIcon = forwardRef$1(function BorderRadiusBottomLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M18 19H13.2002C11.9566 19 10.9636 19.0009 10.1631 18.9355C9.35086 18.8692 8.6487 18.7294 8.00293 18.4004C6.96816 17.8731 6.12689 17.0318 5.59961 15.9971C5.27057 15.3513 5.13081 14.6491 5.06445 13.8369C4.99906 13.0364 5 12.0434 5 10.7998L5 6C5 5.44771 5.44772 5 6 5C6.55228 5 7 5.44771 7 6L7 10.7998C7 12.0762 7.00044 12.9737 7.05762 13.6738C7.11387 14.3624 7.2204 14.772 7.38184 15.0889C7.71738 15.7474 8.25261 16.2826 8.91113 16.6182C9.22797 16.7796 9.63763 16.8861 10.3262 16.9424C11.0263 16.9996 11.9238 17 13.2002 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19Z" }) });
});
BorderRadiusBottomLeftIcon.displayName = "BorderRadiusBottomLeftIcon";

const BorderRadiusBottomRightIcon = forwardRef$1(function BorderRadiusBottomRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M19 6V10.7998C19 12.0434 19.0009 13.0364 18.9355 13.8369C18.8692 14.6491 18.7294 15.3513 18.4004 15.9971C17.8731 17.0318 17.0318 17.8731 15.9971 18.4004C15.3513 18.7294 14.6491 18.8692 13.8369 18.9355C13.0364 19.0009 12.0434 19 10.7998 19L6 19C5.44771 19 5 18.5523 5 18C5 17.4477 5.44771 17 6 17L10.7998 17C12.0762 17 12.9737 16.9996 13.6738 16.9424C14.3624 16.8861 14.772 16.7796 15.0889 16.6182C15.7474 16.2826 16.2826 15.7474 16.6182 15.0889C16.7796 14.772 16.8861 14.3624 16.9424 13.6738C16.9996 12.9737 17 12.0762 17 10.7998V6C17 5.44772 17.4477 5 18 5C18.5523 5 19 5.44772 19 6Z" }) });
});
BorderRadiusBottomRightIcon.displayName = "BorderRadiusBottomRightIcon";

const BorderRadiusTopLeftIcon = forwardRef$1(function BorderRadiusTopLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M5 18V13.2002C5 11.9566 4.99906 10.9636 5.06445 10.1631C5.13081 9.35086 5.27057 8.6487 5.59961 8.00293C6.12689 6.96816 6.96816 6.12689 8.00293 5.59961C8.6487 5.27057 9.35086 5.13081 10.1631 5.06445C10.9636 4.99906 11.9566 5 13.2002 5H18C18.5523 5 19 5.44771 19 6C19 6.55228 18.5523 7 18 7H13.2002C11.9238 7 11.0263 7.00044 10.3262 7.05762C9.63763 7.11387 9.22797 7.2204 8.91113 7.38184C8.25261 7.71738 7.71738 8.25261 7.38184 8.91113C7.2204 9.22797 7.11387 9.63763 7.05762 10.3262C7.00044 11.0263 7 11.9238 7 13.2002V18C7 18.5523 6.55228 19 6 19C5.44771 19 5 18.5523 5 18Z" }) });
});
BorderRadiusTopLeftIcon.displayName = "BorderRadiusTopLeftIcon";

const BorderRadiusTopRightIcon = forwardRef$1(function BorderRadiusTopRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M6 5L10.7998 5C12.0434 5 13.0364 4.99906 13.8369 5.06445C14.6491 5.13082 15.3513 5.27057 15.9971 5.59961C17.0318 6.12689 17.8731 6.96816 18.4004 8.00293C18.7294 8.6487 18.8692 9.35086 18.9355 10.1631C19.0009 10.9636 19 11.9566 19 13.2002V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V13.2002C17 11.9238 16.9996 11.0263 16.9424 10.3262C16.8861 9.63763 16.7796 9.22797 16.6182 8.91113C16.2826 8.25261 15.7474 7.71738 15.0889 7.38184C14.772 7.2204 14.3624 7.11387 13.6738 7.05762C12.9737 7.00044 12.0762 7 10.7998 7L6 7C5.44772 7 5 6.55229 5 6C5 5.44772 5.44772 5 6 5Z" }) });
});
BorderRadiusTopRightIcon.displayName = "BorderRadiusTopRightIcon";

const BrandCenterIcon = forwardRef$1(function BrandCenterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M10.3066 3C11.0615 3 11.7456 3.30059 12.2412 3.78711C12.4944 3.68408 12.7914 3.69455 13.0469 3.83984L16.6221 5.87305C17.276 6.24504 17.7151 6.84292 17.8975 7.50879C18.1685 7.5446 18.42 7.69881 18.5674 7.9502L20.6328 11.4736C21.3892 12.7651 20.9395 14.4156 19.6289 15.1611L10.7637 20.2051C10.7466 20.2148 10.7284 20.222 10.7109 20.2305C9.93357 20.7167 9.01234 21 8.02344 21C5.24906 20.9999 3 18.7836 3 16.0498V5.7002C3 4.20903 4.22689 3 5.74023 3H10.3066ZM5.74023 4.7998C5.23579 4.7998 4.82715 5.20314 4.82715 5.7002V16.0498C4.82715 17.7895 6.25795 19.2001 8.02344 19.2002C9.78901 19.2002 11.2207 17.7895 11.2207 16.0498V5.7002C11.2207 5.20313 10.8111 4.7998 10.3066 4.7998H5.74023ZM8.02344 14.7002C8.78005 14.7002 9.39345 15.3043 9.39355 16.0498C9.39355 16.7954 8.78011 17.4004 8.02344 17.4004C7.26683 17.4003 6.65332 16.7953 6.65332 16.0498C6.65343 15.3044 7.26689 14.7003 8.02344 14.7002ZM13.5293 16.5527L18.7158 13.6035C19.1526 13.3551 19.3025 12.8045 19.0508 12.374L17.5137 9.75098L13.5293 16.5527ZM13.0469 13.7744L16.043 8.66211C16.2952 8.23173 16.1458 7.6812 15.709 7.43262L13.0469 5.91699V13.7744Z" }) });
});
BrandCenterIcon.displayName = "BrandCenterIcon";

const BrandIcon = forwardRef$1(function BrandIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.4746 2.70365C11.279 1.76544 12.7239 1.76546 13.5283 2.70365L14.8681 4.26615C14.8709 4.26939 14.8736 4.27143 14.875 4.27201H14.8769L16.8955 3.94779C18.1217 3.75088 19.2087 4.6983 19.2295 5.91752L19.2646 7.98783C19.265 8.00352 19.2729 8.01315 19.2773 8.01615L21.0293 9.08256C22.078 9.72107 22.3196 11.1399 21.5576 12.0933L20.2705 13.7027C20.2676 13.7065 20.2648 13.7124 20.2636 13.7193C20.2625 13.7265 20.2634 13.7342 20.2656 13.7408L20.9306 15.6978C21.3222 16.8499 20.6234 18.1093 19.4101 18.3482L17.4043 18.7427C17.4025 18.7433 17.395 18.7467 17.3906 18.7583L16.6591 20.6919C16.2247 21.8395 14.8733 22.35 13.791 21.7417L12.0048 20.7369H12.0039C12.0025 20.7362 12.0013 20.7359 12.0009 20.7359L11.999 20.7369H11.998L10.2119 21.7417H10.2109C9.12856 22.3494 7.77801 21.8392 7.34371 20.6919L6.61226 18.7583C6.60733 18.7453 6.59899 18.7428 6.59859 18.7427L4.59273 18.3482C3.37971 18.1092 2.68073 16.8499 3.07223 15.6978L3.73726 13.7408C3.73949 13.7342 3.74038 13.7265 3.73922 13.7193C3.73799 13.7122 3.73535 13.7065 3.73238 13.7027L2.44527 12.0933C1.68334 11.14 1.92494 9.72117 2.97359 9.08256L4.72555 8.01615C4.72985 8.01325 4.73789 8.00371 4.73824 7.98783L4.7734 5.91752C4.79418 4.69833 5.88123 3.75103 7.10738 3.94779L9.12594 4.27201H9.12789C9.12912 4.27156 9.13188 4.26941 9.13473 4.26615L10.4746 2.70365ZM11.998 4.00053C11.9973 4.00113 11.9953 4.00287 11.9931 4.00541L10.6533 5.56791C10.1988 6.09785 9.50154 6.35797 8.80855 6.24662L6.79 5.9224L6.78805 5.92142C6.78721 5.9221 6.78576 5.92395 6.78414 5.92533C6.78104 5.92808 6.77794 5.93175 6.77633 5.9351C6.77511 5.93782 6.77355 5.94291 6.7734 5.9517L6.73824 8.02201C6.72636 8.7161 6.3617 9.36172 5.76461 9.72513L4.01363 10.7915C4.00974 10.7939 4.00794 10.7957 4.0068 10.7974C4.00497 10.8002 4.00218 10.8059 4.00094 10.813C3.99975 10.8203 3.99983 10.8271 4.00094 10.8316C4.00182 10.835 4.00355 10.839 4.00777 10.8443L5.29391 12.4537C5.72872 12.9976 5.85439 13.7267 5.63082 14.3843L4.96578 16.3423C4.96306 16.3505 4.96245 16.356 4.96285 16.3599C4.96343 16.3648 4.96571 16.3702 4.96871 16.3755C4.97174 16.3808 4.97449 16.3844 4.97555 16.3853C4.97588 16.3855 4.97749 16.3859 4.97945 16.3863L6.98531 16.7808C7.67326 16.9162 8.23612 17.3997 8.48238 18.0503L9.2148 19.9839L9.21871 19.9927C9.21947 19.9938 9.22009 19.9951 9.22066 19.9956C9.22197 19.9969 9.22433 19.9977 9.22652 19.9986H9.23141L11.0185 18.9937C11.6293 18.6503 12.3735 18.6503 12.9843 18.9937L14.7714 19.9986H14.7763C14.7784 19.9978 14.7808 19.9967 14.7822 19.9956C14.7827 19.9951 14.7835 19.9938 14.7841 19.9927C14.7849 19.9915 14.7864 19.9883 14.788 19.9839L15.5205 18.0503L15.5703 17.9302C15.8375 17.3407 16.3728 16.9078 17.0175 16.7808L19.0234 16.3863C19.0251 16.3859 19.0267 16.3855 19.0273 16.3853C19.0283 16.3846 19.0311 16.3808 19.0341 16.3755C19.0371 16.3703 19.0394 16.3647 19.04 16.3599C19.0404 16.356 19.0398 16.3506 19.0371 16.3423L18.372 14.3843C18.1485 13.7269 18.2745 12.9975 18.7089 12.4537L19.9951 10.8443C19.9992 10.839 20.001 10.835 20.0019 10.8316C20.003 10.827 20.0031 10.8203 20.0019 10.813C20.0006 10.8056 19.9979 10.8002 19.9961 10.7974C19.9949 10.7956 19.9934 10.7941 19.9892 10.7915L18.2382 9.72513C17.6413 9.36173 17.2764 8.71612 17.2646 8.02201L17.2295 5.9517C17.2293 5.94265 17.2278 5.93778 17.2265 5.9351C17.2249 5.93165 17.2219 5.92812 17.2187 5.92533C17.2162 5.92323 17.2144 5.92166 17.2138 5.92142L17.2129 5.9224L15.1943 6.24662C14.5013 6.35787 13.804 6.09806 13.3496 5.56791L12.0097 4.00541L12.0048 4.00053V3.99955H11.998V4.00053ZM13.7548 9.7974C14.1427 9.40429 14.7758 9.39982 15.1689 9.78763C15.562 10.1755 15.5664 10.8085 15.1787 11.2017L12.0742 14.3482C11.49 14.9399 10.5364 14.9403 9.95211 14.3482L8.82125 13.2017C8.43353 12.8086 8.43796 12.1755 8.83101 11.7876C9.22415 11.3999 9.85722 11.4043 10.2451 11.7974L11.0127 12.5757L13.7548 9.7974Z" }) });
});
BrandIcon.displayName = "BrandIcon";

const BreakdownIcon = forwardRef$1(function BreakdownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5 1.99902C5.55228 1.99902 6 2.44772 6 3V3.80859H18.125C19.6739 3.80859 20.9998 5.02422 21 6.6084V7.80566C20.9997 9.38989 19.6737 10.6053 18.125 10.6055H15.7236C15.8003 10.8577 15.8438 11.1263 15.8438 11.4062V12.6025C15.8435 14.1868 14.5176 15.4033 12.9688 15.4033H10.5674C10.6439 15.6553 10.6875 15.9235 10.6875 16.2031V17.4004C10.687 18.9844 9.36117 20.2002 7.8125 20.2002H6V21C5.99974 21.5521 5.55212 22 5 22C4.44788 22 4.00026 21.5521 4 21V3C4 2.44772 4.44772 1.99902 5 1.99902ZM6 15.4033V18.2002H7.8125C8.33424 18.2002 8.68699 17.8038 8.6875 17.4004V16.2031C8.6875 15.7994 8.33462 15.4033 7.8125 15.4033H6ZM6 10.6055V13.4033H12.9688C13.4907 13.4033 13.8435 13.0062 13.8438 12.6025V11.4062C13.8438 11.0025 13.4909 10.6055 12.9688 10.6055H6ZM6 5.80859V8.60547H18.125L18.2207 8.60156C18.6897 8.55658 18.9997 8.18394 19 7.80566V6.6084C18.9998 6.20483 18.6469 5.80859 18.125 5.80859H6Z" }) });
});
BreakdownIcon.displayName = "BreakdownIcon";

const BuildingIcon = forwardRef$1(function BuildingIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M10 12C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H8C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12H10Z" }), jsx("path", { d: "M10 8C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9C7 8.44772 7.44772 8 8 8H10Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C13.6569 3 15 4.34315 15 6V7H18C19.6569 7 21 8.34315 21 10V18H22C22.5523 18 23 18.4477 23 19C23 19.5523 22.5523 20 22 20H2C1.44772 20 1 19.5523 1 19C1 18.4477 1.44772 18 2 18H3V6C3 4.34315 4.34315 3 6 3H12ZM6 5C5.44771 5 5 5.44771 5 6V18H13V6C13 5.4477 12.5523 5 12 5H6ZM15 18H19V10C19 9.4477 18.5523 9 18 9H15V18Z" })] });
});
BuildingIcon.displayName = "BuildingIcon";

const BulbSuggestionIcon = forwardRef$1(function BulbSuggestionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.6445 20.0059C14.1487 20.0571 14.5419 20.4833 14.542 21.001C14.5419 21.5187 14.1487 21.9449 13.6445 21.9961L13.542 22.001H9.74609C9.19385 22.001 8.74616 21.5532 8.74609 21.001C8.74619 20.4488 9.19387 20.001 9.74609 20.001H13.542L13.6445 20.0059ZM11.6445 2C12.2456 2.00005 12.8317 2.06945 13.3945 2.20117L13.6348 2.26172L13.7314 2.29297C14.2052 2.47313 14.4749 2.98634 14.3408 3.48633C14.2065 3.98621 13.716 4.296 13.2158 4.21484L13.1152 4.19336L12.7598 4.11035C12.3999 4.03842 12.0271 4.00004 11.6445 4C8.52575 4 6.00009 6.52316 6 9.63184C6.00004 11.584 6.99601 13.3047 8.5127 14.3164H14.7744C15.4666 13.8547 16.0521 13.246 16.4824 12.5332C16.7678 12.0605 17.3827 11.9083 17.8555 12.1934C18.328 12.4788 18.4804 13.0937 18.1953 13.5664C17.6316 14.5003 16.8733 15.304 15.9766 15.9209L15.584 16.1738C15.5537 16.192 15.5217 16.2078 15.4912 16.2256V17.2119C15.4909 18.2888 14.6165 19.1591 13.542 19.1592H9.74609C8.67154 19.1592 7.7972 18.2889 7.79688 17.2119V16.2256L7.7041 16.1738C5.48709 14.8403 4.00004 12.41 4 9.63184C4.00009 5.41517 7.42461 2 11.6445 2ZM9.79688 17.1592H13.4912V16.3164H9.79688V17.1592ZM17.3887 3.26172C17.5635 2.91257 18.0634 2.91257 18.2383 3.26172L19.166 5.11523C19.2119 5.20691 19.287 5.28131 19.3789 5.32715L21.2354 6.25391C21.5851 6.42848 21.5851 6.92699 21.2354 7.10156L19.3789 8.02832C19.287 8.07416 19.2119 8.14855 19.166 8.24023L18.2383 10.0938C18.0634 10.4429 17.5635 10.4429 17.3887 10.0938L16.46 8.24023C16.4141 8.1486 16.3399 8.07414 16.248 8.02832L14.3916 7.10156C14.0418 6.92699 14.0418 6.42848 14.3916 6.25391L16.248 5.32715C16.3399 5.28132 16.4141 5.20688 16.46 5.11523L17.3887 3.26172Z" }) });
});
BulbSuggestionIcon.displayName = "BulbSuggestionIcon";

const CalendarDynamicIcon = forwardRef$1(function CalendarDynamicIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.3205 1.53236C13.8282 1.3971 14.3495 1.69827 14.4856 2.20424L14.7326 3.12025L15.6526 2.87514C17.1759 2.4685 18.7413 3.36874 19.1496 4.88685L20.3821 9.46986C20.5179 9.97594 20.216 10.4964 19.7082 10.632C19.2006 10.7674 18.6794 10.467 18.5432 9.96107L18.05 8.12709L5.176 11.5656L7.1467 18.8986C7.28282 19.4047 7.80588 19.7051 8.31369 19.5695L13.8303 18.0958C14.338 17.9604 14.8602 18.2607 14.9963 18.7667C15.1322 19.2728 14.8302 19.7923 14.3225 19.9279L8.80588 21.4015C7.28246 21.8083 5.71611 20.9082 5.30783 19.3898L2.59787 9.30775C2.18984 7.78932 3.09493 6.22929 4.61838 5.8224L5.5383 5.57631L5.29025 4.66029C5.15418 4.15413 5.45628 3.63282 5.96408 3.49721C6.47171 3.36172 6.99385 3.66224 7.1301 4.1681L7.37717 5.0851L12.8938 3.61146L12.6467 2.69545C12.5106 2.18928 12.8127 1.66798 13.3205 1.53236ZM18.4602 13.0548C18.6378 12.2345 19.8126 12.2346 19.9904 13.0548L20.0783 13.4572C20.2466 14.2367 20.8569 14.846 21.6389 15.0138L22.0422 15.0997C22.8659 15.2765 22.8659 16.4484 22.0422 16.6251L21.6389 16.712C20.857 16.8798 20.2467 17.4893 20.0783 18.2687L19.9904 18.671C19.813 19.492 18.6376 19.492 18.4602 18.671L18.3742 18.2687C18.2059 17.4892 17.5939 16.8796 16.8117 16.712L16.4084 16.6251C15.5855 16.4479 15.5853 15.2767 16.4084 15.0997L16.8117 15.0138C17.594 14.8462 18.206 14.2369 18.3742 13.4572L18.4602 13.0548ZM17.3108 5.37807C17.1746 4.87214 16.6525 4.57162 16.1447 4.70717L5.11057 7.65443C4.60284 7.79005 4.3009 8.31048 4.43674 8.81654L4.68381 9.73353L17.5578 6.29506L17.3108 5.37807Z", fill: "currentColor" }) });
});
CalendarDynamicIcon.displayName = "CalendarDynamicIcon";

const CampaignsIcon = forwardRef$1(function CampaignsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M12.9492 14.7383H12.9482C12.3327 14.9433 11.6673 14.9433 11.0518 14.7383H11.0508L4 12.3877V18C4 18.5523 4.44771 19 5 19H19C19.5523 19 20 18.5523 20 18V12.3877L12.9492 14.7383ZM14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H10C9.44772 9 9 8.55228 9 8C9 7.44772 9.44772 7 10 7H14ZM18 5C18 4.44771 17.5523 4 17 4H7C6.44771 4 6 4.44771 6 5V10.9453L11.6836 12.8408L11.8398 12.8789C11.9987 12.9047 12.1622 12.8922 12.3164 12.8408L18 10.9453V5ZM20 10.3887C21.0641 10.387 22 11.2458 22 12.3877V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V12.3877C2 11.2458 2.9359 10.387 4 10.3887V5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V10.3887Z" }) });
});
CampaignsIcon.displayName = "CampaignsIcon";

const CartIcon = forwardRef$1(function CartIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M8.9043 17.1279C9.88118 17.2264 10.6571 18.0454 10.6572 19.0596C10.6571 20.1415 9.774 21.001 8.70605 21.001C7.70486 21.0009 6.86559 20.2457 6.76465 19.2598L6.75488 19.0596L6.76465 18.8594C6.86572 17.8736 7.70495 17.1182 8.70605 17.1182L8.9043 17.1279ZM17.4619 17.1279C18.4388 17.2264 19.2147 18.0454 19.2148 19.0596C19.2148 20.1414 18.3316 21.001 17.2637 21.001C16.2626 21.0007 15.4232 20.2456 15.3223 19.2598L15.3125 19.0596L15.3223 18.8594C15.4233 17.8737 16.2627 17.1184 17.2637 17.1182L17.4619 17.1279ZM3.69434 3C4.8722 3.00023 5.89098 3.84445 6.08789 5.01367L6.22363 5.82324H19.5752C21.0417 5.82357 22.1782 7.11198 21.9795 8.55762L21.957 8.69727L21.0713 13.2021C20.7172 15.0047 19.1263 16.2937 17.29 16.2939H9.2207C7.40431 16.2938 5.83386 15.034 5.4541 13.2734L5.4209 13.1006L4.3916 6.98926L4.11523 5.3457C4.08287 5.1538 3.91048 5.00023 3.69434 5H3.00098C2.44869 5 2.00098 4.55228 2.00098 4C2.00105 3.44778 2.44874 3 3.00098 3H3.69434ZM7.39355 12.7686L7.42773 12.9297C7.63632 13.7206 8.36419 14.2938 9.2207 14.2939H17.29C18.1844 14.2937 18.9421 13.668 19.1094 12.8174L19.9941 8.3125L20.001 8.22168C19.9931 8.01295 19.8197 7.82353 19.5752 7.82324H6.56055L7.39355 12.7686Z" }) });
});
CartIcon.displayName = "CartIcon";

const ChangeIcon = forwardRef$1(function ChangeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.44774 5.36328C10.6415 3.48513 13.5874 3.54754 14.6645 5.55078L19.6606 14.8437L19.7534 15.0322C20.6365 16.9821 19.0434 18.9995 16.9975 19H7.00536C4.89342 18.9998 3.26384 16.8499 4.34227 14.8437L9.33836 5.55078L9.44774 5.36328ZM12.9028 6.49804C12.5683 5.87579 11.5907 5.83684 11.1753 6.38086L11.1001 6.49804L6.10399 15.791C5.8575 16.2495 6.15478 16.9999 7.00536 17H16.9975C17.7947 16.9996 18.1064 16.34 17.939 15.8799L17.8989 15.791L12.9028 6.49804Z" }) });
});
ChangeIcon.displayName = "ChangeIcon";

const ChatIcon = forwardRef$1(function ChatIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.002 4C20.6587 4 22.002 5.34312 22.002 7V17C22.002 18.6569 20.6587 20 19.002 20H12.2793L7.5166 22.8574C7.20767 23.0428 6.8223 23.0476 6.50879 22.8701C6.19551 22.6926 6.00195 22.3601 6.00195 22V20H5.00195C3.34511 20 2.00195 18.6569 2.00195 17V7C2.00195 5.34315 3.3451 4 5.00195 4H19.002ZM5.00195 6C4.44967 6 4.00195 6.44771 4.00195 7V17C4.00195 17.5523 4.44966 18 5.00195 18H7.00195C7.55424 18 8.00195 18.4477 8.00195 19V20.2334L11.4873 18.1426L11.6084 18.0811C11.7324 18.028 11.8661 18 12.002 18H19.002C19.5542 18 20.002 17.5523 20.002 17V7C20.002 6.44774 19.5542 6 19.002 6H5.00195ZM7.52051 10.751L7.61035 10.7559H7.61914L7.62793 10.7568C8.25816 10.8212 8.75 11.3526 8.75 12C8.75 12.6903 8.19037 13.25 7.5 13.25C6.80963 13.25 6.25 12.6903 6.25 12C6.25 11.3097 6.80963 10.75 7.5 10.75H7.50977L7.52051 10.751ZM12 10.75C12.6903 10.75 13.25 11.3097 13.25 12C13.25 12.6903 12.6903 13.25 12 13.25C11.3097 13.25 10.75 12.6903 10.75 12C10.75 11.3097 11.3097 10.75 12 10.75ZM16.5 10.75C17.1903 10.75 17.75 11.3097 17.75 12C17.75 12.6903 17.1903 13.25 16.5 13.25C15.8097 13.25 15.25 12.6903 15.25 12C15.25 11.3097 15.8097 10.75 16.5 10.75Z" }) });
});
ChatIcon.displayName = "ChatIcon";

const CheckIcon = forwardRef$1(function CheckIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M18.2421 6.34653C18.6031 5.92872 19.2353 5.882 19.6532 6.24301C20.0706 6.60403 20.1164 7.23538 19.7557 7.65317L11.2655 17.4823C10.699 18.138 9.69577 18.1777 9.07801 17.5702L5.29871 13.8514C4.90517 13.4641 4.89969 12.831 5.28699 12.4374C5.67436 12.0439 6.30747 12.0394 6.70105 12.4266L10.0995 15.7713L18.2421 6.34653Z" }) });
});
CheckIcon.displayName = "CheckIcon";

const ChevronDoubleLeftIcon = forwardRef$1(function ChevronDoubleLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.3115 7.27436C10.7122 6.89448 11.3456 6.91108 11.7256 7.31147C12.1055 7.71216 12.089 8.3455 11.6885 8.72554L8.2344 11.9999L11.6885 15.2744L11.7588 15.3486C12.0894 15.7327 12.0818 16.3128 11.7256 16.6884C11.3693 17.0638 10.7907 17.1018 10.3897 16.7919L10.3115 16.7255L6.46682 13.0791H6.46584C5.84472 12.4895 5.84472 11.5104 6.46584 10.9208H6.46682L10.3115 7.27436ZM16.3115 7.27436C16.7122 6.89461 17.3456 6.91101 17.7256 7.31147C18.1053 7.71211 18.0888 8.34554 17.6885 8.72554L14.2344 11.9999L17.6885 15.2744L17.7588 15.3486C18.0892 15.7326 18.0816 16.3128 17.7256 16.6884C17.3693 17.0639 16.7907 17.1016 16.3897 16.7919L16.3115 16.7255L12.4668 13.0791H12.4658C11.8445 12.4894 11.8445 11.5105 12.4658 10.9208H12.4668L16.3115 7.27436Z" }) });
});
ChevronDoubleLeftIcon.displayName = "ChevronDoubleLeftIcon";

const ChevronDoubleRightIcon = forwardRef$1(function ChevronDoubleRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.6884 7.27464C13.2878 6.89475 12.6544 6.91136 12.2743 7.31175C11.8946 7.71244 11.911 8.34582 12.3114 8.72581L15.7655 12.0002L12.3114 15.2746L12.2411 15.3489C11.9107 15.733 11.9182 16.3131 12.2743 16.6887C12.6306 17.0639 13.2093 17.1019 13.6103 16.7922L13.6884 16.7258L17.5331 13.0793H17.5341C18.1552 12.4898 18.1551 11.5107 17.5341 10.9211H17.5331L13.6884 7.27464ZM7.6884 7.27464C7.28771 6.89488 6.65431 6.91128 6.27434 7.31175C5.89477 7.71239 5.9112 8.34586 6.31145 8.72581L9.76555 12.0002L6.31145 15.2746L6.24113 15.3489C5.91092 15.7329 5.91838 16.3131 6.27434 16.6887C6.63057 17.064 7.20927 17.1017 7.61027 16.7922L7.6884 16.7258L11.5331 13.0793H11.5341C12.1554 12.4898 12.1553 11.5107 11.5341 10.9211H11.5331L7.6884 7.27464Z" }) });
});
ChevronDoubleRightIcon.displayName = "ChevronDoubleRightIcon";

const ChevronDownIcon = forwardRef$1(function ChevronDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M16.3487 8.24123C16.7328 7.9107 17.3128 7.91827 17.6885 8.27444C18.089 8.65447 18.1055 9.28782 17.7256 9.6885L13.168 14.4951C12.5295 15.1682 11.4705 15.1682 10.8321 14.4951L6.27444 9.6885C5.89455 9.28782 5.91104 8.65446 6.31155 8.27444C6.71221 7.89452 7.34557 7.91107 7.72561 8.31155L12 12.8213L16.2744 8.31155L16.3487 8.24123Z" }), jsx("path", { d: "M16.3486 8.24122C16.7327 7.9107 17.3128 7.91828 17.6885 8.27443C18.089 8.65446 18.1055 9.28781 17.7256 9.68849L13.168 14.4951C12.5295 15.1682 11.4705 15.1682 10.832 14.4951L6.27442 9.68849C5.89457 9.2878 5.91104 8.65444 6.31153 8.27443C6.71219 7.89452 7.34556 7.91108 7.7256 8.31154L12 12.8213L16.2744 8.31154L16.3486 8.24122Z" })] });
});
ChevronDownIcon.displayName = "ChevronDownIcon";

const ChevronLeftIcon = forwardRef$1(function ChevronLeftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.7255 6.31196C15.3456 5.91146 14.7132 5.89424 14.3124 6.27387L9.50578 10.8315C8.83279 11.4699 8.83284 12.528 9.50578 13.1665L14.3124 17.7241C14.7131 18.1039 15.3455 18.0873 15.7255 17.687C16.1054 17.2862 16.0891 16.6529 15.6884 16.2729L11.1806 11.9995L15.6884 7.72505C16.0888 7.345 16.1054 6.71262 15.7255 6.31196Z" }) });
});
ChevronLeftIcon.displayName = "ChevronLeftIcon";

const ChevronRightIcon = forwardRef$1(function ChevronRightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.24122 7.65136C8.9107 7.26726 8.91828 6.68718 9.27443 6.31151C9.65446 5.91099 10.2878 5.89448 10.6885 6.2744L15.4951 10.832C16.1682 11.4705 16.1682 12.5295 15.4951 13.168L10.6885 17.7256C10.2878 18.1054 9.65444 18.089 9.27443 17.6885C8.89452 17.2878 8.91108 16.6544 9.31154 16.2744L13.8213 12L9.31154 7.72558L9.24122 7.65136Z" }) });
});
ChevronRightIcon.displayName = "ChevronRightIcon";

const ChevronUpIcon = forwardRef$1(function ChevronUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.3486 15.7588C16.7327 16.0893 17.3128 16.0817 17.6885 15.7256C18.089 15.3455 18.1055 14.7122 17.7256 14.3115L13.168 9.50487C12.5295 8.83182 11.4705 8.83182 10.832 9.50487L6.27442 14.3115C5.89457 14.7122 5.91104 15.3456 6.31153 15.7256C6.71219 16.1055 7.34556 16.0889 7.7256 15.6885L12 11.1787L16.2744 15.6885L16.3486 15.7588Z" }) });
});
ChevronUpIcon.displayName = "ChevronUpIcon";

const CleanUpIcon = forwardRef$1(function CleanUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C12.5521 2.00003 12.9998 2.44791 13 3V5H17.5C18.2993 5 18.9468 5.4342 19.3604 5.98535C19.7736 6.53639 20 7.25226 20 8C20 8.74774 19.7736 9.46361 19.3604 10.0146C18.9468 10.5658 18.2993 11 17.5 11H13V13H15.5C16.2993 13 16.9468 13.4342 17.3604 13.9854C17.7736 14.5364 18 15.2523 18 16C18 16.7477 17.7736 17.4636 17.3604 18.0146C16.9468 18.5658 16.2993 19 15.5 19H13V20.998L12.9951 21.1006C12.9438 21.6047 12.5177 21.998 12 21.998C11.4823 21.998 11.0562 21.6048 11.0049 21.1006L11 20.998V19H8.5C7.70066 19 7.05317 18.5658 6.63965 18.0146C6.22637 17.4636 6 16.7477 6 16C6 15.2523 6.22637 14.5364 6.63965 13.9854C7.05317 13.4342 7.70066 13 8.5 13H11V11H6.5C5.70067 11 5.05318 10.5658 4.63965 10.0146C4.22636 9.4636 4 8.74773 4 8C4 7.25227 4.22636 6.5364 4.63965 5.98535C5.05318 5.4342 5.70067 5 6.5 5H11V3C11.0002 2.4479 11.4478 2 12 2ZM8.5 15C8.47113 15 8.3686 15.0131 8.23926 15.1855C8.10964 15.3584 8 15.6432 8 16C8 16.3568 8.10964 16.6416 8.23926 16.8145C8.3686 16.9869 8.47113 17 8.5 17H15.5C15.5288 17 15.6314 16.9869 15.7607 16.8145C15.8904 16.6416 16 16.3568 16 16C16 15.6432 15.8904 15.3584 15.7607 15.1855C15.6314 15.0131 15.5288 15 15.5 15H8.5ZM6.5 7C6.47112 7 6.36859 7.01315 6.23926 7.18555C6.10965 7.35836 6 7.64316 6 8C6 8.35684 6.10965 8.64164 6.23926 8.81445C6.36859 8.98685 6.47112 9 6.5 9H17.5C17.5289 9 17.6314 8.98686 17.7607 8.81445C17.8904 8.64164 18 8.35683 18 8C18 7.64317 17.8904 7.35836 17.7607 7.18555C17.6314 7.01314 17.5289 7 17.5 7H6.5Z" }) });
});
CleanUpIcon.displayName = "CleanUpIcon";

const ClickIcon = forwardRef$1(function ClickIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.60156 11.4629C9.16924 10.3344 10.2286 9.22784 11.3535 9.56445L11.4629 9.60156L20.0771 12.9004H20.0762C21.159 13.3149 21.3239 14.758 20.4053 15.415L20.3125 15.4766L17.3096 17.3105L15.4766 20.3125C14.8719 21.3014 13.4221 21.201 12.9434 20.1777L12.9004 20.0762L9.60156 11.4629ZM14.3613 18.3008L15.6748 16.1523L15.7725 16.0127C15.8778 15.879 16.0064 15.7642 16.1523 15.6748H16.1533L18.3008 14.3613L11.916 11.916L14.3613 18.3008ZM6.29883 14.415C6.68932 14.0249 7.32245 14.0248 7.71289 14.415C8.10332 14.8055 8.10312 15.4386 7.71289 15.8291L6.77637 16.7656C6.38584 17.1562 5.75283 17.1561 5.3623 16.7656C4.97196 16.3751 4.97184 15.742 5.3623 15.3516L6.29883 14.415ZM5.42676 10.0693C5.93097 10.1206 6.32422 10.5467 6.32422 11.0645C6.32412 11.5821 5.93093 12.0083 5.42676 12.0596L5.32422 12.0645H4C3.44778 12.0645 3.00011 11.6166 3 11.0645C3 10.5122 3.44772 10.0645 4 10.0645H5.32422L5.42676 10.0693ZM15.4287 5.29395C15.8214 4.97359 16.4004 4.99643 16.7666 5.3623C17.1326 5.7283 17.1559 6.30744 16.8359 6.7002L16.7666 6.77637L15.8301 7.71289C15.4395 8.10338 14.8065 8.10342 14.416 7.71289C14.0257 7.32234 14.0256 6.68927 14.416 6.29883L15.3525 5.3623L15.4287 5.29395ZM5.3623 5.36133C5.72842 4.99545 6.30751 4.97272 6.7002 5.29297L6.77637 5.36133L7.71289 6.29785L7.78125 6.37402C8.10162 6.76671 8.07881 7.34575 7.71289 7.71191C7.34674 8.07805 6.76777 8.10072 6.375 7.78027L6.29883 7.71191L5.3623 6.77539L5.29395 6.69922C4.97368 6.30645 4.99623 5.72742 5.3623 5.36133ZM11.0645 3C11.6167 3 12.0645 3.44772 12.0645 4V5.32422C12.0643 5.87641 11.6167 6.32422 11.0645 6.32422C10.5123 6.32417 10.0646 5.87638 10.0645 5.32422V4C10.0645 3.44775 10.5122 3.00005 11.0645 3Z" }) });
});
ClickIcon.displayName = "ClickIcon";

const CloseIcon = forwardRef$1(function CloseIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5.29299 5.29301C5.6591 4.92689 6.2381 4.9043 6.63088 5.22465L6.70705 5.29301L12 10.586L17.293 5.29301L17.3692 5.22465C17.7619 4.9043 18.3409 4.92689 18.707 5.29301C19.073 5.65913 19.0957 6.23817 18.7754 6.6309L18.707 6.70707L13.4141 12L18.707 17.293L18.7754 17.3692C19.0956 17.762 19.0731 18.341 18.707 18.7071C18.341 19.0731 17.7619 19.0957 17.3692 18.7754L17.293 18.7071L12 13.4141L6.70705 18.7071C6.31656 19.0975 5.6835 19.0975 5.29299 18.7071C4.90248 18.3166 4.90252 17.6835 5.29299 17.293L10.586 12L5.29299 6.70707L5.22463 6.6309C4.90429 6.23815 4.92693 5.65913 5.29299 5.29301Z" }) });
});
CloseIcon.displayName = "CloseIcon";

const CodeBlockIcon = forwardRef$1(function CodeBlockIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.7998 3C17.3434 3 17.8116 2.99893 18.1953 3.03028C18.5412 3.05855 18.8856 3.11652 19.2197 3.25977L19.3623 3.32715C19.8562 3.57884 20.2695 3.96167 20.5576 4.43165L20.6729 4.6377C20.8656 5.01601 20.9374 5.40943 20.9697 5.80469C21.0011 6.18837 21 6.65665 21 7.2002V16.7998C21 17.3434 21.0011 17.8116 20.9697 18.1953C20.9415 18.5412 20.8835 18.8856 20.7402 19.2197L20.6729 19.3623C20.4211 19.8563 20.0383 20.2695 19.5684 20.5576L19.3623 20.6729C18.984 20.8656 18.5906 20.9374 18.1953 20.9697C17.8116 21.0011 17.3434 21 16.7998 21H7.2002C6.65665 21 6.18836 21.0011 5.80469 20.9697C5.40944 20.9374 5.016 20.8656 4.6377 20.6729L4.43165 20.5576C3.96166 20.2694 3.57887 19.8562 3.32715 19.3623L3.25977 19.2197C3.11652 18.8856 3.05855 18.5412 3.03028 18.1953C2.99893 17.8116 3 17.3434 3 16.7998V11.5L3.00489 11.3975C3.05622 10.8933 3.48233 10.5 4 10.5C4.51768 10.5 4.94379 10.8933 4.99512 11.3975L5 11.5V16.7998C5 17.3764 5.00127 17.7489 5.02442 18.0322C5.04105 18.2357 5.06565 18.3433 5.0879 18.4053L5.10938 18.4541C5.1813 18.5952 5.28523 18.7164 5.41211 18.8086L5.5459 18.8906C5.59533 18.9158 5.69619 18.9534 5.96778 18.9756C6.25111 18.9987 6.62365 19 7.2002 19H16.7998C17.3764 19 17.7489 18.9987 18.0322 18.9756C18.3038 18.9534 18.4047 18.9158 18.4541 18.8906L18.5879 18.8086C18.7148 18.7163 18.8188 18.5951 18.8906 18.4541L18.9121 18.4053C18.9344 18.3433 18.959 18.2357 18.9756 18.0322C18.9987 17.7489 19 17.3764 19 16.7998V7.2002C19 6.62365 18.9987 6.25112 18.9756 5.96778C18.9534 5.69617 18.9158 5.59531 18.8906 5.5459L18.8086 5.41211C18.7164 5.28523 18.5952 5.18127 18.4541 5.10938L18.4053 5.0879C18.3433 5.06566 18.2357 5.04105 18.0322 5.02442C17.7489 5.00127 17.3764 5 16.7998 5H15.5C14.9477 5 14.5 4.55229 14.5 4C14.5 3.44772 14.9477 3.00001 15.5 3H16.7998ZM5.36915 3.22461C5.76192 2.90426 6.34092 2.92686 6.70704 3.29297C7.07315 3.65909 7.09575 4.23809 6.7754 4.63086L6.70704 4.70704L5.41407 6L6.70704 7.29297C7.09756 7.6835 7.09756 8.31651 6.70704 8.70704C6.31651 9.09756 5.6835 9.09756 5.29297 8.70704L3.29297 6.70704L3.22461 6.63086C2.92562 6.26428 2.92562 5.73573 3.22461 5.36915L3.29297 5.29297L5.29297 3.29297L5.36915 3.22461ZM9.29297 3.29297C9.65909 2.92686 10.2381 2.90427 10.6309 3.22461L10.707 3.29297L12.707 5.29297L12.7754 5.36915C13.0744 5.73573 13.0744 6.26428 12.7754 6.63086L12.707 6.70704L10.707 8.70704C10.3165 9.09756 9.6835 9.09756 9.29297 8.70704C8.90245 8.31651 8.90245 7.6835 9.29297 7.29297L10.5859 6L9.29297 4.70704L9.22461 4.63086C8.90427 4.23809 8.92686 3.65909 9.29297 3.29297Z" }) });
});
CodeBlockIcon.displayName = "CodeBlockIcon";

const CodeIcon = forwardRef$1(function CodeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.9384 4.15901C13.1105 3.68244 13.6189 3.40462 14.121 3.5301C14.6567 3.66422 14.9826 4.20724 14.8485 4.74299L11.0926 19.7449L11.0634 19.8436C10.891 20.32 10.3819 20.5982 9.87976 20.4725C9.34425 20.3383 9.01837 19.7952 9.15222 19.2596L12.9081 4.25666L12.9384 4.15901ZM18.3407 16.4598C17.9499 16.8494 17.3167 16.8492 16.9266 16.4588C16.5365 16.0681 16.5371 15.434 16.9276 15.0438L18.3407 16.4598ZM5.7362 7.47444C6.12912 7.15439 6.70821 7.17761 7.07409 7.54377C7.46426 7.93457 7.46388 8.56761 7.07312 8.95783L4.02526 12.0008L7.07312 15.0438L7.14245 15.1199C7.46294 15.5125 7.43991 16.0925 7.07409 16.4588C6.70823 16.8246 6.12898 16.8479 5.7362 16.5281L5.66003 16.4598L2.56823 13.3719C1.81038 12.6151 1.8108 11.3875 2.56823 10.6307L5.66003 7.54279L5.7362 7.47444ZM21.4325 10.6307H21.4335L21.5663 10.7781C22.1461 11.4886 22.1463 12.5141 21.5663 13.2244L21.4325 13.3719L18.3407 16.4598L17.6346 15.7518L16.9276 15.0438L19.9745 12.0008L16.9276 8.95783L17.6346 8.2508L18.3407 7.54279L21.4325 10.6307ZM16.9266 7.54377C17.3168 7.15305 17.9499 7.15278 18.3407 7.54279L16.9276 8.95783C16.5372 8.56766 16.5368 7.93451 16.9266 7.54377Z" }) });
});
CodeIcon.displayName = "CodeIcon";

const ColumnChartIcon = forwardRef$1(function ColumnChartIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.49951 19.4995C2.49951 18.9472 2.9482 18.4995 3.50049 18.4995L4.30908 18.4995L4.30908 6.37451C4.30908 4.82564 5.52471 3.49975 7.10889 3.49951L8.30615 3.49951C9.89037 3.49978 11.1058 4.82581 11.106 6.37451L11.106 8.77588C11.3582 8.69918 11.6268 8.65576 11.9067 8.65576L13.103 8.65576C14.6873 8.65603 15.9038 9.98193 15.9038 11.5308L15.9038 13.9321C16.1558 13.8556 16.4239 13.812 16.7036 13.812L17.9009 13.812C19.4849 13.8125 20.7007 15.1383 20.7007 16.687L20.7007 18.4995L21.5005 18.4995C22.0525 18.4998 22.5005 18.9474 22.5005 19.4995C22.5005 20.0516 22.0525 20.4992 21.5005 20.4995L3.50049 20.4995C2.9482 20.4995 2.49951 20.0518 2.49951 19.4995ZM15.9038 18.4995L18.7007 18.4995L18.7007 16.687C18.7007 16.1653 18.3043 15.8125 17.9009 15.812L16.7036 15.812C16.2999 15.812 15.9038 16.1649 15.9038 16.687L15.9038 18.4995ZM11.106 18.4995L13.9038 18.4995L13.9038 11.5308C13.9038 11.0088 13.5066 10.656 13.103 10.6558L11.9067 10.6558C11.503 10.6558 11.106 11.0087 11.106 11.5308L11.106 18.4995ZM6.30908 18.4995L9.10596 18.4995L9.10596 6.37451L9.10205 6.27881C9.05707 5.80985 8.68443 5.49978 8.30615 5.49951L7.10889 5.49951C6.70532 5.49976 6.30908 5.85258 6.30908 6.37451L6.30908 18.4995Z", fill: "currentColor" }) });
});
ColumnChartIcon.displayName = "ColumnChartIcon";

const ColumnDataIcon = forwardRef$1(function ColumnDataIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.2002 3C16.0237 3 16.7016 2.99898 17.252 3.04395C17.814 3.08988 18.3311 3.18827 18.8164 3.43555L19.0918 3.58985C19.7183 3.97414 20.2289 4.52513 20.5645 5.1836L20.6504 5.36719C20.8356 5.79892 20.9159 6.2562 20.9561 6.74805C21.001 7.29843 21 7.97632 21 8.79981V15.2002C21 16.0237 21.001 16.7016 20.9561 17.252C20.9159 17.7438 20.8356 18.2011 20.6504 18.6328L20.5645 18.8164C20.2289 19.4749 19.7183 20.0259 19.0918 20.4102L18.8164 20.5645C18.3311 20.8117 17.814 20.9101 17.252 20.9561C16.7016 21.001 16.0237 21 15.2002 21H8.79981C8.54116 21 8.29689 20.9974 8.06641 20.9961C8.04442 20.9975 8.02235 21 8 21C7.97303 21 7.94636 20.9982 7.91992 20.9961C7.47767 20.9923 7.08846 20.9839 6.74805 20.9561C6.2562 20.9159 5.79892 20.8356 5.36719 20.6504L5.1836 20.5645C4.52513 20.2289 3.97414 19.7183 3.58985 19.0918L3.43555 18.8164C3.18827 18.3311 3.08988 17.814 3.04395 17.252C2.99898 16.7016 3 16.0237 3 15.2002V8.79981C3 7.97632 2.99898 7.29843 3.04395 6.74805C3.08988 6.18599 3.18827 5.6689 3.43555 5.1836C3.81902 4.43109 4.43109 3.81902 5.1836 3.43555C5.6689 3.18827 6.18599 3.08988 6.74805 3.04395C7.08846 3.01613 7.47767 3.00668 7.91992 3.00293C7.94633 3.00084 7.97305 3 8 3C8.02233 3 8.04444 3.00149 8.06641 3.00293C8.29689 3.00168 8.54116 3 8.79981 3H15.2002ZM9 19H15.2002C16.0566 19 16.6388 18.9997 17.0889 18.9629C17.5273 18.9271 17.7518 18.8619 17.9082 18.7822L18.0459 18.7051C18.3592 18.5129 18.6145 18.2374 18.7822 17.9082L18.8389 17.7754C18.8924 17.6258 18.936 17.4175 18.9629 17.0889C18.9997 16.6388 19 16.0566 19 15.2002V9H9V19ZM5 15.2002C5 16.0566 5.00035 16.6388 5.03711 17.0889C5.07293 17.5273 5.13809 17.7518 5.21778 17.9082L5.29492 18.0459C5.48707 18.3592 5.76256 18.6145 6.0918 18.7822L6.22461 18.8389C6.37418 18.8924 6.58253 18.936 6.91113 18.9629C6.94015 18.9653 6.96985 18.9657 7 18.9678V9H5V15.2002ZM12.5 15C13.0523 15 13.5 15.4477 13.5 16C13.5 16.5523 13.0523 17 12.5 17H11.5C10.9477 17 10.5 16.5523 10.5 16C10.5 15.4477 10.9477 15 11.5 15H12.5ZM16.5 15C17.0523 15 17.5 15.4477 17.5 16C17.5 16.5523 17.0523 17 16.5 17H15.5C14.9477 17 14.5 16.5523 14.5 16C14.5 15.4477 14.9477 15 15.5 15H16.5ZM12.5 11C13.0523 11 13.5 11.4477 13.5 12C13.5 12.5523 13.0523 13 12.5 13H11.5C10.9477 13 10.5 12.5523 10.5 12C10.5 11.4477 10.9477 11 11.5 11H12.5ZM16.5 11C17.0523 11 17.5 11.4477 17.5 12C17.5 12.5523 17.0523 13 16.5 13H15.5C14.9477 13 14.5 12.5523 14.5 12C14.5 11.4477 14.9477 11 15.5 11H16.5ZM6.91113 5.03711C6.47272 5.07293 6.2482 5.13809 6.0918 5.21778C5.71555 5.40951 5.40951 5.71555 5.21778 6.0918C5.13809 6.2482 5.07293 6.47272 5.03711 6.91113C5.03474 6.94015 5.03431 6.96985 5.03223 7H7V5.03125C6.96982 5.03333 6.94017 5.03474 6.91113 5.03711ZM9 7H18.9678C18.9657 6.96985 18.9653 6.94015 18.9629 6.91113C18.936 6.58253 18.8924 6.37418 18.8389 6.22461L18.7822 6.0918C18.6145 5.76256 18.3592 5.48707 18.0459 5.29492L17.9082 5.21778C17.7518 5.13809 17.5273 5.07293 17.0889 5.03711C16.6388 5.00035 16.0566 5 15.2002 5H9V7Z" }) });
});
ColumnDataIcon.displayName = "ColumnDataIcon";

const ColumnIcon = forwardRef$1(function ColumnIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 3C19.5523 3 20 3.44772 20 4C20 4.55228 19.5523 5 19 5H17V7H18C18.5523 7 19 7.44772 19 8C19 8.55228 18.5523 9 18 9H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V9H9V20C9 20.5523 8.55228 21 8 21C7.44772 21 7 20.5523 7 20V9H6C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7H7V5H5C4.44772 5 4 4.55228 4 4C4 3.44772 4.44772 3 5 3H19ZM9 7H15V5H9V7Z" }), jsx("path", { d: "M12.5 19C13.0523 19 13.5 19.4477 13.5 20C13.5 20.5523 13.0523 21 12.5 21H11.5C10.9477 21 10.5 20.5523 10.5 20C10.5 19.4477 10.9477 19 11.5 19H12.5Z" }), jsx("path", { d: "M12.5 15C13.0523 15 13.5 15.4477 13.5 16C13.5 16.5523 13.0523 17 12.5 17H11.5C10.9477 17 10.5 16.5523 10.5 16C10.5 15.4477 10.9477 15 11.5 15H12.5Z" }), jsx("path", { d: "M12.5 11C13.0523 11 13.5 11.4477 13.5 12C13.5 12.5523 13.0523 13 12.5 13H11.5C10.9477 13 10.5 12.5523 10.5 12C10.5 11.4477 10.9477 11 11.5 11H12.5Z" })] });
});
ColumnIcon.displayName = "ColumnIcon";

const CommentIcon = forwardRef$1(function CommentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.002 4C20.6587 4 22.002 5.34312 22.002 7V17C22.002 18.6569 20.6587 20 19.002 20H12.2793L7.5166 22.8574C7.20767 23.0428 6.8223 23.0476 6.50879 22.8701C6.19551 22.6926 6.00195 22.3601 6.00195 22V20H5.00195C3.34511 20 2.00195 18.6569 2.00195 17V7C2.00195 5.34315 3.3451 4 5.00195 4H19.002ZM5.00195 6C4.44967 6 4.00195 6.44771 4.00195 7V17C4.00195 17.5523 4.44966 18 5.00195 18H7.00195C7.55424 18 8.00195 18.4477 8.00195 19V20.2334L11.4873 18.1426L11.6084 18.0811C11.7324 18.028 11.8661 18 12.002 18H19.002C19.5542 18 20.002 17.5523 20.002 17V7C20.002 6.44774 19.5542 6 19.002 6H5.00195Z", fill: "currentColor" }) });
});
CommentIcon.displayName = "CommentIcon";

const CompactModeIcon = forwardRef$1(function CompactModeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5 17C6.10457 17 7 17.8954 7 19C7 20.1046 6.10457 21 5 21C3.89543 21 3 20.1046 3 19C3 17.8954 3.89543 17 5 17ZM12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17ZM19 17C20.1046 17 21 17.8954 21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17ZM5 10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10ZM5 3C6.10457 3 7 3.89543 7 5C7 6.10457 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3ZM12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5C10 3.89543 10.8954 3 12 3ZM19 3C20.1046 3 21 3.89543 21 5C21 6.10457 20.1046 7 19 7C17.8954 7 17 6.10457 17 5C17 3.89543 17.8954 3 19 3Z" }) });
});
CompactModeIcon.displayName = "CompactModeIcon";

const ComponentIcon = forwardRef$1(function ComponentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M12.2991 2.08973C12.7008 1.98582 13.1207 1.97184 13.5281 2.04945C14.0281 2.14483 14.4791 2.41664 14.9774 2.70105L19.2589 5.14531C19.7415 5.42074 20.19 5.66176 20.5237 6.03157C20.7956 6.33325 21.0014 6.69157 21.1272 7.07997C21.2429 7.43718 21.2653 7.81617 21.2692 8.22003V14.022C21.2658 14.3985 21.246 14.7526 21.1441 15.0895C21.0328 15.4565 20.8494 15.7982 20.607 16.0926C20.3098 16.4535 19.908 16.7067 19.4754 16.992L13.1449 21.1665C12.6653 21.4827 12.2322 21.783 11.7392 21.9107C11.388 22.0015 11.023 22.0232 10.6641 21.9752L10.5103 21.951C10.0101 21.8557 9.56019 21.5828 9.06191 21.2984L4.77939 18.8551C4.29686 18.5798 3.84932 18.3379 3.51568 17.9679C3.24395 17.6662 3.03696 17.309 2.91113 16.9205C2.79555 16.5632 2.77295 16.1844 2.76917 15.7804V9.97844C2.7726 9.6018 2.79307 9.24699 2.89524 8.9099C3.00653 8.54324 3.18881 8.20227 3.4313 7.90782C3.72869 7.54695 4.13127 7.2938 4.56398 7.00847L10.8944 2.83399C11.3737 2.51792 11.8062 2.21733 12.2991 2.08973ZM4.80222 15.3675C4.80222 16.0694 4.81444 16.1888 4.84292 16.2769L4.8737 16.3585C4.909 16.438 4.9573 16.5113 5.01566 16.576C5.07737 16.6445 5.17245 16.713 5.77607 17.0574L10.0586 19.5017L10.0874 19.5178V17.707L4.80222 14.6917V15.3675ZM12.1204 17.6647V19.3819L18.3675 15.2628C18.9076 14.9066 18.9923 14.8373 19.0475 14.7703C19.1167 14.6861 19.1687 14.5886 19.2004 14.4843C19.2256 14.4007 19.2361 14.2896 19.2361 13.6373V12.9726L12.1204 17.6647ZM4.80222 12.325L10.0874 15.3413V13.5295L4.80222 10.5142V12.325ZM12.1204 13.4872V15.2043L19.2361 10.5112V8.79609L12.1204 13.4872ZM13.1528 4.07677C13.0364 4.0546 12.916 4.05824 12.8014 4.08784C12.7103 4.11146 12.602 4.16776 12.0023 4.5632L5.74728 8.68733L11.0662 11.7228L18.2901 6.95912C18.2809 6.95388 18.2717 6.94838 18.2623 6.94301L13.9807 4.49875C13.357 4.1428 13.2453 4.09442 13.1528 4.07677Z" }) });
});
ComponentIcon.displayName = "ComponentIcon";

const ConceptsIcon = forwardRef$1(function ConceptsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M11.999 8.19238C12.24 8.19238 12.4565 8.34032 12.543 8.56445L13.0166 9.79102C13.2603 10.4226 13.7608 10.9221 14.3945 11.165L15.626 11.6367C15.8509 11.7229 15.999 11.9386 15.999 12.1787C15.9989 12.4186 15.8507 12.6336 15.626 12.7197L14.3945 13.1914C13.7608 13.4343 13.2604 13.9339 13.0166 14.5654L12.543 15.792C12.4565 16.0162 12.24 16.1641 11.999 16.1641C11.7582 16.164 11.5425 16.0161 11.4561 15.792L10.9824 14.5654C10.7387 13.9338 10.2373 13.4343 9.60352 13.1914L8.37305 12.7197C8.14826 12.6336 7.99919 12.4187 7.99903 12.1787C7.99903 11.9386 8.14813 11.7229 8.37305 11.6367L9.60352 11.165C10.2373 10.9221 10.7387 10.4226 10.9824 9.79102L11.4561 8.56445C11.5425 8.34039 11.7582 8.19248 11.999 8.19238Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M11.999 2C14.1808 2 16.0691 3.24134 16.9971 5.04883C17.049 5.15006 17.1551 5.22604 17.2676 5.24414C19.2799 5.56468 21.0483 6.97285 21.7227 9.04102C22.3967 11.109 21.7961 13.2828 20.3574 14.7207C20.2971 14.781 20.2595 14.8657 20.252 14.9512L20.2549 15.0361L20.3008 15.4131C20.4673 17.3029 19.664 19.2333 18.0088 20.4316C16.2434 21.7097 13.982 21.8119 12.165 20.8926C12.0636 20.8418 11.9343 20.8416 11.833 20.8926C10.016 21.8119 7.75469 21.7098 5.98926 20.4316C4.224 19.1535 3.4273 17.0422 3.74317 15.0361C3.76071 14.924 3.72101 14.8012 3.64063 14.7207C2.20205 13.2828 1.6014 11.1089 2.2754 9.04102C2.94972 6.97289 4.71821 5.56473 6.73047 5.24414C6.84301 5.22613 6.94805 5.15091 7 5.0498C7.92773 3.24175 9.81692 2.00009 11.999 2ZM11.999 3.99316C10.5969 3.99325 9.37947 4.78927 8.78028 5.95703C8.43775 6.6244 7.78869 7.09359 7.0459 7.21191C5.74632 7.41899 4.6101 8.32752 4.17676 9.65625C3.74368 10.9851 4.12738 12.3858 5.05665 13.3145C5.58747 13.8452 5.83516 14.6043 5.71875 15.3447C5.5147 16.6405 6.03072 17.9981 7.16504 18.8193C8.29926 19.6405 9.75325 19.7097 10.9268 19.1162C11.5555 18.7981 12.3001 18.7784 12.9434 19.0566L13.294 19.2197C14.4248 19.6983 15.7696 19.5891 16.833 18.8193C17.9672 17.9982 18.4831 16.6413 18.2793 15.3457L18.2617 15.207C18.1946 14.5115 18.4436 13.8123 18.9414 13.3145C19.8707 12.3858 20.2544 10.9851 19.8213 9.65625C19.388 8.32747 18.2518 7.41893 16.9522 7.21191C16.2557 7.10087 15.6413 6.68114 15.2852 6.0791L15.2178 5.95703C14.6185 4.78918 13.4012 3.99316 11.999 3.99316Z" })] });
});
ConceptsIcon.displayName = "ConceptsIcon";

const ConnectionIcon = forwardRef$1(function ConnectionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M2 11.9998C2 9.18768 3.12016 6.63963 4.92871 4.79768C5.31912 4.40019 5.95225 4.40039 6.34277 4.79768C6.73329 5.19542 6.73329 5.84037 6.34277 6.23811C4.89397 7.71367 4 9.74962 4 11.9998C4.00002 14.2498 4.89422 16.2851 6.34277 17.7606C6.73328 18.1584 6.73325 18.8032 6.34277 19.201C5.95224 19.5987 5.31924 19.5987 4.92871 19.201C3.12037 17.359 2.00002 14.8117 2 11.9998ZM20 11.9998C20 9.74961 19.106 7.71367 17.6572 6.23811C17.2666 5.84037 17.2666 5.19542 17.6572 4.79768C18.0477 4.40037 18.6808 4.4002 19.0713 4.79768C20.8798 6.63963 22 9.18768 22 11.9998C22 14.8117 20.8796 17.359 19.0713 19.201C18.6807 19.5987 18.0477 19.5987 17.6572 19.201C17.2667 18.8032 17.2666 18.1584 17.6572 17.7606C19.1058 16.2851 20 14.2498 20 11.9998ZM6 11.9998C6 10.3126 6.67312 8.78326 7.75781 7.67854C8.14836 7.28115 8.78147 7.28092 9.17188 7.67854C9.5623 8.07621 9.56218 8.72123 9.17188 9.11897C8.44692 9.85732 8 10.8745 8 11.9998C8.00002 13.125 8.44694 14.1424 9.17188 14.8807C9.56211 15.2784 9.56231 15.9235 9.17188 16.3211C8.78149 16.7187 8.14835 16.7185 7.75781 16.3211C6.67314 15.2164 6.00002 13.687 6 11.9998ZM16 11.9998C16 10.8745 15.5531 9.85732 14.8281 9.11897C14.4378 8.72123 14.4377 8.07621 14.8281 7.67854C15.2186 7.28091 15.8517 7.28113 16.2422 7.67854C17.3269 8.78326 18 10.3126 18 11.9998C18 13.687 17.3269 15.2164 16.2422 16.3211C15.8517 16.7185 15.2186 16.7187 14.8281 16.3211C14.4377 15.9235 14.4379 15.2784 14.8281 14.8807C15.5531 14.1424 16 13.125 16 11.9998ZM10 11.9998C10 10.8748 10.8954 9.96272 12 9.96272C13.1046 9.96272 14 10.8748 14 11.9998C14 13.1248 13.1046 14.0369 12 14.0369C10.8954 14.0369 10 13.1248 10 11.9998Z" }) });
});
ConnectionIcon.displayName = "ConnectionIcon";

const CopyIcon = forwardRef$1(function CopyIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.5576 3.00391C17.7904 3.00764 18.0035 3.01461 18.1953 3.03028C18.5906 3.06259 18.984 3.13438 19.3623 3.32715L19.5684 3.44239C20.0383 3.73054 20.4211 4.14374 20.6729 4.6377L20.7402 4.78028C20.8835 5.11438 20.9415 5.45882 20.9697 5.80469C21.0011 6.18837 21 6.65665 21 7.2002V12.7998C21 13.3434 21.0011 13.8116 20.9697 14.1953C20.9415 14.5412 20.8835 14.8856 20.7402 15.2197L20.6729 15.3623C20.4212 15.8562 20.0383 16.2695 19.5684 16.5576L19.3623 16.6729C18.984 16.8656 18.5906 16.9374 18.1953 16.9697C17.8593 16.9972 17.4585 16.9988 16.999 16.999C16.9988 17.4585 16.9972 17.8593 16.9697 18.1953C16.9415 18.5412 16.8835 18.8856 16.7402 19.2197L16.6729 19.3623C16.4212 19.8562 16.0383 20.2695 15.5684 20.5576L15.3623 20.6729C14.984 20.8656 14.5906 20.9374 14.1953 20.9697C13.8116 21.0011 13.3434 21 12.7998 21H7.2002C6.65665 21 6.18837 21.0011 5.80469 20.9697C5.45882 20.9415 5.11438 20.8835 4.78028 20.7402L4.6377 20.6729C4.14374 20.4211 3.73054 20.0383 3.44239 19.5684L3.32715 19.3623C3.13438 18.984 3.06259 18.5906 3.03028 18.1953C3.01461 18.0035 3.00764 17.7904 3.00391 17.5576L3 16.7998V11.2002C3 10.6567 2.99893 10.1884 3.03028 9.80469C3.06259 9.40944 3.1344 9.016 3.32715 8.6377L3.44239 8.43165C3.73057 7.96166 4.14381 7.57887 4.6377 7.32715L4.78028 7.25977C5.11438 7.11652 5.45882 7.05855 5.80469 7.03028C6.14043 7.00285 6.54096 7.00023 7 7C7.00023 6.54096 7.00285 6.14043 7.03028 5.80469C7.06259 5.40944 7.1344 5.016 7.32715 4.6377L7.44239 4.43165C7.73057 3.96166 8.14381 3.57887 8.6377 3.32715L8.78028 3.25977C9.11438 3.11652 9.45882 3.05855 9.80469 3.03028C10.1884 2.99893 10.6567 3 11.2002 3H16.7998L17.5576 3.00391ZM7.2002 9C6.62365 9 6.25111 9.00127 5.96778 9.02442C5.76435 9.04105 5.65667 9.06565 5.59473 9.0879L5.5459 9.10938C5.40484 9.1813 5.28366 9.28523 5.19141 9.41211L5.10938 9.5459C5.08419 9.59533 5.04662 9.69619 5.02442 9.96778C5.00127 10.2511 5 10.6237 5 11.2002V16.7998C5 17.3764 5.00127 17.7489 5.02442 18.0322C5.04662 18.3038 5.0842 18.4047 5.10938 18.4541L5.19141 18.5879C5.28368 18.7148 5.40488 18.8188 5.5459 18.8906L5.59473 18.9121C5.65667 18.9344 5.76434 18.959 5.96778 18.9756C6.25111 18.9987 6.62365 19 7.2002 19H12.7998C13.3764 19 13.7489 18.9987 14.0322 18.9756C14.3038 18.9534 14.4047 18.9158 14.4541 18.8906L14.5879 18.8086C14.7148 18.7164 14.8187 18.5952 14.8906 18.4541L14.9121 18.4053C14.9344 18.3433 14.959 18.2357 14.9756 18.0322C14.9987 17.7489 15 17.3764 15 16.7998V11.2002C15 10.6237 14.9987 10.2511 14.9756 9.96778C14.959 9.76434 14.9344 9.65667 14.9121 9.59473L14.8906 9.5459C14.8188 9.40488 14.7148 9.28369 14.5879 9.19141L14.4541 9.10938C14.4047 9.0842 14.3038 9.04662 14.0322 9.02442C13.7489 9.00127 13.3764 9 12.7998 9H7.2002ZM11.2002 5C10.6237 5 10.2511 5.00127 9.96778 5.02442C9.76435 5.04105 9.65667 5.06565 9.59473 5.0879L9.5459 5.10938C9.40484 5.1813 9.28366 5.28523 9.19141 5.41211L9.10938 5.5459C9.08419 5.59533 9.04662 5.69619 9.02442 5.96778C9.00406 6.21689 9.00151 6.53496 9.00098 7H12.7998C13.3434 7 13.8116 6.99893 14.1953 7.03028C14.5906 7.06259 14.984 7.13438 15.3623 7.32715L15.5684 7.44239C16.0383 7.73054 16.4211 8.14374 16.6729 8.6377L16.7402 8.78028C16.8835 9.11438 16.9415 9.45882 16.9697 9.80469C17.0011 10.1884 17 10.6567 17 11.2002V14.9981C17.4651 14.9975 17.7831 14.9959 18.0322 14.9756C18.3038 14.9534 18.4047 14.9158 18.4541 14.8906L18.5879 14.8086C18.7148 14.7164 18.8187 14.5952 18.8906 14.4541L18.9121 14.4053C18.9344 14.3433 18.959 14.2357 18.9756 14.0322C18.9987 13.7489 19 13.3764 19 12.7998V7.2002C19 6.62365 18.9987 6.25111 18.9756 5.96778C18.959 5.76434 18.9344 5.65667 18.9121 5.59473L18.8906 5.5459C18.8188 5.40488 18.7148 5.28368 18.5879 5.19141L18.4541 5.10938C18.4047 5.0842 18.3038 5.04662 18.0322 5.02442C17.7489 5.00127 17.3764 5 16.7998 5H11.2002Z" }) });
});
CopyIcon.displayName = "CopyIcon";

const CreditIcon = forwardRef$1(function CreditIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 6.84863C12.3012 6.84863 12.5716 7.03427 12.6797 7.31543L13.5908 9.68359C13.6923 9.94768 13.9009 10.1562 14.165 10.2578L16.5332 11.1689C16.8144 11.2771 17 11.5474 17 11.8486C17 12.1499 16.8144 12.4202 16.5332 12.5283L14.165 13.4395C13.9009 13.5411 13.6923 13.7496 13.5908 14.0137L12.6797 16.3818C12.5716 16.6629 12.3012 16.8486 12 16.8486C11.6988 16.8486 11.4284 16.6629 11.3203 16.3818L10.4092 14.0137C10.3077 13.7496 10.0991 13.5411 9.83496 13.4395L7.4668 12.5283C7.18566 12.4202 7.00001 12.1499 7 11.8486C7 11.5474 7.18565 11.2771 7.4668 11.1689L9.83496 10.2578C10.0991 10.1562 10.3077 9.94769 10.4092 9.68359L11.3203 7.31543C11.4284 7.03427 11.6988 6.84863 12 6.84863Z" }) });
});
CreditIcon.displayName = "CreditIcon";

const CubeIcon = forwardRef$1(function CubeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.7012 2.54694C11.5806 2.12277 12.6165 2.15303 13.4736 2.63776L19.4727 6.03034H19.4736C20.4185 6.56477 21.0008 7.5686 21.001 8.65339V15.3497C21.0008 16.3667 20.4891 17.3127 19.6465 17.8673L19.4736 17.9727L13.4736 21.3663L13.4727 21.3653C12.5585 21.8822 11.4415 21.8821 10.5273 21.3653V21.3663L4.52734 17.9727C3.58231 17.4384 3.00015 16.4345 3 15.3497V8.65339C3.00013 7.56855 3.58243 6.56573 4.52734 6.03132L10.5273 2.63776L10.7012 2.54694ZM5 15.3497C5.00015 15.7172 5.19752 16.0538 5.51172 16.2315L11 19.335V12.584L5 9.19147V15.3497ZM13 12.584V19.335L18.4893 16.2315L18.6016 16.1583C18.8498 15.9698 19.0008 15.6713 19.001 15.3497V9.19147L13 12.584ZM12.4883 4.37897C12.2229 4.229 11.907 4.20987 11.6289 4.32233L11.5117 4.37897L6.03125 7.47663L12 10.8526L17.9688 7.47663L12.4883 4.37897Z" }) });
});
CubeIcon.displayName = "CubeIcon";

const CumulativeIcon = forwardRef$1(function CumulativeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { opacity: 0.5, d: "M4 3C4.55219 3.00011 5 3.44778 5 4V17.998L5.00488 18.0996C5.0561 18.6039 5.48224 18.998 6 18.998H19.998L20.0996 19.0029C20.6039 19.0541 20.998 19.4803 20.998 19.998C20.9977 20.5155 20.6037 20.941 20.0996 20.9922L19.998 20.998H6C4.39514 20.998 3.08457 19.7372 3.00391 18.1523L3 17.998V4C3 3.44772 3.44772 3 4 3Z" }), jsx("path", { d: "M16.869 5.72465C17.2618 5.4043 17.8408 5.42689 18.2069 5.79301C18.5729 6.15913 18.5956 6.73817 18.2753 7.1309L18.2069 7.20707L8.20689 17.2071C7.8164 17.5974 7.18332 17.5974 6.79283 17.2071C6.40235 16.8166 6.40243 16.1835 6.79283 15.793L16.7928 5.79301L16.869 5.72465Z" })] });
});
CumulativeIcon.displayName = "CumulativeIcon";

const DashboardsIcon = forwardRef$1(function DashboardsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M16.7998 3C17.3434 3 17.8117 2.99892 18.1953 3.03027C18.5906 3.06258 18.984 3.1344 19.3623 3.32714C19.9265 3.61472 20.3853 4.07345 20.6728 4.63769C20.8656 5.01599 20.9374 5.40943 20.9697 5.80468C21.0011 6.18835 21 6.65664 21 7.20019V16.7998C21 17.3433 21.0011 17.8117 20.9697 18.1953C20.9374 18.5906 20.8656 18.984 20.6728 19.3623C20.3853 19.9266 19.9266 20.3853 19.3623 20.6728C18.984 20.8656 18.5906 20.9374 18.1953 20.9697C17.8117 21.0011 17.3434 21 16.7998 21H7.20019C6.65664 21 6.18835 21.0011 5.80468 20.9697C5.40943 20.9374 5.01599 20.8656 4.63769 20.6728C4.07345 20.3853 3.61472 19.9265 3.32714 19.3623C3.1344 18.984 3.06258 18.5906 3.03027 18.1953C2.99892 17.8117 3 17.3433 3 16.7998V7.20019C3 6.65664 2.99892 6.18835 3.03027 5.80468C3.06258 5.40943 3.1344 5.01599 3.32714 4.63769C3.61472 4.07347 4.07347 3.61472 4.63769 3.32714C5.01599 3.1344 5.40943 3.06258 5.80468 3.03027C6.18835 2.99892 6.65664 3 7.20019 3H16.7998ZM13 19H16.7998C17.3764 19 17.7488 18.9997 18.0322 18.9766C18.3038 18.9544 18.4046 18.9158 18.4541 18.8906C18.6421 18.7948 18.7948 18.642 18.8906 18.4541C18.9158 18.4046 18.9544 18.3038 18.9766 18.0322C18.9997 17.7488 19 17.3763 19 16.7998V15H13V19ZM5 11V16.7998C5 17.3763 5.00126 17.7488 5.02441 18.0322C5.0466 18.3038 5.08418 18.4046 5.10937 18.4541C5.20522 18.642 5.35792 18.7948 5.54589 18.8906C5.59533 18.9158 5.69613 18.9544 5.96777 18.9766C6.2511 18.9997 6.62364 19 7.20019 19H11V11H5ZM13 13H19V7.20019C19 6.62364 18.9997 6.2511 18.9766 5.96777C18.9544 5.69613 18.9158 5.59533 18.8906 5.54589C18.7948 5.35792 18.6421 5.20522 18.4541 5.10937C18.4046 5.08418 18.3038 5.0466 18.0322 5.02441C17.7488 5.00126 17.3764 5 16.7998 5H13V13ZM7.20019 5C6.62364 5 6.2511 5.00126 5.96777 5.02441C5.69618 5.0466 5.59533 5.08418 5.54589 5.10937C5.35793 5.20522 5.20522 5.35793 5.10937 5.54589C5.08418 5.59533 5.0466 5.69618 5.02441 5.96777C5.00126 6.2511 5 6.62364 5 7.20019V9H11V5H7.20019Z" }) });
});
DashboardsIcon.displayName = "DashboardsIcon";

const DbtIcon = forwardRef$1(function DbtIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M18.7197 3C19.2886 3.06447 19.8267 3.32461 20.2334 3.74902H20.2354L20.3867 3.90723C20.7236 4.2905 20.9435 4.76607 21 5.27734C21 5.52172 20.9357 5.68445 20.7891 5.99316C20.6424 6.30205 18.8347 9.42684 18.2969 10.2891C17.9881 10.7934 17.8262 11.3959 17.8262 11.9824C17.8262 12.569 17.988 13.1714 18.2969 13.6758C18.8347 14.538 20.6424 17.6804 20.7891 17.9893C20.9355 18.2977 20.9999 18.4444 21 18.6885C20.9356 19.2751 20.6754 19.811 20.251 20.2021C19.8443 20.6244 19.3063 20.9023 18.7373 20.9512C18.4929 20.9512 18.3305 20.8869 18.0371 20.7402C17.7435 20.5934 14.5547 18.8356 13.6924 18.2979C13.628 18.2646 13.5613 18.2157 13.4814 18.1846L9.21582 15.6621C9.31361 16.4754 9.67205 17.2583 10.2588 17.8271C10.372 17.9403 10.4875 18.0381 10.6162 18.1357C10.5185 18.1846 10.4053 18.2335 10.3076 18.2979C9.44558 18.8355 6.30483 20.6413 5.99414 20.7891C5.68533 20.9357 5.53818 21 5.27832 21C4.69159 20.9356 4.15581 20.6754 3.76465 20.251C3.34248 19.8444 3.06454 19.3069 3 18.7227C3.01555 18.4783 3.08214 18.2335 3.21094 18.0225C3.35761 17.7136 5.16413 14.5715 5.70215 13.709C6.01106 13.2046 6.17382 12.6178 6.17383 12.0156C6.17383 11.4134 6.01107 10.8267 5.70215 10.3223C5.16421 9.42654 3.34206 6.28641 3.21094 5.97754C3.07992 5.76649 3.01555 5.52169 3 5.27734C3.06453 4.69086 3.32466 4.15559 3.74902 3.74902C4.15342 3.32468 4.68882 3.06452 5.27539 3L5.45898 3.02148C5.64138 3.05283 5.8213 3.11437 5.99121 3.21094C6.25124 3.32427 8.54744 4.66042 9.76758 5.37598L10.0449 5.53809C10.1427 5.60253 10.2256 5.65124 10.29 5.68457L10.4209 5.7666L14.7656 8.33789C14.6678 7.36234 14.1632 6.46648 13.3809 5.86426C13.4786 5.81537 13.5926 5.76659 13.6904 5.70215C14.5531 5.16418 17.695 3.34204 18.0039 3.21094C18.215 3.08206 18.4597 3.01555 18.7197 3ZM12.2275 10.8467C12.0965 10.7157 11.9036 10.7158 11.7725 10.8467L10.8457 11.7734C10.7146 11.9045 10.7146 12.0974 10.8457 12.2285L11.7725 13.1553C11.8858 13.2686 12.0964 13.2686 12.2275 13.1553L13.1543 12.2285C13.2853 12.0974 13.2854 11.9045 13.1543 11.7734L12.2275 10.8467Z" }) });
});
DbtIcon.displayName = "DbtIcon";

const DebuggerIcon = forwardRef$1(function DebuggerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.001 3C14.5172 3.00002 16.5566 5.04041 16.5566 7.55664V7.63184C16.8639 7.75051 17.1447 7.92164 17.3877 8.13477L19.4854 7.48926C20.0132 7.32684 20.5729 7.62353 20.7354 8.15137C20.8976 8.67905 20.6018 9.23883 20.0742 9.40137L18.3184 9.94043C18.3278 10.0336 18.335 10.1282 18.335 10.2236V11.1123C18.335 11.6646 17.8872 12.1123 17.335 12.1123C16.7827 12.1123 16.335 11.6646 16.335 11.1123V10.2236C16.335 10.1087 16.3102 10.001 16.2666 9.9043L16.2178 9.81152C16.0786 9.58934 15.8336 9.44531 15.5566 9.44531H8.44531C8.1642 9.44533 7.91608 9.59376 7.77832 9.82129C7.77341 9.8301 7.76883 9.83903 7.76367 9.84766C7.70244 9.95819 7.667 10.0855 7.66699 10.2236V14.6689C7.66724 16.9878 9.48842 18.8812 11.7783 18.9971L12.001 19.0029L12.1035 19.0078C12.6076 19.0592 13.001 19.4853 13.001 20.0029C13.0009 20.5205 12.6075 20.9457 12.1035 20.9971L12.001 21.0029L11.6748 20.9941C9.37714 20.8776 7.40366 19.5363 6.3916 17.6104L4.56445 18.2754L4.46582 18.3057C3.97464 18.4296 3.45922 18.164 3.28223 17.6777C3.09351 17.1587 3.36187 16.5843 3.88086 16.3955L5.75391 15.7139C5.69744 15.3739 5.66702 15.0249 5.66699 14.6689V13.8906H4C3.44782 13.8906 3.00013 13.4428 3 12.8906C3.00002 12.3384 3.44775 11.8907 4 11.8906H5.66699V10.2236C5.66699 10.1419 5.67077 10.0605 5.67773 9.98047L3.9082 9.39453C3.38401 9.22091 3.09896 8.65508 3.27246 8.13086C3.44603 7.60672 4.01197 7.32277 4.53613 7.49609L6.57422 8.1709C6.82629 7.94102 7.12096 7.75711 7.44531 7.63184V7.55664C7.44533 5.04042 9.48477 3.00003 12.001 3ZM13.8535 13.8545C15.2856 12.4226 17.6071 12.4224 19.0391 13.8545C20.2255 15.0413 20.4276 16.8384 19.6475 18.2344L20.709 19.2969L20.7783 19.3721C21.0983 19.7648 21.0748 20.3449 20.709 20.7109C20.343 21.0765 19.7637 21.0991 19.3711 20.7793L19.2949 20.7109L18.2334 19.6484C16.8374 20.4288 15.0404 20.2266 13.8535 19.04C12.4216 17.608 12.4216 15.2866 13.8535 13.8545ZM17.625 15.2686C16.974 14.6176 15.9186 14.6177 15.2676 15.2686C14.6167 15.9196 14.6167 16.9749 15.2676 17.626C15.9186 18.2766 16.9741 18.2768 17.625 17.626C18.2756 16.975 18.2755 15.9196 17.625 15.2686ZM12.001 5C10.6266 5.00003 9.5093 6.08507 9.45117 7.44531H14.5508C14.4926 6.08507 13.3753 5.00002 12.001 5Z" }) });
});
DebuggerIcon.displayName = "DebuggerIcon";

const DeleteIcon = forwardRef$1(function DeleteIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.002 2.00098C14.1833 2.00115 16.0263 3.43267 16.6543 5.40625H20.2539L20.3555 5.41113C20.8597 5.46233 21.2539 5.88847 21.2539 6.40625C21.2538 6.92393 20.8597 7.3502 20.3555 7.40137L20.2539 7.40625H19.7646L18.9492 19.2568C18.843 20.7994 17.5622 21.9996 16.0146 22H7.98926C6.53816 22 5.32186 20.945 5.08789 19.542L5.05469 19.2568L4.23828 7.40625H3.75C3.1978 7.40625 2.75013 6.95842 2.75 6.40625C2.75 5.85397 3.19772 5.40625 3.75 5.40625H7.34863C7.97662 3.43248 9.8204 2.00098 12.002 2.00098ZM7.0498 19.1191L7.06055 19.2109C7.13575 19.6632 7.52698 20 7.98926 20H16.0146C16.5073 19.9996 16.9189 19.6166 16.9531 19.1191L17.7598 7.40625H6.24414L7.0498 19.1191ZM13.2354 10.5645C13.6254 10.1736 14.2585 10.1725 14.6494 10.5625C15.0403 10.9526 15.0405 11.5856 14.6504 11.9766L13.4131 13.2158L14.6504 14.4561C15.0405 14.847 15.0402 15.48 14.6494 15.8701C14.2585 16.2601 13.6254 16.259 13.2354 15.8682L12.001 14.6309L10.7676 15.8682C10.3775 16.259 9.74444 16.26 9.35352 15.8701C8.96276 15.4801 8.96177 14.847 9.35156 14.4561L10.5879 13.2158L9.35156 11.9766L9.2832 11.9004C8.96359 11.5073 8.98721 10.9281 9.35352 10.5625C9.71992 10.1971 10.2991 10.1747 10.6914 10.4951L10.7676 10.5645L12.001 11.8008L13.2354 10.5645ZM12.002 4.00098C10.953 4.00098 10.0328 4.56379 9.52832 5.40625H14.4756C13.9711 4.56372 13.0509 4.00112 12.002 4.00098Z" }) });
});
DeleteIcon.displayName = "DeleteIcon";

const DescriptionAddIcon = forwardRef$1(function DescriptionAddIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16 2C18.2092 2 20 3.79088 20 6V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V6C18 4.89542 17.1046 4 16 4H8C6.89543 4 6 4.89543 6 6V18C6 19.1046 6.89542 20 8 20H11C11.5523 20 12 20.4477 12 21C12 21.5523 11.5523 22 11 22H8C5.79088 22 4 20.2092 4 18V6C4 3.79087 5.79087 2 8 2H16ZM18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15C17 14.4477 17.4477 14 18 14ZM11 10C11.5523 10 12 10.4477 12 11C12 11.5523 11.5523 12 11 12H9C8.44772 12 8 11.5523 8 11C8 10.4477 8.44772 10 9 10H11ZM15 6C15.5523 6 16 6.44772 16 7C16 7.55228 15.5523 8 15 8H9C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6H15Z" }) });
});
DescriptionAddIcon.displayName = "DescriptionAddIcon";

const DescriptionIcon = forwardRef$1(function DescriptionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M14.6348 9.09277C16.1001 7.76877 18.3621 7.81337 19.7744 9.22559L19.9072 9.36426C21.1885 10.7824 21.1885 12.9471 19.9072 14.3652L19.7744 14.5039L12.5723 21.707C12.3848 21.8945 12.1303 21.9999 11.8652 22H8C7.44776 22 7.00008 21.5522 7 21V17.1348L7.00488 17.0361C7.02761 16.8072 7.12887 16.5918 7.29297 16.4277L14.4951 9.22559H14.4961L14.6348 9.09277ZM18.3604 10.6396C17.7258 10.0051 16.7217 9.96513 16.041 10.5205L15.9102 10.6396L9 17.5488V20H11.4512L18.3604 13.0898L18.4795 12.958C18.9974 12.3226 18.9977 11.4057 18.4795 10.7705L18.3604 10.6396ZM7.10449 11.0049C7.60874 11.0561 8.00195 11.4822 8.00195 12C8.00195 12.5178 7.60874 12.9439 7.10449 12.9951L7.00195 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H7.00195L7.10449 11.0049ZM10.5 7C11.0523 7 11.5 7.44772 11.5 8C11.5 8.55228 11.0523 9 10.5 9H4C3.44772 9 3 8.55228 3 8C3 7.44772 3.44772 7 4 7H10.5ZM20 3C20.5523 3 21 3.44772 21 4C21 4.55228 20.5523 5 20 5H4C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3H20Z" }) });
});
DescriptionIcon.displayName = "DescriptionIcon";

const DestinationIcon = forwardRef$1(function DestinationIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C16.4444 2 19.9999 5.697 20 10.1982C20 12.7264 18.912 15.0671 17.6377 16.9531C16.3566 18.849 14.8264 20.3759 13.8027 21.2988C12.7657 22.2338 11.2343 22.2338 10.1973 21.2988C9.17365 20.3759 7.6434 18.849 6.3623 16.9531C5.08795 15.0671 4 12.7264 4 10.1982C4.00015 5.697 7.55564 2 12 2ZM12 4C8.71256 4 6.00015 6.74848 6 10.1982C6 12.1645 6.85566 14.1105 8.01953 15.833C9.17655 17.5453 10.5796 18.9501 11.5371 19.8135C11.813 20.062 12.187 20.062 12.4629 19.8135C13.4204 18.9501 14.8235 17.5453 15.9805 15.833C17.1443 14.1105 18 12.1645 18 10.1982C17.9999 6.74848 15.2874 4 12 4ZM11.9961 6.5C13.9291 6.5 15.4961 8.067 15.4961 10C15.4961 11.933 13.9291 13.5 11.9961 13.5C10.0631 13.5 8.49609 11.933 8.49609 10C8.49609 8.067 10.0631 6.50001 11.9961 6.5ZM11.9961 8.5C11.1677 8.50001 10.4961 9.17159 10.4961 10C10.4961 10.8284 11.1677 11.5 11.9961 11.5C12.8245 11.5 13.4961 10.8284 13.4961 10C13.4961 9.17158 12.8245 8.5 11.9961 8.5Z" }) });
});
DestinationIcon.displayName = "DestinationIcon";

const DictationMicrophoneOffIcon = forwardRef$1(function DictationMicrophoneOffIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props, children: jsx("g", { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", children: jsx("path", { d: "M9 5a3 3 0 0 1 6 1v5m-6-1v2a3 3 0 0 0 4 2.8M5 10v2a7 7 0 0 0 12 4.9M19 10v2m-7 7v3m-4 0h8M3 3l18 18" }) }) });
});
DictationMicrophoneOffIcon.displayName = "DictationMicrophoneOffIcon";

const DictationMicrophoneIcon = forwardRef$1(function DictationMicrophoneIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props, children: jsxs("g", { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", children: [jsx("rect", { x: 9, y: 3, width: 6, height: 12, rx: 3 }), jsx("path", { d: "M5 10v2a7 7 0 0 0 14 0v-2M12 19v3m-4 0h8" })] }) });
});
DictationMicrophoneIcon.displayName = "DictationMicrophoneIcon";

const DollarIcon = forwardRef$1(function DollarIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.001 2C12.553 2.00018 13.0008 2.44794 13.001 3V4.21973C14.1982 4.50518 15.3196 5.21783 15.998 6.45508L16.0996 6.65137L16.1396 6.74512C16.3152 7.22052 16.1056 7.76073 15.6406 7.98828C15.1755 8.21558 14.62 8.04957 14.3525 7.61914L14.3027 7.5293L14.1904 7.32422C13.5863 6.33582 12.3746 5.91501 11.168 6.12012C9.8892 6.33767 9.00012 7.17637 9 8.36328C9.00009 9.19211 9.3164 9.64973 9.82715 10.0107C10.4217 10.4308 11.256 10.7002 12.2949 11.0195C13.2506 11.3133 14.4159 11.6584 15.3184 12.2803C16.3069 12.9616 17.0009 13.9848 17.001 15.5098C17.001 17.9575 14.9582 19.3483 13.001 19.752V20.9971C13.001 21.5492 12.5531 21.9969 12.001 21.9971C11.4489 21.9969 11.001 21.5492 11.001 20.9971V19.8477C9.50025 19.6883 8.01248 18.9971 7.20703 17.5479L7.10156 17.3467L7.06152 17.252C6.88649 16.7767 7.09586 16.2362 7.56055 16.0088C8.02543 15.7814 8.58094 15.9479 8.84863 16.3779L8.89844 16.4678L9.00781 16.6641C9.60638 17.6108 10.9644 18.0707 12.4365 17.8262C14.0115 17.5644 15.001 16.636 15.001 15.5098C15.0009 14.7175 14.6951 14.2804 14.1836 13.9277C13.5862 13.5161 12.751 13.2526 11.707 12.9316C10.7459 12.6362 9.57836 12.2834 8.67285 11.6436C7.6841 10.9446 7.00011 9.90301 7 8.36328C7.00013 5.90961 8.91179 4.47516 10.833 4.14844C10.8885 4.13901 10.9449 4.1327 11.001 4.125V3C11.0011 2.44796 11.449 2.00021 12.001 2Z" }) });
});
DollarIcon.displayName = "DollarIcon";

const DotIcon = forwardRef$1(function DotIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 8C13.0609 8 14.078 8.42173 14.8281 9.17188C15.5783 9.92202 16 10.9391 16 12C16 13.0609 15.5783 14.078 14.8281 14.8281C14.078 15.5783 13.0609 16 12 16C10.9391 16 9.92202 15.5783 9.17188 14.8281C8.42173 14.078 8 13.0609 8 12C8 10.9391 8.42173 9.92202 9.17188 9.17188C9.92202 8.42173 10.9391 8 12 8Z" }) });
});
DotIcon.displayName = "DotIcon";

const DottedCircleIcon = forwardRef$1(function DottedCircleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.4424 19.874C13.9479 19.8408 14.4069 20.1948 14.4932 20.7051C14.5851 21.2497 14.2174 21.7655 13.6729 21.8574L13.2617 21.918C12.8479 21.9702 12.4262 21.9971 11.999 21.9971C11.5716 21.9971 11.1494 21.9702 10.7354 21.918L10.3242 21.8574L10.2246 21.8359C9.73589 21.7016 9.41874 21.2156 9.50488 20.7051C9.59112 20.1947 10.05 19.8406 10.5557 19.874L10.6572 19.8857L10.9863 19.9336C11.3174 19.9754 11.6558 19.9971 11.999 19.9971C12.4567 19.9971 12.9054 19.9592 13.3408 19.8857L13.4424 19.874ZM4.08008 16.3916C4.50212 16.0917 5.07728 16.1655 5.41113 16.5469L5.47461 16.627L5.6748 16.8975C6.15678 17.5186 6.72859 18.0674 7.37012 18.5234C7.82027 18.8434 7.92642 19.4678 7.60645 19.918C7.28647 20.368 6.66201 20.4731 6.21191 20.1533C5.41087 19.5839 4.69652 18.8995 4.09473 18.124L3.84375 17.7861L3.78906 17.6992C3.53895 17.2587 3.65832 16.6915 4.08008 16.3916ZM18.5869 16.5469C18.9207 16.1656 19.496 16.0919 19.918 16.3916C20.3678 16.7117 20.4732 17.3361 20.1533 17.7861L19.9023 18.124C19.3006 18.8995 18.5871 19.5839 17.7861 20.1533L17.6992 20.208C17.2587 20.4582 16.6916 20.3396 16.3916 19.918C16.0719 19.4679 16.1771 18.8434 16.627 18.5234L16.8975 18.3223C17.5187 17.8402 18.0674 17.2686 18.5234 16.627L18.5869 16.5469ZM2.16211 10.2246C2.29637 9.73595 2.78157 9.41904 3.29199 9.50488C3.83655 9.59677 4.20415 10.1127 4.1123 10.6572L4.06348 10.9863C4.02171 11.3175 4.00001 11.6557 4 11.999C4.00001 12.3424 4.02168 12.6805 4.06348 13.0117L4.1123 13.3408L4.12402 13.4424C4.15724 13.948 3.80243 14.407 3.29199 14.4932C2.7818 14.5789 2.2966 14.2617 2.16211 13.7734L2.13965 13.6729L2.0791 13.2617C2.02689 12.8478 2.00001 12.4263 2 11.999C2.00001 11.4292 2.04768 10.8693 2.13965 10.3242L2.16211 10.2246ZM20.7051 9.50488C21.2157 9.41873 21.7016 9.73579 21.8359 10.2246L21.8574 10.3242L21.918 10.7354C21.9702 11.1495 21.9971 11.5715 21.9971 11.999C21.9971 12.5687 21.9493 13.128 21.8574 13.6729L21.8359 13.7734C21.7015 14.262 21.2156 14.5793 20.7051 14.4932C20.1609 14.4011 19.7941 13.8851 19.8857 13.3408L19.9336 13.0117C19.9754 12.6804 19.9971 12.3424 19.9971 11.999C19.9971 11.6557 19.9754 11.3175 19.9336 10.9863L19.8857 10.6572L19.874 10.5557C19.8405 10.05 20.1947 9.59126 20.7051 9.50488ZM6.21191 3.84375C6.66195 3.52408 7.28648 3.63026 7.60645 4.08008C7.92608 4.5302 7.82014 5.15473 7.37012 5.47461C6.63725 5.99564 5.99562 6.63723 5.47461 7.37012C5.15471 7.82006 4.53017 7.92606 4.08008 7.60645C3.63032 7.28649 3.52416 6.66193 3.84375 6.21191C4.49457 5.29631 5.29632 4.49459 6.21191 3.84375ZM16.3916 4.08008C16.6915 3.65819 17.2586 3.53897 17.6992 3.78906L17.7861 3.84375L18.124 4.09473C18.8996 4.69653 19.5839 5.41085 20.1533 6.21191C20.4732 6.66204 20.368 7.28649 19.918 7.60645C19.4678 7.92625 18.8434 7.82021 18.5234 7.37012C18.0674 6.72857 17.5186 6.15679 16.8975 5.6748L16.627 5.47461L16.5469 5.41113C16.1655 5.0773 16.0917 4.50211 16.3916 4.08008ZM11.999 2C12.4262 2.00001 12.8479 2.02691 13.2617 2.0791L13.6729 2.13965L13.7734 2.16211C14.2618 2.29662 14.5791 2.7817 14.4932 3.29199C14.407 3.80243 13.948 4.15724 13.4424 4.12402L13.3408 4.1123L13.0117 4.06348C12.6806 4.02169 12.3423 4.00001 11.999 4C11.5413 4.00002 11.0927 4.03884 10.6572 4.1123L10.5557 4.12402C10.0499 4.1574 9.59103 3.80253 9.50488 3.29199C9.41323 2.74765 9.77995 2.23168 10.3242 2.13965L10.7354 2.0791C11.1494 2.02685 11.5716 2.00002 11.999 2Z" }) });
});
DottedCircleIcon.displayName = "DottedCircleIcon";

const DownloadIcon = forwardRef$1(function DownloadIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M20 14C20.5523 14 21 14.4477 21 15V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V15C3 14.4477 3.44772 14 4 14C4.55228 14 5 14.4477 5 15V18C5 18.5523 5.4477 19 6 19H18C18.5523 19 19 18.5523 19 18V15C19 14.4477 19.4477 14 20 14ZM12 3C12.5523 3 13 3.44772 13 4V12.0859L14.793 10.293L14.8691 10.2246C15.2619 9.90426 15.8409 9.92685 16.207 10.293C16.5731 10.6591 16.5957 11.2381 16.2754 11.6309L16.207 11.707L12.707 15.207C12.3409 15.5731 11.7619 15.5957 11.3691 15.2754L11.293 15.207L7.79297 11.707L7.72461 11.6309C7.40426 11.2381 7.42685 10.6591 7.79297 10.293C8.15908 9.92685 8.73809 9.90426 9.13086 10.2246L9.20703 10.293L11 12.0859V4C11 3.44772 11.4477 3 12 3Z" }) });
});
DownloadIcon.displayName = "DownloadIcon";

const DraftIcon = forwardRef$1(function DraftIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.8652 13.0361C18.5818 12.3198 19.7434 12.3197 20.46 13.0361C21.1766 13.7527 21.1766 14.9143 20.46 15.6309L15.2402 20.8506C15.1465 20.9443 15.0192 20.997 14.8867 20.9971H12.998C12.7222 20.9968 12.4981 20.773 12.498 20.4971V18.6094C12.498 18.4769 12.5509 18.3496 12.6445 18.2559L17.8652 13.0361ZM17.9434 3C19.5956 3.00001 20.9354 4.33997 20.9355 5.99219V9.97461C20.9355 10.5268 20.4877 10.9745 19.9355 10.9746C19.3833 10.9746 18.9356 10.5268 18.9355 9.97461V5.99219C18.9354 5.44467 18.4912 5.00001 17.9434 5H5.99219C5.4444 5 5.00018 5.44467 5 5.99219V17.9424C5 18.4901 5.44428 18.9346 5.99219 18.9346H7.9834L8.08594 18.9395C8.59016 18.9906 8.98323 19.4169 8.9834 19.9346C8.98322 20.4522 8.59012 20.8775 8.08594 20.9287L7.9834 20.9346H5.99219C4.33987 20.9346 3 19.5948 3 17.9424V5.99219C3.00018 4.33996 4.33997 3 5.99219 3H17.9434ZM11.5381 11.5039C12.0425 11.555 12.4365 11.9812 12.4365 12.499C12.4364 13.0167 12.0424 13.4431 11.5381 13.4941L11.4365 13.499H8.24902C7.69695 13.4989 7.2492 13.0511 7.24902 12.499C7.24902 11.9468 7.69684 11.4991 8.24902 11.499H11.4365L11.5381 11.5039ZM15.6855 7.25C16.2378 7.25 16.6855 7.69772 16.6855 8.25C16.6853 8.80206 16.2377 9.25 15.6855 9.25H8.24902C7.697 9.24988 7.24928 8.80199 7.24902 8.25C7.24902 7.69779 7.69684 7.25012 8.24902 7.25H15.6855Z" }) });
});
DraftIcon.displayName = "DraftIcon";

const DragIcon = forwardRef$1(function DragIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.5 6.16667C15.5 6.47609 15.3771 6.77283 15.1583 6.99162C14.9395 7.21042 14.6428 7.33333 14.3333 7.33333C14.0239 7.33333 13.7272 7.21042 13.5084 6.99162C13.2896 6.77283 13.1667 6.47609 13.1667 6.16667C13.1667 5.85725 13.2896 5.5605 13.5084 5.34171C13.7272 5.12292 14.0239 5 14.3333 5C14.6428 5 14.9395 5.12292 15.1583 5.34171C15.3771 5.5605 15.5 5.85725 15.5 6.16667ZM10.8333 6.16667C10.8333 6.47609 10.7104 6.77283 10.4916 6.99162C10.2728 7.21042 9.97609 7.33333 9.66667 7.33333C9.35725 7.33333 9.0605 7.21042 8.84171 6.99162C8.62292 6.77283 8.5 6.47609 8.5 6.16667C8.5 5.85725 8.62292 5.5605 8.84171 5.34171C9.0605 5.12292 9.35725 5 9.66667 5C9.97609 5 10.2728 5.12292 10.4916 5.34171C10.7104 5.5605 10.8333 5.85725 10.8333 6.16667ZM10.8333 12C10.8333 12.3094 10.7104 12.6062 10.4916 12.825C10.2728 13.0438 9.97609 13.1667 9.66667 13.1667C9.35725 13.1667 9.0605 13.0438 8.84171 12.825C8.62292 12.6062 8.5 12.3094 8.5 12C8.5 11.6906 8.62292 11.3938 8.84171 11.175C9.0605 10.9562 9.35725 10.8333 9.66667 10.8333C9.97609 10.8333 10.2728 10.9562 10.4916 11.175C10.7104 11.3938 10.8333 11.6906 10.8333 12ZM15.5 12C15.5 12.3094 15.3771 12.6062 15.1583 12.825C14.9395 13.0438 14.6428 13.1667 14.3333 13.1667C14.0239 13.1667 13.7272 13.0438 13.5084 12.825C13.2896 12.6062 13.1667 12.3094 13.1667 12C13.1667 11.6906 13.2896 11.3938 13.5084 11.175C13.7272 10.9562 14.0239 10.8333 14.3333 10.8333C14.6428 10.8333 14.9395 10.9562 15.1583 11.175C15.3771 11.3938 15.5 11.6906 15.5 12ZM15.5 17.8333C15.5 18.1428 15.3771 18.4395 15.1583 18.6583C14.9395 18.8771 14.6428 19 14.3333 19C14.0239 19 13.7272 18.8771 13.5084 18.6583C13.2896 18.4395 13.1667 18.1428 13.1667 17.8333C13.1667 17.5239 13.2896 17.2272 13.5084 17.0084C13.7272 16.7896 14.0239 16.6667 14.3333 16.6667C14.6428 16.6667 14.9395 16.7896 15.1583 17.0084C15.3771 17.2272 15.5 17.5239 15.5 17.8333ZM10.8333 17.8333C10.8333 18.1428 10.7104 18.4395 10.4916 18.6583C10.2728 18.8771 9.97609 19 9.66667 19C9.35725 19 9.0605 18.8771 8.84171 18.6583C8.62292 18.4395 8.5 18.1428 8.5 17.8333C8.5 17.5239 8.62292 17.2272 8.84171 17.0084C9.0605 16.7896 9.35725 16.6667 9.66667 16.6667C9.97609 16.6667 10.2728 16.7896 10.4916 17.0084C10.7104 17.2272 10.8333 17.5239 10.8333 17.8333Z" }) });
});
DragIcon.displayName = "DragIcon";

const DynamicTableIcon = forwardRef$1(function DynamicTableIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M16.7998 3C17.3434 3 17.8116 2.99893 18.1953 3.03028C18.5906 3.06259 18.984 3.13441 19.3623 3.32715C19.9265 3.61473 20.3853 4.07348 20.6729 4.6377L20.7402 4.78028C20.8835 5.11438 20.9415 5.45882 20.9697 5.80469C21.0011 6.18836 21 6.65665 21 7.2002V12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12V9H9.1709V19H9.5C10.0523 19 10.5 19.4477 10.5 20C10.5 20.5523 10.0523 21 9.5 21H7.2002C6.65665 21 6.18836 21.0011 5.80469 20.9697C5.45882 20.9415 5.11438 20.8835 4.78028 20.7402L4.6377 20.6729C4.07348 20.3853 3.61473 19.9265 3.32715 19.3623C3.1344 18.984 3.06259 18.5906 3.03028 18.1953C2.99893 17.8116 3 17.3434 3 16.7998V7.2002C3 6.65665 2.99893 6.18836 3.03028 5.80469C3.06259 5.40944 3.1344 5.01599 3.32715 4.6377C3.61473 4.07348 4.07348 3.61473 4.6377 3.32715C5.01599 3.1344 5.40944 3.06259 5.80469 3.03028C6.18836 2.99893 6.65665 3 7.2002 3H16.7998ZM5 9V16.7998C5 17.3764 5.00127 17.7489 5.02442 18.0322C5.04661 18.3038 5.08419 18.4047 5.10938 18.4541C5.20522 18.6421 5.35794 18.7948 5.5459 18.8906L5.59473 18.9121C5.65668 18.9344 5.76435 18.959 5.96778 18.9756C6.24629 18.9983 6.61098 18.999 7.1709 18.999V9H5ZM7.1709 5C6.61098 5.00005 6.24629 5.00166 5.96778 5.02442C5.6962 5.04662 5.59534 5.08419 5.5459 5.10938C5.35794 5.20522 5.20522 5.35794 5.10938 5.5459C5.08419 5.59534 5.04662 5.6962 5.02442 5.96778C5.00407 6.21689 5.00151 6.53496 5.00098 7H7.1709V5ZM9.1709 7H18.999C18.9985 6.53496 18.9959 6.21689 18.9756 5.96778C18.959 5.76435 18.9344 5.65668 18.9121 5.59473L18.8906 5.5459C18.7948 5.35794 18.6421 5.20522 18.4541 5.10938C18.4047 5.08419 18.3038 5.04661 18.0322 5.02442C17.7489 5.00127 17.3764 5 16.7998 5H9.1709V7Z" }), jsx("path", { d: "M17.3635 14.9195C17.5408 14.2579 18.2209 13.8653 18.8825 14.0426L20.0804 14.3636C20.7421 14.5408 21.1347 15.2209 20.9575 15.8825L20.6364 17.0805C20.4591 17.7421 19.7791 18.1347 19.1175 17.9574L17.9195 17.6365C17.2579 17.4592 16.8653 16.7791 17.0426 16.1175L17.3635 14.9195Z" }), jsx("path", { d: "M16 19C16 20.1046 15.1046 21 14 21C12.8955 21 12 20.1046 12 19C12 17.8954 12.8955 17 14 17C15.1046 17 16 17.8954 16 19Z" }), jsx("path", { d: "M11.805 11.6435C11.9424 10.9001 12.8233 10.5721 13.4134 11.0446L15.5869 12.7848C16.201 13.2765 16.0331 14.252 15.29 14.5101L12.6238 15.4361C11.8994 15.6877 11.173 15.0638 11.3124 14.3097L11.805 11.6435Z" })] });
});
DynamicTableIcon.displayName = "DynamicTableIcon";

const EditIcon = forwardRef$1(function EditIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M14.2666 4.7569C15.276 3.74773 16.9125 3.74767 17.9219 4.7569L19.2461 6.08209H19.2471C20.256 7.0915 20.2561 8.72802 19.2471 9.73737H19.2461L17.5938 11.3907L9.50488 19.4786C9.16886 19.8144 8.71266 20.004 8.2373 20.004H5C4.44798 20.0038 4.00026 19.556 4 19.004V15.7657C4.00007 15.2906 4.18937 14.8342 4.52539 14.4981L14.2666 4.7569ZM6 15.8516V18.004H8.15137L15.4717 10.6827L13.3203 8.53131L6 15.8516ZM16.5078 6.17096C16.2795 5.94278 15.909 5.94284 15.6807 6.17096L14.7344 7.11627L16.8857 9.26862L17.832 8.3233C18.0604 8.09489 18.0604 7.72457 17.832 7.49615L16.5078 6.17096Z" }) });
});
EditIcon.displayName = "EditIcon";

const EmailIcon = forwardRef$1(function EmailIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.999 2C17.521 2.00019 21.997 6.47709 21.9971 11.999C21.997 13.1032 21.727 14.3087 21.0488 15.2412C20.3775 16.1641 19.3396 16.7624 17.9912 16.7227L17.7178 16.7061C16.5142 16.5965 15.4782 15.9945 14.7871 15.1201C13.8931 16.2694 12.5424 16.9868 11.04 16.8623L10.8037 16.8359C8.2749 16.4801 6.76515 13.9255 7.12305 11.3789L7.16113 11.1416C7.61547 8.70735 9.71531 6.80459 12.165 7.14844L12.3994 7.18848C13.2051 7.3489 13.8986 7.73776 14.4512 8.27637C14.5657 7.77312 15.0498 7.43452 15.5693 7.50977C16.1157 7.58915 16.4942 8.0962 16.415 8.64258L15.9004 12.1904C15.722 13.4482 16.6329 14.5995 17.8984 14.7148L18.0361 14.7236C18.7058 14.7476 19.1302 14.4775 19.4307 14.0645C19.7889 13.5719 19.997 12.8205 19.9971 11.999C19.997 7.58166 16.4164 4.00019 11.999 4C7.58171 4.00021 4.00008 7.58168 4 11.999C4.00019 16.4163 7.58177 19.9969 11.999 19.9971C13.545 19.997 14.9862 19.5594 16.208 18.8018C16.6772 18.5109 17.2939 18.6559 17.585 19.125C17.8757 19.5943 17.7309 20.211 17.2617 20.502C15.7326 21.4501 13.928 21.997 11.999 21.9971C6.4772 21.9969 2.00019 17.5209 2 11.999C2.00008 6.47711 6.47714 2.00021 11.999 2ZM11.8867 9.12891C10.7663 8.97189 9.51154 9.82951 9.16113 11.3457L9.10352 11.6572C8.86329 13.3666 9.88706 14.6871 11.082 14.8555L11.3076 14.873C12.4415 14.8968 13.6409 13.9298 13.8662 12.3271L13.8965 12.0107C13.972 10.5601 13.1318 9.44402 12.1084 9.17383L11.8867 9.12891Z" }) });
});
EmailIcon.displayName = "EmailIcon";

const EmaileditorButtonEmojiIcon = forwardRef$1(function EmaileditorButtonEmojiIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15.4512 13.7871C15.6425 13.7524 15.8389 13.7922 15.998 13.8994C16.1571 14.0066 16.268 14.1739 16.3076 14.3643C16.3472 14.5546 16.3115 14.7523 16.2158 14.9189C16.1309 15.0628 16.0396 15.2001 15.9395 15.335C15.0497 16.5567 13.5164 17.2879 12.002 17.2754C10.4873 17.2854 8.95718 16.5539 8.06543 15.3359C7.96516 15.2014 7.87435 15.0644 7.78906 14.9209C7.69268 14.7544 7.65621 14.5568 7.69531 14.3662C7.73432 14.1759 7.84432 14.0092 8.00293 13.9014C8.16176 13.7937 8.35837 13.7529 8.5498 13.7871C8.74114 13.8213 8.91121 13.928 9.03027 14.0791C9.10453 14.1707 9.18089 14.2558 9.26172 14.3389C9.98207 15.0825 10.9871 15.4753 12.0029 15.4746C13.0188 15.4768 14.0236 15.0852 14.7412 14.3408C14.8217 14.2578 14.8979 14.1727 14.9717 14.0811C15.0903 13.9296 15.2598 13.8218 15.4512 13.7871Z" }), jsx("path", { fill: "currentColor", d: "M9.25 8C10.0784 8 10.75 8.79582 10.75 9.90039C10.7498 11.0048 10.0783 11.75 9.25 11.75C8.42167 11.75 7.75016 11.0048 7.75 9.90039C7.75 8.79582 8.42157 8 9.25 8Z" }), jsx("path", { fill: "currentColor", d: "M14.75 8C15.5784 8 16.25 8.79582 16.25 9.90039C16.2498 11.0048 15.5783 11.75 14.75 11.75C13.9217 11.75 13.2502 11.0048 13.25 9.90039C13.25 8.79582 13.9216 8 14.75 8Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" })] });
});
EmaileditorButtonEmojiIcon.displayName = "EmaileditorButtonEmojiIcon";

const EmaileditorButtonIcon = forwardRef$1(function EmaileditorButtonIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M9.47559 11.6855C9.06113 10.5797 10.0762 9.37997 11.2646 9.74609L11.3799 9.78711L20.499 13.3535C21.6355 13.7982 21.7612 15.3491 20.7402 15.9863L17.5488 17.9785L15.5977 21.2402C14.9603 22.3054 13.3973 22.1452 12.9678 21L9.47559 11.6855ZM14.4512 19.2607L15.8984 16.8428C16.0177 16.6435 16.1827 16.4738 16.3818 16.3496L18.8027 14.8379L11.7607 12.083L14.4512 19.2607Z" }), jsx("path", { fill: "currentColor", d: "M13.6523 3.95605C17.2004 3.95625 20.1555 6.44535 20.9717 9.77246C21.1029 10.3086 20.7745 10.8499 20.2383 10.9814C19.7019 11.113 19.1599 10.7844 19.0283 10.248C18.4197 7.76822 16.2312 5.95625 13.6523 5.95605H8.97754C5.93556 5.9561 3.43359 8.48132 3.43359 11.6406C3.43384 14.7997 5.93571 17.3242 8.97754 17.3242C9.52979 17.3242 9.97748 17.772 9.97754 18.3242C9.97752 18.8765 9.52981 19.3242 8.97754 19.3242C4.79142 19.3242 1.43384 15.8641 1.43359 11.6406C1.43359 7.4169 4.79126 3.9561 8.97754 3.95605H13.6523Z" })] });
});
EmaileditorButtonIcon.displayName = "EmaileditorButtonIcon";

const EmaileditorDividerIcon = forwardRef$1(function EmaileditorDividerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", opacity: 0.4, d: "M5 4C5.55228 4 6 4.44772 6 5C6 5.55228 5.55228 6 5 6H3C2.44772 6 2 5.55228 2 5C2 4.44772 2.44772 4 3 4H5Z" }), jsx("path", { fill: "currentColor", opacity: 0.4, d: "M13 4C13.5523 4 14 4.44772 14 5C14 5.55228 13.5523 6 13 6H11C10.4477 6 10 5.55228 10 5C10 4.44772 10.4477 4 11 4H13Z" }), jsx("path", { fill: "currentColor", opacity: 0.4, d: "M21 4C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H19C18.4477 6 18 5.55228 18 5C18 4.44772 18.4477 4 19 4H21Z" }), jsx("path", { fill: "currentColor", opacity: 0.4, d: "M5 18C5.55228 18 6 18.4477 6 19C6 19.5523 5.55228 20 5 20H3C2.44772 20 2 19.5523 2 19C2 18.4477 2.44772 18 3 18H5Z" }), jsx("path", { fill: "currentColor", opacity: 0.4, d: "M13 18C13.5523 18 14 18.4477 14 19C14 19.5523 13.5523 20 13 20H11C10.4477 20 10 19.5523 10 19C10 18.4477 10.4477 18 11 18H13Z" }), jsx("path", { fill: "currentColor", opacity: 0.4, d: "M21 18C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20H19C18.4477 20 18 19.5523 18 19C18 18.4477 18.4477 18 19 18H21Z" }), jsx("path", { fill: "currentColor", d: "M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21Z" })] });
});
EmaileditorDividerIcon.displayName = "EmaileditorDividerIcon";

const EmaileditorGifIcon = forwardRef$1(function EmaileditorGifIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 7C20 6.44771 19.5523 6 19 6H5C4.44771 6 4 6.44771 4 7V17C4 17.5523 4.44771 18 5 18H19C19.5523 18 20 17.5523 20 17V7ZM22 17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17Z" }), jsx("path", { fill: "currentColor", d: "M6 12.287C6 13.8269 6.91945 14.75 8.47937 14.75C9.91356 14.75 10.833 13.9432 10.833 12.6904V12.5236C10.833 11.9457 10.5658 11.6897 9.94892 11.6897H9.14342C8.72692 11.6897 8.51081 11.872 8.51081 12.225C8.51081 12.5818 8.73084 12.7757 9.14342 12.7757H9.2888V12.8378C9.2888 13.1985 8.99018 13.4468 8.55403 13.4468C7.95678 13.4468 7.65029 13.0472 7.65029 12.2793V11.7595C7.65029 10.9838 7.95678 10.6037 8.60118 10.6037C9.06483 10.6037 9.30059 10.914 9.61886 11.0807C9.73674 11.1467 9.87033 11.1894 10.0275 11.1894C10.4126 11.1894 10.6837 10.9256 10.6837 10.5532C10.6837 10.2003 10.4244 9.87447 10.0196 9.63787C9.611 9.39739 9.0609 9.25 8.47151 9.25C6.95481 9.25 6 10.2003 6 11.6703V12.287Z" }), jsx("path", { fill: "currentColor", d: "M12.3576 14.6724C12.8841 14.6724 13.1709 14.3621 13.1709 13.7997V10.1731C13.1709 9.6146 12.8762 9.30042 12.3458 9.30042C11.8153 9.30042 11.5206 9.61072 11.5206 10.1731V13.7997C11.5206 14.3583 11.8232 14.6724 12.3576 14.6724Z" }), jsx("path", { fill: "currentColor", d: "M14.9234 14.6724C15.442 14.6724 15.725 14.366 15.725 13.7997V12.8068H17.1945C17.556 12.8068 17.8035 12.5547 17.8035 12.1939C17.8035 11.8293 17.5599 11.5811 17.1945 11.5811H15.725V10.6075H17.391C17.7407 10.6075 18 10.3477 18 9.9792C18 9.61072 17.7407 9.33921 17.391 9.33921H14.8959C14.389 9.33921 14.0747 9.65339 14.0747 10.1654V13.7997C14.0747 14.3544 14.3851 14.6724 14.9234 14.6724Z" })] });
});
EmaileditorGifIcon.displayName = "EmaileditorGifIcon";

const EmaileditorMenuIcon = forwardRef$1(function EmaileditorMenuIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12ZM22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2C17.5229 2 22 6.47716 22 12Z" }), jsx("path", { fill: "currentColor", d: "M8 10.75C8.69028 10.75 9.25 11.3095 9.25 12C9.25 12.6905 8.69028 13.25 8 13.25C7.30972 13.25 6.75 12.6905 6.75 12C6.75 11.3095 7.30972 10.75 8 10.75Z" }), jsx("path", { fill: "currentColor", d: "M12 10.75C12.6904 10.75 13.25 11.3096 13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12C10.75 11.3096 11.3096 10.75 12 10.75Z" }), jsx("path", { fill: "currentColor", d: "M16 10.75C16.6904 10.75 17.25 11.3096 17.25 12C17.25 12.6904 16.6904 13.25 16 13.25C15.3096 13.25 14.75 12.6904 14.75 12C14.75 11.3096 15.3096 10.75 16 10.75Z" })] });
});
EmaileditorMenuIcon.displayName = "EmaileditorMenuIcon";

const EmaileditorParagraphIcon = forwardRef$1(function EmaileditorParagraphIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 3C20.5523 3 21 3.44772 21 4C21 4.55228 20.5523 5 20 5H4C3.44772 5 3 4.55228 3 4C3 3.44772 3.44772 3 4 3H20Z" }), jsx("path", { fill: "currentColor", d: "M9 9C9.55228 9 10 8.55229 10 8C10 7.44771 9.55228 7 9 7H4C3.44772 7 3 7.44771 3 8C3 8.55229 3.44772 9 4 9H9Z" }), jsx("path", { fill: "currentColor", d: "M6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11H4C3.44772 11 3 11.4477 3 12C3 12.5523 3.44772 13 4 13H6Z" }), jsx("path", { fill: "currentColor", d: "M5 17C5.55228 17 6 16.5523 6 16C6 15.4477 5.55228 15 5 15H4C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H5Z" }), jsx("path", { fill: "currentColor", d: "M15.6152 8V18H14.2305V8C14.2305 7.44771 13.7828 7 13.2305 7C12.6783 7.00016 12.2305 7.44781 12.2305 8V12.5H11.708C9.64574 12.5 8 14.1936 8 16.25C8 18.2421 9.5442 19.8938 11.5156 19.9951L11.708 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H17.6152V8C17.6152 7.44771 17.1675 7 16.6152 7C16.063 7.00008 15.6152 7.44777 15.6152 8Z" }), jsx("path", { fill: "currentColor", d: "M5 21C5.55228 21 6 20.5523 6 20C6 19.4477 5.55228 19 5 19H4C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H5Z" })] });
});
EmaileditorParagraphIcon.displayName = "EmaileditorParagraphIcon";

const EmaileditorSocialIcon = forwardRef$1(function EmaileditorSocialIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M15 7.99998C18.866 7.99998 22 11.134 22 15C22 15.7834 21.8093 16.6633 21.3037 17.3584C20.7604 18.1052 19.8933 18.5715 18.7832 18.4707C18.2096 18.4185 17.6876 18.216 17.2509 17.9064C17.0241 17.7457 16.7089 17.7497 16.4894 17.9201C15.8479 18.418 15.0387 18.6794 14.1572 18.5556C12.2488 18.2874 11.1609 16.3784 11.4189 14.541C11.6772 12.7035 13.2487 11.1684 15.1572 11.4365C15.5212 11.4877 15.8554 11.5984 16.1561 11.7569C16.3838 11.877 16.6698 11.8364 16.9083 11.7395C17.0678 11.6747 17.2462 11.6502 17.4287 11.6767C17.9753 11.7561 18.3538 12.264 18.2744 12.8105L17.9307 15.1728C17.8377 15.8233 18.3094 16.4199 18.9639 16.4795C19.342 16.5138 19.5387 16.3849 19.6865 16.1816C19.8721 15.9265 20 15.5006 20 15C20 12.2386 17.7614 9.99999 15 9.99999C12.2386 9.99999 10 12.2386 10 15C10 17.7614 12.2386 20 15 20C15.9671 20 16.8673 19.7264 17.6309 19.2529C18.1002 18.9619 18.7167 19.1068 19.0078 19.5762C19.2986 20.0455 19.1538 20.6611 18.6846 20.9521C17.6137 21.6162 16.3502 22 15 22C11.134 22 8 18.866 8 15C8.00001 11.134 11.134 7.99998 15 7.99998ZM14.8789 13.417C14.3042 13.3364 13.54 13.819 13.3994 14.8193C13.259 15.8195 13.8609 16.4944 14.4355 16.5752C15.0101 16.6557 15.7744 16.1728 15.915 15.1728C16.0557 14.1725 15.4535 13.4977 14.8789 13.417Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M9.62402 2.0078C10.172 2.0763 10.5607 2.57599 10.4922 3.12401L10.4531 3.43846C10.4161 3.7367 10.6486 3.99998 10.9492 3.99998H11C11.5523 3.99998 12 4.44771 12 4.99998C12 5.55227 11.5523 5.99998 11 5.99998H10.5742C10.3222 5.99998 10.1096 6.18751 10.0781 6.43748L9.90751 7.80327C9.8977 7.88186 9.86969 7.95721 9.82375 8.02172C9.46134 8.53045 8.99524 9.00431 8.14677 9.85319C8.05302 9.94698 7.9255 9.99999 7.79289 9.99999H6.07422C5.82222 9.99999 5.60962 10.1875 5.57812 10.4375L5.49219 11.124C5.42369 11.672 4.924 12.0607 4.37598 11.9922C3.82796 11.9237 3.43931 11.424 3.50781 10.876L3.54688 10.5615C3.58388 10.2633 3.35137 9.99999 3.05078 9.99999H3C2.44772 9.99999 2 9.55227 2 8.99998C2.00001 8.44771 2.44772 7.99998 3 7.99998H3.42578C3.67778 7.99998 3.89039 7.81246 3.92188 7.56248L4.04688 6.56248C4.08418 6.26406 3.85153 5.99998 3.55078 5.99998H3C2.44772 5.99998 2 5.55227 2 4.99998C2.00001 4.44771 2.44772 3.99998 3 3.99998H3.92578C4.17778 3.99998 4.39038 3.81246 4.42188 3.56248L4.50781 2.87596C4.57632 2.32795 5.07601 1.9393 5.62402 2.0078C6.17204 2.0763 6.56068 2.57599 6.49219 3.12401L6.45312 3.43846C6.41612 3.7367 6.64863 3.99998 6.94922 3.99998H7.92578C8.17778 3.99998 8.39038 3.81246 8.42188 3.56248L8.50781 2.87596C8.57632 2.32795 9.07601 1.9393 9.62402 2.0078ZM6.57422 5.99998C6.32222 5.99998 6.10961 6.18751 6.07812 6.43748L5.95312 7.43748C5.91582 7.73591 6.14847 7.99998 6.44922 7.99998H7.42578C7.67778 7.99998 7.89039 7.81246 7.92188 7.56248L8.04688 6.56248C8.08418 6.26406 7.85153 5.99998 7.55078 5.99998H6.57422Z" })] });
});
EmaileditorSocialIcon.displayName = "EmaileditorSocialIcon";

const EmaileditorSpacerIcon = forwardRef$1(function EmaileditorSpacerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M11.3691 2.22461C11.7619 1.90426 12.3409 1.92685 12.707 2.29297L15.207 4.79297C15.5976 5.18349 15.5976 5.81651 15.207 6.20703C14.8165 6.59756 14.1835 6.59756 13.793 6.20703L12 4.41406L10.207 6.20703C9.81651 6.59756 9.18349 6.59756 8.79297 6.20703C8.40244 5.81651 8.40244 5.18349 8.79297 4.79297L11.293 2.29297L11.3691 2.22461Z" }), jsx("path", { fill: "currentColor", d: "M13.793 17.793C14.1835 17.4024 14.8165 17.4024 15.207 17.793C15.5976 18.1835 15.5976 18.8165 15.207 19.207L12.707 21.707C12.3165 22.0976 11.6835 22.0976 11.293 21.707L8.79297 19.207C8.40244 18.8165 8.40244 18.1835 8.79297 17.793C9.18349 17.4024 9.81651 17.4024 10.207 17.793L12 19.5859L13.793 17.793Z" }), jsx("path", { fill: "currentColor", d: "M11 9V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9Z" }), jsx("path", { fill: "currentColor", d: "M11 20V15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20Z" }), jsx("path", { fill: "currentColor", d: "M2 13V11C2 9.34315 3.34315 8 5 8H7C7.55228 8 8 8.44771 8 9C8 9.55228 7.55228 10 7 10H5C4.44771 10 4 10.4477 4 11V13C4 13.5523 4.44771 14 5 14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H5C3.34315 16 2 14.6569 2 13Z" }), jsx("path", { fill: "currentColor", d: "M20 13V11C20 10.4477 19.5523 10 19 10H17C16.4477 10 16 9.55228 16 9C16 8.44771 16.4477 8 17 8H19C20.6569 8 22 9.34315 22 11V13C22 14.6569 20.6569 16 19 16H17C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14H19C19.5523 14 20 13.5523 20 13Z" })] });
});
EmaileditorSpacerIcon.displayName = "EmaileditorSpacerIcon";

const EmaileditorStickerIcon = forwardRef$1(function EmaileditorStickerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M19.9961 11.7334C19.9908 11.5723 19.913 11.3828 19.7412 11.2109L12.7891 4.25879C12.6172 4.08699 12.4277 4.00918 12.2666 4.00391C12.1781 4.00101 12.0892 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.9104 19.999 11.8215 19.9961 11.7334ZM22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2C12.1111 2 12.2217 2.00225 12.332 2.00586C13.0795 2.03032 13.7322 2.37379 14.2031 2.84473L21.1553 9.79688C21.6261 10.2677 21.9695 10.9198 21.9941 11.667C21.9978 11.778 22 11.8891 22 12Z" }), jsx("path", { fill: "currentColor", d: "M13 2.50098C13.5518 2.52211 13.982 2.98628 13.961 3.53809C13.8252 7.08161 16.9174 10.1737 20.461 10.0381C21.0128 10.017 21.4779 10.4471 21.499 10.999C21.5202 11.5508 21.0898 12.0148 20.5381 12.0361C15.8306 12.2164 11.7827 8.16941 11.9629 3.46191C11.984 2.91015 12.4483 2.48003 13 2.50098Z" }), jsx("path", { fill: "currentColor", d: "M13.793 5.29297C14.1835 4.90244 14.8165 4.90244 15.207 5.29297L18.707 8.79297C19.0976 9.18349 19.0976 9.81651 18.707 10.207C18.3165 10.5976 17.6835 10.5976 17.293 10.207L13.793 6.70703C13.4024 6.31651 13.4024 5.68349 13.793 5.29297Z" })] });
});
EmaileditorStickerIcon.displayName = "EmaileditorStickerIcon";

const EmaileditorTitleIcon = forwardRef$1(function EmaileditorTitleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15 8C14.4477 8 14 7.55228 14 7C14 6.44772 14.4477 6 15 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H15Z" }), jsx("path", { fill: "currentColor", d: "M15 12C14.4477 12 14 11.5523 14 11C14 10.4477 14.4477 10 15 10H20C20.5523 10 21 10.4477 21 11C21 11.5523 20.5523 12 20 12H15Z" }), jsx("path", { fill: "currentColor", d: "M4 16C3.44772 16 3 15.5523 3 15C3 14.4477 3.44772 14 4 14H20C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16H4Z" }), jsx("path", { fill: "currentColor", d: "M4 20C3.44772 20 3 19.5523 3 19C3 18.4477 3.44772 18 4 18H20C20.5523 18 21 18.4477 21 19C21 19.5523 20.5523 20 20 20H4Z" }), jsx("path", { fill: "currentColor", d: "M10 6.33301V6H9V10C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H7C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10V6H6V6.33301C6 6.88529 5.55228 7.33301 5 7.33301C4.44772 7.33301 4 6.88529 4 6.33301V5C4 4.44772 4.44772 4 5 4H11C11.5523 4 12 4.44772 12 5V6.33301C12 6.88529 11.5523 7.33301 11 7.33301C10.4477 7.33301 10 6.88529 10 6.33301Z" })] });
});
EmaileditorTitleIcon.displayName = "EmaileditorTitleIcon";

const EmaileditorVideoIcon = forwardRef$1(function EmaileditorVideoIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M19.9944 6.89746C19.943 6.39344 19.5178 6.00012 19.0002 6H5.00023C4.44795 6 4.00023 6.44771 4.00023 7L3.99926 17C3.99926 17.5523 4.44696 18 4.99926 18H18.9993C19.5516 18 19.9993 17.5523 19.9993 17L20.0002 7L19.9944 6.89746ZM10.5276 9.11816C10.8527 8.94426 11.2472 8.96344 11.5539 9.16797L14.5539 11.168C14.8321 11.3534 14.9993 11.6656 14.9993 12C14.9993 12.3344 14.8321 12.6466 14.5539 12.832L11.5539 14.832C11.2472 15.0366 10.8527 15.0557 10.5276 14.8818C10.2024 14.7078 9.99926 14.3688 9.99926 14V10C9.99926 9.6312 10.2024 9.29218 10.5276 9.11816ZM21.9993 17C21.9993 18.6569 20.6561 20 18.9993 20H4.99926C3.34241 20 1.99926 18.6569 1.99926 17L2.00023 7C2.00023 5.34315 3.34338 4 5.00023 4H19.0002C20.657 4.00013 22.0002 5.34323 22.0002 7L21.9993 17Z" }) });
});
EmaileditorVideoIcon.displayName = "EmaileditorVideoIcon";

const EnterIcon = forwardRef$1(function EnterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.4053 2.00488C11.9012 2.05614 11.5079 2.48238 11.5078 3C11.5078 3.51771 11.9011 3.94383 12.4053 3.99512L12.5078 4H16.6387C17.3435 4 17.9999 4.61592 18 5.48242V18.998C17.9998 19.5502 17.5522 19.998 17 19.998H8.60547C8.05335 19.998 7.60568 19.5501 7.60547 18.998V12.9297C7.6053 12.3775 7.15765 11.9297 6.60547 11.9297C6.05332 11.9297 5.60563 12.3776 5.60547 12.9297V18.998C5.60568 20.6547 6.94878 21.998 8.60547 21.998H17C18.6567 21.998 19.9998 20.6547 20 18.998V5.48242C19.9999 3.60715 18.5415 2 16.6387 2H12.5078L12.4053 2.00488ZM15.125 12C14.5038 12 14 12.5038 14 13.125C14.0001 13.7461 14.5039 14.25 15.125 14.25C15.7461 14.2499 16.2499 13.7461 16.25 13.125C16.25 12.5039 15.7461 12.0001 15.125 12ZM9.0625 3.50391C8.672 3.1137 8.03888 3.11361 7.64844 3.50391C7.25813 3.89435 7.25823 4.52746 7.64844 4.91797L8.08594 5.35547H4L3.89746 5.36035C3.39341 5.41166 3.00015 5.83791 3 6.35547C3.00014 6.873 3.39345 7.29826 3.89746 7.34961L4 7.35547H8.08496L7.64844 7.79199C7.25796 8.18247 7.25806 8.81649 7.64844 9.20703C8.03885 9.59729 8.67199 9.59713 9.0625 9.20703L11.207 7.0625C11.3944 6.87504 11.4999 6.62052 11.5 6.35547C11.4999 6.09042 11.3944 5.83589 11.207 5.64844L9.0625 3.50391Z" }) });
});
EnterIcon.displayName = "EnterIcon";

const ErrorIcon = forwardRef$1(function ErrorIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.54688 3.94333C10.9855 2.64374 13.2063 2.68686 14.5928 4.07322L19.9287 9.41013L20.0586 9.54685C21.3165 10.9392 21.3168 13.0638 20.0586 14.456L19.9287 14.5927L14.5928 19.9287C13.2063 21.3152 10.9855 21.3583 9.54688 20.0586L9.41016 19.9287L4.07324 14.5927C2.64213 13.1616 2.64237 10.8414 4.07324 9.41013L9.41016 4.07322L9.54688 3.94333ZM13.1787 5.48728C12.5691 4.87779 11.6041 4.83972 10.9502 5.37302L10.8242 5.48728L5.48731 10.8242C4.83746 11.4744 4.83725 12.5286 5.48731 13.1787L10.8242 18.5146L10.9502 18.6289C11.6041 19.1624 12.5691 19.1242 13.1787 18.5146L18.5146 13.1787L18.6289 13.0517C19.1267 12.4414 19.1268 11.5605 18.6289 10.9502L18.5146 10.8242L13.1787 5.48728ZM13.1787 9.40915C13.5691 9.01888 14.2023 9.01908 14.5928 9.40915C14.9832 9.79969 14.9833 10.4337 14.5928 10.8242L13.416 12.001L14.5928 13.1787L14.6611 13.2539C14.9817 13.6467 14.959 14.2265 14.5928 14.5927C14.2265 14.9587 13.6466 14.9816 13.2539 14.6611L13.1787 14.5927L12.002 13.415L10.8242 14.5927C10.4337 14.983 9.80063 14.983 9.41016 14.5927C9.01971 14.2023 9.01985 13.5692 9.41016 13.1787L10.5869 12.001L9.41016 10.8242C9.01967 10.4337 9.01974 9.79969 9.41016 9.40915C9.80063 9.019 10.4338 9.01895 10.8242 9.40915L12.002 10.5869L13.1787 9.40915Z" }) });
});
ErrorIcon.displayName = "ErrorIcon";

const ExitIcon = forwardRef$1(function ExitIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.1026 13.0049C10.6067 13.0562 11 13.4823 11 14V20C11 20.5522 10.5523 20.9999 10 21C9.44779 21 9.00009 20.5522 9.00005 20V16.414L4.45708 20.957C4.06658 21.3475 3.43355 21.3475 3.04302 20.957C2.65249 20.5665 2.65249 19.9335 3.04302 19.543L7.58598 15H4.00005C3.44779 15 3.00009 14.5522 3.00005 14C3.00005 13.4477 3.44776 13 4.00005 13H10L10.1026 13.0049ZM19.543 3.04295C19.9335 2.65243 20.5666 2.65243 20.9571 3.04295C21.3475 3.43348 21.3476 4.06652 20.9571 4.45702L16.4141 8.99999H20C20.5523 9.00003 21 9.44773 21 9.99999C21 10.5522 20.5523 10.9999 20 11H14C13.4478 11 13.0001 10.5522 13 9.99999V3.99999C13 3.4477 13.4478 2.99999 14 2.99999C14.5523 3.00003 15 3.44773 15 3.99999V7.58592L19.543 3.04295Z" }) });
});
ExitIcon.displayName = "ExitIcon";

const ExpandIcon = forwardRef$1(function ExpandIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.29297 13.293C9.68349 12.9024 10.3165 12.9024 10.707 13.293C11.0976 13.6835 11.0976 14.3165 10.707 14.707L6.41406 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13C4.55228 13 5 13.4477 5 14V17.5859L9.29297 13.293ZM20.1025 3.00488C20.6067 3.05621 21 3.48232 21 4V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V6.41406L14.707 10.707C14.3165 11.0976 13.6835 11.0976 13.293 10.707C12.9024 10.3165 12.9024 9.68349 13.293 9.29297L17.5859 5H14C13.4477 5 13 4.55228 13 4C13 3.44772 13.4477 3 14 3H20L20.1025 3.00488Z" }) });
});
ExpandIcon.displayName = "ExpandIcon";

const ExperimentIcon = forwardRef$1(function ExperimentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7146 4.18359C13.1058 3.79374 13.7388 3.7944 14.1287 4.18555L15.0711 5.13086L15.0721 5.13281L19.7664 9.86035L19.7674 9.8623L20.7029 10.8076C21.0908 11.2002 21.0874 11.8334 20.6951 12.2217C20.3025 12.6098 19.6684 12.6062 19.2801 12.2139L19.0545 11.9854L10.3748 20.7266C8.68769 22.4253 5.9496 22.4254 4.2625 20.7266C2.5792 19.0309 2.57913 16.2843 4.2625 14.5889L12.952 5.83789L12.7117 5.59766C12.322 5.20652 12.3237 4.57344 12.7146 4.18359ZM5.68145 15.998C4.77256 16.9137 4.7724 18.4017 5.68145 19.3174C6.58634 20.2286 8.05084 20.2286 8.95586 19.3174L13.8367 14.4014H7.55254C7.46505 14.4014 7.38048 14.3893 7.29961 14.3682L5.68145 15.998ZM9.25273 12.4014H15.532L15.6346 12.4062C15.6869 12.4116 15.7382 12.4215 15.7879 12.4346L17.6463 10.5645L14.3621 7.25586L9.25273 12.4014Z" }), jsx("path", { d: "M20.0008 5.78223C20.553 5.78223 21.0007 6.23 21.0008 6.78223C21.0008 7.33451 20.5531 7.78223 20.0008 7.78223H19.991C19.4388 7.78211 18.991 7.33444 18.991 6.78223C18.9911 6.23007 19.4389 5.78235 19.991 5.78223H20.0008Z" }), jsx("path", { d: "M18.5838 2C19.401 2.00024 20.0534 2.66518 20.0535 3.47266C20.0535 4.28018 19.401 4.94507 18.5838 4.94531C17.7664 4.9452 17.1141 4.28025 17.1141 3.47266C17.1142 2.66511 17.7665 2.00012 18.5838 2Z" })] });
});
ExperimentIcon.displayName = "ExperimentIcon";

const ExtensionsIcon = forwardRef$1(function ExtensionsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M19 7C19 6.4477 18.5523 6 18 6H14.5C13.9477 6 13.5 5.55228 13.5 5V4.5C13.5 3.67158 12.8284 3 12 3C11.1716 3 10.5 3.67158 10.5 4.5V5C10.5 5.55228 10.0523 6 9.5 6H6C5.44771 6 5 6.44771 5 7V17C5 17.5523 5.44771 18 6 18H18C18.5523 18 19 17.5523 19 17V15.4639C17.3039 15.2212 16 13.7632 16 12C16 10.2368 17.3038 8.77776 19 8.53516V7ZM21 9.5C21 10.0523 20.5523 10.5 20 10.5H19.5C18.6716 10.5 18 11.1716 18 12C18 12.8284 18.6716 13.5 19.5 13.5H20C20.5523 13.5 21 13.9477 21 14.5V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4H8.53613C8.77879 2.3039 10.2368 1 12 1C13.7632 1 15.2212 2.3039 15.4639 4H18C19.6569 4 21 5.34315 21 7V9.5Z" }) });
});
ExtensionsIcon.displayName = "ExtensionsIcon";

const ExternalLinkIcon = forwardRef$1(function ExternalLinkIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.47852 4.00488C9.98239 4.05647 10.376 4.48251 10.376 5C10.3757 5.51731 9.98228 5.9436 9.47852 5.99512L9.37598 6H7.80078C7.29446 6 6.97408 6.0008 6.73242 6.02051C6.61758 6.02989 6.54224 6.04221 6.49317 6.05371L6.41016 6.08203C6.30438 6.13593 6.21278 6.21351 6.14356 6.30859L6.08203 6.41016C6.07028 6.43335 6.03919 6.50382 6.02051 6.73242C6.0008 6.97408 6 7.29445 6 7.80078V16.2021C6 16.7084 6.00078 17.0289 6.02051 17.2705C6.03931 17.5002 6.07047 17.5711 6.08203 17.5938L6.14356 17.6943C6.21264 17.7891 6.30385 17.8671 6.40918 17.9209H6.41016L6.49317 17.9492C6.54224 17.9607 6.61772 17.9731 6.73242 17.9824C6.97407 18.0021 7.2945 18.0029 7.80078 18.0029H16.2021C16.7084 18.0029 17.0289 18.0022 17.2705 17.9824C17.5002 17.9636 17.5711 17.9325 17.5938 17.9209L17.6943 17.8594C17.7892 17.7903 17.8671 17.6992 17.9209 17.5938L17.9492 17.5098C17.9607 17.4608 17.973 17.3853 17.9824 17.2705C18.0022 17.0289 18.0029 16.7084 18.0029 16.2021V14.627C18.003 14.0748 18.4508 13.627 19.0029 13.627C19.5549 13.6272 20.0028 14.0749 20.0029 14.627V16.2021C20.0029 16.6756 20.0035 17.0917 19.9756 17.4336C19.9503 17.7429 19.8983 18.0595 19.7656 18.3691L19.7031 18.501C19.4724 18.9538 19.1214 19.3334 18.6904 19.5977L18.501 19.7031C18.1495 19.8822 17.7871 19.9467 17.4336 19.9756C17.0917 20.0035 16.6756 20.0029 16.2021 20.0029H7.80078C7.32737 20.0029 6.91129 20.0035 6.56934 19.9756C6.26006 19.9503 5.94337 19.8982 5.63379 19.7656L5.50195 19.7031C5.04919 19.4725 4.67048 19.121 4.40625 18.6904L4.29981 18.501C4.12082 18.1496 4.05626 17.787 4.02734 17.4336C3.99941 17.0917 4 16.6756 4 16.2021V7.80078C4 7.32734 3.99943 6.9113 4.02734 6.56934C4.05624 6.2158 4.12078 5.85346 4.29981 5.50195L4.40625 5.3125C4.67051 4.88167 5.04912 4.53052 5.50195 4.29981L5.63379 4.23828C5.94358 4.10546 6.25984 4.05264 6.56934 4.02734C6.9113 3.99943 7.32734 4 7.80078 4H9.37598L9.47852 4.00488ZM19.1045 4.00488C19.6089 4.05599 20.0029 4.48216 20.0029 5V10.001C20.0024 10.5527 19.5547 11.0007 19.0029 11.001C18.451 11.001 18.0035 10.5528 18.0029 10.001V7.41309L11.707 13.708L11.6309 13.7764C11.2381 14.0963 10.6589 14.0729 10.293 13.707C9.90274 13.3165 9.90271 12.6834 10.293 12.293L16.5879 6H14C13.4479 5.99998 13.0003 5.55205 13 5C13 4.44773 13.4477 4.00002 14 4H19.0029L19.1045 4.00488Z" }) });
});
ExternalLinkIcon.displayName = "ExternalLinkIcon";

const EyeIcon = forwardRef$1(function EyeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.9999 5.5C15.7927 5.50005 19.0438 7.25601 21.284 9.99121C22.2381 11.1563 22.2381 12.8418 21.284 14.0068C19.0438 16.742 15.7927 18.499 11.9999 18.499C8.207 18.499 4.95592 16.742 2.71567 14.0068C1.76144 12.8417 1.76144 11.1563 2.71567 9.99121C4.95593 7.25605 8.20708 5.5 11.9999 5.5ZM11.9999 7.37598C8.80225 7.37598 6.05511 8.84753 4.13462 11.1924C3.75043 11.6617 3.75029 12.3374 4.13462 12.8066C6.0551 15.1515 8.80233 16.6221 11.9999 16.6221C15.1974 16.622 17.9447 15.1515 19.8651 12.8066C20.2494 12.3374 20.2492 11.6617 19.8651 11.1924C17.9447 8.84757 15.1974 7.37602 11.9999 7.37598ZM11.9999 9.21777C13.5108 9.21777 14.7362 10.4633 14.7362 11.999C14.7361 13.5346 13.5108 14.7793 11.9999 14.7793C10.489 14.7792 9.2646 13.5345 9.2645 11.999C9.2645 10.4634 10.489 9.21791 11.9999 9.21777Z" }) });
});
EyeIcon.displayName = "EyeIcon";

const FavoriteIcon = forwardRef$1(function FavoriteIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M12 4.38853C13.6155 3.13955 15.4688 2.76705 17.1652 3.13526C19.0918 3.55351 20.7256 4.90782 21.5039 6.79719C23.1069 10.6889 21.0104 16.2252 12.4889 20.8758C12.1854 21.0414 11.8146 21.0414 11.5111 20.8758C2.9896 16.2252 0.893102 10.6889 2.49608 6.79719C3.27445 4.90782 4.90821 3.55351 6.83476 3.13526C8.53122 2.76706 10.3845 3.13956 12 4.38853ZM16.731 5.03464C15.4938 4.76605 14.0244 5.08044 12.7114 6.37722C12.5236 6.56253 12.2674 6.66702 12 6.66702C11.7326 6.66702 11.4764 6.56254 11.2886 6.37722C9.97554 5.08044 8.50622 4.76605 7.26902 5.03464C6.00713 5.30872 4.8923 6.20846 4.35119 7.52217C3.3364 9.98613 4.25984 14.5167 12 18.9032C19.7401 14.5167 20.6636 9.98613 19.6488 7.52217C19.1077 6.20847 17.9929 5.30872 16.731 5.03464Z" }) });
});
FavoriteIcon.displayName = "FavoriteIcon";

const FavoritedIcon = forwardRef$1(function FavoritedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M12.4886 20.8757C21.0104 16.2252 23.1069 10.6891 21.5039 6.79741C20.7257 4.90785 19.0921 3.55377 17.1654 3.1355C15.4692 2.76724 13.6154 3.13838 12 4.38699C10.3846 3.13838 8.53086 2.76724 6.83457 3.13551C4.90791 3.55378 3.27436 4.90787 2.49607 6.79742C0.893082 10.6892 2.98973 16.2252 11.5114 20.8757C11.815 21.0414 12.1852 21.0414 12.4886 20.8757Z" }) });
});
FavoritedIcon.displayName = "FavoritedIcon";

const FileIcon = forwardRef$1(function FileIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.1719 2C12.9674 2.00007 13.7304 2.31638 14.293 2.87891L19.1211 7.70703C19.6837 8.26959 19.9999 9.03259 20 9.82812V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H12.1719ZM7 4C6.44771 4 6 4.44771 6 5V19C6 19.5523 6.4477 20 7 20H17C17.5523 20 18 19.5523 18 19V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 7C14 7.5523 14.4477 8 15 8H16.5859L14 5.41406V7Z" }) });
});
FileIcon.displayName = "FileIcon";

const FilterIcon = forwardRef$1(function FilterIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.1025 16.0049C13.6067 16.0562 14 16.4823 14 17C14 17.5177 13.6067 17.9438 13.1025 17.9951L13 18H11C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16H13L13.1025 16.0049ZM16.1025 11.0049C16.6067 11.0562 17 11.4823 17 12C17 12.5177 16.6067 12.9438 16.1025 12.9951L16 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H16L16.1025 11.0049ZM19 6C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7C4 6.44772 4.44772 6 5 6H19Z" }) });
});
FilterIcon.displayName = "FilterIcon";

const FlagIcon = forwardRef$1(function FlagIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.0879 1.33333C13.1526 1.3335 13.7879 2.52023 13.1973 3.40625L11.4681 6L13.1973 8.59375C13.7879 9.47979 13.1526 10.6665 12.0879 10.6667H3.33333V14C3.33333 14.3682 3.03486 14.6667 2.66667 14.6667C2.29848 14.6667 2 14.3682 2 14V2.66667C2 1.93029 2.59696 1.33333 3.33333 1.33333H12.0879ZM3.33333 9.33333H12.0879L10.3587 6.73958C10.0602 6.29173 10.0602 5.70826 10.3587 5.26042L12.0879 2.66667H3.33333V9.33333Z" }) });
});
FlagIcon.displayName = "FlagIcon";

const FlipHorizontallyIcon = forwardRef$1(function FlipHorizontallyIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M9.77539 12.6309C10.0957 12.2381 10.0731 11.6591 9.70703 11.293L7.20703 8.79297C6.81651 8.40244 6.18349 8.40244 5.79297 8.79297C5.40244 9.18349 5.40244 9.81651 5.79297 10.207L7.58594 12L5.79297 13.793C5.40244 14.1835 5.40244 14.8165 5.79297 15.207C6.18349 15.5976 6.81651 15.5976 7.20703 15.207L9.70703 12.707L9.77539 12.6309Z" }), jsx("path", { fill: "currentColor", d: "M18.207 10.207C18.5976 9.81651 18.5976 9.18349 18.207 8.79297C17.8165 8.40244 17.1835 8.40244 16.793 8.79297L14.293 11.293C13.9024 11.6835 13.9024 12.3165 14.293 12.707L16.793 15.207C17.1835 15.5976 17.8165 15.5976 18.207 15.207C18.5976 14.8165 18.5976 14.1835 18.207 13.793L16.4141 12L18.207 10.207Z" }), jsx("path", { fill: "currentColor", d: "M3 13L8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11L3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z" }), jsx("path", { fill: "currentColor", d: "M16 13L21 13C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11L16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13Z" }), jsx("path", { fill: "currentColor", d: "M11 3C11 2.44771 11.4477 2 12 2C12.5523 2 13 2.44771 13 3L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 3Z" })] });
});
FlipHorizontallyIcon.displayName = "FlipHorizontallyIcon";

const FlipVerticallyIcon = forwardRef$1(function FlipVerticallyIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M11.3691 9.77539C11.7619 10.0957 12.3409 10.0731 12.707 9.70703L15.207 7.20703C15.5976 6.81651 15.5976 6.18349 15.207 5.79297C14.8165 5.40244 14.1835 5.40244 13.793 5.79297L12 7.58594L10.207 5.79297C9.81651 5.40244 9.18349 5.40244 8.79297 5.79297C8.40244 6.18349 8.40244 6.81651 8.79297 7.20703L11.293 9.70703L11.3691 9.77539Z" }), jsx("path", { fill: "currentColor", d: "M13.793 18.207C14.1835 18.5976 14.8165 18.5976 15.207 18.207C15.5976 17.8165 15.5976 17.1835 15.207 16.793L12.707 14.293C12.3165 13.9024 11.6835 13.9024 11.293 14.293L8.79297 16.793C8.40244 17.1835 8.40244 17.8165 8.79297 18.207C9.18349 18.5976 9.81651 18.5976 10.207 18.207L12 16.4141L13.793 18.207Z" }), jsx("path", { fill: "currentColor", d: "M11 3V8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3Z" }), jsx("path", { fill: "currentColor", d: "M11 16V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16Z" }), jsx("path", { fill: "currentColor", d: "M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L3 13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11L21 11Z" })] });
});
FlipVerticallyIcon.displayName = "FlipVerticallyIcon";

const FlowsIcon = forwardRef$1(function FlowsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M17.293 3.29304C17.6835 2.90252 18.3165 2.90252 18.707 3.29304L20.707 5.29304C21.0975 5.68357 21.0975 6.31659 20.707 6.70711L18.707 8.70711C18.3165 9.09758 17.6835 9.09758 17.293 8.70711C16.9025 8.3166 16.9025 7.68357 17.293 7.29304L17.5859 7.00008H14C13.4477 7.00008 13 7.44778 13 8.00008V16.0001C13 17.6569 11.6569 19.0001 10 19.0001H8.82617C8.41404 20.1647 7.30583 21.0001 6 21.0001C4.34317 21.0001 3.00004 19.6569 3 18.0001C3 16.3432 4.34315 15.0001 6 15.0001C7.30588 15.0001 8.41408 15.8354 8.82617 17.0001H10C10.5523 17.0001 11 16.5524 11 16.0001V8.00008C11 6.34323 12.3431 5.00008 14 5.00008H17.5859L17.293 4.70711C16.9025 4.31659 16.9025 3.68357 17.293 3.29304ZM6 17.0001C5.44772 17.0001 5 17.4478 5 18.0001C5.00004 18.5523 5.44774 19.0001 6 19.0001C6.55226 19.0001 6.99996 18.5523 7 18.0001C7 17.4478 6.55228 17.0001 6 17.0001Z" }), jsx("path", { fill: "currentColor", d: "M19.043 15.543C19.4335 15.1525 20.0665 15.1525 20.457 15.543C20.8475 15.9336 20.8475 16.5666 20.457 16.9571L19.4141 18.0001L20.457 19.043C20.8475 19.4336 20.8475 20.0666 20.457 20.4571C20.0665 20.8476 19.4335 20.8476 19.043 20.4571L18 19.4141L16.957 20.4571C16.5665 20.8476 15.9335 20.8476 15.543 20.4571C15.1525 20.0666 15.1525 19.4336 15.543 19.043L16.5859 18.0001L15.543 16.9571C15.1525 16.5666 15.1525 15.9336 15.543 15.543C15.9335 15.1525 16.5665 15.1525 16.957 15.543L18 16.586L19.043 15.543Z" }), jsx("path", { fill: "currentColor", d: "M7.04297 3.54304C7.43349 3.15252 8.06651 3.15252 8.45703 3.54304C8.84752 3.93357 8.84754 4.5666 8.45703 4.95711L7.41406 6.00008L8.45703 7.04304C8.84752 7.43357 8.84754 8.0666 8.45703 8.45711C8.06652 8.84758 7.43348 8.84758 7.04297 8.45711L6 7.41414L4.95703 8.45711C4.56652 8.84758 3.93348 8.84758 3.54297 8.45711C3.15246 8.0666 3.15248 7.43357 3.54297 7.04304L4.58594 6.00008L3.54297 4.95711C3.15246 4.56659 3.15248 3.93357 3.54297 3.54304C3.93349 3.15252 4.56651 3.15252 4.95703 3.54304L6 4.58601L7.04297 3.54304Z" })] });
});
FlowsIcon.displayName = "FlowsIcon";

const FocusIcon = forwardRef$1(function FocusIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 15C4.55228 15 5 15.4477 5 16V17C5 18.1046 5.89542 19 7 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H7C4.79088 21 3 19.2092 3 17V16C3 15.4477 3.44772 15 4 15ZM20 15C20.5523 15 21 15.4477 21 16V17C21 19.2092 19.2092 21 17 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17C18.1046 19 19 18.1046 19 17V16C19 15.4477 19.4477 15 20 15ZM13 8C14.6569 8 16 9.34315 16 11V13C16 14.6569 14.6569 16 13 16H11C9.34315 16 8 14.6569 8 13V11C8 9.34315 9.34315 8 11 8H13ZM11 10C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10H11ZM8 3C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H7C5.89543 5 5 5.89543 5 7V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V7C3 4.79087 4.79087 3 7 3H8ZM17 3C19.2092 3 21 4.79088 21 7V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V7C19 5.89542 18.1046 5 17 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H17Z" }) });
});
FocusIcon.displayName = "FocusIcon";

const FolderAddIcon = forwardRef$1(function FolderAddIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M18 13C18.5523 13 19 13.4477 19 14V16H21C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H19V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20V18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H17V14C17 13.4477 17.4477 13 18 13Z" }), jsx("path", { d: "M8.92969 3C9.93272 3.00002 10.8694 3.50132 11.4258 4.33594L12.2383 5.55469L12.3135 5.65332C12.502 5.87181 12.7776 5.99997 13.0703 6H19C20.6569 6 22 7.34315 22 9V10C22 10.5523 21.5523 11 21 11C20.4477 11 20 10.5523 20 10V9C20 8.4477 19.5523 8 19 8H13.0703C12.0673 7.99997 11.1306 7.49869 10.5742 6.66406L9.76172 5.44531C9.5763 5.16717 9.26403 5.00002 8.92969 5H5C4.44771 5 4 5.44771 4 6V17C4 17.5523 4.44771 18 5 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H5C3.34315 20 2 18.6569 2 17V6C2 4.34315 3.34315 3 5 3H8.92969Z" })] });
});
FolderAddIcon.displayName = "FolderAddIcon";

const FolderMoveIcon = forwardRef$1(function FolderMoveIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M18.293 13.293C18.6835 12.9024 19.3165 12.9024 19.707 13.293L22.707 16.293C23.0976 16.6835 23.0976 17.3165 22.707 17.707L19.707 20.707C19.3165 21.0976 18.6835 21.0976 18.293 20.707C17.9024 20.3165 17.9024 19.6835 18.293 19.293L19.5859 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H19.5859L18.293 14.707C17.9024 14.3165 17.9024 13.6835 18.293 13.293Z" }), jsx("path", { d: "M8.92969 3C9.93272 3.00002 10.8694 3.50132 11.4258 4.33594L12.2383 5.55469L12.3135 5.65332C12.502 5.87181 12.7776 5.99997 13.0703 6H19C20.6569 6 22 7.34315 22 9V10C22 10.5523 21.5523 11 21 11C20.4477 11 20 10.5523 20 10V9C20 8.4477 19.5523 8 19 8H13.0703C12.0673 7.99997 11.1306 7.49869 10.5742 6.66406L9.76172 5.44531C9.5763 5.16717 9.26403 5.00002 8.92969 5H5C4.44771 5 4 5.44771 4 6V17C4 17.5523 4.44771 18 5 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H5C3.34315 20 2 18.6569 2 17V6C2 4.34315 3.34315 3 5 3H8.92969Z" })] });
});
FolderMoveIcon.displayName = "FolderMoveIcon";

const FolderOpenIcon = forwardRef$1(function FolderOpenIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.92969 3C9.93272 3.00002 10.8694 3.50132 11.4258 4.33594L12.5352 6H18C19.6569 6 21 7.34315 21 9V10.0352C22.1535 10.2431 22.9143 11.4269 22.5488 12.5967L20.8936 17.8945C20.5022 19.1471 19.3415 20 18.0293 20H4.44043C4.43554 20 4.43066 19.9991 4.42578 19.999C4.39548 19.9986 4.36553 19.9972 4.33594 19.9941C3.03673 19.9392 2.00019 18.8722 2 17.5596V6C2 4.34315 3.34315 3 5 3H8.92969ZM9.4707 12C9.03344 12.0001 8.64702 12.2848 8.5166 12.7021L6.86133 18H18.0293C18.4667 18 18.8539 17.7153 18.9844 17.2979L20.6396 12H9.4707ZM5 5C4.44771 5 4 5.44771 4 6V17.5596C4.0002 17.8027 4.19732 17.9998 4.44043 18C4.63324 18 4.80481 17.8744 4.8623 17.6904L6.60742 12.1055C6.99878 10.8532 8.15868 10.0001 9.4707 10H19V9C19 8.4477 18.5523 8 18 8H12.5352C11.9081 7.99999 11.32 7.70617 10.9434 7.21094L10.8711 7.10938L9.76172 5.44531C9.5763 5.16717 9.26403 5.00002 8.92969 5H5Z" }) });
});
FolderOpenIcon.displayName = "FolderOpenIcon";

const FolderRemoveIcon = forwardRef$1(function FolderRemoveIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M19.4141 14.1719C19.8046 13.7814 20.4376 13.7814 20.8281 14.1719C21.2186 14.5624 21.2186 15.1954 20.8281 15.5859L19.4141 17L20.8281 18.4141C21.2186 18.8046 21.2186 19.4376 20.8281 19.8281C20.4376 20.2186 19.8046 20.2186 19.4141 19.8281L18 18.4141L16.5859 19.8281C16.1954 20.2186 15.5624 20.2186 15.1719 19.8281C14.7814 19.4376 14.7814 18.8046 15.1719 18.4141L16.5859 17L15.1719 15.5859C14.7814 15.1954 14.7814 14.5624 15.1719 14.1719C15.5624 13.7814 16.1954 13.7814 16.5859 14.1719L18 15.5859L19.4141 14.1719Z" }), jsx("path", { d: "M8.92969 3C9.93272 3.00002 10.8694 3.50132 11.4258 4.33594L12.2383 5.55469L12.3135 5.65332C12.502 5.87181 12.7776 5.99997 13.0703 6H19C20.6569 6 22 7.34315 22 9V10C22 10.5523 21.5523 11 21 11C20.4477 11 20 10.5523 20 10V9C20 8.4477 19.5523 8 19 8H13.0703C12.0673 7.99997 11.1306 7.49869 10.5742 6.66406L9.76172 5.44531C9.5763 5.16717 9.26403 5.00002 8.92969 5H5C4.44771 5 4 5.44771 4 6V17C4 17.5523 4.44771 18 5 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H5C3.34315 20 2 18.6569 2 17V6C2 4.34315 3.34315 3 5 3H8.92969Z" })] });
});
FolderRemoveIcon.displayName = "FolderRemoveIcon";

const FolderIcon = forwardRef$1(function FolderIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.17188 3C9.96743 3.00008 10.7304 3.31639 11.293 3.87891L12.1211 4.70703L12.1943 4.77344C12.3723 4.91932 12.5961 4.99994 12.8281 5H19C20.6569 5 22 6.34315 22 8V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V6C2 4.34315 3.34315 3 5 3H9.17188ZM5 11C4.4477 11 4 11.4477 4 12V17C4 17.5523 4.4477 18 5 18H19C19.5523 18 20 17.5523 20 17V12C20 11.4477 19.5523 11 19 11H5ZM5 5C4.44771 5 4 5.44771 4 6V9.17383C4.31306 9.06306 4.649 9 5 9H19C19.351 9 19.6869 9.06306 20 9.17383V8C20 7.4477 19.5523 7 19 7H12.8281C12.1319 6.99994 11.4606 6.75784 10.9268 6.32031L10.707 6.12109L9.87891 5.29297C9.6914 5.10547 9.43698 5.00008 9.17188 5H5Z" }) });
});
FolderIcon.displayName = "FolderIcon";

const FoldersIcon = forwardRef$1(function FoldersIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1719 3C11.9674 3.00007 12.7304 3.31638 13.293 3.87891L14.4141 5H20C21.6569 5 23 6.34315 23 8V14C23 15.6569 21.6569 17 20 17H19V18C19 19.6569 17.6569 21 16 21H4C2.34315 21 1 19.6569 1 18V10C1 8.34315 2.34315 7 4 7H5V6C5 4.34315 6.34315 3 8 3H11.1719ZM4 9C3.44771 9 3 9.44771 3 10V18C3 18.5523 3.44771 19 4 19H16C16.5523 19 17 18.5523 17 18V12C17 11.4477 16.5523 11 16 11H10.4141C9.88369 11 9.37503 10.7891 9 10.4141L7.87891 9.29297C7.69143 9.1055 7.43699 9.00008 7.17188 9H4ZM8 5C7.44771 5 7 5.44771 7 6V7H7.17188C7.96742 7.00008 8.73042 7.31636 9.29297 7.87891L10.4141 9H16C17.6569 9 19 10.3431 19 12V15H20C20.5523 15 21 14.5523 21 14V8C21 7.44771 20.5523 7 20 7H14.4141C13.8837 6.99996 13.3751 6.78919 13 6.41406L11.8789 5.29297C11.6914 5.10546 11.4369 5.00007 11.1719 5H8Z" }) });
});
FoldersIcon.displayName = "FoldersIcon";

const FrameStackIcon = forwardRef$1(function FrameStackIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10 6.30404C10 4.98903 11.2474 4.03116 12.5176 4.37142L19.8477 6.33627C20.722 6.57058 21.3301 7.36273 21.3301 8.26791V13.6966C21.33 15.0116 20.0827 15.9695 18.8125 15.6292L17.8301 15.3656V16.7054C17.83 18.015 16.5923 18.9715 15.3252 18.641L13.8301 18.2503V19.1966C13.83 20.5115 12.5826 21.4695 11.3125 21.1292L3.98242 19.1644C3.10814 18.9301 2.50007 18.1379 2.5 17.2328V11.804C2.5 10.489 3.74738 9.53116 5.01758 9.87142L6.5 10.2679V9.30404C6.5 7.98903 7.74738 7.03116 9.01758 7.37142L10 7.63412V6.30404ZM4.5 17.2328L11.8301 19.1966V13.7679L4.5 11.804V17.2328ZM8.5 10.804L12.3477 11.8363C13.222 12.0706 13.8301 12.8627 13.8301 13.7679V16.1829L15.8301 16.7054V11.2679L8.5 9.30404V10.804ZM12 8.17025L16.3477 9.33627C17.222 9.57058 17.8301 10.3627 17.8301 11.2679V13.2943L19.3301 13.6966V8.26791L12 6.30404V8.17025Z" }) });
});
FrameStackIcon.displayName = "FrameStackIcon";

const FrameIcon = forwardRef$1(function FrameIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 15C4.55228 15 5 15.4477 5 16V17C5 18.1046 5.89542 19 7 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H7C4.79088 21 3 19.2092 3 17V16C3 15.4477 3.44772 15 4 15ZM20 15C20.5523 15 21 15.4477 21 16V17C21 19.2092 19.2092 21 17 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17C18.1046 19 19 18.1046 19 17V16C19 15.4477 19.4477 15 20 15ZM8 3C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H7C5.89543 5 5 5.89543 5 7V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V7C3 4.79087 4.79087 3 7 3H8ZM17 3C19.2092 3 21 4.79088 21 7V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V7C19 5.89542 18.1046 5 17 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H17Z" }) });
});
FrameIcon.displayName = "FrameIcon";

const FunctionIcon = forwardRef$1(function FunctionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7.91016 6C8.46236 6.00007 8.91011 6.4478 8.91016 7C8.91016 7.51764 8.51678 7.94374 8.0127 7.99512L7.82812 8.00391C7.44717 8.03902 7.11243 8.31626 7.00977 8.7168L6.99121 8.80469L6.83691 9.74805H7.50098L7.60352 9.75293C8.10752 9.80429 8.50084 10.2305 8.50098 10.748C8.50098 11.2657 8.10758 11.6918 7.60352 11.7432L7.50098 11.748H6.50879L5.89258 15.5137C5.66006 16.9325 4.44692 17.9951 3 17.9951C2.4478 17.9951 2.00013 17.5473 2 16.9951C2.00004 16.4775 2.39337 16.0513 2.89746 16L3.08203 15.9912C3.49019 15.9536 3.84553 15.6378 3.91895 15.1904L4.48242 11.748H4.22754C3.67525 11.748 3.22754 11.3003 3.22754 10.748C3.22768 10.1959 3.67534 9.74805 4.22754 9.74805H4.81055L5.01758 8.48145L5.07227 8.21973C5.40238 6.93385 6.55359 6.00001 7.91016 6ZM10.249 7.47754C10.4453 6.96154 11.0229 6.70238 11.5391 6.89844C12.055 7.09474 12.3142 7.67237 12.1182 8.18848C11.1768 10.6669 11.1187 12.8704 11.9424 15.3145L12.1182 15.8066L12.1504 15.9043C12.2815 16.3937 12.0227 16.9127 11.5391 17.0967C11.0552 17.2805 10.5171 17.0642 10.29 16.6113L10.249 16.5176L10.042 15.9385C9.07565 13.0601 9.14462 10.3851 10.249 7.47754ZM19.8301 6.89844C20.314 6.71464 20.8521 6.93083 21.0791 7.38379L21.1201 7.47754L21.3271 8.05664C22.2935 10.935 22.2245 13.6101 21.1201 16.5176C20.9238 17.0336 20.3462 17.2927 19.8301 17.0967C19.3141 16.9004 19.0549 16.3228 19.251 15.8066C20.1923 13.3282 20.2504 11.1247 19.4268 8.68066L19.251 8.18848L19.2188 8.09082C19.0876 7.60138 19.3463 7.08243 19.8301 6.89844ZM14.834 14.6973C14.4927 15.1314 13.8639 15.2074 13.4297 14.8662C12.9956 14.5249 12.9206 13.8961 13.2617 13.4619L14.834 14.6973ZM16.6025 9.21973C16.9544 8.85515 17.5325 8.80905 17.9395 9.12891C18.3463 9.44879 18.438 10.0212 18.167 10.4492L18.1074 10.5332L16.9561 11.9971L18.1074 13.4619L18.167 13.5449C18.4383 13.973 18.3465 14.5462 17.9395 14.8662C17.5053 15.2074 16.8764 15.1314 16.5352 14.6973L15.6846 13.6152L14.834 14.6973L14.0479 14.0791L13.2617 13.4619L14.4121 11.9971L13.2617 10.5332L13.2021 10.4492C12.9311 10.0212 13.0229 9.44879 13.4297 9.12891C13.8367 8.80906 14.4147 8.85516 14.7666 9.21973L14.834 9.29688L15.6846 10.3789L16.5352 9.29688L16.6025 9.21973Z" }) });
});
FunctionIcon.displayName = "FunctionIcon";

const FunnelIcon = forwardRef$1(function FunnelIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.2539 3.5C18.7769 3.50039 20.0038 4.74002 20.0039 6.25879V7.28809C20.0039 7.92675 19.7831 8.54423 19.3828 9.03516L19.2002 9.2373L14.9746 13.4824C14.8334 13.6242 14.753 13.8181 14.7529 14.0205V17.958C14.7529 18.6895 14.329 19.3535 13.6719 19.6611L13.5371 19.7178L11.7871 20.377C10.5546 20.8413 9.25211 19.9238 9.25195 18.6182V14.0205C9.25187 13.8689 9.20689 13.7222 9.125 13.5986L9.03027 13.4824L4.80469 9.2373C4.28952 8.71965 4.00098 8.01811 4.00098 7.28809V6.25879C4.00109 4.7399 5.22789 3.50021 6.75098 3.5H17.2539ZM6.75098 5.5C6.34113 5.50021 6.00109 5.83577 6.00098 6.25879V7.28809C6.00098 7.49071 6.08144 7.68428 6.22266 7.82617L10.4482 12.0723L10.6309 12.2744C11.0311 12.7652 11.2519 13.3819 11.252 14.0205V18.4404L12.7529 17.875V14.0205C12.753 13.2907 13.0416 12.5898 13.5566 12.0723L17.7822 7.82617L17.877 7.71094C17.9589 7.5873 18.0039 7.43986 18.0039 7.28809V6.25879C18.0038 5.83588 17.6636 5.50039 17.2539 5.5H6.75098Z" }) });
});
FunnelIcon.displayName = "FunnelIcon";

const GalleryIcon = forwardRef$1(function GalleryIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M10 3C10.5523 3 11 3.44772 11 4V8C11 8.55229 10.5523 9 10 9H4C3.44772 9 3 8.55229 3 8V7.2002C3 6.65665 2.99893 6.18836 3.03028 5.80469C3.06259 5.40943 3.1344 5.016 3.32715 4.6377C3.61472 4.07347 4.07347 3.61472 4.6377 3.32715C5.016 3.1344 5.40943 3.06259 5.80469 3.03028C6.18836 2.99893 6.65665 3 7.2002 3H10ZM7.2002 5C6.62365 5 6.25112 5.00127 5.96778 5.02442C5.69619 5.04662 5.59534 5.08419 5.5459 5.10938C5.35793 5.20521 5.20521 5.35793 5.10938 5.5459C5.08419 5.59534 5.04662 5.69619 5.02442 5.96778C5.00406 6.21692 5.00142 6.5349 5.00098 7H9V5H7.2002Z", fill: "currentColor" }), jsx("path", { d: "M20 15C20.5523 15 21 15.4477 21 16V16.7998C21 17.3434 21.0011 17.8116 20.9697 18.1953C20.9374 18.5906 20.8656 18.984 20.6729 19.3623C20.3853 19.9265 19.9265 20.3853 19.3623 20.6729C18.984 20.8656 18.5906 20.9374 18.1953 20.9697C17.8116 21.0011 17.3434 21 16.7998 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 13.4477 15 14 15H20ZM15 19H16.7998C17.3764 19 17.7489 18.9987 18.0322 18.9756C18.3038 18.9534 18.4047 18.9158 18.4541 18.8906C18.6421 18.7948 18.7948 18.6421 18.8906 18.4541C18.9158 18.4047 18.9534 18.3038 18.9756 18.0322C18.9959 17.7831 18.9986 17.4651 18.999 17H15V19Z", fill: "currentColor" }), jsx("path", { d: "M10 11C10.5523 11 11 11.4477 11 12V20C11 20.5523 10.5523 21 10 21H7.2002C6.65665 21 6.18837 21.0011 5.80469 20.9697C5.40943 20.9374 5.016 20.8656 4.6377 20.6729C4.07339 20.3853 3.61468 19.9264 3.32715 19.3623C3.13438 18.984 3.06259 18.5906 3.03028 18.1953C2.99893 17.8116 3 17.3434 3 16.7998V12C3 11.4477 3.44772 11 4 11H10ZM5 16.7998C5 17.3764 5.00127 17.7489 5.02442 18.0322C5.04662 18.3039 5.0842 18.4047 5.10938 18.4541C5.20525 18.6421 5.35799 18.7949 5.5459 18.8906C5.59533 18.9158 5.6962 18.9534 5.96778 18.9756C6.25111 18.9987 6.62365 19 7.2002 19H9V13H5V16.7998Z", fill: "currentColor" }), jsx("path", { d: "M19 7.2002C19 6.62365 18.9987 6.25111 18.9756 5.96778C18.9534 5.6962 18.9158 5.59533 18.8906 5.5459C18.7949 5.35799 18.6421 5.20525 18.4541 5.10938C18.4047 5.0842 18.3039 5.04662 18.0322 5.02442C17.7489 5.00127 17.3764 5 16.7998 5H15V11H19V7.2002ZM21 12C21 12.5523 20.5523 13 20 13H14C13.4477 13 13 12.5523 13 12V4C13 3.44772 13.4477 3 14 3H16.7998C17.3434 3 17.8116 2.99893 18.1953 3.03028C18.5906 3.06259 18.984 3.13438 19.3623 3.32715C19.9264 3.61468 20.3853 4.07339 20.6729 4.6377C20.8656 5.016 20.9374 5.40943 20.9697 5.80469C21.0011 6.18837 21 6.65665 21 7.2002V12Z", fill: "currentColor" })] });
});
GalleryIcon.displayName = "GalleryIcon";

const GlobeIcon = forwardRef$1(function GlobeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.5137 2.0127C17.7965 2.28071 21.997 6.64969 21.9971 11.999C21.9969 17.4661 17.6093 21.9044 12.1631 21.9922C12.109 21.9953 12.0541 21.9971 11.999 21.9971L11.8359 21.9932L11.834 21.9922C6.38816 21.904 2.00018 17.4659 2 11.999C2.00008 6.47711 6.47714 2.00021 11.999 2L12.5137 2.0127ZM9.02539 12.999C9.1271 14.9649 9.5237 16.6931 10.085 17.9561C10.4126 18.6931 10.7769 19.2283 11.1309 19.5654C11.4798 19.8975 11.7723 19.997 11.999 19.9971C12.2258 19.997 12.5173 19.8975 12.8662 19.5654C13.2204 19.2283 13.5853 18.6935 13.9131 17.9561C14.4744 16.6931 14.87 14.965 14.9717 12.999H9.02539ZM16.9746 12.999C16.8714 15.2025 16.4298 17.2159 15.7402 18.7676C15.6801 18.9028 15.6165 19.0351 15.5518 19.165C17.9019 17.9976 19.5943 15.7095 19.9326 12.999H16.9746ZM4.06445 12.999C4.40264 15.7089 6.09512 17.9964 8.44434 19.1641C8.37982 19.0347 8.3167 18.9023 8.25684 18.7676C7.56732 17.216 7.12563 15.2023 7.02246 12.999H4.06445ZM8.44434 4.83301C6.09483 6.00077 4.40249 8.28887 4.06445 10.999H7.02246C7.1256 8.79528 7.56714 6.78131 8.25684 5.22949C8.31677 5.09464 8.37974 4.96256 8.44434 4.83301ZM11.999 4C11.7723 4.00011 11.4798 4.09954 11.1309 4.43164C10.7767 4.76886 10.4128 5.30444 10.085 6.04199C9.52359 7.30508 9.12706 9.03279 9.02539 10.999H14.9717C14.87 9.03293 14.4744 7.30505 13.9131 6.04199C13.5852 5.30438 13.2204 4.76881 12.8662 4.43164C12.5173 4.09972 12.2257 4.0001 11.999 4ZM15.7402 5.22949C16.4299 6.7813 16.8715 8.79529 16.9746 10.999H19.9326C19.5945 8.28828 17.9021 5.99952 15.5518 4.83203C15.6165 4.96189 15.6801 5.09431 15.7402 5.22949Z" }) });
});
GlobeIcon.displayName = "GlobeIcon";

const HeatmapIcon = forwardRef$1(function HeatmapIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5.5 16C6.88067 16 8 17.1193 8 18.5C8 19.8807 6.88067 21 5.5 21C4.11933 21 3 19.8807 3 18.5C3 17.1193 4.11933 16 5.5 16ZM12 17C12.8284 17 13.5 17.6716 13.5 18.5C13.5 19.3284 12.8284 20 12 20C11.1716 20 10.5 19.3284 10.5 18.5C10.5 17.6716 11.1716 17 12 17ZM5.5 18C5.22387 18 5 18.2239 5 18.5C5 18.7761 5.22387 19 5.5 19C5.77613 19 6 18.7761 6 18.5C6 18.2239 5.77613 18 5.5 18ZM5.5 9.5C6.88067 9.5 8 10.6193 8 12C8 13.3807 6.88067 14.5 5.5 14.5C4.11933 14.5 3 13.3807 3 12C3 10.6193 4.11933 9.5 5.5 9.5ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5ZM18.5 10.5C19.3284 10.5 20 11.1716 20 12C20 12.8284 19.3284 13.5 18.5 13.5C17.6716 13.5 17 12.8284 17 12C17 11.1716 17.6716 10.5 18.5 10.5ZM5.5 11.5C5.22387 11.5 5 11.7239 5 12C5 12.2761 5.22387 12.5 5.5 12.5C5.77613 12.5 6 12.2761 6 12C6 11.7239 5.77613 11.5 5.5 11.5ZM12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5ZM18.5 3C19.8807 3 21 4.11927 21 5.5C21 6.88073 19.8807 8 18.5 8C17.1193 8 16 6.88073 16 5.5C16 4.11927 17.1193 3 18.5 3ZM12 4C12.8283 4 13.5 4.67152 13.5 5.5C13.5 6.32848 12.8283 7 12 7C11.1717 7 10.5 6.32848 10.5 5.5C10.5 4.67152 11.1717 4 12 4ZM18.5 5C18.2239 5 18 5.22387 18 5.5C18 5.77613 18.2239 6 18.5 6C18.7761 6 19 5.77613 19 5.5C19 5.22387 18.7761 5 18.5 5Z" }) });
});
HeatmapIcon.displayName = "HeatmapIcon";

const HideIcon = forwardRef$1(function HideIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.2744 10.3115C19.6544 9.91107 20.2878 9.89452 20.6884 10.2744C21.089 10.6545 21.1055 11.2878 20.7256 11.6885C19.5447 12.9337 18.2286 13.8932 16.8369 14.5586L17.8535 16.2266L17.9023 16.3164C18.121 16.7736 17.9625 17.3311 17.5205 17.6006C17.0784 17.8699 16.5102 17.7554 16.2041 17.3516L16.1465 17.2676L14.9316 15.2735C14.2956 15.4494 13.6501 15.5671 13 15.627V18.0049C12.9996 18.5569 12.552 19.0049 12 19.0049C11.4479 19.0049 11.0004 18.5569 11 18.0049V15.625C10.35 15.5651 9.70519 15.4464 9.0693 15.2705L7.85348 17.2676C7.56598 17.7387 6.95088 17.8878 6.47946 17.6006C6.00805 17.3132 5.85921 16.6981 6.14645 16.2266L7.16403 14.5557C5.86419 13.9341 4.62907 13.0586 3.50973 11.9307L3.27438 11.6885L3.20797 11.6104C2.89816 11.2093 2.93597 10.6307 3.31149 10.2744C3.68715 9.91826 4.26722 9.91071 4.65133 10.2412L4.72555 10.3115L5.13376 10.7237C7.20066 12.7142 9.62048 13.6738 12 13.6738C14.538 13.6738 17.1218 12.5815 19.2744 10.3115Z" }) });
});
HideIcon.displayName = "HideIcon";

const HistoryIcon = forwardRef$1(function HistoryIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { d: "M12 7C12.5523 7 13 7.44772 13 8V11.5859L15.207 13.793L15.2754 13.8691C15.5957 14.2619 15.5731 14.8409 15.207 15.207C14.8409 15.5731 14.2619 15.5957 13.8691 15.2754L13.793 15.207L11.293 12.707C11.1054 12.5195 11 12.2652 11 12V8C11 7.44772 11.4477 7 12 7Z" }), jsx("path", { d: "M13.0566 19.7607C13.6737 19.7608 14.1738 20.2609 14.1738 20.8779C14.1738 21.4949 13.6736 21.995 13.0566 21.9951C12.4396 21.9951 11.9395 21.495 11.9395 20.8779C11.9395 20.2608 12.4395 19.7607 13.0566 19.7607Z" }), jsx("path", { d: "M11.9385 2C13.0898 2 14.1979 2.19627 15.2285 2.55762L15.666 2.72266L15.7588 2.76562C16.207 3.00224 16.4119 3.54549 16.2178 4.02539C16.0234 4.50525 15.4983 4.75228 15.0117 4.61035L14.915 4.57715L14.5674 4.44531C13.7459 4.15722 12.8611 4 11.9385 4C7.55459 4.00034 4.00034 7.55459 4 11.9385C4 14.7145 5.42559 17.1594 7.58691 18.5791V15.291C7.58693 14.7389 8.03486 14.2913 8.58691 14.291C9.13907 14.2912 9.58689 14.7388 9.58691 15.291V20.8779C9.58677 21.43 9.13899 21.8778 8.58691 21.8779H3C2.44802 21.8777 2.00014 21.4299 2 20.8779C2.00002 20.3258 2.44794 19.8782 3 19.8779H5.96094C3.55696 18.0647 2 15.1841 2 11.9385C2.00034 6.45002 6.45002 2.00034 11.9385 2Z" }), jsx("path", { d: "M16.8193 18.1533C17.3537 17.845 18.0372 18.0281 18.3457 18.5625C18.6543 19.0969 18.4709 19.7804 17.9365 20.0889C17.4021 20.3974 16.7187 20.2141 16.4102 19.6797C16.1017 19.1453 16.285 18.4619 16.8193 18.1533Z" }), jsx("path", { d: "M19.2725 14.8818C19.581 14.3477 20.2645 14.1645 20.7988 14.4727C21.3331 14.7812 21.5162 15.4647 21.208 15.999C20.8994 16.5334 20.2161 16.7167 19.6816 16.4082C19.1473 16.0996 18.964 15.4162 19.2725 14.8818Z" }), jsx("path", { d: "M20.8779 9.7041C21.495 9.70415 21.9951 10.2052 21.9951 10.8223C21.9949 11.4392 21.4949 11.9394 20.8779 11.9395C20.261 11.9395 19.761 11.4392 19.7607 10.8223C19.7607 10.2052 20.2608 9.7041 20.8779 9.7041Z" }), jsx("path", { d: "M18.5615 5.53418C19.0959 5.22579 19.7793 5.40903 20.0879 5.94336C20.3964 6.47777 20.2131 7.16119 19.6787 7.46973C19.1444 7.77822 18.4609 7.59494 18.1523 7.06055C17.844 6.52616 18.0273 5.84267 18.5615 5.53418Z" })] });
});
HistoryIcon.displayName = "HistoryIcon";

const HouseholdIcon = forwardRef$1(function HouseholdIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 8.508a3 3 0 1 1 0 5.999 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 1.999 1 1 0 0 0 0-2Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.315 3.516a3.001 3.001 0 0 1 3.37 0l6 4.07A2.999 2.999 0 0 1 21 10.067v7.935A3 3 0 0 1 17.998 21H6.002A3.001 3.001 0 0 1 3 18v-7.934c0-.994.493-1.923 1.315-2.481l6-4.07Zm2.247 1.656a1 1 0 0 0-1.123 0l-6 4.07a.999.999 0 0 0-.439.825v7.935c0 .55.448.999 1.002.999h1.099a5 5 0 0 1 9.798 0h1.099c.554 0 1.002-.45 1.002-1v-7.934c0-.33-.164-.64-.439-.826l-6-4.07ZM12 17.002a2.998 2.998 0 0 0-2.825 1.999h5.65A2.998 2.998 0 0 0 12 17.003Z", clipRule: "evenodd" })] });
});
HouseholdIcon.displayName = "HouseholdIcon";

const IconBubbleCheckIcon = forwardRef$1(function IconBubbleCheckIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M14.043 8.54297C14.4335 8.15254 15.0665 8.15248 15.457 8.54297C15.8474 8.93347 15.8474 9.56653 15.457 9.95703L11.957 13.457C11.5665 13.8475 10.9335 13.8475 10.543 13.457L9.04297 11.957C8.65244 11.5665 8.65245 10.9335 9.04297 10.543C9.4335 10.1526 10.0665 10.1525 10.457 10.543L11.25 11.3359L14.043 8.54297Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.1562 3.00391C19.7414 3.08424 21.002 4.39486 21.002 6V16.0361C21.0018 17.6928 19.6585 19.036 18.002 19.0361H15.376L12.6357 21.3057C12.264 21.6137 11.7254 21.6119 11.3555 21.3018L8.65137 19.0361H6.00195C4.34519 19.0361 3.00213 17.6927 3.00195 16.0361V6C3.00196 4.34315 4.34511 3 6.00195 3H18.002L18.1562 3.00391ZM6.00195 5C5.44967 5 5.00196 5.44772 5.00195 6V16.0361C5.00213 16.5882 5.4498 17.0361 6.00195 17.0361H8.65137C9.12119 17.0361 9.57643 17.2011 9.93652 17.5029L12.001 19.2334L14.0996 17.4961C14.4584 17.199 14.9101 17.0361 15.376 17.0361H18.002L18.1045 17.0303C18.6085 16.9789 19.0018 16.5535 19.002 16.0361V6C19.002 5.48239 18.6087 5.05624 18.1045 5.00488L18.002 5H6.00195Z", fill: "currentColor" })] });
});
IconBubbleCheckIcon.displayName = "IconBubbleCheckIcon";

const IdeaIcon = forwardRef$1(function IdeaIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M5 20C5 19.4477 4.55229 19 4 19C3.44771 19 3 19.4477 3 20C3 20.5523 3.44771 21 4 21C4.55229 21 5 20.5523 5 20ZM3.5 9.21484C3.5 6.14993 5.97495 3.65744 9.03711 3.65723C9.36085 3.65723 9.67942 3.68534 9.98926 3.73926C10.1042 3.75923 10.22 3.72036 10.292 3.65137C11.3586 2.62949 12.8072 2 14.4004 2C17.3632 2.00009 19.8142 4.17111 20.2734 7.00781L20.2979 7.08594C20.3101 7.11071 20.3266 7.13335 20.3457 7.15332C21.3701 8.22559 22 9.68369 22 11.2861C21.9998 14.5799 19.34 17.2568 16.0498 17.2568C15.6615 17.2568 15.2809 17.2201 14.9121 17.1484C14.8198 17.1305 14.7132 17.1558 14.6328 17.2227C13.6749 18.0197 12.4418 18.5 11.0996 18.5C8.29215 18.4998 5.97949 16.4054 5.61328 13.6953C5.60253 13.6158 5.56103 13.54 5.49902 13.4883C4.2789 12.47 3.50014 10.9329 3.5 9.21484ZM7 20C7 21.6569 5.65685 23 4 23C2.34315 23 1 21.6569 1 20C1 18.3431 2.34315 17 4 17C5.65685 17 7 18.3431 7 20ZM5.5 9.21484C5.50014 10.3167 5.99736 11.2998 6.78027 11.9531C7.22552 12.3248 7.51699 12.8525 7.59473 13.4277C7.82963 15.1657 9.31328 16.4998 11.0996 16.5C11.9564 16.5 12.7408 16.1953 13.3535 15.6855C13.8875 15.2412 14.602 15.05 15.2939 15.1846L15.4785 15.2158C15.6648 15.2429 15.8554 15.2568 16.0498 15.2568C18.2272 15.2568 19.9998 13.4835 20 11.2861C20 10.2174 19.5817 9.24933 18.8994 8.53516C18.5818 8.20271 18.3722 7.78074 18.2988 7.32715C17.9928 5.43727 16.3599 4.00009 14.4004 4C13.3443 4 12.3859 4.41538 11.6758 5.0957C11.1325 5.6163 10.371 5.83597 9.64648 5.70996C9.44938 5.67566 9.24541 5.65723 9.03711 5.65723C7.08765 5.65744 5.5 7.24634 5.5 9.21484Z" }) });
});
IdeaIcon.displayName = "IdeaIcon";

const IdentityIcon = forwardRef$1(function IdentityIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19 4C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19ZM5 6C4.44771 6 4 6.44771 4 7V17C4 17.5523 4.4477 18 5 18H19C19.5523 18 20 17.5523 20 17V7C20 6.4477 19.5523 6 19 6H5ZM8.48535 12C9.37852 12.0001 10.055 12.188 10.5527 12.5127C11.0607 12.8441 11.2998 13.2644 11.4043 13.5703H11.4053L11.4473 13.7246C11.6011 14.4783 10.9361 14.9997 10.374 15H6.5957C5.99838 15 5.27804 14.4081 5.56543 13.5693C5.6701 13.2635 5.90938 12.8438 6.41699 12.5127C6.9149 12.188 7.59189 12 8.48535 12ZM15.5 12.5C16.0523 12.5 16.5 12.9477 16.5 13.5C16.5 14.0523 16.0523 14.5 15.5 14.5H14C13.4477 14.5 13 14.0523 13 13.5C13 12.9477 13.4477 12.5 14 12.5H15.5ZM8.4834 8C9.44968 8.00023 10.2334 8.78364 10.2334 9.75C10.2334 10.7164 9.44968 11.4998 8.4834 11.5C7.51692 11.5 6.7334 10.7165 6.7334 9.75C6.7334 8.7835 7.51692 8 8.4834 8ZM17.5 9C18.0523 9 18.5 9.44772 18.5 10C18.5 10.5523 18.0523 11 17.5 11H14C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9H17.5Z" }) });
});
IdentityIcon.displayName = "IdentityIcon";

const IgnoreIcon = forwardRef$1(function IgnoreIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C14.7612 2 17.2627 3.12017 19.0713 4.92871L19.4023 5.27637C21.0154 7.05144 22 9.41157 22 12C22 17.5229 17.5229 22 12 22C9.41157 22 7.05144 21.0154 5.27637 19.4023L4.92871 19.0713C3.12017 17.2627 2 14.7612 2 12C2 6.47716 6.47716 2 12 2ZM7.09473 18.3184C8.4499 19.3722 10.1507 20 12 20C16.4183 20 20 16.4183 20 12C20 10.1507 19.3722 8.4499 18.3184 7.09473L7.09473 18.3184ZM12 4C7.58172 4 4 7.58172 4 12C4 13.8489 4.62731 15.5493 5.68066 16.9043L16.9043 5.68066C15.5493 4.62731 13.8489 4 12 4Z" }) });
});
IgnoreIcon.displayName = "IgnoreIcon";

const ImageIcon = forwardRef$1(function ImageIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5 6.5C16.1569 6.5 17.5 7.84315 17.5 9.5C17.5 11.1569 16.1569 12.5 14.5 12.5C12.8431 12.5 11.5 11.1569 11.5 9.5C11.5 7.84315 12.8431 6.5 14.5 6.5ZM14.5 8.5C13.9477 8.5 13.5 8.9477 13.5 9.5C13.5 10.0523 13.9477 10.5 14.5 10.5C15.0523 10.5 15.5 10.0523 15.5 9.5C15.5 8.9477 15.0523 8.5 14.5 8.5Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 3C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18ZM8.70703 14.1221C8.3165 13.7316 7.6835 13.7316 7.29297 14.1221L5 16.415V18C5 18.5523 5.4477 19 6 19H13.585L8.70703 14.1221ZM6 5C5.44771 5 5 5.44771 5 6V13.5869L5.87891 12.708C7.05048 11.5365 8.94952 11.5365 10.1211 12.708L16.4131 19H18C18.5523 19 19 18.5523 19 18V6C19 5.4477 18.5523 5 18 5H6Z" })] });
});
ImageIcon.displayName = "ImageIcon";

const ImgRotate90Icon = forwardRef$1(function ImgRotate90Icon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M9.90527 2.86816C11.0622 1.71117 12.9378 1.71117 14.0947 2.86816L21.1318 9.90527C22.2883 11.0622 22.2893 12.9378 21.1328 14.0947L14.0947 21.1318C12.9378 22.2888 11.0622 22.2888 9.90527 21.1318L2.86816 14.0947C1.71123 12.9377 1.71121 11.0623 2.86816 9.90527L9.90527 2.86816ZM12.6807 4.28223C12.3048 3.90634 11.6952 3.90634 11.3193 4.28223L4.28223 11.3193C3.90628 11.6953 3.90628 12.3047 4.28223 12.6807L11.3193 19.7178C11.6952 20.0936 12.3048 20.0936 12.6807 19.7178L19.7178 12.6807L19.7842 12.6074C20.0925 12.2293 20.0702 11.6718 19.7178 11.3193L12.6807 4.28223Z" }), jsx("path", { fill: "currentColor", d: "M13.0104 10.85L12.4037 11.4567C12.0955 11.765 12.3017 12.2925 12.7373 12.3099L15.4744 12.4194C15.7661 12.4311 16.0056 12.1915 15.994 11.8998L15.8844 9.16267C15.8671 8.7272 15.3395 8.52091 15.0313 8.82913L14.4246 9.43583C13.0578 8.06899 10.8417 8.06899 9.47487 9.43582C8.10804 10.8027 8.10804 13.0187 9.47487 14.3856C10.285 15.1957 11.3943 15.5249 12.4441 15.3757C12.9909 15.298 13.3712 14.7917 13.2935 14.245C13.2158 13.6983 12.7095 13.3179 12.1627 13.3956C11.7088 13.4602 11.2356 13.3179 10.8891 12.9714C10.3033 12.3856 10.3033 11.4358 10.8891 10.85C11.4749 10.2643 12.4246 10.2643 13.0104 10.85Z" })] });
});
ImgRotate90Icon.displayName = "ImgRotate90Icon";

const InAppIcon = forwardRef$1(function InAppIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19 4C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7C2 5.34315 3.34315 4 5 4H19ZM4 17C4 17.5523 4.44771 18 5 18H19C19.5523 18 20 17.5523 20 17V12H4V17ZM5 6C4.44771 6 4 6.44771 4 7V10H20V7C20 6.44771 19.5523 6 19 6H5ZM6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7ZM9 7C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z", fill: "currentColor" }) });
});
InAppIcon.displayName = "InAppIcon";

const InformationIcon = forwardRef$1(function InformationIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.999 2C17.521 2.00019 21.997 6.47709 21.9971 11.999C21.9969 17.5209 17.5209 21.9969 11.999 21.9971C6.4772 21.9969 2.00019 17.5209 2 11.999C2.00008 6.47711 6.47714 2.00021 11.999 2ZM11.999 4C7.58171 4.00021 4.00008 7.58168 4 11.999C4.00019 16.4163 7.58177 19.9969 11.999 19.9971C16.4163 19.9969 19.9969 16.4163 19.9971 11.999C19.997 7.58166 16.4164 4.00019 11.999 4ZM11.999 9.99902C12.5511 9.99921 12.9989 10.4469 12.999 10.999V15.998C12.999 16.5502 12.5512 16.9979 11.999 16.998C11.4469 16.9978 10.999 16.5502 10.999 15.998V11.999C10.447 11.9988 9.99913 11.5511 9.99902 10.999C9.9991 10.4469 10.447 9.99924 10.999 9.99902H11.999ZM11.999 7C12.5512 7.00006 12.999 7.44783 12.999 8C12.999 8.55214 12.5511 8.99994 11.999 9C11.4469 8.99993 10.9991 8.55213 10.999 8C10.999 7.44784 11.4469 7.00007 11.999 7Z" }) });
});
InformationIcon.displayName = "InformationIcon";

const InsightsAgentCloseIcon = forwardRef$1(function InsightsAgentCloseIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M4.5 21.6C3.67157 21.6 3 20.9285 3 20.1L3 18.3C3 17.4716 3.67157 16.8 4.5 16.8C5.32843 16.8 6 17.4716 6 18.3V20.1C6 20.9285 5.32843 21.6 4.5 21.6Z", fill: "var(--chakra-colors-purple-400)" }), jsx("path", { d: "M9.5 21.6C8.67157 21.6 8 20.9285 8 20.1L8 13.5C8 12.6716 8.67157 12 9.5 12C10.3284 12 11 12.6716 11 13.5L11 20.1C11 20.9285 10.3284 21.6 9.5 21.6Z", fill: "var(--chakra-colors-teal-400)" }), jsx("path", { d: "M14.5 21.6C13.6716 21.6 13 20.9285 13 20.1L13 8.70003C13 7.8716 13.6716 7.20003 14.5 7.20003C15.3284 7.20003 16 7.8716 16 8.70003L16 20.1C16 20.9285 15.3284 21.6 14.5 21.6Z", fill: "var(--chakra-colors-green-300)" }), jsx("path", { d: "M19.5 21.6C18.6716 21.6 18 20.9285 18 20.1L18 3.90002C18 3.0716 18.6716 2.40002 19.5 2.40002C20.3284 2.40002 21 3.0716 21 3.90002L21 20.1C21 20.9285 20.3284 21.6 19.5 21.6Z", fill: "var(--chakra-colors-yellow-400)" }), jsx("path", { d: "M5.16788 6C5.48143 5.35886 6.42918 5.36492 6.3899 6.00781L6.32765 7.02641C6.28158 7.78037 6.74859 8.3623 7.50034 8.48765L11.0443 9.0786C11.3119 9.12321 11.2071 9.51159 10.9157 9.55524L7.09741 10.1273C6.28568 10.2489 5.51074 10.8201 5.14613 11.5657L4.64458 12.5913C4.33314 13.2281 3.3923 13.2281 3.42214 12.5913L3.4734 11.4973C3.50672 10.7862 3.08143 10.2303 2.38678 10.0768L1.31303 9.83964C0.692325 9.70252 0.935076 8.79655 1.62927 8.65943L2.83012 8.42223C3.60702 8.26878 4.33023 7.71284 4.67797 7.00179L5.16788 6Z", fill: "currentColor" })] });
});
InsightsAgentCloseIcon.displayName = "InsightsAgentCloseIcon";

const InsightsAgentOpenIcon = forwardRef$1(function InsightsAgentOpenIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M4.5 21.6C3.67157 21.6 3 20.9285 3 20.1L3 18.3C3 17.4716 3.67157 16.8 4.5 16.8C5.32843 16.8 6 17.4716 6 18.3V20.1C6 20.9285 5.32843 21.6 4.5 21.6Z", fill: "currentColor" }), jsx("path", { d: "M9.5 21.6C8.67157 21.6 8 20.9285 8 20.1L8 13.5C8 12.6716 8.67157 12 9.5 12C10.3284 12 11 12.6716 11 13.5L11 20.1C11 20.9285 10.3284 21.6 9.5 21.6Z", fill: "currentColor" }), jsx("path", { d: "M14.5 21.6C13.6716 21.6 13 20.9285 13 20.1L13 8.70003C13 7.8716 13.6716 7.20003 14.5 7.20003C15.3284 7.20003 16 7.8716 16 8.70003L16 20.1C16 20.9285 15.3284 21.6 14.5 21.6Z", fill: "currentColor" }), jsx("path", { d: "M19.5 21.6C18.6716 21.6 18 20.9285 18 20.1L18 3.90002C18 3.0716 18.6716 2.40002 19.5 2.40002C20.3284 2.40002 21 3.0716 21 3.90002L21 20.1C21 20.9285 20.3284 21.6 19.5 21.6Z", fill: "currentColor" }), jsx("path", { d: "M5.16788 6C5.48143 5.35886 6.42918 5.36492 6.3899 6.00781L6.32765 7.02641C6.28158 7.78037 6.74859 8.3623 7.50034 8.48765L11.0443 9.0786C11.3119 9.12321 11.2071 9.51159 10.9157 9.55524L7.09741 10.1273C6.28568 10.2489 5.51074 10.8201 5.14613 11.5657L4.64458 12.5913C4.33314 13.2281 3.3923 13.2281 3.42214 12.5913L3.4734 11.4973C3.50672 10.7862 3.08143 10.2303 2.38678 10.0768L1.31303 9.83964C0.692325 9.70252 0.935076 8.79655 1.62927 8.65943L2.83012 8.42223C3.60702 8.26878 4.33023 7.71284 4.67797 7.00179L5.16788 6Z", fill: "currentColor" })] });
});
InsightsAgentOpenIcon.displayName = "InsightsAgentOpenIcon";

const InsightsIcon = forwardRef$1(function InsightsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M4.5 21.6C3.67157 21.6 3 20.9284 3 20.1L3 18.3C3 17.4716 3.67157 16.8 4.5 16.8C5.32843 16.8 6 17.4716 6 18.3V20.1C6 20.9284 5.32843 21.6 4.5 21.6Z", fill: "var(--chakra-colors-purple-400)" }), jsx("path", { d: "M9.5 21.6C8.67157 21.6 8 20.9284 8 20.1V13.5C8 12.6716 8.67157 12 9.5 12C10.3284 12 11 12.6716 11 13.5V20.1C11 20.9284 10.3284 21.6 9.5 21.6Z", fill: "var(--chakra-colors-teal-400)" }), jsx("path", { d: "M14.5 21.6C13.6716 21.6 13 20.9284 13 20.1V8.7C13 7.87157 13.6716 7.2 14.5 7.2C15.3284 7.2 16 7.87157 16 8.7V20.1C16 20.9284 15.3284 21.6 14.5 21.6Z", fill: "var(--chakra-colors-green-300)" }), jsx("path", { d: "M19.5 21.6C18.6716 21.6 18 20.9284 18 20.1V3.89999C18 3.07157 18.6716 2.39999 19.5 2.39999C20.3284 2.39999 21 3.07157 21 3.89999V20.1C21 20.9284 20.3284 21.6 19.5 21.6Z", fill: "var(--chakra-colors-yellow-400)" })] });
});
InsightsIcon.displayName = "InsightsIcon";

const ItalicIcon = forwardRef$1(function ItalicIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M18.1074 4.00488C18.6116 4.05613 19.0049 4.48226 19.0049 5C19.0046 5.51752 18.6115 5.94388 18.1074 5.99512L18.0049 6H14.8857L11.2109 18.0029H13.7178L13.8193 18.0078C14.3238 18.0588 14.7177 18.4851 14.7178 19.0029C14.7175 19.5206 14.3237 19.9471 13.8193 19.998L13.7178 20.0029H6C5.44807 20.0027 5.00026 19.5548 5 19.0029C5.00009 18.4509 5.44796 18.0032 6 18.0029H9.11914L12.7949 6H10.2871C9.73537 5.99955 9.28737 5.55178 9.28711 5C9.28711 4.44799 9.73521 4.00045 10.2871 4H18.0049L18.1074 4.00488Z" }) });
});
ItalicIcon.displayName = "ItalicIcon";

const JourneyTemplateIcon = forwardRef$1(function JourneyTemplateIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M4 15.6895C4.55208 15.6895 4.99967 16.1374 5 16.6895V18.0029C5.00012 18.5551 5.44786 19.0028 6 19.0029H7.3125C7.86473 19.0029 8.31242 19.4507 8.3125 20.0029C8.31238 20.5551 7.86471 21.0029 7.3125 21.0029H6C4.34329 21.0028 3.00012 19.6596 3 18.0029V16.6895C3.00033 16.1375 3.44799 15.6895 4 15.6895Z" }), jsx("path", { d: "M13.3145 19.0029C13.8665 19.0031 14.3144 19.4508 14.3145 20.0029C14.3143 20.555 13.8665 21.0028 13.3145 21.0029H10.6885C10.1364 21.0028 9.6886 20.555 9.68848 20.0029C9.68856 19.4508 10.1363 19.0031 10.6885 19.0029H13.3145Z" }), jsx("path", { d: "M20.0029 15.6895C20.5549 15.6896 21.0026 16.1375 21.0029 16.6895V18.0029C21.0028 19.6596 19.6596 21.0028 18.0029 21.0029H16.6895C16.1375 21.0026 15.6896 20.5549 15.6895 20.0029C15.6895 19.4509 16.1375 19.0033 16.6895 19.0029H18.0029C18.555 19.0028 19.0028 18.555 19.0029 18.0029V16.6895C19.0033 16.1375 19.4509 15.6895 20.0029 15.6895Z" }), jsx("path", { d: "M15.7441 13.9609C16.1347 13.571 16.7679 13.5706 17.1582 13.9609C17.5484 14.3513 17.5481 14.9845 17.1582 15.375L16.9736 15.5586L17.1582 15.7432C17.5483 16.1336 17.5482 16.7668 17.1582 17.1572C16.7678 17.5477 16.1347 17.5475 15.7441 17.1572L15.5596 16.9727L15.376 17.1572C14.9855 17.5476 14.3524 17.5476 13.9619 17.1572C13.5715 16.7667 13.5715 16.1337 13.9619 15.7432L14.1455 15.5586L13.9619 15.375C13.5714 14.9845 13.5714 14.3514 13.9619 13.9609C14.3525 13.5709 14.9856 13.5706 15.376 13.9609L15.5596 14.1445L15.7441 13.9609Z" }), jsx("path", { d: "M14.6689 7.44531C16.2031 7.44548 17.4472 8.68946 17.4473 10.2236C17.4471 11.7577 16.203 13.0018 14.6689 13.002H9.33496C8.90533 13.002 8.55679 13.3497 8.55664 13.7793C8.55664 14.209 8.90524 14.5576 9.33496 14.5576H11.1133C11.6652 14.558 12.1133 15.0056 12.1133 15.5576C12.1133 16.1096 11.6652 16.5572 11.1133 16.5576H9.33496C7.80067 16.5576 6.55664 15.3136 6.55664 13.7793C6.55679 12.2451 7.80077 11.002 9.33496 11.002H14.6689C15.0984 11.0018 15.4471 10.6531 15.4473 10.2236C15.4472 9.79403 15.0985 9.44548 14.6689 9.44531H12.8906C12.3385 9.44518 11.8906 8.99751 11.8906 8.44531C11.8906 7.89313 12.3385 7.44545 12.8906 7.44531H14.6689Z" }), jsx("path", { d: "M4 9.68848C4.55221 9.68848 4.99988 10.1363 5 10.6885V13.3145C4.99984 13.8666 4.55218 14.3145 4 14.3145C3.44789 14.3144 3.00016 13.8665 3 13.3145V10.6885C3.00012 10.1363 3.44786 9.68856 4 9.68848Z" }), jsx("path", { d: "M20.0029 9.68848C20.555 9.6886 21.0028 10.1364 21.0029 10.6885V13.3145C21.0028 13.8665 20.555 14.3143 20.0029 14.3145C19.4508 14.3144 19.0031 13.8665 19.0029 13.3145V10.6885C19.0031 10.1363 19.4508 9.68856 20.0029 9.68848Z" }), jsx("path", { d: "M8.44531 6.66699C9.42728 6.66703 10.2236 7.46333 10.2236 8.44531C10.2236 9.42727 9.42727 10.2236 8.44531 10.2236C7.46332 10.2236 6.66701 9.4273 6.66699 8.44531C6.66699 7.46331 7.46331 6.66699 8.44531 6.66699Z" }), jsx("path", { d: "M7.3125 3C7.86473 3 8.31242 3.44778 8.3125 4C8.3125 4.55228 7.86478 5 7.3125 5H6C5.44783 5.00008 5.00008 5.44784 5 6V7.3125C5 7.86478 4.55228 8.3125 4 8.3125C3.44778 8.31242 3 7.86473 3 7.3125V6C3.00008 4.34326 4.34327 3.00008 6 3H7.3125Z" }), jsx("path", { d: "M18.0029 3C19.6596 3.00012 21.0028 4.34329 21.0029 6V7.3125C21.0029 7.86471 20.5551 8.31238 20.0029 8.3125C19.4507 8.31242 19.0029 7.86473 19.0029 7.3125V6C19.0028 5.44786 18.5551 5.00012 18.0029 5H16.6895C16.1374 4.99967 15.6895 4.55208 15.6895 4C15.6895 3.44799 16.1375 3.00033 16.6895 3H18.0029Z" }), jsx("path", { d: "M13.3145 3C13.8665 3.00016 14.3144 3.44789 14.3145 4C14.3145 4.55218 13.8666 4.99984 13.3145 5H10.6885C10.1363 4.99987 9.68848 4.55221 9.68848 4C9.68856 3.44786 10.1363 3.00012 10.6885 3H13.3145Z" })] });
});
JourneyTemplateIcon.displayName = "JourneyTemplateIcon";

const JourneyIcon = forwardRef$1(function JourneyIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M18.7188 15.293C19.1095 14.9031 19.743 14.9031 20.1338 15.293C20.5245 15.6832 20.5245 16.3159 20.1338 16.7061L18.8389 17.998L20.1348 19.292C20.5251 19.6822 20.5254 20.315 20.1348 20.7051C19.7441 21.095 19.1106 21.0946 18.7197 20.7051L17.4238 19.4111L16.1377 20.6963L16.0625 20.7646C15.6695 21.0846 15.089 21.0619 14.7227 20.6963C14.3563 20.3305 14.3338 19.7509 14.6543 19.3584L14.7227 19.2832L16.0088 17.998L14.7236 16.7158C14.3328 16.3257 14.333 15.693 14.7236 15.3027C15.1145 14.9125 15.7478 14.9125 16.1387 15.3027L17.4238 16.585L18.7188 15.293ZM17.0713 4.7207C19.2605 4.83158 21.001 6.64166 21.001 8.8584C21.0006 11.1463 19.1463 13.0009 16.8584 13.001H7.14355C5.9601 13.0012 5 13.961 5 15.1445C5.00026 16.3278 5.96027 17.2869 7.14355 17.2871H12.001L12.1025 17.293C12.6069 17.344 13.0008 17.7693 13.001 18.2871C13.0009 18.8049 12.6069 19.2312 12.1025 19.2822L12.001 19.2871H7.14355C4.85569 19.2869 3.00026 17.4324 3 15.1445C3 12.8565 4.85553 11.0012 7.14355 11.001H16.8584C18.0418 11.0009 19.0006 10.0417 19.001 8.8584C19.001 7.74866 18.158 6.8352 17.0771 6.72559L16.8584 6.71484H14.2871C13.7351 6.71465 13.2872 6.26692 13.2871 5.71484C13.2871 5.16268 13.735 4.71504 14.2871 4.71484H16.8584L17.0713 4.7207ZM7.42871 3C9.24334 3.00002 10.7147 4.47154 10.7148 6.28613C10.7147 8.10078 9.24338 9.57225 7.42871 9.57227C5.61431 9.57193 4.1427 8.10059 4.14258 6.28613C4.14276 4.47173 5.61434 3.00033 7.42871 3ZM7.42871 5C6.71891 5.00033 6.14276 5.5763 6.14258 6.28613C6.1427 6.99602 6.71887 7.57193 7.42871 7.57227C8.13881 7.57225 8.71472 6.99621 8.71484 6.28613C8.71466 5.57611 8.13878 5.00002 7.42871 5Z" }) });
});
JourneyIcon.displayName = "JourneyIcon";

const KanbanIcon = forwardRef$1(function KanbanIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13 7C13 6.44771 12.5523 6 12 6C11.4477 6 11 6.44771 11 7V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V7ZM6 7C6 6.44771 5.55229 6 5 6C4.44771 6 4 6.44771 4 7V13C4 13.5523 4.44771 14 5 14C5.55229 14 6 13.5523 6 13V7ZM20 7C20 6.44771 19.5523 6 19 6C18.4477 6 18 6.44771 18 7V11C18 11.5523 18.4477 12 19 12C19.5523 12 20 11.5523 20 11V7ZM8 13C8 14.6569 6.65685 16 5 16C3.34315 16 2 14.6569 2 13V7C2 5.34315 3.34315 4 5 4C6.65685 4 8 5.34315 8 7V13ZM15 17C15 18.6569 13.6569 20 12 20C10.3431 20 9 18.6569 9 17V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7V17ZM22 11C22 12.6569 20.6569 14 19 14C17.3431 14 16 12.6569 16 11V7C16 5.34315 17.3431 4 19 4C20.6569 4 22 5.34315 22 7V11Z", fill: "currentColor" }) });
});
KanbanIcon.displayName = "KanbanIcon";

const KeyIcon = forwardRef$1(function KeyIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M14.8252 7.70703C15.6372 7.70727 16.2958 8.36556 16.2959 9.17773C16.2957 9.98983 15.6371 10.6482 14.8252 10.6484C14.0131 10.6483 13.3547 9.9899 13.3545 9.17773C13.3546 8.36549 14.0131 7.70715 14.8252 7.70703Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8242 3C18.2354 3 21.0007 5.76563 21.001 9.17676C21.001 12.5881 18.2356 15.3535 14.8242 15.3535C14.51 15.3535 14.2009 15.3268 13.8984 15.2812L12.708 16.4727C12.5206 16.6601 12.266 16.7655 12.001 16.7656H10.6475V18.1182C10.6475 18.3833 10.5419 18.6377 10.3545 18.8252L9.02344 20.1572C8.48291 20.6977 7.74966 21.0009 6.98535 21.001H4.94141C3.86951 21.0007 3 20.1316 3 19.0596V17.0156C3.00017 16.2514 3.30433 15.518 3.84473 14.9775L8.71875 10.1016C8.67335 9.79952 8.64746 9.49053 8.64746 9.17676C8.64773 5.76578 11.4132 3.00025 14.8242 3ZM14.8242 5C12.5178 5.00025 10.6477 6.87034 10.6475 9.17676C10.6475 9.52806 10.6907 9.86845 10.7715 10.1924C10.8565 10.5329 10.7568 10.8933 10.5088 11.1416L5.25879 16.3916C5.0934 16.557 5.00017 16.7818 5 17.0156V19.001H6.98535C7.21936 19.0009 7.44392 18.9076 7.60938 18.7422L8.64746 17.7041V15.7656C8.6477 15.2137 9.09553 14.7659 9.64746 14.7656H11.5859L12.8594 13.4922L12.957 13.4062C13.1968 13.2221 13.5107 13.1553 13.8086 13.2295C14.1326 13.3103 14.4729 13.3535 14.8242 13.3535C17.131 13.3535 19.001 11.4836 19.001 9.17676C19.0007 6.87019 17.1309 5 14.8242 5Z" })] });
});
KeyIcon.displayName = "KeyIcon";

const LaunchAdIcon = forwardRef$1(function LaunchAdIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15.5 9.5C15.5 8.94771 15.0523 8.5 14.5 8.5C13.9477 8.5 13.5 8.94771 13.5 9.5C13.5 10.0523 13.9477 10.5 14.5 10.5C15.0523 10.5 15.5 10.0523 15.5 9.5ZM17.5 9.5C17.5 11.1569 16.1569 12.5 14.5 12.5C12.8431 12.5 11.5 11.1569 11.5 9.5C11.5 7.84315 12.8431 6.5 14.5 6.5C16.1569 6.5 17.5 7.84315 17.5 9.5Z" }), jsx("path", { fill: "currentColor", d: "M19 10V6C19 5.44771 18.5523 5 18 5H6C5.44771 5 5 5.44771 5 6V18C5 18.5523 5.44771 19 6 19H11C11.5523 19 12 19.4477 12 20C12 20.5523 11.5523 21 11 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10Z" }), jsx("path", { fill: "currentColor", d: "M5.87891 12.7074C7.05048 11.5359 8.94952 11.5359 10.1211 12.7074L11.707 14.2933C12.0974 14.6838 12.0975 15.3169 11.707 15.7074C11.3165 16.0977 10.6835 16.0977 10.293 15.7074L8.70703 14.1214C8.3165 13.7309 7.6835 13.7309 7.29297 14.1214L4.70703 16.7074C4.31655 17.0977 3.68345 17.0977 3.29297 16.7074C2.9025 16.3169 2.90261 15.6838 3.29297 15.2933L5.87891 12.7074Z" }), jsx("path", { fill: "currentColor", d: "M19 19V16H16C15.4477 16 15 15.5523 15 15C15 14.4477 15.4477 14 16 14H20C20.5523 14 21 14.4477 21 15V19C21 19.5523 20.5523 20 20 20C19.4477 20 19 19.5523 19 19Z" }), jsx("path", { fill: "currentColor", d: "M19.1172 14.6864C19.5666 14.3654 20.1917 14.4694 20.5127 14.9188C20.8334 15.3682 20.7286 15.9924 20.2793 16.3133C18.9188 17.2851 18.1537 18.1172 17.7021 18.9598C17.253 19.798 17.0632 20.7406 17.0185 22.034C16.9995 22.5859 16.5371 23.0178 15.9853 22.9989C15.4335 22.9798 15.0016 22.5175 15.0205 21.9657C15.0706 20.515 15.2887 19.2298 15.9394 18.0155C16.5879 16.8055 17.6148 15.7595 19.1172 14.6864Z" })] });
});
LaunchAdIcon.displayName = "LaunchAdIcon";

const LawGavelIcon = forwardRef$1(function LawGavelIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5586 16C13.8496 16 14.9958 16.8261 15.4043 18.0508L15.7207 19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H3C2.44772 21 2 20.5523 2 20C2.00001 19.4477 2.44772 19 3 19H3.2793L3.5957 18.0517C4.00418 16.8271 5.15033 16 6.44141 16H12.5586ZM6.44141 18C6.01113 18 5.62934 18.2755 5.49316 18.6836L5.3877 19H13.6123L13.5068 18.6836C13.3707 18.2755 12.9888 18 12.5586 18H6.44141Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.541 4.04295C15.6218 2.9622 17.3742 2.96221 18.4551 4.04295C19.536 5.12382 19.536 6.87612 18.4551 7.95701L17.1621 9.24998L21.2051 13.2929C21.5956 13.6835 21.5956 14.3165 21.2051 14.707C20.8146 15.0975 20.1815 15.0975 19.791 14.707L15.748 10.664L14.4551 11.957C13.3742 13.0379 11.6219 13.0377 10.541 11.957C9.46041 10.8761 9.46026 9.12379 10.541 8.04295L14.541 4.04295ZM17.041 5.45701C16.7413 5.15741 16.2549 5.15722 15.9551 5.45701L11.9551 9.45701C11.6554 9.75675 11.6555 10.243 11.9551 10.5429C12.255 10.8428 12.7413 10.8427 13.041 10.5429L17.041 6.54295C17.3409 6.24312 17.3409 5.75684 17.041 5.45701Z", fill: "currentColor" }), jsx("path", { d: "M4 12C4.55228 12 4.99999 12.4477 5 13C5 13.5523 4.55228 14 4 14H2C1.44772 14 1 13.5523 1 13C1.00001 12.4477 1.44772 12 2 12H4Z", fill: "currentColor" }), jsx("path", { d: "M3.29297 7.29295C3.68349 6.90244 4.31651 6.90244 4.70703 7.29295L6.20703 8.79295C6.59755 9.18347 6.59755 9.81649 6.20703 10.207C5.81651 10.5975 5.18349 10.5975 4.79297 10.207L3.29297 8.70701C2.90245 8.31649 2.90245 7.68347 3.29297 7.29295Z", fill: "currentColor" })] });
});
LawGavelIcon.displayName = "LawGavelIcon";

const LawScaleIcon = forwardRef$1(function LawScaleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9997 2C12.5519 2.00007 12.9997 2.44776 12.9997 3V4H13.527C13.9925 4 14.4524 4.10834 14.8688 4.31641L16.0241 4.89453C16.1627 4.96384 16.3164 4.99988 16.4714 5H20.9997C21.5519 5.00007 21.9997 5.44776 21.9997 6C21.9997 6.55224 21.5519 6.99993 20.9997 7H19.8864L21.9274 13.1221C22.3548 14.4044 21.8862 16.1345 20.28 16.6143C19.087 16.9706 17.9114 16.9717 16.7184 16.6152C15.1128 16.1353 14.6437 14.4043 15.071 13.1221L17.112 7H16.4714C16.0059 6.99988 15.5459 6.89178 15.1296 6.68359L13.9743 6.10547C13.8356 6.03626 13.682 6 13.527 6H12.9997V19H16.9997C17.5519 19.0001 17.9997 19.4478 17.9997 20C17.9997 20.5522 17.5519 20.9999 16.9997 21H6.99968C6.4476 20.9998 5.99968 20.5521 5.99968 20C5.99968 19.4479 6.4476 19.0002 6.99968 19H10.9997V6H10.4714C10.3164 6.00012 10.1627 6.03614 10.0241 6.10547L8.86882 6.68359C8.45243 6.89166 7.9925 7 7.52702 7H6.8864L8.92741 13.1221C9.35492 14.4045 8.8862 16.1346 7.27995 16.6143C6.08701 16.9706 4.91137 16.9717 3.71843 16.6152C2.11276 16.1353 1.64362 14.4044 2.07097 13.1221L4.11198 7H2.99968C2.4476 6.99975 1.99968 6.55213 1.99968 6C1.99968 5.44787 2.4476 5.00025 2.99968 5H7.52702C7.68202 5 7.83562 4.96374 7.97429 4.89453L9.12956 4.31641C9.54589 4.10823 10.0058 4.00012 10.4714 4H10.9997V3C10.9997 2.44787 11.4476 2.00025 11.9997 2ZM3.96843 13.7549C3.89016 13.9898 3.90574 14.2273 3.97819 14.4014C4.04562 14.5631 4.15261 14.6578 4.29069 14.6992C5.11006 14.944 5.88834 14.9439 6.70769 14.6992L6.80534 14.6572C6.89674 14.6057 6.96952 14.5227 7.02019 14.4014C7.09273 14.2272 7.10828 13.9899 7.02995 13.7549L5.4987 9.16211L3.96843 13.7549ZM16.9684 13.7549C16.8902 13.9898 16.9057 14.2273 16.9782 14.4014C17.0456 14.5632 17.1526 14.6578 17.2907 14.6992C18.1101 14.944 18.8883 14.9439 19.7077 14.6992L19.8053 14.6572C19.8967 14.6057 19.9695 14.5227 20.0202 14.4014C20.0927 14.2272 20.1092 13.9898 20.0309 13.7549L18.4987 9.16113L16.9684 13.7549Z", fill: "currentColor" }) });
});
LawScaleIcon.displayName = "LawScaleIcon";

const LightningBoltWithSlashIcon = forwardRef$1(function LightningBoltWithSlashIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.0007 16.8311C11.5526 16.8312 12.0004 17.2792 12.0007 17.8311V19.1387L12.2312 18.8613C12.5839 18.4366 13.2145 18.3779 13.6394 18.7305C14.0641 19.0831 14.1226 19.7137 13.7703 20.1387L12.7117 21.4131C12.2781 21.9997 11.5747 22.0579 11.1228 21.9404C10.6492 21.8172 10.0009 21.3759 10.0007 20.5469V17.8311C10.0011 17.2791 10.4487 16.8311 11.0007 16.8311ZM5.29369 6.29298C5.65981 5.92705 6.23888 5.90432 6.63158 6.22462L6.70775 6.29298L18.7078 18.293L18.7761 18.3691C19.0963 18.7618 19.0736 19.341 18.7078 19.707C18.3417 20.0731 17.7626 20.0956 17.3699 19.7754L17.2937 19.707L5.29369 7.70704L5.22533 7.63087C4.90498 7.23809 4.92757 6.65909 5.29369 6.29298ZM5.76634 11.3213C6.10988 10.9489 6.68622 10.8896 7.10033 11.2002C7.542 11.5315 7.63157 12.1578 7.30052 12.5996L6.24974 14H8.00072L8.10326 14.0049C8.60715 14.0564 9.0006 14.4826 9.00072 15C9.00066 15.5175 8.60718 15.9436 8.10326 15.9951L8.00072 16H5.43236C4.80161 15.9999 4.28757 15.626 4.04466 15.1201C3.7991 14.6084 3.84055 14.0093 4.13451 13.5L4.20091 13.4004L5.70091 11.3994L5.76634 11.3213ZM11.3142 2.54981C12.1609 1.45319 13.8677 2.12246 13.8679 3.45411V8.32911H18.5681C19.6788 8.32956 20.2877 9.48418 19.866 10.3887L19.7673 10.5664L17.7986 13.5957C17.4976 14.0587 16.8778 14.1904 16.4148 13.8897C15.9518 13.5887 15.82 12.9689 16.1208 12.5059L17.5359 10.3291H13.3025C12.4868 10.3291 11.8679 9.65794 11.8679 8.8838V5.35743L11.0515 6.61329C10.7505 7.0762 10.1317 7.20705 9.66869 6.90626C9.20566 6.6053 9.07386 5.9865 9.37474 5.52344L11.2341 2.66212L11.3142 2.54981Z" }) });
});
LightningBoltWithSlashIcon.displayName = "LightningBoltWithSlashIcon";

const LightningBoltIcon = forwardRef$1(function LightningBoltIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.4111 2.50488C12.1709 1.52555 13.7643 2.05865 13.7646 3.35351V8.39746H18.6748C19.6986 8.39751 20.322 9.52518 19.8271 10.4121L19.7763 10.498L12.6601 21.3965C11.9336 22.5083 10.2354 21.9828 10.2353 20.6465V15.6035H5.32515C4.26852 15.603 3.63874 14.4006 4.22456 13.5029L11.3398 2.60449L11.4111 2.50488ZM6.15034 13.8018H10.6767C11.4076 13.8018 12 14.4071 12 15.1533V19.1592L17.8505 10.1982H13.3232C12.5928 10.1979 12.0001 9.59355 12 8.84765V4.84179L6.15034 13.8018Z" }) });
});
LightningBoltIcon.displayName = "LightningBoltIcon";

const LimitIcon = forwardRef$1(function LimitIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17 21C19.2092 21 21 19.2091 21 17L21 7C21 4.79081 19.2092 3 17 3L7 3C4.79087 3 3 4.79081 3 7L3 17C3 19.2091 4.79087 21 7 21L17 21ZM7 19C5.89543 19 5 18.1046 5 17L5 7C5 5.8954 5.89542 5 7 5L17 5C18.1046 5 19 5.89538 19 7L19 17C19 18.1046 18.1046 19 17 19L7 19ZM15 9C15.5523 9 16 8.55228 16 8C16 7.44771 15.5523 7 15 7L9 7C8.44771 7 8 7.44772 8 8C8 8.55228 8.44771 9 9 9L15 9ZM12 17C12.5523 17 13 16.5523 13 16L13 13.4141L13.293 13.707C13.6835 14.0976 14.3165 14.0976 14.707 13.707C15.0976 13.3165 15.0976 12.6835 14.707 12.293L12.707 10.293C12.3165 9.90244 11.6835 9.90244 11.293 10.293L9.29297 12.293L9.22461 12.3691C8.90426 12.7619 8.92685 13.3409 9.29297 13.707C9.65908 14.0731 10.2381 14.0957 10.6309 13.7754L10.707 13.707L11 13.4141L11 16C11 16.5523 11.4477 17 12 17Z" }) });
});
LimitIcon.displayName = "LimitIcon";

const LinearIcon = forwardRef$1(function LinearIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { opacity: 0.5, d: "M4 3C4.55228 3 5 3.44772 5 4V18C5 18.5523 5.44772 19 6 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H6C4.34315 21 3 19.6569 3 18V4C3 3.44772 3.44772 3 4 3Z" }), jsx("path", { d: "M19.1025 11.0049C19.6067 11.0562 20 11.4823 20 12C20 12.5177 19.6067 12.9438 19.1025 12.9951L19 13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H19L19.1025 11.0049Z" })] });
});
LinearIcon.displayName = "LinearIcon";

const LinkIcon = forwardRef$1(function LinkIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5.5108 9.5204C5.89871 9.12772 6.53188 9.123 6.92486 9.51064C7.31774 9.89839 7.32198 10.5316 6.93463 10.9247L6.27545 11.5927L6.27057 11.5976C4.57679 13.2914 4.5769 16.0374 6.27057 17.7313L6.43268 17.8856C8.13529 19.4238 10.7636 19.3722 12.4044 17.7313L12.4092 17.7274L13.0772 17.0683L13.1534 16.9999C13.5482 16.6823 14.1276 16.7086 14.4913 17.077C14.8791 17.47 14.8742 18.1031 14.4815 18.4911L13.8174 19.1454L13.8184 19.1464C11.4209 21.5436 7.58047 21.6184 5.09283 19.371L4.8565 19.1464C2.38166 16.6715 2.38165 12.6584 4.8565 10.1835L5.5108 9.5204ZM13.0713 9.51552C13.4618 9.12516 14.0959 9.12527 14.4864 9.51552C14.8765 9.90595 14.8765 10.5391 14.4864 10.9296L10.9297 14.4862C10.5393 14.8765 9.90616 14.8765 9.51568 14.4862C9.12545 14.0957 9.12543 13.4626 9.51568 13.0722L13.0713 9.51552ZM18.4913 14.4823C18.1033 14.8751 17.4702 14.879 17.0772 14.4911C16.6842 14.1032 16.6798 13.4701 17.0674 13.077L18.4913 14.4823ZM10.1885 4.85146C12.6638 2.38132 16.6723 2.38308 19.1456 4.85634L19.3712 5.09267C21.6172 7.57894 21.5426 11.4156 19.1495 13.8134L19.1504 13.8143L18.4913 14.4823L17.7794 13.7792L17.0674 13.077L17.7266 12.4091L17.7315 12.4042L17.8858 12.2431C19.3745 10.5954 19.3742 8.08031 17.8858 6.43251L17.7315 6.2704C16.0907 4.62961 13.4624 4.57799 11.7598 6.11611L11.5977 6.2704L11.5928 6.27529L10.9249 6.93447C10.5318 7.32203 9.89863 7.31763 9.5108 6.9247C9.12315 6.53166 9.12772 5.89852 9.52057 5.51064L10.1885 4.85146Z" }) });
});
LinkIcon.displayName = "LinkIcon";

const ListBulletedIcon = forwardRef$1(function ListBulletedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M6 15C7.10457 15 8 15.8954 8 17C8 18.1046 7.10457 19 6 19C4.89543 19 4 18.1046 4 17C4 15.8954 4.89543 15 6 15ZM20 16C20.5523 16 21 16.4477 21 17C21 17.5523 20.5523 18 20 18H12C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16H20ZM6 5C7.10457 5 8 5.89543 8 7C8 8.10457 7.10457 9 6 9C4.89543 9 4 8.10457 4 7C4 5.89543 4.89543 5 6 5ZM20 6C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H12C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6H20Z" }) });
});
ListBulletedIcon.displayName = "ListBulletedIcon";

const ListNumberedIcon = forwardRef$1(function ListNumberedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7.24902 13.5107C7.85282 13.5567 8.3567 13.7618 8.72168 14.0996L8.86914 14.251C9.18844 14.6203 9.34848 15.0963 9.34863 15.6191L9.33984 15.835C9.29463 16.335 9.08891 16.8227 8.69238 17.2988L8.68555 17.3066L8.68164 17.3096L7.49902 18.7256C7.44278 18.7934 7.48407 18.9129 7.6084 18.9131H8.80371L8.94238 18.9258C9.25544 18.9848 9.49955 19.2392 9.5 19.5557V19.8555L9.48438 19.9873C9.42749 20.2411 9.2108 20.4356 8.94238 20.4863L8.80371 20.5H5.15234C4.84365 20.4999 4.57586 20.2975 4.51367 20.0195L4.5 19.8945C4.50021 19.7594 4.54974 19.6279 4.63867 19.5225L7.05566 16.6631L7.06152 16.6553L7.0625 16.6533L7.19043 16.498L7.28613 16.3701C7.45574 16.1263 7.51556 15.9437 7.5293 15.7578L7.53223 15.665C7.53217 15.5028 7.49891 15.385 7.44824 15.3018L7.3916 15.2285C7.33321 15.1697 7.24451 15.1199 7.1084 15.0986L6.95508 15.0869C6.72797 15.087 6.56945 15.1687 6.46484 15.3164L6.41309 15.4033C6.29395 15.6281 6.04189 15.8528 5.71094 15.8604H5.70312L5.69531 15.8594L5.58105 15.8516L5.56641 15.8496L5.20117 15.7861C4.88002 15.7303 4.57389 15.4379 4.67578 15.0654L4.67773 15.0586L4.72949 14.9023L4.73145 14.8965L4.79688 14.7432C5.15547 13.9934 5.98042 13.5003 6.98438 13.5L7.24902 13.5107ZM19 16C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H13C12.4477 18 12 17.5523 12 17C12 16.4477 12.4477 16 13 16H19ZM7.47168 4.01367C7.76736 4.07302 7.99986 4.32914 8 4.65039V10.3506L7.98633 10.4844C7.92311 10.7841 7.65172 10.9995 7.3418 11H6.93555C6.62532 11 6.35243 10.7845 6.28906 10.4844L6.27637 10.3506V6.57129L6.27148 6.54102C6.25334 6.48246 6.18349 6.43316 6.10742 6.45312L6.06934 6.46875L5.99414 6.5127C5.59592 6.74345 5.07156 6.50612 5.00684 6.04883L5 5.95312V5.5957C5.0001 5.35978 5.13069 5.14721 5.33105 5.0332L6.99219 4.08789L7.00098 4.08301L7.0625 4.05371L7.07031 4.0498L7.19238 4.01367C7.23444 4.00524 7.27776 4.00004 7.32129 4H7.3418L7.47168 4.01367ZM19 6C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H13C12.4477 8 12 7.55228 12 7C12 6.44772 12.4477 6 13 6H19Z" }) });
});
ListNumberedIcon.displayName = "ListNumberedIcon";

const LocalizeIcon = forwardRef$1(function LocalizeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1572 11.3008C15.8444 9.6694 18.1556 9.6694 18.8428 11.3008L21.9218 18.6124C22.136 19.1213 21.8966 19.7076 21.3877 19.9219C20.8789 20.1359 20.2925 19.8973 20.0782 19.3886L19.4932 18H14.5068L13.9219 19.3886C13.7075 19.8973 13.1212 20.1359 12.6124 19.9219C12.1034 19.7076 11.864 19.1213 12.0781 18.6124L15.1572 11.3008ZM15.3486 16H18.6514L17 12.0772L15.3486 16Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3C8.5523 3 9 3.4477 9 4V5H12C12.5522 5 13 5.4477 13 6C13 6.5523 12.5522 7 12 7H11.3711C11.0587 8.911 10.4435 10.5232 9.4375 11.8174C10.1886 12.3427 11.1111 12.7472 12.2431 13.0303C12.7789 13.1642 13.1046 13.7074 12.9707 14.2432C12.8366 14.7787 12.2935 15.1046 11.7578 14.9707C10.2964 14.6053 9.041 14.0412 8 13.2432C6.9589 14.0407 5.7033 14.6045 4.2422 14.9698C3.7065 15.1034 3.1642 14.7779 3.0303 14.2422C2.8964 13.7064 3.2221 13.1633 3.7578 13.0292C4.8895 12.7463 5.8124 12.3424 6.5635 11.8174C5.5575 10.5232 4.9422 8.911 4.6299 7H4C3.4477 7 3 6.5523 3 6C3 5.4477 3.4477 5 4 5H7V4C7 3.4477 7.4477 3 8 3ZM6.6582 7C6.924 8.4134 7.3744 9.5255 8 10.3994C8.6258 9.5254 9.0759 8.4135 9.3418 7H6.6582Z" })] });
});
LocalizeIcon.displayName = "LocalizeIcon";

const LockAspectRatioIcon = forwardRef$1(function LockAspectRatioIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M19 6C19 5.44771 18.5523 5 18 5H6C5.44771 5 5 5.44771 5 6V18C5 18.5523 5.44771 19 6 19H18C18.5523 19 19 18.5523 19 18V6ZM21 18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18Z" }), jsx("path", { fill: "currentColor", d: "M7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12V15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H8C7.44772 17 7 16.5523 7 16V12Z" }), jsx("path", { fill: "currentColor", d: "M17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12V9L12 9C11.4477 9 11 8.55228 11 8C11 7.44771 11.4477 7 12 7L16 7C16.5523 7 17 7.44772 17 8V12Z" })] });
});
LockAspectRatioIcon.displayName = "LockAspectRatioIcon";

const LockIcon = forwardRef$1(function LockIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C14.7614 2 17 4.23857 17 7V9C18.6569 9 20 10.3431 20 12V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V12C4 10.3431 5.34315 9 7 9V7C7 4.23858 9.23858 2 12 2ZM7 11C6.4477 11 6 11.4477 6 12V19C6 19.5523 6.4477 20 7 20H17C17.5523 20 18 19.5523 18 19V12C18 11.4477 17.5523 11 17 11H7ZM12 13C12.5523 13 13 13.4477 13 14V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14C11 13.4477 11.4477 13 12 13ZM12 4C10.3431 4 9 5.34314 9 7V9H15V7C15 5.34315 13.6568 4 12 4Z" }) });
});
LockIcon.displayName = "LockIcon";

const LogoutIcon = forwardRef$1(function LogoutIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.5947 2.00488C13.0988 2.05614 13.4921 2.48238 13.4922 3C13.4922 3.51771 13.0989 3.94383 12.5947 3.99512L12.4922 4H8.36133C7.65654 4 7.00013 4.61592 7 5.48242V18.998C7.00021 19.5502 7.44784 19.998 8 19.998H16.3945C16.9467 19.998 17.3943 19.5501 17.3945 18.998V12.9297C17.3947 12.3775 17.8423 11.9297 18.3945 11.9297C18.9467 11.9297 19.3944 12.3776 19.3945 12.9297V18.998C19.3943 20.6547 18.0512 21.998 16.3945 21.998H8C6.34327 21.998 5.00021 20.6547 5 18.998V5.48242C5.00014 3.60715 6.45854 2 8.36133 2H12.4922L12.5947 2.00488ZM14.125 12C14.7461 12.0001 15.25 12.5039 15.25 13.125C15.2499 13.7461 14.7461 14.2499 14.125 14.25C13.5039 14.25 13.0001 13.7461 13 13.125C13 12.5038 13.5038 12 14.125 12ZM18.1484 3.50391C18.5389 3.1136 19.172 3.11371 19.5625 3.50391L21.707 5.64844C21.8944 5.83589 21.9999 6.09042 22 6.35547C21.9999 6.62053 21.8944 6.87504 21.707 7.0625L19.5625 9.20703C19.172 9.59713 18.5388 9.59729 18.1484 9.20703C17.7581 8.81649 17.758 8.18246 18.1484 7.79199L18.585 7.35547H14.5L14.3975 7.34961C13.8935 7.29825 13.5001 6.87299 13.5 6.35547C13.5001 5.83792 13.8934 5.41167 14.3975 5.36035L14.5 5.35547H18.5859L18.1484 4.91797C17.7582 4.52746 17.7581 3.89435 18.1484 3.50391Z" }) });
});
LogoutIcon.displayName = "LogoutIcon";

const MailBounceIcon = forwardRef$1(function MailBounceIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.995 4A3.004 3.004 0 0 1 22 7v2a1 1 0 0 1-2 0V7.204l-6.468 4.327a2.73 2.73 0 0 1-3.064 0L4 7.203V17a1 1 0 0 0 1 1h6.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h13.995ZM11.58 9.869a.731.731 0 0 0 .84 0L18.202 6H5.798l5.782 3.867Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M15.999 17.7a.999.999 0 0 1 1.028 1.33l-.01.032c-.002.003-.002.006-.002.007l-.059.139c-.16.308-.472.516-.825.539a1.003 1.003 0 0 1-.963-.56l-.001-.005-.014-.026A1 1 0 0 1 16 17.7Zm-2.786-2.405a1 1 0 0 1 1.333-.141l.08.064.039.034.048.044a1 1 0 0 1-1.263 1.547l-.08-.064-.035-.032-.044-.04a1 1 0 0 1-.078-1.412ZM18 15a1 1 0 0 1 .045 1.998 1 1 0 0 1-.304-1.975l.102-.015.157-.007Zm-6.933-1.5a1 1 0 0 1-.021 2H11a1 1 0 1 1 0-2h.067ZM21 11a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" })] });
});
MailBounceIcon.displayName = "MailBounceIcon";

const MailClickIcon = forwardRef$1(function MailClickIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.536 13.536a1 1 0 0 1 1.001-.25l6 1.847a1 1 0 0 1 .153 1.85l-2.471 1.235-1.236 2.472a1 1 0 0 1-1.85-.153l-1.846-6a1 1 0 0 1 .25-1.001Zm2.775 4.026.268-.536c.097-.194.254-.35.447-.447l.537-.269-1.81-.557.558 1.809Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.995 4A3.004 3.004 0 0 1 22 7v5a1 1 0 0 1-2 0V7.204l-6.468 4.327a2.73 2.73 0 0 1-3.064 0L4 7.203V17a1 1 0 0 0 1 1h6.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h13.995ZM11.58 9.869a.731.731 0 0 0 .84 0L18.202 6H5.798l5.782 3.867Z", clipRule: "evenodd" })] });
});
MailClickIcon.displayName = "MailClickIcon";

const MailOpenIcon = forwardRef$1(function MailOpenIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20.31 16.275a1 1 0 0 1 1.38 1.45l-4.2 4a1 1 0 0 1-1.38 0l-1.8-1.716a1 1 0 0 1 1.38-1.448l1.109 1.057 3.512-3.343Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.39 3.442a3.15 3.15 0 0 1 3.218 0l6.925 4.116A3 3 0 0 1 22 10.138V13a1 1 0 0 1-2 0v-.306l-4.098 2.361.264.177a1 1 0 0 1-1.111 1.662l-2.635-1.761a.73.73 0 0 0-.84 0L5.798 19H11a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3v-7.863C2 9.08 2.558 8.1 3.467 7.558l6.923-4.116ZM4 17.797l4.093-2.739L4 12.711v5.086ZM12.586 5.16a1.15 1.15 0 0 0-1.174 0L4.49 9.278a1 1 0 0 0-.489.86v.267l5.948 3.412.52-.347a2.73 2.73 0 0 1 3.064 0l.518.346 5.95-3.43v-.248a1 1 0 0 0-.49-.86l-6.924-4.117Z", clipRule: "evenodd" })] });
});
MailOpenIcon.displayName = "MailOpenIcon";

const MailSendIcon = forwardRef$1(function MailSendIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.29 13.543a1.002 1.002 0 0 1 1.115-.12l5.548 2.936a1 1 0 0 1 0 1.767l-5.548 2.937a1 1 0 0 1-1.417-1.2l.875-2.62-.875-2.621a1 1 0 0 1 .302-1.08Zm2.575 3.383a.994.994 0 0 1 0 .633l-.188.57 1.672-.886-1.672-.886.188.57Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M13 19a1 1 0 1 1 0 2h-1a1 1 0 0 1 0-2h1Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.995 4A3.004 3.004 0 0 1 22 7v5a1 1 0 0 1-2 0V7.204l-6.468 4.327a2.73 2.73 0 0 1-3.064 0L4 7.203V17a1 1 0 0 0 1 1h2a1 1 0 0 1 0 2H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h13.995ZM11.58 9.869a.731.731 0 0 0 .84 0L18.202 6H5.798l5.782 3.867Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M13 16a1 1 0 1 1 0 2h-3a1 1 0 0 1 0-2h3Z" })] });
});
MailSendIcon.displayName = "MailSendIcon";

const MailIcon = forwardRef$1(function MailIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.9981 7.74707L13.8994 12.7383C12.7945 13.6419 11.2055 13.6419 10.1006 12.7383L4.00098 7.74707C4.00032 7.88275 4 8.03297 4 8.2002V15.7998C4 16.3763 4.00127 16.7488 4.02442 17.0322C4.04661 17.3038 4.08419 17.4046 4.10938 17.4541C4.20522 17.642 4.35793 17.7948 4.5459 17.8906C4.59534 17.9158 4.69613 17.9544 4.96778 17.9766C5.25111 17.9997 5.62365 18 6.2002 18H17.7998C18.3764 18 18.7488 17.9997 19.0322 17.9766C19.3038 17.9544 19.4046 17.9158 19.4541 17.8906C19.6421 17.7948 19.7948 17.642 19.8906 17.4541C19.9158 17.4046 19.9544 17.3038 19.9766 17.0322C19.9997 16.7488 20 16.3763 20 15.7998V8.2002C20 8.03297 19.9987 7.88275 19.9981 7.74707ZM6.2002 6C5.67567 6 5.3201 6.00199 5.04688 6.01954L11.3672 11.1895C11.7355 11.4908 12.2645 11.4908 12.6328 11.1895L18.9522 6.01954C18.679 6.00205 18.3237 6 17.7998 6H6.2002ZM22 15.7998C22 16.3433 22.0011 16.8117 21.9697 17.1953C21.9374 17.5906 21.8656 17.984 21.6729 18.3623C21.3853 18.9266 20.9266 19.3853 20.3623 19.6729C19.984 19.8656 19.5906 19.9374 19.1953 19.9697C18.8117 20.0011 18.3434 20 17.7998 20H6.2002C5.65665 20 5.18836 20.0011 4.80469 19.9697C4.40944 19.9374 4.016 19.8656 3.6377 19.6729C3.07346 19.3853 2.61473 18.9266 2.32715 18.3623C2.13441 17.984 2.06259 17.5906 2.03028 17.1953C1.99893 16.8117 2 16.3433 2 15.7998V8.2002C2 7.65665 1.99893 7.18836 2.03028 6.80469C2.06259 6.40944 2.13441 6.016 2.32715 5.6377C2.61473 5.07348 3.07348 4.61473 3.6377 4.32715C4.016 4.13441 4.40944 4.06259 4.80469 4.03028C5.18836 3.99893 5.65665 4 6.2002 4H17.7998C18.3434 4 18.8117 3.99893 19.1953 4.03028C19.5906 4.06259 19.984 4.13441 20.3623 4.32715C20.9266 4.61473 21.3853 5.07346 21.6729 5.6377C21.8656 6.016 21.9374 6.40944 21.9697 6.80469C22.0011 7.18836 22 7.65665 22 8.2002V15.7998Z" }) });
});
MailIcon.displayName = "MailIcon";

const ManagerIcon = forwardRef$1(function ManagerIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 14.8347 20.8192 17.3943 18.9258 19.2129L18.5381 19.5664C16.7855 21.082 14.4987 22 12 22C9.6575 22 7.50129 21.1933 5.79688 19.8438L5.46191 19.5664C3.34326 17.7342 2 15.0235 2 12C2 6.47716 6.47716 2 12 2ZM12 17C10.2094 17 8.70362 17.6366 7.58984 18.6748C8.85429 19.5122 10.3692 20 12 20C13.631 20 15.1456 19.5114 16.4102 18.6738C15.2964 17.6359 13.7904 17 12 17ZM12 4C7.58172 4 4 7.58172 4 12C4 14.0649 4.78291 15.9452 6.06836 17.3652C7.56251 15.8956 9.61274 15 12 15C14.387 15 16.4366 15.8959 17.9307 17.3652C19.2164 15.9452 20 14.0652 20 12C20 7.58172 16.4183 4 12 4ZM12 6C14.2092 6 16 7.79088 16 10C16 12.2092 14.2092 14 12 14C9.79082 14 8 12.2092 8 10C8 7.79088 9.7908 6 12 6ZM12 8C10.8954 8 10 8.89542 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89542 13.1046 8 12 8Z" }) });
});
ManagerIcon.displayName = "ManagerIcon";

const MapIcon = forwardRef$1(function MapIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M8.13086 4.00586C8.63512 4.05707 9.0293 4.48321 9.0293 5.00098V6.62695H10.6758L10.7783 6.63184C11.2822 6.68341 11.6758 7.10945 11.6758 7.62695C11.6753 8.14408 11.282 8.56959 10.7783 8.62109L10.6758 8.62695H9.0293V14.6279C9.02903 15.1798 8.58112 15.6276 8.0293 15.6279H6.70605C6.03266 15.6279 5.5 16.1678 5.5 16.8164L5.50586 16.9365C5.56712 17.5299 6.075 18.0039 6.70605 18.0039H17.7334C18.1628 18.0037 18.4977 17.6604 18.498 17.2539V13.7529C18.498 13.2006 18.9458 12.7529 19.498 12.7529C20.0502 12.7531 20.498 13.2008 20.498 13.7529V17.2539C20.4977 18.78 19.2523 20.0037 17.7334 20.0039H6.70605C4.99837 20.0039 3.59028 18.6712 3.50391 16.9805L3.5 16.8164V7.18848C3.50026 5.42049 4.94339 4.00098 6.70605 4.00098H8.0293L8.13086 4.00586ZM6.70605 6.00098C6.03283 6.00098 5.50026 6.54013 5.5 7.18848V13.8623C5.87269 13.7117 6.28017 13.6279 6.70605 13.6279H7.0293V6.00098H6.70605ZM16.8516 4.00098C18.8578 4.00128 20.498 5.61727 20.498 7.62695C20.4977 9.13813 19.5895 10.2629 18.8477 10.9375C18.4633 11.287 18.0825 11.5533 17.7998 11.7324C17.6575 11.8226 17.5374 11.893 17.4502 11.9414C17.4066 11.9656 17.3709 11.9844 17.3447 11.998C17.3317 12.0049 17.3207 12.0105 17.3125 12.0146L17.2969 12.0225H17.2959V12.0234C17.0162 12.1622 16.687 12.1619 16.4072 12.0234L16.8516 11.127L16.4062 12.0225H16.4053L16.4043 12.0215C16.4033 12.021 16.4017 12.0202 16.4004 12.0195C16.3976 12.0182 16.3936 12.0166 16.3896 12.0146C16.3815 12.0105 16.3703 12.0048 16.3574 11.998C16.3313 11.9844 16.2953 11.9655 16.252 11.9414C16.1648 11.893 16.0445 11.8225 15.9023 11.7324C15.6198 11.5534 15.2396 11.2867 14.8555 10.9375C14.1136 10.2629 13.2045 9.13815 13.2041 7.62695C13.2041 5.61708 14.8451 4.00098 16.8516 4.00098ZM16.8516 6.00098C15.9345 6.00098 15.2041 6.7367 15.2041 7.62695C15.2045 8.30296 15.6201 8.92961 16.2012 9.45801C16.4278 9.66395 16.6578 9.83383 16.8506 9.96289C17.0437 9.83363 17.2748 9.66455 17.502 9.45801C18.083 8.92961 18.4977 8.30296 18.498 7.62695C18.498 6.73689 17.7683 6.00128 16.8516 6.00098Z" }) });
});
MapIcon.displayName = "MapIcon";

const MeetingIcon = forwardRef$1(function MeetingIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.999 3C16.5512 3 16.9989 3.44783 16.999 4V4.88281H17.999C19.598 4.88281 20.999 6.11756 20.999 7.76562V18.1191C20.9989 19.7671 19.5979 21.001 17.999 21.001H6C4.40127 21.0008 3.00014 19.767 3 18.1191V7.76562C3 6.11764 4.40118 4.88295 6 4.88281H7V4C7.00013 3.44783 7.4478 3 8 3C8.55215 3.00006 8.99987 3.44786 9 4V4.88281H14.999V4C14.9992 3.44799 15.447 3.00026 15.999 3ZM5 18.1191C5.00015 18.5503 5.3902 19.0008 6 19.001H17.999C18.609 19.001 18.9989 18.5503 18.999 18.1191V11.5889H5V18.1191ZM6 6.88281C5.39009 6.88295 5 7.33444 5 7.76562V9.58887H18.999V7.76562C18.999 7.33437 18.6091 6.88281 17.999 6.88281H6Z" }) });
});
MeetingIcon.displayName = "MeetingIcon";

const MergeIcon = forwardRef$1(function MergeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 3C4.55207 3.00026 5 3.44787 5 4L5.00391 4.41699C5.04381 6.45587 5.38339 7.81811 6.03516 8.78223C6.69782 9.76211 7.78851 10.4805 9.6543 10.998H17.4502L15.4551 9.14551C15.0506 8.76968 15.0276 8.13706 15.4033 7.73242C15.7791 7.32812 16.4118 7.30412 16.8164 7.67969L20.6777 11.2656L20.75 11.3398C20.9084 11.5211 20.997 11.755 20.9971 11.998C20.997 12.276 20.8813 12.5423 20.6777 12.7314L16.8164 16.3164L16.7373 16.3828C16.3332 16.6879 15.7556 16.6434 15.4033 16.2646C15.0511 15.8853 15.0493 15.3055 15.3838 14.9248L15.4551 14.8516L17.4512 12.998H9.65723C7.78946 13.5157 6.69815 14.2343 6.03516 15.2148C5.38335 16.179 5.04378 17.541 5.00391 19.5801L5 19.9971L4.99512 20.0996C4.94367 20.6035 4.51737 20.9968 4 20.9971C3.48252 20.997 3.05636 20.6035 3.00488 20.0996L3 19.9971L3.00391 19.5488C3.04612 17.3368 3.4137 15.521 4.37793 14.0947C4.9762 13.2098 5.7676 12.5294 6.74512 11.998C5.76787 11.4668 4.97611 10.787 4.37793 9.90234C3.41361 8.47589 3.04606 6.65964 3.00391 4.44727L3 4C3 3.44777 3.4478 3.00009 4 3Z" }) });
});
MergeIcon.displayName = "MergeIcon";

const MessagesIcon = forwardRef$1(function MessagesIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M19.5 2C21.1568 2 22.5 3.34315 22.5 5V11C22.5 12.6569 21.1568 14 19.5 14H19C18.4477 14 18 13.5523 18 13C18 12.4477 18.4477 12 19 12H19.5C20.0523 12 20.5 11.5523 20.5 11V5.25586L17 7.5C15.9635 8.288 14.5369 8.31674 13.4688 7.57227L9.49998 5.21875V6C9.49998 6.55228 9.05227 7 8.49998 7C7.9477 7 7.49998 6.55228 7.49998 6V5C7.49998 3.34315 8.84313 2 10.5 2H19.5ZM14.6123 5.93164C14.9684 6.1798 15.4436 6.1699 15.7891 5.90723L18.8476 4H11.249L14.6123 5.93164Z" }), jsx("path", { fill: "currentColor", d: "M14 11.7559C13.9999 11.3115 13.6557 10.9963 13.2861 10.9961H4.71387C4.34425 10.9963 4.00012 11.3114 4 11.7559V17.0361C4.00002 17.4807 4.34419 17.7957 4.71387 17.7959H5.57129C6.12351 17.7959 6.57118 18.2437 6.57129 18.7959V19.2744L8.93359 17.9277L9.0498 17.8711C9.1697 17.822 9.29833 17.7959 9.42871 17.7959H13.2861C13.6558 17.7957 14 17.4807 14 17.0361V11.7559ZM16 17.0361C16 18.5354 14.8095 19.7957 13.2861 19.7959H9.69434L6.06641 21.8643C5.75691 22.0407 5.37741 22.0393 5.06934 21.8604C4.76125 21.6814 4.57129 21.3524 4.57129 20.9961V19.7881C3.11687 19.712 2.00002 18.4882 2 17.0361V11.7559C2.00012 10.2568 3.19044 8.99632 4.71387 8.99609H13.2861C14.8095 8.99632 15.9999 10.2567 16 11.7559V17.0361Z" })] });
});
MessagesIcon.displayName = "MessagesIcon";

const MetricIcon = forwardRef$1(function MetricIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M20 18.9999C20.5523 18.9999 21 19.4476 21 19.9999C21 20.5522 20.5523 20.9999 20 20.9999H4C3.44774 20.9999 3.00004 20.5522 3 19.9999C3 19.4476 3.44772 18.9999 4 18.9999H20ZM17.293 6.29289C17.6835 5.90237 18.3165 5.90237 18.707 6.29289C19.0976 6.68342 19.0976 7.31643 18.707 7.70696L15 11.414C14.625 11.789 14.1163 11.9999 13.5859 11.9999H10.4141L6.70703 15.707C6.31651 16.0975 5.68349 16.0975 5.29297 15.707C4.90244 15.3164 4.90244 14.6834 5.29297 14.2929L9 10.5859L9.14648 10.453C9.50237 10.1614 9.94989 9.99996 10.4141 9.99992H13.5859L17.293 6.29289Z" }) });
});
MetricIcon.displayName = "MetricIcon";

const MobilePhoneIcon = forwardRef$1(function MobilePhoneIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15 1C17.2091 1 19 2.79086 19 5V19C19 21.2091 17.2091 23 15 23H9C6.79086 23 5 21.2091 5 19V5C5 2.79086 6.79086 1 9 1H15ZM9 3C7.89543 3 7 3.89543 7 5V19C7 20.1046 7.89543 21 9 21H15C16.1046 21 17 20.1046 17 19V5C17 3.89543 16.1046 3 15 3H9ZM14 17C14.5523 17 15 17.4477 15 18C15 18.5523 14.5523 19 14 19H10C9.44772 19 9 18.5523 9 18C9 17.4477 9.44772 17 10 17H14Z" }) });
});
MobilePhoneIcon.displayName = "MobilePhoneIcon";

const ModelIcon = forwardRef$1(function ModelIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M14.9092 13.4272C15.7879 12.5486 17.2121 12.5486 18.0908 13.4272L19.5049 14.8413C20.3836 15.72 20.3836 17.1443 19.5049 18.0229L18.0908 19.437C17.2121 20.3157 15.7879 20.3157 14.9092 19.437L13.4951 18.0229C12.6164 17.1443 12.6164 15.72 13.4951 14.8413L14.9092 13.4272ZM8.5 12.9995C9.88057 12.9995 10.9998 14.119 11 15.4995V17.4995C11 18.8802 9.88069 19.9995 8.5 19.9995H6.5C5.11929 19.9995 4 18.8802 4 17.4995V15.4995C4.00019 14.119 5.11941 12.9995 6.5 12.9995H8.5ZM16.6768 14.8413C16.5791 14.7437 16.4209 14.7437 16.3232 14.8413L14.9092 16.2554C14.8115 16.353 14.8115 16.5113 14.9092 16.6089L16.3232 18.0229C16.4209 18.1206 16.5791 18.1206 16.6768 18.0229L18.0908 16.6089C18.1885 16.5113 18.1885 16.353 18.0908 16.2554L16.6768 14.8413ZM6.5 14.9995C6.22398 14.9995 6.00019 15.2235 6 15.4995V17.4995C6 17.7757 6.22386 17.9995 6.5 17.9995H8.5C8.77612 17.9995 9 17.7756 9 17.4995V15.4995C8.99981 15.2236 8.776 14.9995 8.5 14.9995H6.5ZM6.33301 5.02979C6.92735 4.28629 8.0746 4.28629 8.66895 5.02979L8.78711 5.20068L10.9043 8.729C11.5032 9.72847 10.7834 11 9.61816 11.0005H5.38379C4.21819 11.0003 3.49832 9.72864 4.09766 8.729L6.21484 5.20068L6.33301 5.02979ZM16.5 4.00049C18.433 4.00049 20 5.56749 20 7.50049C19.9997 9.43326 18.4328 11.0005 16.5 11.0005C14.5672 11.0005 13.0003 9.43324 13 7.50049C13 5.56752 14.567 4.00053 16.5 4.00049ZM6.2666 9.00049H8.73535L7.50098 6.94385L6.2666 9.00049ZM16.5 6.00049C15.6716 6.00053 15 6.67208 15 7.50049C15.0003 8.32867 15.6718 9.00045 16.5 9.00049C17.3283 9.00049 17.9997 8.32869 18 7.50049C18 6.67206 17.3284 6.00049 16.5 6.00049Z" }) });
});
ModelIcon.displayName = "ModelIcon";

const MonitorIcon = forwardRef$1(function MonitorIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19 5C20.6569 5 22 6.34315 22 8V16C22 17.6569 20.6569 19 19 19H14.8682L15.832 20.4453C16.0366 20.7521 16.0557 21.1466 15.8818 21.4717C15.7078 21.7968 15.3688 22 15 22H9C8.6312 22 8.29218 21.7968 8.11816 21.4717C7.94426 21.1466 7.96344 20.7521 8.16797 20.4453L9.13184 19H5C3.34315 19 2 17.6569 2 16V8C2 6.34315 3.34315 5 5 5H19ZM10.8682 20H13.1318L12.4648 19H11.5352L10.8682 20ZM5 7C4.44771 7 4 7.44771 4 8V16C4 16.5523 4.4477 17 5 17H19C19.5523 17 20 16.5523 20 16V8C20 7.4477 19.5523 7 19 7H5Z" }) });
});
MonitorIcon.displayName = "MonitorIcon";

const MoonStarIcon = forwardRef$1(function MoonStarIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1602 2.00291C11.5463 1.9702 11.9168 2.16388 12.1113 2.49901C12.3057 2.83409 12.2902 3.25131 12.0703 3.5703C11.4032 4.53816 11.0127 5.71027 11.0127 6.97655C11.0128 10.2962 13.7038 12.9873 17.0234 12.9873C18.2898 12.9873 19.4619 12.5967 20.4297 11.9297C20.7486 11.7099 21.1659 11.6934 21.501 11.8877C21.836 12.0822 22.0297 12.4528 21.9971 12.8389C21.5625 17.9707 17.2603 21.9999 12.0166 22C6.48474 22 2 17.5153 2 11.9834C2.00009 6.73983 6.02861 2.43789 11.1602 2.00291ZM9.43359 4.39647C6.27593 5.47107 4.00398 8.46204 4.00391 11.9834C4.00391 16.4086 7.59132 19.9961 12.0166 19.9961C15.538 19.996 18.529 17.7241 19.6035 14.5664C18.7935 14.8417 17.9255 14.9912 17.0234 14.9912C12.5972 14.9912 9.00892 11.4027 9.00879 6.97655C9.00879 6.0746 9.15833 5.20646 9.43359 4.39647Z", fill: "currentColor" }), jsx("path", { d: "M17.0762 3.36424C17.2607 2.99505 17.788 2.99504 17.9727 3.36424L18.7852 4.99022C18.8336 5.08715 18.9128 5.16538 19.0098 5.21385L20.6357 6.02733C21.005 6.21196 21.005 6.73923 20.6357 6.92381L19.0098 7.73631C18.9128 7.78478 18.8336 7.86399 18.7852 7.96092L17.9727 9.5869C17.788 9.95591 17.2607 9.95595 17.0762 9.5869L16.2637 7.96092C16.2152 7.86399 16.1359 7.78479 16.0391 7.73631L14.4131 6.92381C14.0439 6.73923 14.044 6.21198 14.4131 6.02733L16.0391 5.21385C16.1359 5.16538 16.2152 5.08717 16.2637 4.99022L17.0762 3.36424Z", fill: "currentColor" })] });
});
MoonStarIcon.displayName = "MoonStarIcon";

const MoonIcon = forwardRef$1(function MoonIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.16 2.003a1.003 1.003 0 0 1 .91 1.567 6.01 6.01 0 0 0 8.36 8.36 1.002 1.002 0 0 1 1.567.909c-.434 5.132-4.737 9.16-9.98 9.161C6.485 22 2 17.515 2 11.983c0-5.243 4.029-9.545 9.16-9.98ZM9.434 4.396a8.013 8.013 0 1 0 10.17 10.17 8.015 8.015 0 0 1-10.17-10.17Z", clipRule: "evenodd" }) });
});
MoonIcon.displayName = "MoonIcon";

const MoveIcon = forwardRef$1(function MoveIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M14.2933 18.0432C14.6838 17.6527 15.3169 17.6527 15.7074 18.0432C16.0974 18.4338 16.0977 19.0669 15.7074 19.4573L14.1214 21.0432C12.95 22.2145 11.0497 22.2145 9.87829 21.0432L8.29332 19.4573C7.90284 19.0668 7.90291 18.4338 8.29332 18.0432C8.68385 17.6527 9.31686 17.6527 9.70739 18.0432L11.2933 19.6282C11.6838 20.0185 12.317 20.0185 12.7074 19.6282L14.2933 18.0432Z", fill: "currentColor" }), jsx("path", { d: "M4.54332 8.29325C4.93385 7.90273 5.56686 7.90273 5.95739 8.29325C6.34744 8.68381 6.34775 9.31694 5.95739 9.70731L4.37145 11.2932C3.98119 11.6837 3.98103 12.3169 4.37145 12.7073L5.95739 14.2932C6.34744 14.6838 6.34775 15.3169 5.95739 15.7073C5.56701 16.0976 4.93385 16.0973 4.54332 15.7073L2.95739 14.1214C1.78582 12.9499 1.7859 11.0497 2.95739 9.87821L4.54332 8.29325Z", fill: "currentColor" }), jsx("path", { d: "M18.0433 8.29325C18.4338 7.90273 19.0669 7.90273 19.4574 8.29325L21.0433 9.87821C22.2146 11.0497 22.2147 12.9499 21.0433 14.1214L19.4574 15.7073C19.067 16.0976 18.4338 16.0973 18.0433 15.7073C17.6528 15.3168 17.6529 14.6838 18.0433 14.2932L19.6283 12.7073C20.0187 12.3169 20.0186 11.6837 19.6283 11.2932L18.0433 9.70731C17.6528 9.31682 17.6529 8.68378 18.0433 8.29325Z", fill: "currentColor" }), jsx("path", { d: "M9.87829 2.95731C11.0498 1.78571 12.9499 1.78571 14.1214 2.95731L15.7074 4.54325C16.0974 4.93381 16.0977 5.56694 15.7074 5.95731C15.317 6.34757 14.6838 6.34733 14.2933 5.95731L12.7074 4.37137C12.317 3.98092 11.6838 3.981 11.2933 4.37137L9.70739 5.95731C9.31701 6.34756 8.68385 6.34733 8.29332 5.95731C7.90284 5.56682 7.90291 4.93378 8.29332 4.54325L9.87829 2.95731Z", fill: "currentColor" })] });
});
MoveIcon.displayName = "MoveIcon";

const MuseIcon = forwardRef$1(function MuseIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5.91024 4C6.77684 4 7.39658 4.67666 7.39658 5.73832C7.39653 6.79973 7.22541 7.75727 6.94149 9.79012C6.73792 11.2145 6.38888 13.389 6.24325 14.2931C6.52285 13.7585 7.17786 12.5091 7.29403 12.2745C8.66605 9.50557 10.0959 7.03196 10.508 6.37699C11.0544 5.50256 11.535 5.15237 12.2785 5.15237C12.6646 5.1524 13.124 5.34745 13.3517 5.60744C13.6604 5.96037 13.7248 6.52934 13.714 7.14946C13.6979 8.10067 13.5745 9.61727 13.4054 11.3077C13.3301 12.0603 13.1849 13.5966 13.0871 14.6271C13.9654 13.0557 15.5908 10.1656 16.2463 9.15632C16.8177 8.27657 17.3921 7.71004 18.1643 7.71001C18.8305 7.71001 19.6517 8.1809 19.6028 9.43268C19.5308 11.2803 19.2644 15.3046 19.1428 17.1105C19.9601 15.9209 21.0333 14.16 21.4358 13.4982C21.8428 12.8289 22.2603 12.288 22.8938 12.2696C23.544 12.2508 23.9794 12.6928 23.9993 13.3751C24.019 14.0576 23.6123 14.8251 23.0725 15.6965C22.4868 16.642 21.8312 17.654 21.0335 18.5988C20.2358 19.5436 19.5027 20.2618 18.384 20.2619C17.382 20.2619 16.6771 19.5961 16.6281 18.3771C16.6026 17.7384 16.7235 16.3647 16.8147 15.2912C16.9202 14.048 17.0478 12.8476 17.1369 12.0538C16.2563 13.6665 14.4026 17.0432 13.5685 18.3615C12.7524 19.6512 12.3547 20.1055 11.4933 20.1057C10.6316 20.1057 10.2536 19.485 10.2413 18.551C10.2275 17.5379 10.9886 11.4547 11.2462 9.42781C10.8285 10.3217 9.80148 12.5163 9.15734 13.8214C8.53419 15.0843 7.48905 17.2665 6.73055 18.5236C6.18411 19.4293 5.57028 20.1056 4.66021 20.1057C3.75009 20.1057 3.23637 19.4939 3.23637 18.51C3.23637 17.5261 3.52123 15.8868 3.82721 13.8536C3.98019 12.8697 4.15464 11.7982 4.35161 10.6612C4.49583 9.83846 4.74639 8.39097 4.90045 7.502C4.20053 8.59186 2.9409 10.5536 2.55764 11.1446C2.1315 11.8019 1.74901 12.2812 1.11525 12.2813C0.415901 12.2813 0.000127898 11.7355 0 11.1017C0 10.4678 0.322379 9.97919 0.845713 9.11922C1.51779 8.01407 2.72591 6.50769 3.38774 5.71681C4.1678 4.78476 4.9474 4.00012 5.91024 4Z", fill: "currentColor" }) });
});
MuseIcon.displayName = "MuseIcon";

const NeedsChangesIcon = forwardRef$1(function NeedsChangesIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7225 2.87858C16.8941 1.7071 18.793 1.70718 19.9647 2.87858L20.1385 3.05143C21.3089 4.22196 21.3095 6.11967 20.1404 7.29167L18.2576 9.17838C19.4748 10.6987 20.3893 12.2725 20.7772 13.7536C21.2323 15.4925 20.9769 17.2461 19.4686 18.4528C18.2571 19.4217 16.8946 19.2906 15.8074 18.8415C14.7496 18.4043 13.811 17.6229 13.1668 17.0007C12.7699 16.6172 12.7585 15.9839 13.1414 15.5866C13.5251 15.1894 14.1583 15.1785 14.5555 15.5622C15.1356 16.1226 15.8593 16.6986 16.5711 16.9928C17.2539 17.2749 17.7715 17.2477 18.2186 16.8903C18.9239 16.3258 19.1659 15.4942 18.8426 14.2594C18.5624 13.1897 17.8716 11.932 16.8348 10.6051L15.1551 12.2897C14.5923 12.8537 13.8278 13.1715 13.0311 13.1715H10.8436C10.2916 13.1713 9.84381 12.7235 9.84357 12.1715V9.99967C9.84357 9.2042 10.16 8.44117 10.7225 7.87858L12.1619 6.43815C9.30643 4.90732 6.57286 5.04896 5.14728 6.47428C4.17978 7.442 3.79733 8.97012 4.14045 10.8005C4.4826 12.6252 5.53754 14.6427 7.26838 16.3737C8.2902 17.3955 9.3945 18.1101 10.2977 18.5661C10.7486 18.7937 11.1424 18.9534 11.4393 19.0534C11.7788 19.1677 11.8964 19.1715 11.8436 19.1715C12.3959 19.1715 12.8436 19.6193 12.8436 20.1715C12.8434 20.7237 12.3957 21.1715 11.8436 21.1715C11.5408 21.1714 11.151 21.0659 10.8006 20.9479C10.407 20.8153 9.92571 20.6185 9.39631 20.3512C8.33841 19.8171 7.05147 18.9858 5.85431 17.7887C3.87561 15.81 2.60027 13.4393 2.17463 11.1696C1.75013 8.90559 2.1628 6.63086 3.73322 5.06022C6.1797 2.614 10.2331 2.96233 13.6287 4.97135L15.7225 2.87858ZM18.5506 4.29264C18.16 3.90226 17.5271 3.9022 17.1365 4.29264L12.1365 9.29264C11.9492 9.48015 11.8436 9.73462 11.8436 9.99967V11.1715H13.0311C13.2966 11.1715 13.5515 11.0654 13.7391 10.8776L18.7244 5.87956C19.1141 5.4889 19.1136 4.85568 18.7235 4.46549L18.5506 4.29264Z", fill: "currentColor" }) });
});
NeedsChangesIcon.displayName = "NeedsChangesIcon";

const NewChatIcon = forwardRef$1(function NewChatIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M12 3a1 1 0 1 1 0 2H6a1 1 0 0 0-1 1v8.903a1 1 0 0 0 1 1h1.5a1.5 1.5 0 0 1 1.5 1.5v.558l2.253-1.744.1-.071a1.5 1.5 0 0 1 .818-.243H18a1 1 0 0 0 1-1V12a1 1 0 1 1 2 0v2.903a3 3 0 0 1-3 3h-5.658l-3.697 2.863A1.02 1.02 0 0 1 7 19.959v-2.056H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h6Zm3.376 1.457c.202-.942 1.546-.942 1.748 0l.143.661c.174.81.806 1.442 1.615 1.615l.661.142c.942.202.942 1.547 0 1.75l-.661.142a2.104 2.104 0 0 0-1.615 1.615l-.143.661c-.202.942-1.546.942-1.748 0l-.143-.661a2.104 2.104 0 0 0-1.615-1.615l-.661-.143c-.942-.202-.942-1.547 0-1.749l.661-.142a2.104 2.104 0 0 0 1.615-1.615l.143-.66Z" }) });
});
NewChatIcon.displayName = "NewChatIcon";

const NotificationCheckIcon = forwardRef$1(function NotificationCheckIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M13.793 8.29297C14.1835 7.90247 14.8165 7.90253 15.207 8.29297C15.5976 8.68349 15.5976 9.31651 15.207 9.70703L11.707 13.207C11.3165 13.5975 10.6835 13.5975 10.293 13.207L8.79297 11.707C8.40255 11.3165 8.40255 10.6835 8.79297 10.293C9.18347 9.90247 9.8165 9.90253 10.207 10.293L11 11.0859L13.793 8.29297Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C16.2176 2.0001 19.7757 5.14112 20.2988 9.32617L20.9619 14.6279C21.1856 16.4184 19.7887 17.9999 17.9844 18H16.8994C16.4361 20.2821 14.4189 22 12 22C9.58114 21.9999 7.56388 20.2821 7.10059 18H6.01562C4.21129 17.9998 2.81529 16.4183 3.03906 14.6279L3.70215 9.32617C4.22529 5.14118 7.78245 2.00018 12 2ZM9.1748 18C9.58698 19.1645 10.6943 19.9999 12 20C13.3058 20 14.414 19.1646 14.8262 18H9.1748ZM12 4C8.7911 4.00018 6.08456 6.39008 5.68652 9.57422L5.02344 14.876C4.94888 15.4727 5.41431 15.9998 6.01562 16H17.9844C18.5857 15.9999 19.052 15.4727 18.9775 14.876L18.3145 9.57422C17.9164 6.39 15.209 4.0001 12 4Z", fill: "currentColor" })] });
});
NotificationCheckIcon.displayName = "NotificationCheckIcon";

const NullIcon = forwardRef$1(function NullIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 20C12.5523 20 13 20.4477 13 21V21.0098C13 21.5621 12.5523 22.0098 12 22.0098C11.4478 22.0097 11 21.562 11 21.0098V21C11 20.4478 11.4478 20.0001 12 20ZM7.67578 19.8428C7.91466 19.3959 8.45862 19.1941 8.9375 19.3906C9.41631 19.5874 9.6607 20.1128 9.5166 20.5986L9.48242 20.6953L9.47852 20.7051C9.26851 21.2155 8.68449 21.4597 8.17383 21.25C7.66332 21.0401 7.41947 20.456 7.62891 19.9453L7.63281 19.9355L7.67578 19.8428ZM15.0645 19.3896C15.5437 19.1941 16.0861 19.3974 16.3242 19.8447L16.3682 19.9375L16.3721 19.9463L16.4062 20.043C16.5495 20.5291 16.3034 21.0541 15.8242 21.25C15.3449 21.4458 14.8016 21.2433 14.5635 20.7959L14.5205 20.7031L14.5166 20.6934L14.4824 20.5967C14.3394 20.1107 14.5853 19.5854 15.0645 19.3896ZM6.3418 19.0781C5.95212 19.4694 5.31809 19.4707 4.92676 19.0811C4.53568 18.6914 4.53452 18.0583 4.92383 17.667L6.3418 19.0781ZM17.6533 17.6582C18.0194 17.2922 18.5984 17.2697 18.9912 17.5898L19.0674 17.6582L19.0742 17.665L19.1436 17.7412C19.4637 18.134 19.4403 18.713 19.0742 19.0791C18.7082 19.445 18.129 19.4686 17.7363 19.1484L17.6602 19.0791L17.6533 19.0723L17.585 18.9961C17.2648 18.6034 17.2874 18.0243 17.6533 17.6582ZM4.93164 17.6592C5.32136 17.2684 5.95453 17.2668 6.3457 17.6562C6.73687 18.0459 6.73819 18.68 6.34863 19.0713L6.3418 19.0781L5.63281 18.3721L4.92383 17.667L4.93164 17.6592ZM19.3848 15.0693C19.5805 14.5902 20.1058 14.3443 20.5918 14.4873L20.6885 14.5215L20.6982 14.5254L20.791 14.5684C21.2384 14.8065 21.4409 15.3498 21.2451 15.8291C21.0493 16.3084 20.5242 16.5544 20.0381 16.4111L19.9414 16.377L19.9326 16.373L19.8398 16.3291C19.3926 16.091 19.1892 15.5485 19.3848 15.0693ZM3.30957 14.5225C3.82011 14.3126 4.404 14.5561 4.61426 15.0664C4.82429 15.5771 4.58098 16.1619 4.07031 16.3721L4.06152 16.376C3.55077 16.5861 2.96595 16.3418 2.75586 15.8311C2.54608 15.3205 2.78945 14.7366 3.2998 14.5264L3.30957 14.5225ZM3.10742 11.0098C3.61166 11.061 4.00488 11.4871 4.00488 12.0049C4.00488 12.5226 3.61166 12.9488 3.10742 13L3.00488 13.0049H2.99512C2.44283 13.0049 1.99512 12.5572 1.99512 12.0049C1.99512 11.4526 2.44283 11.0049 2.99512 11.0049H3.00488L3.10742 11.0098ZM21.1074 11.0098C21.6117 11.061 22.0049 11.4871 22.0049 12.0049C22.0049 12.5226 21.6117 12.9488 21.1074 13L21.0049 13.0049H20.9951C20.4428 13.0049 19.9951 12.5572 19.9951 12.0049C19.9951 11.4526 20.4428 11.0049 20.9951 11.0049H21.0049L21.1074 11.0098ZM19.9355 7.63672C20.4453 7.42457 21.0308 7.66517 21.2432 8.1748C21.4554 8.68458 21.2138 9.27008 20.7041 9.48242L20.6953 9.48633C20.1856 9.69852 19.6002 9.45771 19.3877 8.94824C19.1755 8.43855 19.4163 7.85307 19.9258 7.64062L19.9355 7.63672ZM2.75684 8.17578C2.95503 7.69764 3.4815 7.45513 3.9668 7.60059L4.06348 7.63477L4.07324 7.63867L4.16504 7.68262C4.61137 7.92296 4.81156 8.46695 4.61328 8.94531C4.40173 9.45536 3.81676 9.69777 3.30664 9.48633L3.29785 9.48242L3.20508 9.43848C2.75916 9.19802 2.55876 8.65392 2.75684 8.17578ZM17.6621 4.92871C18.0534 4.53942 18.6866 4.54062 19.0762 4.93164C19.4659 5.32297 19.4646 5.95696 19.0732 6.34668L19.0664 6.35352C18.6751 6.74318 18.0411 6.74189 17.6514 6.35059C17.262 5.95939 17.2635 5.32622 17.6543 4.93652L17.6621 4.92871ZM4.92578 4.93066C5.2919 4.56455 5.8709 4.54195 6.26367 4.8623L6.33984 4.93066L6.34668 4.9375L6.41602 5.01367C6.73618 5.40644 6.71273 5.98552 6.34668 6.35156C5.98063 6.71761 5.40156 6.74106 5.00879 6.4209L4.93262 6.35156L4.92578 6.34473L4.85742 6.26855C4.53707 5.87578 4.55967 5.29678 4.92578 4.93066ZM8.17188 2.76172C8.65022 2.56401 9.19353 2.76478 9.43359 3.21094L9.47754 3.30371L9.48145 3.3125L9.51562 3.40918C9.66102 3.89479 9.418 4.42133 8.93945 4.61914C8.42931 4.82972 7.84486 4.58709 7.63379 4.07715L7.62988 4.06738L7.5957 3.9707C7.45065 3.48533 7.6937 2.95957 8.17188 2.76172ZM16.3672 4.0752C16.1571 4.58594 15.5723 4.82922 15.0615 4.61914C14.5512 4.40886 14.3076 3.82502 14.5176 3.31445L16.3672 4.0752ZM14.5215 3.30469C14.7317 2.79434 15.3156 2.55096 15.8262 2.76074C16.3369 2.97082 16.5812 3.55564 16.3711 4.06641L16.3672 4.0752L15.4424 3.69434L14.5176 3.31445L14.5215 3.30469ZM12 2C12.5523 2 13 2.44772 13 3V3.00977C13 3.56205 12.5523 4.00977 12 4.00977C11.4478 4.0097 11 3.56201 11 3.00977V3C11 2.44776 11.4478 2.00007 12 2Z" }) });
});
NullIcon.displayName = "NullIcon";

const NumberSignIcon = forwardRef$1(function NumberSignIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.124 3.00783C17.672 3.07633 18.0607 3.57603 17.9922 4.12404L17.6328 7.00002H20C20.5523 7.00002 21 7.44774 21 8.00002C21 8.5523 20.5523 9.00002 20 9.00002H17.3828L16.6328 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H16.3828L15.9922 20.124C15.9237 20.6721 15.424 21.0607 14.876 20.9922C14.328 20.9237 13.9393 20.424 14.0078 19.876L14.3672 17H8.38281L7.99219 20.124C7.92369 20.6721 7.424 21.0607 6.87598 20.9922C6.32796 20.9237 5.93931 20.424 6.00781 19.876L6.36719 17H4C3.44772 17 3 16.5523 3 16C3.00001 15.4477 3.44772 15 4 15H6.61719L7.36719 9.00002H4C3.44772 9.00002 3 8.5523 3 8.00002C3.00001 7.44774 3.44772 7.00002 4 7.00002H7.61719L8.00781 3.87599C8.07632 3.32798 8.57601 2.93933 9.12402 3.00783C9.67204 3.07633 10.0607 3.57603 9.99219 4.12404L9.63281 7.00002H15.6172L16.0078 3.87599C16.0763 3.32798 16.576 2.93933 17.124 3.00783ZM8.63281 15H14.6172L15.3672 9.00002H9.38281L8.63281 15Z" }) });
});
NumberSignIcon.displayName = "NumberSignIcon";

const NumberIcon = forwardRef$1(function NumberIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M20.8633 7.10742C21.2093 7.10777 21.4911 7.38418 21.4912 7.72363C21.4911 7.82213 21.4665 7.91917 21.4209 8.00586L21.3682 8.08984L19.418 10.6738L19.4189 10.6748C19.4203 10.6773 19.4214 10.681 19.4238 10.6826C19.4262 10.6839 19.4306 10.6846 19.4346 10.6846C20.2262 10.6848 20.8747 10.9926 21.3213 11.5273C21.7648 12.0588 21.999 12.802 21.999 13.6602C21.9989 14.6794 21.6324 15.5176 21.0127 16.1006C20.3937 16.6827 19.5333 17.0009 18.5664 17.001C16.9158 17.0007 15.6736 16.0598 15.2852 14.6865C15.169 14.2758 15.4879 13.9168 15.8779 13.8662L16.4785 13.7881C16.8632 13.7384 17.1896 13.9882 17.333 14.2988C17.4519 14.5562 17.6096 14.7541 17.8076 14.8877C18.0046 15.0204 18.2533 15.0975 18.5664 15.0977C18.9725 15.0976 19.3092 14.9602 19.543 14.7236C19.7767 14.4868 19.9227 14.1364 19.9229 13.6875C19.9228 13.1739 19.7706 12.8035 19.5381 12.5635C19.3059 12.3243 18.9749 12.1955 18.5811 12.1953C18.4587 12.1953 18.3485 12.2055 18.2432 12.2266C17.9667 12.282 17.6303 12.2454 17.4023 12.0322L17.3115 11.9287L17.1553 11.7139C16.9687 11.4577 16.9692 11.1119 17.1582 10.8574L18.0664 9.63672C18.2591 9.37695 18.0705 9.01162 17.7432 9.01074H16.376C15.9644 9.01074 15.6299 8.68301 15.6299 8.2793V7.83887C15.6301 7.43531 15.9645 7.10742 16.376 7.10742H20.8633ZM10.6797 7C11.6317 7.00015 12.3981 7.2993 12.9258 7.82227C13.4528 8.3448 13.7255 9.07583 13.7256 9.9082C13.7256 10.7037 13.4645 11.4821 12.8662 12.251L12.8652 12.252L11.2207 14.3555C11.0184 14.6143 11.2058 14.9889 11.5381 14.9893H13.1875C13.5987 14.9894 13.9332 15.3165 13.9336 15.7197V16.1611C13.9335 16.5647 13.5989 16.8924 13.1875 16.8926H8.15137C7.77343 16.8924 7.4668 16.5915 7.4668 16.2207C7.4668 16.0721 7.51672 15.9272 7.60938 15.8096L10.9424 11.5859L10.9443 11.585L11.1357 11.3359C11.5395 10.7823 11.6493 10.4049 11.6494 9.97656C11.6494 9.6187 11.5566 9.35322 11.3965 9.17969C11.2389 9.00905 10.994 8.9035 10.6387 8.90332C10.2581 8.90332 9.96759 9.0558 9.7793 9.34668L9.7041 9.47949C9.56547 9.76718 9.27612 10.035 8.91797 10.0439L8.76074 10.0312L8.25684 9.9375C7.89673 9.87042 7.60259 9.53642 7.70215 9.14746L7.77246 8.91504C8.17242 7.77971 9.28069 7.00001 10.6797 7ZM5.17578 7.10742C5.587 7.10769 5.92072 7.43547 5.9209 7.83887V16.1611C5.92066 16.5645 5.58696 16.8913 5.17578 16.8916H4.58984C4.17844 16.8916 3.84399 16.5646 3.84375 16.1611V10.6426C3.84346 10.3374 3.50457 10.1486 3.2373 10.3047L3.12695 10.3682C2.63037 10.6587 2.0002 10.3084 2 9.74121V9.21875C2.00009 8.95931 2.14092 8.71901 2.36914 8.58789L4.77246 7.20898L4.86035 7.16504C4.95105 7.12787 5.04949 7.10742 5.14844 7.10742H5.17578ZM8.04883 16.7139L8.15137 16.7236C8.08216 16.7236 8.01628 16.709 7.95605 16.6846C7.98574 16.6966 8.01666 16.7074 8.04883 16.7139ZM13.4033 16.6816C13.3368 16.7082 13.2638 16.7236 13.1875 16.7236L13.3027 16.7129C13.3375 16.7059 13.3711 16.6945 13.4033 16.6816ZM4.47266 16.7119L4.53125 16.7178C4.47945 16.7127 4.42961 16.7023 4.38281 16.6846C4.41175 16.6955 4.44167 16.7056 4.47266 16.7119ZM5.29199 16.7119L5.37305 16.6895C5.37699 16.688 5.38083 16.6851 5.38477 16.6836C5.35494 16.6951 5.32401 16.7054 5.29199 16.7119ZM13.749 16.2744C13.7418 16.309 13.7302 16.342 13.7168 16.374C13.7302 16.342 13.7428 16.309 13.75 16.2744L13.7607 16.1611L13.749 16.2744ZM4.05078 16.3545C4.05226 16.3585 4.0541 16.3623 4.05566 16.3662C4.04386 16.3367 4.03395 16.3061 4.02734 16.2744L4.05078 16.3545ZM18.7129 15.2598C18.6649 15.2636 18.6161 15.2656 18.5664 15.2656L18.3379 15.251C18.4111 15.2601 18.4877 15.2666 18.5674 15.2666C18.6666 15.2666 18.7624 15.2584 18.8545 15.2432L18.7129 15.2598ZM18 15.1709C18.0071 15.1735 18.0143 15.1762 18.0215 15.1787C18.0143 15.1762 18.0071 15.1735 18 15.1709ZM11.5381 15.1582H13.1875C13.2131 15.1582 13.238 15.1618 13.2627 15.165L13.1875 15.1572H11.5381L11.4521 15.1523L11.5381 15.1582ZM11.0625 14.9102C11.0713 14.9231 11.0819 14.935 11.0918 14.9473C11.08 14.9326 11.0679 14.918 11.0576 14.9023L11.0625 14.9102ZM16.501 13.9551L15.9824 14.0234L16.501 13.9561C16.7914 13.9186 17.0558 14.1064 17.1768 14.3682C17.191 14.399 17.2091 14.4275 17.2246 14.457L17.1777 14.3682C17.0569 14.1063 16.7914 13.9176 16.501 13.9551ZM15.7002 14.0977C15.6976 14.0991 15.6949 14.1011 15.6924 14.1025C15.7227 14.0856 15.7552 14.0709 15.7891 14.0596L15.7002 14.0977ZM21.8271 13.6602C21.8271 13.6732 21.8263 13.6863 21.8262 13.6992L21.8281 13.6602C21.8281 13.5605 21.8239 13.4621 21.8174 13.3662C21.8239 13.4622 21.8271 13.5603 21.8271 13.6602ZM17.5107 11.9004C17.5129 11.9024 17.5154 11.9042 17.5176 11.9062C17.4937 11.8836 17.4712 11.8585 17.4512 11.8311L17.5107 11.9004ZM18.2051 9.73535L17.2969 10.957L17.2676 11.0039C17.277 10.9882 17.2868 10.9719 17.2979 10.957L18.2051 9.73633C18.2223 9.7132 18.238 9.68917 18.251 9.66504V9.66406C18.2379 9.6883 18.2223 9.71213 18.2051 9.73535ZM19.9902 10.9121C19.9575 10.9049 19.9241 10.8995 19.8906 10.8936C19.9241 10.8994 19.9575 10.9049 19.9902 10.9121ZM19.7734 10.876C19.7507 10.8731 19.7281 10.8685 19.7051 10.8662L19.6582 10.8633C19.6971 10.8664 19.7354 10.8712 19.7734 10.876ZM19.2588 10.7422C19.2871 10.8051 19.3531 10.8535 19.4336 10.8535C19.4625 10.8535 19.4911 10.8556 19.5195 10.8564L19.4346 10.8525C19.3383 10.8525 19.2629 10.7835 19.2471 10.7031L19.2588 10.7422ZM8.89648 9.875C8.89867 9.87492 8.90114 9.87405 8.90332 9.87402C8.86697 9.87443 8.82931 9.87215 8.79199 9.86523L8.89648 9.875ZM18.3047 9.51562C18.2995 9.54069 18.2932 9.5661 18.2842 9.59082L18.3057 9.51562C18.3109 9.49035 18.3139 9.46475 18.3154 9.43945L18.3047 9.51562ZM2.17676 9.14941C2.17377 9.17224 2.17286 9.19543 2.17285 9.21875L2.17773 9.14453L2.17676 9.14941ZM7.86816 9.1875V9.19141C7.86845 9.19026 7.86885 9.18863 7.86914 9.1875C7.88808 9.11394 7.90964 9.0415 7.93457 8.9707L7.86816 9.1875ZM4.8584 7.35352L2.45605 8.7334L2.39258 8.77441C2.38534 8.77995 2.37898 8.78709 2.37207 8.79297C2.39795 8.77116 2.42602 8.75065 2.45605 8.7334L4.8584 7.35449C4.86367 7.35148 4.86965 7.34855 4.875 7.3457C4.86972 7.34851 4.86362 7.35058 4.8584 7.35352ZM15.8369 8.47363C15.8384 8.47759 15.8402 8.48143 15.8418 8.48535C15.83 8.45582 15.8201 8.42528 15.8135 8.39355L15.8369 8.47363ZM8.5166 8.03125C8.465 8.08448 8.41586 8.14006 8.36914 8.19727L8.51758 8.03125C8.56932 7.97788 8.62326 7.92608 8.67969 7.87695L8.5166 8.03125ZM21.3125 7.79688L21.3135 7.79395L21.3184 7.72363C21.3184 7.74823 21.3166 7.77285 21.3125 7.79688ZM5.07227 7.28223C5.09719 7.27898 5.12313 7.27734 5.14844 7.27734H5.17578C5.25301 7.27739 5.3273 7.29213 5.39453 7.31934C5.36181 7.30607 5.32743 7.29525 5.29199 7.28809L5.17578 7.27637H5.14844L5.07227 7.28223ZM21.0498 7.31641C21.0365 7.31038 21.0227 7.30553 21.0088 7.30078C21.0228 7.3054 21.0365 7.31052 21.0498 7.31641ZM20.9854 7.29395C20.9753 7.29113 20.9654 7.28724 20.9551 7.28516L20.9346 7.2832C20.9518 7.28588 20.9688 7.28942 20.9854 7.29395ZM16.2598 7.28809L16.375 7.27734H20.8633C20.8771 7.27735 20.8908 7.27908 20.9043 7.28027L20.8633 7.27637H16.376L16.2598 7.28809ZM11.0127 7.18262C11.2199 7.19945 11.4158 7.23205 11.5996 7.2793C11.4161 7.23213 11.2205 7.19947 11.0137 7.18262L10.6797 7.16895L11.0127 7.18262Z" }) });
});
NumberIcon.displayName = "NumberIcon";

const ObjectIcon = forwardRef$1(function ObjectIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9 3C9.55228 3 9.99999 3.44772 10 4C10 4.55228 9.55228 5 9 5C7.89544 5 7.00001 5.89544 7 7V10C7 10.7695 6.70771 11.469 6.23145 12C6.70771 12.531 7 13.2305 7 14V17C7 18.1046 7.89542 19 9 19C9.55228 19 9.99999 19.4477 10 20C10 20.5523 9.55228 21 9 21C6.79088 21 5 19.2092 5 17V14C5 13.4823 4.60667 13.0562 4.10254 13.0049L3.89746 12.9951C3.39333 12.9438 3 12.5177 3 12C3 11.4823 3.39333 11.0562 3.89746 11.0049L4.10254 10.9951C4.60668 10.9438 5 10.5177 5 10V7C5.00001 4.79087 6.79087 3 9 3ZM15 3C17.2092 3 19 4.79088 19 7V10C19 10.5177 19.3933 10.9438 19.8975 10.9951L20.1025 11.0049C20.6067 11.0562 21 11.4823 21 12C21 12.5177 20.6067 12.9438 20.1025 12.9951L19.8975 13.0049C19.3933 13.0562 19 13.4823 19 14V17C19 19.2092 17.2092 21 15 21C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19C16.1046 19 17 18.1046 17 17V14C17 13.2308 17.2916 12.531 17.7676 12C17.2916 11.469 17 10.7692 17 10V7C17 5.89543 16.1046 5 15 5C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3Z" }) });
});
ObjectIcon.displayName = "ObjectIcon";

const OrbitIcon = forwardRef$1(function OrbitIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.7263 3.00649C18.6109 2.96034 19.517 3.15584 20.1804 3.81899L20.2995 3.94594C20.8674 4.59531 21.0361 5.44374 20.9929 6.27309C20.9466 7.15824 20.6584 8.13848 20.2106 9.13734C19.8026 10.0476 19.2422 11.0148 18.5544 11.9996C19.2424 12.9844 19.8026 13.9517 20.2106 14.862C20.6584 15.8607 20.9466 16.8411 20.9929 17.7262C21.0361 18.5557 20.8674 19.4039 20.2995 20.0534L20.1804 20.1803C19.5169 20.8437 18.611 21.039 17.7263 20.9928C16.8412 20.9465 15.8608 20.6583 14.862 20.2106C13.9517 19.8025 12.9845 19.2423 11.9997 18.5543C11.0148 19.2422 10.0477 19.8025 9.13741 20.2106C8.13854 20.6583 7.1583 20.9466 6.27315 20.9928C5.4438 21.036 4.59537 20.8673 3.946 20.2995L3.81905 20.1803C3.1559 19.5169 2.9604 18.6108 3.00655 17.7262C3.05286 16.8411 3.34104 15.8608 3.78877 14.862C4.19677 13.9518 4.75638 12.9844 5.44405 11.9996C4.75648 11.015 4.19671 10.0474 3.78877 9.13734C3.34109 8.13857 3.0528 7.15817 3.00655 6.27309C2.96046 5.38846 3.15571 4.48232 3.81905 3.81899C4.48238 3.15565 5.38852 2.9604 6.27315 3.00649C7.15823 3.05274 8.13863 3.34103 9.13741 3.78871C10.0474 4.19665 11.0151 4.75642 11.9997 5.44399C12.9843 4.75616 13.9519 4.19671 14.862 3.78871C15.8608 3.34098 16.8412 3.0528 17.7263 3.00649ZM6.72725 13.6745C6.27016 14.3762 5.89581 15.0516 5.61397 15.6803C5.22469 16.5487 5.03261 17.2774 5.00362 17.8297C4.97476 18.382 5.1105 18.6434 5.23311 18.7663L5.28584 18.8131C5.42556 18.9208 5.68648 19.0209 6.16963 18.9957C6.722 18.9668 7.45054 18.7747 8.31905 18.3854C8.94774 18.1036 9.62313 17.7292 10.3249 17.2721C9.82906 16.8585 9.33395 16.4161 8.84639 15.9469L8.44502 15.5543C7.82841 14.9377 7.25463 14.3069 6.72725 13.6745ZM17.2722 13.6745C16.7448 14.3069 16.171 14.9377 15.5544 15.5543C14.9378 16.171 14.307 16.7447 13.6745 17.2721C14.3763 17.7292 15.0517 18.1035 15.6804 18.3854C16.5488 18.7747 17.2774 18.9667 17.8298 18.9957C18.3826 19.0246 18.6436 18.8889 18.7663 18.7663L18.8132 18.7135C18.9208 18.5737 19.0211 18.313 18.9958 17.8297C18.9668 17.2774 18.7747 16.5487 18.3855 15.6803C18.1036 15.0516 17.7293 14.3763 17.2722 13.6745ZM11.9987 7.94106C11.4133 8.40885 10.8222 8.927 10.236 9.49086L9.86006 9.86C9.15153 10.5685 8.51023 11.2887 7.94209 11.9996C8.51022 12.7106 9.15153 13.4307 9.86006 14.1393L10.236 14.5084C10.8219 15.072 11.4136 15.5896 11.9987 16.0573C12.7099 15.489 13.4306 14.848 14.1394 14.1393C14.8481 13.4305 15.4891 12.7098 16.0573 11.9987C15.5897 11.4135 15.0721 10.8219 14.5085 10.236L14.1394 9.86C13.4304 9.15111 12.71 8.50939 11.9987 7.94106ZM6.16963 5.00356C5.61709 4.97474 5.35578 5.11038 5.23311 5.23305C5.11044 5.35572 4.97481 5.61703 5.00362 6.16957C5.03255 6.72189 5.22474 7.45059 5.61397 8.31899C5.89569 8.94745 6.26942 9.62334 6.72627 10.3248C7.25377 9.69223 7.82826 9.06172 8.44502 8.44496L8.84639 8.05238C9.33422 7.58299 9.82879 7.13999 10.3249 6.72621C9.6234 6.26936 8.94751 5.89563 8.31905 5.61391C7.45065 5.22468 6.72195 5.03249 6.16963 5.00356ZM17.8298 5.00356C17.2774 5.03255 16.5488 5.22463 15.6804 5.61391C15.0516 5.89578 14.3754 6.26908 13.6735 6.72621C14.3064 7.25384 14.9374 7.82801 15.5544 8.44496L15.947 8.84633C16.4161 9.33389 16.8586 9.829 17.2722 10.3248C17.7293 9.62307 18.1036 8.94768 18.3855 8.31899C18.7748 7.45048 18.9669 6.72194 18.9958 6.16957C19.021 5.68642 18.9208 5.4255 18.8132 5.28578L18.7663 5.23305C18.6435 5.11044 18.382 4.9747 17.8298 5.00356Z" }) });
});
OrbitIcon.displayName = "OrbitIcon";

const OverflowMenuIcon = forwardRef$1(function OverflowMenuIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 10C5.10455 10 6 10.8954 6 12C6 13.1046 5.10455 14 4 14C2.89545 14 2 13.1046 2 12C2 10.8954 2.89545 10 4 10ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10Z" }) });
});
OverflowMenuIcon.displayName = "OverflowMenuIcon";

const OverlapIcon = forwardRef$1(function OverlapIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.2998 2C12.7455 2.00013 15.6312 4.3885 16.3975 7.59961C19.6096 8.36521 21.998 11.2526 21.998 14.6992C21.9979 18.7304 18.7304 21.9979 14.6992 21.998C11.2529 21.9979 8.36633 19.6093 7.60059 16.3975C4.3891 15.6315 2.00013 12.7458 2 9.2998C2 5.26847 5.2685 2.00013 9.2998 2ZM16.584 9.74512C16.3626 13.4213 13.4221 16.3612 9.74609 16.583C10.5059 18.5792 12.4363 19.9979 14.6992 19.998C17.6258 19.9979 19.9979 17.6258 19.998 14.6992C19.998 12.4363 18.5801 10.5051 16.584 9.74512ZM14.5957 9.40137C11.7512 9.45607 9.45588 11.7512 9.40137 14.5957C12.2474 14.5422 14.542 12.2474 14.5957 9.40137ZM9.2998 4C6.37307 4.00013 4 6.37304 4 9.2998C4.00012 11.5621 5.41861 13.4918 7.41406 14.252C7.63624 10.5769 10.577 7.63643 14.252 7.41406C13.4919 5.41854 11.5621 4.00012 9.2998 4Z", fill: "currentColor" }), jsx("path", { opacity: 0.4, d: "M14.5957 9.40137C11.7512 9.45607 9.45588 11.7512 9.40137 14.5957C12.2474 14.5422 14.542 12.2474 14.5957 9.40137Z", fill: "currentColor" })] });
});
OverlapIcon.displayName = "OverlapIcon";

const PaddingIcon = forwardRef$1(function PaddingIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M4 3C4.55228 3 5 3.44771 5 4V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V4C3 3.44771 3.44772 3 4 3Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M13 8C14.6569 8 16 9.34315 16 11V13C16 14.6569 14.6569 16 13 16H11C9.34315 16 8 14.6569 8 13V11C8 9.34315 9.34315 8 11 8H13ZM11 10C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10H11Z" })] });
});
PaddingIcon.displayName = "PaddingIcon";

const PaperclipIcon = forwardRef$1(function PaperclipIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M19 5.81738C19 5.35052 18.8226 4.88722 18.4678 4.53223C18.1131 4.1774 17.6505 4.00012 17.1846 4C16.7185 3.99999 16.2553 4.17723 15.9004 4.53223L5.94434 14.4932C5.31469 15.1233 4.99996 15.9473 5 16.7744C5.00009 17.6016 5.31469 18.4257 5.94434 19.0557C6.574 19.6856 7.39733 19.9999 8.22363 20C9.04987 20 9.87319 19.6855 10.5029 19.0557L15.4814 14.0752C15.8718 13.6846 16.5049 13.684 16.8955 14.0742C17.2861 14.4646 17.2859 15.0986 16.8955 15.4893L11.918 20.4688C10.8982 21.4891 9.55917 22 8.22363 22C6.88819 21.9999 5.55001 21.489 4.53027 20.4688C3.51061 19.4486 3.00009 18.1101 3 16.7744C2.99994 15.4387 3.51049 14.0995 4.53027 13.0791L14.4854 3.11816C15.2303 2.37297 16.2093 1.99999 17.1846 2C18.1595 2.00013 19.1381 2.37302 19.8828 3.11816C20.6276 3.86342 21 4.84223 21 5.81738C20.9999 6.79244 20.6276 7.77144 19.8828 8.5166L9.92676 18.4766C8.98636 19.4174 7.46189 19.4174 6.52148 18.4766C5.58135 17.536 5.58135 16.0119 6.52148 15.0713L11.499 10.0908C11.8894 9.70029 12.5224 9.69969 12.9131 10.0898C13.3037 10.4803 13.3035 11.1143 12.9131 11.5049L7.93555 16.4854C7.77623 16.645 7.77608 16.9039 7.93555 17.0635C8.09471 17.2226 8.35246 17.2224 8.51172 17.0635L18.4678 7.10254C18.7782 6.79199 18.9524 6.3984 18.9912 5.99219L19 5.81738Z" }) });
});
PaperclipIcon.displayName = "PaperclipIcon";

const PauseIcon = forwardRef$1(function PauseIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9 4.75C9.69036 4.75 10.25 5.30964 10.25 6V17.9971C10.2498 18.6872 9.69022 19.2471 9 19.2471C8.30978 19.2471 7.75023 18.6872 7.75 17.9971V6C7.75 5.30964 8.30964 4.75 9 4.75ZM15 4.75C15.6904 4.75 16.25 5.30964 16.25 6V17.9971C16.2498 18.6872 15.6902 19.2471 15 19.2471C14.3098 19.2471 13.7502 18.6872 13.75 17.9971V6C13.75 5.30964 14.3096 4.75 15 4.75Z" }) });
});
PauseIcon.displayName = "PauseIcon";

const PercentIcon = forwardRef$1(function PercentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.0004 14.0002C18.6571 14.0004 20.0004 15.3435 20.0004 17.0002C20.0002 18.6569 18.657 20 17.0004 20.0002C15.3436 20.0002 14.0005 18.657 14.0004 17.0002C14.0004 15.3434 15.3435 14.0002 17.0004 14.0002ZM17.2933 5.29321C17.6839 4.90275 18.3169 4.90271 18.7074 5.29321C19.0976 5.68374 19.0978 6.31685 18.7074 6.70728L6.7074 18.7073C6.31697 19.0977 5.68388 19.0975 5.29333 18.7073C4.90281 18.3168 4.90281 17.6837 5.29333 17.2932L17.2933 5.29321ZM17.0004 16.0002C16.4481 16.0002 16.0004 16.448 16.0004 17.0002C16.0005 17.5524 16.4482 18.0002 17.0004 18.0002C17.5524 18 18.0002 17.5523 18.0004 17.0002C18.0004 16.4481 17.5525 16.0004 17.0004 16.0002ZM7.00037 4.00024C8.65705 4.00044 10.0004 5.34351 10.0004 7.00024C10.0002 8.65686 8.65697 10 7.00037 10.0002C5.34359 10.0002 4.0005 8.65699 4.00037 7.00024C4.00037 5.34339 5.34351 4.00024 7.00037 4.00024ZM7.00037 6.00024C6.44808 6.00024 6.00037 6.44796 6.00037 7.00024C6.0005 7.55242 6.44816 8.00024 7.00037 8.00024C7.5524 8.00005 8.00023 7.55229 8.00037 7.00024C8.00037 6.44808 7.55248 6.00044 7.00037 6.00024Z" }) });
});
PercentIcon.displayName = "PercentIcon";

const PerformanceIcon = forwardRef$1(function PerformanceIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4 3C4.55228 3 5 3.44772 5 4V9.75781L7.54297 7.21484C8.62386 6.13387 10.3761 6.13393 11.457 7.21484C11.7569 7.51452 12.2431 7.51452 12.543 7.21484L14.8789 4.87891C16.0504 3.70732 17.9496 3.70734 19.1211 4.87891L20.707 6.46484L20.7754 6.54004C21.0961 6.93282 21.0733 7.51266 20.707 7.87891C20.341 8.24483 19.7619 8.26745 19.3691 7.94727L19.293 7.87891L17.707 6.29297C17.3166 5.90248 16.6834 5.90248 16.293 6.29297L13.957 8.62891C12.8761 9.70963 11.1239 9.70963 10.043 8.62891C9.74308 8.32902 9.25684 8.32908 8.95703 8.62891L5 12.5859V14.5859L7.54297 12.043C8.62387 10.962 10.3761 10.9621 11.457 12.043C11.7569 12.3428 12.2431 12.3428 12.543 12.043L14.8789 9.70703C16.0504 8.53564 17.9496 8.53567 19.1211 9.70703L20.707 11.293L20.7754 11.3691C21.0957 11.7619 21.0731 12.3409 20.707 12.707C20.3409 13.0731 19.7619 13.0957 19.3691 12.7754L19.293 12.707L17.707 11.1211C17.3166 10.7308 16.6834 10.7308 16.293 11.1211L13.957 13.457C12.8761 14.538 11.1239 14.538 10.043 13.457C9.74308 13.1571 9.25684 13.1572 8.95703 13.457L5 17.4141V18C5 18.5523 5.4477 19 6 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H6C4.34315 21 3 19.6569 3 18V4C3 3.44772 3.44772 3 4 3Z" }) });
});
PerformanceIcon.displayName = "PerformanceIcon";

const PhoneIcon = forwardRef$1(function PhoneIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7.14551 3C8.66054 3 10.046 3.8559 10.7236 5.21094L11.3994 6.56152L11.4824 6.74707C11.8358 7.62179 11.6734 8.62256 11.0615 9.34082L10.9238 9.49023C10.7559 9.65813 10.7489 9.85654 10.8076 9.97266L10.9512 10.2432C11.6813 11.5709 12.6446 12.4925 14.0273 13.1924L14.0742 13.2109C14.1923 13.2468 14.3627 13.2232 14.5098 13.0762C15.282 12.304 16.4619 12.1125 17.4385 12.6006L18.7891 13.2764L19.0371 13.4111C20.2478 14.1272 21 15.4341 21 16.8545V18C21 19.6569 19.6569 21 18 21C9.71572 21 3 14.2843 3 6C3 4.34315 4.34315 3 6 3H7.14551ZM6 5C5.44771 5 5 5.44771 5 6C5 13.1797 10.8203 19 18 19C18.5523 19 19 18.5523 19 18V16.8545C19 16.1443 18.6239 15.4908 18.0186 15.1328L17.8945 15.0654L16.5439 14.3896C16.337 14.2862 16.0872 14.327 15.9238 14.4902C15.266 15.148 14.2432 15.4362 13.3096 15.0605L13.124 14.9766C11.385 14.0963 10.1281 12.8924 9.2041 11.2168L9.02344 10.876C8.52686 9.89485 8.80813 8.77773 9.50977 8.07617L9.56543 8.01074C9.66448 7.87351 9.69346 7.69673 9.64258 7.53516L9.61035 7.45605L8.93457 6.10547C8.59575 5.42799 7.90298 5 7.14551 5H6Z" }) });
});
PhoneIcon.displayName = "PhoneIcon";

const PieIcon = forwardRef$1(function PieIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1796 4.63968C11.7316 4.63977 12.1793 5.08766 12.1796 5.63968V10.666C12.1796 11.0591 12.18 11.2945 12.1942 11.4688C12.2023 11.5677 12.213 11.6145 12.2177 11.6309C12.2508 11.696 12.304 11.7491 12.369 11.7823C12.3843 11.7868 12.4294 11.7974 12.5311 11.8057C12.7054 11.8199 12.9407 11.8203 13.3339 11.8203H18.3602C18.9122 11.8205 19.36 12.2684 19.3602 12.8203C19.3602 17.3383 15.6975 21.0009 11.1796 21.001C6.66164 21.001 2.99896 17.3383 2.9989 12.8203C2.99915 8.30257 6.66175 4.6397 11.1796 4.63968ZM10.1796 6.72074C7.24181 7.19864 4.99913 9.74756 4.9989 12.8203C4.99896 16.2337 7.76621 19.001 11.1796 19.001C14.2523 19.0009 16.8001 16.7581 17.2782 13.8203H13.3339C12.9734 13.8203 12.6427 13.8213 12.368 13.7989C12.1175 13.7784 11.8464 13.735 11.576 13.6192L11.4608 13.5645C11.0195 13.3396 10.6603 12.9804 10.4354 12.5391C10.2784 12.2308 10.2244 11.9181 10.201 11.6319C10.1786 11.3573 10.1796 11.0264 10.1796 10.666V6.72074Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8192 3.05179C15.0664 2.98099 15.2864 2.99314 15.4569 3.02152C15.5989 3.04519 15.7504 3.08903 15.8505 3.11722C18.2068 3.78106 20.0765 5.59872 20.8143 7.92289L20.8827 8.14945L20.9325 8.33109C20.9499 8.39895 20.9666 8.47222 20.9784 8.543C20.9997 8.67083 21.0123 8.82681 20.9872 9.00101L20.9481 9.1807C20.8511 9.51904 20.617 9.82835 20.3173 10.0137C20.0853 10.1569 19.8563 10.2003 19.6913 10.2168C19.5466 10.2313 19.3833 10.2305 19.2635 10.2305H15.4872C15.3781 10.2305 15.236 10.2309 15.1112 10.2207C14.9745 10.2095 14.7726 10.1813 14.5604 10.0733C14.3221 9.95177 14.1224 9.76608 13.9833 9.5391L13.9276 9.43949C13.8194 9.2271 13.7903 9.02535 13.7792 8.88871C13.769 8.76381 13.7694 8.62183 13.7694 8.51273V4.73734C13.7694 4.61751 13.7685 4.45353 13.7831 4.30863C13.7996 4.14376 13.843 3.91547 13.9862 3.68363C14.1714 3.38379 14.4805 3.14888 14.8192 3.05179ZM15.7694 8.2305H18.8016C18.266 6.84042 17.1595 5.73379 15.7694 5.19828V8.2305Z" })] });
});
PieIcon.displayName = "PieIcon";

const PinIcon = forwardRef$1(function PinIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.383 3.83572C15.0048 2.45773 12.6813 2.83472 11.8097 4.57791L10.5539 7.0906C10.4439 7.31038 10.2439 7.47234 10.006 7.53494L5.12905 8.81814C2.9981 9.37914 2.27895 12.0411 3.83706 13.5994L6.41128 16.1736L3.29311 19.2927C2.90263 19.6833 2.90263 20.3163 3.29311 20.7068C3.68363 21.0973 4.31665 21.0973 4.70718 20.7068L7.82534 17.5877L10.4005 20.1629C11.9588 21.7211 14.6197 21.0016 15.1808 18.8709L16.465 13.9929C16.5277 13.7553 16.6896 13.556 16.9093 13.4461L19.422 12.1892C21.1652 11.3177 21.5422 8.99514 20.1642 7.61697L16.383 3.83572ZM13.5988 5.47244C13.8599 4.95027 14.556 4.83704 14.9689 5.24978L18.7501 9.03103C19.1628 9.44387 19.0497 10.1391 18.5275 10.4002L16.0148 11.657C15.2804 12.0243 14.7394 12.6902 14.5304 13.4842L13.2472 18.3621C13.0788 19.0002 12.2813 19.2155 11.8146 18.7488L8.99624 15.9295L8.06948 15.0027L5.25112 12.1844C4.78468 11.7176 4.99986 10.921 5.63784 10.7527L10.5158 9.46951C11.3096 9.2605 11.9757 8.71949 12.3429 7.98513L13.5988 5.47244Z" }) });
});
PinIcon.displayName = "PinIcon";

const PinnedIcon = forwardRef$1(function PinnedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.8101 4.57765C12.6816 2.8345 15.0052 2.45748 16.3833 3.83546L20.1636 7.61574C21.5417 8.99385 21.1646 11.3174 19.4214 12.189L16.9087 13.4458C16.6891 13.5558 16.527 13.755 16.4644 13.9927L15.1812 18.8696C14.6203 21.0004 11.9593 21.7206 10.4009 20.1626L7.82572 17.5874L4.70755 20.7066C4.31706 21.0971 3.68402 21.097 3.29349 20.7066C2.90297 20.316 2.90297 19.683 3.29349 19.2925L6.41166 16.1734L3.83744 13.5982C2.27943 12.0399 2.9985 9.37885 5.12943 8.81788L10.0064 7.53468C10.2442 7.47211 10.4433 7.31 10.5533 7.09035L11.8101 4.57765Z" }) });
});
PinnedIcon.displayName = "PinnedIcon";

const PlanIcon = forwardRef$1(function PlanIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M19 3C19.1366 3 19.2671 3.02659 19.3857 3.07617C20.5977 3.36326 21.5 4.45023 21.5 5.75V8C21.5 9.10455 20.6046 10 19.5 10H18V18.25C18 19.7688 16.7688 21 15.25 21C15.2047 21 15.16 20.9943 15.1152 20.9922C15.0774 20.9965 15.039 21 15 21H5.5C3.84315 21 2.5 19.6569 2.5 18V17C2.5 15.8954 3.39545 15 4.5 15H5V6C5 4.34315 6.34315 3 8 3H19ZM4.5 18C4.5 18.5523 4.94771 19 5.5 19H12.6064C12.5389 18.7614 12.5 18.5103 12.5 18.25V17H4.5V18ZM8 5C7.44771 5 7 5.44771 7 6V15H12.5C13.6046 15 14.5 15.8954 14.5 17V18.25C14.5 18.6642 14.8358 19 15.25 19C15.6642 19 16 18.6642 16 18.25V5.75C16 5.48971 16.0389 5.23864 16.1064 5H8ZM18.75 5C18.3358 5 18 5.33578 18 5.75V8H19.5V5.75C19.5 5.33578 19.1642 5 18.75 5Z" }) });
});
PlanIcon.displayName = "PlanIcon";

const PlayIcon = forwardRef$1(function PlayIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4.99902 6.57179C4.99919 4.54997 7.2232 3.33489 8.93262 4.38429L17.7725 9.81105H17.7734C19.408 10.815 19.4083 13.1843 17.7734 14.188L8.93262 19.6148C7.2234 20.664 4.99953 19.4489 4.99902 17.4273V6.57179ZM7.88672 6.08839C7.49158 5.84581 7.00017 6.13508 7 6.57179V17.4273C7.00052 17.8636 7.49166 18.1532 7.88672 17.9107L16.7275 12.4829L16.791 12.438C17.0892 12.1963 17.0677 11.7256 16.7275 11.5161L7.88672 6.08839Z" }) });
});
PlayIcon.displayName = "PlayIcon";

const PlusIcon = forwardRef$1(function PlusIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M11.999 5C12.5511 5.00026 12.999 5.44788 12.999 6V10.999H17.999L18.1006 11.0049C18.6046 11.0562 18.9989 11.4815 18.999 11.999C18.9988 12.5165 18.6046 12.9429 18.1006 12.9941L17.999 12.999H12.999V17.999C12.9985 18.5507 12.5508 18.9988 11.999 18.999C11.4472 18.9989 10.9995 18.5508 10.999 17.999V12.999H6C5.44788 12.999 5.00026 12.5511 5 11.999C5.00016 11.4469 5.44781 10.999 6 10.999H10.999V6C10.999 5.44781 11.4469 5.00016 11.999 5Z" }) });
});
PlusIcon.displayName = "PlusIcon";

const ProjectsIcon = forwardRef$1(function ProjectsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M17 3C17.5523 3 18 3.44772 18 4C18 4.55228 17.5523 5 17 5H7C6.44772 5 6 4.55228 6 4C6 3.44772 6.44772 3 7 3H17Z" }), jsx("path", { fill: "currentColor", d: "M19 6.5C19.5523 6.5 20 6.94772 20 7.5C20 8.05228 19.5523 8.5 19 8.5H5C4.44772 8.5 4 8.05228 4 7.5C4 6.94772 4.44772 6.5 5 6.5H19Z" }), jsx("path", { fill: "currentColor", d: "M18.8684 10C20.8524 10 22.2899 11.8912 21.759 13.8027L20.3704 18.8027C20.0096 20.1011 18.8273 21 17.4797 21H6.51977C5.17231 20.9998 3.98978 20.101 3.62914 18.8027L2.24047 13.8027C1.70969 11.8913 3.14731 10.0001 5.1311 10H18.8684ZM5.1311 12C4.46988 12.0001 3.99122 12.6304 4.16821 13.2676L5.55688 18.2676C5.67707 18.7002 6.07074 18.9998 6.51977 19H17.4797C17.9289 19 18.3233 18.7004 18.4436 18.2676L19.8323 13.2676C20.0092 12.6304 19.5298 12 18.8684 12H5.1311Z" })] });
});
ProjectsIcon.displayName = "ProjectsIcon";

const PublishIcon = forwardRef$1(function PublishIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M20 13.75C20.5523 13.75 21 14.1977 21 14.75V18C20.9999 19.6568 19.6568 21 18 21H6C4.34323 21 3.00013 19.6568 3 18V14.75C3 14.1977 3.44772 13.75 4 13.75C4.55228 13.75 5 14.1977 5 14.75V18C5.00013 18.5522 5.44778 19 6 19H18C18.5522 19 18.9999 18.5522 19 18V14.75C19 14.1977 19.4477 13.75 20 13.75ZM11.3691 3.22462C11.7619 2.90427 12.3409 2.92686 12.707 3.29298L17.207 7.79298L17.2754 7.86915C17.5956 8.26192 17.5731 8.84097 17.207 9.20704C16.8409 9.57301 16.2619 9.59562 15.8691 9.2754L15.793 9.20704L13 6.41407V15.25C12.9999 15.8022 12.5522 16.25 12 16.25C11.4478 16.25 11.0001 15.8022 11 15.25V6.41407L8.20703 9.20704C7.81654 9.59741 7.18346 9.59741 6.79297 9.20704C6.40248 8.81656 6.40256 8.18351 6.79297 7.79298L11.293 3.29298L11.3691 3.22462Z" }) });
});
PublishIcon.displayName = "PublishIcon";

const PushBouncedIcon = forwardRef$1(function PushBouncedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M13.69 3a3.002 3.002 0 0 1 3.002 3v5.875a1 1 0 0 1-2 0V6c0-.55-.448-1-1.002-1H8a1 1 0 0 0-1 1v11.749a1 1 0 0 0 1 1h1.577a1 1 0 0 1 0 2H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5.69Zm.309 15.574a1 1 0 0 1 1.03 1.331l-.012.031-.002.006-.059.14a1 1 0 0 1-1.787-.021l-.001-.004-.015-.027A1 1 0 0 1 14 18.574Z" }), jsx("path", { fill: "currentColor", d: "M11.213 16.169a1 1 0 0 1 1.333-.142l.08.065.04.035.047.044a1 1 0 0 1-1.263 1.547l-.08-.066-.079-.07a1.001 1.001 0 0 1-.078-1.413ZM16 15.874a1 1 0 0 1 .045 1.997 1 1 0 0 1-.304-1.973l.103-.016.156-.008Zm-6.932-1.5a1 1 0 0 1-.022 2H9a1 1 0 0 1 0-2h.068Zm9.932-2.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" })] });
});
PushBouncedIcon.displayName = "PushBouncedIcon";

const PushClickedIcon = forwardRef$1(function PushClickedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.293 15.293a1 1 0 0 1 1-.249l5 1.539a1 1 0 0 1 .154 1.85l-2.01 1.005-1.004 2.01a1 1 0 0 1-1.85-.154l-1.54-5a1 1 0 0 1 .25-1.001Zm2.467 3.026.038-.074.084-.138a1 1 0 0 1 .363-.31l.074-.037-.808-.25.249.81Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M13.69 3.126a3.002 3.002 0 0 1 3.002 3v5.875a1 1 0 0 1-2 0V6.126c0-.55-.448-1-1.002-1H8a1 1 0 0 0-1 1v11.749a1 1 0 0 0 1 1h2.577a1 1 0 0 1 0 2H8a3 3 0 0 1-3-3V6.126a3 3 0 0 1 3-3h5.69Z" }), jsx("path", { fill: "currentColor", d: "M9.75 15a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h.75Zm-.285-2.535a1 1 0 0 1 1.414 0l.53.53a1 1 0 0 1-1.414 1.414l-.53-.53a1 1 0 0 1 0-1.414ZM13 11a1 1 0 0 1 1 1v.75a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1Z" })] });
});
PushClickedIcon.displayName = "PushClickedIcon";

const PushDeliveredIcon = forwardRef$1(function PushDeliveredIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M13.69 3a3.002 3.002 0 0 1 3.002 3v5.875a1 1 0 0 1-2 0V6c0-.55-.448-1-1.002-1H8a1 1 0 0 0-1 1v11.749a1 1 0 0 0 1 1h2.577a1 1 0 0 1 0 2H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5.69Z" }), jsx("path", { fill: "currentColor", d: "M18.31 13.275a1 1 0 0 1 1.38 1.45l-4.2 4a1 1 0 0 1-1.38 0l-1.8-1.715a1 1 0 1 1 1.38-1.449l1.109 1.057 3.512-3.343Z" })] });
});
PushDeliveredIcon.displayName = "PushDeliveredIcon";

const PushSentIcon = forwardRef$1(function PushSentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M13.69 3a3.002 3.002 0 0 1 3.002 3v5.875a1 1 0 0 1-2 0V6c0-.55-.448-1-1.002-1H8a1 1 0 0 0-1 1v11.749a1 1 0 0 0 1 1h1.577a1 1 0 0 1 0 2H8a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5.69Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.291 12.416a1 1 0 0 1 1.114-.12l5.55 2.936a1 1 0 0 1 0 1.768l-5.55 2.936a1 1 0 0 1-1.416-1.199l.874-2.62-.874-2.622a1 1 0 0 1 .302-1.079Zm2.575 3.384a.994.994 0 0 1 0 .633l-.19.569 1.673-.886-1.672-.886.19.57Z", clipRule: "evenodd" })] });
});
PushSentIcon.displayName = "PushSentIcon";

const PushTappedIcon = forwardRef$1(function PushTappedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.112 14.476c.586-.432 1.368-.302 1.853.162l1.022.782.617-.496c.968-.853 2.418-.651 3.265.27l.163.178c1.35 1.468 1.422 3.755-.035 5.095-.976.896-2.384 1.102-3.636.604l-2.427-.966a.75.75 0 0 1-.467-.613l-.055-.48a1.488 1.488 0 0 1 .525-1.32l-.987-1.073c-.508-.553-.577-1.474.043-2.045l.12-.098Zm5.653 1.733c-.384-.417-.916-.395-1.183-.15a.714.714 0 0 1-.036.032l-1.074.866a.75.75 0 0 1-.927.013l-.791-.606 1.128 1.227a.752.752 0 0 1-.533 1.258l-.444.01.001.019 2.01.8c.766.305 1.553.156 2.066-.316.757-.695.822-2.022-.054-2.975l-.163-.178Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M12.69 3a3.002 3.002 0 0 1 3.002 3v5.875a1 1 0 0 1-2 0V6c0-.55-.448-1-1.002-1H7a1 1 0 0 0-1 1v11.749a1 1 0 0 0 1 1h2.577a1 1 0 0 1 0 2H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5.69Z" }), jsx("path", { fill: "currentColor", d: "M8.75 14.874a1 1 0 1 1 0 2H8a1 1 0 0 1 0-2h.75Zm-.285-2.535a1 1 0 0 1 1.414 0l.53.53a1 1 0 0 1-1.414 1.414l-.53-.53a1 1 0 0 1 0-1.414ZM12 10.874a1 1 0 0 1 1 1v.75a1 1 0 1 1-2 0v-.75a1 1 0 0 1 1-1Z" })] });
});
PushTappedIcon.displayName = "PushTappedIcon";

const PushIcon = forwardRef$1(function PushIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M14 18C14.5523 18 15 18.4477 15 19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19C9 18.4477 9.44772 18 10 18H14Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 1C17.6569 1 19 2.34315 19 4V20C19 21.6569 17.6569 23 16 23H8C6.34315 23 5 21.6569 5 20V4C5 2.34315 6.34315 1 8 1H16ZM8 3C7.44771 3 7 3.44771 7 4V20C7 20.5523 7.44771 21 8 21H16C16.5523 21 17 20.5523 17 20V4C17 3.44771 16.5523 3 16 3H8Z", fill: "currentColor" })] });
});
PushIcon.displayName = "PushIcon";

const QuestionIcon = forwardRef$1(function QuestionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 15C12.5523 15 13 15.4477 13 16V16.0098C13 16.5621 12.5523 17.0098 12 17.0098C11.4477 17.0098 11 16.5621 11 16.0098V16C11 15.4477 11.4477 15 12 15ZM12 7C13.6569 7.00001 15 8.34316 15 10C15 10.6733 14.8197 11.222 14.4805 11.6631C14.1671 12.0705 13.7662 12.3145 13.5186 12.4648C13.2192 12.6466 13.1207 12.7082 13.0537 12.7822C13.0395 12.7979 13 12.8278 13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.3526 11.2105 11.8391 11.5713 11.4404C11.8791 11.1004 12.2802 10.8765 12.4805 10.7549C12.7328 10.6017 12.8329 10.5235 12.8945 10.4434C12.9302 10.3969 13 10.2926 13 10C13 9.44771 12.5523 9.00001 12 9C11.6311 9 11.3072 9.19946 11.1328 9.50098C10.8562 9.97876 10.2445 10.1417 9.7666 9.86523C9.28881 9.5886 9.12587 8.97697 9.40234 8.49902C9.91958 7.60514 10.8884 7 12 7Z" }) });
});
QuestionIcon.displayName = "QuestionIcon";

const RedactedIcon = forwardRef$1(function RedactedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M2 11.2277L2.39841 10.1964L4.2842 10.8234V9H5.46171V10.8399L7.41833 10.1799L7.83444 11.2277L5.87782 11.8713L7.00221 13.3564L6.03718 14L4.85967 12.4323L3.71757 14L2.74369 13.3564L3.86808 11.8383L2 11.2277Z" }), jsx("path", { d: "M9.08278 11.2277L9.48119 10.1964L11.367 10.8234V9H12.5445V10.8399L14.5011 10.1799L14.9172 11.2277L12.9606 11.8713L14.085 13.3564L13.12 14L11.9425 12.4323L10.8004 14L9.82647 13.3564L10.9509 11.8383L9.08278 11.2277Z" }), jsx("path", { d: "M16.1656 11.2277L16.564 10.1964L18.4498 10.8234V9H19.6273V10.8399L21.5839 10.1799L22 11.2277L20.0434 11.8713L21.1678 13.3564L20.2027 14L19.0252 12.4323L17.8831 14L16.9093 13.3564L18.0336 11.8383L16.1656 11.2277Z" })] });
});
RedactedIcon.displayName = "RedactedIcon";

const RedoIcon = forwardRef$1(function RedoIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.7266 4.29116C17.0935 3.92596 17.6734 3.90449 18.0654 4.22573L18.1406 4.29506L21.418 7.58706C22.1947 8.36772 22.1949 9.63172 21.418 10.4123L18.1406 13.7052C17.7511 14.096 17.1178 14.0973 16.7266 13.7081C16.3353 13.3186 16.3343 12.6855 16.7236 12.2941L19.0078 9.99917H6.98242L6.8291 10.0031C5.25791 10.0832 4.00118 11.3904 4.00098 12.9992V13.9982C4.00116 15.659 5.34051 16.9982 6.98242 16.9982H11.959C12.5106 16.9988 12.9588 17.4464 12.959 17.9982C12.9588 18.55 12.5107 18.9976 11.959 18.9982H6.98242C4.22723 18.9982 2.00116 16.7548 2.00098 13.9982V12.9992C2.00118 10.3287 4.09017 8.14015 6.72559 8.006L6.98242 7.99916H19.0068L16.7236 5.70522C16.3343 5.31384 16.3354 4.68073 16.7266 4.29116Z" }) });
});
RedoIcon.displayName = "RedoIcon";

const ReferenceIcon = forwardRef$1(function ReferenceIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M21 17C21.5523 17 22 17.4477 22 18C22 20.2092 20.2092 22 18 22C15.7908 22 14 20.2092 14 18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18C16 19.1046 16.8954 20 18 20C19.1046 20 20 19.1046 20 18C20 17.4477 20.4477 17 21 17ZM16.7998 3C17.3434 3 17.8116 2.99893 18.1953 3.03028C18.5906 3.06259 18.984 3.13441 19.3623 3.32715C19.9265 3.61473 20.3853 4.07348 20.6729 4.6377L20.7402 4.78028C20.8835 5.11438 20.9415 5.45882 20.9697 5.80469C21.0011 6.18836 21 6.65665 21 7.2002V8C21 8.51768 20.6067 8.94379 20.1025 8.99512L20 9H9.1709V19H11C11.5523 19 12 19.4477 12 20C12 20.5523 11.5523 21 11 21H7.2002C6.65665 21 6.18836 21.0011 5.80469 20.9697C5.45882 20.9415 5.11438 20.8835 4.78028 20.7402L4.6377 20.6729C4.07348 20.3853 3.61473 19.9265 3.32715 19.3623C3.1344 18.984 3.06259 18.5906 3.03028 18.1953C2.99893 17.8116 3 17.3434 3 16.7998V7.2002C3 6.65665 2.99893 6.18836 3.03028 5.80469C3.06259 5.40944 3.1344 5.01599 3.32715 4.6377C3.61473 4.07348 4.07348 3.61473 4.6377 3.32715C5.01599 3.1344 5.40944 3.06259 5.80469 3.03028C6.18836 2.99893 6.65665 3 7.2002 3H16.7998ZM5 9V16.7998C5 17.3764 5.00127 17.7489 5.02442 18.0322C5.04661 18.3038 5.08419 18.4047 5.10938 18.4541C5.20522 18.6421 5.35794 18.7948 5.5459 18.8906L5.59473 18.9121C5.65668 18.9344 5.76435 18.959 5.96778 18.9756C6.24629 18.9983 6.61098 18.999 7.1709 18.999V9H5ZM18 15C18.5523 15 19 15.4477 19 16V17C19 17.5523 18.5523 18 18 18C17.4477 18 17 17.5523 17 17V16C17 15.4477 17.4477 15 18 15ZM18 11C20.2092 11 22 12.7908 22 15C22 15.5523 21.5523 16 21 16C20.4477 16 20 15.5523 20 15C20 13.8954 19.1046 13 18 13C16.8954 13 16 13.8954 16 15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15C14 12.7908 15.7908 11 18 11ZM7.1709 5C6.61098 5.00005 6.24629 5.00166 5.96778 5.02442C5.6962 5.04662 5.59534 5.08419 5.5459 5.10938C5.35794 5.20522 5.20522 5.35794 5.10938 5.5459C5.08419 5.59534 5.04662 5.6962 5.02442 5.96778C5.00407 6.21689 5.00151 6.53496 5.00098 7H7.1709V5ZM9.1709 7H18.999C18.9985 6.53496 18.9959 6.21689 18.9756 5.96778C18.959 5.76435 18.9344 5.65668 18.9121 5.59473L18.8906 5.5459C18.7948 5.35794 18.6421 5.20522 18.4541 5.10938C18.4047 5.08419 18.3038 5.04661 18.0322 5.02442C17.7489 5.00127 17.3764 5 16.7998 5H9.1709V7Z" }) });
});
ReferenceIcon.displayName = "ReferenceIcon";

const RefreshIcon = forwardRef$1(function RefreshIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.7266 7.28006C17.1236 6.89636 17.7568 6.90751 18.1406 7.30448C19.2917 8.49502 20.001 10.1258 20.001 11.9197C20.0007 15.5525 17.0907 18.5202 13.4736 18.5203H11.8359L12.6064 19.3006C12.9941 19.6936 12.9905 20.3267 12.5977 20.7146C12.2046 21.1022 11.5715 21.0976 11.1836 20.7049L8.81348 18.3045C8.42956 17.9152 8.42973 17.2896 8.81348 16.9002L11.1836 14.4998C11.5716 14.1068 12.2046 14.1021 12.5977 14.49C12.9904 14.878 12.9942 15.5111 12.6064 15.9041L11.998 16.5203H13.4736C15.9611 16.5202 18.0007 14.4731 18.001 11.9197C18.001 10.6615 17.5056 9.52409 16.7031 8.69413C16.3193 8.29708 16.3296 7.66394 16.7266 7.28006ZM9.61328 3.28788C9.98171 2.92449 10.5606 2.90569 10.9512 3.22831L11.0273 3.29764L13.3965 5.69803C13.7807 6.08743 13.7807 6.71292 13.3965 7.10233L11.0273 9.50272C10.6394 9.89522 10.0062 9.90006 9.61328 9.51249C9.22047 9.12474 9.21625 8.49153 9.60352 8.09842L10.293 7.40018H9.52734C7.03983 7.40018 5.00023 9.4473 5 12.0008C5.00013 13.2588 5.49544 14.3965 6.29785 15.2264C6.68126 15.6234 6.67128 16.2567 6.27441 16.6404C5.8775 17.024 5.24423 17.0126 4.86035 16.616C3.70932 15.4256 3.00013 13.7945 3 12.0008C3.00024 8.36792 5.91024 5.40018 9.52734 5.40018H10.293L9.60352 4.70194L9.53516 4.62577C9.21775 4.2311 9.24534 3.65155 9.61328 3.28788Z" }) });
});
RefreshIcon.displayName = "RefreshIcon";

const RemoveTimeRangeIcon = forwardRef$1(function RemoveTimeRangeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 1.99965C12.4999 1.99965 12.9998 2.49977 13 2.99965C13 3.49965 12.5 3.99965 12 3.99965C7.58184 3.99965 4.00019 7.58153 4 11.9996C4 16.418 7.58172 19.9996 12 19.9996C16.4183 19.9996 20 16.418 20 11.9996C20.0002 11.4094 20.5001 10.9996 21 10.9996C21.4999 10.9996 21.9998 11.3789 22 11.9996C22 17.5225 17.5229 21.9996 12 21.9996C6.47716 21.9996 2 17.5225 2 11.9996C2.00019 6.47697 6.47727 1.99965 12 1.99965ZM12 7.06117C12.5522 7.06117 12.9999 7.50901 13 8.06117V11.6471L15.207 13.8541C15.5975 14.2446 15.5974 14.8777 15.207 15.2682C14.8165 15.6587 14.1835 15.6587 13.793 15.2682L11.293 12.7682C11.1055 12.5807 11 12.3263 11 12.0612V8.06117C11.0001 7.50901 11.4478 7.06117 12 7.06117ZM20.4141 2.29262C20.8045 1.90226 21.4376 1.9024 21.8281 2.29262C22.2186 2.68312 22.2186 3.31615 21.8281 3.70668L20.4131 5.12074L21.8281 6.53578C22.2186 6.92631 22.2186 7.55932 21.8281 7.94984C21.4376 8.34018 20.8045 8.34031 20.4141 7.94984L19 6.53481L17.5859 7.94984C17.1955 8.3403 16.5624 8.34016 16.1719 7.94984C15.7814 7.55932 15.7814 6.92631 16.1719 6.53578L17.5859 5.12074L16.1719 3.70668C15.7814 3.31615 15.7814 2.68312 16.1719 2.29262C16.5624 1.90241 17.1955 1.90225 17.5859 2.29262L19 3.70668L20.4141 2.29262Z", fill: "currentColor" }) });
});
RemoveTimeRangeIcon.displayName = "RemoveTimeRangeIcon";

const ResetIcon = forwardRef$1(function ResetIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M13.0566 19.7607C13.6737 19.7608 14.1738 20.2609 14.1738 20.8779C14.1738 21.4949 13.6736 21.995 13.0566 21.9951C12.4396 21.9951 11.9395 21.495 11.9395 20.8779C11.9395 20.2608 12.4395 19.7607 13.0566 19.7607ZM11.9385 2C13.0898 2 14.1979 2.19627 15.2285 2.55762L15.666 2.72266L15.7588 2.76562C16.207 3.00224 16.4119 3.54549 16.2178 4.02539C16.0234 4.50525 15.4983 4.75228 15.0117 4.61035L14.915 4.57715L14.5674 4.44531C13.7459 4.15722 12.8611 4 11.9385 4C7.55459 4.00034 4.00034 7.55459 4 11.9385C4 14.7145 5.42559 17.1594 7.58691 18.5791V15.291C7.58693 14.7389 8.03486 14.2913 8.58691 14.291C9.13907 14.2912 9.58689 14.7388 9.58691 15.291V20.8779C9.58677 21.43 9.13899 21.8778 8.58691 21.8779H3C2.44802 21.8777 2.00014 21.4299 2 20.8779C2.00002 20.3258 2.44794 19.8782 3 19.8779H5.96094C3.55696 18.0647 2 15.1841 2 11.9385C2.00034 6.45002 6.45002 2.00034 11.9385 2ZM16.8193 18.1533C17.3537 17.845 18.0372 18.0281 18.3457 18.5625C18.6543 19.0969 18.4709 19.7804 17.9365 20.0889C17.4021 20.3974 16.7187 20.2141 16.4102 19.6797C16.1017 19.1453 16.285 18.4619 16.8193 18.1533ZM19.2725 14.8818C19.581 14.3477 20.2645 14.1645 20.7988 14.4727C21.3331 14.7812 21.5162 15.4647 21.208 15.999C20.8994 16.5334 20.2161 16.7167 19.6816 16.4082C19.1473 16.0996 18.964 15.4162 19.2725 14.8818ZM20.8779 9.7041C21.495 9.70415 21.9951 10.2052 21.9951 10.8223C21.9949 11.4392 21.4949 11.9394 20.8779 11.9395C20.261 11.9395 19.761 11.4392 19.7607 10.8223C19.7607 10.2052 20.2608 9.7041 20.8779 9.7041ZM18.5615 5.53418C19.0959 5.22578 19.7793 5.40903 20.0879 5.94336C20.3964 6.47777 20.2131 7.16119 19.6787 7.46973C19.1444 7.77822 18.4609 7.59494 18.1523 7.06055C17.844 6.52616 18.0273 5.84267 18.5615 5.53418Z" }) });
});
ResetIcon.displayName = "ResetIcon";

const RotateIcon = forwardRef$1(function RotateIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M3 19.875V4.125C3 3.50368 3.50368 3 4.125 3C4.74632 3 5.25 3.50368 5.25 4.125V19.875C5.25 20.4963 4.74632 21 4.125 21C3.50368 21 3 20.4963 3 19.875Z" }), jsx("path", { fill: "currentColor", d: "M19.875 18.75C20.4963 18.75 21 19.2537 21 19.875C21 20.4963 20.4963 21 19.875 21L4.125 21C3.50368 21 3 20.4963 3 19.875C3 19.2537 3.50368 18.75 4.125 18.75L19.875 18.75Z" }), jsx("path", { fill: "currentColor", d: "M4.125 8.625C10.3382 8.625 15.375 13.6618 15.375 19.875H13.125C13.125 14.9044 9.09556 10.875 4.125 10.875V8.625Z" })] });
});
RotateIcon.displayName = "RotateIcon";

const SearchIcon = forwardRef$1(function SearchIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.582 4C14.2204 4 17.1648 6.95828 17.165 10.6006C17.1649 12.0528 16.6959 13.3956 15.9023 14.4863C15.9058 14.4891 15.9097 14.4913 15.9131 14.4941L15.9883 14.5625L19.71 18.2969L19.7783 18.373C20.0979 18.7663 20.0746 19.3455 19.708 19.7109C19.3412 20.0761 18.7612 20.0984 18.3691 19.7773L18.2939 19.709L14.5723 15.9746L14.5059 15.9004C13.4104 16.7174 12.0531 17.2021 10.582 17.2021C6.94389 17.2019 4.00023 14.2428 4 10.6006C4.00026 6.95845 6.94391 4.00028 10.582 4ZM10.582 6C8.05475 6.00028 6.00026 8.05674 6 10.6006C6.00023 13.1445 8.05473 15.2019 10.582 15.2021C13.1096 15.2021 15.1648 13.1446 15.165 10.6006C15.1648 8.05657 13.1095 6 10.582 6Z" }) });
});
SearchIcon.displayName = "SearchIcon";

const SelectorIcon = forwardRef$1(function SelectorIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.3486 14.2407C15.7327 13.9104 16.3128 13.9179 16.6885 14.2739C17.0639 14.6302 17.1017 15.2088 16.792 15.6099L16.7256 15.688L13.0791 19.5327V19.5337C12.4895 20.155 11.5105 20.155 10.9209 19.5337V19.5327L7.27441 15.688C6.89463 15.2873 6.91105 14.6539 7.31152 14.2739C7.71215 13.8942 8.34558 13.9107 8.72558 14.311L12 17.7651L15.2744 14.311L15.3486 14.2407ZM10.9209 4.46534C11.5105 3.84426 12.4895 3.84421 13.0791 4.46534V4.46632L16.7256 8.31104L16.792 8.38917C17.1018 8.79016 17.0638 9.36877 16.6885 9.7251C16.3128 10.0813 15.7327 10.0889 15.3486 9.75831L15.2744 9.68799L12 6.23389L8.72558 9.68799C8.34554 10.0885 7.7122 10.105 7.31152 9.7251C6.9111 9.34506 6.89451 8.71169 7.27441 8.31104L10.9209 4.46632V4.46534Z" }) });
});
SelectorIcon.displayName = "SelectorIcon";

const SendMessageLineIcon = forwardRef$1(function SendMessageLineIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.10839 5.62887C2.54071 3.93737 4.30144 2.44374 5.87597 3.20407L20.3721 10.208L20.5078 10.2802C21.8721 11.0658 21.8266 13.089 20.3716 13.7924L5.87597 20.7959C4.30153 21.5561 2.54087 20.0636 3.10839 18.372L5.19273 12.159C5.22735 12.0558 5.22735 11.9441 5.19272 11.8409L3.10839 5.62887ZM6.90612 10.659C6.97445 10.8627 7.16529 11 7.38016 11H9.29784C9.85002 11 10.2977 11.4478 10.2978 12C10.2978 12.5522 9.85011 13 9.29784 13H7.38104C7.16622 13 6.97541 13.1372 6.90704 13.3408L5.38778 17.8662C5.24689 18.2858 5.68065 18.6681 6.07927 18.4755L18.5525 12.4501C18.9291 12.2682 18.9292 11.7317 18.5525 11.5497L6.07901 5.52249C5.68044 5.3299 5.24665 5.71203 5.38743 6.13171L6.90612 10.659Z" }) });
});
SendMessageLineIcon.displayName = "SendMessageLineIcon";

const SendMessageIcon = forwardRef$1(function SendMessageIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M3.104 5.619C2.56 3.951 4.251 2.437 5.8 3.206l14.107 7.009c1.459.724 1.459 2.846 0 3.57L5.8 20.795c-1.548.768-3.24-.746-2.695-2.414l1.309-4.01a2 2 0 0 1 1.901-1.379h2.814A.982.982 0 0 0 10.1 12a.982.982 0 0 0-.972-.993H6.314a2 2 0 0 1-1.901-1.38L3.104 5.62Z" }) });
});
SendMessageIcon.displayName = "SendMessageIcon";

const SequencesIcon = forwardRef$1(function SequencesIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 14C8.433 14 10 15.567 10 17.5C10 19.433 8.433 21 6.5 21C4.567 21 3 19.433 3 17.5C3 15.567 4.567 14 6.5 14ZM6.5 16C5.67158 16 5 16.6716 5 17.5C5 18.3284 5.67158 19 6.5 19C7.32842 19 8 18.3284 8 17.5C8 16.6716 7.32842 16 6.5 16Z" }), jsx("path", { fill: "currentColor", d: "M18 5C19.7369 5.00009 20.9999 6.50814 21 8.18164V15.8184C20.9999 17.4918 19.7369 18.9999 18 19H15.4141L15.707 19.293C16.0974 19.6835 16.0974 20.3166 15.707 20.707C15.3166 21.0975 14.6835 21.0974 14.293 20.707L12.293 18.707C11.9024 18.3165 11.9024 17.6835 12.293 17.293L14.293 15.293C14.6835 14.9025 15.3165 14.9025 15.707 15.293C16.0974 15.6835 16.0974 16.3166 15.707 16.707L15.4141 17H18C18.4721 16.9999 18.9999 16.5546 19 15.8184V8.18164C18.9999 7.44541 18.4721 7.0001 18 7H14C13.4477 7 13 6.55228 13 6C13 5.44771 13.4477 5 14 5H18Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 3C8.43299 3 10 4.56701 10 6.5C10 8.43299 8.43299 10 6.5 10C4.56701 10 3 8.43299 3 6.5C3 4.56701 4.56701 3 6.5 3ZM6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5Z" })] });
});
SequencesIcon.displayName = "SequencesIcon";

const SettingSliderIcon = forwardRef$1(function SettingSliderIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M9 13a4 4 0 0 1 3.874 3H20a1 1 0 1 1 0 2h-7.126a4 4 0 0 1-7.748 0H4a1 1 0 1 1 0-2h1.126A4 4 0 0 1 9 13Zm0 2a2 2 0 1 0 0 4 2 2 0 1 0 0-4Zm8-12a4 4 0 0 1 4 4 4 4 0 0 1-7.874 1H4a1 1 0 0 1 0-2h9.126A4 4 0 0 1 17 3Zm0 2a2 2 0 1 0 0 4 2 2 0 1 0 0-4Z" }) });
});
SettingSliderIcon.displayName = "SettingSliderIcon";

const SettingsIcon = forwardRef$1(function SettingsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.03024 4.57764C9.52518 1.14925 14.4748 1.14926 14.9697 4.57764L15.0234 4.95166C15.1164 5.59632 15.7911 5.98159 16.3935 5.73389L17.0136 5.479C20.1835 4.17568 22.7079 8.34984 20.082 10.5522L19.2695 11.2329C18.793 11.6325 18.7932 12.3664 19.2695 12.7661L20.082 13.4468C22.7082 15.6492 20.1836 19.8235 17.0136 18.52L16.3935 18.2651C15.7913 18.0176 15.1166 18.403 15.0234 19.0474L14.9697 19.4214C14.475 22.8502 9.52493 22.8502 9.03024 19.4214L8.97653 19.0474C8.88334 18.4029 8.20869 18.0175 7.60641 18.2651L6.9863 18.52C3.81637 19.8235 1.29174 15.6492 3.91794 13.4468L4.73044 12.7661C5.20682 12.3664 5.20691 11.6325 4.73044 11.2329L3.91794 10.5522C1.29209 8.34985 3.81652 4.17578 6.9863 5.479L7.60641 5.73389C8.20881 5.98159 8.88352 5.59632 8.97653 4.95166L9.03024 4.57764ZM12.9902 4.86279C12.825 3.7204 11.1749 3.72039 11.0097 4.86279L10.956 5.23779C10.6768 7.17152 8.65273 8.32655 6.84567 7.5835L6.22555 7.32861C5.16913 6.89456 4.3281 8.28592 5.20309 9.02002L6.01559 9.70068C7.44505 10.8996 7.44496 13.0993 6.01559 14.2983L5.20309 14.979C4.32774 15.7131 5.16898 17.1047 6.22555 16.6704L6.84567 16.4155C8.65261 15.6726 10.6766 16.8277 10.956 18.7612L11.0097 19.1362C11.1747 20.2791 12.8252 20.2791 12.9902 19.1362L13.0439 18.7612C13.3233 16.8278 15.3473 15.6726 17.1543 16.4155L17.7744 16.6704C18.831 17.1047 19.6722 15.7131 18.7968 14.979L17.9843 14.2983C16.555 13.0993 16.5549 10.8996 17.9843 9.70068L18.7968 9.02002C19.6719 8.28592 18.8309 6.89446 17.7744 7.32861L17.1543 7.5835C15.3472 8.32655 13.3232 7.17152 13.0439 5.23779L12.9902 4.86279ZM12 9.00049C12.7956 9.0005 13.5585 9.31679 14.1211 9.87939C14.6835 10.442 15 11.205 15 12.0005C14.9998 12.796 14.6836 13.5591 14.1211 14.1216C13.5585 14.684 12.7955 15.0005 12 15.0005C11.2044 15.0005 10.4415 14.684 9.87887 14.1216C9.31638 13.5591 9.0001 12.796 8.99997 12.0005C8.99997 11.2049 9.31641 10.442 9.87887 9.87939C10.4415 9.31679 11.2043 9.00049 12 9.00049ZM12 11.0005C11.7348 11.0005 11.4805 11.1059 11.2929 11.2935C11.1055 11.481 11 11.7354 11 12.0005C11.0001 12.2655 11.1055 12.5201 11.2929 12.7075C11.4804 12.8949 11.7349 13.0005 12 13.0005C12.2651 13.0005 12.5195 12.8949 12.707 12.7075C12.8944 12.5201 12.9998 12.2655 13 12.0005C13 11.7354 12.8944 11.481 12.707 11.2935C12.5195 11.1059 12.2652 11.0005 12 11.0005Z" }) });
});
SettingsIcon.displayName = "SettingsIcon";

const ShortcutIcon = forwardRef$1(function ShortcutIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { d: "M13.105 7.553a1 1 0 0 1 1.79.894l-4 8a1 1 0 0 1-1.79-.894l4-8Z" }), jsx("path", { d: "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h12ZM6 5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6Z" })] });
});
ShortcutIcon.displayName = "ShortcutIcon";

const ShuffleIcon = forwardRef$1(function ShuffleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M16.6211 13.0488C17.0085 12.6553 17.6416 12.6497 18.0352 13.0371L20.7012 15.6621C20.8921 15.8501 21 16.1071 21 16.375C21 16.6429 20.8921 16.9 20.7012 17.0879L18.0352 19.7129C17.6416 20.1003 17.0085 20.0947 16.6211 19.7012C16.2337 19.3076 16.2383 18.6746 16.6318 18.2871L17.5586 17.375H16.2803C15.5546 17.3749 14.8555 17.0888 14.3408 16.5752L12.5908 14.8291C12.1999 14.439 12.1998 13.806 12.5898 13.415C12.98 13.0242 13.613 13.023 14.0039 13.4131L15.7539 15.1602C15.8894 15.2952 16.0786 15.3749 16.2803 15.375H17.5586L16.6318 14.4629C16.2383 14.0755 16.2337 13.4424 16.6211 13.0488Z" }), jsx("path", { fill: "currentColor", d: "M16.6914 4.29981C17.0781 3.90562 17.7112 3.89951 18.1055 4.28614L20.7002 6.83204C20.8918 7.02008 21 7.27747 21 7.54591C20.9999 7.81424 20.8917 8.07185 20.7002 8.25977L18.1055 10.8047C17.7112 11.1913 17.0781 11.1852 16.6914 10.791C16.3048 10.3968 16.311 9.76368 16.7051 9.37696L17.5527 8.54591H16.3916C16.1921 8.54598 16.0045 8.62323 15.8691 8.75587L6.98438 17.4678C6.47106 17.971 5.77888 18.25 5.06152 18.25H4C3.44775 18.25 3.00006 17.8022 3 17.25C3 16.6977 3.44772 16.25 4 16.25H5.06152C5.26111 16.25 5.44862 16.1718 5.58398 16.0391L14.4688 7.32813C14.982 6.8249 15.6741 6.54598 16.3916 6.54591H17.5527L16.7051 5.71388C16.3109 5.32717 16.3048 4.69407 16.6914 4.29981Z" }), jsx("path", { fill: "currentColor", d: "M5.01367 5.69727C5.73139 5.69738 6.42329 5.97696 6.93652 6.48048L9.67285 9.16505C10.067 9.55183 10.0733 10.1849 9.68652 10.5791C9.29975 10.9731 8.66664 10.9794 8.27246 10.5928L5.53613 7.90821C5.40078 7.77542 5.21316 7.69738 5.01367 7.69727H4C3.44785 7.69727 3.00022 7.24937 3 6.69727C3 6.14499 3.44772 5.69727 4 5.69727H5.01367Z" })] });
});
ShuffleIcon.displayName = "ShuffleIcon";

const SmsBouncedIcon = forwardRef$1(function SmsBouncedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsxs("g", { transform: "scale(1.5)", children: [jsx("path", { d: "M8.00014 2C11.1867 2 13.6724 3.29909 14.6102 5.76302C14.741 6.10703 14.5681 6.49206 14.2241 6.62305C13.88 6.75391 13.495 6.58104 13.3641 6.23698C12.6905 4.46739 10.8507 3.33333 8.00014 3.33333C6.17297 3.33336 4.75607 3.80593 3.80873 4.5957C2.87617 5.37336 2.33347 6.51123 2.33347 8C2.33347 8.31854 2.45185 8.81365 2.61147 9.31185C2.76425 9.78869 2.92956 10.1923 2.97345 10.2975C2.98116 10.316 2.97297 10.2965 2.98517 10.3255L3.0086 10.3854L3.0353 10.4648C3.1429 10.8172 3.25369 11.597 2.73517 12.6406C2.97214 12.6298 3.20682 12.5777 3.42722 12.5013C3.65419 12.4226 3.84725 12.3255 3.98321 12.248C4.05036 12.2098 4.10239 12.1774 4.13556 12.1556C4.15201 12.1448 4.16406 12.1362 4.17071 12.1315C4.17267 12.1301 4.17425 12.129 4.17527 12.1283C4.38063 11.9781 4.65381 11.9585 4.87905 12.0768C5.7664 12.5433 6.86353 12.6667 8.00014 12.6667C8.28207 12.6667 8.55487 12.6555 8.81785 12.6335C9.18475 12.6027 9.50712 12.8753 9.5379 13.2422C9.56853 13.609 9.29599 13.9315 8.92918 13.9622C8.62755 13.9875 8.31755 14 8.00014 14C6.92072 14 5.70581 13.8988 4.61147 13.4238C4.42531 13.5279 4.16892 13.6553 3.86407 13.7611C3.22999 13.981 2.30623 14.1364 1.38165 13.6986C1.20033 13.6126 1.06674 13.4495 1.01902 13.2546C0.971359 13.0596 1.01439 12.8533 1.13556 12.6934C1.59443 12.0881 1.73936 11.6186 1.77944 11.3184C1.81974 11.0163 1.75835 10.849 1.75665 10.8444L1.756 10.8431C1.75474 10.8401 1.75385 10.8364 1.75144 10.8307C1.7493 10.8257 1.74614 10.8187 1.74298 10.8112L1.74233 10.8105C1.69122 10.688 1.51085 10.2459 1.34194 9.71875C1.17977 9.21261 1.00014 8.5443 1.00014 8C1.00014 6.15569 1.689 4.62663 2.95522 3.57096C4.20689 2.52755 5.95717 2.00003 8.00014 2Z", fill: "currentColor" }), jsx("path", { d: "M10.6662 11.8001C10.7585 11.7921 10.8544 11.8029 10.9474 11.8359C11.2941 11.9594 11.4749 12.3407 11.3517 12.6875C11.3484 12.6968 11.346 12.7041 11.3445 12.7083C11.344 12.71 11.3435 12.7114 11.3432 12.7122L11.3042 12.8053C11.1978 13.0108 10.9897 13.149 10.754 13.1641C10.4846 13.1811 10.2306 13.0337 10.1121 12.791L10.1115 12.7884L10.1024 12.7708C9.93428 12.4433 10.0634 12.0412 10.3908 11.873C10.479 11.8278 10.5732 11.8042 10.6662 11.8001Z", fill: "currentColor" }), jsx("path", { d: "M8.80873 10.1966C9.03905 9.93954 9.42423 9.90331 9.69741 10.1022L9.75079 10.1452L9.77683 10.1686L9.80873 10.1979C10.0814 10.4451 10.1021 10.8665 9.85496 11.1393C9.62333 11.3947 9.23888 11.4291 8.96694 11.2292L8.91355 11.1855L8.86082 11.1387C8.58652 10.8931 8.56312 10.4709 8.80873 10.1966Z", fill: "currentColor" }), jsx("path", { d: "M12.0001 10C12.3682 10.0001 12.6667 10.2986 12.6668 10.6667C12.6667 11.0248 12.3843 11.3157 12.0301 11.3314C11.6638 11.3685 11.3368 11.102 11.2996 10.7357C11.2649 10.3925 11.4968 10.0837 11.8276 10.0156L11.8953 10.0052L12.0001 10Z", fill: "currentColor" }), jsx("path", { d: "M7.3784 9C7.74638 9.00413 8.04174 9.30589 8.0379 9.67383C8.03382 10.0419 7.7321 10.3372 7.36407 10.3333C7.35411 10.3332 7.3437 10.3333 7.33347 10.3333C6.96529 10.3333 6.66681 10.0349 6.66681 9.66667C6.66681 9.29848 6.96529 9 7.33347 9H7.3784Z", fill: "currentColor" }), jsx("path", { d: "M14.0001 7.33333C14.7365 7.33333 15.3335 7.93029 15.3335 8.66667C15.3335 9.40305 14.7365 10 14.0001 10C13.2638 10 12.6668 9.40305 12.6668 8.66667C12.6668 7.93029 13.2638 7.33333 14.0001 7.33333Z", fill: "currentColor" })] }) });
});
SmsBouncedIcon.displayName = "SmsBouncedIcon";

const SmsOpenedIcon = forwardRef$1(function SmsOpenedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsxs("g", { transform: "scale(1.5)", children: [jsx("path", { d: "M7.99965 2C10.0426 2 11.7929 2.52758 13.0446 3.57096C14.3108 4.62664 14.9997 6.15565 14.9997 8C14.9997 8.36819 14.7012 8.66667 14.333 8.66667C13.9649 8.66658 13.6663 8.36814 13.6663 8C13.6663 6.51117 13.1237 5.37336 12.1911 4.5957C11.2437 3.80595 9.82685 3.33333 7.99965 3.33333C6.17248 3.33336 4.75558 3.80593 3.80825 4.5957C2.87569 5.37336 2.33299 6.51123 2.33299 8C2.33299 8.31854 2.45136 8.81365 2.61098 9.31185C2.76376 9.78869 2.92907 10.1923 2.97296 10.2975C2.98067 10.316 2.97248 10.2965 2.98468 10.3255L3.00812 10.3854L3.03481 10.4648C3.14241 10.8172 3.2532 11.597 2.73468 12.6406C2.97165 12.6298 3.20633 12.5777 3.42674 12.5013C3.65371 12.4226 3.84676 12.3255 3.98273 12.248C4.04988 12.2098 4.1019 12.1774 4.13507 12.1556C4.15152 12.1448 4.16357 12.1361 4.17023 12.1315C4.17218 12.1301 4.17376 12.129 4.17478 12.1283C4.38014 11.9781 4.65333 11.9585 4.87856 12.0768C5.76591 12.5433 6.86304 12.6667 7.99965 12.6667C8.36784 12.6667 8.66632 12.9651 8.66632 13.3333C8.66632 13.7015 8.36784 14 7.99965 14C6.92023 14 5.70533 13.8988 4.61098 13.4238C4.42482 13.5279 4.16843 13.6553 3.86358 13.7611C3.2295 13.981 2.30575 14.1364 1.38116 13.6986C1.19984 13.6126 1.06626 13.4495 1.01853 13.2546C0.970871 13.0596 1.0139 12.8533 1.13507 12.6934C1.59394 12.0881 1.73888 11.6186 1.77895 11.3184C1.81925 11.0163 1.75786 10.849 1.75616 10.8444L1.75551 10.8431C1.75425 10.8401 1.75337 10.8364 1.75095 10.8307C1.74881 10.8257 1.74565 10.8187 1.74249 10.8112L1.74184 10.8105C1.69073 10.688 1.51037 10.2459 1.34145 9.71875C1.17928 9.21261 0.999652 8.5443 0.999652 8C0.999652 6.15569 1.68852 4.62663 2.95473 3.57096C4.2064 2.52755 5.95668 2.00003 7.99965 2Z", fill: "currentColor" }), jsx("path", { d: "M13.54 10.1836C13.8066 9.92992 14.2289 9.94056 14.4827 10.207C14.7364 10.4737 14.7258 10.8959 14.4593 11.1497L11.6592 13.8164C11.4017 14.0612 10.9972 14.0613 10.7399 13.8164L9.54002 12.6732C9.27351 12.4193 9.26279 11.9971 9.51658 11.7305C9.77045 11.4639 10.1927 11.4539 10.4593 11.7077L11.1989 12.4121L13.54 10.1836Z", fill: "currentColor" }), jsx("path", { d: "M4.99965 7.16667C5.4599 7.16667 5.83299 7.5398 5.83299 8C5.83299 8.4602 5.4599 8.83333 4.99965 8.83333C4.53948 8.83325 4.16632 8.46014 4.16632 8C4.16632 7.53986 4.53948 7.16675 4.99965 7.16667Z", fill: "currentColor" }), jsx("path", { d: "M7.99965 7.16667C8.45986 7.16667 8.83299 7.53979 8.83299 8C8.83299 8.4602 8.45986 8.83333 7.99965 8.83333C7.53952 8.83325 7.16632 8.46015 7.16632 8C7.16632 7.53985 7.53952 7.16675 7.99965 7.16667Z", fill: "currentColor" }), jsx("path", { d: "M10.9997 7.16667C11.4599 7.16667 11.833 7.53979 11.833 8C11.833 8.4602 11.4599 8.83333 10.9997 8.83333C10.5395 8.83325 10.1663 8.46015 10.1663 8C10.1663 7.53985 10.5395 7.16675 10.9997 7.16667Z", fill: "currentColor" })] }) });
});
SmsOpenedIcon.displayName = "SmsOpenedIcon";

const SmsSentIcon = forwardRef$1(function SmsSentIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsxs("g", { transform: "scale(1.5)", children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.1939 9.69466C10.4018 9.51865 10.696 9.48716 10.9367 9.61458L14.636 11.5723C14.8541 11.6878 14.9901 11.9152 14.9901 12.1621C14.99 12.4089 14.854 12.6358 14.636 12.7513L10.9367 14.709C10.696 14.8364 10.4018 14.8049 10.1939 14.6289C9.9861 14.4529 9.90672 14.1679 9.99273 13.9095L10.5754 12.1621L9.99273 10.4141C9.90672 10.1557 9.9861 9.87072 10.1939 9.69466ZM11.9107 11.9512C11.9562 12.0878 11.9562 12.2358 11.9107 12.3724L11.7844 12.752L12.899 12.1621L11.7844 11.5716L11.9107 11.9512Z", fill: "currentColor" }), jsx("path", { d: "M8.66656 12.6667C9.03475 12.6667 9.33323 12.9651 9.33323 13.3333C9.33323 13.7015 9.03475 14 8.66656 14H7.9999C7.63178 13.9999 7.33323 13.7015 7.33323 13.3333C7.33323 12.9652 7.63178 12.6668 7.9999 12.6667H8.66656Z", fill: "currentColor" }), jsx("path", { d: "M7.9999 2C10.0429 2 11.7931 2.52758 13.0448 3.57096C14.3111 4.62664 14.9999 6.15565 14.9999 8C14.9999 8.36819 14.7014 8.66667 14.3332 8.66667C13.9651 8.66658 13.6666 8.36814 13.6666 8C13.6666 6.51117 13.1239 5.37336 12.1913 4.5957C11.2439 3.80595 9.8271 3.33333 7.9999 3.33333C6.17273 3.33336 4.75582 3.80593 3.80849 4.5957C2.87593 5.37336 2.33323 6.51123 2.33323 8C2.33323 8.31854 2.4516 8.81365 2.61122 9.31185C2.764 9.78869 2.92931 10.1923 2.9732 10.2975C2.98092 10.316 2.97272 10.2965 2.98492 10.3255L3.00836 10.3854L3.03505 10.4648C3.14266 10.8172 3.25345 11.597 2.73492 12.6406C2.97189 12.6298 3.20658 12.5777 3.42698 12.5013C3.65395 12.4226 3.847 12.3255 3.98297 12.248C4.05012 12.2098 4.10214 12.1774 4.13531 12.1556C4.15176 12.1448 4.16381 12.1362 4.17047 12.1315C4.17243 12.1301 4.174 12.129 4.17503 12.1283C4.47177 11.9113 4.88841 11.9758 5.10602 12.2721C5.32373 12.5691 5.25971 12.9867 4.96279 13.2044L4.56891 12.6667C4.9303 13.1595 4.96049 13.2009 4.96279 13.2044L4.96214 13.2051L4.96083 13.2057C4.96023 13.2062 4.95965 13.2071 4.95888 13.2077L4.93284 13.2259C4.9169 13.237 4.89476 13.2518 4.86773 13.2695C4.81367 13.3051 4.73774 13.353 4.64313 13.4069C4.4549 13.5141 4.1862 13.6492 3.86383 13.7611C3.22975 13.981 2.30599 14.1364 1.38141 13.6986C1.20008 13.6126 1.0665 13.4495 1.01878 13.2546C0.971115 13.0596 1.01414 12.8533 1.13531 12.6934C1.59419 12.0881 1.73912 11.6186 1.77919 11.3184C1.81949 11.0163 1.75811 10.849 1.75641 10.8444L1.75576 10.8431C1.7545 10.8401 1.75361 10.8364 1.7512 10.8307C1.74905 10.8257 1.74589 10.8187 1.74273 10.8112L1.74208 10.8105C1.69097 10.688 1.51061 10.2459 1.34169 9.71875C1.17953 9.21261 0.999896 8.5443 0.999896 8C0.999896 6.15569 1.68876 4.62663 2.95497 3.57096C4.20665 2.52755 5.95693 2.00003 7.9999 2Z", fill: "currentColor" }), jsx("path", { d: "M8.66656 10.6667C9.03475 10.6667 9.33323 10.9651 9.33323 11.3333C9.33323 11.7015 9.03475 12 8.66656 12H6.66656C6.29845 11.9999 5.9999 11.7015 5.9999 11.3333C5.9999 10.9652 6.29845 10.6668 6.66656 10.6667H8.66656Z", fill: "currentColor" }), jsx("path", { d: "M4.9999 7.16667C5.46014 7.16667 5.83323 7.5398 5.83323 8C5.83323 8.4602 5.46014 8.83333 4.9999 8.83333C4.53972 8.83325 4.16656 8.46014 4.16656 8C4.16656 7.53986 4.53972 7.16675 4.9999 7.16667Z", fill: "currentColor" }), jsx("path", { d: "M7.9999 7.16667C8.4601 7.16667 8.83323 7.5398 8.83323 8C8.83323 8.4602 8.4601 8.83333 7.9999 8.83333C7.53976 8.83325 7.16656 8.46015 7.16656 8C7.16656 7.53985 7.53976 7.16675 7.9999 7.16667Z", fill: "currentColor" }), jsx("path", { d: "M10.9999 7.16667C11.4601 7.16667 11.8332 7.5398 11.8332 8C11.8332 8.4602 11.4601 8.83333 10.9999 8.83333C10.5398 8.83325 10.1666 8.46015 10.1666 8C10.1666 7.53985 10.5398 7.16675 10.9999 7.16667Z", fill: "currentColor" })] }) });
});
SmsSentIcon.displayName = "SmsSentIcon";

const SmsTappedIcon = forwardRef$1(function SmsTappedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsxs("g", { transform: "scale(1.5)", children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.69041 9.02409C9.86499 8.84951 10.1217 8.78552 10.3577 8.85807L14.3577 10.0892C14.618 10.1694 14.804 10.3998 14.8265 10.6712C14.8488 10.9426 14.7035 11.2004 14.4599 11.3223L12.8122 12.1458L11.9886 13.7936C11.8667 14.0371 11.6089 14.1825 11.3375 14.1602C11.0661 14.1377 10.8357 13.9516 10.7555 13.6914L9.52439 9.69141C9.45185 9.45547 9.5159 9.19867 9.69041 9.02409ZM11.54 11.7083L11.7191 11.3509C11.7835 11.222 11.8883 11.1172 12.0172 11.0527L12.3747 10.8737L11.1689 10.5026L11.54 11.7083Z", fill: "currentColor" }), jsx("path", { d: "M7.99965 2C10.0426 2 11.7929 2.52758 13.0446 3.57096C14.3108 4.62664 14.9997 6.15565 14.9997 8C14.9997 8.36819 14.7012 8.66667 14.333 8.66667C13.9649 8.66658 13.6663 8.36814 13.6663 8C13.6663 6.51117 13.1237 5.37336 12.1911 4.5957C11.2437 3.80595 9.82685 3.33333 7.99965 3.33333C6.17248 3.33336 4.75558 3.80593 3.80825 4.5957C2.87569 5.37336 2.33299 6.51123 2.33299 8C2.33299 8.31854 2.45136 8.81365 2.61098 9.31185C2.76376 9.78869 2.92907 10.1923 2.97296 10.2975C2.98067 10.316 2.97248 10.2965 2.98468 10.3255L3.00812 10.3854L3.03481 10.4648C3.14241 10.8172 3.2532 11.597 2.73468 12.6406C2.97165 12.6298 3.20633 12.5777 3.42674 12.5013C3.65371 12.4226 3.84676 12.3255 3.98273 12.248C4.04988 12.2098 4.1019 12.1774 4.13507 12.1556C4.15152 12.1448 4.16357 12.1361 4.17023 12.1315C4.17218 12.1301 4.17478 12.1283 4.17478 12.1283C4.38014 11.9781 4.65333 11.9585 4.87856 12.0768C5.76591 12.5433 6.86304 12.6667 7.99965 12.6667C8.28158 12.6667 8.55439 12.6555 8.81736 12.6335C9.18426 12.6027 9.50663 12.8753 9.53741 13.2422C9.56804 13.609 9.2955 13.9315 8.92869 13.9622C8.62706 13.9875 8.31706 14 7.99965 14C6.92023 14 5.70533 13.8988 4.61098 13.4238C4.42482 13.5279 4.16843 13.6553 3.86358 13.7611C3.2295 13.981 2.30575 14.1364 1.38116 13.6986C1.19984 13.6126 1.06626 13.4495 1.01853 13.2546C0.970871 13.0596 1.0139 12.8533 1.13507 12.6934C1.59394 12.0881 1.73888 11.6186 1.77895 11.3184C1.81925 11.0163 1.75786 10.849 1.75616 10.8444L1.75551 10.8431C1.75425 10.8401 1.75337 10.8364 1.75095 10.8307C1.74881 10.8257 1.74565 10.8187 1.74249 10.8112L1.74184 10.8105C1.69073 10.688 1.51037 10.2459 1.34145 9.71875C1.17928 9.21261 0.999652 8.5443 0.999652 8C0.999652 6.15569 1.68852 4.62663 2.95473 3.57096C4.2064 2.52755 5.95668 2.00003 7.99965 2Z", fill: "currentColor" }), jsx("path", { d: "M7.41632 9.33333C7.78451 9.33333 8.08299 9.63181 8.08299 10C8.08299 10.3682 7.78451 10.6667 7.41632 10.6667H6.66632C6.2982 10.6666 5.99965 10.3681 5.99965 10C5.99965 9.63186 6.2982 9.33342 6.66632 9.33333H7.41632Z", fill: "currentColor" }), jsx("path", { d: "M7.36619 6.69987C7.6265 6.43955 8.04919 6.43962 8.30955 6.69987L8.8395 7.23047C9.09985 7.49082 9.09985 7.91283 8.8395 8.17318C8.57914 8.43345 8.15711 8.4335 7.89679 8.17318L7.36619 7.64323C7.10597 7.3829 7.10595 6.96019 7.36619 6.69987Z", fill: "currentColor" }), jsx("path", { d: "M10.6663 5.33333C11.0345 5.33333 11.333 5.63181 11.333 6V6.75C11.333 7.11819 11.0345 7.41667 10.6663 7.41667C10.2982 7.41658 9.99965 7.11814 9.99965 6.75V6C9.99965 5.63186 10.2982 5.33342 10.6663 5.33333Z", fill: "currentColor" })] }) });
});
SmsTappedIcon.displayName = "SmsTappedIcon";

const SmsIcon = forwardRef$1(function SmsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { transform: "scale(1.5)", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.99975 1.83203C10.0945 1.83203 11.887 2.37578 13.1677 3.44857C14.4625 4.53327 15.1664 6.10349 15.1664 7.9987C15.1664 9.89389 14.4625 11.4641 13.1677 12.5488C11.887 13.6216 10.0945 14.1654 7.99975 14.1654C6.89038 14.1654 5.64362 14.0605 4.52189 13.5697C4.33092 13.6774 4.0655 13.8099 3.74975 13.9199C3.10086 14.146 2.15712 14.3053 1.21329 13.8561C1.03248 13.77 0.899585 13.6066 0.851964 13.4121C0.804487 13.2177 0.847315 13.012 0.967849 12.8522C1.44148 12.2244 1.59118 11.7359 1.63256 11.4219C1.67387 11.1081 1.61166 10.9326 1.60847 10.9238C1.60956 10.9268 1.60959 10.927 1.60717 10.9212C1.60588 10.9182 1.60434 10.9151 1.60196 10.9095C1.59977 10.9043 1.59672 10.8971 1.5935 10.8893C1.54194 10.7651 1.35678 10.3098 1.18334 9.76628C1.01668 9.24395 0.833083 8.55673 0.833083 7.9987C0.833083 6.10351 1.53704 4.53327 2.83178 3.44857C4.11244 2.37577 5.90502 1.83205 7.99975 1.83203ZM7.99975 3.16536C6.12244 3.16538 4.6648 3.65298 3.68855 4.4707C2.72652 5.27662 2.16642 6.45651 2.16642 7.9987C2.16642 8.33176 2.28941 8.84631 2.45353 9.36068C2.61083 9.85365 2.78073 10.2703 2.82527 10.3776C2.83132 10.3922 2.82682 10.382 2.83699 10.4062C2.8429 10.4204 2.85163 10.4409 2.86043 10.4648C2.97312 10.7724 3.16012 11.6269 2.56485 12.8073C2.82075 12.7996 3.07397 12.7434 3.31095 12.6608C3.54502 12.5792 3.74429 12.4787 3.88452 12.3984C3.954 12.3587 4.00777 12.3247 4.04207 12.3021C4.05913 12.2908 4.07158 12.2822 4.07853 12.2773C4.08097 12.2756 4.08373 12.2734 4.08373 12.2734C4.28955 12.1225 4.56369 12.1028 4.78946 12.222C5.70364 12.7049 6.83257 12.832 7.99975 12.832C9.87705 12.832 11.3347 12.3444 12.3109 11.5267C13.273 10.7208 13.8331 9.54089 13.8331 7.9987C13.8331 6.45648 13.273 5.27662 12.3109 4.4707C11.3347 3.65299 9.87706 3.16536 7.99975 3.16536Z", fill: "currentColor" }) }) });
});
SmsIcon.displayName = "SmsIcon";

const SortVerticalDownIcon = forwardRef$1(function SortVerticalDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.5877 19.4189C11.3683 20.195 12.6314 20.195 13.412 19.4189L16.7049 16.1425C17.0962 15.753 17.0982 15.1199 16.7088 14.7285C16.3194 14.3371 15.6863 14.3362 15.2948 14.7255L12.9998 17.0087V4.99996C12.9997 4.4478 12.552 3.99998 11.9998 3.99996C11.4476 3.99995 11 4.44778 10.9998 4.99996V17.0087L8.70492 14.7255C8.31347 14.3362 7.68038 14.3372 7.29086 14.7285C6.90142 15.12 6.90338 15.753 7.29477 16.1425L10.5877 19.4189Z" }) });
});
SortVerticalDownIcon.displayName = "SortVerticalDownIcon";

const SortVerticalUpIcon = forwardRef$1(function SortVerticalUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.7391 4.44621C11.5239 3.8091 12.68 3.85417 13.412 4.58195L16.7049 7.85832L16.7743 7.93351C17.0954 8.32542 17.0739 8.90537 16.7088 9.27238C16.3194 9.66373 15.6863 9.66462 15.2948 9.27531L12.9998 6.99211V19.0009C12.9997 19.5531 12.552 20.0009 11.9998 20.0009C11.4476 20.0009 11 19.5531 10.9998 19.0009V6.99211L8.70492 9.27531L8.62875 9.34465C8.23524 9.66359 7.65592 9.63908 7.29086 9.27238C6.90142 8.88088 6.90338 8.24782 7.29477 7.85832L10.5877 4.58195L10.7391 4.44621Z" }) });
});
SortVerticalUpIcon.displayName = "SortVerticalUpIcon";

const SortVerticalIcon = forwardRef$1(function SortVerticalIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M5.58822 3.58203C6.3688 2.80626 7.63201 2.80603 8.41244 3.58203L11.7054 6.8584C12.0962 7.24783 12.0983 7.88108 11.7093 8.27246C11.32 8.6637 10.6868 8.66438 10.2953 8.27539L8.00033 5.99219V20.001L7.99545 20.1035C7.94415 20.6074 7.51765 21.0006 7.00033 21.001C6.4827 21.001 6.0566 20.6076 6.00522 20.1035L6.00033 20.001V5.99219L3.70541 8.27539C3.31406 8.66468 2.68089 8.6634 2.29135 8.27246C1.90191 7.88096 1.90386 7.2479 2.29526 6.8584L5.58822 3.58203ZM16.9994 3C17.5169 3.00008 17.9431 3.39344 17.9945 3.89746L17.9994 4V18.0088L20.2943 15.7256C20.6857 15.3363 21.3189 15.3373 21.7083 15.7285C22.0977 16.12 22.0957 16.7531 21.7044 17.1426L18.4115 20.4189C17.6309 21.1949 16.3677 21.195 15.5872 20.4189L12.2943 17.1426C11.9031 16.7531 11.9012 16.12 12.2904 15.7285C12.6798 15.3373 13.313 15.3364 13.7044 15.7256L15.9994 18.0088V4L16.0042 3.89746C16.0556 3.39349 16.4819 3.00017 16.9994 3Z" }) });
});
SortVerticalIcon.displayName = "SortVerticalIcon";

const SourceIcon = forwardRef$1(function SourceIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 1.99902C14.3307 1.99902 16.4907 2.47043 18.1045 3.27734C19.6581 4.0543 20.9997 5.31209 21 6.99902V16.9797C21 16.9904 20.9913 16.999 20.9806 16.999V16.999C20.971 16.999 20.9629 17.0061 20.9614 17.0156C20.9537 17.0682 20.9448 17.1212 20.9346 17.1738C20.7257 18.2515 20.0426 19.1873 19.0986 19.9229C18.1535 20.6592 16.9289 21.2131 15.5684 21.5625C14.2031 21.9131 12.712 22.0549 11.2363 21.9805C9.7615 21.9061 8.32799 21.6168 7.07617 21.1279C5.83097 20.6415 4.76107 19.9554 4.02539 19.0918C3.37975 18.3338 3.00206 17.4437 3.00098 16.5005C3.00098 16.5002 3.00076 16.5 3.00049 16.5V16.5C3.00022 16.5 3 16.4998 3 16.4995V7C3 5.31282 4.34175 4.05438 5.89551 3.27734C7.50934 2.47043 9.66928 1.99902 12 1.99902ZM18.9065 15.9648C18.7959 15.645 18.4071 15.5713 18.1045 15.7227V15.7227C16.4907 16.5295 14.3306 17 12 17C9.66937 17 7.50932 16.5295 5.89551 15.7227V15.7227C5.59214 15.571 5.20215 15.646 5.09135 15.9666C5.05135 16.0823 5.02527 16.195 5.01172 16.3037C4.95577 16.7543 5.09481 17.263 5.54785 17.7949C6.01152 18.3392 6.77129 18.862 7.80469 19.2656C8.83172 19.6667 10.0495 19.9185 11.3369 19.9834C12.6237 20.0483 13.913 19.9224 15.0713 19.625C16.2336 19.3265 17.19 18.8738 17.8691 18.3447C18.5491 17.8149 18.8786 17.2684 18.9707 16.7939C19.0215 16.5315 19.0065 16.254 18.9065 15.9648ZM5 12L5.00488 12.0996C5.05898 12.6134 5.53255 13.3047 6.79004 13.9336C8.07163 14.5743 9.91255 15 12 15C14.0875 15 15.9284 14.5743 17.21 13.9336C18.4674 13.3047 18.941 12.6134 18.9951 12.0996L19 12V11.2368C19 10.7953 18.4994 10.5252 18.1045 10.7227V10.7227C16.4907 11.5295 14.3306 12 12 12C9.66937 12 7.50932 11.5295 5.89551 10.7227V10.7227C5.50064 10.5252 5 10.7953 5 11.2368V12ZM12 4C9.91244 4 8.07164 4.42561 6.79004 5.06641C5.44911 5.73703 5 6.47834 5 7C5.00028 7.52166 5.44937 8.26315 6.79004 8.93359C8.07163 9.57434 9.91255 10 12 10C14.0874 10 15.9284 9.57434 17.21 8.93359C18.5506 8.26315 18.9997 7.52166 19 7C19 6.47834 18.5509 5.73703 17.21 5.06641C15.9284 4.42561 14.0876 4 12 4Z" }) });
});
SourceIcon.displayName = "SourceIcon";

const SparkleSquareIcon = forwardRef$1(function SparkleSquareIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.997 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3v-2a1 1 0 0 1 2 0v2a1 1 0 0 0 .65.936l2.229-2.229a3 3 0 0 1 4.117-.118l.963-.963a3.001 3.001 0 0 1 4.115-.12l1.926 1.712V6a1 1 0 0 0-1-1h-12a1 1 0 0 0-1 1v2a1 1 0 1 1-2 0V6a3 3 0 0 1 3-3h12Zm-7.293 15.121a1 1 0 0 0-1.414 0L8.411 19h3.172l-.879-.879ZM15.742 17a1 1 0 0 0-1.37.041l-.96.959 1 1h3.58l-2.25-2Z", clipRule: "evenodd" }), jsx("path", { fill: "currentColor", d: "M7.552 8.506c.339-.68 1.364-.673 1.322.009l-.067 1.08c-.05.799.455 1.415 1.267 1.549l2.423.189c1 0 1 1.334 0 1.334l-2.858.215c-.878.129-1.438.734-1.832 1.524l-.543 1.088c-.337.675-1.354.675-1.323 0l.056-1.16c.036-.754-.702-1.343-1.453-1.506l-1.161-.25c-.67-.147-.408-1.107.342-1.253l1.298-.25c.84-.163 1.623-.753 2-1.507l.529-1.062ZM16.998 11a1 1 0 0 1 0 2h-1a1 1 0 0 1 0-2h1Zm0-4a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h5Z" })] });
});
SparkleSquareIcon.displayName = "SparkleSquareIcon";

const SparkleIcon = forwardRef$1(function SparkleIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M8.12006 7.09775C8.32364 6.14969 9.67636 6.1497 9.87994 7.09775L10.0566 7.92036C10.3818 9.435 11.565 10.6182 13.0796 10.9434L13.9022 11.1201C14.8503 11.3236 14.8503 12.6764 13.9022 12.8799L13.0796 13.0566C11.565 13.3818 10.3818 14.565 10.0566 16.0796L9.87994 16.9022C9.67636 17.8503 8.32364 17.8503 8.12006 16.9022L7.94342 16.0796C7.61817 14.565 6.435 13.3818 4.92036 13.0566L4.09775 12.8799C3.14969 12.6764 3.1497 11.3236 4.09775 11.1201L4.92036 10.9434C6.435 10.6182 7.61817 9.435 7.94342 7.92036L8.12006 7.09775Z" }), jsx("path", { d: "M16.6089 4.82122C16.6994 4.39987 17.3006 4.39987 17.3911 4.82122L17.4696 5.18683C17.6141 5.86 18.14 6.38585 18.8132 6.53041L19.1788 6.60892C19.6001 6.6994 19.6001 7.3006 19.1788 7.39108L18.8132 7.46959C18.14 7.61415 17.6141 8.14 17.4696 8.81317L17.3911 9.17878C17.3006 9.60014 16.6994 9.60014 16.6089 9.17878L16.5304 8.81317C16.3859 8.14 15.86 7.61415 15.1868 7.46959L14.8212 7.39109C14.3999 7.3006 14.3999 6.6994 14.8212 6.60892L15.1868 6.53041C15.86 6.38585 16.3859 5.86 16.5304 5.18683L16.6089 4.82122Z" }), jsx("path", { d: "M16.4134 13.7318C16.5491 13.0998 17.4509 13.0998 17.5866 13.7318L17.7044 14.2802C17.9212 15.29 18.71 16.0788 19.7198 16.2956L20.2682 16.4134C20.9002 16.5491 20.9002 17.4509 20.2682 17.5866L19.7198 17.7044C18.71 17.9212 17.9212 18.71 17.7044 19.7198L17.5866 20.2682C17.4509 20.9002 16.5491 20.9002 16.4134 20.2682L16.2956 19.7198C16.0788 18.71 15.29 17.9212 14.2802 17.7044L13.7318 17.5866C13.0998 17.4509 13.0998 16.5491 13.7318 16.4134L14.2802 16.2956C15.29 16.0788 16.0788 15.29 16.2956 14.2802L16.4134 13.7318Z" })] });
});
SparkleIcon.displayName = "SparkleIcon";

const SplitIcon = forwardRef$1(function SplitIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 3C12.5523 3 13 3.44772 13 4V12.0625C15.9963 12.4324 18.5757 14.4448 19.6367 17.3281L20.0303 15.7578L20.0596 15.6592C20.2316 15.1827 20.7401 14.9049 21.2422 15.0303C21.7446 15.1559 22.0631 15.6408 21.9902 16.1426L21.9697 16.2422L20.9697 20.2422C20.8441 20.7446 20.3592 21.0631 19.8574 20.9902L19.7578 20.9697L15.7578 19.9697C15.2221 19.8358 14.8965 19.2935 15.0303 18.7578C15.1642 18.2221 15.7065 17.8965 16.2422 18.0303L17.917 18.4482L17.7686 18.041C16.8864 15.6152 14.5813 14 12 14C9.41874 14 7.11358 15.6152 6.23145 18.041L6.08203 18.4482L7.75781 18.0303L7.85742 18.0098C8.35919 17.9369 8.84411 18.2554 8.96973 18.7578C9.09514 19.2599 8.81736 19.7684 8.34082 19.9404L8.24219 19.9697L4.24219 20.9697C3.74006 21.0951 3.23162 20.8173 3.05957 20.3408L3.03027 20.2422L2.03027 16.2422C1.89648 15.7065 2.22212 15.1642 2.75781 15.0303C3.29353 14.8965 3.83579 15.2221 3.96973 15.7578L4.36133 17.3291C5.42203 14.445 8.00319 12.4325 11 12.0625V4C11 3.44773 11.4477 3.00002 12 3Z" }) });
});
SplitIcon.displayName = "SplitIcon";

const SqlIcon = forwardRef$1(function SqlIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.3965 7C14.8544 7 16.3975 8.75197 16.3975 11.5439C16.3974 13.0889 15.9309 14.33 15.0732 15.0781L15.54 15.7959C15.655 15.9842 15.7011 16.1241 15.7012 16.3125C15.7012 16.7139 15.4075 16.9999 14.9932 17C14.7111 17 14.5262 16.8902 14.3535 16.6104L13.8477 15.8379C13.4044 15.996 12.9203 16.0752 12.3965 16.0752C9.93314 16.075 8.39068 14.36 8.39062 11.5439C8.39062 8.75213 9.9331 7.0002 12.3965 7ZM4.23535 7C5.75464 7.00012 6.90009 7.67509 7.26855 8.81836C7.30885 8.94001 7.33203 9.06841 7.33203 9.22656C7.3319 9.66436 7.03199 9.96191 6.58887 9.96191C6.19771 9.96182 5.95638 9.79781 5.76074 9.4209C5.4845 8.758 4.94892 8.48448 4.23535 8.48438C3.37771 8.48438 2.80765 8.90995 2.80762 9.55469C2.80762 10.096 3.20444 10.4309 4.18848 10.6377L5.06348 10.8262C6.82485 11.1972 7.58495 11.9452 7.58496 13.2773C7.58496 14.9927 6.31245 16.0752 4.24023 16.0752C2.52518 16.0751 1.42563 15.3516 1.0918 14.3906C1.03424 14.2325 1 14.0617 1 13.8975C1.00015 13.411 1.31675 13.0889 1.76562 13.0889C2.12243 13.0889 2.35824 13.2349 2.56543 13.624C2.83597 14.2931 3.4869 14.5977 4.28125 14.5977C5.21341 14.5976 5.84641 14.123 5.84668 13.4785C5.84668 12.9007 5.45495 12.5717 4.41309 12.3467L3.53223 12.1641C1.87479 11.8173 1.06348 10.9776 1.06348 9.66992C1.06369 8.0643 2.38778 7 4.23535 7ZM18.3955 7.03027C18.942 7.03047 19.2646 7.38322 19.2646 7.99121V14.4082H22.2109C22.6829 14.4082 23 14.6945 23 15.1689C23 15.6434 22.6887 15.9297 22.2109 15.9297H18.3955C17.8488 15.9297 17.5265 15.5767 17.5264 14.9688V7.99121C17.5264 7.38305 17.8487 7.03027 18.3955 7.03027ZM12.3965 8.51465C11.0325 8.51489 10.1631 9.70107 10.1631 11.5439C10.1631 13.3807 11.0326 14.5603 12.3965 14.5605C12.6095 14.5605 12.806 14.5303 12.9902 14.4756L12.5928 13.8672C12.4778 13.6849 12.4317 13.527 12.4316 13.375C12.4316 12.9796 12.7079 12.6992 13.082 12.6992C13.3237 12.6993 13.4909 12.7911 13.6348 13.0039L14.0205 13.5576C14.4061 13.0832 14.625 12.3894 14.625 11.5439C14.625 9.70088 13.7549 8.51465 12.3965 8.51465Z" }) });
});
SqlIcon.displayName = "SqlIcon";

const StarBadgeIcon = forwardRef$1(function StarBadgeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.75585 2.8152C11.0855 1.69201 13.0882 1.72951 14.373 2.9275L14.4971 3.03004C14.7998 3.25334 15.1918 3.35722 15.5859 3.30348L15.7539 3.28492C17.4893 3.13255 19.121 4.28547 19.4385 6.03004L19.4746 6.17555C19.578 6.51133 19.8202 6.80685 20.165 6.98316L20.3144 7.06422C21.7869 7.91054 22.413 9.70932 21.7197 11.2683L21.6455 11.4236C21.4606 11.7883 21.4606 12.2112 21.6455 12.5759L21.7197 12.7312C22.413 14.2903 21.7869 16.089 20.3144 16.9353L20.165 17.0164C19.8203 17.1926 19.5779 17.4881 19.4746 17.824L19.4385 17.9695C19.121 19.7139 17.4893 20.8669 15.7539 20.7146L15.5859 20.6961C15.1916 20.6423 14.7997 20.7462 14.4971 20.9695L14.373 21.072C13.0882 22.2699 11.0855 22.3074 9.75585 21.1843L9.62889 21.072C9.3535 20.8154 8.9766 20.6729 8.58495 20.6824L8.416 20.6961C6.67516 20.9332 4.99962 19.842 4.59862 18.1365L4.56346 17.9695C4.50048 17.6238 4.29309 17.3079 3.9785 17.0994L3.8369 17.0164C2.20697 16.1825 1.5225 14.2203 2.35643 12.5759L2.41698 12.4373C2.52124 12.1538 2.52122 11.8457 2.41698 11.5623L2.35643 11.4236C1.52246 9.77928 2.20691 7.817 3.8369 6.98316L3.9785 6.90016C4.29314 6.6916 4.50047 6.3757 4.56346 6.03004L4.59862 5.86305C4.99959 4.15745 6.67513 3.06629 8.416 3.30348L8.58495 3.31715C8.97653 3.32666 9.35345 3.18415 9.62889 2.9275L9.75585 2.8152ZM13.0088 4.39039C12.4856 3.90257 11.6622 3.8717 11.1015 4.29859L10.9932 4.39039C10.2782 5.05691 9.30986 5.38428 8.33983 5.30641L8.14647 5.28492C7.39795 5.18288 6.74377 5.63677 6.56151 6.26051L6.53124 6.38746V6.38844C6.35569 7.35207 5.75924 8.17822 4.91893 8.66969L4.74803 8.76344C4.06254 9.114 3.82343 9.89273 4.14061 10.5183L4.22362 10.6961C4.58573 11.5291 4.58575 12.4704 4.22362 13.3035L4.14061 13.4812C3.82347 14.1068 4.06248 14.8855 4.74803 15.2361L4.91893 15.3298C5.75942 15.8214 6.35583 16.6483 6.53124 17.6121L6.56151 17.739C6.74379 18.3627 7.39795 18.8166 8.14647 18.7146L8.33983 18.6931C9.30979 18.6153 10.2781 18.9425 10.9932 19.6091L11.1015 19.7009C11.6622 20.1278 12.4856 20.0969 13.0088 19.6091L13.1553 19.4812C13.9028 18.86 14.8864 18.5826 15.8555 18.7146L16.0039 18.7273C16.7382 18.7571 17.3531 18.2568 17.4707 17.6121L17.5117 17.4207C17.7424 16.4762 18.3818 15.6821 19.2539 15.2361L19.3769 15.1658C19.9281 14.8141 20.1323 14.1617 19.915 13.5994L19.8613 13.4812C19.3879 12.5478 19.3879 11.4518 19.8613 10.5183L19.915 10.4002C20.1323 9.83793 19.9277 9.18641 19.3769 8.83473L19.2539 8.76344C18.3238 8.28774 17.6579 7.4162 17.4707 6.38844V6.38746C17.3531 5.74262 16.7382 5.24245 16.0039 5.27223L15.8555 5.28492C14.8863 5.41696 13.9028 5.13937 13.1553 4.51832L13.0088 4.39039ZM11.4346 8.41481C11.7076 7.86155 12.4965 7.86155 12.7695 8.41481L13.4599 9.81422C13.5683 10.0338 13.7781 10.1862 14.0205 10.2214L15.5654 10.4461C16.1757 10.5349 16.4192 11.285 15.9775 11.7156L14.8603 12.8045C14.6849 12.9755 14.6051 13.2222 14.6465 13.4636L14.9101 15.0017C15.0144 15.6095 14.376 16.0735 13.8301 15.7869L12.4482 15.0603C12.2314 14.9463 11.9727 14.9463 11.7558 15.0603L10.374 15.7869C9.82802 16.0734 9.18973 15.6095 9.29393 15.0017L9.55858 13.4636C9.59999 13.2222 9.51917 12.9755 9.34374 12.8045L8.22655 11.7156C7.78487 11.2851 8.02846 10.535 8.63866 10.4461L10.1836 10.2214C10.426 10.1862 10.6358 10.0339 10.7441 9.81422L11.4346 8.41481Z" }) });
});
StarBadgeIcon.displayName = "StarBadgeIcon";

const StarIcon = forwardRef$1(function StarIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.2538 3.49934C11.0473 2.12298 13.1091 2.16917 13.8182 3.63703L15.7372 7.60871L15.7704 7.64778C15.7851 7.65839 15.8035 7.66646 15.8241 7.66926L20.2421 8.24446L20.3954 8.26985C21.9039 8.57891 22.531 10.4282 21.4764 11.5726L21.3641 11.6849L18.1327 14.7142C18.1068 14.7389 18.0979 14.7725 18.1034 14.8021L18.9139 19.1292L18.9374 19.2855C19.111 20.8301 17.5069 21.9468 16.1112 21.3245L15.9735 21.2562L12.0575 19.1575C12.0308 19.1433 11.9986 19.1396 11.9696 19.1468L11.9423 19.1575L8.02625 21.2562C6.55469 22.0447 4.77078 20.8056 5.08485 19.1292L5.89637 14.8021L5.89344 14.7562L5.8661 14.7142L2.63563 11.6849C1.39045 10.5171 2.08736 8.46241 3.7577 8.24446L8.17567 7.66926L8.20399 7.66145C8.23089 7.65072 8.2518 7.63083 8.26258 7.60871L10.1805 3.63703L10.2538 3.49934ZM11.9999 4.39973C11.9719 4.39977 11.9489 4.40788 11.9345 4.41633C11.9291 4.41954 11.9222 4.42409 11.9159 4.43098L11.8964 4.46125L9.97742 8.43391C9.69971 9.00837 9.1658 9.41216 8.54578 9.53254L8.42176 9.55305L4.00379 10.1282C3.96869 10.1329 3.95205 10.1432 3.94324 10.1507C3.93144 10.1609 3.91921 10.1786 3.91199 10.2005C3.90495 10.2222 3.90528 10.2411 3.90809 10.2532C3.91001 10.2614 3.91494 10.2769 3.93836 10.2991L7.16981 13.3294L7.26063 13.4193C7.66517 13.8498 7.85951 14.4374 7.78797 15.0247L7.76844 15.1517L6.95692 19.4779C6.95141 19.5073 6.95632 19.5223 6.95985 19.5306C6.96513 19.5427 6.97711 19.5594 6.99793 19.5745C7.01925 19.5898 7.04236 19.5983 7.06043 19.5999C7.07446 19.6011 7.0953 19.5997 7.12586 19.5833L11.0409 17.4837L11.1542 17.4271C11.7285 17.164 12.398 17.1831 12.9589 17.4837L16.8739 19.5833L16.913 19.598C16.9234 19.6001 16.9324 19.6005 16.9393 19.5999C16.9574 19.5983 16.9805 19.5898 17.0018 19.5745C17.0227 19.5594 17.0346 19.5427 17.0399 19.5306C17.0416 19.5266 17.0429 19.5208 17.0438 19.513L17.0429 19.4779L16.2313 15.1517C16.1059 14.4814 16.3329 13.7949 16.829 13.3294L20.0604 10.2991L20.0839 10.2708C20.0882 10.2633 20.0907 10.2573 20.0917 10.2532C20.0945 10.2411 20.0948 10.2222 20.0878 10.2005C20.0805 10.1786 20.0683 10.1609 20.0565 10.1507C20.0522 10.147 20.0453 10.1431 20.036 10.139L19.996 10.1282L15.578 9.55305C14.9053 9.46527 14.3174 9.0467 14.0214 8.43391L12.1034 4.46125C12.0901 4.43374 12.076 4.42275 12.0653 4.41633C12.0509 4.40791 12.0278 4.39975 11.9999 4.39973Z" }) });
});
StarIcon.displayName = "StarIcon";

const StarredIcon = forwardRef$1(function StarredIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M10.2531 3.49891C11.0466 2.12244 13.1094 2.1687 13.8186 3.6366L15.7365 7.60828L15.7707 7.64734C15.7855 7.65799 15.8037 7.66605 15.8244 7.66883L20.2424 8.24402L20.3957 8.26941C21.9042 8.57858 22.5304 10.4278 21.4758 11.5721L21.3645 11.6845L18.133 14.7138C18.107 14.7385 18.0982 14.772 18.1037 14.8016L18.9143 19.1288L18.9377 19.285C19.1114 20.8297 17.5072 21.9464 16.1115 21.3241L15.9729 21.2567L12.0578 19.1571C12.0311 19.1429 11.9989 19.1391 11.9699 19.1464L11.9426 19.1571L8.02659 21.2567C6.55506 22.045 4.77112 20.8051 5.08518 19.1288L5.8967 14.8016L5.89377 14.7557L5.86643 14.7138L2.63498 11.6845C1.3898 10.5166 2.08769 8.46198 3.75803 8.24402L8.17502 7.66883L8.20432 7.66102C8.23122 7.65029 8.25213 7.6304 8.26291 7.60828L10.1809 3.6366L10.2531 3.49891Z" }) });
});
StarredIcon.displayName = "StarredIcon";

const StopIcon = forwardRef$1(function StopIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M15.7633 5H8.23669C7.8267 4.99999 7.47298 4.99998 7.18164 5.02378C6.87416 5.0489 6.56832 5.10437 6.27402 5.25432C5.83498 5.47802 5.47802 5.83498 5.25432 6.27402C5.10437 6.56832 5.0489 6.87416 5.02378 7.18164C4.99998 7.47298 4.99999 7.82667 5 8.23666V15.7633C4.99999 16.1733 4.99998 16.5271 5.02378 16.8183C5.0489 17.1259 5.10437 17.4317 5.25432 17.726C5.47802 18.1651 5.83498 18.522 6.27402 18.7457C6.56832 18.8956 6.87416 18.9511 7.18164 18.9762C7.47298 19 7.82668 19 8.23668 19H15.7634C16.1733 19 16.5271 19 16.8183 18.9762C17.1259 18.9511 17.4317 18.8956 17.726 18.7457C18.1651 18.522 18.522 18.1651 18.7457 17.726C18.8956 17.4317 18.9511 17.1259 18.9762 16.8183C19 16.5271 19 16.1733 19 15.7634V8.23668C19 7.82668 19 7.47298 18.9762 7.18164C18.9511 6.87416 18.8956 6.56832 18.7457 6.27402C18.522 5.83498 18.1651 5.47802 17.726 5.25432C17.4317 5.10437 17.1259 5.0489 16.8183 5.02378C16.5271 4.99998 16.1733 4.99999 15.7633 5Z" }) });
});
StopIcon.displayName = "StopIcon";

const StrikethroughSIcon = forwardRef$1(function StrikethroughSIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17.6025 15.0068C18.1167 14.9476 18.5846 15.2893 18.6934 15.7842L18.71 15.8857L18.7363 16.1885C18.7421 16.2909 18.7451 16.3947 18.7451 16.5C18.7451 19.0018 16.4951 21.9999 11.9951 22C9.66191 22 8.04096 21.197 6.95215 20.165C6.02012 19.2817 5.52274 18.2747 5.26758 17.5811L5.17188 17.3037L5.14648 17.2051C5.04192 16.7091 5.32804 16.2043 5.82129 16.0469C6.3143 15.8898 6.83985 16.1351 7.04199 16.5996L7.07812 16.6963L7.14648 16.8955C7.33017 17.3933 7.68363 18.1039 8.32715 18.7139C9.03932 19.3888 10.1667 20 11.9951 20C15.4949 19.9999 16.7451 17.7957 16.7451 16.5C16.7451 16.4313 16.7429 16.3649 16.7393 16.3008L16.7236 16.1143L16.7168 16.0127C16.7098 15.5058 17.0881 15.0662 17.6025 15.0068ZM11.9951 2C14.3294 2.00005 15.8954 2.8053 16.9043 3.87402C17.8839 4.91191 18.2568 6.1107 18.3994 6.7959C18.5119 7.33661 18.1647 7.867 17.624 7.97949C17.0835 8.09192 16.5541 7.74454 16.4414 7.2041C16.3401 6.71691 16.0805 5.91584 15.4492 5.24707C14.8468 4.60896 13.8221 4.00005 11.9951 4C10.2252 4 9.11922 4.56847 8.45703 5.24023C7.77725 5.92993 7.49512 6.79777 7.49512 7.5C7.49512 8.07699 7.62542 8.49849 7.82227 8.82715C8.02276 9.16188 8.32509 9.45459 8.74316 9.7207C9.39874 10.138 10.2455 10.4359 11.2275 10.7188L12.249 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H7.10742C6.7226 10.6829 6.3777 10.3074 6.10645 9.85449C5.70502 9.18416 5.49512 8.40065 5.49512 7.5C5.49512 6.30344 5.9631 4.92151 7.0332 3.83594C8.12101 2.73254 9.7652 2 11.9951 2Z" }) });
});
StrikethroughSIcon.displayName = "StrikethroughSIcon";

const StylesIcon = forwardRef$1(function StylesIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", d: "M10 2C10.8265 2 11.5746 2.33441 12.1172 2.875C12.3945 2.76032 12.7201 2.77105 13 2.93262L16.9141 5.19238C17.6297 5.60556 18.1108 6.26925 18.3105 7.00879C18.6071 7.04866 18.8826 7.22077 19.0439 7.5L21.3047 11.415C22.133 12.85 21.641 14.6843 20.2061 15.5127L10.5 21.1162C10.4806 21.1274 10.4603 21.1367 10.4404 21.1465C9.58974 21.686 8.58188 22 7.5 22C4.46244 22 2 19.5376 2 16.5V5C2 3.34315 3.34315 2 5 2H10ZM5 4C4.44771 4 4 4.44771 4 5V16.5C4 18.433 5.567 20 7.5 20C9.433 20 11 18.433 11 16.5V5C11 4.4477 10.5523 4 10 4H5ZM7.5 15C8.32843 15 9 15.6716 9 16.5C9 17.3284 8.32843 18 7.5 18C6.67157 18 6 17.3284 6 16.5C6 15.6716 6.67157 15 7.5 15ZM13.5273 17.0586L19.2061 13.7812C19.6844 13.5051 19.8484 12.8934 19.5723 12.415L17.8906 9.50195L13.5273 17.0586ZM13 13.9717L16.2803 8.29102C16.5564 7.81276 16.3924 7.20096 15.9141 6.9248L13 5.24219V13.9717Z" }) });
});
StylesIcon.displayName = "StylesIcon";

const SubtractIcon = forwardRef$1(function SubtractIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H17Z" }) });
});
SubtractIcon.displayName = "SubtractIcon";

const SuccessIcon = forwardRef$1(function SuccessIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM14.2256 8.86719C14.5752 8.4399 15.2054 8.3763 15.6328 8.72559C16.0601 9.07518 16.1237 9.70538 15.7744 10.1328L11.2744 15.6328C11.0955 15.8515 10.832 15.9849 10.5498 15.999C10.3028 16.0113 10.0614 15.9314 9.87109 15.7773L9.79297 15.707L7.79297 13.707L7.72461 13.6309C7.40426 13.2381 7.42685 12.6591 7.79297 12.293C8.15908 11.9269 8.73809 11.9043 9.13086 12.2246L9.20703 12.293L10.4248 13.5107L14.2256 8.86719Z" }) });
});
SuccessIcon.displayName = "SuccessIcon";

const SunIcon = forwardRef$1(function SunIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M12 20C12.5523 20 13 20.4477 13 21V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V21C11 20.4477 11.4477 20 12 20Z" }), jsx("path", { d: "M4.93262 17.6533C5.32314 17.2628 5.95713 17.2628 6.34766 17.6533C6.73775 18.0439 6.73799 18.677 6.34766 19.0674L5.6377 19.7773C5.24717 20.1679 4.61318 20.1679 4.22266 19.7773C3.83234 19.3869 3.83255 18.7538 4.22266 18.3633L4.93262 17.6533Z" }), jsx("path", { d: "M17.6523 17.6533C18.0429 17.2628 18.6769 17.2628 19.0674 17.6533L19.7773 18.3633C20.1674 18.7538 20.1676 19.3869 19.7773 19.7773C19.3868 20.1679 18.7528 20.1679 18.3623 19.7773L17.6523 19.0674C17.262 18.677 17.2622 18.0439 17.6523 17.6533Z" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.75781 7.75781C10.101 5.41467 13.8991 5.41466 16.2422 7.75781C18.5854 10.101 18.5854 13.8991 16.2422 16.2422C13.8991 18.5854 10.101 18.5854 7.75781 16.2422C5.41466 13.8991 5.41467 10.101 7.75781 7.75781ZM14.8281 9.17188C13.2661 7.60979 10.734 7.60978 9.17188 9.17188C7.60978 10.734 7.60979 13.2661 9.17188 14.8281C10.734 16.3903 13.2661 16.3903 14.8281 14.8281C16.3903 13.2661 16.3903 10.734 14.8281 9.17188Z" }), jsx("path", { d: "M3 11C3.55228 11 4 11.4477 4 12C4 12.5523 3.55228 13 3 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H3Z" }), jsx("path", { d: "M22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H21C20.4477 13 20 12.5523 20 12C20 11.4477 20.4477 11 21 11H22Z" }), jsx("path", { d: "M4.22266 4.22266C4.61318 3.83213 5.24717 3.83213 5.6377 4.22266L6.34766 4.93262C6.738 5.323 6.73774 5.95613 6.34766 6.34668C5.95713 6.7372 5.32314 6.7372 4.93262 6.34668L4.22266 5.63672C3.83257 5.24618 3.83233 4.61305 4.22266 4.22266Z" }), jsx("path", { d: "M18.3623 4.22266C18.7528 3.83213 19.3868 3.83213 19.7773 4.22266C20.1676 4.61304 20.1674 5.24618 19.7773 5.63672L19.0674 6.34668C18.6769 6.7372 18.0429 6.7372 17.6523 6.34668C17.2622 5.95613 17.262 5.323 17.6523 4.93262L18.3623 4.22266Z" }), jsx("path", { d: "M12 1C12.5523 1 13 1.44772 13 2V3C13 3.55228 12.5523 4 12 4C11.4477 4 11 3.55228 11 3V2C11 1.44772 11.4477 1 12 1Z" })] });
});
SunIcon.displayName = "SunIcon";

const SunriseIcon = forwardRef$1(function SunriseIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M17 19C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20C6 19.4477 6.44772 19 7 19H17Z", fill: "currentColor" }), jsx("path", { d: "M21 15C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H3C2.44772 17 2 16.5523 2 16C2 15.4477 2.44772 15 3 15H21Z", fill: "currentColor" }), jsx("path", { d: "M4 11C4.55228 11 5 11.4477 5 12C5 12.5523 4.55228 13 4 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H4Z", fill: "currentColor" }), jsx("path", { d: "M12 7C14.7614 7 17 9.23857 17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 10.3432 13.6568 9 12 9C10.3431 9 9 10.3431 9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 9.23858 9.23858 7 12 7Z", fill: "currentColor" }), jsx("path", { d: "M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.4477 13 19 12.5523 19 12C19 11.4477 19.4477 11 20 11H21Z", fill: "currentColor" }), jsx("path", { d: "M4.92969 4.92871C5.32017 4.53838 5.95326 4.53839 6.34375 4.92871L7.05078 5.63574C7.44126 6.02622 7.44116 6.65927 7.05078 7.0498C6.66026 7.44033 6.02724 7.44033 5.63672 7.0498L4.92969 6.34277C4.53931 5.95224 4.53921 5.31919 4.92969 4.92871Z", fill: "currentColor" }), jsx("path", { d: "M17.6562 4.92871C18.0467 4.53834 18.6798 4.53843 19.0703 4.92871C19.4608 5.31921 19.4607 5.95226 19.0703 6.34277L18.3633 7.05078C17.9727 7.44105 17.3396 7.44028 16.9492 7.0498C16.5588 6.65925 16.5587 6.0262 16.9492 5.63574L17.6562 4.92871Z", fill: "currentColor" }), jsx("path", { d: "M12 2C12.5523 2 13 2.44772 13 3V4C13 4.55228 12.5523 5 12 5C11.4477 5 11 4.55228 11 4V3C11 2.44772 11.4477 2 12 2Z", fill: "currentColor" })] });
});
SunriseIcon.displayName = "SunriseIcon";

const SunsetIcon = forwardRef$1(function SunsetIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M17 19C17.5523 19 18 19.4477 18 20C18 20.5523 17.5523 21 17 21H7C6.44772 21 6 20.5523 6 20C6 19.4477 6.44772 19 7 19H17Z", fill: "currentColor" }), jsx("path", { d: "M22 15C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H2C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15H22Z", fill: "currentColor" }), jsx("path", { d: "M12 3C16.9706 3 21 7.02944 21 12C21 12.5523 20.5523 13 20 13C19.4477 13 19 12.5523 19 12C19 8.134 15.866 5 12 5C8.134 5 5 8.134 5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 7.02944 7.02944 3 12 3Z", fill: "currentColor" })] });
});
SunsetIcon.displayName = "SunsetIcon";

const SyncTemplateIcon = forwardRef$1(function SyncTemplateIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M13.4717 19.2956C14.0022 19.1428 14.5569 19.4496 14.7097 19.9805C14.8624 20.5114 14.5559 21.0655 14.0253 21.2183C13.5343 21.3597 13.0238 21.4547 12.4982 21.4968C11.9478 21.5408 11.4654 21.13 11.4212 20.5794C11.3772 20.0287 11.7879 19.546 12.3381 19.5017C12.729 19.4704 13.1079 19.4003 13.4717 19.2956Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M3.68624 14.65C5.31704 13.6901 7.39417 14.267 8.32412 15.9093C8.62442 16.4397 8.76921 17.0189 8.77265 17.592C8.77606 18.1607 8.96365 18.7625 9.48115 18.9976C9.98367 19.2261 10.2062 19.8195 9.97813 20.3224C9.74988 20.8253 9.15682 21.0488 8.65414 20.8207C8.46897 20.7365 8.28734 20.6452 8.10944 20.5471C7.79137 20.3718 7.4 20.4049 7.08703 20.5891C5.4563 21.549 3.38013 20.9719 2.45013 19.3298C1.52634 17.6983 2.0671 15.6035 3.68624 14.65ZM6.58418 16.8961C6.19597 16.2105 5.35305 15.9905 4.70072 16.3744C4.03712 16.765 3.79582 17.6466 4.19006 18.343C4.57833 19.0286 5.4212 19.2487 6.07353 18.8647C6.7369 18.474 6.97821 17.5923 6.58418 16.8961Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M18.9278 11.5607C19.478 11.5168 19.9596 11.9276 20.0038 12.4781C20.0477 13.0281 20.0436 13.5716 19.993 14.1019C19.9746 14.294 20.0465 14.5028 20.216 14.5949C20.2486 14.6127 20.281 14.631 20.3133 14.65C21.9328 15.6033 22.4742 17.6982 21.5504 19.3298C20.6203 20.972 18.5433 21.5492 16.9125 20.5891C15.2935 19.6356 14.7525 17.5408 15.6764 15.9093L15.7672 15.7588C16.23 15.0298 16.928 14.5342 17.7028 14.3151C17.8758 14.2661 17.9851 14.0904 18.0021 13.9113C18.0417 13.497 18.0455 13.0711 18.0109 12.6383C17.9669 12.0876 18.3775 11.6049 18.9278 11.5607ZM19.2998 16.3744C18.6473 15.9904 17.8045 16.2105 17.4163 16.8961C17.0222 17.5923 17.2634 18.474 17.927 18.8647C18.5792 19.2487 19.4221 19.0287 19.8104 18.343C20.1801 17.69 19.991 16.8738 19.4189 16.4525L19.2998 16.3744Z" }), jsx("path", { fill: "currentColor", d: "M4.56304 8.70785C4.80956 8.21358 5.41055 8.01286 5.90461 8.25941C6.39848 8.50607 6.59904 9.10651 6.35278 9.60083C6.10551 10.0969 5.91547 10.6312 5.79135 11.1924C5.67204 11.7317 5.13816 12.0726 4.59917 11.9534C4.06003 11.834 3.71924 11.299 3.83856 10.7595C3.99801 10.0388 4.24304 9.34996 4.56304 8.70785Z" }), jsx("path", { fill: "currentColor", d: "M16.8051 6.97856C17.2042 6.59694 17.8374 6.6106 18.2189 7.00983C18.6432 7.45418 19.0228 7.94804 19.3496 8.48119C19.6379 8.95211 19.49 9.56798 19.0195 9.8568C18.5489 10.1454 17.9324 9.99749 17.6438 9.52657C17.3909 9.11399 17.0984 8.7342 16.7729 8.39326C16.3914 7.99379 16.4059 7.36028 16.8051 6.97856Z" }), jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M12.0032 2.5C13.8913 2.50003 15.39 4.05634 15.3903 5.93513C15.39 7.81391 13.8913 9.37022 12.0032 9.37025C10.7396 9.37009 9.65016 8.67294 9.06778 7.64869C8.87815 7.31518 8.45043 7.14762 8.14837 7.38402C7.71344 7.72446 7.08454 7.64726 6.74431 7.21206C6.40429 6.77691 6.48138 6.14852 6.91616 5.80812C7.42534 5.4096 7.98277 5.07048 8.57993 4.80474C8.72788 4.73897 8.86352 4.63634 8.93103 4.4891C9.46673 3.32064 10.6323 2.50018 12.0032 2.5ZM12.0032 4.50187C11.255 4.50212 10.616 5.12582 10.6157 5.93513C10.616 6.74442 11.255 7.36911 12.0032 7.36936C12.7515 7.36933 13.3904 6.74456 13.3906 5.93513C13.3904 5.12568 12.7515 4.5019 12.0032 4.50187Z" })] });
});
SyncTemplateIcon.displayName = "SyncTemplateIcon";

const SyncIcon = forwardRef$1(function SyncIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M3.68636 14.1436C5.31746 13.184 7.39489 13.7607 8.32503 15.4023C8.95079 16.5068 8.9027 17.8225 8.30452 18.8535C9.3632 19.5813 10.6363 20.0039 12.0057 20.0039C12.4309 20.0039 12.8469 19.9634 13.2489 19.8857C13.7908 19.7814 14.3159 20.1358 14.4207 20.6777C14.5254 21.2198 14.1697 21.7447 13.6278 21.8496C13.102 21.9512 12.5592 22.0039 12.0057 22.0039C10.05 22.0039 8.24666 21.3417 6.80061 20.2305C5.22031 20.9687 3.32643 20.3679 2.45003 18.8213C1.52609 17.1906 2.06695 15.0966 3.68636 14.1436ZM17.118 7.3457C17.5115 7.00941 18.0913 7.03188 18.4578 7.38184L18.5282 7.45605L18.7694 7.75098C19.9446 9.25252 20.6463 11.1545 20.6463 13.2188C20.6463 13.5892 20.6211 13.9545 20.577 14.3135C21.992 15.3287 22.426 17.2813 21.5535 18.8213C20.6233 20.4627 18.5459 21.0397 16.9149 20.0801C15.2958 19.127 14.7547 17.033 15.6785 15.4023L15.7694 15.252C16.4113 14.2413 17.5052 13.6753 18.6297 13.6787C18.6396 13.5268 18.6463 13.3735 18.6463 13.2188C18.6463 11.6143 18.1028 10.143 17.1951 8.9834L17.0086 8.75586L16.9461 8.6748C16.6572 8.25833 16.7246 7.6823 17.118 7.3457ZM6.58479 16.3887C6.19648 15.7033 5.35347 15.4833 4.701 15.8672C4.03731 16.2577 3.79596 17.1389 4.19026 17.835C4.57857 18.5203 5.42158 18.7403 6.07405 18.3564C6.73768 17.966 6.979 17.0847 6.58479 16.3887ZM19.3026 15.8672C18.65 15.4835 17.807 15.7035 17.4188 16.3887C17.0247 17.0846 17.266 17.9659 17.9295 18.3564C18.5819 18.7402 19.4249 18.5203 19.8133 17.835C20.183 17.1822 19.9939 16.3664 19.4217 15.9453L19.3026 15.8672ZM5.69807 11.0928C5.52853 11.618 4.96462 11.9063 4.43929 11.7373C3.91372 11.5678 3.62437 11.0041 3.79378 10.4785L5.69807 11.0928ZM12.0057 1.99902C13.894 1.99922 15.3931 3.55477 15.3934 5.43262C15.3931 7.31046 13.894 8.86601 12.0057 8.86621C10.7377 8.86621 9.6463 8.16392 9.06526 7.13477C7.48723 7.93325 6.2586 9.35502 5.69807 11.0928L4.74593 10.7852L3.79378 10.4785C4.57091 8.06921 6.34554 6.1144 8.63069 5.12793C8.78237 3.38919 10.2202 1.99902 12.0057 1.99902ZM12.0057 4C11.2572 4 10.6182 4.62351 10.618 5.43262C10.6183 6.24171 11.2572 6.86621 12.0057 6.86621C12.7541 6.86601 13.3931 6.24158 13.3934 5.43262C13.3931 4.62364 12.7541 4.0002 12.0057 4Z" }) });
});
SyncIcon.displayName = "SyncIcon";

const TableIcon = forwardRef$1(function TableIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M15.2002 3C16.0237 3 16.7016 2.99898 17.252 3.04395C17.814 3.08988 18.3311 3.18827 18.8164 3.43555L19.0918 3.58985C19.7183 3.97414 20.2289 4.52513 20.5645 5.1836L20.6504 5.36719C20.8356 5.79892 20.9159 6.2562 20.9561 6.74805C21.001 7.29843 21 7.97632 21 8.79981V15.2002C21 16.0237 21.001 16.7016 20.9561 17.252C20.9159 17.7438 20.8356 18.2011 20.6504 18.6328L20.5645 18.8164C20.2289 19.4749 19.7183 20.0259 19.0918 20.4102L18.8164 20.5645C18.3311 20.8117 17.814 20.9101 17.252 20.9561C16.7016 21.001 16.0237 21 15.2002 21H8.79981C7.97632 21 7.29843 21.001 6.74805 20.9561C6.2562 20.9159 5.79892 20.8356 5.36719 20.6504L5.1836 20.5645C4.52513 20.2289 3.97414 19.7183 3.58985 19.0918L3.43555 18.8164C3.18827 18.3311 3.08988 17.814 3.04395 17.252C2.99898 16.7016 3 16.0237 3 15.2002V8.79981C3 7.97632 2.99898 7.29843 3.04395 6.74805C3.08988 6.18599 3.18827 5.6689 3.43555 5.1836C3.81902 4.43109 4.43109 3.81902 5.1836 3.43555C5.6689 3.18827 6.18599 3.08988 6.74805 3.04395C7.29843 2.99898 7.97632 3 8.79981 3H15.2002ZM9.1709 9V19H15.2002C16.0566 19 16.6388 18.9997 17.0889 18.9629C17.5273 18.9271 17.7518 18.8619 17.9082 18.7822L18.0459 18.7051C18.3592 18.5129 18.6145 18.2374 18.7822 17.9082L18.8389 17.7754C18.8924 17.6258 18.936 17.4175 18.9629 17.0889C18.9997 16.6388 19 16.0566 19 15.2002V9H9.1709ZM5 9V15.2002C5 16.0566 5.00035 16.6388 5.03711 17.0889C5.07293 17.5273 5.13809 17.7518 5.21778 17.9082L5.29492 18.0459C5.48707 18.3592 5.76256 18.6145 6.0918 18.7822L6.22461 18.8389C6.37418 18.8924 6.58253 18.936 6.91113 18.9629C6.99303 18.9696 7.0794 18.973 7.1709 18.9775V9H5ZM6.91113 5.03711C6.47272 5.07293 6.2482 5.13809 6.0918 5.21778C5.71555 5.40951 5.40951 5.71555 5.21778 6.0918C5.13809 6.2482 5.07293 6.47272 5.03711 6.91113C5.03474 6.94015 5.03431 6.96985 5.03223 7H7.1709V5.02149C7.07938 5.02598 6.99304 5.03042 6.91113 5.03711ZM9.1709 7H18.9678C18.9657 6.96985 18.9653 6.94015 18.9629 6.91113C18.936 6.58253 18.8924 6.37418 18.8389 6.22461L18.7822 6.0918C18.6145 5.76256 18.3592 5.48707 18.0459 5.29492L17.9082 5.21778C17.7518 5.13809 17.5273 5.07293 17.0889 5.03711C16.6388 5.00035 16.0566 5 15.2002 5H9.1709V7Z" }) });
});
TableIcon.displayName = "TableIcon";

const TagIcon = forwardRef$1(function TagIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.8789 3C11.8332 3.0001 12.749 3.37988 13.4238 4.05469L19.9463 10.5771L20.0732 10.7109C21.3494 12.1236 21.3075 14.3046 19.9463 15.666L15.666 19.9463C14.3046 21.3075 12.1236 21.3494 10.7109 20.0732L10.5771 19.9463L4.05469 13.4238C3.37988 12.749 3.0001 11.8332 3 10.8789V6.59863C3.00004 4.61118 4.61118 3.00004 6.59863 3H10.8789ZM6.59863 4.7998C5.60494 4.79984 4.79984 5.60494 4.7998 6.59863V10.8789C4.7999 11.3559 4.98894 11.814 5.32617 12.1514L11.8496 18.6738L11.9854 18.7969C12.692 19.3736 13.7346 19.3326 14.3936 18.6738L18.6738 14.3936C19.3326 13.7346 19.3736 12.692 18.7969 11.9854L18.6738 11.8496L12.1514 5.32617C11.814 4.98894 11.3559 4.7999 10.8789 4.7998H6.59863ZM7.94824 6.59863C8.69354 6.59865 9.29785 7.20294 9.29785 7.94824C9.29784 8.69354 8.69354 9.29784 7.94824 9.29785C7.20294 9.29785 6.59865 8.69354 6.59863 7.94824C6.59863 7.20293 7.20293 6.59863 7.94824 6.59863Z" }) });
});
TagIcon.displayName = "TagIcon";

const TelescopeIcon = forwardRef$1(function TelescopeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M17.628 4.112a1.9 1.9 0 0 1 2.346.943l.076.178 1.834 4.967a1.878 1.878 0 0 1-1.135 2.417l-4.618 1.657a3.256 3.256 0 0 1-2.396-.08l-.01.005-1.553.557v3.248h1.68a1 1 0 1 1 0 2h-5.36a1 1 0 0 1 0-2h1.68v-2.541a2.802 2.802 0 0 1-2.023-.2l-2.706.971a2.346 2.346 0 0 1-2.994-1.385l-.305-.827a2.317 2.317 0 0 1 1.401-2.981l2.698-.969a2.772 2.772 0 0 1 1.615-1.518l3.358-1.205.007-.003A3.214 3.214 0 0 1 13.01 5.77l4.618-1.657ZM4.22 12.924a.316.316 0 0 0-.2.405l.305.828c.06.161.254.263.443.195l1.988-.715-.53-1.434-2.006.72Zm4.313-2.487a.756.756 0 0 0-.468.971l.61 1.655a.795.795 0 0 0 1.017.458l2.422-.87a3.244 3.244 0 0 1-.123-.288l-.917-2.483a3.232 3.232 0 0 1-.1-.32l-2.44.877Zm5.153-2.786a1.195 1.195 0 0 0-.736 1.535l.917 2.484c.229.618.936.955 1.588.721l4.508-1.618-1.753-4.746-4.524 1.624Z" }) });
});
TelescopeIcon.displayName = "TelescopeIcon";

const TemplatesIcon = forwardRef$1(function TemplatesIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M18 2C19.6569 2 21 3.34315 21 5V19C21 20.6569 19.6569 22 18 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H18ZM7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44771 20 7 20H11V4H7ZM13 20H18C18.5523 20 19 19.5523 19 19V13H13V20ZM13 11H19V5C19 4.44772 18.5523 4 18 4H13V11Z" }) });
});
TemplatesIcon.displayName = "TemplatesIcon";

const TextAlignVerticalDownIcon = forwardRef$1(function TextAlignVerticalDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M15.543 12.2932C15.9335 11.9027 16.5665 11.9026 16.957 12.2932C17.3475 12.6837 17.3476 13.3167 16.957 13.7072L13.4141 17.2502C12.6331 18.0312 11.3669 18.0312 10.5859 17.2502L7.04297 13.7072C6.65245 13.3167 6.65245 12.6837 7.04297 12.2932C7.43349 11.9026 8.0665 11.9027 8.45703 12.2932L12 15.8361L15.543 12.2932Z" }), jsx("path", { fill: "currentColor", d: "M11 16.25V3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V16.25C13 16.8023 12.5523 17.25 12 17.25C11.4477 17.25 11 16.8023 11 16.25Z" }), jsx("path", { fill: "currentColor", d: "M19 20C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H19Z" })] });
});
TextAlignVerticalDownIcon.displayName = "TextAlignVerticalDownIcon";

const TextAlignVerticalUpIcon = forwardRef$1(function TextAlignVerticalUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M10.5859 6.75C11.367 5.96895 12.633 5.96894 13.4141 6.75L16.957 10.293C17.3475 10.6835 17.3475 11.3165 16.957 11.707C16.5665 12.0974 15.9335 12.0974 15.543 11.707L12 8.16406L8.45703 11.707C8.06653 12.0974 7.43347 12.0974 7.04297 11.707C6.65248 11.3165 6.65255 10.6835 7.04297 10.293L10.5859 6.75Z" }), jsx("path", { fill: "currentColor", d: "M11 21V7.75C11 7.19772 11.4477 6.75 12 6.75C12.5523 6.75 13 7.19772 13 7.75V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21Z" }), jsx("path", { fill: "currentColor", d: "M19 2C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H5C4.44772 4 4 3.55228 4 3C4 2.44772 4.44772 2 5 2H19Z" })] });
});
TextAlignVerticalUpIcon.displayName = "TextAlignVerticalUpIcon";

const TextAutoHeightIcon = forwardRef$1(function TextAutoHeightIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M18 21C17.4477 21 17 20.5523 17 20C17 19.4823 17.3933 19.0562 17.8975 19.0049L18.1025 18.9951C18.6067 18.9438 19 18.5177 19 18V6C19 5.48231 18.6067 5.05621 18.1025 5.00488L17.8975 4.99512C17.3933 4.94378 17 4.51768 17 4C17 3.44772 17.4477 3 18 3C19.6569 3 21 4.34315 21 6V18C21 19.6568 19.6569 21 18 21ZM5.89746 5.00488C5.39333 5.05621 5 5.48232 5 6L5 18C5 18.5177 5.39332 18.9438 5.89746 18.9951L6.10254 19.0049C6.60667 19.0562 7 19.4823 7 20C7 20.5523 6.55228 21 6 21C4.34316 21 3 19.6569 3 18L3 6C3 4.34314 4.34315 3 6 3C6.55228 3 7 3.44772 7 4C7 4.51768 6.60667 4.94379 6.10254 4.99512L5.89746 5.00488Z" }), jsx("path", { fill: "currentColor", d: "M15 7C15.5523 7 16 7.44771 16 8C16 8.55228 15.5523 9 15 9H9C8.44771 9 8 8.55228 8 8C8 7.44771 8.44771 7 9 7H15Z" }), jsx("path", { fill: "currentColor", d: "M13 11C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H9C8.44771 13 8 12.5523 8 12C8 11.4477 8.44771 11 9 11H13Z" }), jsx("path", { fill: "currentColor", d: "M11 15C11.5523 15 12 15.4477 12 16C12 16.5523 11.5523 17 11 17H9C8.44771 17 8 16.5523 8 16C8 15.4477 8.44771 15 9 15H11Z" })] });
});
TextAutoHeightIcon.displayName = "TextAutoHeightIcon";

const TextAutoWidthIcon = forwardRef$1(function TextAutoWidthIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M3 18V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V18C5 18.5523 5.44771 19 6 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H6C4.34315 21 3 19.6569 3 18ZM3 8V6C3 4.34315 4.34315 3 6 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6C5.44771 5 5 5.44771 5 6V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8ZM19 8V6C19 5.44771 18.5523 5 18 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3H18C19.6569 3 21 4.34315 21 6V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8Z" }), jsx("path", { fill: "currentColor", d: "M15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H9C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9H15Z" }), jsx("path", { fill: "currentColor", d: "M13 13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H9C8.44772 15 8 14.5523 8 14C8 13.4477 8.44772 13 9 13H13Z" }), jsx("path", { fill: "currentColor", d: "M19.2405 16.1852L18.5436 14.3733C18.4571 14.1484 18.241 14 18 14C17.759 14 17.5429 14.1484 17.4564 14.3733L16.7595 16.1852C16.658 16.4493 16.4493 16.658 16.1852 16.7595L14.3733 17.4564C14.1484 17.5429 14 17.759 14 18C14 18.241 14.1484 18.4571 14.3733 18.5436L16.1852 19.2405C16.4493 19.342 16.658 19.5507 16.7595 19.8148L17.4564 21.6267C17.5429 21.8516 17.759 22 18 22C18.241 22 18.4571 21.8516 18.5436 21.6267L19.2405 19.8148C19.342 19.5507 19.5507 19.342 19.8148 19.2405L21.6267 18.5436C21.8516 18.4571 22 18.241 22 18C22 17.759 21.8516 17.5429 21.6267 17.4564L19.8148 16.7595C19.5507 16.658 19.342 16.4493 19.2405 16.1852Z" })] });
});
TextAutoWidthIcon.displayName = "TextAutoWidthIcon";

const TextFixedWidthIcon = forwardRef$1(function TextFixedWidthIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M6 5C5.44771 5 5 5.44771 5 6L5 18C5 18.5523 5.4477 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.4477 18.5523 5 18 5L6 5ZM18 3C19.6569 3 21 4.34315 21 6V18C21 19.6568 19.6569 21 18 21H6C4.34316 21 3 19.6569 3 18L3 6C3 4.34314 4.34315 3 6 3L18 3Z" }), jsx("path", { fill: "currentColor", d: "M15 9C15.5523 9 16 9.44771 16 10C16 10.5523 15.5523 11 15 11H9C8.44771 11 8 10.5523 8 10C8 9.44771 8.44771 9 9 9H15Z" }), jsx("path", { fill: "currentColor", d: "M13 13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H9C8.44771 15 8 14.5523 8 14C8 13.4477 8.44771 13 9 13H13Z" })] });
});
TextFixedWidthIcon.displayName = "TextFixedWidthIcon";

const TextStringIcon = forwardRef$1(function TextStringIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.1055 4.00488C19.6096 4.05613 20.0028 4.48238 20.0029 5V6.75C20.0029 7.30228 19.5552 7.75 19.0029 7.75C18.4508 7.74978 18.0029 7.30215 18.0029 6.75V6H13.002V18.0029H13.752L13.8545 18.0078C14.3585 18.0591 14.7517 18.4854 14.752 19.0029C14.752 19.5206 14.3586 19.9467 13.8545 19.998L13.752 20.0029H10.251C9.69889 20.0027 9.25098 19.5551 9.25098 19.0029C9.2512 18.451 9.69903 18.0032 10.251 18.0029H11.002V6H6V6.75C6 7.30228 5.55228 7.75 5 7.75C4.44783 7.74987 4 7.3022 4 6.75V5L4.00488 4.89746C4.05631 4.39352 4.48251 4.00013 5 4H19.0029L19.1055 4.00488Z" }) });
});
TextStringIcon.displayName = "TextStringIcon";

const ThumbDownFilledIcon = forwardRef$1(function ThumbDownFilledIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M7.0424 2.64739C9.76828 2.41118 11.5156 2.60791 14.1664 3.57317C15.338 4 16.0012 5.12819 16.0014 6.27434V12.7304C16.0012 15.4451 13.0015 17.5004 11.9242 21.3857C11.7511 21.7998 11.3195 22.0578 10.8832 21.9521C7.3867 21.1039 8.53212 17.8155 9.00138 14.9999H6.00138C3.43823 14.9998 1.53647 12.6227 2.09904 10.122L2.94376 6.36711C3.37942 4.43132 4.95165 2.82858 7.0424 2.64739Z", fill: "currentColor" }), jsx("path", { d: "M20.0014 3.49992C21.1059 3.49992 22.0013 4.39539 22.0014 5.49992V12.4999C22.0014 13.6045 21.1059 14.4999 20.0014 14.4999H19.0014C17.8969 14.4998 17.0014 13.6044 17.0014 12.4999V5.49992C17.0014 4.39549 17.897 3.50009 19.0014 3.49992H20.0014Z", fill: "currentColor" })] });
});
ThumbDownFilledIcon.displayName = "ThumbDownFilledIcon";

const ThumbDownIcon = forwardRef$1(function ThumbDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M11.128 20.786c-.74.305-1.645.32-2.442-.21-.618-.412-1.116-.936-1.314-1.688-.183-.702-.056-1.44.158-2.172l.47-1.61H6.665c-2.41 0-4.073-2.32-3.58-4.635l.751-3.517c.386-1.809 1.796-3.367 3.74-3.544 2.44-.223 4.908-.039 7.29.876.19.073.364.167.523.276a2.7 2.7 0 0 1 1.943-.823h.89C19.806 3.739 21 5.076 21 6.613v5.62c0 1.536-1.195 2.873-2.777 2.874h-.89c-.456 0-.879-.115-1.252-.31a4.15 4.15 0 0 1-.577.824c-1.172 1.304-1.917 2.029-2.685 3.568a3.358 3.358 0 0 1-1.69 1.597ZM9.795 18.91c.15.1.334.123.57.026.255-.105.512-.337.664-.64.914-1.833 1.87-2.77 2.989-4.013a2.06 2.06 0 0 0 .537-1.367V6.87c0-.392-.21-.642-.405-.717-2.026-.778-4.171-.955-6.392-.752-.903.083-1.724.841-1.965 1.97l-.75 3.517c-.256 1.2.616 2.219 1.623 2.219h2.666a1.002 1.002 0 0 1 .96 1.28l-.843 2.89c-.187.638-.184.942-.142 1.104.03.112.107.277.488.53Zm8.428-5.804c.38 0 .777-.342.777-.874v-5.62c0-.532-.396-.874-.777-.874h-.89c-.38 0-.777.341-.777.874v5.62c0 .532.397.874.777.874h.89Z" }) });
});
ThumbDownIcon.displayName = "ThumbDownIcon";

const ThumbUpFilledIcon = forwardRef$1(function ThumbUpFilledIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M12.0771 2.59082C12.2502 2.17649 12.6818 1.91765 13.1182 2.02344C16.6149 2.87135 15.4693 6.15998 15 8.97559H18C20.5631 8.97559 22.4647 11.3529 21.9023 13.8535L21.0576 17.6084C20.6221 19.5441 19.0506 21.1467 16.96 21.3281C14.2341 21.5644 12.4866 21.3685 9.83594 20.4033C8.66398 19.9765 8.00003 18.8476 8 17.7012V11.2461C8 8.53128 10.9998 6.47602 12.0771 2.59082Z", fill: "currentColor" }), jsx("path", { d: "M5 9.47559C6.10446 9.47559 6.99983 10.3711 7 11.4756V18.4756C7 19.5802 6.10457 20.4756 5 20.4756H4C2.89543 20.4756 2 19.5802 2 18.4756V11.4756C2.00017 10.3711 2.89554 9.47559 4 9.47559H5Z", fill: "currentColor" })] });
});
ThumbUpFilledIcon.displayName = "ThumbUpFilledIcon";

const ThumbUpIcon = forwardRef$1(function ThumbUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props, children: jsx("path", { d: "M12.871 3.537c.742-.306 1.646-.321 2.443.21.617.411 1.116.935 1.313 1.687.184.702.057 1.44-.157 2.172L16 9.216h1.333c2.41 0 4.074 2.321 3.58 4.635l-.75 3.518c-.387 1.808-1.796 3.366-3.74 3.544-2.44.223-4.908.038-7.29-.876a2.508 2.508 0 0 1-.523-.276 2.7 2.7 0 0 1-1.944.823h-.89C4.195 20.584 3 19.247 3 17.71v-5.62c0-1.537 1.195-2.874 2.778-2.874h.89c.456 0 .879.114 1.251.31a4.15 4.15 0 0 1 .578-.825c1.172-1.303 1.917-2.028 2.685-3.567a3.358 3.358 0 0 1 1.69-1.597Zm1.333 1.874c-.15-.1-.334-.123-.57-.025a1.36 1.36 0 0 0-.663.64c-.914 1.832-1.87 2.77-2.99 4.013-.34.38-.536.868-.536 1.366v6.048c0 .391.21.642.405.717 2.026.777 4.17.954 6.392.752.902-.083 1.723-.842 1.964-1.971l.752-3.517c.255-1.199-.617-2.218-1.625-2.218h-2.666a1.002 1.002 0 0 1-.96-1.28l.844-2.89c.187-.639.184-.943.142-1.105-.03-.111-.107-.276-.489-.53Zm-8.427 5.805c-.38 0-.777.342-.778.874v5.62c0 .532.397.873.778.874h.89c.38 0 .777-.342.777-.874v-5.62c0-.533-.397-.874-.778-.874h-.89Z" }) });
});
ThumbUpIcon.displayName = "ThumbUpIcon";

const TimeIcon = forwardRef$1(function TimeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12 7C12.5523 7 13 7.44772 13 8V11.5859L15.207 13.793L15.2754 13.8691C15.5957 14.2619 15.5731 14.8409 15.207 15.207C14.8409 15.5731 14.2619 15.5957 13.8691 15.2754L13.793 15.207L11.293 12.707C11.1054 12.5195 11 12.2652 11 12V8C11 7.44772 11.4477 7 12 7Z" }) });
});
TimeIcon.displayName = "TimeIcon";

const TraitTemplateIcon = forwardRef$1(function TraitTemplateIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.006 18.9795C12.402 18.9626 12.7869 19.184 12.9601 19.5674C13.1872 20.0706 12.9632 20.6623 12.4601 20.8896L12.4113 20.9121L12.4025 20.915C12.3801 20.9249 12.3571 20.9332 12.3341 20.9414L12.3165 20.9492C12.2409 20.9745 12.1638 20.9894 12.087 20.9961C12.074 20.9972 12.0611 20.9994 12.048 21H11.9513C11.9379 20.9993 11.9246 20.9973 11.9113 20.9961C11.8835 20.9936 11.856 20.9892 11.8282 20.9844C11.7484 20.9704 11.6707 20.9476 11.5968 20.915L11.589 20.9121L11.5402 20.8906L11.4484 20.8437C11.01 20.5895 10.8271 20.0392 11.0402 19.5674C11.2 19.2136 11.5398 18.9975 11.9025 18.9795H12.006ZM7.04016 17.7607C7.2533 17.2889 7.78706 17.0627 8.2677 17.2236L8.3634 17.2607L8.46008 17.3047L8.55188 17.3516C8.99017 17.6058 9.17314 18.1561 8.96008 18.6279C8.74696 19.0997 8.21315 19.3259 7.73254 19.165L7.63684 19.1279L7.54016 19.084L7.44836 19.0371C7.00997 18.7828 6.82706 18.2326 7.04016 17.7607ZM15.7325 17.2236C16.2131 17.0628 16.7469 17.289 16.9601 17.7607C17.1873 18.264 16.9632 18.8566 16.4601 19.084L16.3634 19.1279L16.2677 19.165C15.7871 19.3259 15.2533 19.0997 15.0402 18.6279C14.8129 18.1246 15.0369 17.532 15.5402 17.3047L15.6368 17.2607L15.7325 17.2236ZM3.08899 15.9766C3.30211 15.5047 3.83592 15.2776 4.31653 15.4385L4.41125 15.4766L4.46008 15.498L4.55188 15.5449C4.99017 15.7992 5.17314 16.3495 4.96008 16.8213C4.74697 17.2931 4.21315 17.5192 3.73254 17.3584L3.63684 17.3213L3.58899 17.2988L3.49719 17.2519C3.05905 16.9977 2.87615 16.4482 3.08899 15.9766ZM19.589 15.4766C20.0922 15.2496 20.684 15.4735 20.9113 15.9766C21.1383 16.4798 20.9143 17.0715 20.4113 17.2988L20.3634 17.3213L20.2677 17.3584C19.7871 17.5193 19.2533 17.2932 19.0402 16.8213C18.8129 16.318 19.0369 15.7253 19.5402 15.498L19.589 15.4766ZM12.006 14.8506C12.402 14.8337 12.7869 15.0551 12.9601 15.4385C13.1872 15.9417 12.9632 16.5334 12.4601 16.7607L12.4113 16.7832L12.4025 16.7861C12.3234 16.8209 12.2401 16.8449 12.1544 16.8584C11.9626 16.8885 11.7695 16.8622 11.5968 16.7861L11.589 16.7832L11.5402 16.7617L11.4484 16.7148C11.01 16.4606 10.8271 15.9103 11.0402 15.4385C11.1999 15.0847 11.5398 14.8686 11.9025 14.8506H12.006ZM7.04016 13.6318C7.25329 13.1599 7.78705 12.9338 8.2677 13.0947L8.3634 13.1318L8.46008 13.1758L8.55188 13.2226C8.99014 13.477 9.17316 14.0273 8.96008 14.499C8.74695 14.9708 8.21311 15.1969 7.73254 15.0361L7.63684 14.999L7.54016 14.9551L7.44836 14.9082C7.00999 14.6539 6.8271 14.1036 7.04016 13.6318ZM15.7325 13.0947C16.2132 12.9339 16.747 13.16 16.9601 13.6318C17.1873 14.1351 16.9633 14.7277 16.4601 14.9551L16.3634 14.999L16.2677 15.0361C15.7871 15.197 15.2533 14.9708 15.0402 14.499C14.8129 13.9957 15.0368 13.4031 15.5402 13.1758L15.6368 13.1318L15.7325 13.0947ZM3.08899 11.8476C3.3021 11.3758 3.83591 11.1487 4.31653 11.3096L4.41125 11.3476L4.46008 11.3691L4.55188 11.416C4.99014 11.6703 5.17316 12.2206 4.96008 12.6924C4.74695 13.1641 4.21312 13.3903 3.73254 13.2295L3.63684 13.1924L3.58899 13.1699L3.49719 13.123C3.05907 12.8688 2.87619 12.3193 3.08899 11.8476ZM19.589 11.3476C20.0922 11.1207 20.684 11.3445 20.9113 11.8476C21.1383 12.3509 20.9144 12.9426 20.4113 13.1699L20.3634 13.1924L20.2677 13.2295C19.7871 13.3904 19.2533 13.1642 19.0402 12.6924C18.8129 12.189 19.0368 11.5964 19.5402 11.3691L19.589 11.3476ZM11.6886 3.0498C11.9232 2.97337 12.1799 2.98616 12.4073 3.08788L20.4054 6.66698C20.7652 6.82805 20.9962 7.1859 20.9962 7.58007C20.9961 7.9741 20.765 8.33212 20.4054 8.49316L12.4064 12.0723C12.1791 12.1737 11.9229 12.1867 11.6886 12.1103L11.59 12.0723L3.59192 8.49316C3.2323 8.33211 3.00027 7.97409 3.00012 7.58007C3.00015 7.18603 3.23237 6.82813 3.59192 6.66698L11.59 3.08788L11.6886 3.0498ZM6.44836 7.58007L11.9982 10.0635L17.547 7.58007L11.9982 5.09667L6.44836 7.58007Z" }) });
});
TraitTemplateIcon.displayName = "TraitTemplateIcon";

const TraitIcon = forwardRef$1(function TraitIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M19.6953 15.7618C20.1783 15.6082 20.7091 15.8424 20.915 16.3175C21.1341 16.8239 20.9017 17.4132 20.3955 17.6329L13.1924 20.755C12.4313 21.0849 11.5668 21.0848 10.8057 20.755L3.60351 17.6329L3.51171 17.587C3.06947 17.3396 2.87742 16.7925 3.083 16.3175C3.28894 15.8424 3.81972 15.6083 4.30273 15.7618L4.39843 15.797L11.6016 18.92C11.855 19.0297 12.143 19.0298 12.3965 18.92L19.5996 15.797L19.6953 15.7618ZM19.5996 11.1729C20.1062 10.9537 20.6954 11.1869 20.915 11.6935C21.1344 12.1999 20.9018 12.7891 20.3955 13.0089L13.1924 16.131C12.4789 16.4403 11.675 16.4591 10.9502 16.1886L10.8057 16.131L3.60351 13.0089L3.51171 12.963C3.06943 12.7156 2.87733 12.1685 3.083 11.6935C3.28902 11.2186 3.8198 10.9843 4.30273 11.1378L4.39843 11.1729L11.6016 14.296C11.8551 14.4058 12.143 14.4058 12.3965 14.296L19.5996 11.1729ZM11.6982 3.04697C11.9267 2.97488 12.1755 2.98591 12.3975 3.08212L20.3955 6.5499L20.5264 6.61826C20.8162 6.79884 20.9969 7.11858 20.9971 7.46689C20.9971 7.86516 20.7608 8.2262 20.3955 8.38486L12.3965 11.8526C12.143 11.9623 11.855 11.9623 11.6016 11.8526L3.60351 8.38486C3.23787 8.22635 3.00097 7.86541 3.00097 7.46689C3.0012 7.0686 3.23804 6.70833 3.60351 6.5499L11.6016 3.08212L11.6982 3.04697ZM6.51464 7.46689L11.999 9.84482L17.4824 7.46689L11.999 5.08994L6.51464 7.46689Z" }) });
});
TraitIcon.displayName = "TraitIcon";

const TrendDownIcon = forwardRef$1(function TrendDownIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M2.29297 6.29297C2.68349 5.90245 3.31651 5.90244 3.70703 6.29297L8.29297 10.8789C8.68347 11.2691 9.31658 11.2692 9.70703 10.8789L10.8789 9.70703C12.0504 8.53566 13.9496 8.53566 15.1211 9.70703L20 14.5859V12C20 11.4477 20.4477 11 21 11C21.5522 11 22 11.4477 22 12V17C22 17.5522 21.5522 18 21 18H16C15.4477 18 15 17.5522 15 17C15 16.4477 15.4477 16 16 16H18.5859L13.707 11.1211C13.3166 10.7308 12.6834 10.7308 12.293 11.1211L11.1211 12.293C9.94959 13.4643 8.05045 13.4642 6.87891 12.293L2.29297 7.70703C1.90245 7.31651 1.90244 6.68349 2.29297 6.29297Z", fill: "currentColor" }) });
});
TrendDownIcon.displayName = "TrendDownIcon";

const TrendUpIcon = forwardRef$1(function TrendUpIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M21.0001 6C21.5523 6.00004 22.0001 6.44774 22.0001 7V12C22.0001 12.5523 21.5523 13 21.0001 13C20.4478 13 20.0001 12.5523 20.0001 12V9.41406L15.1212 14.293C13.9497 15.4643 12.0505 15.4643 10.879 14.293L9.70711 13.1211C9.31664 12.7308 8.68354 12.7308 8.29304 13.1211L3.70711 17.707C3.3166 18.0975 2.68357 18.0975 2.29304 17.707C1.90252 17.3165 1.90252 16.6835 2.29304 16.293L6.87898 11.707C8.05052 10.5357 9.94965 10.5357 11.1212 11.707L12.293 12.8789C12.6835 13.2692 13.3167 13.2692 13.7071 12.8789L18.586 8H16.0001C15.4478 8 15.0001 7.55228 15.0001 7C15.0001 6.44772 15.4478 6 16.0001 6H21.0001Z", fill: "currentColor" }) });
});
TrendUpIcon.displayName = "TrendUpIcon";

const TrendsIcon = forwardRef$1(function TrendsIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M20 7.99992C21.1045 7.99994 22 8.8954 22 9.99992C22 11.1045 21.1046 11.9999 20 11.9999C19.8843 11.9999 19.7714 11.9875 19.6611 11.9687L16.875 15.3114C16.954 15.5264 17 15.7576 17 15.9999C17 17.1045 16.1046 17.9999 15 17.9999C13.8954 17.9999 13 17.1045 13 15.9999C13 15.8843 13.0114 15.7713 13.0303 15.6611L9.6875 12.8749C9.47278 12.9537 9.24202 12.9999 9 12.9999C8.93443 12.9999 8.86962 12.9963 8.80566 12.9902L5.81836 17.1718C5.93359 17.4244 5.99999 17.7042 6 17.9999C6 19.1045 5.10456 19.9999 4 19.9999C2.89543 19.9999 2 19.1045 2 17.9999C2.00004 16.8954 2.89546 15.9999 4 15.9999C4.06491 15.9999 4.12905 16.0036 4.19238 16.0097L7.18066 11.8261C7.06602 11.574 7 11.2949 7 10.9999C7.00004 9.89539 7.89546 8.99992 9 8.99992C10.1045 8.99994 11 9.8954 11 10.9999C11 11.1152 10.9875 11.2279 10.9688 11.3378L14.3105 14.1239C14.5256 14.0449 14.7575 13.9999 15 13.9999C15.1149 13.9999 15.2273 14.0116 15.3369 14.0302L18.123 10.6874C18.0445 10.4729 18 10.2417 18 9.99992C18 8.89539 18.8955 7.99992 20 7.99992Z" }), jsx("path", { fill: "currentColor", d: "M4.5 6.99992C5.32839 6.99994 5.99996 7.67154 6 8.49992C6 9.32834 5.32841 9.9999 4.5 9.99992C3.67157 9.99992 3 9.32835 3 8.49992C3.00004 7.67153 3.6716 6.99992 4.5 6.99992Z" }), jsx("path", { fill: "currentColor", d: "M14.291 4.12101C14.3461 3.95954 14.6538 3.95955 14.709 4.12101C14.867 4.58666 15.1184 5.16325 15.4775 5.52238C15.8367 5.8815 16.4132 6.13291 16.8789 6.29093C17.0404 6.34596 17.0404 6.65383 16.8789 6.7089C16.4132 6.86693 15.8367 7.11837 15.4775 7.47746C15.1184 7.83659 14.867 8.41317 14.709 8.87883C14.6539 9.04043 14.346 9.04044 14.291 8.87883C14.133 8.41317 13.8816 7.83659 13.5225 7.47746C13.1633 7.11835 12.5867 6.86694 12.1211 6.7089C11.9595 6.65381 11.9595 6.34598 12.1211 6.29093C12.5867 6.13291 13.1633 5.8815 13.5225 5.52238C13.8815 5.16324 14.133 4.58664 14.291 4.12101Z" })] });
});
TrendsIcon.displayName = "TrendsIcon";

const UnderConstructionIcon = forwardRef$1(function UnderConstructionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6944 3.01074C16.9615 3.11876 18.0357 4.02062 18.3486 5.27246L21.9697 19.7578C22.1034 20.2934 21.7776 20.8356 21.2422 20.9697C20.7065 21.1035 20.1643 20.7778 20.0303 20.2422L19.4697 18H14.5303L13.9697 20.2422C13.8358 20.7778 13.2934 21.1032 12.7578 20.9697C12.2221 20.8358 11.8965 20.2935 12.0303 19.7578L12.4697 18H4.53029L3.96974 20.2422C3.83585 20.7778 3.29341 21.1032 2.75783 20.9697C2.22211 20.8358 1.89649 20.2935 2.03029 19.7578L5.65138 5.27246C5.98529 3.93703 7.18499 3.00001 8.56154 3H15.4385L15.6944 3.01074ZM8.39259 5.01465C8.00722 5.08056 7.68921 5.36841 7.59181 5.75781L5.03029 16H12.9697L15.4082 6.24219C15.5558 5.65089 15.1461 5.07671 14.5586 5.00684L14.4385 5H8.56154L8.39259 5.01465ZM15.0303 16H18.9697L16.999 8.12305L15.0303 16Z" }) });
});
UnderConstructionIcon.displayName = "UnderConstructionIcon";

const UnderlineIcon = forwardRef$1(function UnderlineIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ref: ref, ...props, children: [jsx("path", { fill: "currentColor", d: "M18 20C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20H18Z" }), jsx("path", { fill: "currentColor", d: "M18 3C18.5523 3 19 3.44772 19 4V12C19 15.866 15.866 18 12 18C8.134 18 5 15.866 5 12V4C5 3.44772 5.44772 3 6 3C6.55228 3 7 3.44772 7 4V12C7 14.7614 9.23858 16 12 16C14.7614 16 17 14.7614 17 12V4C17 3.44772 17.4477 3 18 3Z" })] });
});
UnderlineIcon.displayName = "UnderlineIcon";

const UndoIcon = forwardRef$1(function UndoIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M7.2749 4.29116C6.90794 3.92596 6.32804 3.90449 5.93604 4.22573L5.86084 4.29506L2.5835 7.58706C1.80679 8.36772 1.80657 9.63172 2.5835 10.4123L5.86084 13.7052C6.25039 14.096 6.88363 14.0973 7.2749 13.7081C7.66613 13.3186 7.66721 12.6855 7.27783 12.2941L4.99365 9.99917H17.019L17.1724 10.0031C18.7436 10.0832 20.0003 11.3904 20.0005 12.9992V13.9982C20.0003 15.659 18.661 16.9982 17.019 16.9982H12.0425C11.4908 16.9988 11.0427 17.4464 11.0425 17.9982C11.0427 18.55 11.4908 18.9976 12.0425 18.9982H17.019C19.7742 18.9982 22.0003 16.7548 22.0005 13.9982V12.9992C22.0003 10.3287 19.9113 8.14015 17.2759 8.006L17.019 7.99916H4.99463L7.27783 5.70522C7.66719 5.31384 7.66607 4.68073 7.2749 4.29116Z" }) });
});
UndoIcon.displayName = "UndoIcon";

const UnionIcon = forwardRef$1(function UnionIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M19 2C20.6569 2 22 3.34315 22 5V13C22 14.6569 20.6569 16 19 16H16V19C16 20.6569 14.6569 22 13 22H5C3.34315 22 2 20.6569 2 19V11C2 9.34315 3.34315 8 5 8H8V5C8 3.34315 9.34315 2 11 2H19ZM5 10C4.44772 10 4 10.4477 4 11V19C4 19.5523 4.44772 20 5 20H13C13.5523 20 14 19.5523 14 19V11C14 10.4477 13.5523 10 13 10H5ZM11 4C10.4477 4 10 4.44772 10 5V8H13C14.6569 8 16 9.34315 16 11V14H19C19.5523 14 20 13.5523 20 13V5C20 4.44772 19.5523 4 19 4H11Z" }), jsx("path", { opacity: 0.4, d: "M10 13C10 13.5523 10.4477 14 11 14H16V16H11C9.34315 16 8 14.6569 8 13V8H10V13Z" })] });
});
UnionIcon.displayName = "UnionIcon";

const UnlinkIcon = forwardRef$1(function UnlinkIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.1611 17.4335C16.6631 17.3083 17.1717 17.586 17.3437 18.0624L17.373 18.1611L17.7734 19.7617L17.7929 19.8613C17.8657 20.3629 17.5481 20.8478 17.0458 20.9736C16.5434 21.0992 16.0351 20.8207 15.8632 20.3437L15.8329 20.246L15.4335 18.6454L15.413 18.5449C15.3407 18.0434 15.6589 17.5591 16.1611 17.4335ZM6.08879 9.69916C6.47674 9.30609 7.10978 9.30144 7.50285 9.68939C7.89591 10.0773 7.89958 10.7104 7.51164 11.1035L6.91887 11.705L6.91399 11.7099C5.42889 13.1955 5.42859 15.6043 6.91399 17.0898L7.05559 17.2245C8.54867 18.5737 10.8547 18.5286 12.2939 17.0898L12.2978 17.0849L12.8993 16.4911C13.2924 16.1034 13.9255 16.1079 14.3134 16.5009C14.7013 16.8939 14.6975 17.527 14.3046 17.915L13.703 18.5087C11.5069 20.6995 7.99229 20.767 5.71574 18.7099L5.49992 18.5038C3.23514 16.239 3.23378 12.5678 5.49504 10.3007V10.2997L6.08879 9.69916ZM18.5458 15.412L18.6454 15.4326L20.246 15.832L20.3437 15.8622C20.8206 16.0341 21.099 16.5425 20.9736 17.0449C20.8479 17.5473 20.363 17.8647 19.8613 17.7919L19.7607 17.7724L18.1611 17.372L18.0624 17.3427C17.586 17.1706 17.3081 16.6622 17.4335 16.1601C17.5592 15.6578 18.0442 15.3393 18.5458 15.412ZM10.3007 5.49506C12.5677 3.23336 16.2389 3.23494 18.5038 5.49994L18.7089 5.71674C20.7672 7.99508 20.6993 11.5121 18.5038 13.7079L18.5029 13.707L17.915 14.3046L17.8388 14.374C17.4483 14.6963 16.8693 14.6775 16.5009 14.3144C16.1079 13.9265 16.1034 13.2925 16.4911 12.8994L17.0849 12.2988L17.0888 12.2939L17.2245 12.1523C18.5301 10.7072 18.5301 8.50076 17.2245 7.0556L17.0888 6.914C15.6033 5.42861 13.1953 5.42854 11.7099 6.914L11.705 6.91888L11.1034 7.51166L11.0273 7.58002C10.6324 7.89757 10.053 7.87127 9.68938 7.50287C9.30155 7.10988 9.30635 6.47678 9.69914 6.08881L10.2997 5.49506H10.3007ZM3.0302 6.95795C3.15584 6.45554 3.64075 6.13704 4.1425 6.2099L4.24211 6.23041L5.8427 6.62982L5.94035 6.66009C6.4173 6.83196 6.69579 7.34032 6.57024 7.84271C6.44463 8.34512 5.95966 8.66258 5.45793 8.58978L5.35735 8.57025L3.75774 8.16986L3.6591 8.14056C3.18257 7.96851 2.90479 7.46008 3.0302 6.95795ZM6.95891 3.02924C7.46086 2.9041 7.96948 3.18182 8.14152 3.65814L8.17082 3.75677L8.57121 5.35736L8.59074 5.45697C8.66357 5.95859 8.34586 6.44349 7.84367 6.56927C7.34124 6.69488 6.8329 6.4164 6.66106 5.93939L6.63078 5.84174L6.23137 4.24115L6.21086 4.14056C6.13866 3.6392 6.45684 3.15475 6.95891 3.02924Z" }) });
});
UnlinkIcon.displayName = "UnlinkIcon";

const UnlockedIcon = forwardRef$1(function UnlockedIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M12 13C12.5523 13 13 13.4477 13 14V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V14C11 13.4477 11.4477 13 12 13Z", fill: "currentColor" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C14.3311 2 16.2877 3.59469 16.8428 5.75098C16.9802 6.28572 16.6578 6.8311 16.123 6.96875C15.5883 7.10623 15.0429 6.78377 14.9053 6.24902C14.572 4.95501 13.3963 4 12 4C10.3431 4 9 5.34314 9 7V9H17C18.6569 9 20 10.3431 20 12V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V12C4 10.3431 5.34315 9 7 9V7C7 4.23858 9.23858 2 12 2ZM7 11C6.4477 11 6 11.4477 6 12V19C6 19.5523 6.4477 20 7 20H17C17.5523 20 18 19.5523 18 19V12C18 11.4477 17.5523 11 17 11H7Z", fill: "currentColor" })] });
});
UnlockedIcon.displayName = "UnlockedIcon";

const UnpinIcon = forwardRef$1(function UnpinIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.29279 3.40232C3.68332 3.0118 4.31633 3.0118 4.70685 3.40232L20.6004 19.2959L20.6688 19.372C20.989 19.7648 20.9664 20.3439 20.6004 20.7099C20.2341 21.076 19.6542 21.099 19.2615 20.7783L19.1863 20.7099L15.7069 17.2304L15.4617 18.167C14.9182 20.2309 12.3404 20.9282 10.8309 19.4189L8.41388 17.0019L5.58967 19.8261C5.19913 20.2165 4.56606 20.2166 4.1756 19.8261C3.78552 19.4357 3.78542 18.8025 4.1756 18.4121L6.99982 15.5869L4.58381 13.1709C3.07475 11.6614 3.77173 9.0835 5.83576 8.54001L6.77033 8.29392L3.29279 4.81638C2.90234 4.42592 2.90247 3.79286 3.29279 3.40232ZM6.34455 10.4746C5.7733 10.6252 5.58023 11.3388 5.99787 11.7568L12.2449 18.0039C12.6629 18.4218 13.3766 18.2289 13.5272 17.6572L14.0701 15.5937L8.40705 9.93064L6.34455 10.4746Z" }), jsx("path", { d: "M12.1639 4.52927C13.0081 2.84073 15.2586 2.47575 16.5936 3.81052L20.1932 7.40915C21.5274 8.74405 21.1623 10.9944 19.4744 11.8388L17.6922 12.7304C17.1985 12.9772 16.5976 12.7765 16.3504 12.2832C16.1034 11.7892 16.3037 11.1884 16.7977 10.9414L18.5799 10.0498C19.0468 9.81581 19.1472 9.19277 18.7781 8.82322L15.1795 5.22458C14.8098 4.85511 14.1867 4.95625 13.9529 5.4238L13.0623 7.20603C12.8153 7.69949 12.2142 7.89973 11.7205 7.65329C11.2267 7.40637 11.0266 6.80539 11.2733 6.3115L12.1639 4.52927Z" })] });
});
UnpinIcon.displayName = "UnpinIcon";

const UpgradeIcon = forwardRef$1(function UpgradeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12 2C17.5229 2 22 6.47716 22 12C22 17.5229 17.5229 22 12 22C6.47716 22 2 17.5229 2 12C2 6.47716 6.47716 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM12.0205 7.00098C12.0381 7.00133 12.0557 7.00165 12.0732 7.00293C12.1225 7.0065 12.1707 7.01396 12.2178 7.02441C12.2269 7.02645 12.236 7.02895 12.2451 7.03125C12.3141 7.04866 12.3799 7.07357 12.4424 7.10449C12.4746 7.12042 12.5064 7.13761 12.5371 7.15723C12.5449 7.16219 12.5529 7.16671 12.5605 7.17188C12.6122 7.2069 12.6613 7.24722 12.707 7.29297L15.707 10.293L15.7754 10.3691C16.0957 10.7619 16.0731 11.3409 15.707 11.707C15.3409 12.0731 14.7619 12.0957 14.3691 11.7754L14.293 11.707L13 10.4141V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V10.4141L9.70703 11.707C9.31651 12.0976 8.68349 12.0976 8.29297 11.707C7.90244 11.3165 7.90244 10.6835 8.29297 10.293L11.293 7.29297C11.3548 7.23117 11.4248 7.17778 11.501 7.13379C11.5154 7.12546 11.5302 7.1179 11.5449 7.11035C11.6073 7.0784 11.6731 7.05257 11.7422 7.03418C11.7588 7.02976 11.7753 7.02503 11.792 7.02148C11.803 7.01916 11.8141 7.01758 11.8252 7.01562C11.8427 7.01252 11.8603 7.00998 11.8779 7.00781C11.8957 7.00565 11.9136 7.00415 11.9316 7.00293C11.9476 7.00184 11.9635 7.00131 11.9795 7.00098C11.9863 7.00084 11.9931 7 12 7C12.0069 7 12.0137 7.00084 12.0205 7.00098Z" }) });
});
UpgradeIcon.displayName = "UpgradeIcon";

const UserIcon = forwardRef$1(function UserIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M12.0001 12.5C16.0259 12.5 19.0942 14.9504 20.338 18.3682L20.3966 18.5469C20.6546 19.4384 20.4147 20.3043 19.8937 20.9355C19.3504 21.5936 18.5059 22 17.5909 22H6.40929C5.49441 21.9999 4.65075 21.5935 4.10753 20.9355C3.55161 20.2622 3.31514 19.3219 3.66222 18.3682L3.78429 18.0508C5.09878 14.7997 8.10019 12.5001 12.0001 12.5ZM12.0001 14.5C8.97362 14.5001 6.66771 16.2512 5.63781 18.8027L5.5421 19.0518C5.45827 19.2821 5.50485 19.4867 5.64952 19.6621C5.807 19.8528 6.08198 19.9999 6.40929 20H17.5909C17.9183 20 18.1932 19.8529 18.3507 19.6621C18.4773 19.5087 18.5296 19.3335 18.4845 19.1377L18.4591 19.0518C17.4815 16.3656 15.1244 14.5 12.0001 14.5ZM12.0001 2C14.4854 2.00001 16.5001 4.01472 16.5001 6.5C16.5001 8.98528 14.4854 11 12.0001 11C9.51483 11 7.50011 8.98528 7.50011 6.5C7.50011 4.01472 9.51483 2 12.0001 2ZM12.0001 4C10.6194 4 9.50011 5.11928 9.50011 6.5C9.50011 7.88072 10.6194 9 12.0001 9C13.3808 8.99999 14.5001 7.88071 14.5001 6.5C14.5001 5.11929 13.3808 4.00001 12.0001 4Z" }) });
});
UserIcon.displayName = "UserIcon";

const VariableIcon = forwardRef$1(function VariableIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M4.91016 5.00977C5.1901 4.97283 5.47715 5.04024 5.7041 5.2002C5.8148 5.27577 5.90945 5.37328 5.98145 5.48633C6.05333 5.59934 6.10144 5.72622 6.12305 5.8584C6.14261 5.98935 6.13471 6.12331 6.09961 6.25098C6.06449 6.37856 6.00266 6.49714 5.91895 6.59962C4.7552 8.15997 4.12403 10.0535 4.11816 12C4.11816 13.929 4.74597 15.8124 5.91797 17.4004C6.00185 17.5028 6.06333 17.6215 6.09863 17.749C6.1339 17.8767 6.14246 18.0106 6.12305 18.1416C6.10144 18.2738 6.05331 18.4007 5.98145 18.5137C5.90946 18.6267 5.81479 18.7242 5.7041 18.7998C5.5191 18.9298 5.29255 19 5.06055 19C4.89703 19.0013 4.73514 18.9665 4.58691 18.8975C4.43847 18.8283 4.30734 18.726 4.20312 18.5996C2.76823 16.6587 2 14.3569 2 12C2.00001 9.64309 2.76821 7.34135 4.20312 5.4004C4.37313 5.1884 4.62916 5.04777 4.91016 5.00977ZM18.8105 5.00684C18.9946 4.98469 19.1822 5.00948 19.3545 5.07813C19.5266 5.1468 19.6786 5.2578 19.7969 5.4004C21.2318 7.34135 22 9.64309 22 12C22 14.3569 21.2318 16.6587 19.7969 18.5996C19.6927 18.726 19.5615 18.8283 19.4131 18.8975C19.2649 18.9665 19.103 19.0013 18.9395 19C18.7075 19 18.4809 18.9298 18.2959 18.7998C18.068 18.6408 17.9169 18.4035 17.877 18.1416C17.8574 18.0107 17.8653 17.8767 17.9004 17.749C17.9355 17.6215 17.9973 17.5029 18.0811 17.4004C19.2452 15.8402 19.8767 13.9467 19.8828 12C19.8767 10.0534 19.2452 8.15984 18.0811 6.59962C17.969 6.4628 17.8977 6.29746 17.875 6.12208C17.8524 5.94661 17.8794 5.76825 17.9531 5.60743C18.1031 5.27955 18.4307 5.04997 18.8105 5.00684ZM14.9609 7.98438C15.0999 7.98296 15.2376 8.00906 15.3662 8.06153C15.495 8.11412 15.6126 8.19163 15.7109 8.29005C15.8093 8.38848 15.8869 8.5059 15.9395 8.63477C15.9919 8.76359 16.0182 8.90194 16.0166 9.04102C16.015 9.18005 15.986 9.31778 15.9307 9.44532C15.8753 9.57284 15.7948 9.68807 15.6943 9.78419L13.4775 12L15.6943 14.2158C15.8903 14.4118 16 14.6779 16 14.9551C16 15.2322 15.8903 15.4984 15.6943 15.6943C15.4984 15.8903 15.2322 16 14.9551 16C14.6779 16 14.4118 15.8903 14.2158 15.6943L12 13.4785L9.78418 15.6943C9.58819 15.8903 9.32207 16 9.04492 16C8.76777 16 8.50164 15.8903 8.30566 15.6943C8.10969 15.4984 8.00001 15.2322 8 14.9551C8 14.8178 8.02658 14.6815 8.0791 14.5547C8.13161 14.428 8.2087 14.3128 8.30566 14.2158L10.5225 12L8.30566 9.78419C8.2087 9.6872 8.1316 9.57201 8.0791 9.44532C8.02658 9.31852 8 9.18217 8 9.04493C8.00001 8.90789 8.02673 8.77214 8.0791 8.64551C8.13162 8.51872 8.20862 8.40272 8.30566 8.30567C8.40271 8.20863 8.51872 8.13163 8.64551 8.07911C8.77213 8.02674 8.90789 8.00002 9.04492 8.00001C9.18217 8.00001 9.31851 8.02659 9.44531 8.07911C9.572 8.13161 9.6872 8.20871 9.78418 8.30567L12 10.5225L14.2158 8.30567H14.2168C14.313 8.20522 14.429 8.12561 14.5566 8.07032C14.6843 8.01506 14.8219 7.98585 14.9609 7.98438Z" }) });
});
VariableIcon.displayName = "VariableIcon";

const VariantIcon = forwardRef$1(function VariantIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsxs(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M12 15C12.5523 15 13 15.4477 13 16V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V16C11 15.4477 11.4477 15 12 15Z", fill: "currentColor" }), jsx("path", { d: "M6.79297 15.793C7.18349 15.4024 7.81651 15.4024 8.20703 15.793C8.59756 16.1835 8.59756 16.8165 8.20703 17.207L6.70703 18.707C6.31651 19.0976 5.68349 19.0976 5.29297 18.707C4.90244 18.3165 4.90244 17.6835 5.29297 17.293L6.79297 15.793Z", fill: "currentColor" }), jsx("path", { d: "M15.793 15.793C16.1835 15.4024 16.8165 15.4024 17.207 15.793L18.707 17.293C19.0976 17.6835 19.0976 18.3165 18.707 18.707C18.3165 19.0976 17.6835 19.0976 17.293 18.707L15.793 17.207C15.4024 16.8165 15.4024 16.1835 15.793 15.793Z", fill: "currentColor" }), jsx("path", { d: "M8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H8Z", fill: "currentColor" }), jsx("path", { d: "M22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H16C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11H22Z", fill: "currentColor" }), jsx("path", { d: "M12 1C12.5523 1 13 1.44772 13 2V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V2C11 1.44772 11.4477 1 12 1Z", fill: "currentColor" }), jsx("path", { d: "M5.29297 5.29297C5.68349 4.90244 6.31651 4.90244 6.70703 5.29297L8.20703 6.79297C8.59756 7.18349 8.59756 7.81651 8.20703 8.20703C7.81651 8.59756 7.18349 8.59756 6.79297 8.20703L5.29297 6.70703C4.90244 6.31651 4.90244 5.68349 5.29297 5.29297Z", fill: "currentColor" }), jsx("path", { d: "M17.293 5.29297C17.6835 4.90244 18.3165 4.90244 18.707 5.29297C19.0976 5.68349 19.0976 6.31651 18.707 6.70703L17.207 8.20703C16.8165 8.59756 16.1835 8.59756 15.793 8.20703C15.4024 7.81651 15.4024 7.18349 15.793 6.79297L17.293 5.29297Z", fill: "currentColor" })] });
});
VariantIcon.displayName = "VariantIcon";

const VolumeOffIcon = forwardRef$1(function VolumeOffIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.8672 4.16995C11.7743 3.69 12.9998 4.28518 13 5.43851V18.5664C13 19.7201 11.7744 20.3154 10.8672 19.835L10.6904 19.7246L6.49121 16.6612H6.49023C6.35186 16.5604 6.17972 16.504 6 16.5039H4.7998C3.28 16.5038 2 15.2981 2 13.753V10.252C2.00029 8.70714 3.28016 7.50209 4.7998 7.50198H6C6.17969 7.50193 6.35174 7.44468 6.49023 7.34378H6.49121L10.6904 4.2803L10.8672 4.16995ZM7.66895 8.95999C7.18456 9.31315 6.59874 9.50193 6 9.50198H4.7998C4.3318 9.50208 4.0003 9.8639 4 10.252V13.753C4 14.1413 4.33158 14.5038 4.7998 14.5039H6C6.59876 14.504 7.18442 14.6925 7.66895 15.0459L11 17.4746V6.5303L7.66895 8.95999ZM19.293 9.29593C19.6835 8.90541 20.3165 8.90541 20.707 9.29593C21.0972 9.68648 21.0974 10.3196 20.707 10.71L19.4141 12.003L20.707 13.2959L20.7754 13.3721C21.0954 13.7649 21.073 14.344 20.707 14.71C20.341 15.076 19.7619 15.0984 19.3691 14.7783L19.293 14.71L18 13.417L16.707 14.71C16.3166 15.1004 15.6835 15.1001 15.293 14.71C14.9024 14.3195 14.9025 13.6865 15.293 13.2959L16.5859 12.003L15.293 10.71L15.2246 10.6338C14.9043 10.241 14.9269 9.66204 15.293 9.29593C15.6591 8.92982 16.2381 8.90722 16.6309 9.22757L16.707 9.29593L18 10.5889L19.293 9.29593Z" }) });
});
VolumeOffIcon.displayName = "VolumeOffIcon";

const VolumeIcon = forwardRef$1(function VolumeIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M10.8672 4.1698C11.7743 3.68985 12.9998 4.28504 13 5.43836V18.5663C13 19.72 11.7744 20.3152 10.8672 19.8348L10.6904 19.7245L6.49121 16.661H6.49023C6.35186 16.5602 6.17972 16.5038 6 16.5038H4.7998C3.28001 16.5037 2.00001 15.2979 2 13.7528V10.2518C2.00029 8.70699 3.28016 7.50194 4.7998 7.50184H6C6.17969 7.50178 6.35175 7.44453 6.49023 7.34363H6.49121L10.6904 4.28016L10.8672 4.1698ZM17.2812 4.30555C17.6412 3.93346 18.2201 3.90094 18.6182 4.21473L18.6953 4.28211L19.0674 4.66004C20.8846 6.59282 22 9.16897 22 12.0009C21.9997 14.8326 20.8847 17.4091 19.0674 19.3417L18.6953 19.7196C18.2984 20.1026 17.665 20.0923 17.2812 19.6962C16.8977 19.2993 16.9084 18.666 17.3047 18.2821L17.6104 17.9725C19.0994 16.3896 19.9997 14.2942 20 12.0009C20 9.70736 19.0993 7.61235 17.6104 6.02918L17.3047 5.71961L17.2354 5.64539C16.9083 5.25833 16.9219 4.67796 17.2812 4.30555ZM7.66895 8.95984C7.18457 9.313 6.59874 9.50178 6 9.50184H4.7998C4.3318 9.50194 4.0003 9.86375 4 10.2518V13.7528C4.00001 14.1411 4.33159 14.5037 4.7998 14.5038H6C6.59876 14.5038 7.18442 14.6924 7.66895 15.0458L11 17.4745V6.53016L7.66895 8.95984ZM14.2295 7.36316C14.5598 6.96446 15.1347 6.88759 15.5557 7.1698L15.6377 7.23035L15.8994 7.45789C17.1778 8.62357 18 10.2138 18 12.0009C17.9997 13.7877 17.1777 15.3783 15.8994 16.5438L15.6377 16.7714C15.2125 17.1226 14.5816 17.0632 14.2295 16.6386C13.8777 16.2135 13.9377 15.5827 14.3623 15.2304L14.5527 15.0653C15.4784 14.2221 15.9997 13.1423 16 12.0009C16 10.8591 15.4784 9.77984 14.5527 8.93641L14.3623 8.77137L14.2861 8.70203C13.9309 8.34123 13.9002 7.76182 14.2295 7.36316Z" }) });
});
VolumeIcon.displayName = "VolumeIcon";

const WandIcon = forwardRef$1(function WandIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M16.4121 3.78768C17.4618 2.73801 19.1632 2.73801 20.2129 3.78768C21.2626 4.83735 21.2626 6.5388 20.2129 7.58846L7.58889 20.2135C6.53923 21.2631 4.8368 21.2631 3.78713 20.2135C2.73746 19.1638 2.73746 17.4614 3.78713 16.4117L16.4121 3.78768ZM16.4971 15.3443C16.6135 14.802 17.3875 14.802 17.5039 15.3443C17.628 15.9217 18.0788 16.3727 18.6563 16.4967C19.1985 16.6131 19.1985 17.387 18.6563 17.5035C18.0789 17.6275 17.6281 18.0785 17.5039 18.6558C17.3875 19.1981 16.6135 19.1981 16.4971 18.6558C16.3729 18.0784 15.9212 17.6275 15.3438 17.5035C14.8018 17.3869 14.8018 16.6132 15.3438 16.4967C15.9213 16.3726 16.373 15.9218 16.4971 15.3443ZM5.16115 17.7857C4.86997 18.0769 4.86997 18.5483 5.16115 18.8394C5.45232 19.1306 5.9237 19.1306 6.21486 18.8394L15.7256 9.32967L14.6709 8.27498L5.16115 17.7857ZM5.62307 7.75838C5.7104 7.35167 6.29061 7.35167 6.37795 7.75838C6.4711 8.19135 6.80917 8.52964 7.24221 8.62264C7.64892 8.70997 7.64892 9.29018 7.24221 9.37752C6.80917 9.47052 6.4711 9.8088 6.37795 10.2418C6.29061 10.6485 5.7104 10.6485 5.62307 10.2418C5.52996 9.80873 5.19092 9.47052 4.75783 9.37752C4.35144 9.29002 4.35145 8.71014 4.75783 8.62264C5.19092 8.52964 5.52996 8.19143 5.62307 7.75838ZM18.8399 5.16072C18.5487 4.86955 18.0763 4.86955 17.7852 5.16072L16.044 6.90193L17.0987 7.95662L18.8399 6.21541C19.131 5.92424 19.131 5.4519 18.8399 5.16072ZM8.49709 3.6617C8.6136 3.11951 9.38748 3.11945 9.50392 3.6617C9.62796 4.23922 10.0788 4.68999 10.6563 4.81404C11.1985 4.93049 11.1985 5.70438 10.6563 5.82088C10.0787 5.94491 9.62795 6.39662 9.50392 6.9742C9.38739 7.51624 8.61374 7.51615 8.49709 6.9742C8.37306 6.39662 7.92135 5.94491 7.34377 5.82088C6.80187 5.7042 6.80177 4.9306 7.34377 4.81404C7.92135 4.69002 8.37306 4.23928 8.49709 3.6617Z" }) });
});
WandIcon.displayName = "WandIcon";

const WarningIcon = forwardRef$1(function WarningIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.70312 5.73139C10.8314 4.03501 13.3633 4.09137 14.3984 5.90034L20.6221 16.7802L20.7148 16.954C21.5958 18.7688 20.3248 20.9957 18.2227 20.996H5.77539C3.60522 20.996 2.321 18.6233 3.375 16.7802L9.59863 5.90034L9.70312 5.73139ZM12.6631 6.8935C12.3815 6.40139 11.725 6.37122 11.3965 6.8017L11.335 6.8935L5.11133 17.7734C4.78655 18.3416 5.20808 18.996 5.77539 18.996H18.2227C18.7542 18.9957 19.1575 18.4208 18.9385 17.8808L18.8867 17.7734L12.6631 6.8935ZM12.127 15.1523C12.7546 15.217 13.2216 15.7524 13.2217 16.372C13.2216 17.033 12.6901 17.5985 11.999 17.5986C11.3509 17.5985 10.8429 17.1011 10.7822 16.4941L10.7764 16.372L10.7822 16.249C10.8432 15.6422 11.3511 15.1455 11.999 15.1455L12.127 15.1523ZM11.999 9.95405C12.5511 9.95425 12.999 10.4019 12.999 10.954V13.6669C12.9989 14.219 12.5511 14.6667 11.999 14.6669C11.4468 14.6669 10.9992 14.2191 10.999 13.6669V10.954C10.999 10.4018 11.4467 9.95405 11.999 9.95405Z" }) });
});
WarningIcon.displayName = "WarningIcon";

const WhatsappIcon = forwardRef$1(function WhatsappIcon_({ baseline = false, ...props }, ref) {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return jsx(chakra.svg, { __css: styles, width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { transform: "translate(2, 2) scale(1.3333333)", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.54419 1.92912e-06C9.47819 0.0114394 11.3333 0.763127 12.7217 2.09766C14.1099 3.43223 14.9242 5.24679 14.9948 7.16235C15.0315 8.14305 14.8722 9.12158 14.5256 10.0408C14.1789 10.9598 13.6518 11.8016 12.9752 12.5178C12.2983 13.2341 11.485 13.811 10.5823 14.2142C9.67949 14.6173 8.70473 14.8394 7.71491 14.8674H7.5006C6.3754 14.8677 5.26409 14.6169 4.24972 14.1343L0.32412 15H0.313034C0.304816 14.9999 0.296113 14.9983 0.288644 14.9949C0.281258 14.9915 0.274781 14.9864 0.26943 14.9802C0.264058 14.9741 0.259964 14.9668 0.257603 14.959C0.255287 14.9512 0.254318 14.9428 0.255385 14.9348L0.919017 11.001C0.294433 9.86835 -0.0218543 8.59425 0.00117329 7.30373C0.0242463 6.01305 0.385764 4.75021 1.05056 3.64014C1.71531 2.53016 2.66026 1.61092 3.79227 0.972662C4.92438 0.334412 6.20476 -0.000928071 7.50726 1.92912e-06H7.54419ZM4.82392 3.84961C4.75513 3.85778 4.68792 3.87649 4.62439 3.90455C4.53972 3.94196 4.463 3.9956 4.39973 4.06274C4.22097 4.24444 3.72144 4.68188 3.6925 5.6001C3.66361 6.51788 4.31017 7.42605 4.40121 7.55423C4.49174 7.68158 5.6391 9.66555 7.52868 10.47C8.63927 10.9442 9.12631 11.0252 9.44195 11.0252C9.57195 11.0252 9.67041 11.0122 9.77302 11.0061C10.1193 10.9848 10.9003 10.5883 11.0708 10.1573C11.2412 9.726 11.2524 9.3486 11.2074 9.27323C11.1625 9.19778 11.039 9.1434 10.8535 9.04688C10.6673 8.95005 9.7572 8.46795 9.58611 8.40015C9.52277 8.37098 9.45466 8.35328 9.38504 8.34818C9.33963 8.3505 9.29484 8.36385 9.25571 8.38695C9.21674 8.41005 9.18405 8.4423 9.16044 8.4807C9.00833 8.66843 8.65902 9.07643 8.54188 9.1941C8.5163 9.22328 8.48474 9.24653 8.44948 9.26295C8.41414 9.2793 8.37547 9.2886 8.33642 9.28928C8.26453 9.28613 8.194 9.26745 8.13021 9.23438C7.5787 9.00225 7.07592 8.66918 6.64775 8.25368C6.24782 7.86293 5.90816 7.41585 5.64052 6.92655C5.5371 6.7365 5.64077 6.63825 5.73512 6.5493C5.82937 6.46035 5.93051 6.33773 6.02776 6.23145C6.10767 6.14063 6.17449 6.03893 6.2258 5.92969C6.25228 5.87907 6.26515 5.82263 6.26424 5.76563C6.26333 5.70848 6.24812 5.65215 6.21989 5.6023C6.17464 5.50597 5.84002 4.57358 5.68264 4.19898C5.55491 3.87868 5.40264 3.86747 5.26954 3.85767C5.16005 3.85013 5.03439 3.84679 4.90891 3.84302H4.89264L4.82392 3.84961Z", fill: "currentColor" }) }) });
});
WhatsappIcon.displayName = "WhatsappIcon";

const transition = {
    property: {
        ...theme$1.transition.property,
    },
    /**
     * Duration guidelines:
     *  - basic hover states: 150ms ease
     *  - modals & popovers: open 200ms easeOut / close 150ms easeOut
     *  - exits are shorter than entries — the user has decided to leave; get out of the way.
     *  - duration scales with size and distance traveled — larger movement reads heavier.
     *  - everything else: should be evaluated on a case by case basis.
     */
    duration: {
        /** Micro-feedback. */
        fastest: "60ms",
        /** Small state changes. */
        faster: "100ms",
        /** Hover, basic transitions. */
        fast: "150ms",
        /** Opening popovers and menus. */
        normal: "200ms",
        /** Modals and dialogs. */
        slow: "300ms",
        /** Larger surfaces. */
        slower: "400ms",
        /** Deliberate, emphasis. */
        dramatic: "600ms",
    },
    /**
     * The `easeOut` curves are ordered from most subtle (quad) to most dramatic (expo). Use an
     * `easeOut` curve for elements entering or leaving the screen, and an `easeInOut` curve when
     * moving something already on screen to a new position. `linear` is for properties with no
     * spatial motion to read — opacity and color.
     *
     * @see https://animations.dev — ease curves crafted by Benjamin De Cock and Emil Kowalski
     */
    easing: {
        /** No acceleration. For opacity and color, where an eased curve reads as a stall. */
        linear: "linear",
        /** Basic transitions: hover, background, color. */
        easeOutQuad: "cubic-bezier(.25, .46, .45, .94)",
        /** Small popovers: selects, menus. */
        easeOutCubic: "cubic-bezier(.215, .61, .355, 1)",
        /** Larger popovers: modals, dialogs. */
        easeOutQuart: "cubic-bezier(.165, .84, .44, 1)",
        /** Page transitions, major UI changes. */
        easeOutQuint: "cubic-bezier(.23, 1, .32, 1)",
        /** Attention-grabbing motion: notifications. */
        easeOutExpo: "cubic-bezier(.19, 1, .22, 1)",
        /** `ease-in-out` is preferred when moving anything on the screen to a new position. */
        easeInOutQuad: "cubic-bezier(.455, .03, .515, .955)",
        easeInOutCubic: "cubic-bezier(.645, .045, .355, 1)",
        easeInOutQuart: "cubic-bezier(.77, 0, .175, 1)",
        easeInOutQuint: "cubic-bezier(.86, 0, .07, 1)",
        easeInOutExpo: "cubic-bezier(1, 0, 0, 1)",
        easeInOutCirc: "cubic-bezier(.785, .135, .15, .86)",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
/**
 * Motion-ready mirrors of the theme transition tokens.
 *
 * Motion's `transition` prop can't consume CSS strings like `cubic-bezier(…)` or `200ms`,
 * so these parse `theme/foundations/transition.ts` (the source of truth) into bezier tuples
 * and seconds. Use these instead of hand-copying values.
 */
function toBezier(cssValue) {
    const [x1 = 0, y1 = 0, x2 = 0, y2 = 1] = (cssValue.match(/-?\d*\.?\d+/gu) ?? []).map(Number);
    return [x1, y1, x2, y2];
}
function toSeconds(cssValue) {
    // biome-ignore lint/plugin/no-number-parse-int-float: parsing a CSS duration; dropping the "ms" unit is the point
    return Number.parseFloat(cssValue) / 1000;
}
const motionEasings = {
    linear: transition.easing.linear,
    easeOutQuad: toBezier(transition.easing.easeOutQuad),
    easeOutCubic: toBezier(transition.easing.easeOutCubic),
    easeOutQuart: toBezier(transition.easing.easeOutQuart),
    easeOutQuint: toBezier(transition.easing.easeOutQuint),
    easeOutExpo: toBezier(transition.easing.easeOutExpo),
    easeInOutQuad: toBezier(transition.easing.easeInOutQuad),
    easeInOutCubic: toBezier(transition.easing.easeInOutCubic),
    easeInOutQuart: toBezier(transition.easing.easeInOutQuart),
    easeInOutQuint: toBezier(transition.easing.easeInOutQuint),
    easeInOutExpo: toBezier(transition.easing.easeInOutExpo),
    easeInOutCirc: toBezier(transition.easing.easeInOutCirc),
};
const motionDurations = {
    fastest: toSeconds(transition.duration.fastest),
    faster: toSeconds(transition.duration.faster),
    fast: toSeconds(transition.duration.fast),
    normal: toSeconds(transition.duration.normal),
    slow: toSeconds(transition.duration.slow),
    slower: toSeconds(transition.duration.slower),
    dramatic: toSeconds(transition.duration.dramatic),
};

/**
 * Shared motion variants for consistent animation behavior across UI components.
 *
 * These variants define standardized enter/exit animations for different types of UI elements:
 * - Tooltips: Quick, subtle animations for small contextual elements
 * - Menus: Moderate animations for dropdown menus and select components
 * - Popovers: Slightly longer animations for larger modal-like elements
 * - Fade up: An element fading in while it rises into place, such as a card arriving in a chat
 * - Fade down: The inverse, an element fading in while it drops into place from above
 *
 * The motion properties are carefully tuned for each variant, and based off our transition guidelines.
 *
 * @see `source/theme/foundations/transition.ts` for our transition guidelines.
 */
const tooltipVariants = {
    initial: {
        scale: 0.95,
        opacity: 0,
    },
    variants: {
        enter: {
            scale: 1,
            opacity: 1,
            transition: {
                duration: motionDurations.fast,
                ease: motionEasings.easeOutQuad,
            },
        },
        exit: {
            scale: 0.95,
            opacity: 0,
            transition: {
                duration: motionDurations.faster,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};
// Dropdown popovers  like selects and menus.
const dropdownVariants = {
    initial: {
        scale: 0.95,
        opacity: 0,
    },
    variants: {
        enter: {
            scale: 1,
            opacity: 1,
            transition: {
                duration: motionDurations.normal,
                ease: motionEasings.easeOutCubic,
            },
        },
        exit: {
            scale: 0.95,
            opacity: 0,
            transition: {
                duration: motionDurations.faster,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};
// Popovers like modals and dialogs.
// Larger elements should have longer transition durations.
const popoverVariants = {
    initial: {
        scale: 0.95,
        opacity: 0,
        y: 2,
    },
    variants: {
        enter: {
            y: 0,
            scale: 1,
            opacity: 1,
            transition: {
                duration: motionDurations.slow,
                ease: motionEasings.easeOutQuart,
            },
        },
        exit: {
            scale: 0.95,
            opacity: 0,
            transition: {
                duration: motionDurations.fast,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};
// Full-screen modal with app-stack push effect.
// The modal scales up from the center while the background content pushes back.
const fullScreenModalVariants = {
    initial: { scale: 1.06, opacity: 0 },
    animate: "enter",
    exit: "exit",
    variants: {
        enter: {
            scale: 1,
            opacity: 1,
            transition: {
                duration: motionDurations.slower,
                ease: motionEasings.easeOutQuint,
            },
        },
        exit: {
            scale: 1.06,
            opacity: 0,
            transition: {
                duration: motionDurations.fast,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};
// Fades in while rising into place, and leaves the way it came.
const fadeUpVariants = {
    initial: { y: 10, opacity: 0 },
    animate: "enter",
    exit: "exit",
    variants: {
        enter: {
            y: 0,
            opacity: 1,
            transition: {
                duration: motionDurations.normal,
                ease: motionEasings.easeOutCubic,
            },
        },
        exit: {
            y: 10,
            opacity: 0,
            transition: {
                duration: motionDurations.fast,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};
// The inverse of fadeUp: fades in while dropping into place from above.
const fadeDownVariants = {
    initial: { y: -10, opacity: 0 },
    animate: "enter",
    exit: "exit",
    variants: {
        enter: {
            y: 0,
            opacity: 1,
            transition: {
                duration: motionDurations.normal,
                ease: motionEasings.easeOutCubic,
            },
        },
        exit: {
            y: -10,
            opacity: 0,
            transition: {
                duration: motionDurations.fast,
                ease: motionEasings.easeOutQuad,
            },
        },
    },
};

const styledOptions = {
    shouldForwardProp(prop) {
        return isValidMotionProp(prop) || shouldForwardProp(prop);
    },
};
const MotionDivBase = forwardRef$1(function MotionDivBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.div, { ...rest, ref: ref, transition: motionTransition });
});
const StyledDiv = chakra(MotionDivBase, styledOptions);
const MotionBox = forwardRef$1(function MotionBox({ transition, ...rest }, ref) {
    return jsx(StyledDiv, { ...rest, ref: ref, motionTransition: transition });
});
const MotionButtonBase = forwardRef$1(function MotionButtonBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.button, { ...rest, ref: ref, transition: motionTransition });
});
const StyledButton = chakra(MotionButtonBase, styledOptions);
const MotionButton = forwardRef$1(function MotionButton({ transition, ...rest }, ref) {
    return jsx(StyledButton, { ...rest, ref: ref, motionTransition: transition });
});
const MotionTextBase = forwardRef$1(function MotionTextBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.p, { ...rest, ref: ref, transition: motionTransition });
});
const StyledText = chakra(MotionTextBase, styledOptions);
const MotionText = forwardRef$1(function MotionText({ transition, ...rest }, ref) {
    return jsx(StyledText, { ...rest, ref: ref, motionTransition: transition });
});
const MotionSpanBase = forwardRef$1(function MotionSpanBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.span, { ...rest, ref: ref, transition: motionTransition });
});
const StyledSpan = chakra(MotionSpanBase, styledOptions);
const MotionSpan = forwardRef$1(function MotionSpan({ transition, ...rest }, ref) {
    return jsx(StyledSpan, { ...rest, ref: ref, motionTransition: transition });
});
const MotionSvgBase = forwardRef$1(function MotionSvgBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.svg, { ...rest, ref: ref, transition: motionTransition });
});
const StyledSvg = chakra(MotionSvgBase, styledOptions);
const MotionSvg = forwardRef$1(function MotionSvg({ transition, ...rest }, ref) {
    return jsx(StyledSvg, { ...rest, ref: ref, motionTransition: transition });
});
const MotionPathBase = forwardRef$1(function MotionPathBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.path, { ...rest, ref: ref, transition: motionTransition });
});
const StyledPath = chakra(MotionPathBase, styledOptions);
const MotionPath = forwardRef$1(function MotionPath({ transition, ...rest }, ref) {
    return jsx(StyledPath, { ...rest, ref: ref, motionTransition: transition });
});
const MotionCircleBase = forwardRef$1(function MotionCircleBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.circle, { ...rest, ref: ref, transition: motionTransition });
});
const StyledCircle = chakra(MotionCircleBase, styledOptions);
const MotionCircle = forwardRef$1(function MotionCircle({ transition, ...rest }, ref) {
    return jsx(StyledCircle, { ...rest, ref: ref, motionTransition: transition });
});
const MotionRectBase = forwardRef$1(function MotionRectBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.rect, { ...rest, ref: ref, transition: motionTransition });
});
const StyledRect = chakra(MotionRectBase, styledOptions);
const MotionRect = forwardRef$1(function MotionRect({ transition, ...rest }, ref) {
    return jsx(StyledRect, { ...rest, ref: ref, motionTransition: transition });
});
const MotionLineBase = forwardRef$1(function MotionLineBase({ motionTransition, ...rest }, ref) {
    return jsx(motion.line, { ...rest, ref: ref, transition: motionTransition });
});
const StyledLine = chakra(MotionLineBase, styledOptions);
const MotionLine = forwardRef$1(function MotionLine({ transition, ...rest }, ref) {
    return jsx(StyledLine, { ...rest, ref: ref, motionTransition: transition });
});

/** Row entrance and stream glide. No theme token covers springs. */
const springLayout = {
    type: "spring",
    stiffness: 360,
    damping: 32,
    mass: 0.6,
};
/** Snappier spring for content swaps — the status row's label ticker. */
const springSwap = {
    type: "spring",
    stiffness: 460,
    damping: 30,
    mass: 0.55,
};
const itemEnter = { opacity: 0, y: 6 };
const itemVisible = { opacity: 1, y: 0 };
const itemExit = { opacity: 0, y: -3 };
/** Rows fade in fast while a spring settles their position. */
const itemTransition = {
    opacity: { duration: motionDurations.fast, ease: motionEasings.easeOutQuint },
    y: springLayout,
    layout: springLayout,
};
/** The status-row ticker — the old label rolls up and out as the new one rolls in. */
const labelTransition = {
    opacity: { duration: motionDurations.fast, ease: motionEasings.easeOutQuint },
    y: springSwap,
};

function capitalize(verb) {
    return verb.charAt(0).toUpperCase() + verb.slice(1);
}

function formatDuration(duration) {
    const seconds = Math.max(0, Math.round(duration));
    if (seconds < 60)
        return `${seconds}s`;
    const minutes = Math.floor(seconds / 60);
    const remainder = seconds % 60;
    return remainder === 0 ? `${minutes}m` : `${minutes}m ${remainder}s`;
}
function getContentType(items) {
    const first = items[0]?.type;
    return first && items.every((item) => item.type === first) ? first : "mixed";
}
function getActiveLabel(type) {
    if (type === "search")
        return "Searching the web…";
    if (type === "tool")
        return "Running tools…";
    if (type === "trace")
        return "Working through the run…";
    if (type === "mixed")
        return "Working through it…";
    return "Thinking…";
}
/**
 * The newest item, phrased as the run's current activity. Text is excluded — a
 * streaming paragraph is too long for a one-line headline.
 */
function getCurrentActivity(items) {
    const item = items[items.length - 1];
    if (!item || item.type === "text")
        return undefined;
    if (item.type === "step") {
        // A checklist can be queued up front, so the last step is often still
        // pending: the run is at its active step, else the newest one it finished.
        const steps = items.filter((entry) => entry.type === "step");
        const newest = (match) => {
            for (let index = steps.length - 1; index >= 0; index--) {
                const step = steps[index];
                if (step && match(step))
                    return step;
            }
            return undefined;
        };
        const current = newest((step) => step.status === "active") ??
            newest((step) => (step.status ?? "complete") === "complete") ??
            steps[0];
        // A step label may carry a link, and this headline renders inside the
        // trigger button — nesting one there is invalid. Fall back to the generic
        // label, the same way streaming text does.
        const headline = (label) => typeof label === "string" ? label : getActiveLabel("step");
        return current
            ? { key: current.id, label: headline(current.label) }
            : { key: item.id, label: headline(item.label) };
    }
    if (item.type === "search")
        return { key: item.id, label: item.query };
    if (item.type === "tool") {
        return {
            key: item.id,
            label: (jsxs(Fragment, { children: [capitalize(item.action), " ", item.target] })),
        };
    }
    return {
        key: item.id,
        label: item.detail ? (jsxs(Fragment, { children: [item.label, " \u00B7 ", item.detail] })) : (item.label),
    };
}
function getSummary(type, items, duration) {
    if (type === "step" || type === "text") {
        return duration > 0
            ? `Thought for ${formatDuration(duration)}`
            : "Finished thinking";
    }
    if (type === "search")
        return "Searched the web";
    if (type === "tool") {
        return `Ran ${items.length} ${items.length === 1 ? "tool" : "tools"}`;
    }
    if (type === "trace") {
        const messages = items.filter((item) => item.type === "trace" &&
            (item.kind === "thinking" || item.kind === "message")).length;
        const tools = items.length - messages;
        return `${tools} ${tools === 1 ? "tool call" : "tool calls"}, ${messages} ${messages === 1 ? "message" : "messages"}`;
    }
    return `Completed ${items.length} ${items.length === 1 ? "step" : "steps"}`;
}

/**
 * Returns true if the element's content fits, false if the content overflows.
 * If the element doesn't exist or is hidden, returns true.
 */
const useContentFits = (enabled = true, 
/**
 * Set to true for editable inputs. Necessary due to an interaction between Chakra Editable and Tooltip.
 */
{ skipClientWidthZero = false, debounceMs = 200, axis = "horizontal", } = {}) => {
    const [targetElement, setTargetElement] = useState(null);
    const [contentFits, setContentFits] = useState(true);
    const ref = useCallback((node) => {
        setTargetElement((previousElement) => {
            // Ignore null: Tooltip's per-render merged refs call the old ref with
            // null, then the new one with the same element — a null → element state
            // cycle that looped renders infinitely. Trade-off: a node that detaches
            // without a replacement stays measured.
            if (node === null) {
                return previousElement;
            }
            return node;
        });
    }, []);
    const checkContentFits = useCallback((element) => {
        if (element) {
            /**
             * This is needed when using Chakra Tooltip with an Editable component child.
             *
             * Bug: editable component will sometimes immediately exit editing state after entering.
             * Cause: Chakra Tooltip, when disabled, completely removes the tooltip components, forcing
             * a remount of the child editable component, which resets the editing state.
             * Hacky fix: Detects and ignores the content fits state when entering editing state,
             * detected by the preview component being hidden.
             */
            if (skipClientWidthZero && element.clientWidth === 0) {
                return;
            }
            if (axis === "vertical") {
                setContentFits(element.scrollHeight <= element.clientHeight);
            }
            else {
                setContentFits(element.scrollWidth <= element.clientWidth);
            }
        }
    }, [skipClientWidthZero, axis]);
    const debouncedCheckContentFits = useMemo(() => debounceMs < 0
        ? () => {
            checkContentFits(targetElement);
        }
        : debounce(() => {
            checkContentFits(targetElement);
        }, debounceMs), [checkContentFits, targetElement, debounceMs]);
    useEffect(() => {
        if (enabled) {
            debouncedCheckContentFits();
            if (targetElement) {
                const resizeObserver = new ResizeObserver(debouncedCheckContentFits);
                resizeObserver.observe(targetElement);
                window.addEventListener("resize", debouncedCheckContentFits);
                return () => {
                    if ("cancel" in debouncedCheckContentFits &&
                        typeof debouncedCheckContentFits.cancel === "function") {
                        debouncedCheckContentFits.cancel();
                    }
                    resizeObserver.disconnect();
                    window.removeEventListener("resize", debouncedCheckContentFits);
                };
            }
        }
        else {
            // If disabled, reset to default state (content fits)
            // TODO(eric.lovett): This `setContentFits` call should probably be moved to a disable
            // event handler.
            setContentFits(true);
        }
    }, [enabled, debouncedCheckContentFits, targetElement]);
    return { contentFits, ref };
};

const macKeys = {
    mod: "⌘",
    command: "⌘",
    shift: "⇧",
    ctrl: "⌃",
    alt: "⌥",
};
const windowsKeys = {
    mod: "Ctrl",
    shift: "Shift",
    ctrl: "Ctrl",
    alt: "Alt",
};
const openSpeedMap = {
    immediate: 0,
    default: 150,
};
// visualViewport.width counts a scrollbar gutter reserved by scrollbar-gutter: stable.
// Popper bounds the bubble by that width, but nothing paints inside the gutter.
function getReservedScrollbarGutterWidth() {
    const layoutWidth = document.documentElement.getBoundingClientRect().width;
    const visualWidth = window.visualViewport?.width ?? layoutWidth;
    return Math.max(0, visualWidth - layoutWidth);
}
// Measured on every Popper update so the value tracks the page, not the mount.
const keepOutOfScrollbarGutter = {
    name: "keepOutOfScrollbarGutter",
    enabled: true,
    phase: "read",
    fn({ state }) {
        const preventOverflow = state.orderedModifiers.find((modifier) => modifier.name === "preventOverflow");
        if (preventOverflow) {
            preventOverflow.options = {
                ...preventOverflow.options,
                padding: { right: getReservedScrollbarGutterWidth() },
            };
        }
    },
};
const formatKeyboardShortcut = (shortcut) => {
    const keys = shortcut.split("+");
    const platform = typeof navigator === "object" && navigator.userAgent.includes("Mac")
        ? "mac"
        : "windows";
    if (platform === "mac") {
        return keys.map((key) => {
            return macKeys[key] ?? key.toUpperCase();
        });
    }
    return keys
        .map((key) => {
        return windowsKeys[key] ?? key.toUpperCase();
    })
        .join(" + ")
        .split(" ");
};
const Tooltip = forwardRef$1(function Tooltip_({ isDisabled, isOpen, children: childrenProp, placement = "top", preferredPlacements, message, keyboardShortcut, openSpeed = "default", keepMountedWhileDisabled = false, }, ref) {
    const formattedKeyboardShortcut = keyboardShortcut
        ? formatKeyboardShortcut(keyboardShortcut)
        : null;
    // Only forward when a ref was given: React passes `null` when none is, and
    // cloning with it would clobber the child's own ref — e.g. the virtualizer's
    // `measureElement` ref on select options, which breaks option measurement.
    const children = ref && isValidElement(childrenProp)
        ? cloneElement(childrenProp, { ref })
        : childrenProp;
    const modifiers = useMemo(() => [
        keepOutOfScrollbarGutter,
        ...(preferredPlacements
            ? [
                {
                    name: "flip",
                    options: { fallbackPlacements: preferredPlacements },
                },
            ]
            : []),
    ], [preferredPlacements]);
    if (isDisabled && !keepMountedWhileDisabled) {
        return jsx(Fragment, { children: children });
    }
    return (jsx(Tooltip$1, { label: jsxs(Box$1, { display: "flex", alignItems: "center", flexDirection: formattedKeyboardShortcut ? "row" : "column", gap: formattedKeyboardShortcut ? 1.5 : 1, color: "white", children: [typeof message === "string" || typeof message === "number" ? (jsx(Text$1, { fontSize: "sm", color: "white", wordBreak: "break-word", children: message })) : (message), formattedKeyboardShortcut && (jsx(Box$1, { as: "span", display: "flex", alignItems: "center", color: "gray.300", fontWeight: "normal", fontSize: "sm", gap: 0.5, whiteSpace: "nowrap", children: formattedKeyboardShortcut.map((shortcut) => {
                        if (shortcut === "+") {
                            return shortcut;
                        }
                        return jsx(Kbd, { children: shortcut }, shortcut);
                    }) }))] }), placement: placement, openDelay: openSpeedMap[openSpeed], modifiers: modifiers, motionProps: tooltipVariants, isOpen: isOpen, 
        // Chakra gates opening (and clears its state) inside one tree, so the
        // child survives the toggle.
        isDisabled: keepMountedWhileDisabled ? isDisabled : undefined, children: children }));
});
Tooltip.displayName = "Tooltip";

/**
 * Truncated row text needs a way back to the full value. Only strings get a
 * tooltip; a ReactNode has no message to show.
 */
function TruncatedText({ children, css, }) {
    const { contentFits, ref } = useContentFits();
    const message = typeof children === "string" ? children : "";
    return (jsx(Tooltip, { message: message, isDisabled: message === "" || contentFits, children: jsx(chakra.span, { ref: ref, __css: css, children: children }) }));
}
function StepRow({ item, styles, }) {
    const status = item.status ?? "complete";
    return (jsxs(chakra.div, { __css: styles.stepRow, children: [jsx(chakra.span, { "aria-hidden": true, __css: styles.stepIcon, children: status === "complete" ? (jsx(Box, { as: CheckIcon, boxSize: 4 })) : status === "active" ? (jsxs(chakra.span, { __css: styles.stepPulse, children: [jsx(chakra.span, { __css: styles.stepPulseHalo }), jsx(chakra.span, { __css: styles.stepPulseDot })] })) : (jsx(Box, { as: DottedCircleIcon, boxSize: 3 })) }), jsx(chakra.span, { "data-step-status": status, __css: styles.stepLabel, children: item.label }), item.meta && (jsx(chakra.span, { __css: styles.stepMeta, children: item.meta }))] }));
}
function TextRow({ item, styles, }) {
    return jsx(chakra.div, { __css: styles.textRow, children: item.content });
}
function SearchResultRow({ result, styles, }) {
    const content = (jsxs(Fragment, { children: [jsx(chakra.span, { "aria-hidden": true, __css: styles.searchResultIcon, children: jsx(Box, { as: result.icon ?? GlobeIcon, boxSize: 3 }) }), jsx(TruncatedText, { css: styles.searchResultTitle, children: result.title }), result.domain && (jsx(TruncatedText, { css: styles.searchResultDomain, children: result.domain }))] }));
    // Without a url there is nothing to navigate to, and a bare `href` would
    // reload the current page. Results point off-site, so keep the run in place.
    return result.url ? (jsx(chakra.a, { href: result.url, target: "_blank", rel: "noopener noreferrer", __css: styles.searchResult, children: content })) : (jsx(chakra.div, { __css: styles.searchResult, children: content }));
}
function SearchRow({ item, styles, }) {
    return (jsxs(chakra.div, { __css: styles.searchRow, children: [jsxs(chakra.div, { __css: styles.searchQuery, children: [jsx(Box, { "aria-hidden": true, as: SearchIcon, __css: styles.searchQueryIcon }), jsx(TruncatedText, { css: styles.searchQueryText, children: item.query })] }), item.results && item.results.length > 0 && (jsx(chakra.div, { __css: styles.searchResults, children: jsx(AnimatePresence, { initial: false, mode: "popLayout", children: item.results.map((result) => (jsx(MotionBox, { layout: "position", initial: itemEnter, animate: itemVisible, exit: itemExit, transition: itemTransition, children: jsx(SearchResultRow, { result: result, styles: styles }) }, result.id))) }) })), jsx(AnimatePresence, { initial: false, children: item.moreCount ? (jsxs(MotionBox, { initial: itemEnter, animate: itemVisible, exit: itemExit, transition: itemTransition, __css: styles.searchMore, children: ["+", item.moreCount, " more"] }, "more-results")) : null })] }));
}
// `action` and `kind` are widened with `(string & {})`, so unknown values fall
// through to the generic glyph rather than rendering nothing.
const eventIcons = {
    read: FileIcon,
    edit: EditIcon,
    write: EditIcon,
    run: CodeBlockIcon,
    thinking: SparkleIcon,
    message: ChatIcon,
};
function EventIcon({ kind, icon }) {
    return jsx(Box, { as: icon ?? eventIcons[kind] ?? FunctionIcon });
}
function ToolRow({ item, styles, }) {
    const action = capitalize(item.action);
    return (jsxs(chakra.div, { __css: styles.toolRow, children: [jsx(chakra.span, { "aria-hidden": true, __css: styles.toolIcon, children: jsx(EventIcon, { kind: item.action }) }), jsx(TruncatedText, { css: styles.toolAction, children: action }), jsx(TruncatedText, { css: styles.monoChip, children: item.target }), (typeof item.additions === "number" ||
                typeof item.deletions === "number") && (jsxs(chakra.span, { __css: styles.toolDiff, children: [typeof item.additions === "number" && (jsxs(chakra.span, { __css: styles.toolAdditions, children: ["+", item.additions] })), typeof item.deletions === "number" && (jsxs(chakra.span, { __css: styles.toolDeletions, children: ["\u2212", item.deletions] }))] }))] }));
}
function TraceRow({ item, styles, }) {
    return (jsxs(chakra.div, { __css: styles.traceRow, children: [jsx(chakra.span, { "aria-hidden": true, __css: styles.traceIcon, children: jsx(EventIcon, { kind: item.kind, icon: item.icon }) }), jsx(TruncatedText, { css: styles.traceLabel, children: item.label }), item.detail && (jsx(TruncatedText, { css: styles.monoChip, children: item.detail }))] }));
}
function ActivityRow({ item }) {
    const styles = useMultiStyleConfig("AgentActivityRow");
    if (item.type === "text")
        return jsx(TextRow, { item: item, styles: styles });
    if (item.type === "search")
        return jsx(SearchRow, { item: item, styles: styles });
    if (item.type === "tool")
        return jsx(ToolRow, { item: item, styles: styles });
    if (item.type === "trace")
        return jsx(TraceRow, { item: item, styles: styles });
    return jsx(StepRow, { item: item, styles: styles });
}

const AgentActivity = forwardRef$1(function AgentActivity_({ items = [], contentType: initialContentType, size = "md", status = "working", duration = 0, isOpen, defaultIsOpen = false, onOpenChange, collapseOnComplete = true, activeLabel, summary, renderWorkingStatus, renderCompletedStatus, maxViewportHeight = 208, ...props }, ref) {
    const styles = useMultiStyleConfig("AgentActivity", { size });
    const baseId = useId();
    const triggerId = `${baseId}-trigger`;
    const contentId = `${baseId}-content`;
    const contentRef = useRef(null);
    const viewportRef = useRef(null);
    const triggerRef = useRef(null);
    const previousStatus = useRef(status);
    const [contentHeight, setContentHeight] = useState(0);
    const [currentOpen, setCurrentOpen] = useControllableState({
        value: isOpen,
        defaultValue: defaultIsOpen,
        onChange: onOpenChange,
    });
    const working = status === "working";
    // Nothing to disclose before the first item lands, so the status row is
    // plain text — a button over an empty region is announced and focusable
    // for no reason.
    const hasLog = items.length > 0;
    const expanded = currentOpen && hasLog;
    const contentType = items.length
        ? getContentType(items)
        : (initialContentType ?? "mixed");
    const viewportHeight = Math.min(contentHeight, Math.max(0, maxViewportHeight));
    const capped = contentHeight > maxViewportHeight;
    // A transform glide, so the capped log never scrolls natively.
    const streamOffset = working
        ? Math.min(0, viewportHeight - contentHeight)
        : 0;
    useSafeLayoutEffect(() => {
        const node = contentRef.current;
        if (!node)
            return;
        const measure = () => setContentHeight(node.offsetHeight);
        measure();
        if (typeof ResizeObserver === "undefined")
            return;
        const observer = new ResizeObserver(measure);
        observer.observe(node);
        return () => observer.disconnect();
        // The node only mounts once there is a log, so the first item has to
        // re-run this — otherwise the viewport stays measured at zero.
    }, [hasLog]);
    useEffect(() => {
        if (previousStatus.current === "working" &&
            status === "complete" &&
            collapseOnComplete) {
            setCurrentOpen(false);
        }
        previousStatus.current = status;
    }, [collapseOnComplete, setCurrentOpen, status]);
    // collapseOnComplete, or a controlled isOpen flipping false, can close the
    // disclosure while a link inside holds focus, stranding it in aria-hidden
    // content.
    useEffect(() => {
        if (expanded)
            return;
        const viewport = viewportRef.current;
        if (viewport?.contains(document.activeElement)) {
            triggerRef.current?.focus();
        }
    }, [expanded]);
    const toggle = () => {
        const next = !currentOpen;
        setCurrentOpen(next);
        if (next) {
            requestAnimationFrame(() => viewportRef.current?.scrollTo({ top: 0 }));
        }
    };
    const genericLabel = activeLabel ?? getActiveLabel(contentType);
    // The open log already shows the detail, so its label stays generic.
    const currentActivity = working && !expanded && activeLabel == null
        ? getCurrentActivity(items)
        : undefined;
    const liveLabel = currentActivity?.label ?? genericLabel;
    const completedSummary = summary ?? getSummary(contentType, items, duration);
    const labelKey = working ? (currentActivity?.key ?? "working") : "complete";
    // Keyed to live measurement, so it can't live in the theme.
    const maskImage = capped
        ? working
            ? "linear-gradient(to bottom, transparent, black 12px)"
            : "linear-gradient(to bottom, transparent, black 12px, black calc(100% - 12px), transparent)"
        : undefined;
    return (jsxs(chakra.div, { ref: ref, "data-status": working ? "working" : "complete", "data-state": expanded ? "open" : "closed", "data-content": contentType, "aria-busy": working, __css: styles.container, ...props, children: [jsxs(chakra.button, { ...(hasLog
                    ? {
                        ref: triggerRef,
                        type: "button",
                        "aria-expanded": expanded,
                        "aria-controls": contentId,
                        onClick: toggle,
                    }
                    : { as: "div", "data-static": "" }), id: triggerId, "data-group": true, __css: styles.trigger, children: [jsx(chakra.span, { __css: styles.summary, children: jsx(AnimatePresence, { mode: "popLayout", initial: false, children: jsx(MotionSpan, { initial: { opacity: 0 }, animate: { y: 0, opacity: 1 }, exit: { y: -10, opacity: 0 }, transition: labelTransition, __css: styles.summaryLabel, children: working ? (renderWorkingStatus ? (renderWorkingStatus({ label: liveLabel })) : (jsx(chakra.span, { __css: styles.shimmerLabel, children: liveLabel }))) : renderCompletedStatus ? (renderCompletedStatus({ summary: completedSummary })) : (completedSummary) }, labelKey) }) }), hasLog && (jsx(MotionSpan, { "aria-hidden": true, "data-peek": working && !expanded ? "" : undefined, animate: { rotate: expanded ? 180 : 0 }, transition: { duration: 0 }, __css: styles.chevron, children: jsx(Box, { as: ChevronDownIcon }) }))] }), jsx(VisuallyHidden, { "aria-live": "polite", children: working ? genericLabel : completedSummary }), hasLog && (jsx(chakra.div, { id: contentId, role: "region", "aria-labelledby": triggerId, "aria-hidden": !expanded, __css: styles.disclosure, height: expanded ? `${viewportHeight}px` : 0, 
                // Collapsed content leaves the tab order, not just the viewport.
                visibility: expanded ? undefined : "hidden", children: jsx(chakra.div, { ref: viewportRef, ...(capped && expanded && !working ? { tabIndex: 0 } : {}), __css: styles.viewport, 
                    // Measurement-driven, so it can't live in the theme.
                    sx: {
                        height: `${viewportHeight}px`,
                        maskImage,
                        WebkitMaskImage: maskImage,
                        overflowY: capped && expanded && !working ? "auto" : "hidden",
                    }, children: jsx(MotionBox, { ref: contentRef, role: "list", initial: false, animate: { y: streamOffset }, 
                        // The glide is only for the live stream. Releasing the pin on
                        // completion snaps, so a capped log never rewinds to its oldest
                        // rows on its way to collapsing.
                        transition: working ? springLayout : { duration: 0 }, __css: styles.content, children: jsx(AnimatePresence, { mode: "popLayout", initial: working, children: items.map((item) => (jsx(MotionBox, { layout: "position", role: "listitem", initial: itemEnter, animate: itemVisible, exit: itemExit, transition: itemTransition, children: jsx(ActivityRow, { item: item }) }, item.id))) }) }) }) }))] }));
});
AgentActivity.displayName = "AgentActivity";

function ButtonGroup({ size = "sm", ...props }) {
    return jsx(Box$1, { display: "flex", gap: size === "sm" ? 2 : 4, ...props });
}

const SkeletonContext = createContext(false);

const IconButton = forwardRef$1(function IconButton_({ isLoading = false, icon, size = "md", variant = "tertiary", shape = "default", ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    const { h } = useStyleConfig("Button", { size });
    let iconSize = 5;
    if (size === "2xs") {
        iconSize = 3;
    }
    if (size === "xs") {
        iconSize = 3.5;
    }
    if (size === "sm") {
        iconSize = 4;
    }
    if (size === "lg") {
        iconSize = 6;
    }
    let colorScheme;
    let chakraVariant;
    if (variant === "primary") {
        chakraVariant = "iconButtonPrimary";
        colorScheme = "teal";
    }
    if (variant === "secondary") {
        chakraVariant = "outline";
        colorScheme = "clear";
    }
    if (variant === "tertiary") {
        chakraVariant = "ghost";
        colorScheme = "clear";
    }
    if (variant === "danger") {
        chakraVariant = "ghost";
        colorScheme = "danger";
    }
    return (jsx(IconButton$1, { ref: ref, isLoading: isLoading, isDisabled: skeleton, icon: jsx(Icon, { as: icon, boxSize: iconSize }), colorScheme: colorScheme, variant: chakraVariant, width: Number(h), height: Number(h), minWidth: "0", flexShrink: 0, borderRadius: shape === "circle" ? "full" : undefined, ...props }));
});
IconButton.displayName = "IconButton";

const skeletonPulse = keyframes `
  from { background-color: var(--chakra-colors-gray-50); }
  to { background-color: var(--chakra-colors-gray-200); }
`;
const skeletonAnimationStyles = {
    backgroundColor: "var(--chakra-colors-gray-100)",
    animation: `${skeletonPulse} 0.8s ease-in-out infinite alternate`,
};

/**
 * @source [figma](https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Styles-2?node-id=7495-1951&t=3tf6DG33KXUlIWWz-1)
 */
const RADIUS_THRESHOLDS = [
    [64, "2xl"],
    [40, "xl"],
    [24, "lg"],
    [20, "md"],
    [16, "sm"],
    [8, "xs"],
];
/**
 * Determine the radius based on the height of an element.
 * @param height - The height of the element in pixels.
 * @returns The radius of the element, in theme units. See `theme/foundations/radius.ts` for available radii.
 */
function getRadius(height) {
    for (const [minHeight, radius] of RADIUS_THRESHOLDS) {
        if (height >= minHeight) {
            return radius;
        }
    }
    // Default case: return the smallest radius.
    return "xs";
}

const Span = chakra("span");
const skeletonHeight = 0.55;
const skeletonHeightPercentage = `${skeletonHeight * 100}%`;
function SkeletonText() {
    const root = useRef(null);
    const [lines, setLines] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);
    const [radius, setRadius] = useState("sm");
    useEffect(() => {
        const container = root.current?.parentElement;
        if (!container) {
            return;
        }
        const containerHeight = container.offsetHeight;
        // biome-ignore lint/plugin/no-number-parse-int-float: parsing a CSS length; dropping the unit is the point
        const lineHeight = Number.parseFloat(globalThis.getComputedStyle(container).lineHeight);
        const radius = getRadius(lineHeight * skeletonHeight);
        const lines = Math.round(containerHeight / lineHeight);
        setLines(lines);
        setLineHeight(lineHeight);
        setRadius(radius);
    }, []);
    return (jsx(Span, { ref: root, display: "flex", flexDirection: "column", position: "absolute", inset: 0, children: Array.from({ length: lines }).map((_line, index) => (jsx(Span
        // biome-ignore lint/suspicious/noArrayIndexKey: placeholder lines have no identity beyond their position
        , { position: "absolute", top: `${index * lineHeight}px`, width: "100%", height: `${lineHeight}px`, display: "flex", alignItems: "center", children: jsx(Span, { display: "block", width: "100%", height: skeletonHeightPercentage, borderRadius: radius, sx: skeletonAnimationStyles }) }, index))) }));
}

const shimmerAnimation = keyframes `
  from { background-position: 100% center; }
  to { background-position: -100% center; }
`;
/**
 * Derives the 900 shade from a color string like "purple.500" → "purple.900"
 * Returns undefined if the color doesn't follow the "name.shade" pattern.
 */
function deriveShimmerColor(color) {
    const match = /^([a-z]+)\.(\d+)$/iu.exec(color);
    if (match) {
        return `${match[1]}.900`;
    }
    return undefined;
}
const Text = forwardRef(function Text_({ isTruncated = false, size = "md", children, color: customColor, highlight, variant, shimmer = false, shimmerColor, ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    // This code supports 3 use cases:
    //  1. Default color is used for this `Text`
    //  2. Color is inherited from the parent component via `--hightouch-text-color` CSS variable
    //  3. Custom `color` is passed to this `Text` and inherited color is ignored
    const defaultColor = cssVar("chakra-colors-text-primary").reference;
    const inheritedColor = cssVar("hightouch-text-color", defaultColor).reference;
    const color = customColor ?? inheritedColor;
    const theme = useTheme();
    // Build shimmer styles when enabled
    const baseColorCss = String(getCSSVar(theme, "colors", color) ?? "");
    const resolvedShimmerColor = shimmerColor ?? (customColor ? deriveShimmerColor(customColor) : undefined);
    const shimmerColorCss = resolvedShimmerColor
        ? String(getCSSVar(theme, "colors", resolvedShimmerColor) ?? "")
        : "";
    const shimmerStyles = shimmer && shimmerColorCss
        ? {
            background: `linear-gradient(90deg, ${baseColorCss} 40%, ${shimmerColorCss} 50%, ${baseColorCss} 60%)`,
            backgroundSize: "200% auto",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent",
            animation: `${shimmerAnimation} 2000ms linear infinite`,
        }
        : undefined;
    return (jsxs(Text$1, { ref: ref, as: "span", size: size, position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : shimmerStyles ? undefined : color, bg: highlight ? `${highlight}.backgroundHover` : undefined, variant: variant, 
        // If custom color is passed to this `Text`, define `--hightouch-text-color` CSS variable
        // so that nested `Text` components will inherit this custom color too
        sx: {
            ...(customColor
                ? {
                    [cssVar("hightouch-text-color").variable]: getCSSVar(theme, "colors", customColor),
                }
                : undefined),
            ...shimmerStyles,
        }, ...(isTruncated
            ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }
            : {}), ...props, children: [children, skeleton && jsx(SkeletonText, {})] }));
});
Text.displayName = "Text";

const IconMap$1 = {
    realtime: LightningBoltIcon,
    audiences: AudienceIcon,
    relationship: FrameStackIcon,
    event: ClickIcon,
    trait: TraitIcon,
    journey: JourneyIcon,
};
function Alert({ variant = "inline", icon: iconKey, type, title, message, actions, contextMessage, onDismiss, ...props }) {
    let color = "teal";
    let icon = InformationIcon;
    if (type === "info") {
        color = "teal";
        icon = InformationIcon;
    }
    if (type === "subtle") {
        color = "gray";
        icon = InformationIcon;
    }
    if (type === "success") {
        color = "green";
        icon = SuccessIcon;
    }
    if (type === "warning") {
        color = "yellow";
        icon = WarningIcon;
    }
    if (type === "error") {
        color = "red";
        icon = ErrorIcon;
    }
    if (type === "upsell") {
        color = "purple";
        icon = InformationIcon;
    }
    if (iconKey) {
        icon = IconMap$1[iconKey];
    }
    const styles = useMultiStyleConfig("Alert", {
        variant,
        colorScheme: color,
    });
    return (jsxs(chakra.div, { __css: styles.container, ...props, children: [jsx(chakra.div, { __css: styles.iconContainer, children: jsx(Icon, { as: icon }) }), jsxs(chakra.div, { __css: styles.contentContainer, children: [jsxs(chakra.div, { __css: styles.titleContainer, children: [jsx(chakra.div, { __css: styles.title, flex: contextMessage ? undefined : 1, children: title }), contextMessage && jsx(Text, { size: "sm", children: contextMessage })] }), message && (jsx(chakra.span, { as: Text, __css: styles.message, children: message })), actions && (jsx(chakra.div, { __css: styles.buttonGroup, children: jsx(ButtonGroup, { children: actions }) }))] }), onDismiss && (jsx(chakra.div, { __css: styles.closeButton, children: jsx(IconButton, { "aria-label": "Dismiss alert", size: "sm", variant: type === "error" ? "danger" : "tertiary", icon: CloseIcon, onClick: onDismiss }) }))] }));
}

const spin = keyframes `
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(360deg)
  }
`;
const elastic = keyframes `
  0% { 
    stroke-dashoffset: 380;
  }

  50% {
    stroke-dashoffset: 215;
  }

  100% {
    stroke-dashoffset: 380;
  }
`;
const createSquareKeyframes = (scale) => ({
    largeSquareCycle: keyframes `
    0% {
      top: 0;
      left: ${9 * scale}px;
    }
    
    25% {
      top: ${9 * scale}px;
      left: ${9 * scale}px;
    }
    
    50% {
      top: ${9 * scale}px;
      left: 0;
    }
    
    75% {
      top: 0;
      left: 0;
    }
    
    100% {
      top: 0;
      left: ${9 * scale}px;
    }
  `,
    smallSquareCycle: keyframes `
    0% {
      top: ${15 * scale}px;
      left: 0;
    }
    
    25% {
      top: 0;
      left: 0;
    }
    
    50% {
      top: 0;
      left: ${15 * scale}px;
    }
    
    75% {
      top: ${15 * scale}px;
      left: ${15 * scale}px;
    }
    
    100% {
      top: ${15 * scale}px;
      left: 0;
    }
  `,
});
const circularSizes = {
    xs: 3,
    sm: 4,
    md: 6,
    lg: 12,
};
const squareSizes = {
    xs: "3", // 12px
    sm: "4", // 16px
    md: "6", // 24px
    lg: "12", // 48px
};
const speedBaselineMs = {
    slow: 2800,
    normal: 2000,
    fast: 1200,
};
function Spinner({ size = "md", speed = "normal", variant = "default", color = "primary.base", boxSize, ...props }) {
    if (variant === "squares") {
        // Calculate scaling factor based on size (md is 24px, which is our base design)
        const baseSize = 24; // MD size (6 in theme = 24px)
        const currentSizePx = Number(squareSizes[size]) * 4; // Convert theme size to pixels
        const scale = currentSizePx / baseSize;
        // Create scaled keyframes
        const { largeSquareCycle, smallSquareCycle } = createSquareKeyframes(scale);
        // Scale the square dimensions proportionally (original design was 15px and 9px for 24px container)
        const largeSquareSize = Number(15 * scale);
        const smallSquareSize = Number(9 * scale);
        const borderRadius = Number(1) * scale;
        return (jsxs(Box$1, { position: "relative", boxSize: boxSize ?? squareSizes[size], "data-testid": "spinner-squares", flexShrink: 0, display: "inline-block", ...props, children: [jsx(Box$1, { position: "absolute", backgroundColor: "gray.300", width: `${largeSquareSize}px`, height: `${largeSquareSize}px`, borderRadius: `${borderRadius}px`, animation: `${largeSquareCycle}
          ${speedBaselineMs[speed] * 0.8}ms ease-in-out infinite` }), jsx(Box$1, { position: "absolute", backgroundColor: "gray.300", width: `${smallSquareSize}px`, height: `${smallSquareSize}px`, borderRadius: `${borderRadius}px`, animation: `${smallSquareCycle} 
          ${speedBaselineMs[speed] * 0.8}ms ease-in-out infinite` })] }));
    }
    return (jsxs(Box$1, { as: "svg", viewBox: "0 0 100 100", boxSize: boxSize ?? circularSizes[size], animation: `${spin} ${speedBaselineMs[speed] * 0.325}ms linear infinite`, "data-testid": "spinner", flexShrink: 0, ...props, children: [jsx(Box$1, { as: "circle", fill: "none", stroke: "gray.200", strokeWidth: "14", cx: "50", cy: "50", r: "43" }), jsx(Box$1, { as: "circle", fill: "none", stroke: color, strokeWidth: "14", strokeLinecap: "butt", strokeDasharray: "430", strokeDashoffset: "360", cx: "50", cy: "50", r: "43", animation: `${elastic} ${speedBaselineMs[speed]}ms ease-in-out infinite` })] }));
}

const Badge = forwardRef$1(function Badge_({ variant = "subtle", size = "md", shape, isPending, progress, svgIcon, iconSrc, iconColor, children, rightActionProps, rightIcon: RightIcon, "aria-label": ariaLabel, ...props }, ref) {
    const isCircle = shape === "circle";
    const hasProgress = progress !== undefined;
    // Role="img" makes the label valid on the span; skipped for custom `as`
    // elements (which carry their own role) and when a right action would be
    // hidden from assistive tech by the img role
    const role = ariaLabel && !props.as && !rightActionProps ? "img" : undefined;
    const hasRightAction = !isCircle && Boolean(rightActionProps);
    const label = (jsxs(Fragment, { children: [progress === "indeterminate" && (jsx(Spinner, { size: size === "sm" ? "xs" : "sm", ...(isCircle && { boxSize: "1em" }), color: "currentColor" })), typeof progress === "number" && (jsx(CircularProgress, { "aria-hidden": true, value: Math.max(0, Math.min(100, progress)), size: isCircle ? "1em" : size === "sm" ? "3" : "4", color: "currentColor", thickness: "14px" })), !hasProgress && svgIcon && (jsx(Icon, { as: svgIcon, boxSize: isCircle ? "1em" : 4, color: iconColor ?? "inherit" })), !hasProgress && iconSrc && (jsx(Image, { flex: "none", src: iconSrc, boxSize: isCircle ? "1em" : 4, objectFit: "contain", alt: "" })), !isCircle && jsx(Text, { isTruncated: true, children: children })] }));
    return (jsxs(Badge$1, { ref: ref, "aria-label": ariaLabel, role: role, variant: variant, size: size, "data-shape": shape, "data-pending": isPending ? "true" : undefined, "data-progress": hasProgress ? "true" : undefined, "data-has-right-action": hasRightAction ? "true" : undefined, "data-has-image-accessory": iconSrc || svgIcon || hasProgress ? "true" : undefined, ...props, children: [hasRightAction ? jsx("span", { className: "badgeLabel", children: label }) : label, hasRightAction && rightActionProps ? (jsx(IconButton, { size: size === "sm" ? "2xs" : "xs", borderRadius: "full", background: "none", _active: { background: "none" }, ...rightActionProps, onClick: (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    rightActionProps.onClick?.(event);
                } })) : !isCircle && RightIcon ? (jsx(RightIcon, { className: "rightIcon" })) : null] }));
});
Badge.displayName = "Badge";
const BadgeButton = forwardRef$1(function BadgeButton_(props, ref) {
    return jsx(Badge, { ref: ref, as: Button$1, ...props });
});
BadgeButton.displayName = "BadgeButton";

function isResolvedStatus(status) {
    return status !== "pending" && status !== "submitting";
}
const swapFadeTransition = {
    duration: motionDurations.fast,
    ease: motionEasings.easeOutQuad,
};
/**
 * Shared by the card's height and its content slide, so they move as one.
 * No theme token covers springs.
 */
const cardSpring = {
    type: "spring",
    duration: 0.5,
    bounce: 0,
};
// Pass the direction as `custom` on AnimatePresence too, so a leaving element reads the current one.
// The exit fades fast, so it is gone before the footer rises over it.
const slideSwapVariants = {
    initial: (direction) => ({
        opacity: 0,
        x: `${110 * direction}%`,
    }),
    active: { opacity: 1, x: "0%", transition: cardSpring },
    exit: (direction) => ({
        opacity: 0,
        x: `${ -110 * direction}%`,
        transition: { x: cardSpring, opacity: swapFadeTransition },
    }),
};

const Row = forwardRef(function Row_({ style, surface, bg, bgColor, background, backgroundColor, ...props }, ref) {
    const mergedStyle = useSurfaceStyle({
        surface,
        bg,
        bgColor,
        background,
        backgroundColor,
        style,
    });
    return (jsx(Flex, { ref: ref, bg: bg, bgColor: bgColor, background: background, backgroundColor: backgroundColor, ...props, style: mergedStyle }));
});
Row.displayName = "Row";

/**
 * Truncates its text to a single line and reveals the full value in a tooltip
 * only when it actually overflows. Pass `forceTooltip` to always show it.
 */
function TextWithTooltip({ children, isDisabled = false, forceTooltip = false, keyboardShortcut, message, placement, sx, ...props }) {
    const { contentFits, ref } = useContentFits();
    // String() on an element/array child yields "[object Object]"; only string/number get a default.
    const resolvedMessage = message ??
        (typeof children === "string" || typeof children === "number"
            ? children
            : undefined);
    return (jsx(Row, { display: "flex", alignItems: "center", overflow: "hidden", sx: { ">span": { width: "100%", whiteSpace: "nowrap", ...sx } }, children: jsx(Tooltip, { message: resolvedMessage ?? "", isDisabled: isDisabled ||
                resolvedMessage === undefined ||
                (!forceTooltip && contentFits), keyboardShortcut: keyboardShortcut, placement: placement, children: jsx(Box, { minWidth: 0, overflow: "hidden", width: "100%", children: jsx(Text, { ref: ref, ...props, isTruncated: true, display: "block", children: children }) }) }) }));
}

const statusLabels = {
    pending: "Input required",
    submitting: "Submitting",
    approved: "Approved",
    rejected: "Rejected",
    "changes-requested": "Changes requested",
    answered: "Answered",
};
const statusBadgeVariants = {
    pending: "warning",
    submitting: "info",
    approved: "success",
    rejected: "error",
    "changes-requested": "warning",
    answered: "success",
};
const statusIcons = {
    pending: QuestionIcon,
    approved: CheckIcon,
    rejected: CloseIcon,
    "changes-requested": EditIcon,
    answered: CheckIcon,
};
const fadeMotion = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: swapFadeTransition },
    exit: { opacity: 0, transition: swapFadeTransition },
};
// Holds until the growing card has room for the footer, so its top edge never peeks past the clip.
const footerMotion = {
    ...fadeMotion,
    animate: {
        opacity: 1,
        transition: { ...swapFadeTransition, delay: cardSpring.duration * 0.6 },
    },
};
const fadeSwapMotion = {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1, transition: swapFadeTransition },
    exit: { opacity: 0, scale: 0.95, transition: swapFadeTransition },
};
const AgentCard = forwardRef$1(function AgentCard_({ label, title, status, isDisabled, headerEnd, subtext, onDismiss, children, footer, ...props }, ref) {
    const styles = useMultiStyleConfig("AgentCard");
    const isResolved = isResolvedStatus(status);
    // A caller's `cond && <node>` passes `false`, and an empty body would still take the gap.
    const hasChildren = Children.toArray(children).length > 0;
    // Height is not a transform, so the global MotionConfig can't drop it for reduced motion.
    const shouldReduceMotion = useReducedMotion();
    const innerRef = useRef(null);
    const [height, setHeight] = useState("auto");
    useEffect(() => {
        const inner = innerRef.current;
        if (!inner) {
            return;
        }
        const observer = new ResizeObserver(() => {
            setHeight(inner.offsetHeight);
        });
        observer.observe(inner);
        return () => {
            observer.disconnect();
        };
    }, []);
    // A footer action marked `data-resolves` unmounts with the footer, so the card catches the focus it drops.
    const rootRef = useRef(null);
    const mergedRef = useMergeRefs(ref, rootRef);
    const isFocusArmed = useRef(false);
    useEffect(() => {
        if (status === "pending") {
            isFocusArmed.current = false;
        }
    }, [status]);
    useEffect(() => {
        if (!isResolved || !isFocusArmed.current) {
            return;
        }
        isFocusArmed.current = false;
        const active = document.activeElement;
        const root = rootRef.current;
        if (!active || active === document.body || root?.contains(active)) {
            root?.focus();
        }
    }, [isResolved]);
    const handleBlur = (event) => {
        const next = event.relatedTarget;
        if (next instanceof Node && !event.currentTarget.contains(next)) {
            isFocusArmed.current = false;
        }
    };
    const handleFooterClickCapture = (event) => {
        if (event.target instanceof Element &&
            event.target.closest("[data-resolves]")) {
            isFocusArmed.current = true;
        }
    };
    return (jsx(MotionBox, { ref: mergedRef, role: "group", "aria-label": label, tabIndex: -1, onBlur: handleBlur, __css: styles["container"], animate: {
            height,
            transition: shouldReduceMotion ? { duration: 0 } : cardSpring,
        }, ...props, children: jsxs(chakra.div, { ref: innerRef, __css: styles["inner"], children: [jsxs(chakra.div, { __css: styles["header"], children: [jsxs(chakra.div, { __css: styles["titleRow"], children: [jsx(AnimatePresence, { initial: false, mode: "popLayout", children: jsx(MotionBox, { __css: styles["swap"], ...fadeSwapMotion, children: status === "submitting" ? (jsx(chakra.div, { __css: styles["statusIcon"], children: jsx(Spinner, { size: "sm", color: "currentColor" }) })) : (jsx(Box, { as: statusIcons[status], "aria-hidden": true, "data-status": status, __css: styles["statusIcon"] })) }, status) }), jsxs(chakra.div, { __css: styles["heading"], children: [jsx(chakra.div, { __css: styles["title"], children: jsx(AnimatePresence, { initial: false, mode: "popLayout", children: jsx(MotionBox, { __css: styles["titleSwap"], ...fadeMotion, children: jsx(TextWithTooltip, { fontWeight: "medium", children: title }) }, title) }) }), jsx(AnimatePresence, { initial: false, mode: "popLayout", children: jsx(MotionBox, { __css: styles["swap"], ...fadeSwapMotion, children: headerEnd ?? (jsx(Badge, { size: "sm", variant: statusBadgeVariants[status], children: statusLabels[status] })) }, headerEnd ? "header-end" : status) })] }), onDismiss && (jsx(IconButton, { "aria-label": "Dismiss", icon: CloseIcon, size: "sm", variant: "tertiary", isDisabled: isDisabled || status === "submitting", onClick: onDismiss }))] }), jsx(chakra.div, { role: "status", __css: styles["status"], children: jsx(AnimatePresence, { initial: false, mode: "popLayout", children: subtext != null && (jsx(MotionBox, { ...fadeMotion, children: jsx(chakra.div, { __css: styles["subtext"], children: jsx(Text, { color: "text.secondary", children: subtext }) }) }, isResolved ? "result" : "description")) }) })] }), jsxs(AnimatePresence, { initial: false, mode: "popLayout", children: [hasChildren && (jsx(MotionBox, { __css: styles["body"], ...fadeMotion, children: children }, "body")), footer != null && (jsx(MotionBox, { ...(shouldReduceMotion ? fadeMotion : footerMotion), 
                            // Follows the card's height instead of jumping to its new spot.
                            layout: "position", transition: { layout: cardSpring }, onClickCapture: handleFooterClickCapture, children: jsx(chakra.div, { __css: styles["footer"], children: jsx(chakra.div, { __css: styles["actions"], children: footer }) }) }, "footer"))] })] }) }));
});
AgentCard.displayName = "AgentCard";
/** Body content aligned with the title, for use inside a card's own body. */
function AgentCardContent({ children }) {
    const styles = useMultiStyleConfig("AgentCard");
    return jsx(chakra.div, { __css: styles["content"], children: children });
}

const LinkTextButton = forwardRef$1(function LinkTextButton_({ children, isLoading = false, isDisabled = false, size = "md", ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    const styles = useStyleConfig("LinkTextButton", { size });
    return (jsx(Button$1, { ref: ref, __css: styles, isLoading: isLoading, isDisabled: isLoading || isDisabled || skeleton, ...props, children: children }));
});
LinkTextButton.displayName = "LinkTextButton";
// biome-ignore lint/style/useComponentExportOnlyModules: sizing helper ships alongside the component
function getLinkTextSize(size) {
    if (size === "sm" || size === "md" || size === "lg") {
        return size;
    }
    return "md";
}

const Button = forwardRef$1(function Button_({ children, isLoading = false, isDisabled = false, isJustified = false, variant = "secondary", size = "md", shape = "default", icon, directionIcon, directionIconSize, imageUrl, ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    let colorScheme;
    let chakraVariant;
    if (variant === "link") {
        const linkTextSize = getLinkTextSize(size);
        return (jsx(LinkTextButton, { ref: ref, size: linkTextSize, isLoading: isLoading, isDisabled: isLoading || isDisabled || skeleton, ...props, children: children }));
    }
    if (variant === "primary") {
        chakraVariant = "solid";
        colorScheme = "teal";
    }
    if (variant === "secondary") {
        chakraVariant = "outline";
        colorScheme = "clear";
    }
    if (variant === "tertiary") {
        chakraVariant = "ghost";
        colorScheme = "clear";
    }
    if (variant === "danger") {
        chakraVariant = "solid";
        colorScheme = "danger";
    }
    if (variant === "warning") {
        chakraVariant = "outline";
        colorScheme = "danger";
    }
    let iconSize = 5;
    if (size === "sm") {
        iconSize = 4;
    }
    if (size === "lg" || size === "xl") {
        iconSize = 6;
    }
    const iconSpacing = size === "sm" || size === "md" ? 1.5 : 2;
    let leftIcon;
    if (icon) {
        leftIcon = jsx(Icon, { as: icon, boxSize: iconSize });
    }
    if (imageUrl) {
        leftIcon = (jsx(Box$1, { display: "inline-block", boxSize: iconSize, children: jsx(Image, { src: imageUrl, alt: "", maxWidth: "100%", maxHeight: "100%" }) }));
    }
    return (jsx(Button$1, { ref: ref, isLoading: isLoading, isDisabled: isLoading || isDisabled || skeleton, colorScheme: colorScheme, variant: chakraVariant, iconSpacing: iconSpacing, leftIcon: leftIcon, rightIcon: directionIcon ? (jsx(Icon, { as: directionIcon, boxSize: directionIconSize ?? iconSize })) : undefined, width: isJustified ? "100%" : undefined, size: size, borderRadius: shape === "circle" ? "full" : undefined, ...props, children: children }));
});
Button.displayName = "Button";

const changeIcons = {
    add: PlusIcon,
    change: ChangeIcon,
    remove: SubtractIcon,
};
const changeLabels = {
    add: "Added",
    change: "Changed",
    remove: "Removed",
};
// With no press to remember, the spinner goes on the most decisive action offered.
function primaryAction({ onApprove, onRequestChanges, }) {
    if (onApprove) {
        return "approve";
    }
    if (onRequestChanges) {
        return "request-changes";
    }
    return "reject";
}
function Changes({ changes }) {
    const styles = useMultiStyleConfig("ApprovalCard");
    return (
    // WebKit drops list semantics once list-style is none; the role restores them.
    jsx(chakra.ul, { role: "list", __css: styles["changes"], children: changes.map((change, index) => {
            const MarkerIcon = changeIcons[change.kind];
            return (
            // biome-ignore lint/suspicious/noArrayIndexKey: Rows are plain data with no id, and two rows can be identical.
            jsxs(chakra.li, { __css: styles["change"], children: [jsx(chakra.span, { __css: styles["marker"], "data-kind": change.kind, children: jsx(MarkerIcon, { "aria-hidden": true }) }), jsx(VisuallyHidden, { children: changeLabels[change.kind] }), jsxs(chakra.span, { __css: styles["item"], children: [jsxs(chakra.span, { __css: styles["chip"], children: [change.icon && (jsx(chakra.span, { "aria-hidden": true, __css: styles["chipIcon"], color: change.iconColor, children: jsx(change.icon, {}) })), jsx(chakra.span, { __css: styles["chipLabel"], children: change.label })] }), change.detail && (jsx(Text, { size: "sm", color: "text.secondary", children: change.detail }))] })] }, index));
        }) }));
}
const ApprovalCard = forwardRef$1(function ApprovalCard_({ title = "Approval required", description, changes, children, status = "pending", result, isDisabled = false, onApprove, onReject, onRequestChanges, onDismiss, approveLabel = "Approve", rejectLabel = "Reject", requestChangesLabel = "Request changes", ...props }, ref) {
    const isSubmitting = status === "submitting";
    const isResolved = isResolvedStatus(status);
    const isLocked = isDisabled || isSubmitting;
    const hasChanges = changes !== undefined && changes.length > 0;
    // A caller's `cond && <node>` passes `false`, which is no content.
    const hasBody = hasChanges || Children.toArray(children).length > 0;
    const hasActions = Boolean(onReject || onRequestChanges || onApprove);
    // The parent only reports `submitting`, so the card remembers which button to spin.
    const [pressedAction, setPressedAction] = useState();
    useEffect(() => {
        if (status !== "submitting") {
            setPressedAction(undefined);
        }
    }, [status]);
    const actingAction = isSubmitting
        ? (pressedAction ?? primaryAction({ onApprove, onRequestChanges }))
        : undefined;
    const pressAction = (action, callback) => {
        setPressedAction(action);
        callback();
    };
    return (jsx(AgentCard, { ref: ref, label: title, title: title, status: status, isDisabled: isDisabled, subtext: isResolved ? result : description, onDismiss: onDismiss, footer: !isResolved && hasActions ? (
        // Every action resolves the card, so each hands its focus to the card.
        jsxs(Fragment, { children: [onReject && (jsx(Button, { "data-resolves": true, variant: "tertiary", isLoading: actingAction === "reject", isDisabled: isLocked, onClick: () => pressAction("reject", onReject), children: rejectLabel })), onRequestChanges && (jsx(Button, { "data-resolves": true, variant: "secondary", isLoading: actingAction === "request-changes", isDisabled: isLocked, onClick: () => pressAction("request-changes", onRequestChanges), children: requestChangesLabel })), onApprove && (jsx(Button, { "data-resolves": true, variant: "primary", isLoading: actingAction === "approve", isDisabled: isLocked, onClick: () => pressAction("approve", onApprove), children: approveLabel }))] })) : undefined, ...props, children: !isResolved && hasBody && (jsxs(AgentCardContent, { children: [hasChanges && jsx(Changes, { changes: changes }), children] })) }));
});
ApprovalCard.displayName = "ApprovalCard";

/** Focuses a control, with a text area's caret after its text, as a click at the end would leave it. */
function focusControl(element) {
    element?.focus();
    if (element instanceof HTMLTextAreaElement) {
        element.setSelectionRange(element.value.length, element.value.length);
    }
}

const undefinedValue = "___UNDEFINED___";
/**
 * Encode a value to a string.
 */
const encode = (value) => {
    return JSON.stringify(value === undefined ? undefinedValue : value);
};
/**
 * Decode a string to a value.
 */
const decode = (value) => {
    const parsedValue = JSON.parse(value);
    return parsedValue === undefinedValue ? undefined : parsedValue;
};

function Textarea({ resize = "vertical", width = "xs", ...props }) {
    return (jsx(Textarea$1, { focusBorderColor: "teal", resize: resize, width: width, ...props }));
}

function OptionRow({ option, isMultiple, isChecked, rootProps, inputProps, rowProps, }) {
    const styles = useMultiStyleConfig("AskUserCardOption");
    return (jsxs(chakra.label, { __css: styles["root"], ...rootProps, children: [jsx(chakra.input, { ...inputProps }), jsxs(chakra.div, { __css: styles["row"], ...rowProps, children: [jsxs(chakra.div, { __css: styles["content"], children: [jsx(Text, { children: option.label }), option.description && (jsx(Text, { size: "sm", color: "text.tertiary", children: option.description }))] }), jsx(OptionCheck, { styles: styles, isChecked: isChecked, isMultiple: isMultiple })] })] }));
}
function OptionCheck({ styles, isChecked, isMultiple, }) {
    return (jsx(chakra.div, { "aria-hidden": true, __css: styles["check"], "data-checked": isChecked ? "" : undefined, "data-multiple": isMultiple ? "" : undefined, children: isChecked && jsx(CheckIcon, {}) }));
}
// Both rows drop the hook's aria-hidden, because the styled element holds the visible label.
/** A row inside a `RadioGroup`, which supplies its name, value and change. */
function RadioOptionRow({ option }) {
    const group = useRadioGroupContext();
    const value = encode(option.value);
    const { getInputProps, getRadioProps, getRootProps, state } = useRadio({
        isChecked: group.value === value,
        isDisabled: option.isDisabled || group.isDisabled,
        name: group.name,
        value,
        onChange: group.onChange,
    });
    const { "aria-hidden": _hidden, ...rowProps } = getRadioProps();
    return (jsx(OptionRow, { option: option, isChecked: state.isChecked, rootProps: getRootProps(), inputProps: getInputProps(), rowProps: rowProps }));
}
function CheckboxOptionRow({ option, isChecked, isDisabled, onChange, }) {
    const { getInputProps, getCheckboxProps, getRootProps, state } = useCheckbox({
        isChecked,
        isDisabled: option.isDisabled || isDisabled,
        onChange,
    });
    const { "aria-hidden": _hidden, ...rowProps } = getCheckboxProps();
    return (jsx(OptionRow, { option: option, isMultiple: true, isChecked: state.isChecked, rootProps: getRootProps(), inputProps: getInputProps(), rowProps: rowProps }));
}
/** A row holding a text area, for an answer of the user's own. */
function CustomOptionRow({ label, placeholder, value, isChecked, isDisabled, onChange, onPress, onSelect, }) {
    const styles = useMultiStyleConfig("AskUserCardOption");
    const hasText = Boolean(value.trim());
    const selectedId = useId();
    // A touch selects on tap, so a scroll that starts on the row moves nothing.
    const isTouchPress = useRef(false);
    const pressRow = (target) => {
        onPress();
        // The reselect control handles its own press so focus can follow it.
        if (target instanceof Element && target.closest("button")) {
            return;
        }
        // An empty row has nothing to choose yet; typing takes the answer once text arrives.
        if (hasText && !isChecked && !isDisabled) {
            onSelect?.();
        }
    };
    const handleRowPointerDown = (event) => {
        isTouchPress.current = event.pointerType === "touch";
        // A Ctrl+click opens the macOS context menu, so it chooses nothing.
        if (isTouchPress.current || event.button !== 0 || event.ctrlKey) {
            return;
        }
        // A press on the row's padding focuses the text area, and preventDefault stops the browser blurring it.
        if (event.target === event.currentTarget) {
            event.preventDefault();
            focusControl(event.currentTarget.querySelector("textarea"));
        }
        pressRow(event.target);
    };
    const handleRowClick = (event) => {
        if (!isTouchPress.current) {
            return;
        }
        isTouchPress.current = false;
        if (event.target === event.currentTarget) {
            focusControl(event.currentTarget.querySelector("textarea"));
        }
        pressRow(event.target);
    };
    const handleReselectClick = (event) => {
        onSelect?.();
        // The control hides once chosen, so focus moves to the text area.
        focusControl(event.currentTarget.parentElement?.querySelector("textarea"));
    };
    return (jsxs(chakra.div, { __css: styles["customRow"], "data-checked": isChecked ? "" : undefined, "data-disabled": isDisabled ? "" : undefined, "data-reselect": onSelect ? "" : undefined, 
        // Pointer only: tabbing through the field must not move the answer.
        onPointerDown: handleRowPointerDown, onClick: handleRowClick, children: [jsx(Textarea, { "aria-label": label, "aria-describedby": onSelect && isChecked ? selectedId : undefined, rows: 2, resize: "none", width: "100%", placeholder: placeholder, isDisabled: isDisabled, value: value, onChange: (event) => {
                    onChange(event.target.value);
                } }), onSelect && isChecked && (
            // Hidden, so a screen reader reads it only as the description.
            jsx(chakra.span, { id: selectedId, hidden: true, children: "Selected answer" })), onSelect && (jsx(chakra.button, { type: "button", 
                // Only a way back: typing already selects it.
                hidden: !hasText || isChecked || isDisabled, "aria-label": "Use my own answer", __css: styles["customCheck"], onClick: handleReselectClick, children: jsx(OptionCheck, { styles: styles, isChecked: false }) }))] }));
}

function RadioGroup({ isDisabled, children, orientation: defaultOrientation = "horizontal", value, onChange, ...props }) {
    let hasDescriptions = false;
    for (const child of Children.toArray(children)) {
        if (isValidElement(child) &&
            "description" in child.props &&
            child.props.description) {
            hasDescriptions = true;
            break;
        }
    }
    let orientation = defaultOrientation === "horizontal" ? "row" : "column";
    // Switch orientation to vertical if there are more than 3 radios or at least one has a description
    if (hasDescriptions || Children.count(children) > 3) {
        orientation = "column";
    }
    const handleChange = (value) => {
        onChange(decode(value));
    };
    return (jsx(RadioGroup$1, { isDisabled: isDisabled, value: encode(value), onChange: handleChange, ...props, children: jsx(Stack, { align: "start", direction: orientation, spacing: orientation === "column" && !hasDescriptions ? 2 : 4, children: children }) }));
}

const emptyAnswer = { selected: [] };
/** Long enough for the selection to visibly register before the step changes. */
const autoAdvanceDelayMs = 600;
function hasOptions(question) {
    return Boolean(question.options?.length);
}
function isSingleChoice(question) {
    return !question.isMultiple && hasOptions(question);
}
function acceptsCustom(question) {
    return Boolean(question.allowCustom) || !hasOptions(question);
}
function isAnswered(question, answer) {
    return (answer.selected.length > 0 ||
        (acceptsCustom(question) && Boolean(answer.custom?.trim())));
}
function NavChevron({ label, icon, isHidden, isDisabled, styles, onClick, }) {
    return (jsx(chakra.div, { __css: styles["navSlot"], "data-hidden": isHidden ? "" : undefined, children: jsx(IconButton, { "aria-label": label, icon: icon, size: "sm", variant: "tertiary", isDisabled: isDisabled, onClick: onClick }) }));
}
const AskUserCard = forwardRef$1(function AskUserCard_({ title = "A few questions", status = "pending", result, isDisabled = false, onDismiss, questions, answers, onAnswersChange, step: stepProp, onStepChange, onSubmit, onSkipAll, hasFooter = true, skipAllLabel = "Skip all", nextLabel = "Next", submitLabel = "Submit", ...props }, ref) {
    const styles = useMultiStyleConfig("AskUserCard");
    const [step, setStep] = useControllableState({
        value: stepProp,
        defaultValue: 0,
        onChange: onStepChange,
    });
    // Derived during render, so a step changed from outside also slides the right way.
    const [previousStep, setPreviousStep] = useState(step);
    const [direction, setDirection] = useState(1);
    if (step !== previousStep) {
        setPreviousStep(step);
        setDirection(step > previousStep ? 1 : -1);
    }
    // Clamped once, so no step value can push the counter or chevrons past the ends.
    const index = Math.min(Math.max(step, 0), questions.length - 1);
    const question = questions[index];
    const answer = (question && answers[question.id]) ?? emptyAnswer;
    const isSubmitting = status === "submitting";
    const isResolved = isResolvedStatus(status);
    const isLocked = isDisabled || isSubmitting;
    const isLastQuestion = index >= questions.length - 1;
    const isActive = !isResolved && question !== undefined;
    const canAdvance = question
        ? question.isRequired === false || isAnswered(question, answer)
        : false;
    const descriptionId = useId();
    const allRequiredAnswered = questions.every((item) => item.isRequired === false ||
        isAnswered(item, answers[item.id] ?? emptyAnswer));
    // Held outside the answer so picking an option never destroys typed text.
    // On single choice a `custom` value is the chosen answer only while `selected` is empty.
    const [customDrafts, setCustomDrafts] = useState({});
    // A draft outlives a radio pick but not `answers` dropping its question, so a reset clears it for good.
    if (Object.keys(customDrafts).some((id) => !Object.hasOwn(answers, id))) {
        setCustomDrafts((drafts) => Object.fromEntries(Object.entries(drafts).filter(([id]) => Object.hasOwn(answers, id))));
    }
    const customDraft = (question && customDrafts[question.id]) ?? "";
    // Only single choice keeps a real-text draft, so a reset of `answers` clears the field elsewhere.
    const customText = answer.custom ??
        (question && (isSingleChoice(question) || !customDraft.trim())
            ? customDraft
            : "");
    const isCustomSelected = question
        ? isSingleChoice(question)
            ? Boolean(answer.custom?.trim()) && answer.selected.length === 0
            : Boolean(customText.trim())
        : false;
    // True only between a pointer click (detail > 0) and the change it triggers.
    const isPointerSelection = useRef(false);
    // A fresh object per pick, so a second pick restarts the delay.
    // Anything that makes it stale drops it during render.
    const [pendingAdvance, setPendingAdvance] = useState();
    const isAdvancePending = pendingAdvance?.from === index && status === "pending" && !isDisabled;
    if (pendingAdvance !== undefined && !isAdvancePending) {
        setPendingAdvance(undefined);
    }
    // Navigating can hide the control just used, so the new question's checked or first control takes focus.
    // Looked up by id, since AnimatePresence reuses a question it is still exiting.
    const focusNextQuestion = useRef(false);
    const cardRef = useRef(null);
    const mergedRef = useMergeRefs(ref, cardRef);
    const bodyRef = useRef(null);
    const questionId = question?.id;
    useEffect(() => {
        if (!focusNextQuestion.current || questionId === undefined) {
            return;
        }
        focusNextQuestion.current = false;
        const node = Array.from(bodyRef.current?.querySelectorAll("[data-question]") ?? []).find((element) => element.dataset["question"] === questionId);
        // A chosen typed answer takes focus over the first radio, where an arrow key would replace it.
        const target = node?.querySelector("input:checked:not(:disabled)") ??
            node?.querySelector("[data-checked] textarea:not(:disabled)") ??
            node?.querySelector("input:not(:disabled), textarea:not(:disabled)");
        // Never take focus from somewhere else, such as the chat composer.
        const active = document.activeElement;
        if (active &&
            active !== document.body &&
            !cardRef.current?.contains(active)) {
            return;
        }
        focusControl(target);
    }, [questionId]);
    const goToStep = (nextStep) => {
        setPendingAdvance(undefined);
        if (nextStep === index) {
            return;
        }
        focusNextQuestion.current = true;
        setStep(nextStep);
    };
    // Checked when the timer fires, so answers that land a render late still count.
    const advance = useCallbackRef(() => {
        if (canAdvance) {
            goToStep(index + 1);
        }
        else {
            setPendingAdvance(undefined);
        }
    });
    useEffect(() => {
        if (!isAdvancePending) {
            return;
        }
        const timer = setTimeout(advance, autoAdvanceDelayMs);
        return () => {
            clearTimeout(timer);
        };
    }, [isAdvancePending, pendingAdvance, advance]);
    const setAnswer = (id, next) => {
        onAnswersChange({ ...answers, [id]: next });
    };
    const selectSingle = (value) => {
        if (!question || value === undefined) {
            return;
        }
        const fromPointer = isPointerSelection.current;
        isPointerSelection.current = false;
        if (customText) {
            setCustomDrafts((drafts) => ({ ...drafts, [question.id]: customText }));
        }
        setAnswer(question.id, { selected: [value] });
        setPendingAdvance(fromPointer && question.autoAdvance !== false && !isLastQuestion
            ? { from: index }
            : undefined);
    };
    const toggleMultiple = (value) => {
        if (!question) {
            return;
        }
        const selected = answer.selected.includes(value)
            ? answer.selected.filter((item) => item !== value)
            : [...answer.selected, value];
        setAnswer(question.id, { ...answer, selected });
    };
    const setCustomAnswer = (value) => {
        if (!question) {
            return;
        }
        setPendingAdvance(undefined);
        setCustomDrafts((drafts) => ({ ...drafts, [question.id]: value }));
        // Blank text stays a draft, so `answers` only ever hold real text.
        const hasText = Boolean(value.trim());
        setAnswer(question.id, {
            selected: hasText && isSingleChoice(question) ? [] : answer.selected,
            ...(hasText ? { custom: value } : {}),
        });
    };
    const selectCustomAnswer = () => {
        if (!question) {
            return;
        }
        setPendingAdvance(undefined);
        setAnswer(question.id, { selected: [], custom: customText });
    };
    const handleDismiss = () => {
        setPendingAdvance(undefined);
        onDismiss?.();
    };
    const handleSkipAll = () => {
        setPendingAdvance(undefined);
        onSkipAll?.();
    };
    const handlePrimaryAction = () => {
        if (isLastQuestion) {
            onSubmit?.(answers);
        }
        else {
            goToStep(index + 1);
        }
    };
    const handleOptionsClick = (event) => {
        if (event.detail === 0) {
            return;
        }
        isPointerSelection.current = true;
        // A click that selects nothing must not leave the flag set.
        setTimeout(() => {
            isPointerSelection.current = false;
        }, 0);
    };
    return (jsx(AgentCard, { ref: mergedRef, label: title, title: isActive ? question.title : title, status: status, isDisabled: isDisabled, subtext: isResolved ? result : undefined, onDismiss: onDismiss && handleDismiss, headerEnd: isActive ? (jsxs(chakra.div, { __css: styles["nav"], children: [jsx(NavChevron, { label: "Previous question", icon: ChevronLeftIcon, isHidden: index === 0, isDisabled: index === 0 || isLocked, styles: styles, onClick: () => {
                        goToStep(index - 1);
                    } }), jsxs(chakra.div, { __css: styles["counter"], children: [jsxs(Text, { "aria-hidden": true, size: "sm", variant: "numeric", color: "text.tertiary", children: [index + 1, " of ", questions.length] }), jsxs(VisuallyHidden, { "aria-live": "polite", children: ["Question ", index + 1, " of ", questions.length] })] }), jsx(NavChevron, { label: "Next question", icon: ChevronRightIcon, isHidden: isLastQuestion, isDisabled: isLastQuestion || isLocked || !canAdvance, styles: styles, onClick: () => {
                        goToStep(index + 1);
                    } })] })) : undefined, footer: hasFooter && isActive ? (jsxs(Fragment, { children: [onSkipAll && (jsx(chakra.div, { __css: styles["skipAll"], children: jsx(Button, { "data-resolves": true, size: "sm", variant: "tertiary", isDisabled: isLocked, onClick: handleSkipAll, children: skipAllLabel }) })), jsx(Button, { "data-resolves": isLastQuestion ? "" : undefined, size: "sm", variant: "primary", isLoading: isLastQuestion && isSubmitting, isDisabled: isDisabled ||
                        (isLastQuestion
                            ? !allRequiredAnswered
                            : !canAdvance || isSubmitting), onClick: handlePrimaryAction, children: isLastQuestion ? submitLabel : nextLabel })] })) : undefined, ...props, children: isActive && (jsx(chakra.div, { ref: bodyRef, "data-card-disabled": isDisabled ? "" : undefined, children: jsx(AnimatePresence, { initial: false, mode: "popLayout", custom: direction, children: jsx(MotionBox, { variants: slideSwapVariants, custom: direction, initial: "initial", animate: "active", exit: "exit", children: jsxs(chakra.div, { "data-question": question.id, role: "group", "aria-label": question.title, "aria-describedby": question.description ? `${descriptionId}-${index}` : undefined, __css: styles["question"], children: [question.description && (jsx(AgentCardContent, { children: jsx(Text, { id: `${descriptionId}-${index}`, color: "text.secondary", children: question.description }) })), question.options?.length ? (question.isMultiple ? (jsx(chakra.div, { __css: styles["options"], children: question.options.map((option) => (jsx(CheckboxOptionRow, { option: option, isChecked: answer.selected.includes(option.value), isDisabled: isLocked, onChange: () => {
                                        toggleMultiple(option.value);
                                    } }, option.value))) })) : (jsx(chakra.div, { onClick: handleOptionsClick, children: jsx(RadioGroup, { orientation: "vertical", width: "100%", isDisabled: isLocked, value: answer.selected[0], onChange: selectSingle, children: question.options.map((option) => (jsx(RadioOptionRow, { option: option }, option.value))) }) }))) : null, acceptsCustom(question) && (jsx(CustomOptionRow, { label: `${hasOptions(question) ? "Custom answer" : "Answer"} to: ${question.title}`, placeholder: question.customPlaceholder ??
                                    (hasOptions(question)
                                        ? "Type something else…"
                                        : "Type your answer…"), value: customText, isChecked: isCustomSelected, isDisabled: isLocked, onChange: setCustomAnswer, onPress: () => {
                                    setPendingAdvance(undefined);
                                }, onSelect: isSingleChoice(question) ? selectCustomAnswer : undefined }))] }) }, question.id) }) })) }));
});
AskUserCard.displayName = "AskUserCard";

// Color palette from https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Styles-2?node-id=7714-2351&t=3tf6DG33KXUlIWWz-1
// Semantic tokens mirror "HT 2 · Colors": https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Hightouch-UI?node-id=8506-7858
const colors = {
    teal: {
        "50": "oklch(0.98 0.0174 209.43)",
        "100": "oklch(0.9637 0.0326 212.04)",
        "200": "oklch(0.9125 0.0507 210.29)",
        "300": "oklch(0.8419 0.0658 213.26)",
        "400": "oklch(0.7487 0.1036 211.39)",
        "500": "oklch(0.5972 0.131 213.44)",
        "600": "oklch(0.5243 0.1143 214.28)",
        "700": "oklch(0.4668 0.0943 213.73)",
        "800": "oklch(0.4025 0.0826 212)",
        "900": "oklch(0.3427 0.071 210.27)",
    },
    yellow: {
        "50": "oklch(0.9871 0.0239 94.52)",
        "100": "oklch(0.9639 0.0686 97)",
        "200": "oklch(0.9249 0.1183 97.1)",
        "300": "oklch(0.8788 0.148 92.73)",
        "400": "oklch(0.8266 0.1731 86.1)",
        "500": "oklch(0.7659 0.1668 71.73)",
        "600": "oklch(0.6392 0.1581 60.07)",
        "700": "oklch(0.548 0.148 50.76)",
        "800": "oklch(0.4672 0.1315 48.45)",
        "900": "oklch(0.3748 0.1115 47.49)",
    },
    red: {
        "50": "oklch(96.91% 0.015 17.42)",
        "100": "oklch(90.23% 0.050764487400613734 18.134245085608146)",
        "200": "oklch(83.48% 0.09155694161436399 18.345986095067442)",
        "300": "oklch(76.76% 0.1379562554882739 18.596481624165502)",
        "400": "oklch(70.13% 0.19088395210545106 18.65430749379855)",
        "500": "oklch(63.33% 0.213 18.7)",
        "600": "oklch(54.91% 0.22 18.59)",
        "700": "oklch(43.46% 0.174 18.79)",
        "800": "oklch(31.64% 0.12686925279130523 18.9842584108985)",
        "900": "oklch(21.08% 0.08451422681622453 18.772611548125568)",
    },
    gray: {
        "50": "oklch(98.51% 0 355)",
        "100": "oklch(97.02% 0 355)",
        "200": "oklch(94.01% 0 0)",
        "300": "oklch(90.24% 0.0025 345.22)",
        "400": "oklch(81.84% 0.0057 3.37)",
        "500": "oklch(63.8% 0.0061 3.44)",
        "600": "oklch(50.59% 0.0082 355.05)",
        "700": "oklch(40.77% 0.0031 345.34)",
        "800": "oklch(30.18% 0.004 355)",
        "900": "oklch(23.34% 0.004 355)",
    },
    green: {
        "50": "oklch(0.96 0.0148 158.25)",
        "100": "oklch(0.9298 0.0478 156.56)",
        "200": "oklch(0.856 0.0977 154.31)",
        "300": "oklch(0.7761 0.1295 152.9)",
        "400": "oklch(0.6717 0.1422 153.17)",
        "500": "oklch(0.5904 0.1616 152.22)",
        "600": "oklch(0.4551 0.1329 155.25)",
        "700": "oklch(0.3832 0.1031 156.41)",
        "800": "oklch(0.3277 0.0924 157.43)",
        "900": "oklch(0.3034 0.0685 169.68)",
    },
    blue: {
        "50": "oklch(0.9709 0.0125 255.5)",
        "100": "oklch(0.9338 0.0348 259.59)",
        "200": "oklch(0.883 0.0625 259.03)",
        "300": "oklch(0.8115 0.0996 256.56)",
        "400": "oklch(0.707 0.158 259.16)",
        "500": "oklch(0.6199 0.2108 263.3)",
        "600": "oklch(0.5178 0.2286 265.2)",
        "700": "oklch(0.4803 0.2313 266.03)",
        "800": "oklch(0.4043 0.2004 267.27)",
        "900": "oklch(0.321 0.1378 267.64)",
    },
    purple: {
        "50": "oklch(0.9575 0.0114 308.33)",
        "100": "oklch(0.8997 0.0245 306.94)",
        "200": "oklch(0.8076 0.0506 307.77)",
        "300": "oklch(0.727 0.0731 307.34)",
        "400": "oklch(0.6511 0.0936 307.59)",
        "500": "oklch(0.5972 0.1079 307.75)",
        "600": "oklch(0.524 0.1061 307.91)",
        "700": "oklch(0.4362 0.0889 307.9)",
        "800": "oklch(0.3393 0.0694 308.56)",
        "900": "oklch(0.2977 0.0622 308.08)",
    },
    pink: {
        "50": "oklch(97.18% 0.011 339.33)",
        "100": "oklch(94.76% 0.023 338.62)",
        "200": "oklch(89.55% 0.051 340.45)",
        "300": "oklch(81.57% 0.1 343.67)",
        "400": "oklch(70.56% 0.171 347.84)",
        "500": "oklch(64.07% 0.205 352.56)",
        "600": "oklch(57.55% 0.214 359.48)",
        "700": "oklch(51.08% 0.191 2.82)",
        "800": "oklch(44.62% 0.16 2.77)",
        "900": "oklch(39.84% 0.13 1.02)",
    },
    orange: {
        "50": "oklch(98.1% 0.015 80.71)",
        "100": "oklch(95.42% 0.034 80.31)",
        "200": "oklch(89.96% 0.083 73.51)",
        "300": "oklch(83.26% 0.134 68.84)",
        "400": "oklch(74.21% 0.173 57.75)",
        "500": "oklch(69.47% 0.196 49.2)",
        "600": "oklch(63.37% 0.196 42.09)",
        "700": "oklch(54.13% 0.178 39.62)",
        "800": "oklch(46.06% 0.155 38.44)",
        "900": "oklch(36.7% 0.123 39.51)",
    },
    indigo: {
        "50": "oklch(94.96% 0.023 291.37)",
        "100": "oklch(91.63% 0.042 291.47)",
        "200": "oklch(84.1% 0.075 290.63)",
        "300": "oklch(78.42% 0.091 290.6)",
        "400": "oklch(67.89% 0.122 289.83)",
        "500": "oklch(57.6% 0.135 289.1)",
        "600": "oklch(46.86% 0.135 287.37)",
        "700": "oklch(38.9% 0.124 288.18)",
        "800": "oklch(31.66% 0.099 289.01)",
        "900": "oklch(20.7% 0.108 289.18)",
    },
    blackAlpha: {
        "04": "oklch(0 0 0 / 4%)",
        "08": "oklch(0 0 0 / 8%)",
        "12": "oklch(0 0 0 / 12%)",
        "16": "oklch(0 0 0 / 16%)",
        "20": "oklch(0 0 0 / 20%)",
        "40": "oklch(0 0 0 / 40%)",
        "60": "oklch(0 0 0 / 60%)",
        "80": "oklch(0 0 0 / 80%)",
        "100": "oklch(0 0 0 / 100%)",
    },
    whiteAlpha: {
        "04": "oklch(1 0 0 / 4%)",
        "08": "oklch(1 0 0 / 8%)",
        "12": "oklch(1 0 0 / 12%)",
        "16": "oklch(1 0 0 / 16%)",
        "20": "oklch(1 0 0 / 20%)",
        "40": "oklch(1 0 0 / 40%)",
        "60": "oklch(1 0 0 / 60%)",
        "80": "oklch(1 0 0 / 80%)",
        "100": "oklch(1 0 0 / 100%)",
    },
};
// Key order is the series assignment order from Figma (1. blue → 8. brown).
const charts = {
    blue: {
        "200": "oklch(86.03% 0.063 227.99)",
        "400": "oklch(73.33% 0.086 230.59)",
    },
    green: {
        "200": "oklch(88.4% 0.063 157.76)",
        "400": "oklch(72.7% 0.078 156.87)",
    },
    yellow: {
        "200": "oklch(89.06% 0.061 75.05)",
        "400": "oklch(83.09% 0.093 74.38)",
    },
    orange: {
        "200": "oklch(86.39% 0.066 38.19)",
        "400": "oklch(73.93% 0.106 39.19)",
    },
    red: {
        "200": "oklch(84.35% 0.054 26.89)",
        "400": "oklch(68% 0.12 28.87)",
    },
    pink: {
        "200": "oklch(92.56% 0.046 330.44)",
        "400": "oklch(82.96% 0.093 332.37)",
    },
    purple: {
        "200": "oklch(84.1% 0.075 290.63)",
        "400": "oklch(67.89% 0.122 289.83)",
    },
    brown: {
        "200": "oklch(91.29% 0.018 48.52)",
        "400": "oklch(75.34% 0.045 47.35)",
    },
};
const themeColors = {
    ...colors,
    /** Black washes for scrims, hovers, and overlays on light surfaces. */
    blackAlpha: {
        ...colors.blackAlpha,
    },
    /** White washes for scrims, hovers, and overlays on dark surfaces. */
    whiteAlpha: {
        ...colors.whiteAlpha,
    },
    gray: {
        ...colors.gray,
        base: colors.gray["600"],
        border: colors.gray["300"],
        background: colors.gray["50"],
        backgroundHover: colors.gray["100"],
        text: colors.gray["700"],
        pressed: colors.gray["800"],
    },
    teal: {
        ...colors.teal,
        dark: colors.teal["800"],
        hover: colors.teal["700"],
        base: colors.teal["600"],
        border: colors.teal["300"],
        background: colors.teal["50"],
        backgroundHover: colors.teal["100"],
        text: colors.teal["700"],
        pressed: colors.teal["800"],
    },
    green: {
        ...colors.green,
        base: colors.green["600"],
        border: colors.green["300"],
        background: colors.green["50"],
        backgroundHover: colors.green["100"],
        text: colors.green["700"],
        pressed: colors.green["800"],
    },
    blue: {
        ...colors.blue,
        hover: colors.blue["700"],
        base: colors.blue["600"],
        border: colors.blue["300"],
        background: colors.blue["50"],
        backgroundHover: colors.blue["100"],
        text: colors.blue["700"],
        pressed: colors.blue["800"],
    },
    indigo: {
        ...colors.indigo,
        hover: colors.indigo["700"],
        base: colors.indigo["600"],
        border: colors.indigo["300"],
        background: colors.indigo["50"],
        backgroundHover: colors.indigo["100"],
        text: colors.indigo["700"],
        pressed: colors.indigo["800"],
    },
    purple: {
        ...colors.purple,
        base: colors.purple["600"],
        border: colors.purple["300"],
        background: colors.purple["50"],
        backgroundHover: colors.purple["100"],
        text: colors.purple["700"],
        pressed: colors.purple["800"],
    },
    pink: {
        ...colors.pink,
        hover: colors.pink["700"],
        base: colors.pink["600"],
        border: colors.pink["300"],
        background: colors.pink["50"],
        backgroundHover: colors.pink["100"],
        text: colors.pink["700"],
        pressed: colors.pink["800"],
    },
    orange: {
        ...colors.orange,
        hover: colors.orange["700"],
        base: colors.orange["600"],
        border: colors.orange["300"],
        background: colors.orange["50"],
        backgroundHover: colors.orange["100"],
        text: colors.orange["700"],
        pressed: colors.orange["800"],
    },
    yellow: {
        ...colors.yellow,
        base: colors.yellow["600"],
        border: colors.yellow["300"],
        background: colors.yellow["50"],
        backgroundHover: colors.yellow["100"],
        text: colors.yellow["700"],
        pressed: colors.yellow["800"],
    },
    red: {
        ...colors.red,
        base: colors.red["600"],
        border: colors.red["300"],
        background: colors.red["50"],
        backgroundHover: colors.red["100"],
        text: colors.red["700"],
        pressed: colors.red["800"],
    },
    success: {
        base: colors.green["600"],
        hover: colors.green["700"],
        /** Success and confirmation (green.300). */
        border: colors.green["300"],
        background: colors.green["50"],
        backgroundHover: colors.green["100"],
        text: colors.green["700"],
        pressed: colors.green["800"],
    },
    warning: {
        ...colors.yellow,
        base: colors.yellow["600"],
        hover: colors.yellow["700"],
        /** Warnings (yellow.300). */
        border: colors.yellow["300"],
        background: colors.yellow["50"],
        backgroundHover: colors.yellow["100"],
        text: colors.yellow["700"],
        pressed: colors.yellow["800"],
    },
    danger: {
        ...colors.red,
        dark: colors.red["800"],
        hover: colors.red["700"],
        base: colors.red["600"],
        /** Errors and destructive surfaces (red.200). */
        border: colors.red["200"],
        background: colors.red["50"],
        backgroundHover: colors.red["100"],
        text: colors.red["700"],
        pressed: colors.red["800"],
    },
    /**
     * `text.danger` (a 600 rung, for standalone text) is intentionally distinct from `danger.text`
     * (a 700 rung, paired with `danger.background`). The split is danger-only: `text.warning`,
     * `text.success`, and `text.upsell` match their group's `.text` token on the 700 rung.
     */
    text: {
        primary: colors.gray["800"],
        secondary: colors.gray["700"],
        tertiary: colors.gray["600"],
        placeholder: colors.gray["600"],
        accent: colors.teal["700"],
        danger: colors.red["600"],
        disabled: colors.gray["500"],
        upsell: colors.purple["700"],
        warning: colors.yellow["700"],
        success: colors.green["700"],
        white: "oklch(1 0 0)",
    },
    /**
     * Icon tokens mirror text tokens one-for-one — use the matching pair so icons never drift from
     * adjacent copy. Hue-colored icons sit on the 600 rung per Figma — one step brighter than most
     * text counterparts (`icon.danger` and `text.danger` match).
     */
    icon: {
        primary: colors.gray["800"],
        secondary: colors.gray["700"],
        tertiary: colors.gray["600"],
        disabled: colors.gray["500"],
        accent: colors.teal["600"],
        danger: colors.red["600"],
        warning: colors.yellow["600"],
        success: colors.green["600"],
        upsell: colors.purple["600"],
        white: "oklch(1 0 0)",
    },
    base: {
        /** Default resting border on a surface (gray.300). */
        border: colors.gray["300"],
        /** Disabled surfaces (gray.200). */
        borderDisabled: colors.gray["200"],
        /** Hover state for interactive surfaces (gray.400). */
        borderHover: colors.gray["400"],
        borderTransparent: "transparent",
        /** Separators inside a surface; lighter than base.border (gray.200). */
        divider: colors.gray["200"],
        white: "oklch(1 0 0)",
        background: colors.gray["100"],
        backgroundHover: colors.gray["200"],
        backgroundPressed: colors.gray["300"],
        lightBackground: colors.gray["50"],
        containerBackground: colors.blackAlpha["80"],
        backgroundDisabled: colors.gray["200"],
    },
    primary: {
        pressed: colors.teal["800"],
        hover: colors.teal["700"],
        base: colors.teal["600"],
        /** Selected or branded surfaces (teal.300). */
        border: colors.teal["300"],
        background: colors.teal["50"],
        backgroundHover: colors.teal["100"],
        text: colors.teal["700"],
    },
    upsell: {
        dark: colors.purple["800"],
        pressed: colors.purple["800"],
        hover: colors.purple["700"],
        base: colors.purple["600"],
        /** Upsell and premium surfaces (purple.300). */
        border: colors.purple["300"],
        background: colors.purple["50"],
        backgroundHover: colors.purple["100"],
        text: colors.purple["700"],
        disabled: colors.purple["200"],
    },
    link: {
        pressed: colors.teal["800"],
        hover: colors.teal["700"],
        default: colors.teal["600"],
    },
    gradients: {
        upsell: {
            background: `linear-gradient(to bottom right, ${colors.teal[100]}, ${colors.purple[100]}, ${colors.purple[200]})`,
            backgroundHover: `linear-gradient(to bottom right, ${colors.teal[100]}, ${colors.purple[300]})`,
            hover: `linear-gradient(to bottom right, ${colors.purple[200]}, ${colors.purple[800]})`,
            primary: `linear-gradient(to bottom right, ${colors.purple[200]}, ${colors.purple[700]})`,
        },
    },
    /** Data-viz series use their own palette (`charts.*`), separate from the product hues. */
    charts: {
        blue: {
            ...charts.blue,
            base: charts.blue["400"],
            light: charts.blue["200"],
        },
        green: {
            ...charts.green,
            base: charts.green["400"],
            light: charts.green["200"],
        },
        yellow: {
            ...charts.yellow,
            base: charts.yellow["400"],
            light: charts.yellow["200"],
        },
        orange: {
            ...charts.orange,
            base: charts.orange["400"],
            light: charts.orange["200"],
        },
        red: {
            ...charts.red,
            base: charts.red["400"],
            light: charts.red["200"],
        },
        pink: {
            ...charts.pink,
            base: charts.pink["400"],
            light: charts.pink["200"],
        },
        purple: {
            ...charts.purple,
            base: charts.purple["400"],
            light: charts.purple["200"],
        },
        brown: {
            ...charts.brown,
            base: charts.brown["400"],
            light: charts.brown["200"],
        },
    },
    /** Marketing surfaces use the Hightouch brand black and accent green. App surfaces stay on teal. */
    brand: {
        // Brand color palette from https://site-storybook.vercel.hightouch.com/?path=/docs/design-system-atoms-colors--docs
        black: "#101111",
        accent: "#40DE9E",
    },
};
const avatarGradientHues = [
    "teal",
    "purple",
    "indigo",
    "blue",
    "green",
    "pink",
    "orange",
    "red",
    "yellow",
];
function avatarGradientEntry(hue, backgroundShade) {
    return {
        background: `${hue}.${backgroundShade}`,
        text: `${hue}.700`,
        border: `${hue}.300`,
    };
}
/** Pastel gradient avatar palette entries for boring-avatars. */
const avatarGradientPalette = avatarGradientHues.flatMap((hue) => [
    avatarGradientEntry(hue, "100"),
    avatarGradientEntry(hue, "200"),
]);
`linear-gradient(to bottom right, ${themeColors.teal.background}, ${themeColors.purple.background}, ${colors.purple[200]})`;

// Mirrors boring-avatars' hashCode so initials match the marble background hue.
function hashCode(name) {
    let hash = 0;
    for (let index = 0; index < name.length; index++) {
        const char = name.charCodeAt(index);
        hash = (hash << 5) - hash + char;
        hash &= hash;
    }
    return Math.abs(hash);
}

const AvatarColors = ["teal", "indigo", "orange", "blue", "green", "pink"];
const AvatarPixelSizes = {
    sm: 20,
    md: 24,
    lg: 32,
    xl: 40,
};
/**
 * Corner radius applied to square avatars, scaled per size. Kept a touch
 * tighter than the equivalent `IconBox` sizes so the corners read as
 * subtly rounded rather than pill-like.
 */
const SquareRadii = {
    sm: "sm",
    md: "md",
    lg: "md",
    xl: "lg",
};
function useGradientPalette(avatarName) {
    const backgrounds = useToken("colors", avatarGradientPalette.map((entry) => entry.background));
    const texts = useToken("colors", avatarGradientPalette.map((entry) => entry.text));
    const borders = useToken("colors", avatarGradientPalette.map((entry) => entry.border));
    const colorIndex = useMemo(() => hashCode(avatarName) % avatarGradientPalette.length, [avatarName]);
    return useMemo(() => ({
        colors: backgrounds,
        initialsColor: texts[colorIndex],
        borderColor: borders[colorIndex],
    }), [backgrounds, texts, borders, colorIndex]);
}
// Mirrors Chakra's internal initials logic (avatar-name.mjs), which isn't exported
function getInitials(name) {
    const names = name.trim().split(" ");
    const firstName = names[0] ?? "";
    const lastName = names.length > 1 ? names.at(-1) : "";
    return firstName && lastName
        ? `${firstName.charAt(0)}${lastName.charAt(0)}`
        : firstName.charAt(0);
}
function useAvatarVariant(name, id) {
    return useMemo(() => {
        const prando = new Prando(name ?? id);
        const colorIndex = prando.nextInt(0, AvatarColors.length - 1);
        return AvatarColors[colorIndex];
    }, [name, id]);
}
function getSharedAvatarProps({ size, shape, skeleton, borderColor, }) {
    return {
        size,
        borderRadius: shape === "square" ? SquareRadii[size] : undefined,
        "data-loading": skeleton,
        borderWidth: "hairline",
        borderStyle: skeleton ? "none" : "solid",
        ...(borderColor ? { borderColor: `${borderColor}!` } : {}),
    };
}
const AvatarVisual = forwardRef$1(function AvatarVisual_({ name, avatarName, size, shape, skeleton, gradient, variant, gradientPalette, ...props }, ref) {
    const sharedProps = getSharedAvatarProps({ size, shape, skeleton });
    if (!gradient) {
        return (jsx(Avatar$1, { ref: ref, name: name, variant: variant, ...sharedProps, ...props }));
    }
    const gradientIcon = (jsx(BoringAvatar, { "aria-hidden": true, name: avatarName, size: AvatarPixelSizes[size], square: shape === "square", colors: gradientPalette.colors }));
    return (jsx(Avatar$1, { ref: ref, icon: gradientIcon, bg: "transparent", color: name ? gradientPalette.initialsColor : undefined, overflow: "hidden", ...sharedProps, borderColor: `${gradientPalette.borderColor}!`, ...props, children: name ? (jsx(Box, { role: "img", "aria-label": name, position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", lineHeight: "normal", userSelect: "none", children: getInitials(name) })) : null }));
});
AvatarVisual.displayName = "AvatarVisual";
const Avatar = forwardRef$1(function Avatar_({ name, size = "md", shape = "circle", tip, hideTooltip = false, gradient = true, ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    const styles = useMultiStyleConfig("Avatar", { size });
    // Stable id per component instance, used for color selection when no name is provided
    const id = useId();
    const avatarName = name ?? id;
    const gradientPalette = useGradientPalette(avatarName);
    const variant = useAvatarVariant(name, id);
    const visualProps = {
        name,
        avatarName,
        size,
        shape,
        skeleton,
        gradient,
        variant,
        gradientPalette,
    };
    return (jsx(Tooltip, { ref: ref, isDisabled: !name || hideTooltip, message: tip ? (jsxs(Box, { __css: styles["expandedTooltip"], children: [jsxs(Box, { className: "tooltipContainer", children: [jsx(AvatarVisual, { ...visualProps, size: "sm", skeleton: false }), jsx(Text, { className: "primaryLabel", size: "sm", children: name })] }), tip && (jsx(Text, { className: "secondaryLabel", size: "sm", children: tip }))] })) : ((name ?? "")), children: jsx(AvatarVisual, { ...visualProps, ...props }) }));
});
Avatar.displayName = "Avatar";

const BadgeGroupItemContext = createContext({
    isHidden: false,
});

function Portal(props) {
    try {
        // biome-ignore lint/correctness/useHookAtTopLevel: called unconditionally on every render; the try/catch only guards rendering outside a modal context
        const modalContext = useModalContext();
        // TODO(eric.lovett): Refactor this to avoid constructing JSX inside the try-catch.
        return jsx(Portal$1, { containerRef: modalContext?.dialogRef, ...props });
    }
    catch {
        return jsx(Portal$1, { ...props });
    }
}

// Detect the index of an element inside container, at which
// Flexbox layout wraps elements and places them on the next line
function detectWrapIndex$1(container) {
    const isWrapped = container.offsetHeight < container.scrollHeight;
    if (!isWrapped) {
        return -1;
    }
    let index = 0;
    let previousChildY;
    // HTMLCollection is iterable only with lib.dom.iterable, which tsc and tsgo
    // resolve differently; Array.from sidesteps the lib difference.
    for (const child of Array.from(container.children)) {
        if (!(child instanceof HTMLElement)) {
            continue;
        }
        const childY = child.offsetTop;
        // When the Y coordinate of a node is larger than a Y coordinate of
        // the previous node, it means this node is placed on the next line,
        // which happens when node doesn't fit anymore and Flexbox moves it below
        if (typeof previousChildY === "number" && childY > previousChildY) {
            return index;
        }
        previousChildY = childY;
        index++;
    }
    return -1;
}
function BadgeGroup({ truncate = true, removePortal = false, children, variant, size, ...props }) {
    const moreButtonStyles = useStyleConfig("Badge", {
        variant,
        size,
    });
    const container = useRef(null);
    // Index of the node at which Flexbox forced the element onto the next line
    const [wrappedAtIndex, setWrappedAtIndex] = useState(-1);
    // X coordinate of the "+4" button used to anchor that button to the last badge in the row
    const [moreButtonX, setMoreButtonX] = useState(undefined);
    useEffect(() => {
        const containerElement = container.current;
        if (!containerElement || !truncate) {
            return;
        }
        const recalculateLayout = () => {
            const wrappedAtIndex = detectWrapIndex$1(containerElement);
            setWrappedAtIndex(wrappedAtIndex);
            if (wrappedAtIndex === -1) {
                return;
            }
            const elementBeforeWrap = containerElement.children[wrappedAtIndex - 1];
            if (!elementBeforeWrap || !(elementBeforeWrap instanceof HTMLElement)) {
                return;
            }
            // Position "+4" button near the last badge and add a 4px gap
            const moreButtonX = elementBeforeWrap.offsetLeft + elementBeforeWrap.offsetWidth + 4;
            setMoreButtonX(moreButtonX);
        };
        // Recalculate layout when container is resized
        const resizeObserver = new ResizeObserver(recalculateLayout);
        resizeObserver.observe(containerElement);
        // Recalculate layout when badges are added, changed or removed
        const mutationObserver = new MutationObserver(recalculateLayout);
        mutationObserver.observe(containerElement, {
            childList: true,
            subtree: true,
        });
        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [truncate]);
    // Children nodes excluding `false`, `undefined`, `null`
    const childrenNodes = Children.toArray(children);
    const PopoverContentWrapper = removePortal ? Fragment$1 : Portal;
    return (jsxs(Box$1, { position: "relative", display: "flex", gap: 1, ...props, children: [jsx(Box$1, { ref: container, flex: "1", minWidth: 10, display: "flex", gap: 1, flexWrap: "wrap", 
                // 6 (24px) is the height of the badge
                height: truncate ? 6 : undefined, overflow: truncate ? "hidden" : undefined, children: Children.map(children, (child, index) => {
                    if (!isValidElement(child)) {
                        return child;
                    }
                    return (jsx(BadgeGroupItemContext.Provider, { value: { isHidden: index >= wrappedAtIndex }, children: child }));
                }) }), wrappedAtIndex >= 0 && typeof moreButtonX === "number" && (jsxs(Fragment, { children: [jsx(Box$1, { flex: "none", visibility: "hidden", __css: moreButtonStyles, children: jsxs(Text, { children: ["+", childrenNodes.length - wrappedAtIndex] }) }), jsxs(Popover$1, { isLazy: true, children: [jsx(PopoverTrigger$1, { children: jsx(Box$1, { as: "button", type: "button", position: "absolute", top: 0, left: 0, transform: `translateX(${moreButtonX}px)`, _focusVisible: {
                                        shadow: "outline",
                                        outline: "none",
                                    }, __css: moreButtonStyles, children: jsxs(Text, { children: ["+", childrenNodes.length - wrappedAtIndex] }) }) }), jsx(PopoverContentWrapper, { children: jsx(PopoverContent$1, { width: "max-content", maxWidth: "lg", children: jsx(PopoverBody$1, { display: "flex", flexWrap: "wrap", gap: 1, py: 4, children: Children.toArray(children).slice(wrappedAtIndex) }) }) })] })] }))] }));
}

/**
 * Hook used to support Input Method Editor text replacement
 *
 * Downshift's `useCombobox` has a bug and currently does not support IME text replacement.
 * https://github.com/downshift-js/downshift/issues/1452
 */
const useComboboxImeSupport = (onInputValueChange, onChange) => {
    const isComposingRef = useRef(false);
    const getOnChangeWithCompositionSupport = useCallback((event) => {
        onInputValueChange(event?.target?.value);
        // IME method start
        if (event.type === "compositionstart") {
            isComposingRef.current = true;
            return;
        }
        // IME method end
        if (event.type === "compositionend") {
            isComposingRef.current = false;
        }
        if (!isComposingRef.current) {
            onChange?.(event);
        }
    }, [onChange, onInputValueChange]);
    return getOnChangeWithCompositionSupport;
};

/**
 * Delays the execution of a callback until the condition is met.
 * Once the condition is met, the callback is executed after a delay.
 */
const useDelayedCallback = (callback, condition, delay = 100) => {
    useEffect(() => {
        if (condition) {
            const timer = setTimeout(() => {
                callback();
            }, delay);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [callback, condition, delay]);
};

function useVirtualItems({ options, optionGroups, optionLabel, containerRef, estimatedSize = 32, }) {
    const virtualItems = useMemo(() => {
        const items = [];
        if (Array.isArray(options)) {
            let index = 0;
            for (const option of options) {
                if (typeof option === "symbol") {
                    items.push({
                        type: "creatable-option",
                        index,
                    });
                    index++;
                    continue;
                }
                items.push({
                    type: "option",
                    option,
                    index,
                });
                index++;
            }
            return items;
        }
        if (Array.isArray(optionGroups)) {
            // Item inside virtual list doesn't match an item inside Downshift
            // with the same index, because groups aren't included in Downshift items.
            // Because of that, we need to calculate the index for each option item
            // inside virtual list ourselves, while excluding groups.
            let index = 0;
            for (const optionGroup of optionGroups) {
                if (typeof optionGroup === "symbol") {
                    // Group components do not support creatable options, so we skip them.
                    index++;
                    continue;
                }
                // A group with no label contributes no header row at all, so its
                // options sit flush against whatever precedes them.
                if (optionGroup.label) {
                    items.push({
                        type: "group",
                        label: optionGroup.label,
                    });
                }
                for (const option of optionGroup.options) {
                    items.push({
                        type: "option",
                        option,
                        index: index++,
                    });
                }
            }
        }
        return items;
    }, [options, optionGroups]);
    const getVirtualItemKey = useCallback((virtualIndex) => {
        const item = virtualItems[virtualIndex];
        if (!item) {
            return String(virtualIndex);
        }
        if (item.type === "group") {
            return `${item.label}-${virtualIndex}`;
        }
        if (item.type === "creatable-option") {
            return "creatable";
        }
        return `${optionLabel(item.option)}-${virtualIndex}`;
    }, [virtualItems, optionLabel]);
    const getVirtualItemIndex = useCallback((downshiftIndex) => {
        if (Array.isArray(options)) {
            return downshiftIndex;
        }
        // `downshiftIndex` is an index of a currently highlighted option in Downshift,
        // which doesn't match the index in a virtual list, because rows
        // with group labels in them aren't passed to Downshift and don't count when calculating index.
        return virtualItems.findIndex((virtualItem) => {
            return (virtualItem.type === "option" && virtualItem.index === downshiftIndex);
        });
    }, [virtualItems, options]);
    // TanStack Virtual is currently incompatible with React's Rules of Hooks and React Compiler.
    // See https://github.com/TanStack/virtual/issues/1119.
    const virtualizer = useVirtualizer({
        count: virtualItems.length,
        getItemKey: getVirtualItemKey,
        getScrollElement() {
            return containerRef.current;
        },
        // TODO(eric.lovett): This deps array is missing `estimatedSize` and therefore may be buggy.
        // Please consider adding it.
        estimateSize: useCallback(() => estimatedSize, []),
    });
    return {
        virtualItems,
        getVirtualItemKey,
        getVirtualItemIndex,
        virtualizer,
    };
}

const defaultIsOptionDisabled = () => false;
/**
 * Stops a mousedown event on the native scrollbar from stealing focus from
 * the combobox/select input and closing the popover.
 *
 * Clicking the scrollbar blurs the input, which makes downshift close the
 * dropdown and disrupts the drag scroll. A scrollbar mousedown always targets
 * the scroll container itself, never an option, so we `preventDefault` for any
 * mousedown that didn't originate inside an option. This also covers presses
 * on the container's padding and group headers, while preserving clicks, text
 * selection, and drag-and-drop on the option content.
 */
function handleScrollbarMouseDown(event) {
    const target = event.target;
    if (!target.closest('[role="option"]')) {
        event.preventDefault();
    }
}
function defaultOptionLabel(option) {
    return String(option.label ?? "");
}
function defaultOptionDescription(option) {
    return String(option.description ?? "");
}
function defaultOptionEquality(optionValue, value) {
    return isEqual(optionValue, value);
}
function defaultOptionValue(option) {
    return option.value;
}
const defaultCreateOptionMessage = (inputValue) => {
    return `Create "${inputValue}"`;
};
function scrollVirtualizerOnHighlightChange({ highlightedIndex, numberOfOptions, scrollToIndex, }) {
    if (typeof highlightedIndex !== "number" || numberOfOptions === 0) {
        return;
    }
    if (highlightedIndex >= 0) {
        scrollToIndex(highlightedIndex);
    }
}

function SelectEmptyState({ hasBorder = true, children, }) {
    const styles = useStyleConfig("SelectEmptyState", { hasBorder });
    return jsx(chakra.p, { __css: styles, children: children });
}

const IconBox = forwardRef$1(function IconBox_({ isSelected = false, icon, color, size = "md", variant = "default", ...props }, ref) {
    const styles = useStyleConfig("IconBox", {
        isSelected,
        colorScheme: color,
        size,
        variant,
    });
    return (jsx(chakra.div, { ref: ref, __css: styles, ...props, children: icon }));
});
IconBox.displayName = "IconBox";

function IconAccessory({ accessory }) {
    const styles = useMultiStyleConfig("IconAccessory");
    return (jsx(Tooltip, { isDisabled: !accessory.tooltip, message: accessory.tooltip, placement: "auto", preferredPlacements: ["left", "right"], children: jsxs(chakra.div, { __css: styles["container"], children: [accessory.type === "image" && (jsx(Image, { src: accessory.url, __css: styles["accessory"], "aria-hidden": "true" })), accessory.type === "icon" && (jsx(Box$1, { as: accessory.icon, __css: styles["accessory"], "aria-hidden": "true", color: accessory.color })), accessory.type === "icon-box" && (jsx(IconBox, { "aria-hidden": "true", size: "sm", ...accessory })), accessory.type === "swatch" && (jsx(chakra.span, { __css: { ...styles["swatch"], bg: accessory.color }, "aria-hidden": "true" })), accessory.type === "emoji" && (jsx(Text$1, { fontSize: "3xl", children: accessory.emoji })), accessory.type === "badge" && (jsx(Badge, { variant: accessory.variant, size: "sm", children: accessory.text }))] }) }));
}

// Icon accessories get their state color here rather than from an `svg` rule
// in the option theme, which would outrank the accessory's own `color` because
// of CSS specificity.
function withDefaultIconColor(accessory, { isDisabled, isSelected, isAction, colorScheme }) {
    if (accessory.type !== "icon") {
        return accessory;
    }
    if (isDisabled) {
        return { ...accessory, color: "text.disabled" };
    }
    const defaultColor = isSelected
        ? `${colorScheme}.base`
        : isAction
            ? "link.default"
            : "text.placeholder";
    return { ...accessory, color: accessory.color ?? defaultColor };
}
const SelectOption = forwardRef$1(function SelectOption_({ children, disabledMessage, isDisabled = false, isHighlighted = false, isSelected = false, isAction = false, isPreviousSelected = false, isNextSelected = false, leftAccessory, rightAccessory, colorScheme = "teal", ...props }, ref) {
    const styles = useMultiStyleConfig("SelectOption", {
        isHighlighted,
        colorScheme,
        variant: isSelected ? "selected" : isAction ? "action" : undefined,
    });
    const iconState = { isDisabled, isSelected, isAction, colorScheme };
    return (jsx(Tooltip, { isDisabled: !disabledMessage, message: disabledMessage, placement: "auto", preferredPlacements: ["left", "right"], children: jsxs(chakra.div, { ref: ref, __css: styles["option"], role: "option", "aria-selected": isSelected ? "true" : undefined, "aria-disabled": isDisabled ? "true" : undefined, "data-previous-selected": isPreviousSelected ? "true" : undefined, "data-next-selected": isNextSelected ? "true" : undefined, "data-disabled": isDisabled ? "true" : undefined, "data-description": disabledMessage, ...props, children: [leftAccessory && (jsx(IconAccessory, { accessory: {
                        ...withDefaultIconColor(leftAccessory, iconState),
                        tooltip: disabledMessage ? undefined : leftAccessory.tooltip,
                    } })), children, isDisabled && jsx(Box$1, { __css: styles["lockIcon"], as: LockIcon }), rightAccessory && (jsx(IconAccessory, { accessory: {
                        ...withDefaultIconColor(rightAccessory, iconState),
                        tooltip: disabledMessage ? undefined : rightAccessory.tooltip,
                    } }))] }) }));
});
SelectOption.displayName = "SelectOption";

function SelectOptionLabel({ description, ...props }) {
    const styles = useMultiStyleConfig("SelectOption");
    if (description) {
        return (jsxs(chakra.div, { __css: styles["labelContainer"], children: [jsx(chakra.span, { __css: styles["label"], ...props }), jsx(chakra.span, { __css: styles["description"], className: "select-option-description", children: description })] }));
    }
    return jsx(chakra.span, { __css: styles["label"], ...props });
}

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
// Internal: not re-exported from source/index.ts, so it stays off the public surface.
const openPopoverRepositionTransition = `opacity ${transition.duration.fast} ${transition.easing.linear}, transform ${transition.duration.fast} ${transition.easing.easeOutCubic}`;

const SelectPopover = forwardRef$1(function SelectPopover_({ isOpen, children, color: _color, "data-testid": dataTestId, removePortal, hasFooter = false, ...props }, ref) {
    const styles = useMultiStyleConfig("SelectPopover", { hasFooter });
    const Wrapper = removePortal ? Fragment$1 : Portal;
    return (jsx(Wrapper, { children: jsx(RemoveScroll, { enabled: isOpen, children: jsx(PopoverContent$1, { border: "none", "data-testid": dataTestId, borderRadius: "lg", boxShadow: "none !important", outline: "none !important", background: "transparent", opacity: isOpen ? 1 : 0, width: "inherit", "aria-label": "Options", motionProps: dropdownVariants, rootProps: {
                    zIndex: "popover",
                    // https://github.com/chakra-ui/chakra-ui/issues/5865#issuecomment-1503817127
                    minWidth: "max-content",
                }, children: jsx(Box$1, { ref: ref, __css: styles, transition: isOpen ? openPopoverRepositionTransition : undefined, ...props, children: children }) }) }) }));
});
SelectPopover.displayName = "SelectPopover";

const toastActions = {
    toast(options) {
        toast.custom((toastInstance) => (jsx(AnimatePresence, { mode: "wait", children: toastInstance.visible && (jsx(MotionBox
            // Repeated ids get a new createdAt, so the old toast exits before its replacement enters.
            , { ...tooltipVariants, animate: "enter", exit: "exit", children: jsx(Toast, { ...options, onClose: () => {
                        toast.dismiss(toastInstance.id);
                    } }) }, toastInstance.createdAt)) })), {
            id: options.id,
        });
    },
    close(id) {
        toast.dismiss(id);
    },
    closeAll() {
        toast.dismiss();
    },
};
function useToast() {
    return toastActions;
}
// biome-ignore lint/style/useComponentExportOnlyModules: internal component; the module's API is the imperative toast functions
function Toast({ title, message, variant, actionText, onAction, onClose, }) {
    let color = "teal";
    let icon = InformationIcon;
    if (variant === "success") {
        color = "success";
        icon = SuccessIcon;
    }
    if (variant === "warning") {
        color = "warning";
        icon = WarningIcon;
    }
    if (variant === "error") {
        color = "danger";
        icon = ErrorIcon;
    }
    const actionClicked = useCallback(() => {
        onClose();
        if (typeof onAction === "function") {
            onAction();
        }
    }, [onAction, onClose]);
    return (jsxs(Box$1, { display: "flex", alignItems: message ? "start" : "center", gap: 16, bg: "white", borderRadius: "xl", p: 4, shadow: "lg", children: [jsxs(Box$1, { display: "flex", alignItems: message ? "start" : "center", gap: 3, children: [jsx(Flex, { flex: "none", fontSize: "3xl", children: jsx(Icon, { as: icon, color: `${color}.base` }) }), jsxs(Box$1, { flex: "1", minWidth: 0, maxWidth: "360px", children: [jsx(Text$1, { fontWeight: "medium", color: "text.primary", children: title }), message && (jsx(Text$1, { mt: 1, color: "text.secondary", children: message })), message && actionText && (jsx(Box$1, { mt: 3, children: jsx(Button, { onClick: actionClicked, children: actionText }) }))] })] }), jsxs(Box$1, { display: "flex", alignItems: "center", gap: 3, children: [!message && actionText && (jsx(Button, { onClick: actionClicked, children: actionText })), jsx(Box$1, { mt: message ? -1 : 0, children: jsx(IconButton, { "aria-label": "Dismiss", icon: CloseIcon, size: "sm", onClick: onClose }) })] })] }));
}

// Used to identify a badge input option for creating a new option, e.g. "Create 'something'"
const CreatableOption$1 = Symbol("creatable option");
const defaultPasteDelimiters = [",", "\t", ";", Papa.RECORD_SEP, Papa.UNIT_SEP];
function BadgeInput({ isDisabled = false, isLoading = false, isInvalid = false, isValueInvalid, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", supportsCreatableOptions, createOptionMessage = defaultCreateOptionMessage, disableSortingAndFiltering = false, options, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionIconSrc, placeholder = "", removePortal = false, value, size = "md", width = "xs", popoverWidth, onChange, onClose, onCreateOption, onSearchUpdate, pasteDelimiters = defaultPasteDelimiters, onOpen, description, valueLabel = optionLabel, badgeInputRef, _internalRenderLabelContent, }) {
    const { toast } = useToast();
    const [inputValue, setInputValue] = useState("");
    const updateSearch = useCallback((value) => {
        setInputValue(value);
        onSearchUpdate?.(value);
    }, [onSearchUpdate]);
    const selection = useMultipleSelection({
        selectedItems: value,
        onStateChange({ selectedItems: newSelectedItems, type }) {
            switch (type) {
                case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
                case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
                case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem: {
                    onChange(newSelectedItems ?? []);
                    break;
                }
                case useMultipleSelection.stateChangeTypes.SelectedItemClick:
                case useMultipleSelection.stateChangeTypes
                    .SelectedItemKeyDownNavigationNext:
                case useMultipleSelection.stateChangeTypes
                    .SelectedItemKeyDownNavigationPrevious:
                case useMultipleSelection.stateChangeTypes
                    .DropdownKeyDownNavigationPrevious:
                case useMultipleSelection.stateChangeTypes.DropdownClick:
                case useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
                case useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
                case useMultipleSelection.stateChangeTypes.FunctionSetActiveIndex:
                case useMultipleSelection.stateChangeTypes.FunctionReset: {
                    break;
                }
            }
        },
        onSelectedItemsChange({ selectedItems }) {
            onChange(selectedItems ?? []);
        },
    });
    const filteredOptions = useMemo(() => {
        // Exclude all options that are already selected
        const unselectedOptions = options.filter((option) => {
            const isSelected = value.some((valueItem) => {
                return isEqual(optionValue(option), valueItem);
            });
            return !isSelected;
        });
        if (inputValue.length === 0 || disableSortingAndFiltering) {
            return unselectedOptions;
        }
        return matchSorter(unselectedOptions, inputValue, {
            keys: [optionLabel],
        });
    }, [
        options,
        optionLabel,
        optionValue,
        disableSortingAndFiltering,
        inputValue,
        value,
    ]);
    const optionLabels = useMemo(() => new Set(options.map((option) => optionLabel(option))), [options, optionLabel]);
    const isCreating = supportsCreatableOptions &&
        inputValue.length > 0 &&
        !optionLabels.has(inputValue);
    const isNewValueEqualToPreviouslySelectedOption = supportsCreatableOptions &&
        filteredOptions.length === 0 &&
        inputValue.length > 0 &&
        optionLabels.has(inputValue);
    const badgeInputOptions = useMemo(() => {
        return isCreating ? [...filteredOptions, CreatableOption$1] : filteredOptions;
    }, [isCreating, filteredOptions]);
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const optionsContainer = useRef(null);
    const { virtualItems, virtualizer } = useVirtualItems({
        options: badgeInputOptions,
        optionLabel,
        containerRef: optionsContainer,
    });
    const handleCreateOption = useCallback(async (value) => {
        if (onCreateOption) {
            void onCreateOption(value);
            updateSearch("");
        }
    }, [onCreateOption, updateSearch]);
    const handlePaste = useCallback((event) => {
        const pasted = event.clipboardData.getData("text/plain");
        event.preventDefault();
        // Use papaparse for robust CSV/TSV/spreadsheet parsing,
        // handling quoted values, escaped quotes, and mixed delimiters.
        // Pipe (`|`) is intentionally omitted from `delimitersToGuess` since
        // it is a valid character in customer-pasted values (e.g. audience filters).
        const parseResult = Papa.parse(pasted, {
            header: false,
            skipEmptyLines: true,
            delimitersToGuess: pasteDelimiters,
        });
        // UndetectableDelimiter is expected for newline-only lists (e.g. one value per line)
        // where papaparse can't find a column delimiter. It still parses correctly.
        const fatalErrors = parseResult.errors.filter((error) => error.code !== "UndetectableDelimiter");
        if (fatalErrors.length > 0) {
            toast({
                id: "badge-input-paste-error",
                title: "Failed to parse pasted content",
                message: fatalErrors[0]?.message,
                variant: "error",
            });
            return;
        }
        // Flatten the 2D array into a 1D array of trimmed, non-empty values
        const pastedValues = parseResult.data
            .flat()
            .map((v) => (typeof v === "string" ? v.trim() : ""))
            .filter((v) => v.length > 0);
        if (pastedValues.length === 0) {
            return;
        }
        const matchedOptionValues = [];
        const unmatchedValues = new Set();
        for (const pastedValue of pastedValues) {
            // Try to match against existing options by label
            const matchedOption = options.find((option) => optionLabel(option) === pastedValue);
            if (matchedOption) {
                const matchedValue = optionValue(matchedOption);
                // Skip if already selected or already queued to add
                const isAlreadySelected = value.some((existing) => isEqual(existing, matchedValue));
                const isAlreadyQueued = matchedOptionValues.some((queued) => isEqual(queued, matchedValue));
                if (!isAlreadySelected && !isAlreadyQueued) {
                    matchedOptionValues.push(matchedValue);
                }
            }
            else if (supportsCreatableOptions &&
                onCreateOption &&
                !unmatchedValues.has(pastedValue)) {
                // Track unmatched values to create via onCreateOption
                const createdValue = pastedValue;
                if (!value.some((existing) => isEqual(existing, createdValue))) {
                    unmatchedValues.add(pastedValue);
                }
            }
        }
        // Add matched options via onChange
        if (matchedOptionValues.length > 0) {
            onChange([...value, ...matchedOptionValues]);
        }
        // Create new options via onCreateOption.
        // Consumers should use functional state updaters (e.g. setValue(prev => [...prev, newValue]))
        // so that multiple calls chain correctly within the same event.
        for (const unmatchedValue of unmatchedValues) {
            void onCreateOption?.(unmatchedValue);
        }
        updateSearch("");
    }, [
        options,
        optionLabel,
        optionValue,
        value,
        onChange,
        onCreateOption,
        supportsCreatableOptions,
        pasteDelimiters,
        toast,
        updateSearch,
    ]);
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            if (!option) {
                return "";
            }
            if (typeof option === "symbol") {
                return inputValue;
            }
            return optionLabel(option);
        },
        stateReducer(state, { type, changes }) {
            switch (type) {
                case useCombobox.stateChangeTypes.ItemClick:
                case useCombobox.stateChangeTypes.InputKeyDownEnter: {
                    return {
                        ...changes,
                        isOpen: true,
                    };
                }
                case useCombobox.stateChangeTypes.InputClick: {
                    return {
                        ...changes,
                        isOpen: state.isOpen,
                    };
                }
                case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
                case useCombobox.stateChangeTypes.InputKeyDownEscape:
                case useCombobox.stateChangeTypes.InputKeyDownHome:
                case useCombobox.stateChangeTypes.InputKeyDownEnd:
                case useCombobox.stateChangeTypes.InputKeyDownPageUp:
                case useCombobox.stateChangeTypes.InputKeyDownPageDown:
                case useCombobox.stateChangeTypes.InputChange:
                case useCombobox.stateChangeTypes.InputBlur:
                case useCombobox.stateChangeTypes.MenuMouseLeave:
                case useCombobox.stateChangeTypes.ItemMouseMove:
                case useCombobox.stateChangeTypes.ToggleButtonClick:
                case useCombobox.stateChangeTypes.FunctionToggleMenu:
                case useCombobox.stateChangeTypes.FunctionOpenMenu:
                case useCombobox.stateChangeTypes.FunctionCloseMenu:
                case useCombobox.stateChangeTypes.FunctionSetHighlightedIndex:
                case useCombobox.stateChangeTypes.FunctionSelectItem:
                case useCombobox.stateChangeTypes.FunctionSetInputValue:
                case useCombobox.stateChangeTypes.FunctionReset:
                case useCombobox.stateChangeTypes
                    .ControlledPropUpdatedSelectedItem:
                    {
                        return changes;
                    }
            }
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen) {
                onOpen?.();
            }
            else {
                onClose?.();
            }
        },
        onStateChange({ type, selectedItem: newSelectedItem, inputValue: newInputValue, }) {
            switch (type) {
                case useCombobox.stateChangeTypes.InputKeyDownEnter:
                case useCombobox.stateChangeTypes.ItemClick: {
                    if (newSelectedItem) {
                        if (typeof newSelectedItem === "symbol") {
                            void handleCreateOption(inputValue ?? "");
                        }
                        else {
                            if (isOptionDisabled(newSelectedItem)) {
                                return;
                            }
                            selection.addSelectedItem(optionValue(newSelectedItem));
                            /**
                             * Occasionally badge inputs that support creatable options bug out.
                             * The newSelectedItem is not a symbol, bc `isCreate` is incorrectly false, while the input value is still set.
                             * It results in the input persisting after creation.
                             * This is a workaround to clear the input value when an existing option is selected.
                             *
                             * We should clear search input after input selection regardless if it supports creatable options or not.
                             */
                            updateSearch("");
                        }
                    }
                    break;
                }
                case useCombobox.stateChangeTypes.InputChange: {
                    updateSearch(newInputValue?.trimStart() ?? "");
                    break;
                }
                case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
                case useCombobox.stateChangeTypes.InputKeyDownEscape:
                case useCombobox.stateChangeTypes.InputKeyDownHome:
                case useCombobox.stateChangeTypes.InputKeyDownEnd:
                case useCombobox.stateChangeTypes.InputKeyDownPageUp:
                case useCombobox.stateChangeTypes.InputKeyDownPageDown:
                case useCombobox.stateChangeTypes.InputBlur:
                case useCombobox.stateChangeTypes.InputClick:
                case useCombobox.stateChangeTypes.MenuMouseLeave:
                case useCombobox.stateChangeTypes.ItemMouseMove:
                case useCombobox.stateChangeTypes.ToggleButtonClick:
                case useCombobox.stateChangeTypes.FunctionToggleMenu:
                case useCombobox.stateChangeTypes.FunctionOpenMenu:
                case useCombobox.stateChangeTypes.FunctionCloseMenu:
                case useCombobox.stateChangeTypes.FunctionSetHighlightedIndex:
                case useCombobox.stateChangeTypes.FunctionSelectItem:
                case useCombobox.stateChangeTypes.FunctionSetInputValue:
                case useCombobox.stateChangeTypes.FunctionReset:
                case useCombobox.stateChangeTypes
                    .ControlledPropUpdatedSelectedItem:
                    {
                        break;
                    }
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        handleCreateOption,
        inputValue,
        isOptionDisabled,
        onClose,
        onOpen,
        optionLabel,
        optionValue,
        selection,
        updateSearch,
        virtualizer,
        virtualItems.length,
    ]);
    const combobox = useCombobox({
        inputId: formControl.id,
        items: badgeInputOptions,
        defaultHighlightedIndex: 0,
        selectedItem: null,
        inputValue,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, combobox.isOpen);
    const getComboboxMenuProps = combobox.getMenuProps;
    const menuProps = useMemo(() => getComboboxMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [getComboboxMenuProps]);
    // Reset input value to empty string, if user hasn't selected any option and input lost focus
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
        // event handler.
        updateSearch("");
    }, [combobox.isOpen, updateSearch]);
    const selectedOptions = useMemo(() => {
        const result = [];
        for (const valueItem of value) {
            const option = options.find((option) => {
                return isEqual(optionValue(option), valueItem);
            });
            if (option) {
                result.push(option);
            }
        }
        return result;
    }, [options, optionValue, value]);
    const styles = useMultiStyleConfig("BadgeInput", { size });
    const optionStyles = useMultiStyleConfig("SelectOption");
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const { isFocusVisible, focusProps } = useFocusRing({
        isTextInput: true,
        within: true,
    });
    const badgesRef = useRef(null);
    const inputRef = useRef(null);
    const comboboxInputRef = useMergeRefs(badgeInputRef, inputRef);
    const inputProps = useMemo(() => combobox.getInputProps({
        ...selection.getDropdownProps({
            ref: comboboxInputRef,
            preventKeyAction: combobox.isOpen,
        }),
        onFocus(event) {
            combobox.openMenu();
            formControl.onFocus(event);
        },
        onBlur: formControl.onBlur,
    }), 
    // TODO(eric.lovett): This deps array is missing `combobox`, `comboboxInputRef`, `formControl`, and `selection` and therefore may
    // be buggy. Please consider adding them.
    [
        combobox.getInputProps,
        selection.getDropdownProps,
        combobox.isOpen,
        combobox.openMenu,
        formControl.onFocus,
        formControl.onBlur,
    ]);
    const handleChange = useComboboxImeSupport(updateSearch, inputProps.onChange);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, isOpen: combobox.isOpen, initialFocusRef: inputRef, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(chakra.div, { __css: styles["badgeInput"], width: width, role: "combobox", "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, "data-selected": selectedOptions.length > 0 ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, "data-testid": "badge-input", onFocus: (event) => {
                            if (typeof focusProps.onFocus === "function") {
                                focusProps.onFocus(event);
                            }
                        }, onBlur: (event) => {
                            if (typeof focusProps.onBlur === "function") {
                                focusProps.onBlur(event);
                            }
                        }, onKeyDown: (event) => {
                            if (event.key === "Escape" && combobox.isOpen) {
                                event.stopPropagation();
                            }
                        }, children: [jsxs(chakra.div, { ref: badgesRef, __css: styles["badges"], onClick: (event) => {
                                    // Focus text input when user clicks on whitespace
                                    if (event.target === badgesRef.current) {
                                        inputRef.current?.focus();
                                    }
                                }, children: [selectedOptions.map((selectedOption, index) => {
                                        const iconSrc = typeof optionIconSrc === "function"
                                            ? optionIconSrc(selectedOption)
                                            : undefined;
                                        const isSelectedValueInvalid = isValueInvalid?.(selectedOption) ?? false;
                                        return (jsx(Badge, { variant: isSelectedValueInvalid ? "error" : undefined, "data-invalid": isSelectedValueInvalid ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-testid": "badge-input-selected-option", iconSrc: iconSrc, size: size === "sm" ? "sm" : "md", ...(formControl.disabled
                                                ? {}
                                                : selection.getSelectedItemProps({
                                                    selectedItem: optionValue(selectedOption),
                                                    index,
                                                })), rightActionProps: formControl.disabled
                                                ? undefined
                                                : {
                                                    icon: CloseIcon,
                                                    "aria-label": "remove",
                                                    "data-testid": "badge-input-selected-option-remove",
                                                    onClick: () => {
                                                        if (formControl.disabled) {
                                                            return;
                                                        }
                                                        selection.removeSelectedItem(optionValue(selectedOption));
                                                        inputRef.current?.focus(); // Keep focus on the input so it remains open.
                                                    },
                                                }, children: valueLabel(selectedOption) }, optionLabel(selectedOption)));
                                    }), jsx(chakra.div, { __css: styles["inputContainer"], children: jsx(chakra.input
                                        // Ask 1Password to not autofill this input and not show their icon inside
                                        , { "data-1p-ignore": true, __css: styles["input"], type: "text", "aria-label": placeholder ??
                                                `Search ${supportsCreatableOptions ? "or add new tags" : "tags"}`, placeholder: value.length === 0 ? placeholder : undefined, disabled: formControl.disabled, "data-testid": "badge-input-input", ...inputProps, onChange: handleChange, onPaste: handlePaste }) })] }), isLoading ? (jsx(chakra.div, { __css: styles["spinnerContainer"], children: jsx(Spinner, { size: "sm" }) })) : (jsx(chakra.button, { __css: styles["toggleButton"], type: "button", disabled: formControl.disabled, "data-testid": "badge-input-toggle", ...combobox.getToggleButtonProps(), "aria-label": "Toggle options", children: jsx(chakra.div, { as: SelectorIcon, __css: styles["toggleButtonIcon"] }) }))] }) }), jsxs(SelectPopover, { isOpen: combobox.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "badge-input-popover", ...menuProps, children: [virtualItems.length === 0 && (jsx(SelectEmptyState, { children: isNewValueEqualToPreviouslySelectedOption
                                ? `"${inputValue}" has already been selected`
                                : emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    const isOption = virtualItem.type === "option";
                                    const iconSrc = isOption
                                        ? optionIconSrc?.(virtualItem.option)
                                        : null;
                                    const disabledMessageOrBoolean = virtualItem.type === "option"
                                        ? isOptionDisabled(virtualItem.option)
                                        : undefined;
                                    return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], position: "absolute", style: {
                                            transform: `translateY(${start}px)`,
                                        }, children: [virtualItem.type === "creatable-option" && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, "data-index": index, ...combobox.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: CreatableOption$1,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        combobox.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { children: createOptionMessage(inputValue) }) })), isOption && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, leftAccessory: iconSrc
                                                    ? { type: "image", url: iconSrc }
                                                    : undefined, ...combobox.getItemProps({
                                                    id: `${formControl.id}-option-${virtualItem.index}`,
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        combobox.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                }) }) })), description && (jsx(chakra.div, { __css: {
                                ...optionStyles["option"],
                                borderTopWidth: "hairline",
                                borderColor: "base.border",
                                fontSize: "sm",
                                color: "text.secondary",
                            }, children: description }))] })] }) }));
}

const MenuIconButton = forwardRef$1(function MenuIconButton_({ variant = "tertiary", ...props }, ref) {
    return (jsx(MenuButton$1, { ref: ref, as: IconButton, variant: variant, ...props }));
});
MenuIconButton.displayName = "MenuIconButton";

const MenuActionsButton = forwardRef$1(function MenuActionsButton_(props, ref) {
    return (jsx(MenuIconButton, { ref: ref, icon: OverflowMenuIcon, ...props, "aria-label": props["aria-label"] ?? "Actions" }));
});
MenuActionsButton.displayName = "MenuActionsButton";

const menuContext = createContext({});
const MenuContextProvider = menuContext.Provider;
const useMenuContext = () => useContext(menuContext);

const MenuItem = forwardRef(function MenuItem_({ icon, variant, iconColor, autofocus, ...props }, propsRef) {
    const { initialFocusRef } = useMenuContext();
    const ref = useMergeRefs(propsRef, autofocus ? initialFocusRef : undefined);
    return (jsx(MenuItem$1, { ref: ref, fontWeight: "medium", icon: icon ? (jsx(Icon, { as: icon, boxSize: 5, color: iconColor ??
                (variant === "danger" ? "text.danger" : "text.tertiary") })) : undefined, color: variant === "danger" ? "text.danger" : "text.primary", _hover: {
            bg: variant === "danger" ? "danger.background" : "base.background",
            color: variant === "danger" ? "danger.hover" : "text.primary",
        }, sx: {
            "&:hover .chakra-icon": {
                color: variant === "danger" ? "danger.hover" : "text.primary",
            },
        }, ...props }));
});
MenuItem.displayName = "MenuItem";

const Breadcrumbs = forwardRef$1(function Breadcrumbs_({ items, linkComponent = "a", "aria-label": ariaLabel = "Breadcrumb", ...props }, ref) {
    const styles = useMultiStyleConfig("Breadcrumbs");
    const navRef = useRef(null);
    const listRef = useRef(null);
    const itemRefs = useRef([]);
    const labelRefs = useRef([]);
    const overflowRef = useRef(null);
    const separatorRef = useRef(null);
    const triggerRef = useRef(null);
    const menuRef = useRef(null);
    const mergedRef = useMergeRefs(ref, navRef);
    const [overflowCount, setOverflowCount] = useState(0);
    const measuredCount = useRef(0);
    const hiddenCount = Math.min(overflowCount, Math.max(0, items.length - 2));
    const [isOpen, setIsOpen] = useState(false);
    const [restoreNavigationFocus, setRestoreNavigationFocus] = useState(false);
    useSafeLayoutEffect(() => {
        const nav = navRef.current;
        const list = listRef.current;
        const overflow = overflowRef.current;
        if (!nav || !list || !overflow)
            return;
        const measure = () => {
            const gap = Number(getComputedStyle(list).columnGap.replace("px", "")) || 0;
            const separatorWidth = separatorRef.current?.getBoundingClientRect().width ?? 0;
            const widths = labelRefs.current
                .slice(0, items.length)
                .map((label) => label?.getBoundingClientRect().width ?? 0);
            const step = separatorWidth + gap * 2;
            const width = widths.reduce((total, itemWidth) => total + itemWidth, 0) +
                (items.length - 1) * step;
            const count = items.length > 3 || (items.length > 2 && width > nav.clientWidth)
                ? items.length - 2
                : 0;
            const activeElement = nav.ownerDocument.activeElement;
            const hidesFocusedItem = itemRefs.current
                .slice(1, count + 1)
                .some((item) => item?.contains(activeElement));
            const hidesFocusedMenu = (count === 0 && overflow.contains(activeElement)) ||
                (count !== measuredCount.current &&
                    menuRef.current?.contains(activeElement));
            if (hidesFocusedItem || hidesFocusedMenu)
                setRestoreNavigationFocus(true);
            if (count !== measuredCount.current)
                setIsOpen(false);
            measuredCount.current = count;
            setOverflowCount(count);
        };
        // Keep live labels mounted once; measure hidden ancestors without duplicating their subscriptions.
        const observer = new ResizeObserver(measure);
        observer.observe(nav);
        for (const item of itemRefs.current.slice(0, items.length)) {
            if (item)
                observer.observe(item);
        }
        const mutationObserver = new MutationObserver(measure);
        mutationObserver.observe(list, {
            childList: true,
            subtree: true,
            characterData: true,
        });
        measure();
        return () => {
            observer.disconnect();
            mutationObserver.disconnect();
        };
    }, [items.length]);
    useEffect(() => {
        if (!restoreNavigationFocus)
            return;
        setRestoreNavigationFocus(false);
        const nav = navRef.current;
        // Preserve focus when resizing or navigation removes its target, unless the caller moved it.
        if (!nav)
            return;
        const activeElement = nav.ownerDocument.activeElement;
        const focusIsHidden = itemRefs.current
            .slice(1, hiddenCount + 1)
            .some((item) => item?.contains(activeElement)) ||
            (hiddenCount === 0 && overflowRef.current?.contains(activeElement));
        if (activeElement === nav.ownerDocument.body || focusIsHidden) {
            const target = hiddenCount > 0 ? triggerRef.current : nav;
            target?.focus({ preventScroll: true });
        }
    }, [hiddenCount, restoreNavigationFocus]);
    const hiddenItems = items.slice(1, hiddenCount + 1);
    if (items.length === 0)
        return null;
    return (jsx(chakra.nav, { ref: mergedRef, "aria-label": ariaLabel, tabIndex: -1, __css: styles.container, ...props, children: jsx(chakra.ol, { ref: listRef, __css: styles.list, children: items.map((item, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: Hierarchy positions stay stable when live labels change or repeat.
            jsxs(Fragment$1, { children: [jsxs(chakra.li, { ref: (element) => {
                            itemRefs.current[index] = element;
                        }, "aria-hidden": (index > 0 && index <= hiddenCount) || undefined, "data-hidden": index > 0 && index <= hiddenCount ? "" : undefined, "data-current": index === items.length - 1 ? "" : undefined, __css: styles.item, children: [index > 0 && (jsx(Box, { as: ChevronRightIcon, "aria-hidden": true, __css: styles.separator })), jsx(chakra.span, { as: item.href ? linkComponent : item.onClick ? "button" : "span", href: item.href, type: !item.href && item.onClick ? "button" : undefined, onClick: item.href || item.onClick
                                    ? () => {
                                        setRestoreNavigationFocus(true);
                                        item.onClick?.();
                                    }
                                    : undefined, "aria-label": item["aria-label"], "aria-current": index === items.length - 1 && !item.href && !item.onClick
                                    ? "page"
                                    : undefined, "data-group": item.href || item.onClick ? "" : undefined, __css: item.href || item.onClick ? styles.link : styles.label, children: jsx(TextWithTooltip, { size: "sm", color: "inherit", message: item.label, children: jsxs(chakra.span, { ref: (element) => {
                                            labelRefs.current[index] = element;
                                        }, __css: styles.labelContent, children: [item.icon && (jsx(chakra.span, { __css: styles.iconContainer, children: jsx(Box, { as: item.icon, "aria-hidden": true, __css: styles.icon }) })), item.label] }) }) })] }), index === 0 && (jsxs(chakra.li, { ref: overflowRef, "aria-hidden": hiddenCount === 0 || undefined, "data-hidden": hiddenCount === 0 ? "" : undefined, __css: styles.overflowItem, children: [jsx(Box, { ref: separatorRef, as: ChevronRightIcon, "aria-hidden": true, __css: styles.separator }), jsxs(Menu$1, { computePositionOnMount: true, variant: "breadcrumb", isOpen: isOpen, onOpen: () => setIsOpen(true), onClose: () => setIsOpen(false), children: [jsx(MenuActionsButton, { ref: triggerRef, size: "xs", "aria-label": "Show hidden breadcrumbs" }), hiddenCount > 0 && (jsx(Portal, { children: jsx(BreadcrumbMenuList, { menuRef: menuRef, children: jsx(chakra.div, { __css: styles.menuItems, children: hiddenItems.map((hiddenItem, hiddenIndex) => (jsxs(MenuItem
                                                // biome-ignore lint/suspicious/noArrayIndexKey: Repeated names still represent distinct hierarchy positions.
                                                , { as: hiddenItem.href ? linkComponent : "button", type: hiddenItem.href ? undefined : "button", href: hiddenItem.href, "aria-label": hiddenItem["aria-label"], isDisabled: !hiddenItem.href && !hiddenItem.onClick, "data-group": true, onClick: () => {
                                                        setRestoreNavigationFocus(true);
                                                        hiddenItem.onClick?.();
                                                    }, children: [hiddenItem.icon && (jsx(Box, { as: hiddenItem.icon, "aria-hidden": true, __css: styles.menuIcon })), jsx(TextWithTooltip, { size: "sm", color: "inherit", message: hiddenItem.label, children: hiddenItem.label })] }, hiddenIndex))) }) }) }))] })] }))] }, index))) }) }));
});
Breadcrumbs.displayName = "Breadcrumbs";
function BreadcrumbMenuList({ menuRef, children, }) {
    const { focusedIndex } = useMenuContext$1();
    const descendants = useMenuDescendantsContext();
    return (jsx(MenuList$1, { ref: menuRef, motionProps: dropdownVariants, onFocus: (event) => {
            if (event.target !== event.currentTarget)
                return;
            // Chakra v2 can focus the list after its item. Preserve the active item
            // (including ArrowUp's last item) instead of leaving focus on the list.
            const item = descendants.item(focusedIndex) ?? descendants.firstEnabled();
            item?.node.focus({ preventScroll: true });
        }, children: children }));
}

const Checkbox = forwardRef$1(function Checkbox_({ id, "aria-label": ariaLabel = "Select checkbox", isChecked, isDisabled = false, isIndeterminate = false, label, badge, description, onChange, ...props }, ref) {
    return (jsxs(Box$1, { display: "flex", flexDirection: "column", alignItems: "start", ...props, children: [jsxs(Box$1, { ref: ref, display: "flex", alignItems: "center", gap: 2, children: [jsx(Checkbox$1, { id: id, "aria-label": label ?? ariaLabel, isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, onChange: onChange, children: label }), label && badge] }), description && (jsx(Text$1, { mt: 1, pl: 6, color: "text.secondary", sx: {
                    [cssVar("hightouch-text-color").variable]: "text.secondary",
                }, children: description }))] }));
});
Checkbox.displayName = "Checkbox";

function CheckboxGroup(props) {
    return jsx(VStack, { align: "start", spacing: 4, ...props });
}

function ClipboardButton({ text, size = "md", ...props }) {
    const { toast } = useToast();
    const { onCopy } = useClipboard(text);
    const copy = useCallback(() => {
        onCopy();
        toast({
            variant: "success",
            id: "copy-to-clipboard",
            title: "Copied to clipboard",
        });
    }, [onCopy, toast]);
    return (jsx(Tooltip, { message: "Copy to clipboard", ...props, children: jsx(IconButton, { size: size, "aria-label": "Copy to clipboard", icon: CopyIcon, onClick: copy }) }));
}

function Code({ children }) {
    return jsx(Code$1, { children: children });
}

// See https://css-tricks.com/click-once-select-all-click-again-select-normally/
const selectAnimation = keyframes `
    to { user-select: text; }
`;
function CodeSnippet({ code, label, variant = "base", hasCopyButton = true, ...props }) {
    const formattedCode = useMemo(() => {
        return stripIndent(code).trim();
    }, [code]);
    return (jsxs(Box$1, { bg: variant === "base" ? "base.lightBackground" : "white", borderWidth: "hairline", borderStyle: "solid", borderColor: "base.border", borderRadius: "xl", color: "text.primary", position: "relative", overflow: "auto", boxShadow: "buttonShadowLight", ...props, children: [label ? (jsxs(Box$1, { bg: "base.background", alignItems: "center", borderTopRadius: "base", fontWeight: "semibold", borderBottomWidth: "hairline", borderBottomStyle: "solid", borderColor: "base.border", display: "flex", justifyContent: "space-between", pl: 3, pr: 1, py: 1, children: [jsx(Text, { isTruncated: true, children: label }), hasCopyButton && (jsx(Box$1, { sx: {
                            button: {
                                _hover: {
                                    bg: "base.backgroundHover",
                                },
                            },
                        }, children: jsx(ClipboardButton, { text: formattedCode }) }))] })) : (hasCopyButton && (jsx(Box$1, { position: "absolute", top: 1, right: 1, sx: {
                    button: {
                        bg: "base.lightBackground",
                        _hover: {
                            bg: "base.backgroundHover",
                        },
                    },
                }, children: jsx(ClipboardButton, { text: formattedCode }) }))), jsx(chakra.pre, { overflow: "auto", overscrollBehaviorX: "contain", px: 3, py: 2, color: "text.primary", children: jsx(Box$1, { as: "code", fontSize: "md", textStyle: "mono", tabIndex: 0, userSelect: "all", _focus: {
                        animation: `${selectAnimation} 100ms step-end forwards`,
                    }, children: formattedCode }) })] }));
}

const Column = forwardRef(function Column_({ style, surface, bg, bgColor, background, backgroundColor, ...props }, ref) {
    const mergedStyle = useSurfaceStyle({
        surface,
        bg,
        bgColor,
        background,
        backgroundColor,
        style,
    });
    return (jsx(Flex, { ref: ref, bg: bg, bgColor: bgColor, background: background, backgroundColor: backgroundColor, ...props, direction: "column", style: mergedStyle }));
});
Column.displayName = "Column";

function SelectClearButton({ onClick, ...props }) {
    const styles = useMultiStyleConfig("SelectClearButton");
    return (jsx(chakra.button, { __css: styles["button"], "aria-label": "Clear selection", "data-testid": "select-clear", onClick: (event) => {
            event.stopPropagation();
            onClick?.(event);
        }, ...props, children: jsx(Icon, { as: CloseIcon, __css: styles["icon"] }) }));
}

const ComboboxControl = forwardRef$1(function ComboboxControl_(props, ref) {
    const styles = useMultiStyleConfig("Combobox");
    return (jsx(chakra.div, { ref: ref, role: "combobox", __css: styles["control"], ...props }));
});
ComboboxControl.displayName = "ComboboxControl";

const ComboboxInput = forwardRef$1(function ComboboxInput_(props, ref) {
    const styles = useMultiStyleConfig("Combobox");
    return (jsx(chakra.input, { ref: ref, "data-1p-ignore": true, __css: styles["input"], type: "text", ...props }));
});
ComboboxInput.displayName = "ComboboxInput";

const ComboboxToggleButton = forwardRef$1(function ComboboxToggleButton_(props, ref) {
    const styles = useMultiStyleConfig("Combobox");
    return (jsx(chakra.button, { ref: ref, "aria-label": "Toggle options", __css: styles["toggleButton"], type: "button", tabIndex: -1, ...props, children: jsx(chakra.div, { as: SelectorIcon, __css: styles["toggleButtonIcon"] }) }));
});
ComboboxToggleButton.displayName = "ComboboxToggleButton";

const SelectToggleButton = forwardRef$1(function SelectToggleButton_({ size, ...props }, ref) {
    const styles = useMultiStyleConfig("Select", { size });
    return (jsx(chakra.button, { ref: ref, __css: styles["toggleButton"], type: "button", ...props, "aria-label": props["aria-label"]
            ? `${props["aria-label"]}, press to show options`
            : "Toggle options menu" }));
});
SelectToggleButton.displayName = "SelectToggleButton";

const SearchInput = forwardRef$1(function SearchInput_({ autoFocus = false, placeholder, value, width = "xs", size = "md", onChange, onKeyDown, onKeyUp, onFocus, onBlur, ...props }, ref) {
    const styles = useMultiStyleConfig("Input", { size });
    const skeleton = useContext(SkeletonContext);
    return (jsxs(InputGroup, { width: width, size: size, ...props, children: [jsx(chakra.div, { as: InputLeftElement, __css: styles["leftElement"], children: jsx(chakra.div, { as: SearchIcon, __css: styles["leftIcon"] }) }), jsx(Input, { ref: ref, isDisabled: skeleton, autoFocus: autoFocus, type: "search", placeholder: placeholder, value: value, size: size, onChange: onChange, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onFocus: onFocus, onBlur: onBlur })] }));
});
SearchInput.displayName = "SearchInput";

// Used to identify a combobox option for creating a new option, e.g. "Create 'something'"
const CreatableOption = Symbol("creatable option");
function Combobox({ headerLabel, headerDescription, isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isLazy = true, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", supportsCreatableOptions = false, createOptionMessage = defaultCreateOptionMessage, disableSortingAndFiltering = false, options, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionAccessories, placeholder = "", removePortal = false, renderInputInControl: renderInputInControlProp = true, trigger, value, variant = "default", fontWeight = "normal", size = "md", width = "xs", popoverWidth, onChange, onClose, onCreateOption, onSearchUpdate, onOpen, valueLabel = optionLabel, comboboxRef, showPlaceholderIcon = false, _internalRenderLabelContent, }) {
    trigger ||= { type: "input" };
    const inputRef = useRef(null);
    const comboboxId = useId();
    // Always render the search bar in the popover for icon trigger,
    // otherwise use the provided renderInputInControl prop
    const renderInputInControl = trigger.type === "input" ? renderInputInControlProp : false;
    const formControl = useFormControl({
        id: `combobox-${comboboxId}`,
        isDisabled,
        isInvalid,
    });
    const selectedOption = useMemo(() => {
        if (value === undefined || value === null) {
            return;
        }
        const foundOption = options.find((option) => {
            return isEqual(optionValue(option), value);
        });
        return foundOption;
    }, [options, optionValue, value]);
    const [isFiltering, setIsFiltering] = useState(false);
    const [inputValue, setInputValue] = useState(() => {
        return selectedOption ? optionLabel(selectedOption) : "";
    });
    const updateSearch = useCallback((value) => {
        setInputValue(value);
        onSearchUpdate?.(value);
    }, [onSearchUpdate]);
    const filteredOptions = useMemo(() => {
        if (!isFiltering || inputValue.length === 0 || disableSortingAndFiltering) {
            return options;
        }
        return matchSorter(options, inputValue, {
            keys: [optionLabel, optionDescription],
        });
    }, [
        disableSortingAndFiltering,
        isFiltering,
        options,
        optionLabel,
        optionDescription,
        inputValue,
    ]);
    const optionLabels = useMemo(() => new Set(filteredOptions.map((option) => optionLabel(option))), [filteredOptions, optionLabel]);
    const isCreating = supportsCreatableOptions &&
        inputValue.length > 0 &&
        !optionLabels.has(inputValue);
    const comboboxOptions = useMemo(() => {
        return isCreating ? [...filteredOptions, CreatableOption] : filteredOptions;
    }, [isCreating, filteredOptions]);
    const optionsContainer = useRef(null);
    const { virtualItems, virtualizer } = useVirtualItems({
        options: comboboxOptions,
        optionLabel,
        containerRef: optionsContainer,
    });
    const blurInput = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.blur();
        }
    }, []);
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            if (!option) {
                return "";
            }
            if (typeof option === "symbol") {
                return inputValue;
            }
            return optionLabel(option);
        },
        onInputValueChange({ inputValue }) {
            updateSearch(inputValue?.trimStart() ?? "");
        },
        onSelectedItemChange({ selectedItem }) {
            // Selected item is a symbol, when user chooses to create a new option
            if (typeof selectedItem === "symbol") {
                if (typeof onCreateOption === "function") {
                    updateSearch("");
                    void onCreateOption(inputValue ?? "");
                }
                return;
            }
            if (selectedItem) {
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                onChange(optionValue(selectedItem));
            }
            else if (isClearable) {
                onChange(undefined);
            }
            blurInput();
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen) {
                if (!renderInputInControl) {
                    // Clear input value when combobox is opened
                    updateSearch("");
                }
                onOpen?.();
            }
        },
        stateReducer(state, { type, changes }) {
            if (type === useCombobox.stateChangeTypes.InputClick) {
                return {
                    ...changes,
                    isOpen: state.isOpen,
                };
            }
            if (type === useCombobox.stateChangeTypes.InputChange) {
                return {
                    ...changes,
                    highlightedIndex: 0,
                };
            }
            // If it's an item click and the item is disabled, prevent the popover from closing
            if ((type === useCombobox.stateChangeTypes.ItemClick ||
                type === useCombobox.stateChangeTypes.InputKeyDownEnter) &&
                changes.selectedItem) {
                const clickedItem = options.find((option) => typeof changes.selectedItem !== "symbol" &&
                    changes.selectedItem &&
                    optionValue(option) === optionValue(changes.selectedItem));
                if (clickedItem && isOptionDisabled(clickedItem)) {
                    return state;
                }
            }
            return changes;
        },
        onStateChange(changes) {
            if (changes.type === useCombobox.stateChangeTypes.InputChange) {
                setIsFiltering(true);
            }
            if (changes.type ===
                useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem ||
                changes.type === useCombobox.stateChangeTypes.InputBlur) {
                setIsFiltering(false);
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        blurInput,
        inputValue,
        isClearable,
        isOptionDisabled,
        onChange,
        onOpen,
        options,
        renderInputInControl,
        updateSearch,
        optionLabel,
        optionValue,
        virtualizer,
        virtualItems.length,
        onCreateOption,
    ]);
    const combobox = useCombobox({
        inputId: formControl.id,
        items: comboboxOptions,
        inputValue,
        selectedItem: selectedOption ?? null,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, combobox.isOpen);
    const menuProps = useMemo(() => combobox.getMenuProps({
        // Don't apply role="listbox" to the popover container
        role: undefined,
        id: `${formControl.id}-popup`,
    }, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [combobox, formControl.id]);
    const colorScheme = combobox.isOpen ? "open" : "closed";
    // Reset combobox input value to selected option's label, if
    // user typed something else, but didn't select another option.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (combobox.selectedItem &&
            typeof combobox.selectedItem !== "symbol" &&
            optionLabel(combobox.selectedItem) !== inputValue) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch(optionLabel(combobox.selectedItem));
        }
    }, [
        combobox.isOpen,
        inputValue,
        combobox.selectedItem,
        optionLabel,
        updateSearch,
    ]);
    // Reset combobox input value to empty string, if user hasn't
    // selected any option and there was no selected option before that.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (!combobox.selectedItem) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch("");
        }
    }, [combobox.isOpen, combobox.selectedItem, updateSearch]);
    const showClearButton = isClearable && Boolean(selectedOption);
    const selectedOptionAccessories = selectedOption && typeof optionAccessories === "function"
        ? optionAccessories(selectedOption)
        : undefined;
    const { isFocusVisible, focusProps } = useFocusRing({ isTextInput: true });
    const comboboxInputRef = useMergeRefs(comboboxRef, inputRef);
    const inputProps = combobox.getInputProps({
        ref: comboboxInputRef,
        "aria-controls": `${formControl.id}-listbox`,
        onFocus(event) {
            combobox.openMenu();
            formControl.onFocus(event);
            if (typeof focusProps.onFocus === "function") {
                focusProps.onFocus(event);
            }
        },
        onBlur(event) {
            formControl.onBlur(event);
            if (typeof focusProps.onBlur === "function") {
                focusProps.onBlur(event);
            }
        },
        onKeyDown(event) {
            if (event.key === "Escape" && combobox.isOpen) {
                event.stopPropagation();
            }
            // Close the combobox when Tab is pressed, restoring focus to the toggle button
            if (!renderInputInControl && event.key === "Tab") {
                combobox.closeMenu();
                event.preventDefault();
            }
        },
    }, { suppressRefError: true });
    const handleChange = useComboboxImeSupport(updateSearch, inputProps.onChange);
    const styles = useMultiStyleConfig("Combobox", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    const setComboboxHighlightedIndex = combobox.setHighlightedIndex;
    const handleMouseLeave = useCallback(() => {
        setComboboxHighlightedIndex(-1);
    }, [setComboboxHighlightedIndex]);
    const ariaLabelFallback = placeholder && placeholder.length > 0 ? placeholder : "Toggle options";
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: isLazy, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused when the input
            // is in the toggle button.
            autoFocus: !renderInputInControl, isOpen: combobox.isOpen, initialFocusRef: inputRef, placement: "bottom-start", returnFocusOnClose: !renderInputInControl, closeOnBlur: false, onClose: onClose, children: [jsx(PopoverTrigger$1, { children: trigger.type === "input" && renderInputInControl ? (jsxs(ComboboxControl, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, __css: styles["control"], "data-selected": selectedOption ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, width: width, "data-testid": "combobox", children: [selectedOptionAccessories?.leftAccessory ? (jsx(IconAccessory, { accessory: selectedOptionAccessories.leftAccessory })) : showPlaceholderIcon &&
                                optionAccessories &&
                                !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(ComboboxInput, { __css: styles["input"], cursor: combobox.isOpen ? "text" : "pointer", disabled: formControl.disabled, placeholder: placeholder, "data-testid": "combobox-input", ...inputProps, onChange: handleChange }), selectedOptionAccessories?.rightAccessory && (jsx(IconAccessory, { accessory: selectedOptionAccessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: combobox.reset })) : (jsx(ComboboxToggleButton, { disabled: formControl.disabled, ...combobox.getToggleButtonProps({
                                        "aria-label": selectedOption
                                            ? valueLabel(selectedOption)
                                            : ariaLabelFallback,
                                    }) })))] })) : trigger.type === "component" ? (trigger.component({
                        isDisabled: formControl.disabled,
                        isLoading: isLoading,
                        onClick: combobox.openMenu,
                        ...combobox.getToggleButtonProps({
                            "aria-label": selectedOption
                                ? valueLabel(selectedOption)
                                : ariaLabelFallback,
                            tabIndex: 0,
                        }),
                    })) : trigger.type === "icon" ? (jsx(IconButton, { isDisabled: formControl.disabled, isLoading: isLoading, icon: trigger.icon, variant: variant === "tertiary" ? "tertiary" : "secondary", size: size, shape: trigger.shape, onClick: combobox.openMenu, ...combobox.getToggleButtonProps({
                            "aria-label": selectedOption
                                ? valueLabel(selectedOption)
                                : ariaLabelFallback,
                            tabIndex: 0,
                        }) })) : (jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, "aria-haspopup": "dialog", __css: styles["control"], "data-selected": selectedOption ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, disabled: formControl.disabled, width: width, ...combobox.getToggleButtonProps({
                            "aria-label": selectedOption
                                ? valueLabel(selectedOption)
                                : ariaLabelFallback,
                            tabIndex: 0,
                        }), children: [selectedOptionAccessories?.leftAccessory ? (jsx(IconAccessory, { accessory: selectedOptionAccessories.leftAccessory })) : showPlaceholderIcon &&
                                optionAccessories &&
                                !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(chakra.span, { __css: styles["value"], "data-placeholder": selectedOption || formControl.disabled ? undefined : "true", children: selectedOption
                                    ? _internalRenderLabelContent
                                        ? _internalRenderLabelContent(selectedOption)
                                        : valueLabel(selectedOption)
                                    : placeholder }), selectedOptionAccessories?.rightAccessory && (jsx(IconAccessory, { accessory: selectedOptionAccessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: combobox.reset })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["toggleButtonIcon"] })))] })) }), jsxs(SelectPopover, { isOpen: combobox.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "combobox-popover", ...menuProps, children: [!renderInputInControl && (jsx(Box, { px: 2, pt: 2, 
                            // Prevent the popover from closing when the user clicks on the search input
                            onMouseUp: (event) => {
                                event.stopPropagation();
                            }, children: jsx(SearchInput, { autoFocus: true, width: "auto", placeholder: placeholder, "aria-label": placeholder || "Search", "aria-invalid": formControl["aria-invalid"], "aria-describedby": formControl["aria-describedby"], "aria-required": formControl["aria-required"], "data-testid": "combobox-search-input", ...inputProps, onChange: handleChange }) })), headerLabel && (jsxs(chakra.div, { __css: selectOptionsStyles["header"], children: [jsx(Text, { fontWeight: "medium", children: headerLabel }), headerDescription && (jsx(Text, { color: "text.secondary", children: headerDescription }))] })), virtualItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], role: "listbox", id: `${formControl.id}-listbox`, onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    const isOption = virtualItem.type === "option";
                                    const accessories = isOption && "option" in virtualItem
                                        ? optionAccessories?.(virtualItem.option)
                                        : null;
                                    const disabledMessageOrBoolean = isOption && "option" in virtualItem
                                        ? isOptionDisabled(virtualItem.option)
                                        : undefined;
                                    return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], position: "absolute", style: {
                                            transform: `translateY(${start}px)`,
                                        }, children: [virtualItem.type === "creatable-option" && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, "data-index": index, ...combobox.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: CreatableOption,
                                                    index: virtualItem.index,
                                                    onMouseLeave: handleMouseLeave,
                                                }), children: jsx(SelectOptionLabel, { children: createOptionMessage(inputValue) }) })), isOption && (jsx(SelectOption, { "data-index": index, isHighlighted: combobox.highlightedIndex === virtualItem.index, isSelected: selectedOption &&
                                                    optionValue(selectedOption) ===
                                                        optionValue(virtualItem.option), isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, ...accessories, ...combobox.getItemProps({
                                                    id: `${formControl.id}-option-${virtualItem.index}`,
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        combobox.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                }) }) }))] })] }) }));
}

function ConfirmationDialog({ isOpen, isConfirmButtonDisabled = false, title, children, cancelButtonText = "Cancel", confirmButtonText, variant, width = "sm", onClose, onCancel, onConfirm, }) {
    const cancelButton = useRef(null);
    const canceled = useCallback(() => {
        if (typeof onCancel === "function") {
            onCancel();
        }
        onClose();
    }, [onCancel, onClose]);
    const [isConfirming, setIsConfirming] = useState(false);
    const confirmed = useCallback(async () => {
        const promise = onConfirm();
        if (promise instanceof Promise) {
            try {
                setIsConfirming(true);
                await promise;
            }
            finally {
                setIsConfirming(false);
            }
        }
        onClose();
    }, [onConfirm, onClose]);
    return (jsx(Portal$1, { appendToParentPortal: false, children: jsx(AlertDialog, { isCentered: true, isOpen: isOpen, leastDestructiveRef: cancelButton, onClose: onClose, children: jsx(AlertDialogOverlay, { children: jsxs(AlertDialogContent, { w: width, motionProps: popoverVariants, children: [jsxs(AlertDialogHeader, { children: [variant !== "neutral" && (jsx(Box$1, { as: variant === "danger" ? ErrorIcon : WarningIcon, color: `${variant}.base`, fontSize: "3xl" })), title] }), jsx(AlertDialogBody, { children: children }), jsx(AlertDialogFooter, { children: jsxs(ButtonGroup, { children: [jsx(Button, { ref: cancelButton, isDisabled: isConfirming, onClick: canceled, children: cancelButtonText }), jsx(Button, { isLoading: isConfirming, isDisabled: isConfirmButtonDisabled, variant: variant === "danger" ? "danger" : "primary", onClick: confirmed, children: confirmButtonText })] }) })] }) }) }) }));
}

const Definition = forwardRef(function Definition_({ message, placement = "top", children, size = "md", color, ...rest }, ref) {
    const styles = useStyleConfig("Definition", { color, size });
    return (jsx(Tooltip, { message: message, placement: placement, children: jsx(Box$1, { ref: ref, as: "span", __css: styles, size: size, ...rest, children: children }) }));
});
Definition.displayName = "Definition";

const fadeSizePx = 24;
const maskBottom = `linear-gradient(to bottom, black calc(100% - ${fadeSizePx}px), transparent)`;
const maskTop = `linear-gradient(to bottom, transparent, black ${fadeSizePx}px)`;
const maskBoth = `linear-gradient(to bottom, transparent, black ${fadeSizePx}px, black calc(100% - ${fadeSizePx}px), transparent)`;
/**
 * Returns a callback ref and a CSS `mask-image` value that fades the
 * edges of a scrollable container when content overflows.
 *
 * Attach the ref to the scrollable element. The hook observes scroll
 * position and size, returning the appropriate gradient mask:
 * - Bottom fade when scrolled to top
 * - Top fade when scrolled to bottom
 * - Both fades when in the middle
 * - `undefined` when content fits without scrolling
 */
function useScrollOverflowMask() {
    const [element, setElement] = useState(null);
    const [maskImage, setMaskImage] = useState();
    const ref = useCallback((node) => {
        setElement(node);
    }, []);
    useEffect(() => {
        if (!element) {
            // TODO(eric.lovett): This `setMasImage` call should probably be moved to the ref callback.
            setMaskImage(undefined);
            return;
        }
        const update = () => {
            const { scrollTop, scrollHeight, clientHeight } = element;
            const isScrollable = scrollHeight > clientHeight + 1;
            if (!isScrollable) {
                setMaskImage(undefined);
                return;
            }
            const atTop = scrollTop <= 1;
            const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
            if (atTop && atBottom) {
                setMaskImage(undefined);
            }
            else if (atTop) {
                setMaskImage(maskBottom);
            }
            else if (atBottom) {
                setMaskImage(maskTop);
            }
            else {
                setMaskImage(maskBoth);
            }
        };
        update();
        element.addEventListener("scroll", update, { passive: true });
        const observer = new ResizeObserver(update);
        observer.observe(element);
        return () => {
            element.removeEventListener("scroll", update);
            observer.disconnect();
        };
    }, [element]);
    return { ref, maskImage };
}

/**
 * Maps the built-in `headerIcon` values to their icon components.
 */
const headerIconsMap = {
    info: InformationIcon,
    warning: WarningIcon,
    danger: ErrorIcon,
};
function Dialog({ isOpen, variant, title, children, actions, headerIcon, width = "md", height = "auto", maxHeight = "60vh", onClose, bodyRef, }) {
    const builtInIcon = typeof headerIcon === "string" ? headerIconsMap[headerIcon] : undefined;
    const styles = useMultiStyleConfig("Dialog", {
        variant: typeof headerIcon === "string" ? headerIcon : undefined,
    });
    const { ref: scrollRef, maskImage } = useScrollOverflowMask();
    const mergedBodyRef = useMergeRefs(scrollRef, bodyRef);
    return (jsx(Modal, { isCentered: true, isOpen: isOpen, closeOnOverlayClick: variant === "info", variant: "genericDialog", onClose: onClose, children: jsx(ModalOverlay, { children: jsxs(ModalContent, { h: height, w: width, maxW: "100%", maxH: maxHeight, motionProps: popoverVariants, children: [jsxs(ModalHeader, { __css: styles.header, children: [headerIcon ? (jsxs(Row, { gap: 2, children: [builtInIcon ? (jsx(Box, { as: builtInIcon, __css: styles.icon })) : (headerIcon), title] })) : (title), variant === "info" && (jsx(IconButton, { "aria-label": "Close dialog", icon: CloseIcon, onClick: onClose }))] }), jsx(ModalBody, { ref: mergedBodyRef, style: maskImage ? { maskImage, WebkitMaskImage: maskImage } : undefined, children: children }), jsx(ModalFooter, { children: actions })] }) }) }));
}

function Drawer({ blockBackgroundInteraction = true, closeOnOverlayClick = true, children, closeOnEsc = true, contentWrapperStyles, containerStyles, initialFocusRef, isOpen, placement = "right", showOverlay = false, size = "lg", trapFocus = false, onClose, }) {
    return (jsxs(Fragment, { children: [jsxs(Drawer$1, { blockScrollOnMount: blockBackgroundInteraction, closeOnOverlayClick: closeOnOverlayClick, closeOnEsc: closeOnEsc, initialFocusRef: initialFocusRef, isOpen: isOpen, placement: placement, size: size, trapFocus: trapFocus, onClose: onClose, children: [jsx(DrawerOverlay, { display: showOverlay ? "block" : "none" }), jsx(DrawerContent, { display: "flex", borderBottom: "none", borderTopRadius: "2xl", boxShadow: "md", p: 0, mt: size === "full" ? 0 : 2, mr: size === "full" ? 0 : 2, containerProps: containerStyles, ...contentWrapperStyles, children: children })] }), !blockBackgroundInteraction && (jsx(Global, { styles: {
                    ".chakra-modal__content-container": {
                        pointerEvents: "none",
                        zIndex: 10,
                    },
                    ".chakra-modal__content": {
                        pointerEvents: "auto",
                        zIndex: 10,
                        transform: "unset !important",
                    },
                } }))] }));
}

function useEditableState(value, { isEditing: controlledIsEditing, isDisabled = false, defaultIsEditing = false, onEditingChange, } = {}) {
    const [innerValue, setInnerValue] = useState(value);
    const [uncontrolledIsEditing, setUncontrolledIsEditing] = useState(defaultIsEditing);
    const isControlled = controlledIsEditing !== undefined;
    // Disabling ends the edit — masking it leaves the state latched under the mask.
    const isEditing = (isControlled ? controlledIsEditing : uncontrolledIsEditing) && !isDisabled;
    // A commit sets innerValue before the prop catches up — an async onChange can
    // take a round trip. Hold that value until the prop moves, or reopening would
    // show the name the commit just replaced.
    const committedValueRef = useRef(null);
    const commitInnerValue = useCallback((committed) => {
        committedValueRef.current = committed;
        setInnerValue(committed);
    }, []);
    useEffect(() => {
        committedValueRef.current = null;
        setInnerValue(value);
    }, [value]);
    // Controlled close and disabled-mid-edit skip updateValue/cancelEdit, so
    // without this the abandoned draft reopens and commits on Enter. While a
    // commit is pending, resync to the committed value, not the stale prop.
    useEffect(() => {
        setInnerValue(committedValueRef.current ?? value);
    }, [isEditing]);
    // Clear the uncontrolled latch too, or re-enabling reopens the editor and takes focus.
    useEffect(() => {
        if (isDisabled) {
            setUncontrolledIsEditing(false);
        }
    }, [isDisabled]);
    const setIsEditing = useCallback((editing) => {
        if (isControlled) {
            onEditingChange?.(editing);
        }
        else {
            setUncontrolledIsEditing(editing);
        }
    }, [isControlled, onEditingChange]);
    return {
        innerValue,
        isEditing,
        commitInnerValue,
        setInnerValue,
        setIsEditing,
    };
}
function useEditableActions({ value, onChange, onCancel, editableState, labelContainerRef, enablePristineSubmit = false, }) {
    const { commitInnerValue, setInnerValue, setIsEditing } = editableState;
    const updateValue = useCallback((newValue) => {
        if (value !== newValue || enablePristineSubmit) {
            commitInnerValue(newValue);
            onChange(newValue);
        }
        setIsEditing(false);
        setTimeout(() => {
            labelContainerRef.current?.blur();
        }, 0);
    }, [
        value,
        enablePristineSubmit,
        commitInnerValue,
        setIsEditing,
        onChange,
        labelContainerRef,
    ]);
    const cancelEdit = useCallback(() => {
        setIsEditing(false);
        setInnerValue(value);
        onCancel?.(value);
        setTimeout(() => {
            labelContainerRef.current?.blur();
        }, 0);
    }, [value, onCancel, setIsEditing, setInnerValue, labelContainerRef]);
    return {
        updateValue,
        cancelEdit,
    };
}
function useEditableFocusEvents(isEditing, inputRef) {
    // Focus input when edit mode is turned on
    useEffect(() => {
        if (isEditing) {
            inputRef.current?.focus();
        }
    }, [isEditing, inputRef]);
}
function useEditableKeyboardEvents(inputRef, updateValue, cancelEdit, innerValue) {
    // Handle keyboard events on input
    useEffect(() => {
        const inputElement = inputRef.current;
        if (!inputElement)
            return;
        const handleKeyDown = (event) => {
            if ("key" in event && event.key === "Enter") {
                if ("shiftKey" in event &&
                    event.shiftKey &&
                    inputElement instanceof HTMLTextAreaElement) {
                    return;
                }
                event.preventDefault();
                updateValue(innerValue);
            }
            else if ("key" in event && event.key === "Escape") {
                event.preventDefault();
                cancelEdit();
            }
        };
        inputElement.addEventListener("keydown", handleKeyDown);
        return () => {
            inputElement.removeEventListener("keydown", handleKeyDown);
        };
    }, [updateValue, innerValue, cancelEdit, inputRef]);
}

/**
 * Renders the left action button in the action container (editing view).
 */
function EditableLeftActionButton({ leftAction, }) {
    return (jsx(Tooltip, { isDisabled: !leftAction.buttonTooltip, message: leftAction.buttonTooltip, children: jsx(IconButton, { "aria-label": leftAction["aria-label"], icon: leftAction.icon, isDisabled: leftAction.isDisabled, isLoading: leftAction.isLoading, size: "sm", onClick: leftAction.onClick }) }));
}
/**
 * Renders the left action indicator in the label container (non-editing view).
 * Shows a button when the field is empty and showOnEmpty is set,
 * otherwise shows the icon as a "used action" indicator.
 */
function EditableLeftActionIndicator({ leftAction, showButton, iconStyle, }) {
    return (jsx(Tooltip, { message: showButton ? leftAction.buttonTooltip : leftAction.usedActionTooltip, children: showButton ? (jsx(IconButton, { "aria-label": leftAction["aria-label"], icon: leftAction.icon, isDisabled: leftAction.isDisabled, isLoading: leftAction.isLoading, size: "sm", onClick: leftAction.onClick })) : (jsx(Box, { as: leftAction.icon, __css: iconStyle })) }));
}

// Past a system double-click threshold, short of a deliberate later word-select.
const DOUBLE_CLICK_WINDOW_MS = 500;
const AutoWidthInput = forwardRef$1(function AutoWidthInput_({ colorScheme = "primary", variant, size, fontWeight, isEditing = false, hideUnderline = false, shouldSelectOnEdit = false, shouldSelectOnDoubleClick = false, width, onMouseDown, ...props }, ref) {
    const FormComponent = variant === "textarea" ? chakra.textarea : chakra.input;
    // Only the edit-opening focus positions the selection; reselecting later would
    // let one keystroke wipe the value. Armed at first render because `autoFocus`
    // focuses during commit, before effects run.
    const isOpeningEditRef = useRef(isEditing);
    const wasEditingRef = useRef(isEditing);
    const openedEditAtRef = useRef(0);
    useEffect(() => {
        if (isEditing && !wasEditingRef.current) {
            isOpeningEditRef.current = true;
        }
        wasEditingRef.current = isEditing;
    }, [isEditing]);
    const isSelectAllGesture = (detail) => shouldSelectOnDoubleClick &&
        detail > 1 &&
        Date.now() - openedEditAtRef.current < DOUBLE_CLICK_WINDOW_MS;
    const styles = useStyleConfig("AutoWidthInput", {
        colorScheme,
        variant,
        size,
        isEditing,
        hideUnderline,
        fontWeight,
        width,
    });
    return (jsx(Box, { __css: styles, "data-replicated-value": props.value?.toString() ?? "", children: jsx(FormComponent, { ref: ref, ...props, rows: variant === "textarea" ? 1 : undefined, onFocus: (event) => {
                if (!isEditing)
                    return;
                const isOpeningEdit = isOpeningEditRef.current;
                isOpeningEditRef.current = false;
                if (isOpeningEdit) {
                    openedEditAtRef.current = Date.now();
                    if (shouldSelectOnEdit) {
                        event.currentTarget.select();
                        return;
                    }
                }
                // Firefox selects the whole value on Tab-in; collapse to the end so
                // one keystroke can't wipe it.
                event.currentTarget.setSelectionRange(event.currentTarget.value.length, event.currentTarget.value.length);
            }, onMouseDown: (event) => {
                // The element is input | textarea; the InputProps handler type isn't.
                onMouseDown?.(event);
                // The browser word-selects at the second click's press — correcting
                // at mouseup flashes the word. Later double-clicks pick a word.
                if (isSelectAllGesture(event.detail)) {
                    event.preventDefault();
                    event.currentTarget.select();
                }
            }, onMouseUp: (event) => {
                // Backstop for engines that adjust the selection again at release.
                if (isSelectAllGesture(event.detail)) {
                    event.currentTarget.select();
                }
            } }) }));
});
AutoWidthInput.displayName = "AutoWidthInput";

const EditableDescription = forwardRef$1(function EditableDescription_({ isDisabled = false, enablePristineSubmit = false, leftAction, value, width, lineClamp = 2, colorScheme: _colorScheme = "primary", placeholder = "Add a description…", actionsPosition = "default", onCancel, onChange, ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    const containerRef = useRef(null);
    const textareaRef = useRef(null);
    const labelContainerRef = useRef(null);
    const textElementRef = useRef(null);
    const combinedTextElementRef = useMergeRefs(ref, textElementRef);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isTextTruncated, setIsTextTruncated] = useState(false);
    const editableState = useEditableState(value);
    const { innerValue, isEditing, setIsEditing } = editableState;
    const variant = isEditing ? "editing" : isExpanded ? "expanded" : "default";
    const colorScheme = _colorScheme === "yellow" ? "warning" : "primary";
    const styles = useMultiStyleConfig("EditableDescription", {
        actionsPosition,
        colorScheme,
        lineClamp,
        variant,
        width,
    });
    const isEditingDisabled = isDisabled || skeleton;
    const placeholderVisible = !value && placeholder;
    const { updateValue, cancelEdit } = useEditableActions({
        value,
        onChange,
        onCancel,
        editableState,
        labelContainerRef,
        enablePristineSubmit,
    });
    useEditableFocusEvents(isEditing, textareaRef);
    useEditableKeyboardEvents(textareaRef, updateValue, cancelEdit, innerValue);
    // Close input and submit value when clicking outside
    useOutsideClick({
        ref: containerRef,
        handler: () => {
            if (isEditing) {
                updateValue(innerValue);
            }
        },
    });
    const handleFocusOut = (event) => {
        if (isEditing && !containerRef.current?.contains(event.relatedTarget)) {
            if (innerValue === value) {
                cancelEdit();
            }
            else {
                updateValue(innerValue);
            }
        }
    };
    // Determine whether the expand button should be shown
    // by checking if the text is truncated
    useEffect(() => {
        if (isEditing || skeleton) {
            return;
        }
        const truncatedTextHeight = textElementRef.current?.offsetHeight ?? 0;
        const fullTextHeight = textElementRef.current?.scrollHeight ?? 0;
        setIsTextTruncated(truncatedTextHeight < fullTextHeight);
    }, [isEditing, value, skeleton]);
    const input = (jsx(AutoWidthInput, { ref: textareaRef, autoFocus: true, "aria-label": `Edit ${value || placeholder || "text"}`, colorScheme: colorScheme, isEditing: isEditing, variant: "textarea", value: innerValue, placeholder: placeholder, width: width, onChange: (event) => {
            editableState.setInnerValue(event.target.value);
        }, onClick: (event) => {
            event.stopPropagation();
        }, onMouseDown: (event) => {
            event.stopPropagation();
        } }));
    const editControls = (jsxs(Box, { __css: styles.actionContainer, children: [leftAction && jsx(EditableLeftActionButton, { leftAction: leftAction }), jsx(IconButton, { icon: CheckIcon, "aria-label": "Save changes", size: "sm", variant: "tertiary", onClick: (event) => {
                    event?.stopPropagation();
                    updateValue(innerValue);
                } }), jsx(IconButton, { icon: CloseIcon, "aria-label": "Cancel editing", size: "sm", variant: "tertiary", onClick: (event) => {
                    event?.stopPropagation();
                    cancelEdit();
                } })] }));
    const showLeftActionOnEmptyDescription = Boolean(leftAction?.showOnEmpty && !value);
    return (jsxs(Box, { ref: containerRef, className: "hightouch-ui-editable-description", role: "group", "aria-label": "Editable textarea", ...props, __css: styles.container, width: width, borderRadius: skeleton ? "lg" : undefined, onBlur: handleFocusOut, children: [jsxs(Box, { __css: styles.contentRow, children: [jsxs(Box, { ref: labelContainerRef, __css: styles.labelContainer, "data-disabled": isEditingDisabled, tabIndex: isEditingDisabled || isEditing ? undefined : 0, onKeyDown: (event) => {
                            if (!isEditingDisabled &&
                                (event.key === "Enter" || event.key === " ")) {
                                event.preventDefault();
                                setIsEditing(true);
                                setIsExpanded(false);
                            }
                        }, onClick: (event) => {
                            if (!isEditingDisabled) {
                                event.stopPropagation();
                                setIsEditing(true);
                                setIsExpanded(false);
                            }
                        }, children: [jsx(Text, { ref: combinedTextElementRef, isTruncated: !isExpanded, className: "editable-text-element", color: placeholderVisible ? "text.placeholder" : "text.secondary", children: value || placeholder }), !isEditingDisabled &&
                                leftAction &&
                                (leftAction.usedActionTooltip ||
                                    showLeftActionOnEmptyDescription) && (jsx(EditableLeftActionIndicator, { leftAction: leftAction, showButton: showLeftActionOnEmptyDescription, iconStyle: styles.usedLeftActionIcon })), !isEditingDisabled && (jsx(Box, { className: "editable-icon-container", children: jsx(EditIcon, {}) }))] }), actionsPosition === "bottom" ? (jsxs(Box, { __css: styles.inputAndActions, children: [input, isEditing && editControls] })) : (jsxs(Fragment, { children: [input, isEditing && editControls] }))] }), isTextTruncated && !isEditing && !isEditingDisabled && (jsx(Button$1, { __css: styles.expandButton, variant: "link", onClick: (event) => {
                    event.stopPropagation();
                    setIsExpanded((previousValue) => !previousValue);
                }, children: isExpanded ? "See less…" : "See more…" }))] }));
});
EditableDescription.displayName = "EditableDescription";

const Heading = forwardRef(function Heading_({ isTruncated = false, children, color = "text.primary", size = "md", variant = "heading", ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    return (jsxs(Heading$1, { ref: ref, position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : color, maxWidth: skeleton ? "max-content" : undefined, size: `heading-${size}`, variant: variant, ...(isTruncated
            ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }
            : {}), ...props, children: [children, skeleton && jsx(SkeletonText, {})] }));
});
Heading.displayName = "Heading";

const EditableHeading = forwardRef$1(function EditableHeading_({ autoFocus = false, isDisabled = false, placeholder, width, value, size = "md", inputProps, onCancel, onChange, ...props }, ref) {
    const skeleton = useContext(SkeletonContext);
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    const labelContainerRef = useRef(null);
    const isEditingDisabled = isDisabled || skeleton;
    const editableState = useEditableState(value, {
        defaultIsEditing: autoFocus && !isEditingDisabled,
    });
    const { innerValue, isEditing, setIsEditing } = editableState;
    const styles = useMultiStyleConfig("EditableHeading", {
        variant: isEditing ? "editing" : "default",
        size,
    });
    const placeholderVisible = !value && placeholder;
    const { updateValue, cancelEdit } = useEditableActions({
        value,
        onChange,
        onCancel,
        editableState,
        labelContainerRef,
    });
    useEditableFocusEvents(isEditing, inputRef);
    useEditableKeyboardEvents(inputRef, updateValue, cancelEdit, innerValue);
    // Close input and submit value when clicking outside
    useOutsideClick({
        ref: containerRef,
        handler: () => {
            if (isEditing) {
                updateValue(innerValue);
            }
        },
    });
    const handleFocusOut = (event) => {
        if (isEditing && !containerRef.current?.contains(event.relatedTarget)) {
            if (innerValue === value) {
                cancelEdit();
            }
            else {
                updateValue(innerValue);
            }
        }
    };
    return (jsxs(Box, { ref: containerRef, role: "group", "aria-label": "Editable input", ...props, __css: styles.container, width: width, onBlur: handleFocusOut, children: [jsxs(Box, { ref: labelContainerRef, __css: styles.labelContainer, "data-disabled": isEditingDisabled, tabIndex: isEditingDisabled || isEditing ? undefined : 0, onKeyDown: (event) => {
                    if (!isEditingDisabled &&
                        (event.key === "Enter" || event.key === " ")) {
                        event.preventDefault();
                        setIsEditing(true);
                    }
                }, onClick: (event) => {
                    if (!isEditingDisabled) {
                        event.stopPropagation();
                        setIsEditing(true);
                    }
                }, children: [jsx(Heading, { ref: ref, isTruncated: true, className: "editable-text-element", color: placeholderVisible ? "text.placeholder" : "text.primary", size: size, children: value || placeholder }), !isEditingDisabled && (jsx(Box, { className: "editable-icon-container", children: jsx(EditIcon, {}) }))] }), jsx(AutoWidthInput, { ref: inputRef, "aria-label": `Edit ${value || placeholder || "heading"}`, ...inputProps, autoFocus: true, width: width, isEditing: isEditing, placeholder: placeholder, size: size, value: innerValue, variant: "heading", onChange: (event) => {
                    editableState.setInnerValue(event.target.value);
                }, onClick: (event) => {
                    event.stopPropagation();
                }, onMouseDown: (event) => {
                    event.stopPropagation();
                } }), isEditing && (jsxs(Box, { __css: styles.actionContainer, children: [jsx(IconButton, { icon: CheckIcon, "aria-label": "Save changes", variant: "tertiary", onClick: (event) => {
                            event?.stopPropagation();
                            updateValue(innerValue);
                        } }), jsx(IconButton, { icon: CloseIcon, "aria-label": "Cancel editing", variant: "tertiary", onClick: (event) => {
                            event?.stopPropagation();
                            cancelEdit();
                        } })] }))] }));
});
EditableHeading.displayName = "EditableHeading";

const EditableText = forwardRef$1(function EditableText_({ variant = "default", isDisabled = false, isEditing: controlledIsEditing, leftAction, onEditingChange, placeholder, width, value, fontWeight = "normal", size = "md", inputProps, onCancel, onChange, ...props }, ref) {
    const isMinimal = variant === "minimal";
    const isControlled = controlledIsEditing !== undefined;
    const skeleton = useContext(SkeletonContext);
    const containerRef = useRef(null);
    const inputRef = useRef(null);
    const labelContainerRef = useRef(null);
    const editOpenedFrom = useRef(null);
    const isEditingDisabled = isDisabled || skeleton;
    const editableState = useEditableState(value, {
        isEditing: controlledIsEditing,
        isDisabled: isEditingDisabled,
        onEditingChange,
    });
    const { innerValue, isEditing, setIsEditing } = editableState;
    // Style-config variant, not the public prop: minimal differs by what renders.
    const styles = useMultiStyleConfig("EditableText", {
        variant: isEditing ? "editing" : "default",
        size,
    });
    const placeholderVisible = !value && placeholder;
    // A controlled label must not take focus or swallow clicks meant for its row.
    const canActivateFromLabel = !isEditingDisabled && !isControlled;
    const { updateValue, cancelEdit } = useEditableActions({
        value,
        onChange,
        onCancel,
        editableState,
        labelContainerRef,
    });
    // The controlled label is not focusable, so return focus to whatever opened the edit.
    useEffect(() => {
        if (isEditing) {
            const active = document.activeElement;
            if (active instanceof HTMLElement &&
                !containerRef.current?.contains(active)) {
                editOpenedFrom.current = active;
            }
            return;
        }
        const origin = editOpenedFrom.current;
        editOpenedFrom.current = null;
        if (!origin?.isConnected)
            return;
        // Never take focus the user has since moved somewhere else.
        const active = document.activeElement;
        if (!active ||
            active === document.body ||
            containerRef.current?.contains(active)) {
            origin.focus();
        }
    }, [isEditing]);
    useEditableFocusEvents(isEditing, inputRef);
    useEditableKeyboardEvents(inputRef, updateValue, cancelEdit, innerValue);
    // Close input and submit value when clicking outside
    useOutsideClick({
        ref: containerRef,
        handler: () => {
            if (isEditing) {
                updateValue(innerValue);
            }
        },
    });
    const handleFocusOut = (event) => {
        if (isEditing && !containerRef.current?.contains(event.relatedTarget)) {
            if (innerValue === value) {
                cancelEdit();
            }
            else {
                updateValue(innerValue);
            }
        }
    };
    const showLeftActionOnEmpty = Boolean(leftAction?.showOnEmpty && !value);
    return (jsxs(Box, { ref: containerRef, role: "group", "aria-label": "Editable input", ...props, __css: styles.container, width: width, onBlur: handleFocusOut, onMouseDown: (event) => {
            // A click in the band around the input blurs, and a blur commits a
            // half-typed name — keep focus where it is.
            if (isEditing && event.target !== inputRef.current) {
                event.preventDefault();
            }
        }, children: [jsxs(Box, { ref: labelContainerRef, __css: styles.labelContainer, "data-disabled": !canActivateFromLabel, tabIndex: canActivateFromLabel && !isEditing ? 0 : undefined, onMouseDown: isControlled
                    ? (event) => {
                        // A double-click here opens the editor; the native word-select would flash first.
                        if (event.detail > 1) {
                            event.preventDefault();
                        }
                    }
                    : undefined, onKeyDown: canActivateFromLabel
                    ? (event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            setIsEditing(true);
                        }
                    }
                    : undefined, onClick: canActivateFromLabel
                    ? (event) => {
                        event.stopPropagation();
                        setIsEditing(true);
                    }
                    : undefined, children: [jsx(Text, { ref: ref, isTruncated: true, className: "editable-text-element", color: placeholderVisible ? "text.placeholder" : "text.primary", size: size, fontWeight: fontWeight, children: value || placeholder }), !isEditingDisabled &&
                        !isMinimal &&
                        leftAction &&
                        (leftAction.usedActionTooltip || showLeftActionOnEmpty) && (jsx(EditableLeftActionIndicator, { leftAction: leftAction, showButton: showLeftActionOnEmpty, iconStyle: styles.usedLeftActionIcon })), canActivateFromLabel && !isMinimal && (jsx(Box, { className: "editable-icon-container", children: jsx(EditIcon, {}) }))] }), jsx(AutoWidthInput, { ref: inputRef, "aria-label": `Edit ${value || placeholder || "text"}`, ...inputProps, autoFocus: true, width: width, fontWeight: fontWeight, isEditing: isEditing, hideUnderline: isMinimal, shouldSelectOnEdit: isControlled, shouldSelectOnDoubleClick: isMinimal, size: size, value: innerValue, variant: "text", placeholder: placeholder, onChange: (event) => {
                    editableState.setInnerValue(event.target.value);
                }, onClick: (event) => {
                    event.stopPropagation();
                }, onMouseDown: (event) => {
                    event.stopPropagation();
                } }), isEditing && !isMinimal && (jsxs(Box, { __css: styles.actionContainer, children: [leftAction && jsx(EditableLeftActionButton, { leftAction: leftAction }), jsx(IconButton, { icon: CheckIcon, "aria-label": "Save changes", size: "sm", variant: "tertiary", onClick: (event) => {
                            event?.stopPropagation();
                            updateValue(innerValue);
                        } }), jsx(IconButton, { icon: CloseIcon, "aria-label": "Cancel editing", size: "sm", variant: "tertiary", onClick: (event) => {
                            event?.stopPropagation();
                            cancelEdit();
                        } })] }))] }));
});
EditableText.displayName = "EditableText";

function Paragraph({ children, size = "md", ...props }) {
    const skeleton = useContext(SkeletonContext);
    return (jsxs(Text$1, { size: size, position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : "text.primary", ...props, children: [children, skeleton && jsx(SkeletonText, {})] }));
}

const HtVideo = forwardRef$1(function HtVideo_({ playback = "click", controls = false, loop = true, muted, controlsList, __css, ...props }, ref) {
    const styles = useStyleConfig("HtVideo");
    const videoRef = useRef(null);
    const mergedRef = useMergeRefs(ref, videoRef);
    // Read once at mount, like the rest of the library. A later change applies on the next load.
    const prefersReducedMotion = useReducedMotion();
    const isAutoplay = playback === "autoplay" && !prefersReducedMotion;
    const isMuted = muted ?? playback === "autoplay";
    const wasAutoplayingRef = useRef(false);
    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            // React sets only the `muted` property. `defaultMuted` adds the attribute some autoplay policies check.
            video.defaultMuted = isMuted;
        }
    }, [isMuted]);
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {
            return;
        }
        if (isAutoplay) {
            wasAutoplayingRef.current = true;
            if (!video.paused) {
                return;
            }
            // jsdom returns undefined from play(), so wrap it before catching.
            Promise.resolve(video.play()).catch((error) => {
                // pause() aborts a pending play(), and autoplay policies reject it. Both leave the first frame.
                if (error instanceof DOMException &&
                    (error.name === "AbortError" || error.name === "NotAllowedError")) {
                    return;
                }
                console.warn("HtVideo could not start autoplay", error);
            });
            return;
        }
        // Stop only when leaving `autoplay`, or for `none`, which never plays, so a viewer's playback on `click` stays.
        if (wasAutoplayingRef.current || playback === "none") {
            if (!video.paused) {
                video.pause();
            }
            if (playback === "none" && video.currentTime !== 0) {
                video.currentTime = 0;
            }
        }
        wasAutoplayingRef.current = false;
    }, [playback, isAutoplay, props.src]);
    return (jsx(Box, { ...props, ref: mergedRef, as: "video", __css: { ...styles, ...__css }, playsInline: true, controls: playback === "click" || (playback === "autoplay" && controls), controlsList: controlsList, autoPlay: isAutoplay, muted: isMuted, loop: playback === "autoplay" && loop }));
});
HtVideo.displayName = "HtVideo";

const chakraComponentSelectors = [
    "chakra-avatar",
    "chakra-button",
    "chakra-link",
    "chakra-badge",
    "chakra-status-indicator-light",
    "chakra-code",
    "chakra-input__group",
    "hightouch-ui-skeleton-box",
    "hightouch-ui-editable-description",
    "chakra-editable__preview",
]
    .map((className) => `[class*="${className}"]`)
    .join(", ");
function Skeleton({ isLoading, ...props }) {
    return (jsx(SkeletonContext.Provider, { value: isLoading, children: jsx(Box$1, { css: {
                ...(isLoading
                    ? {
                        [chakraComponentSelectors]: {
                            position: "relative",
                            borderColor: "transparent",
                            pointerEvents: "none",
                            userSelect: "none",
                            "&::after": {
                                content: '""',
                                position: "absolute",
                                inset: 0,
                                borderRadius: "inherit",
                                ...skeletonAnimationStyles,
                            },
                        },
                        ".chakra-input__group": {
                            borderRadius: "var(--chakra-radii-lg)",
                        },
                        ".chakra-input__left-element": {
                            opacity: 0,
                        },
                        ".chakra-avatar__initials": {
                            opacity: 0,
                        },
                    }
                    : {}),
            }, ...props }) }));
}

function SkeletonBox({ className = "", ...props }) {
    const ref = useRef(null);
    const [radius, setRadius] = useState("sm");
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        const height = element.offsetHeight;
        const computedRadius = getRadius(height);
        setRadius(computedRadius);
    }, []);
    return (jsx(Box$1, { ref: ref, className: `hightouch-ui-skeleton-box ${className}`, borderRadius: radius, ...props }));
}

const VIDEO_SRC_REGEX = /\.(mp4|mov|webm|avi|mkv)(?:\?|#|$)/iu;
/**
 * Returns true when `src` ends in a video extension (mp4, mov, webm, avi, mkv),
 * ignoring any query string or hash. `HtImage` uses the same check to render a
 * `<video>`, so callers that branch UI on video vs image stay in sync with it.
 */
function isVideoSrc(src) {
    return !!src && VIDEO_SRC_REGEX.test(src);
}

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
/**
 * `MarginProps` keys, needed as values at runtime. The `Record` makes a
 * renamed OR newly added key fail to compile, so the list can't silently
 * drift from the type.
 */
const marginPropRecord = {
    m: true,
    margin: true,
    mt: true,
    marginTop: true,
    mr: true,
    marginRight: true,
    mb: true,
    marginBottom: true,
    ml: true,
    marginLeft: true,
    mx: true,
    marginX: true,
    my: true,
    marginY: true,
};
const marginPropNames = Object.keys(marginPropRecord);
/**
 * Splits margin props out of a props object. For components that accept both
 * `MarginProps` and an open set of element attributes, where the usual
 * `...marginProps` rest capture can't tell the two apart.
 */
function splitMarginProps(props) {
    return [pick(props, marginPropNames), omit(props, marginPropNames)];
}

const ERROR_BOX_PROP_NAMES = [
    "width",
    "w",
    "height",
    "h",
    "boxSize",
    "minWidth",
    "minW",
    "maxWidth",
    "maxW",
    "minHeight",
    "minH",
    "maxHeight",
    "maxH",
    "aspectRatio",
    "flex",
    "flexGrow",
    "flexShrink",
    "flexBasis",
    "alignSelf",
    "borderRadius",
    "rounded",
];
const HtImage = forwardRef$1(function HtImage_({ alt, decorative, disableVideoControls, showSkeleton, skeletonHeight = "200px", showError, onRetry, onLoad, onError, ...props }, ref) {
    const styles = useMultiStyleConfig("HtImage");
    const [settledSrc, setSettledSrc] = useState(null);
    const [failedSrc, setFailedSrc] = useState(null);
    const hasError = failedSrc === props.src;
    const isVideo = isVideoSrc(props.src);
    const isHidden = showSkeleton && settledSrc !== props.src;
    const handleLoad = (e) => {
        setSettledSrc(props.src);
        onLoad?.(e);
    };
    const handleError = (e) => {
        setSettledSrc(props.src);
        setFailedSrc(props.src);
        onError?.(e);
    };
    const handleRetry = () => {
        setSettledSrc(null);
        setFailedSrc(null);
        onRetry?.();
    };
    const stateAttributes = {
        "data-skeleton": showSkeleton ? "" : undefined,
        "data-loading": isHidden ? "" : undefined,
    };
    if (showError && hasError) {
        const [marginProps] = splitMarginProps(props);
        return (jsxs(Box, { __css: styles.error, ...pick(props, ERROR_BOX_PROP_NAMES), ...marginProps, children: [jsx(Text, { size: "sm", color: "text.secondary", children: isVideo ? "Video failed to load" : "Image failed to load" }), onRetry && (jsx(Button, { size: "sm", icon: RefreshIcon, onClick: handleRetry, children: "Refresh" }))] }));
    }
    if (isVideo) {
        const { loading: _loading, ...videoProps } = props;
        return (jsxs(Fragment, { children: [isHidden && (jsx(Skeleton, { isLoading: true, children: jsx(SkeletonBox, { height: skeletonHeight, width: "100%" }) })), jsx(HtVideo, { ...videoProps, "aria-label": alt, __css: styles.media, playback: disableVideoControls || isHidden ? "none" : "click", "aria-hidden": isHidden || undefined, onLoadedData: handleLoad, onError: handleError, ...stateAttributes })] }));
    }
    return (jsxs(Fragment, { children: [isHidden && (jsx(Skeleton, { isLoading: true, children: jsx(SkeletonBox, { height: skeletonHeight, width: "100%" }) })), jsx(Box, { ref: ref, as: "img", __css: styles.media, alt: decorative ? "" : alt, onLoad: handleLoad, onError: handleError, ...props, ...stateAttributes })] }));
});
HtImage.displayName = "HtImage";

function EmptyState({ imageUrl, title, message, actions, variant = "card", imageFilter = "default", imageMaxH = 48, messageMaxW = "md", titleMarginProps, ...props }) {
    return (jsxs(Box$1, { ...props, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: variant === "minimal" ? 0 : 16, borderWidth: "hairline", borderStyle: "solid", borderColor: variant === "minimal" ? "transparent" : "base.border", borderRadius: variant === "minimal" ? "none" : "xl", bg: variant === "minimal" ? "transparent" : "white", boxShadow: variant === "minimal" ? "none" : "buttonShadowLight", children: [imageUrl && (jsx(HtImage, { decorative: true, src: imageUrl, maxHeight: imageMaxH, mixBlendMode: imageFilter === "blackAndWhite" ? "luminosity" : "normal" })), title && (jsx(Text$1, { fontSize: "lg", fontWeight: "semibold", lineHeight: "6", color: "text.primary", ...titleMarginProps, children: title })), message && (jsx(Box$1, { mt: 1, maxWidth: messageMaxW, mx: "auto", children: jsx(Paragraph, { textAlign: "center", color: "text.secondary", children: jsx(Balancer, { ratio: 0.65, children: message }) }) })), actions && jsx(ButtonGroup, { mt: 6, children: actions })] }));
}

const Video = chakra("video");
function ExtendedUpsellCard({ badgeText, title, children, actions, videoUrl, videoPoster, imageUrl, ...props }) {
    const styles = useMultiStyleConfig("UpsellCard");
    const [isPlaying, setIsPlaying] = useState(false);
    const video = useRef(null);
    const play = useCallback(() => {
        void video.current?.play();
        setIsPlaying(true);
    }, []);
    return (jsx(Box$1, { __css: styles["container"], ...props, children: jsxs(Box$1, { __css: styles["extendedContainer"], children: [jsxs(Box$1, { __css: styles["extendedContent"], children: [jsx(Badge, { variant: "upsell", children: badgeText }), jsx(Box$1, { as: "h3", __css: styles["title"], children: title }), jsx(Box$1, { children: children }), jsx(Box$1, { __css: styles["actionContainer"], children: actions })] }), videoUrl && (jsxs(Box$1, { __css: styles["extendedMediaWrapper"], children: [jsx(Video, { ref: video, src: videoUrl, poster: videoPoster, controls: isPlaying, preload: "auto", maxWidth: "100%", __css: styles["extendedVideo"] }), !isPlaying && (jsx(Box$1, { __css: styles["extendedVideoOverlay"], children: jsx(Box$1, { as: "button", type: "button", "aria-label": "Play video", __css: styles["extendedVideoButton"], onClick: play, children: jsx(PlayIcon, { color: "white" }) }) }))] })), imageUrl && (jsx(Box$1, { __css: styles["extendedMediaWrapper"], children: jsx(HtImage, { src: imageUrl, loading: "lazy", decorative: true, __css: styles["extendedImage"] }) }))] }) }));
}

// Strip the dot from extensions
const normalizeExtensions = (extensions) => {
    return extensions?.map((extension) => {
        return extension.startsWith(".") ? extension.slice(1) : extension;
    });
};

const keys = new WeakMap();
let counter = 0;
// Two files can match on name, size and mtime and still be separate picks, so
// identity is the object itself, held stable for React keys and for removals
const fileKey = (file) => {
    const existing = keys.get(file);
    if (existing) {
        return existing;
    }
    counter += 1;
    const key = `${file.name}-${counter}`;
    keys.set(file, key);
    return key;
};
// Re-picking a file yields a new object, so sameness for deduping is by value
const fileSignature = (file) => {
    return `${file.name}-${file.size}-${file.lastModified}`;
};

function FileCard({ name, error, onRemove, isDisabled }) {
    return (jsxs(Row, { role: "listitem", align: "center", gap: 3, px: 3, py: 3, bg: "white", boxShadow: "xs", borderRadius: "lg", children: [jsx(IconBox, { "aria-hidden": true, color: "gray", size: "lg", icon: jsx(FileIcon, {}) }), jsxs(Column, { gap: 0.5, flex: 1, minW: 0, children: [jsx(Text, { isTruncated: true, "data-testid": "file-card-name", children: name }), error && (jsx(Text, { size: "sm", color: "text.danger", children: error }))] }), onRemove && (jsx(IconButton, { "aria-label": `Remove ${name}`, icon: DeleteIcon, variant: "danger", isDisabled: isDisabled, onClick: onRemove }))] }));
}
function FileGroup({ label, count, children }) {
    return (jsxs(Column, { gap: 2, children: [jsxs(Row, { align: "center", gap: 2, children: [jsx(Text, { size: "sm", color: "text.secondary", children: label }), jsx(Badge, { children: count })] }), jsx(Column, { role: "list", "aria-label": label, gap: 2, children: children })] }));
}
function FileList({ files, rejections, validFilesLabel, invalidFilesLabel, isDisabled, onRemove, }) {
    const validCards = files.map((file) => {
        return (jsx(FileCard, { name: file.name, isDisabled: isDisabled, onRemove: () => {
                onRemove(file);
            } }, fileKey(file)));
    });
    // Headers only earn their space once there's more than one group to tell apart
    if (rejections.length === 0) {
        return (jsx(Column, { role: "list", gap: 2, "data-testid": "file-list", children: validCards }));
    }
    return (jsxs(Column, { gap: 4, "data-testid": "file-list", children: [files.length > 0 && (jsx(FileGroup, { label: validFilesLabel, count: files.length, children: validCards })), jsx(FileGroup, { label: invalidFilesLabel, count: rejections.length, children: rejections.map((rejection) => {
                    return (jsx(FileCard, { name: rejection.file.name, error: rejection.message, isDisabled: isDisabled, onRemove: () => {
                            onRemove(rejection.file);
                        } }, fileKey(rejection.file)));
                }) })] }));
}

function ProgressBar({ value, "aria-label": ariaLabel, ...props }) {
    return (jsx(Box$1, { h: 2, bg: "base.backgroundDisabled", borderRadius: "lg", overflow: "hidden", ...props, children: jsx(MotionBox, { "aria-label": ariaLabel, "aria-valuemin": "0", "aria-valuemax": "100", "aria-valuenow": value, role: "progressbar", w: "100%", h: "100%", bg: "primary.base", borderRadius: "lg", initial: { x: "-100%" }, animate: { x: `-${100 - value}%` }, transition: {
                damping: 10,
            } }) }));
}

const motionVariants = {
    slideInitial: {
        opacity: 0,
        y: -24,
    },
    slide: {
        opacity: 1,
        y: 0,
        transition: {
            delay: 0.2,
        },
    },
    scaleInitial: {
        opacity: 0,
        scale: 0,
    },
    scale: {
        opacity: 1,
        scale: 1.2,
        transition: {
            delay: 0.2,
        },
    },
    fadeInitial: {
        opacity: 0,
    },
    fade: {
        opacity: 1,
        transition: {
            delay: 0.2,
        },
    },
    exit: {
        opacity: 0,
        y: 16,
        transition: {
            type: "spring",
            damping: 30,
            stiffness: 500,
        },
    },
};
const getFileType = (extensions) => {
    if (!Array.isArray(extensions) || extensions.length === 0) {
        return "generic";
    }
    const isImage = extensions.every((extension) => {
        return ["png", "jpg", "jpeg", "gif"].includes(extension);
    });
    if (isImage) {
        return "image";
    }
    const isCredentials = extensions.every((extension) => {
        return ["p8", "pem", "pub", "crt", "cert", "cer"].includes(extension);
    });
    if (isCredentials) {
        return "credentials";
    }
    return "generic";
};
const iconByFileType = {
    generic: FileIcon,
    image: ImageIcon,
    credentials: KeyIcon,
};
// Chakra sizes-scale indices, not pixels
const fullHeight = 40;
const slimHeight = 12;
function DropZone({ variant, state, isMouseOver, isDisabled, multiple, fileName, errorMessage, uploadProgress, extensions, maxSize, maxFiles, browseRef, getRootProps, getInputProps, }) {
    let backgroundColor = "base.lightBackground";
    let textColor;
    let borderColor = "base.border";
    let borderStyle = "dashed";
    if (state === "active" || isMouseOver) {
        backgroundColor = "white";
    }
    if (state === "success") {
        backgroundColor = "success.background";
        textColor = "text.primary";
        borderColor = "success.border";
        borderStyle = "solid";
    }
    if (state === "error") {
        backgroundColor = "danger.background";
        textColor = "text.danger";
        borderColor = "danger.border";
        borderStyle = "solid";
    }
    if (isDisabled) {
        borderStyle = "solid";
    }
    // Shared so a token change lands on both presentations at once. `border`
    // is a shorthand, so it has to stay ahead of the longhands it would reset.
    const rootProps = {
        borderRadius: "md",
        border: "1px",
        borderStyle,
        borderColor,
        bg: backgroundColor,
        transitionProperty: "background-color, border-color, opacity",
        transitionDuration: "fast",
        transitionTimingFunction: "easeInOutQuad",
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.4 : undefined,
        "data-testid": "file-input",
        ...getRootProps(),
    };
    const input = (jsx("input", { ...getInputProps(), "aria-label": multiple ? "Upload files" : "Upload file" }));
    const browse = (jsx(Text$1, { ref: browseRef, as: "button", type: "button", color: "link.default", fontWeight: "medium", pointerEvents: isDisabled ? "none" : undefined, children: "browse" }));
    if (variant === "slim") {
        return (jsxs(Box$1, { ...rootProps, display: "flex", alignItems: "center", justifyContent: "center", px: 4, height: slimHeight, "data-variant": "slim", children: [input, jsx(Text$1, { isTruncated: true, fontSize: "md", color: textColor, textAlign: "center", children: state === "error" ? errorMessage : jsxs(Fragment, { children: ["Drop files here, or ", browse] }) })] }));
    }
    const fileType = getFileType(extensions);
    const icon = iconByFileType[fileType];
    return (jsxs(Box$1, { ...rootProps, paddingTop: 8, paddingBottom: 2, paddingX: 6, height: fullHeight, "data-variant": "full", children: [input, jsx(Box$1, { boxSize: 10, position: "relative", mx: "auto", children: jsxs(AnimatePresence, { initial: false, children: [state === "inactive" && (jsx(MotionBox, { initial: "slideInitial", animate: "slide", exit: "exit", variants: motionVariants, position: "absolute", inset: 0, children: jsx(Box$1, { as: icon, boxSize: 10, color: "gray.base" }) }, "icon")), state === "success" && (jsx(MotionBox, { initial: "scaleInitial", animate: "scale", exit: "exit", variants: motionVariants, position: "absolute", inset: 0, fontSize: "40px", children: jsx(SuccessIcon, { color: "success.base" }) }, "success")), state === "error" && (jsx(MotionBox, { initial: "scaleInitial", animate: "scale", exit: "exit", variants: motionVariants, position: "absolute", inset: 0, fontSize: "40px", children: jsx(ErrorIcon, { color: "danger.base" }) }, "error")), state === "active" && (jsx(MotionBox, { initial: "slideInitial", animate: "slide", exit: "exit", variants: motionVariants, position: "absolute", inset: 0, children: jsx(motion.div, { initial: {
                                    y: 0,
                                }, animate: {
                                    y: -8,
                                }, transition: {
                                    repeat: Number.POSITIVE_INFINITY,
                                    repeatType: "reverse",
                                    duration: 0.7,
                                    delay: 0.5,
                                }, children: jsx(Box$1, { as: ArrowDownIcon, boxSize: 10, color: "gray.base" }) }) }, "arrow")), state === "uploading" && (jsx(MotionBox, { initial: "fadeInitial", animate: "fade", exit: "exit", variants: motionVariants, position: "absolute", inset: 0, display: "flex", alignItems: "flex-end", justifyContent: "center", children: jsx(Text$1, { fontSize: "lg", fontWeight: "semibold", color: "text.primary", children: "Uploading\u2026" }) }, "uploading"))] }) }), state === "uploading" ? (jsx(Box$1, { mx: "auto", mt: 6, width: "sm", children: jsx(ProgressBar, { "aria-label": "File upload progress", value: uploadProgress }) })) : (jsxs(Fragment, { children: [jsxs(Text$1, { mt: 4, fontSize: "md", color: textColor, textAlign: "center", children: [state === "success" && (jsxs(Balancer, { ratio: 0.65, children: ["File \u201C", fileName, "\u201D was uploaded"] })), state === "error" && (jsx(Balancer, { ratio: 0.65, children: errorMessage })), !["success", "error"].includes(state) && (jsxs(Fragment, { children: ["Drag and drop your ", multiple ? "files" : "file", " here, or", " ", browse] }))] }), jsxs(Text$1, { mt: 2, fontSize: "md", color: "text.secondary", textAlign: "center", opacity: state === "success" ? 0 : 1, pointerEvents: state === "success" ? "none" : undefined, children: [extensions && extensions.length > 0 && (jsxs(Fragment, { children: ["Only", " ", jsx(Text$1, { as: "span", textTransform: "lowercase", children: extensions.join(", ") }), "."] })), " ", prettyBytes(maxSize), " max", multiple ? " per file" : "", 
                            /* A lone size hint is a fragment and takes no period; alongside other restriction sentences, every sentence ends with one. */
                            extensions?.length || maxFiles ? "." : "", maxFiles ? (jsxs(Fragment, { children: [" ", "Up to ", maxFiles, " ", maxFiles === 1 ? "file" : "files", "."] })) : null] })] }))] }));
}

const plural = (count, noun) => {
    return `${count} ${noun}${count === 1 ? "" : "s"}`;
};

function SelectionCaption({ files, rowCount, hasRejections, maxFiles, isDisabled, onClearAll, }) {
    const totalSize = files.reduce((sum, file) => sum + file.size, 0);
    return (jsxs(Row, { align: "center", "data-testid": "file-caption", children: [!hasRejections && (jsxs(Text, { size: "sm", color: "text.secondary", "data-testid": "file-caption-count", children: [maxFiles
                        ? `${files.length} of ${maxFiles} files`
                        : plural(files.length, "file"), " · ", prettyBytes(totalSize)] })), rowCount >= 2 && (jsx(Button, { ml: "auto", variant: "tertiary", size: "sm", isDisabled: isDisabled, onClick: onClearAll, children: "Clear all" }))] }));
}

class FileUploadError extends Error {
}

// Each reason is also the dropzone error code it comes from. Highest priority
// first: an unsupported file's size is beside the point.
const prioritizedReasons = [
    "invalid-extension",
    "file-too-large",
];
const toFileRejections = (rejections) => {
    return rejections.flatMap(({ file, errors }) => {
        for (const reason of prioritizedReasons) {
            const error = errors.find((candidate) => {
                return candidate.code === reason;
            });
            if (error) {
                return [{ file, reason, message: error.message }];
            }
        }
        // Unreachable: the component configures no other rejecting check, and
        // dropping beats labeling a file with a reason we can't determine.
        return [];
    });
};

const emptySelection = {
    files: [],
    rejections: [],
};
const initialState = {
    state: "inactive",
    fileName: undefined,
    errorMessage: undefined,
    isMouseOver: false,
    selection: emptySelection,
    announcement: undefined,
};
// Hover survives because drops, dialogs and uploads emit no mouse event, and
// the selection survives because an inline error must not discard the list
const keepContext = (state) => {
    return {
        ...initialState,
        isMouseOver: state.isMouseOver,
        selection: state.selection,
        announcement: state.announcement,
    };
};
const signaturesOf = (selection) => {
    const seen = new Set();
    for (const file of selection.files) {
        seen.add(fileSignature(file));
    }
    for (const rejection of selection.rejections) {
        seen.add(fileSignature(rejection.file));
    }
    return seen;
};
const describeAddition = (added, refused, total) => {
    const parts = [];
    if (added > 0) {
        parts.push(`${plural(added, "file")} added`);
    }
    if (refused > 0) {
        parts.push(`${plural(refused, "file")} refused`);
    }
    parts.push(`${total} total`);
    return parts.join(", ");
};
// `selection` keeps its reference unless its contents change, which is what
// the reporting effect keys off
const reducer = (state, action) => {
    switch (action.type) {
        case "DRAG_ENTER": {
            return {
                ...state,
                state: "active",
                errorMessage: undefined,
            };
        }
        case "DRAG_LEAVE": {
            return {
                ...state,
                state: state.fileName ? "success" : "inactive",
            };
        }
        case "MOUSE_ENTER": {
            return {
                ...state,
                isMouseOver: true,
            };
        }
        case "MOUSE_LEAVE": {
            return {
                ...state,
                isMouseOver: false,
            };
        }
        case "START_UPLOADING": {
            return {
                ...keepContext(state),
                state: "uploading",
            };
        }
        case "UPLOAD": {
            return {
                ...keepContext(state),
                state: "success",
                fileName: action.fileName,
            };
        }
        case "ERROR": {
            return {
                ...keepContext(state),
                state: "error",
                errorMessage: action.message,
                announcement: action.message,
            };
        }
        // Merged here rather than at the call site so a drop lands against the
        // selection as it stands, not as a render closure remembers it
        case "ADD_FILES": {
            const { selection } = state;
            const seen = signaturesOf(selection);
            const isNew = (file) => {
                const signature = fileSignature(file);
                if (seen.has(signature)) {
                    return false;
                }
                seen.add(signature);
                return true;
            };
            const files = action.files.filter((file) => isNew(file));
            const rejections = action.rejections.filter((rejection) => {
                return isNew(rejection.file);
            });
            // A drop fires no dragleave, so the drag state retires here; the error
            // and any report in flight survive, since nothing was added
            if (files.length + rejections.length === 0) {
                return {
                    ...state,
                    state: state.state === "active" ? "inactive" : state.state,
                    announcement: "No new files added",
                };
            }
            const accepted = [...selection.files, ...files];
            // Refusing only the incoming batch leaves the list the user is adding to.
            // A `0` cap reads as unlimited, matching the hint text under the zone.
            if (action.maxFiles && accepted.length > action.maxFiles) {
                const message = `Too many files. Up to ${action.maxFiles} allowed`;
                return {
                    ...keepContext(state),
                    state: "error",
                    errorMessage: message,
                    announcement: message,
                };
            }
            return {
                ...keepContext(state),
                state: "inactive",
                // Any add pushes the zone further than its own height without moving
                // the pointer, so no mouseleave arrives to retire the hover
                isMouseOver: false,
                selection: {
                    files: accepted,
                    rejections: [...selection.rejections, ...rejections],
                },
                announcement: describeAddition(files.length, rejections.length, accepted.length),
            };
        }
        case "REMOVE_FILE": {
            const key = fileKey(action.file);
            const files = state.selection.files.filter((candidate) => {
                return fileKey(candidate) !== key;
            });
            const rejections = state.selection.rejections.filter((rejection) => {
                return fileKey(rejection.file) !== key;
            });
            const isUnchanged = files.length === state.selection.files.length &&
                rejections.length === state.selection.rejections.length;
            if (isUnchanged) {
                return state;
            }
            return {
                ...state,
                state: "inactive",
                errorMessage: undefined,
                selection: { files, rejections },
                announcement: `${action.file.name} removed, ${files.length + rejections.length} total`,
            };
        }
        case "CLEAR_ALL": {
            const { files, rejections } = state.selection;
            if (files.length + rejections.length === 0) {
                return state;
            }
            return {
                ...state,
                state: "inactive",
                errorMessage: undefined,
                selection: emptySelection,
                announcement: "Selection cleared",
            };
        }
    }
};
// `reportSelection` swallows the error, so a developer only sees it if we report it
const reportUnexpected = (error) => {
    if (!(error instanceof FileUploadError)) {
        globalThis.reportError?.(error);
    }
};
const useFileInput = ({ isDisabled, accept, maxSize, multiple, maxFiles, onUpload, onFilesChange, }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const outcomeIdRef = useRef(0);
    // An outcome the user has already moved past must not overwrite what
    // replaced it on screen
    const claimOutcome = () => {
        outcomeIdRef.current += 1;
        const outcomeId = outcomeIdRef.current;
        return () => outcomeId === outcomeIdRef.current;
    };
    // A rejecting `onFilesChange` lands in the inline error state, on a removal
    // as much as on a drop, rather than as an unhandled rejection
    const reportSelection = async (files, rejections) => {
        const isCurrent = claimOutcome();
        try {
            await onFilesChange?.(files, rejections);
        }
        catch (error) {
            if (isCurrent()) {
                dispatch({
                    type: "ERROR",
                    message: error instanceof FileUploadError
                        ? error.message
                        : "Something went wrong. Try again",
                });
            }
            reportUnexpected(error);
        }
    };
    // The reducer owns every change to the selection, so reporting keys off the
    // committed value
    const reportedRef = useRef(state.selection);
    useEffect(() => {
        if (reportedRef.current === state.selection) {
            return;
        }
        reportedRef.current = state.selection;
        void reportSelection([...state.selection.files], [...state.selection.rejections]);
    });
    // Drives the single-file presentation: progress bar, then success or inline error
    const runUpload = async (file, upload) => {
        // Only the single-file path reaches here, and it holds no selection for a
        // stale outcome to clear
        const isCurrent = multiple ? claimOutcome() : () => true;
        try {
            const promise = upload();
            if (isPromise(promise)) {
                const abortController = new AbortController();
                // Show upload progress only if `upload` promise takes longer than 200ms to resolve
                await Promise.race([
                    promise.catch((error) => {
                        abortController.abort();
                        throw error;
                    }),
                    delay(200, { signal: abortController.signal }).then(() => {
                        if (isCurrent()) {
                            dispatch({
                                type: "START_UPLOADING",
                            });
                        }
                    }),
                ]);
                // `Promise.race` might resolve with `delay` promise first,
                // so we still need to wait for `upload` promise to resolve
                await promise;
                abortController.abort();
                if (isCurrent()) {
                    dispatch({
                        type: "UPLOAD",
                        fileName: file.name,
                    });
                }
                return;
            }
            dispatch({
                type: "UPLOAD",
                fileName: file.name,
            });
        }
        catch (error) {
            if (isCurrent()) {
                dispatch({
                    type: "ERROR",
                    message: error instanceof FileUploadError
                        ? error.message
                        : "Something went wrong. Try again",
                });
            }
            // A superseded outcome suppresses only the UI update; an unexpected
            // consumer error still propagates
            if (!(error instanceof FileUploadError)) {
                throw error;
            }
        }
    };
    const dropzone = useDropzone({
        disabled: isDisabled,
        // `ADD_FILES` counts against `maxFiles` itself, so the dropzone's own cap
        // stays lifted with `0`
        maxFiles: multiple ? 0 : 1,
        // Size is checked here rather than through the dropzone's own `maxSize`,
        // whose message reports the limit in raw bytes
        validator(file) {
            if (file.name && accept) {
                const extension = file.name.split(".").pop();
                if (!extension) {
                    return {
                        code: "invalid-extension",
                        message: "File must have an extension",
                    };
                }
                if (!accept.includes(extension)) {
                    return {
                        code: "invalid-extension",
                        message: `Only ${accept.join(", ").toLowerCase()} files are allowed`,
                    };
                }
            }
            if (file.size > maxSize) {
                return {
                    code: "file-too-large",
                    message: `File is larger than ${prettyBytes(maxSize)}`,
                };
            }
            return null;
        },
        onDragEnter() {
            dispatch({
                type: "DRAG_ENTER",
            });
        },
        onDragLeave() {
            dispatch({
                type: "DRAG_LEAVE",
            });
        },
        async onDrop(files, rejections) {
            if (!multiple) {
                const file = files[0];
                if (!file || !onUpload) {
                    return;
                }
                await runUpload(file, () => onUpload(file));
                return;
            }
            const fileRejections = toFileRejections(rejections);
            // The committed selection is enough here: every action that changes it
            // is raised by a discrete event, flushed before this drop is delivered
            const seen = signaturesOf(state.selection);
            const hasUnseenFile = [
                ...files,
                ...fileRejections.map((rejection) => rejection.file),
            ].some((file) => !seen.has(fileSignature(file)));
            // Only a drop that lands something owns the outcome; one that adds
            // nothing must leave a report still in flight to finish
            if (hasUnseenFile) {
                claimOutcome();
            }
            dispatch({
                type: "ADD_FILES",
                files: [...files],
                rejections: fileRejections,
                maxFiles,
            });
        },
        onError(error) {
            // Reached without going through `onDrop`, so this claims for itself
            claimOutcome();
            dispatch({
                type: "ERROR",
                message: error.message,
            });
        },
        onDropRejected(rejections) {
            // `onDrop` already decided how a multi-file batch is presented
            if (multiple) {
                return;
            }
            dispatch({
                type: "ERROR",
                message: rejections[0]?.errors[0]?.message ??
                    "Something went wrong. Try again",
            });
        },
    });
    const nProgress = useNProgress({
        isAnimating: state.state === "uploading",
    });
    return {
        ...state,
        uploadProgress: nProgress.progress * 100,
        removeFile(file) {
            dispatch({
                type: "REMOVE_FILE",
                file,
            });
        },
        clearFiles() {
            dispatch({
                type: "CLEAR_ALL",
            });
        },
        getRootProps() {
            return {
                ...dropzone.getRootProps(),
                onMouseEnter() {
                    if (isDisabled) {
                        return;
                    }
                    dispatch({
                        type: "MOUSE_ENTER",
                    });
                },
                onMouseLeave() {
                    if (isDisabled) {
                        return;
                    }
                    dispatch({
                        type: "MOUSE_LEAVE",
                    });
                },
            };
        },
        getInputProps() {
            return {
                ...dropzone.getInputProps(),
                accept: accept
                    ? accept.map((extension) => `.${extension}`).join(",")
                    : undefined,
            };
        },
    };
};

const tenMegabytes = 1000 * 1000 * 10;
function FileInput({ isDisabled = false, accept, maxSize = tenMegabytes, multiple = false, maxFiles, onUpload, onFilesChange, validFilesLabel = "Valid files", invalidFilesLabel = "Unable to upload", }) {
    const extensions = normalizeExtensions(accept);
    const browseNodeRef = useRef(null);
    const shouldFocusBrowseRef = useRef(false);
    const setBrowseNode = useCallback((node) => {
        browseNodeRef.current = node;
    }, []);
    const { state, fileName, errorMessage, isMouseOver, selection, announcement, uploadProgress, removeFile, clearFiles, getRootProps, getInputProps, } = useFileInput({
        isDisabled,
        accept: extensions,
        maxSize,
        multiple,
        maxFiles,
        onUpload,
        onFilesChange,
    });
    const rowCount = selection.files.length + selection.rejections.length;
    const hasSelection = rowCount > 0;
    // Emptying the selection unmounts the control that was focused, so focus
    // lands on the returning drop zone rather than falling to the document
    useEffect(() => {
        if (!shouldFocusBrowseRef.current || hasSelection) {
            return;
        }
        shouldFocusBrowseRef.current = false;
        browseNodeRef.current?.focus();
    }, [hasSelection]);
    const dropZone = (jsx(DropZone, { variant: multiple && hasSelection ? "slim" : "full", state: state, isMouseOver: isMouseOver, isDisabled: isDisabled, multiple: multiple, fileName: fileName, errorMessage: errorMessage, uploadProgress: uploadProgress, extensions: extensions, maxSize: maxSize, maxFiles: maxFiles, browseRef: setBrowseNode, getRootProps: getRootProps, getInputProps: getInputProps }));
    if (!multiple) {
        return dropZone;
    }
    return (jsxs(Column, { gap: 2, minH: fullHeight, children: [jsx(VisuallyHidden, { "aria-live": "polite", children: announcement }), hasSelection && (jsxs(Fragment, { children: [jsx(SelectionCaption, { files: selection.files, rowCount: rowCount, hasRejections: selection.rejections.length > 0, maxFiles: maxFiles, isDisabled: isDisabled, onClearAll: () => {
                            shouldFocusBrowseRef.current = true;
                            clearFiles();
                        } }), jsx(FileList, { files: selection.files, rejections: selection.rejections, validFilesLabel: validFilesLabel, invalidFilesLabel: invalidFilesLabel, isDisabled: isDisabled, onRemove: (file) => {
                            shouldFocusBrowseRef.current = true;
                            removeFile(file);
                        } })] })), dropZone] }));
}

function FilterMenu(props) {
    return jsx(Menu$1, { isLazy: true, closeOnSelect: false, ...props });
}

const FilterMenuButton = forwardRef$1(function FilterMenuButton_(props, ref) {
    let iconSize = 5;
    if (props.size === "sm") {
        iconSize = 4;
    }
    else if (props.size === "lg" || props.size === "xl") {
        iconSize = 6;
    }
    return (jsx(MenuButton$1, { ref: ref, as: Button, directionIconSize: iconSize, directionIcon: (props) => (jsx(Icon, { as: ChevronDownIcon, ...props, baseline: true })), ...props }));
});
FilterMenuButton.displayName = "FilterMenuButton";

function FilterMenuGroup({ type, onChange, ...props }) {
    const valueChanged = useCallback((value) => {
        if (type === "radio" && typeof value === "string") {
            onChange(value);
        }
        if (type === "checkbox" && Array.isArray(value)) {
            onChange(value);
        }
    }, [type, onChange]);
    return jsx(MenuOptionGroup, { type: type, onChange: valueChanged, ...props });
}

const FilterMenuIconButton = forwardRef$1(function FilterMenuIconButton_(props, ref) {
    return jsx(MenuButton$1, { ref: ref, as: IconButton, ...props });
});
FilterMenuIconButton.displayName = "FilterMenuIconButton";

function FilterMenuList(props) {
    return jsx(MenuList$1, { motionProps: dropdownVariants, ...props });
}

function FilterMenuOption(props) {
    return (jsx(MenuItemOption, { icon: jsx(Icon, { as: CheckIcon, fontSize: "md" }), ...props }));
}
// This is required for Chakra UI to recognize `FilterMenuOption` as a valid child
// of `MenuOptionGroup` and assign custom props to handle the selection of options.
//
// See https://github.com/chakra-ui/chakra-ui/blob/c595d045c26e0fed2da35bbe6f4eb9bf6939947b/packages/menu/src/use-menu.ts#L739-L746
FilterMenuOption.id = "MenuItemOption";

/** How much of `value` is actually selectable. Stale values would otherwise read as selected. */
function selectedOptionCount(value, options) {
    return options.filter((option) => value.has(option.value)).length;
}
/** Whether the selection reads as "All". Shared so the pill summary and the "All" row can't disagree. */
function isAllSelected(value, options) {
    return selectedOptionCount(value, options) === options.length;
}

/** Renders the checkbox list without its own Popover, so several filters can share one. */
function FilterOptionList({ label, value, onChange, options, showOnlyAffordance = true, }) {
    const styles = useMultiStyleConfig("FilterOptionList", {
        showOnlyAffordance,
    });
    // Row text is a <label> for its checkbox; Checkbox is already a <label>, so
    // wrapping a whole row in one would nest them.
    const idPrefix = useId();
    const allSelected = isAllSelected(value, options);
    // Counted against the options so a stale-only selection reads as empty, not
    // mixed: none unchecked, some mixed, all checked.
    const isIndeterminate = !allSelected && selectedOptionCount(value, options) > 0;
    const toggleAll = () => {
        onChange(allSelected ? new Set() : new Set(options.map((o) => o.value)));
    };
    const selectOnly = (optionValue) => {
        onChange(new Set([optionValue]));
    };
    const focusManager = useFocusManager();
    const onKeyDown = (event) => {
        if (!focusManager ||
            (event.key !== "ArrowDown" && event.key !== "ArrowUp")) {
            return;
        }
        event.preventDefault();
        const accept = (node) => node.matches('input[type="checkbox"]');
        if (event.key === "ArrowDown") {
            focusManager.focusNext({ tabbable: true, wrap: true, accept });
        }
        else {
            focusManager.focusPrevious({ tabbable: true, wrap: true, accept });
        }
    };
    const toggle = (optionValue) => {
        const next = new Set(value);
        if (next.has(optionValue)) {
            next.delete(optionValue);
        }
        else {
            next.add(optionValue);
        }
        onChange(next);
    };
    return (jsxs(chakra.div, { __css: styles["container"], onKeyDown: onKeyDown, children: [label && (jsx(chakra.div, { __css: styles["header"], children: jsx(Text, { size: "sm", fontWeight: "medium", children: label }) })), jsxs(chakra.div, { __css: styles["row"], children: [jsx(Checkbox, { id: `${idPrefix}-all`, "aria-label": label ? `All ${label}` : "All", isChecked: allSelected, isIndeterminate: isIndeterminate, onChange: toggleAll }), jsx(chakra.label, { htmlFor: `${idPrefix}-all`, __css: styles["checkboxLabel"], children: jsx(Text, { children: "All" }) })] }), options.map((option) => (
            // Row click toggles, like the checkbox; only "Only" narrows the
            // selection. Not a <button> (it contains a checkbox).
            jsxs(chakra.div, { className: "group", __css: styles["optionRow"], onClick: () => toggle(option.value), children: [jsx(Checkbox, { id: `${idPrefix}-${option.value}`, "aria-label": option.label, isChecked: value.has(option.value), onChange: () => toggle(option.value), onClick: (e) => e.stopPropagation() }), option.icon && (jsx(chakra.div, { __css: styles["iconSlot"], children: jsx(option.icon, { size: 20 }) })), jsx(chakra.label, { htmlFor: `${idPrefix}-${option.value}`, __css: styles["optionText"], 
                        // Its own activation already toggles the checkbox and focuses it;
                        // reaching the row too would toggle a second time and cancel out.
                        onClick: (event) => event.stopPropagation(), children: jsx(Text, { children: option.label }) }), showOnlyAffordance && (jsx(chakra.button, { type: "button", "aria-label": `Show only ${option.label}`, __css: styles["onlyButton"], onClick: (e) => {
                            e.stopPropagation();
                            selectOnly(option.value);
                        }, children: jsx(Text, { size: "sm", children: "Only" }) }))] }, option.value)))] }));
}

/** The filter pill trigger on its own, for a popover `FilterPill` can't host. */
const FilterPillButton = forwardRef$1(function FilterPillButton_({ label, summary, ...props }, ref) {
    const styles = useMultiStyleConfig("FilterPill", {});
    return (jsx(Button, { ref: ref, ...props, variant: "secondary", shape: "circle", directionIcon: (iconProps) => (jsx(Icon, { as: ChevronDownIcon, ...iconProps, baseline: true })), children: jsxs(chakra.span, { __css: styles["labelGroup"], children: [jsx(Text, { children: label }), summary] }) }));
});
FilterPillButton.displayName = "FilterPillButton";

// biome-ignore lint/style/useComponentExportOnlyModules: re-exported Chakra component
const Popover = Popover$1;
// biome-ignore lint/style/useComponentExportOnlyModules: re-exported Chakra component
const PopoverTrigger = PopoverTrigger$1;
// biome-ignore lint/style/useComponentExportOnlyModules: re-exported Chakra component
const PopoverBody = PopoverBody$1;
const PopoverContent = forwardRef$1(function PopoverContent_(props, ref) {
    return (jsx(PopoverContent$1, { ref: ref, bg: "white", borderRadius: "2xl", boxShadow: "lg", border: "none", motionProps: popoverVariants, ...props }));
});
PopoverContent.displayName = "PopoverContent";

/** A rounded filter trigger that opens a popover of options. */
function FilterPill({ label, summary, children, placement = "bottom-start", ...props }) {
    const styles = useMultiStyleConfig("FilterPill", {});
    const bodyRef = useRef(null);
    // Checkbox forwards its ref to a wrapper div, so resolve the input from the body.
    const initialFocusRef = useMemo(() => ({
        get current() {
            return (bodyRef.current?.querySelector('input[type="checkbox"]') ?? null);
        },
    }), []);
    return (jsxs(Popover, { isLazy: true, placement: placement, initialFocusRef: initialFocusRef, children: [jsx(PopoverTrigger, { children: jsx(FilterPillButton, { label: label, summary: summary, ...props }) }), jsx(Portal, { children: jsx(PopoverContent, { motionProps: dropdownVariants, sx: styles["content"], children: jsx(PopoverBody, { ref: bodyRef, sx: styles["body"], children: jsx(FocusScope, { contain: true, restoreFocus: true, children: children }) }) }) })] }));
}

// An empty selection shows no summary at all: the pill stands as its own label,
// and the badge carries real counts only.
function summaryFor(selected, options) {
    if (isAllSelected(selected, options)) {
        return (jsx(Text, { color: "text.primary", fontWeight: "medium", children: "All" }));
    }
    if (selected.size === 0) {
        return null;
    }
    return (jsx(Badge, { size: "sm", variant: "info", children: selected.size }));
}
/** A `FilterPill` with a single checkbox `FilterOptionList` and an All/count summary. */
function FilterPillMultiSelect({ label, value, onChange, options, showOnlyAffordance = true, }) {
    // Stale values are dropped so the trigger and popover can't disagree.
    const optionValues = new Set(options.map((option) => option.value));
    const selected = new Set([...value].filter((v) => optionValues.has(v)));
    return (jsx(FilterPill, { label: label, summary: summaryFor(selected, options), children: jsx(FilterOptionList, { label: label, value: selected, onChange: onChange, options: options, showOnlyAffordance: showOnlyAffordance }) }));
}

function FormField({ isRequired = false, isOptional = false, label, badge, description, error, children, tip, rightContent, ...props }) {
    return (jsxs(FormControl, { display: "flex", alignItems: "start", gap: 2, justifyContent: "space-between", isInvalid: Boolean(error), isRequired: isRequired, ...props, children: [jsxs(Box$1, { display: "flex", flexDirection: "column", flex: 1, minWidth: 0, children: [jsxs(Box$1, { display: "flex", alignItems: "center", gap: 2, children: [jsxs(FormLabel, { display: "inline", children: [label, isOptional && (jsx(Text$1, { as: "span", size: "sm", color: "text.secondary", fontWeight: "normal", ml: 1, children: "(optional)" }))] }), badge && badge] }), description && jsx(FormHelperText, { children: description }), jsx(Box$1, { mt: 2, children: children }), error && jsx(FormErrorMessage, { children: error }), tip && (jsx(Text$1, { mt: 1, size: "sm", color: "text.tertiary", children: tip }))] }), rightContent] }));
}

const pushBackScale = "scale(0.96)";
const pushBackRadius = "12px";
const enterDuration = transition.duration.slower;
const exitDuration = transition.duration.slow;
// The transition only starts on the frame after the style lands, so the cleanup
// waits past the exit duration rather than exactly on it.
const exitCleanupDelay = motionDurations.slow * 1000 + 50;
const { easeOutQuint } = transition.easing;
function makeTransition(duration) {
    return `transform ${duration} ${easeOutQuint}, border-radius ${duration} ${easeOutQuint}`;
}
function FullScreenModal({ isOpen, onClose, children, containerRef, closeOnEsc = true, }) {
    const resolvedContainerRef = useRef(undefined);
    // Apply push-back effect to the app container
    useEffect(() => {
        const container = containerRef?.current ??
            document.body.firstElementChild ??
            undefined;
        resolvedContainerRef.current = container;
        if (!container)
            return;
        if (isOpen) {
            // TODO(eric.lovett): Refactor this component to receive the element to modify via a
            // different mechanism. For example, this component could receive a callback that it
            // calls with the style properties to set, or it could receive a callback that will
            // return the component to modify.
            container.style.transition = makeTransition(enterDuration);
            container.style.transformOrigin = "center top";
            container.style.transform = pushBackScale;
            container.style.borderRadius = pushBackRadius;
            container.style.overflow = "hidden";
        }
        else {
            container.style.transition = makeTransition(exitDuration);
            container.style.transform = "";
            container.style.borderRadius = "";
            const timer = setTimeout(() => {
                container.style.overflow = "";
                container.style.transition = "";
                container.style.transformOrigin = "";
            }, exitCleanupDelay);
            return () => {
                clearTimeout(timer);
            };
        }
    }, [isOpen, containerRef]);
    // Restore container styles on unmount
    useEffect(() => {
        return () => {
            const container = resolvedContainerRef.current;
            if (!container)
                return;
            container.style.transition = "";
            container.style.transform = "";
            container.style.borderRadius = "";
            container.style.overflow = "";
            container.style.transformOrigin = "";
        };
    }, []);
    return (jsxs(Modal, { blockScrollOnMount: true, closeOnEsc: closeOnEsc, isOpen: isOpen, motionPreset: "none", size: "full", onClose: onClose, children: [jsx(ModalOverlay, { bg: "blackAlpha.40", backdropFilter: "none", motionProps: {
                    initial: { opacity: 0 },
                    animate: {
                        opacity: 1,
                        transition: { duration: motionDurations.slower },
                    },
                    exit: { opacity: 0, transition: { duration: motionDurations.fast } },
                } }), jsx(ModalContent, { m: 0, w: "100vw", maxW: "100vw", h: "100vh", maxH: "100vh", borderRadius: 0, bg: "white", boxShadow: "none", motionProps: fullScreenModalVariants, children: children })] }));
}

/**
 * Hover and focus state with optional open/close delays.
 *
 * Set `openDelayMs` to require dwell on the trigger before activating
 * (intent-based hover — useful for popovers that should not flash open on
 * incidental cursor crossings). Set `closeDelayMs` to keep state active
 * briefly after leave/blur, so the cursor can cross a small gap between
 * related elements (e.g. chip → popover) without flipping state off
 * mid-transit.
 *
 * Hover and focus share a single timer, so any new enter/leave cancels a
 * pending opposite-direction update.
 */
function useHoverFocusState({ openDelayMs = 0, closeDelayMs = 0, } = {}) {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const timeoutRef = useRef(undefined);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    const apply = useCallback((fn, delay) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
        if (delay > 0) {
            timeoutRef.current = setTimeout(fn, delay);
        }
        else {
            fn();
        }
    }, []);
    const handleMouseEnter = useCallback(() => {
        apply(() => {
            setIsHovered(true);
        }, openDelayMs);
    }, [apply, openDelayMs]);
    const handleMouseLeave = useCallback(() => {
        apply(() => {
            setIsHovered(false);
        }, closeDelayMs);
    }, [apply, closeDelayMs]);
    const handleFocus = useCallback(() => {
        apply(() => {
            setIsFocused(true);
        }, openDelayMs);
    }, [apply, openDelayMs]);
    const handleBlur = useCallback(() => {
        apply(() => {
            setIsFocused(false);
        }, closeDelayMs);
    }, [apply, closeDelayMs]);
    const close = useCallback(() => {
        setIsHovered(false);
        setIsFocused(false);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        }
    }, []);
    return {
        isActive: isHovered || isFocused,
        isHovered,
        isFocused,
        handleMouseEnter,
        handleMouseLeave,
        handleFocus,
        handleBlur,
        close,
    };
}

// biome-ignore lint/style/useComponentExportOnlyModules: the variant maps ship alongside the component
const variantIcons = {
    simple: undefined,
    info: InformationIcon,
    danger: ErrorIcon,
    warning: WarningIcon,
    newFeature: SparkleIcon,
};
// biome-ignore lint/style/useComponentExportOnlyModules: the variant maps ship alongside the component
const variantTextColors = {
    simple: "text.secondary",
    info: "text.accent",
    danger: "text.danger",
    warning: "text.warning",
    newFeature: "text.upsell",
};
const hoverDelayMs = 150;
function GlobalAnnouncement({ variant = "simple", label, onDismiss, icon: iconOverride, ...marginProps }) {
    const { isActive, handleMouseEnter, handleMouseLeave, handleFocus, handleBlur, } = useHoverFocusState({ closeDelayMs: hoverDelayMs });
    const styles = useMultiStyleConfig("GlobalAnnouncement", {
        variant,
        isActive,
        hasDismiss: Boolean(onDismiss),
    });
    const IconComponent = iconOverride ?? variantIcons[variant];
    const shimmerEnabled = variant === "newFeature";
    const handleDismiss = useCallback((event) => {
        onDismiss?.(event);
    }, [onDismiss]);
    return (jsxs(chakra.div, { __css: styles.chip, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ...marginProps, children: [IconComponent && jsx(Icon, { as: IconComponent, __css: styles.icon }), jsx(Box$1, { __css: styles.textContainer, children: jsx(Text, { isTruncated: true, size: "sm", color: variantTextColors[variant], shimmer: shimmerEnabled, 
                    // Purple.300: Text's derived shimmer (purple.900) is invisible against text.upsell
                    shimmerColor: shimmerEnabled ? "purple.300" : undefined, children: label }) }), onDismiss && (jsx(chakra.button, { __css: styles.closeButton, "aria-label": "Dismiss announcement", type: "button", onClick: handleDismiss, onFocus: handleFocus, onBlur: handleBlur, children: jsx(Icon, { as: CloseIcon, __css: styles.closeIcon }) }))] }));
}

const protocolRegex = /^https?:\/\//u;
const ChakraLinkComponent = Link$1;
const Link = forwardRef$1(function Link_({ href, children, variant = "primary", ...props }, ref) {
    const isExternal = useMemo(() => {
        return props.isExternal ?? protocolRegex.test(href);
    }, [href, props.isExternal]);
    return (jsx(ChakraLinkComponent, { ref: ref, ...props, isExternal: isExternal, href: href, variant: variant, children: children }));
});
Link.displayName = "Link";

function GlobalAnnouncementPopover({ variant = "simple", label, title, description, onDismiss, primaryAction, secondaryAction, link, icon: iconOverride, shimmer: shimmerEnabled = variant === "newFeature", ...marginProps }) {
    const { isActive, handleMouseEnter, handleMouseLeave, handleFocus, handleBlur, close, } = useHoverFocusState({ openDelayMs: hoverDelayMs });
    // Ref for the first action button to receive focus when popover opens
    const initialFocusRef = useRef(null);
    const chipStyles = useMultiStyleConfig("GlobalAnnouncement", {
        variant,
        isActive,
    });
    const popoverStyles = useMultiStyleConfig("GlobalAnnouncementPopover", {
        variant,
    });
    const IconComponent = iconOverride ?? variantIcons[variant];
    const handleDismiss = useCallback(() => {
        // Close the popover immediately
        close();
        // Notify parent to remove the announcement
        onDismiss?.();
    }, [close, onDismiss]);
    return (jsxs(Popover$1, { autoFocus: true, isLazy: true, closeOnBlur: false, gutter: 8, initialFocusRef: initialFocusRef, isOpen: isActive, placement: "top-start", returnFocusOnClose: false, lazyBehavior: "unmount", children: [jsx(PopoverTrigger$1, { children: jsxs(chakra.button, { __css: chipStyles.chip, display: "inline-flex", type: "button", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, ...marginProps, children: [IconComponent && jsx(Icon, { as: IconComponent, __css: chipStyles.icon }), jsx(Box$1, { __css: chipStyles.textContainer, children: jsx(Text, { isTruncated: true, size: "sm", color: variantTextColors[variant], shimmer: shimmerEnabled, 
                                // Purple.300: Text's derived shimmer (purple.900) is invisible against text.upsell
                                shimmerColor: shimmerEnabled ? "purple.300" : undefined, children: label }) })] }) }), jsx(Portal$1, { children: jsx(PopoverContent$1, { border: "none", borderRadius: "2xl", boxShadow: "none !important", outline: "none !important", bg: "transparent", motionProps: popoverVariants, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, children: jsx(Box$1, { __css: popoverStyles.popover, children: jsxs(chakra.div, { __css: popoverStyles.content, children: [title && (jsxs(chakra.div, { __css: popoverStyles.titleContainer, children: [IconComponent && (jsx(Icon, { as: IconComponent, __css: popoverStyles.titleIcon })), jsx(chakra.span, { __css: popoverStyles.title, children: title })] })), description && (jsx(chakra.span, { __css: popoverStyles.description, children: description })), link && (jsx(Link, { href: link.href, isExternal: link.isExternal, fontSize: "sm", lineHeight: "4", children: link.label })), (onDismiss || primaryAction || secondaryAction) && (jsxs(chakra.div, { __css: popoverStyles.actions, children: [onDismiss && (jsx(Button, { ref: primaryAction || secondaryAction
                                                ? undefined
                                                : initialFocusRef, variant: "tertiary", size: "sm", onClick: handleDismiss, children: "Dismiss" })), secondaryAction && (jsx(Button, { ref: primaryAction ? undefined : initialFocusRef, variant: "tertiary", size: "sm", onClick: secondaryAction.onClick, children: secondaryAction.label })), primaryAction && (jsx(Button, { ref: initialFocusRef, variant: "secondary", size: "sm", onClick: primaryAction.onClick, children: primaryAction.label }))] }))] }) }) }) })] }));
}

function SelectGroup({ hasDivider = false, children, }) {
    const styles = useMultiStyleConfig("SelectGroup");
    const { contentFits, ref } = useContentFits();
    const heading = (jsx(chakra.div, { __css: styles["container"], children: jsx(Tooltip, { message: typeof children === "string" ? children : "", isDisabled: typeof children !== "string" || contentFits, children: jsx(chakra.span, { ref: ref, __css: styles["label"], children: children }) }) }));
    if (!hasDivider) {
        return heading;
    }
    return (jsxs(chakra.div, { __css: styles["root"], children: [jsx(chakra.div, { __css: styles["divider"] }), heading] }));
}

/**
 * Stands for the footer action in Downshift's item list, after every option, so
 * arrow keys reach it and Enter runs it like any other option.
 */
const FooterActionItem = Symbol("footer action");
// Downshift reads any press in the lazily mounted popup as an outside click.
// Hiding the whole press, down and up, keeps its mouse-down flag from sticking and swallowing the next blur.
function hideFromOutsideClickTracker(event) {
    event.stopPropagation();
}
/**
 * Selected options leave the list, the remainder is search-filtered, and what
 * survives is virtualized.
 */
function useGroupedBadgeInputOptions({ optionGroups, optionLabel, optionValue, disableSortingAndFiltering, inputValue, value, optionsContainer, }) {
    const filteredOptionGroups = useMemo(() => {
        return optionGroups
            .map((optionGroup) => {
            // Exclude all options that are already selected
            const unselectedOptions = optionGroup.options.filter((option) => {
                const isSelected = value.some((valueItem) => {
                    return isEqual(optionValue(option), valueItem);
                });
                return !isSelected;
            });
            if (inputValue.length === 0 || disableSortingAndFiltering) {
                return {
                    ...optionGroup,
                    options: unselectedOptions,
                };
            }
            return {
                ...optionGroup,
                options: matchSorter(unselectedOptions, inputValue, {
                    keys: [optionLabel],
                }),
            };
        })
            .filter((optionGroup) => optionGroup.options.length > 0);
    }, [
        optionGroups,
        optionLabel,
        optionValue,
        disableSortingAndFiltering,
        inputValue,
        value,
    ]);
    const downshiftItems = useMemo(() => {
        const items = [];
        for (const optionGroup of filteredOptionGroups) {
            items.push(...optionGroup.options);
        }
        return items;
    }, [filteredOptionGroups]);
    const selectedOptions = useMemo(() => {
        const result = [];
        values: for (const valueItem of value) {
            for (const optionGroup of optionGroups) {
                for (const option of optionGroup.options) {
                    if (isEqual(optionValue(option), valueItem)) {
                        result.push({ option, groupLabel: optionGroup.label });
                        continue values;
                    }
                }
            }
        }
        return result;
    }, [optionGroups, optionValue, value]);
    const { virtualItems, getVirtualItemIndex, virtualizer } = useVirtualItems({
        optionGroups: filteredOptionGroups,
        optionLabel,
        containerRef: optionsContainer,
        estimatedSize: 37,
    });
    return {
        downshiftItems,
        selectedOptions,
        virtualItems,
        getVirtualItemIndex,
        virtualizer,
    };
}
function GroupedBadgeInput({ isDisabled = false, isLoading = false, isInvalid = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", disableSortingAndFiltering = false, optionGroups, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionIconSrc, optionAccessories, placeholder = "", removePortal = false, footerAction, size = "md", value, width = "xs", popoverWidth, onChange, onSearchUpdate, valueLabel = optionLabel, showGroupInBadges = false, badgeInputRef, _internalRenderLabelContent, }) {
    const [inputValue, setInputValue] = useState("");
    const updateSearch = useCallback((value) => {
        setInputValue(value);
        onSearchUpdate?.(value);
    }, [onSearchUpdate]);
    const selection = useMultipleSelection({
        selectedItems: value,
        onStateChange({ selectedItems: newSelectedItems, type }) {
            switch (type) {
                case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownBackspace:
                case useMultipleSelection.stateChangeTypes.SelectedItemKeyDownDelete:
                case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                case useMultipleSelection.stateChangeTypes.FunctionRemoveSelectedItem: {
                    onChange(newSelectedItems ?? []);
                    break;
                }
                case useMultipleSelection.stateChangeTypes.SelectedItemClick:
                case useMultipleSelection.stateChangeTypes
                    .SelectedItemKeyDownNavigationNext:
                case useMultipleSelection.stateChangeTypes
                    .SelectedItemKeyDownNavigationPrevious:
                case useMultipleSelection.stateChangeTypes
                    .DropdownKeyDownNavigationPrevious:
                case useMultipleSelection.stateChangeTypes.DropdownClick:
                case useMultipleSelection.stateChangeTypes.FunctionAddSelectedItem:
                case useMultipleSelection.stateChangeTypes.FunctionSetSelectedItems:
                case useMultipleSelection.stateChangeTypes.FunctionSetActiveIndex:
                case useMultipleSelection.stateChangeTypes.FunctionReset: {
                    break;
                }
            }
        },
        onSelectedItemsChange({ selectedItems }) {
            onChange(selectedItems ?? []);
        },
    });
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    // useFormControl only yields an id inside a FormControl, and these ids are
    // referenced by ARIA attributes that must resolve.
    const generatedId = useId();
    const fieldId = formControl.id ?? generatedId;
    const optionsContainer = useRef(null);
    const { downshiftItems, selectedOptions, virtualItems, getVirtualItemIndex, virtualizer, } = useGroupedBadgeInputOptions({
        optionGroups,
        optionLabel,
        optionValue,
        disableSortingAndFiltering,
        inputValue,
        value,
        optionsContainer,
    });
    const footerActionIndex = downshiftItems.length;
    const hasFooterAction = Boolean(footerAction);
    const comboboxItems = useMemo(() => hasFooterAction ? [...downshiftItems, FooterActionItem] : downshiftItems, [downshiftItems, hasFooterAction]);
    // The footer action's handler is built before useCombobox returns closeMenu.
    const closeMenuRef = useRef(() => { });
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(item) {
            if (!item) {
                return "";
            }
            if (item === FooterActionItem) {
                return footerAction?.label ?? "";
            }
            return optionLabel(item);
        },
        stateReducer(state, { type, changes }) {
            switch (type) {
                case useCombobox.stateChangeTypes.InputClick: {
                    return {
                        ...changes,
                        isOpen: state.isOpen,
                    };
                }
                case useCombobox.stateChangeTypes.ItemClick:
                case useCombobox.stateChangeTypes.InputKeyDownEnter: {
                    return {
                        ...changes,
                        isOpen: true,
                        // Running the action selects nothing, so the search stays.
                        inputValue: changes.selectedItem === FooterActionItem
                            ? state.inputValue
                            : "",
                    };
                }
                case useCombobox.stateChangeTypes.InputKeyDownArrowDown:
                case useCombobox.stateChangeTypes.InputKeyDownArrowUp:
                case useCombobox.stateChangeTypes.InputKeyDownEscape:
                case useCombobox.stateChangeTypes.InputKeyDownHome:
                case useCombobox.stateChangeTypes.InputKeyDownEnd:
                case useCombobox.stateChangeTypes.InputKeyDownPageUp:
                case useCombobox.stateChangeTypes.InputKeyDownPageDown:
                case useCombobox.stateChangeTypes.InputChange:
                case useCombobox.stateChangeTypes.InputBlur:
                case useCombobox.stateChangeTypes.MenuMouseLeave:
                case useCombobox.stateChangeTypes.ItemMouseMove:
                case useCombobox.stateChangeTypes.ToggleButtonClick:
                case useCombobox.stateChangeTypes.FunctionToggleMenu:
                case useCombobox.stateChangeTypes.FunctionOpenMenu:
                case useCombobox.stateChangeTypes.FunctionCloseMenu:
                case useCombobox.stateChangeTypes.FunctionSetHighlightedIndex:
                case useCombobox.stateChangeTypes.FunctionSelectItem:
                case useCombobox.stateChangeTypes.FunctionSetInputValue:
                case useCombobox.stateChangeTypes.FunctionReset:
                case useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem: {
                    return changes;
                }
            }
        },
        onInputValueChange(changes) {
            updateSearch(changes.inputValue?.trimStart() ?? "");
        },
        onStateChange({ type, selectedItem }) {
            if (type === useCombobox.stateChangeTypes.InputKeyDownEnter ||
                type === useCombobox.stateChangeTypes.ItemClick) {
                if (!selectedItem) {
                    return;
                }
                if (selectedItem === FooterActionItem) {
                    if (footerAction && !footerAction.isDisabled) {
                        footerAction.onSelect({
                            closeMenu: () => closeMenuRef.current(),
                        });
                    }
                    return;
                }
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                selection.addSelectedItem(optionValue(selectedItem));
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            // The footer action sits outside the virtualized list.
            if (typeof highlightedIndex !== "number" ||
                highlightedIndex >= footerActionIndex) {
                return;
            }
            const virtualIndex = getVirtualItemIndex(highlightedIndex);
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex: virtualIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        footerAction,
        footerActionIndex,
        isOptionDisabled,
        optionLabel,
        optionValue,
        selection,
        virtualizer,
        getVirtualItemIndex,
        virtualItems.length,
        updateSearch,
    ]);
    const combobox = useCombobox({
        inputId: formControl.id,
        items: comboboxItems,
        defaultHighlightedIndex: 0,
        selectedItem: null,
        inputValue,
        ...downshiftMemoizedArguments,
    });
    useEffect(() => {
        closeMenuRef.current = combobox.closeMenu;
    }, [combobox.closeMenu]);
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, combobox.isOpen);
    const menuProps = useMemo(() => combobox.getMenuProps({
        // The listbox role belongs on the options and footer action: the
        // popover also holds the empty state, which is not an option.
        role: undefined,
        id: `${fieldId}-popup`,
    }, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [combobox, formControl.id]);
    // Reset input value to empty string, if user hasn't selected any option and input lost focus
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
        // event handler.
        updateSearch("");
    }, [combobox.isOpen, updateSearch]);
    const styles = useMultiStyleConfig("BadgeInput", { size });
    const { isFocusVisible, focusProps } = useFocusRing({
        isTextInput: true,
        within: true,
    });
    const badgesRef = useRef(null);
    const inputRef = useRef(null);
    const comboboxInputRef = useMergeRefs(badgeInputRef, inputRef);
    const listboxId = `${fieldId}-listbox`;
    const hasHighlightedItem = combobox.highlightedIndex >= 0 &&
        combobox.highlightedIndex < comboboxItems.length;
    // A FormField renders a label wired to this input, so a name supplied here
    // would stand in front of it. The placeholder defaults to an empty string,
    // which is why the fallback cannot be ??.
    const formField = useFormControlContext();
    const inputLabel = formField ? undefined : placeholder || "Search tags";
    const inputProps = useMemo(() => {
        const dropdownProps = selection.getDropdownProps({
            ref: comboboxInputRef,
            preventKeyAction: combobox.isOpen,
        });
        const props = combobox.getInputProps({
            ...dropdownProps,
            // Downshift aims this at a label this control never renders, and the
            // dangling reference outranks every other name.
            "aria-labelledby": undefined,
            "aria-label": inputLabel,
            "aria-controls": listboxId,
            onFocus(event) {
                combobox.openMenu();
                formControl.onFocus(event);
            },
            onBlur: formControl.onBlur,
        });
        // Downshift returns "" with nothing highlighted, and a stale id once the
        // list shrinks past the highlight; neither is a valid IDREF.
        return {
            ...props,
            "aria-activedescendant": hasHighlightedItem
                ? props["aria-activedescendant"] || undefined
                : undefined,
        };
        // TODO(eric.lovett): This deps array is missing `combobox`, `comboboxInputRef`, `formControl`, and `selection` and therefore may
        // be buggy. Please consider adding them.
    }, [
        combobox.getInputProps,
        inputLabel,
        selection.getDropdownProps,
        combobox.isOpen,
        combobox.openMenu,
        formControl.onFocus,
        formControl.onBlur,
        listboxId,
        hasHighlightedItem,
    ]);
    const handleChange = useComboboxImeSupport(updateSearch, inputProps.onChange);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    const isEmpty = virtualItems.length === 0;
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions", {
        isEmpty,
        hasGroupDividers: true,
        variant: footerAction ? "withFooter" : undefined,
    });
    const { ref: scrollMaskRef, maskImage } = useScrollOverflowMask();
    const optionsContainerRef = useMergeRefs(optionsContainer, scrollMaskRef);
    // Without a footer the popover edge already shows where the list is cut off.
    const optionsMaskImage = footerAction ? maskImage : undefined;
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, isOpen: combobox.isOpen, initialFocusRef: inputRef, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(chakra.div, { __css: styles["badgeInput"], width: width, role: "combobox", "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, "data-selected": selectedOptions.length > 0 ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, "data-testid": "grouped-badge-input", onFocus: (event) => {
                            if (typeof focusProps.onFocus === "function") {
                                focusProps.onFocus(event);
                            }
                        }, onBlur: (event) => {
                            if (typeof focusProps.onBlur === "function") {
                                focusProps.onBlur(event);
                            }
                        }, onKeyDown: (event) => {
                            if (event.key === "Escape" && combobox.isOpen) {
                                event.stopPropagation();
                            }
                        }, children: [jsxs(chakra.div, { ref: badgesRef, __css: styles["badges"], onClick: (event) => {
                                    // Focus text input when user clicks on whitespace
                                    if (event.target === badgesRef.current) {
                                        inputRef.current?.focus();
                                    }
                                }, children: [selectedOptions.map(({ option: selectedOption, groupLabel }, index) => {
                                        const iconSrc = typeof optionIconSrc === "function"
                                            ? optionIconSrc(selectedOption)
                                            : undefined;
                                        const label = valueLabel(selectedOption);
                                        return (jsx(Badge
                                        // Two groups can each hold an option with the same label.
                                        , { "data-disabled": formControl.disabled ? "true" : undefined, "data-testid": "grouped-badge-input-selected-option", size: showGroupInBadges || size === "sm" ? "sm" : "md", ...(formControl.disabled
                                                ? {}
                                                : selection.getSelectedItemProps({
                                                    selectedItem: optionValue(selectedOption),
                                                    index,
                                                })), iconSrc: iconSrc, rightActionProps: {
                                                icon: CloseIcon,
                                                "aria-label": showGroupInBadges
                                                    ? `Remove ${label} from ${groupLabel}`
                                                    : "remove",
                                                "aria-disabled": formControl.disabled,
                                                _disabled: formControl.disabled
                                                    ? { color: "gray.400" }
                                                    : undefined,
                                                "data-testid": "grouped-badge-input-selected-option-remove",
                                                onClick: () => {
                                                    if (formControl.disabled) {
                                                        return;
                                                    }
                                                    selection.removeSelectedItem(optionValue(selectedOption));
                                                    inputRef.current?.focus(); // Keep focus on the input so it remains open.
                                                },
                                            }, children: showGroupInBadges ? (
                                            // The space keeps the group and value two words when read aloud.
                                            jsxs(Fragment, { children: [jsx(chakra.span, { __css: styles["badgeGroupLabel"], children: groupLabel }), " ", jsx(chakra.span, { __css: styles["badgeValueLabel"], children: label })] })) : (label) }, JSON.stringify([
                                            groupLabel,
                                            optionLabel(selectedOption),
                                        ])));
                                    }), jsx(chakra.div, { __css: styles["inputContainer"], children: jsx(chakra.input
                                        // Ask 1Password to not autofill this input and not show their icon inside
                                        , { "data-1p-ignore": true, __css: styles["input"], type: "text", placeholder: value.length === 0 ? placeholder : undefined, disabled: formControl.disabled, "data-testid": "grouped-badge-input-input", ...inputProps, onChange: handleChange }) })] }), isLoading ? (jsx(Spinner, { size: "sm" })) : (jsx(chakra.button, { __css: styles["toggleButton"], type: "button", "aria-label": "Toggle options", disabled: formControl.disabled, "data-testid": "grouped-badge-input-toggle", ...combobox.getToggleButtonProps({
                                    "aria-controls": listboxId,
                                }), children: jsx(chakra.div, { as: SelectorIcon, __css: styles["toggleButtonIcon"] }) }))] }) }), jsxs(SelectPopover, { isOpen: combobox.isOpen, removePortal: removePortal, width: popoverWidth ?? width, hasFooter: Boolean(footerAction), "data-testid": "grouped-badge-input-popover", ...menuProps, children: [isEmpty && (jsx(SelectEmptyState
                        // Its own card would sit inside the popover's, above the footer.
                        , { 
                            // Its own card would sit inside the popover's, above the footer.
                            hasBorder: !footerAction, children: emptyOptionsMessage })), jsxs(chakra.div, { __css: selectOptionsStyles["listbox"], role: "listbox", id: listboxId, children: [jsx(chakra.div, { ref: optionsContainerRef, __css: selectOptionsStyles["container"], style: optionsMaskImage
                                        ? {
                                            maskImage: optionsMaskImage,
                                            WebkitMaskImage: optionsMaskImage,
                                        }
                                        : undefined, onMouseDown: handleScrollbarMouseDown, children: !isEmpty && (jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                            height: `${totalHeight}px`,
                                        }, children: visibleItems.map(({ key, index, start }) => {
                                            const virtualItem = virtualItems[index];
                                            const isOption = virtualItem.type === "option";
                                            const iconSrc = isOption
                                                ? optionIconSrc?.(virtualItem.option)
                                                : null;
                                            const accessories = isOption
                                                ? optionAccessories?.(virtualItem.option)
                                                : undefined;
                                            const disabledMessageOrBoolean = virtualItem.type === "option"
                                                ? isOptionDisabled(virtualItem.option)
                                                : undefined;
                                            return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], style: {
                                                    transform: `translateY(${start}px)`,
                                                }, children: [virtualItem.type === "group" && (jsx(chakra.div
                                                    // A new callback each render, so the row is measured
                                                    // again once the popover stops animating: a divided
                                                    // group is taller than the virtualizer's estimate.
                                                    , { 
                                                        // A new callback each render, so the row is measured
                                                        // again once the popover stops animating: a divided
                                                        // group is taller than the virtualizer's estimate.
                                                        ref: (element) => {
                                                            if (element) {
                                                                virtualizer.measureElement(element);
                                                            }
                                                        }, "data-index": index, children: jsx(SelectGroup
                                                        // Groups emptied by selection or search are already
                                                        // dropped, so the first row is always the first
                                                        // visible group.
                                                        , { 
                                                            // Groups emptied by selection or search are already
                                                            // dropped, so the first row is always the first
                                                            // visible group.
                                                            hasDivider: index > 0, children: virtualItem.label }) })), isOption && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                            ? disabledMessageOrBoolean
                                                            : undefined, "data-index": index, leftAccessory: accessories?.leftAccessory ??
                                                            (iconSrc
                                                                ? { type: "image", url: iconSrc }
                                                                : undefined), rightAccessory: accessories?.rightAccessory, ...combobox.getItemProps({
                                                            ref: virtualizer.measureElement,
                                                            item: virtualItem.option,
                                                            index: virtualItem.index,
                                                            onMouseLeave: () => {
                                                                combobox.setHighlightedIndex(-1);
                                                            },
                                                        }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                        }) })) }), footerAction && (jsx(chakra.div, { __css: selectOptionsStyles["footer"], "data-testid": "grouped-badge-input-footer", 
                                    // Keeps focus on the input when the footer's padding is clicked,
                                    // so the menu does not close under the pointer.
                                    onMouseDown: (event) => {
                                        event.preventDefault();
                                        hideFromOutsideClickTracker(event);
                                    }, onMouseUp: hideFromOutsideClickTracker, onTouchStart: hideFromOutsideClickTracker, onTouchEnd: hideFromOutsideClickTracker, children: jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === footerActionIndex, isDisabled: Boolean(footerAction.isDisabled), disabledMessage: typeof footerAction.isDisabled === "string"
                                            ? footerAction.isDisabled
                                            : undefined, isAction: true, leftAccessory: footerAction.icon
                                            ? { type: "icon", icon: footerAction.icon }
                                            : undefined, "data-testid": "grouped-badge-input-footer-action", ...combobox.getItemProps({
                                            item: FooterActionItem,
                                            index: footerActionIndex,
                                            onMouseLeave: () => {
                                                combobox.setHighlightedIndex(-1);
                                            },
                                        }),
                                        // Downshift reports "false" for any item it is not told to
                                        // skip, and a disabled action stays reachable for its tooltip.
                                        "aria-disabled": footerAction.isDisabled
                                            ? "true"
                                            : undefined, children: jsx(SelectOptionLabel, { children: footerAction.label }) }) }))] })] })] }) }));
}

function GroupedCombobox({ isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isLazy = true, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", disableSortingAndFiltering = false, optionGroups, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionAccessories, placeholder = "", removePortal = false, renderInputInControl: renderInputInControlProp = true, trigger, size = "md", value, variant = "default", fontWeight = "normal", width = "xs", popoverWidth, onChange, onSearchUpdate, valueLabel = optionLabel, comboboxRef, showPlaceholderIcon = false, _internalRenderLabelContent, }) {
    trigger ||= { type: "input" };
    const inputRef = useRef(null);
    // Always render the search bar in the popover for icon trigger,
    // otherwise use the provided renderInputInControl prop
    const renderInputInControl = trigger.type === "input" ? renderInputInControlProp : false;
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const selectedOption = useMemo(() => {
        if (value === undefined || value === null) {
            return;
        }
        for (const optionGroup of optionGroups) {
            for (const option of optionGroup.options) {
                if (isEqual(optionValue(option), value)) {
                    return option;
                }
            }
        }
        // This `return` is indeed useless, but TypeScript errors without it
        return;
    }, [optionGroups, optionValue, value]);
    const [isFiltering, setIsFiltering] = useState(false);
    const [inputValue, setInputValue] = useState(() => {
        return selectedOption ? optionLabel(selectedOption) : "";
    });
    const updateSearch = useCallback((value) => {
        setInputValue(value);
        onSearchUpdate?.(value);
    }, [onSearchUpdate]);
    const filteredOptionGroups = useMemo(() => {
        if (!isFiltering || inputValue.length === 0 || disableSortingAndFiltering) {
            return optionGroups;
        }
        return optionGroups
            .map((optionGroup) => {
            return {
                ...optionGroup,
                options: matchSorter(optionGroup.options, inputValue, {
                    keys: [optionLabel, optionDescription],
                }),
            };
        })
            .filter((optionGroup) => optionGroup.options.length > 0);
    }, [
        disableSortingAndFiltering,
        isFiltering,
        optionGroups,
        optionLabel,
        optionDescription,
        inputValue,
    ]);
    const downshiftItems = useMemo(() => {
        const items = [];
        for (const optionGroup of filteredOptionGroups) {
            items.push(...optionGroup.options);
        }
        return items;
    }, [filteredOptionGroups]);
    const optionsContainer = useRef(null);
    const { virtualItems, getVirtualItemIndex, virtualizer } = useVirtualItems({
        optionGroups: filteredOptionGroups,
        optionLabel,
        containerRef: optionsContainer,
    });
    const blurInput = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.blur();
        }
    }, []);
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            if (!option) {
                return "";
            }
            return optionLabel(option);
        },
        onInputValueChange({ inputValue }) {
            updateSearch(inputValue?.trimStart() ?? "");
        },
        onSelectedItemChange({ selectedItem }) {
            if (selectedItem) {
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                onChange(optionValue(selectedItem));
            }
            else if (isClearable) {
                onChange(undefined);
            }
            blurInput();
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen && !renderInputInControl) {
                // Clear input value when combobox is opened
                updateSearch("");
            }
        },
        stateReducer(state, { type, changes }) {
            if (type === useCombobox.stateChangeTypes.InputClick) {
                return {
                    ...changes,
                    isOpen: state.isOpen,
                };
            }
            if (type === useCombobox.stateChangeTypes.InputChange) {
                return {
                    ...changes,
                    highlightedIndex: 0,
                };
            }
            // If it's an item click and the item is disabled, prevent the popover from closing
            if ((type === useCombobox.stateChangeTypes.ItemClick ||
                type === useCombobox.stateChangeTypes.InputKeyDownEnter) &&
                changes.selectedItem) {
                const clickedItem = downshiftItems.find((option) => typeof changes.selectedItem !== "symbol" &&
                    changes.selectedItem &&
                    optionValue(option) === optionValue(changes.selectedItem));
                if (clickedItem && isOptionDisabled(clickedItem)) {
                    return state;
                }
            }
            return changes;
        },
        onStateChange(changes) {
            if (changes.type === useCombobox.stateChangeTypes.InputChange) {
                setIsFiltering(true);
            }
            if (changes.type ===
                useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem ||
                changes.type === useCombobox.stateChangeTypes.InputBlur) {
                setIsFiltering(false);
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            if (typeof highlightedIndex !== "number") {
                return;
            }
            const virtualIndex = getVirtualItemIndex(highlightedIndex);
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex: virtualIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        blurInput,
        downshiftItems,
        isClearable,
        isOptionDisabled,
        onChange,
        optionLabel,
        optionValue,
        updateSearch,
        renderInputInControl,
        getVirtualItemIndex,
        virtualizer,
        virtualItems.length,
    ]);
    const combobox = useCombobox({
        inputId: formControl.id,
        items: downshiftItems,
        inputValue,
        selectedItem: selectedOption ?? null,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, combobox.isOpen);
    const menuProps = useMemo(() => combobox.getMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [combobox]);
    const colorScheme = combobox.isOpen ? "open" : "closed";
    // Reset combobox input value to selected option's label, if
    // user typed something else, but didn't select another option.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (combobox.selectedItem &&
            optionLabel(combobox.selectedItem) !== inputValue) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch(optionLabel(combobox.selectedItem));
        }
    }, [
        combobox.isOpen,
        inputValue,
        combobox.selectedItem,
        optionLabel,
        updateSearch,
    ]);
    // Reset combobox input value to empty string, if user hasn't
    // selected any option and there was no selected option before that.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (!combobox.selectedItem) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch("");
        }
    }, [combobox.isOpen, combobox.selectedItem, updateSearch]);
    const showClearButton = isClearable && Boolean(selectedOption);
    const accessories = selectedOption && typeof optionAccessories === "function"
        ? optionAccessories(selectedOption)
        : undefined;
    const { isFocusVisible, focusProps } = useFocusRing({ isTextInput: true });
    const comboboxInputRef = useMergeRefs(comboboxRef, inputRef);
    const inputProps = combobox.getInputProps({
        ref: comboboxInputRef,
        onFocus(event) {
            combobox.openMenu();
            formControl.onFocus(event);
            if (typeof focusProps.onFocus === "function") {
                focusProps.onFocus(event);
            }
        },
        onBlur(event) {
            formControl.onBlur(event);
            if (typeof focusProps.onBlur === "function") {
                focusProps.onBlur(event);
            }
        },
        onKeyDown(event) {
            if (event.key === "Escape" && combobox.isOpen) {
                event.stopPropagation();
            }
            // Close the combobox when Tab is pressed, restoring focus to the toggle button
            if (!renderInputInControl && event.key === "Tab") {
                combobox.closeMenu();
                event.preventDefault();
            }
        },
    }, { suppressRefError: true });
    const handleChange = useComboboxImeSupport(updateSearch, inputProps.onChange);
    const styles = useMultiStyleConfig("Combobox", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: isLazy, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused when the input
            // is in the toggle button.
            autoFocus: !renderInputInControl, isOpen: combobox.isOpen, initialFocusRef: inputRef, placement: "bottom-start", returnFocusOnClose: !renderInputInControl, children: [jsx(PopoverTrigger$1, { children: trigger.type === "input" && renderInputInControl ? (jsxs(ComboboxControl, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, __css: styles["control"], "data-selected": selectedOption ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, width: width, "data-testid": "grouped-combobox", children: [accessories?.leftAccessory ? (jsx(IconAccessory, { accessory: accessories.leftAccessory })) : showPlaceholderIcon &&
                                optionAccessories &&
                                !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(ComboboxInput, { __css: styles["input"], cursor: combobox.isOpen ? "text" : "pointer", disabled: formControl.disabled, placeholder: placeholder, "data-testid": "grouped-combobox-input", ...inputProps, onChange: handleChange }), accessories?.rightAccessory && (jsx(IconAccessory, { accessory: accessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: combobox.reset })) : (jsx(ComboboxToggleButton, { __css: styles["toggleButton"], disabled: formControl.disabled, ...combobox.getToggleButtonProps() })))] })) : trigger.type === "component" ? (trigger.component({
                        isDisabled: formControl.disabled,
                        isLoading: isLoading,
                        onClick: combobox.openMenu,
                        ...combobox.getToggleButtonProps({
                            "aria-label": selectedOption
                                ? valueLabel(selectedOption)
                                : placeholder && placeholder.length > 0
                                    ? placeholder
                                    : "Toggle options",
                            tabIndex: 0,
                        }),
                    })) : trigger.type === "icon" ? (jsx(IconButton, { isDisabled: formControl.disabled, isLoading: isLoading, icon: trigger.icon, variant: variant === "tertiary" ? "tertiary" : "secondary", size: size, shape: trigger.shape, onClick: combobox.openMenu, ...combobox.getToggleButtonProps({
                            "aria-label": selectedOption
                                ? valueLabel(selectedOption)
                                : placeholder && placeholder.length > 0
                                    ? placeholder
                                    : "Toggle options",
                            tabIndex: 0,
                        }) })) : (jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, "aria-haspopup": "dialog", __css: styles["control"], "data-selected": selectedOption ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, width: width, ...combobox.getToggleButtonProps({ tabIndex: 0 }), children: [accessories?.leftAccessory ? (jsx(IconAccessory, { accessory: accessories.leftAccessory })) : showPlaceholderIcon &&
                                optionAccessories &&
                                !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(chakra.span, { __css: styles["value"], "data-placeholder": selectedOption || formControl.disabled ? undefined : "true", children: selectedOption
                                    ? _internalRenderLabelContent
                                        ? _internalRenderLabelContent(selectedOption)
                                        : valueLabel(selectedOption)
                                    : placeholder }), accessories?.rightAccessory && (jsx(IconAccessory, { accessory: accessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: combobox.reset })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["toggleButtonIcon"] })))] })) }), jsxs(SelectPopover, { isOpen: combobox.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "grouped-combobox-popover", ...menuProps, children: [!renderInputInControl && (jsx(Box, { px: 2, pt: 2, 
                            // Prevent the popover from closing when the user clicks on the search input
                            onMouseUp: (event) => {
                                event.stopPropagation();
                            }, children: jsx(SearchInput, { autoFocus: true, width: "auto", placeholder: placeholder, "aria-label": placeholder || "Search", "aria-invalid": formControl["aria-invalid"], "aria-describedby": formControl["aria-describedby"], "aria-required": formControl["aria-required"], "data-testid": "combobox-search-input", ...inputProps, onChange: handleChange }) })), downshiftItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), downshiftItems.length > 0 && virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    const isOption = virtualItem.type === "option";
                                    const accessories = isOption
                                        ? optionAccessories?.(virtualItem.option)
                                        : null;
                                    const disabledMessageOrBoolean = virtualItem.type === "option"
                                        ? isOptionDisabled(virtualItem.option)
                                        : undefined;
                                    return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], position: "absolute", style: {
                                            transform: `translateY(${start}px)`,
                                        }, children: [virtualItem.type === "group" && (jsx(chakra.div, { ref: virtualizer.measureElement, "data-index": index, children: jsx(SelectGroup, { children: virtualItem.label }) })), isOption && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, isSelected: selectedOption &&
                                                    optionValue(selectedOption) ===
                                                        optionValue(virtualItem.option), isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, ...accessories, ...combobox.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        combobox.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                }) }) }))] })] }) }));
}

const SelectValue = forwardRef$1(function SelectValue_(props, ref) {
    const styles = useMultiStyleConfig("Select");
    return jsx(chakra.span, { ref: ref, __css: styles["value"], ...props });
});
SelectValue.displayName = "SelectValue";

function GroupedMultiSelect({ isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", optionGroups, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionAccessories, placeholder = "", removePortal = false, size = "md", variant = "default", fontWeight = "normal", value, width = "xs", popoverWidth, onChange, valueLabel = optionLabel, renderValue, selectRef, _internalRenderLabelContent, }) {
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const downshiftItems = useMemo(() => {
        const items = [];
        for (const optionGroup of optionGroups) {
            items.push(...optionGroup.options);
        }
        return items;
    }, [optionGroups]);
    const optionsContainer = useRef(null);
    const { virtualItems, getVirtualItemIndex, virtualizer } = useVirtualItems({
        optionGroups,
        optionLabel,
        containerRef: optionsContainer,
    });
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            return option ? optionLabel(option) : "";
        },
        stateReducer(state, { type, changes }) {
            switch (type) {
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick: {
                    return {
                        ...changes,
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex,
                    };
                }
                case useSelect.stateChangeTypes.ToggleButtonClick:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowDown:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowUp:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownCharacter:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEscape:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownHome:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEnd:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownPageUp:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownPageDown:
                case useSelect.stateChangeTypes.ToggleButtonBlur:
                case useSelect.stateChangeTypes.MenuMouseLeave:
                case useSelect.stateChangeTypes.ItemMouseMove:
                case useSelect.stateChangeTypes.FunctionToggleMenu:
                case useSelect.stateChangeTypes.FunctionOpenMenu:
                case useSelect.stateChangeTypes.FunctionCloseMenu:
                case useSelect.stateChangeTypes.FunctionSetHighlightedIndex:
                case useSelect.stateChangeTypes.FunctionSelectItem:
                case useSelect.stateChangeTypes.FunctionSetInputValue:
                case useSelect.stateChangeTypes.FunctionReset: {
                    return changes;
                }
            }
        },
        onSelectedItemChange({ selectedItem }) {
            if (!selectedItem) {
                return;
            }
            const selectedValue = optionValue(selectedItem);
            if (isOptionDisabled(selectedItem)) {
                return;
            }
            const index = value.findIndex((valueItem) => {
                return isEqual(selectedValue, valueItem);
            });
            if (index > 0) {
                onChange([...value.slice(0, index), ...value.slice(index + 1)]);
            }
            else if (index === 0) {
                onChange(value.slice(1));
            }
            else {
                onChange([...value, selectedValue]);
            }
        },
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            if (typeof highlightedIndex !== "number") {
                return;
            }
            const virtualIndex = getVirtualItemIndex(highlightedIndex);
            scrollVirtualizerOnHighlightChange({
                highlightedIndex: virtualIndex,
                numberOfOptions: virtualItems.length,
                scrollToIndex: virtualizer.scrollToIndex,
            });
        },
    }), [
        isOptionDisabled,
        onChange,
        getVirtualItemIndex,
        optionLabel,
        optionValue,
        value,
        virtualizer,
        virtualItems.length,
    ]);
    const select = useSelect({
        toggleButtonId: formControl.id,
        items: downshiftItems,
        selectedItem: null,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, select.isOpen);
    const colorScheme = select.isOpen ? "open" : "closed";
    useEffect(() => {
        if (!select.isOpen) {
            return;
        }
        const keyDown = (event) => {
            if (event.key === "a" && event.metaKey) {
                event.preventDefault();
                const allValues = downshiftItems.map((option) => optionValue(option));
                onChange(allValues);
            }
        };
        document.body.addEventListener("keydown", keyDown);
        return () => {
            document.body.removeEventListener("keydown", keyDown);
        };
    }, [select.isOpen, downshiftItems, optionValue, onChange]);
    const selectedOptions = useMemo(() => {
        const result = [];
        values: for (const valueItem of value) {
            for (const optionGroup of optionGroups) {
                for (const option of optionGroup.options) {
                    if (isEqual(optionValue(option), valueItem)) {
                        result.push(option);
                        continue values;
                    }
                }
            }
        }
        return result;
    }, [optionGroups, optionValue, value]);
    const showClearButton = isClearable && value.length > 0;
    const clear = useCallback(() => {
        select.reset();
        onChange([]);
        // TODO(eric.lovett): This deps array is missing `select` and therefore may be buggy.
        // Please consider adding it.
    }, [onChange]);
    const styles = useMultiStyleConfig("Select", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const valueLabelText = useMemo(() => value.length > 0
        ? selectedOptions.map((option) => valueLabel(option)).join(", ")
        : placeholder, [value.length, selectedOptions, valueLabel, placeholder]);
    const getSelectToggleButtonProps = select.getToggleButtonProps;
    const toggleButtonProps = useMemo(() => getSelectToggleButtonProps({
        ref: selectRef,
        "aria-label": valueLabelText,
        onFocus: formControl.onFocus,
        onBlur: formControl.onBlur,
    }), [
        getSelectToggleButtonProps,
        formControl.onFocus,
        formControl.onBlur,
        selectRef,
        valueLabelText,
    ]);
    const getSelectMenuProps = select.getMenuProps;
    const menuProps = useMemo(() => getSelectMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [getSelectMenuProps]);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused
            autoFocus: false, isOpen: select.isOpen, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], __css: styles["toggleButton"], "data-selected": value.length > 0 ? "true" : undefined, width: width, disabled: formControl.disabled, "data-testid": "grouped-multi-select", ...toggleButtonProps, children: [renderValue && selectedOptions.length > 0 ? (jsx(chakra.div, { __css: {
                                    flex: "1",
                                    minWidth: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                }, children: renderValue(selectedOptions) })) : (jsx(SelectValue, { __css: styles["value"], "data-placeholder": selectedOptions.length > 0 || formControl.disabled
                                    ? undefined
                                    : "true", children: valueLabelText })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: clear })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["icon"] })))] }) }), jsxs(SelectPopover, { removePortal: removePortal, isOpen: select.isOpen, width: popoverWidth ?? width, "data-testid": "grouped-multi-select-popover", ...menuProps, children: [virtualItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    const isOption = virtualItem.type === "option";
                                    const accessories = isOption
                                        ? optionAccessories?.(virtualItem.option)
                                        : null;
                                    const disabledMessageOrBoolean = virtualItem.type === "option"
                                        ? isOptionDisabled(virtualItem.option)
                                        : undefined;
                                    return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], style: {
                                            transform: `translateY(${start}px)`,
                                        }, children: [virtualItem.type === "group" && (jsx(chakra.div, { ref: virtualizer.measureElement, "data-index": index, children: jsx(SelectGroup, { children: virtualItem.label }) })), isOption && (jsx(SelectOption, { isHighlighted: select.highlightedIndex === virtualItem.index, isSelected: selectedOptions.includes(virtualItem.option), isPreviousSelected: selectedOptions.includes(get(virtualItems, [index - 1, "option"])), isNextSelected: selectedOptions.includes(get(virtualItems, [index + 1, "option"])), isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, ...accessories, ...select.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        select.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                }) }) }))] })] }) }));
}

function GroupedSelect({ isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", optionGroups, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionAccessories, placeholder = "", popoverWidth, removePortal = false, value, size = "md", variant = "default", fontWeight = "normal", width = "xs", onChange, valueLabel = optionLabel, selectRef, showPlaceholderIcon = false, _internalRenderLabelContent, ...props }) {
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const selectedOption = useMemo(() => {
        if (value === undefined || value === null) {
            return;
        }
        for (const optionGroup of optionGroups) {
            for (const option of optionGroup.options) {
                if (isEqual(optionValue(option), value)) {
                    return option;
                }
            }
        }
        // This `return` is indeed useless, but TypeScript errors without it
        return;
    }, [optionGroups, optionValue, value]);
    const downshiftItems = useMemo(() => {
        const items = [];
        for (const optionGroup of optionGroups) {
            items.push(...optionGroup.options);
        }
        return items;
    }, [optionGroups]);
    const optionsContainer = useRef(null);
    const { virtualItems, getVirtualItemIndex, virtualizer } = useVirtualItems({
        optionGroups,
        optionLabel,
        containerRef: optionsContainer,
    });
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            return option ? optionLabel(option) : "";
        },
        onSelectedItemChange({ selectedItem }) {
            if (selectedItem) {
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                onChange(optionValue(selectedItem));
                return;
            }
            if (isClearable) {
                onChange(undefined);
            }
        },
        stateReducer(state, { type, changes }) {
            // If it's an item click and the item is disabled, prevent the popover from closing
            if ((type === useSelect.stateChangeTypes.ItemClick ||
                type === useSelect.stateChangeTypes.ToggleButtonKeyDownEnter ||
                type ===
                    useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton) &&
                changes.selectedItem) {
                const clickedItem = downshiftItems.find((option) => changes.selectedItem &&
                    optionValue(option) === optionValue(changes.selectedItem));
                if (clickedItem && isOptionDisabled(clickedItem)) {
                    return state;
                }
            }
            return changes;
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            if (typeof highlightedIndex !== "number") {
                return;
            }
            const virtualIndex = getVirtualItemIndex(highlightedIndex);
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex: virtualIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        downshiftItems,
        isClearable,
        isOptionDisabled,
        onChange,
        getVirtualItemIndex,
        optionLabel,
        optionValue,
        virtualizer,
        virtualItems,
    ]);
    const select = useSelect({
        toggleButtonId: formControl.id,
        items: downshiftItems,
        selectedItem: selectedOption ?? null,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, select.isOpen);
    const colorScheme = select.isOpen ? "open" : "closed";
    const showClearButton = isClearable && Boolean(selectedOption);
    const selectedOptionAccessories = selectedOption && typeof optionAccessories === "function"
        ? optionAccessories(selectedOption)
        : undefined;
    const styles = useMultiStyleConfig("Select", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const valueLabelText = useMemo(() => (selectedOption ? valueLabel(selectedOption) : placeholder), [selectedOption, valueLabel, placeholder]);
    const getSelectToggleButtonProps = select.getToggleButtonProps;
    const toggleButtonProps = useMemo(() => getSelectToggleButtonProps({
        ref: selectRef,
        "aria-label": valueLabelText,
        onFocus: formControl.onFocus,
        onBlur: formControl.onBlur,
    }), [
        getSelectToggleButtonProps,
        formControl.onFocus,
        formControl.onBlur,
        selectRef,
        valueLabelText,
    ]);
    const getSelectMenuProps = select.getMenuProps;
    const menuProps = useMemo(() => getSelectMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [getSelectMenuProps]);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    const valueLabelRenderer = _internalRenderLabelContent ?? valueLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused
            autoFocus: false, isOpen: select.isOpen, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, __css: styles["toggleButton"], "data-selected": selectedOption ? "true" : undefined, disabled: formControl.disabled, width: width, "data-testid": "grouped-select", ...toggleButtonProps, ...props, children: [selectedOptionAccessories?.leftAccessory ? (jsx(IconAccessory, { accessory: selectedOptionAccessories.leftAccessory })) : showPlaceholderIcon && optionAccessories && !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(SelectValue, { __css: styles["value"], "data-placeholder": selectedOption || formControl.disabled ? undefined : "true", children: selectedOption
                                    ? valueLabelRenderer(selectedOption)
                                    : placeholder }), selectedOptionAccessories?.rightAccessory && (jsx(IconAccessory, { accessory: selectedOptionAccessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: select.reset })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["icon"] })))] }) }), jsxs(SelectPopover, { isOpen: select.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "grouped-select-popover", ...menuProps, children: [virtualItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    const isOption = virtualItem.type === "option";
                                    const accessories = isOption
                                        ? optionAccessories?.(virtualItem.option)
                                        : null;
                                    const disabledMessageOrBoolean = virtualItem.type === "option"
                                        ? isOptionDisabled(virtualItem.option)
                                        : undefined;
                                    return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], position: "absolute", style: {
                                            transform: `translateY(${start}px)`,
                                        }, children: [virtualItem.type === "group" && (jsx(chakra.div, { ref: virtualizer.measureElement, "data-index": index, children: jsx(SelectGroup, { children: virtualItem.label }) })), isOption && (jsx(SelectOption, { isHighlighted: select.highlightedIndex === virtualItem.index, isSelected: virtualItem.option === selectedOption, isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, ...accessories, ...select.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        select.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                }) }) }))] })] }) }));
}

function HiddenFormLabel({ label, children }) {
    return (jsxs(chakra.label, { children: [jsx(VisuallyHidden, { children: label }), children] }));
}

// Deliberately not shared with badge-group.tsx: that copy counts only
// HTMLElement children, so the two disagree once a non-HTML element sits
// before the wrap, and exporting it would put it on the public barrel.
const detectWrapIndex = (container) => {
    if (container.offsetHeight >= container.scrollHeight) {
        return -1;
    }
    let previousChildY;
    for (const [index, child] of Array.from(container.children).entries()) {
        if (!(child instanceof HTMLElement)) {
            continue;
        }
        if (previousChildY !== undefined && child.offsetTop > previousChildY) {
            return index;
        }
        previousChildY = child.offsetTop;
    }
    return -1;
};
const firstLineWidth = (container) => {
    const left = container.getBoundingClientRect().left;
    let firstChildY;
    let right = left;
    for (const child of Array.from(container.children)) {
        if (!(child instanceof HTMLElement)) {
            continue;
        }
        if (firstChildY === undefined) {
            firstChildY = child.offsetTop;
        }
        else if (child.offsetTop > firstChildY) {
            break;
        }
        right = Math.max(right, child.getBoundingClientRect().right);
    }
    return Math.ceil(right - left);
};
/**
 * Counts resizes of an element whose width the badges cannot affect. Observing
 * a run directly would loop: pinning its width resizes it.
 */
const useLabelBadgeGroupResizeTick = () => {
    const [targetElement, setTargetElement] = useState(null);
    const [resizeTick, setResizeTick] = useState(0);
    const ref = useCallback((node) => {
        setTargetElement((previous) => (previous === node ? previous : node));
    }, []);
    useEffect(() => {
        if (!targetElement) {
            return;
        }
        const resizeObserver = new ResizeObserver(() => {
            setResizeTick((tick) => tick + 1);
        });
        resizeObserver.observe(targetElement);
        return () => {
            resizeObserver.disconnect();
        };
    }, [targetElement]);
    return { ref, resizeTick };
};
const useLabelBadgeGroupWrapIndex = (resizeTick) => {
    const [targetElement, setTargetElement] = useState(null);
    const [wrapIndex, setWrapIndex] = useState(-1);
    const ref = useCallback((node) => {
        setTargetElement((previous) => (previous === node ? previous : node));
    }, []);
    useEffect(() => {
        if (!targetElement) {
            return;
        }
        const recalculate = () => {
            targetElement.style.width = "";
            const index = detectWrapIndex(targetElement);
            targetElement.style.width =
                index < 0 ? "" : `${firstLineWidth(targetElement)}px`;
            setWrapIndex(index);
        };
        recalculate();
        const mutationObserver = new MutationObserver(recalculate);
        mutationObserver.observe(targetElement, { childList: true, subtree: true });
        return () => {
            mutationObserver.disconnect();
        };
    }, [targetElement, resizeTick]);
    return { ref, wrapIndex };
};

const LabelBadgeGroupContext = createContext(null);
function useLabelBadgeGroup() {
    const context = useContext(LabelBadgeGroupContext);
    if (!context) {
        throw new Error("LabelBadgeGroup parts must render inside LabelBadgeGroup");
    }
    return context;
}
/**
 * A resource's grouped labels, one badge per group. A read-only badge
 * comma-joins its values ("Season | Spring, Summer"); a removable badge shows
 * each value as a bubble with its own dismiss X. Values past the badge's first
 * line collapse behind an in-badge "+N" popover.
 */
function LabelBadgeGroup({ groupedLabels, size = "md", onRemoveLabel, fallbackFocusRef, ...props }) {
    const isRemovable = Boolean(onRemoveLabel);
    const styles = useMultiStyleConfig("LabelBadgeGroup", { size, isRemovable });
    // The container's width comes from the caller, so pinning a run can't move it.
    const { ref, resizeTick } = useLabelBadgeGroupResizeTick();
    const groupRowRef = useRef(null);
    const removedGroupIndexRef = useRef(null);
    const fallbackFocusPendingRef = useRef(false);
    const totalLabelCount = groupedLabels.reduce((total, { labels }) => total + labels.length, 0);
    // A removal that empties a group unmounts its badge, which fires no blur.
    // Recovery runs after the commit and only when focus fell to the document, so
    // a badge that already placed focus on something surviving keeps it.
    useLayoutEffect(() => {
        const removedIndex = removedGroupIndexRef.current;
        if (removedIndex === null)
            return;
        removedGroupIndexRef.current = null;
        if (document.activeElement !== document.body)
            return;
        if (groupedLabels.length === 0) {
            // A sibling may replace its trigger in this commit, so its ref is not
            // ready yet; the passive effect below picks it up once it is.
            fallbackFocusPendingRef.current = true;
            return;
        }
        // One group was spliced out, so the group that took its place sits at the
        // same index; past the end, the one before it is the nearest survivor.
        const successor = Math.min(removedIndex, groupedLabels.length - 1);
        const badges = Array.from(groupRowRef.current?.querySelectorAll("[data-label-badge]") ?? []);
        const badge = badges[successor];
        (badge?.querySelector("button") ?? badge)?.focus();
    }, [totalLabelCount, groupedLabels.length]);
    useEffect(() => {
        if (!fallbackFocusPendingRef.current)
            return;
        fallbackFocusPendingRef.current = false;
        if (document.activeElement !== document.body)
            return;
        fallbackFocusRef?.current?.focus();
    }, [groupedLabels.length, fallbackFocusRef]);
    // Wrapped once for every badge, so a removal from the row or from a value
    // panel both reach the same recovery.
    const removeLabel = onRemoveLabel &&
        ((label, group) => {
            removedGroupIndexRef.current = groupedLabels.findIndex((entry) => entry.group.id === group.id);
            onRemoveLabel(label, group);
        });
    // After the hooks: the effects above still have to run on the commit that
    // empties the collection, which is what hands focus to `fallbackFocusRef`.
    if (groupedLabels.length === 0) {
        return null;
    }
    return (jsx(chakra.div, { ref: ref, __css: styles["container"], ...props, children: jsx(LabelBadgeGroupContext.Provider, { value: { styles, size, resizeTick }, children: jsx(chakra.div, { ref: groupRowRef, __css: styles["group"], children: groupedLabels.map(({ group, labels }) => (jsx(LabelBadge, { group: group, labels: labels, onRemove: removeLabel }, group.id))) }) }) }));
}
const LabelBadge = ({ group, labels, onRemove }) => {
    const { styles, size } = useLabelBadgeGroup();
    const badgeRef = useRef(null);
    const { contentFits: nameFits, ref: nameRef } = useContentFits();
    return (jsxs(chakra.span, { ref: badgeRef, tabIndex: -1, "data-label-badge": true, __css: styles["badge"], children: [jsx(Tooltip, { message: group.name, isDisabled: nameFits, keepMountedWhileDisabled: true, children: jsx(chakra.span, { ref: nameRef, "data-label-badge-name": true, __css: styles["badgeName"], children: jsx(Text, { size: size, color: "text.tertiary", fontWeight: "normal", children: group.name }) }) }), jsx(ValueRun, { labels: labels, group: group, onRemove: onRemove, badgeRef: badgeRef })] }));
};
const ValueRun = ({ labels, group, onRemove, badgeRef }) => {
    const { styles, resizeTick } = useLabelBadgeGroup();
    const { ref, wrapIndex } = useLabelBadgeGroupWrapIndex(resizeTick);
    const runRef = useRef(null);
    const mergedRunRef = useMergeRefs(runRef, ref);
    const valueTriggerRef = useRef(null);
    // Clamped so a badge can never render as a bare "+N".
    const visibleCount = wrapIndex < 0
        ? labels.length
        : Math.min(Math.max(wrapIndex, 1), labels.length);
    const overflowed = labels.slice(visibleCount);
    // Focus presence, tracked rather than flagged per event: a fold can land a
    // commit later than the removal or resize that caused it.
    const visibleValuesHaveFocusRef = useRef(false);
    const panelHasFocusRef = useRef(false);
    const removalPendingRef = useRef(false);
    const isRemovable = Boolean(onRemove);
    const removeAndRecoverFocus = onRemove &&
        ((label, from) => {
            removalPendingRef.current = true;
            onRemove(label, from);
        });
    // Every case that can leave this run's focus homeless, in one place so their
    // order is explicit: an emptied panel outranks a removal, which outranks a
    // fold. Recovery runs after the commit rather than before the removal, which
    // is what keeps a value panel open: focusing the badge up front would blur
    // the portaled panel and dismiss it. The body check leaves focus alone
    // whenever something surviving already holds it, including the panel's own
    // successor.
    useLayoutEffect(() => {
        // A removal or width change that leaves nothing overflowed takes the
        // portaled panel with it, and the panel cannot recover from its own unmount.
        // Ranked above the removal case because a live X beats the badge when the
        // removal is what emptied the panel.
        if (panelHasFocusRef.current && overflowed.length === 0) {
            panelHasFocusRef.current = false;
            removalPendingRef.current = false;
            if (document.activeElement !== document.body)
                return;
            // A read-only badge has no X to fall back to, so the badge takes it.
            (runRef.current?.querySelector("button") ?? badgeRef.current)?.focus();
            return;
        }
        // Turning read-only swaps the panel from click to hover, which remounts the
        // popover and unmounts the X holding focus while the values stay put. The
        // "+N" is what is left to hold it.
        if (panelHasFocusRef.current && !isRemovable) {
            panelHasFocusRef.current = false;
            if (document.activeElement !== document.body)
                return;
            valueTriggerRef.current?.focus();
            return;
        }
        if (removalPendingRef.current) {
            removalPendingRef.current = false;
            // A dismissed value unmounts its X, which fires no blur. The badge is the
            // owner: it outlives every value, so focus never falls to the document.
            if (document.activeElement === document.body)
                badgeRef.current?.focus();
            return;
        }
        // A width drop can fold the value whose X holds focus, and turning read-only
        // unmounts every X outright. Chromium drops focus to the body, Firefox
        // leaves it on the hidden node, so both count as displaced: the first
        // surviving X takes over, or the badge when there is none.
        if (!visibleValuesHaveFocusRef.current)
            return;
        const active = document.activeElement;
        const focusOnHiddenValue = active instanceof HTMLElement &&
            runRef.current?.contains(active) === true &&
            getComputedStyle(active.closest("[data-label-badge-value]") ?? active)
                .visibility === "hidden";
        if (active !== document.body && !focusOnHiddenValue)
            return;
        (runRef.current?.querySelector("button") ?? badgeRef.current)?.focus();
    }, [labels.length, visibleCount, overflowed.length, isRemovable, badgeRef]);
    return (jsxs(chakra.span, { __css: styles["valueRun"], children: [jsx(chakra.span, { ref: mergedRunRef, __css: styles["run"], onFocusCapture: () => {
                    visibleValuesHaveFocusRef.current = true;
                }, onBlurCapture: (event) => {
                    if (!event.currentTarget.contains(event.relatedTarget)) {
                        visibleValuesHaveFocusRef.current = false;
                    }
                }, children: labels.map((label, index) => (
                // Every value renders so the browser decides what fits; the ones
                // past the cut keep their geometry but lose interactivity.
                jsx(LabelBadgeValueItem, { label: label, group: group, isHidden: index >= visibleCount, isBubble: Boolean(onRemove) && labels.length > 1, onRemove: removeAndRecoverFocus }, label.id))) }), overflowed.length > 0 && (jsx(OverflowValues, { labels: overflowed, group: group, onRemove: removeAndRecoverFocus, triggerRef: valueTriggerRef, panelHasFocusRef: panelHasFocusRef }))] }));
};
const OverflowValues = ({ labels, group, onRemove, triggerRef, panelHasFocusRef, }) => {
    const { styles } = useLabelBadgeGroup();
    const valuePanelRef = useRef(null);
    // Removing a value keeps the panel open, so focus has to land on what
    // remains inside it: the value that took the removed one's place, or the
    // one before it at the end of the list.
    const removedIndexRef = useRef(null);
    useLayoutEffect(() => {
        const removedIndex = removedIndexRef.current;
        if (removedIndex === null)
            return;
        removedIndexRef.current = null;
        if (document.activeElement !== document.body)
            return;
        const dismissButtons = Array.from(valuePanelRef.current?.querySelectorAll("button") ??
            []);
        if (dismissButtons.length === 0)
            return;
        dismissButtons[Math.min(removedIndex, dismissButtons.length - 1)]?.focus();
    }, [labels.length]);
    return (jsx(chakra.span, { __css: styles["overflowSlot"], children: jsxs(Popover, { isLazy: true, placement: "bottom-start", trigger: onRemove ? "click" : "hover", children: [jsx(PopoverTrigger, { children: jsx(chakra.button, { ref: triggerRef, type: "button", __css: styles["overflowTrigger"], "aria-label": `Show ${labels.length} more ${group.name} ${labels.length === 1 ? "value" : "values"}`, 
                        // Badges sit in clickable table rows, and opening the panel is not
                        // a row click. PopoverTrigger composes this with its own toggle.
                        onClick: (event) => event.stopPropagation(), children: `+${labels.length}` }) }), jsx(Portal, { children: jsx(PopoverContent, { ref: valuePanelRef, sx: styles["overflowPanel"], onFocusCapture: () => {
                            panelHasFocusRef.current = true;
                        }, onBlurCapture: (event) => {
                            if (!valuePanelRef.current?.contains(event.relatedTarget)) {
                                panelHasFocusRef.current = false;
                            }
                        }, children: jsx(PopoverBody, { sx: styles["overflowPanelBody"], children: labels.map((label, index) => (jsx(LabelBadgeValueItem, { label: label, group: group, isBubble: true, onRemove: onRemove &&
                                    ((removed, from) => {
                                        removedIndexRef.current = index;
                                        onRemove(removed, from);
                                    }) }, label.id))) }) }) })] }) }));
};
const LabelBadgeValueItem = ({ label, group, isHidden = false, isBubble, onRemove, }) => {
    const { styles } = useLabelBadgeGroup();
    const { contentFits, ref } = useContentFits();
    const shell = isBubble ? "valueBubble" : "valueItem";
    return (
    // The tooltip covers the whole value — a crowded badge can shrink the text
    // to nothing. keepMountedWhileDisabled: a remount would drop the X's focus.
    jsx(Tooltip, { message: label.name, isDisabled: contentFits, keepMountedWhileDisabled: true, children: jsxs(chakra.span, { "data-label-badge-value": true, __css: styles[shell], visibility: isHidden ? "hidden" : undefined, children: [jsx(chakra.span, { __css: styles["valueTextClamp"], children: jsx(chakra.span, { ref: ref, "data-label-badge-value-text": true, __css: styles["valueText"], children: label.name }) }), onRemove && (jsx(IconButton, { size: "2xs", shape: "circle", icon: CloseIcon, "aria-label": `Remove ${label.name} from ${group.name}`, sx: styles["dismissButton"], onClick: (event) => {
                        event.stopPropagation();
                        onRemove(label, group);
                    } }))] }) }));
};

const ChakraLinkButton = Button$1;
const LinkButton = forwardRef$1(function LinkButton_({ children, isDisabled = false, isJustified = false, size = "md", shape = "default", variant = "secondary", icon, directionIcon, imageUrl, isExternal, as, ...props }, ref) {
    let colorScheme;
    let chakraVariant;
    if (variant === "primary") {
        chakraVariant = "solid";
        colorScheme = "teal";
    }
    if (variant === "secondary") {
        chakraVariant = "outline";
        colorScheme = "clear";
    }
    if (variant === "tertiary") {
        chakraVariant = "ghost";
        colorScheme = "clear";
    }
    if (variant === "warning") {
        chakraVariant = "outline";
        colorScheme = "danger";
    }
    let leftIcon;
    if (icon) {
        leftIcon = jsx(Icon, { as: icon, boxSize: 4 });
    }
    if (imageUrl) {
        leftIcon = (jsx(Box$1, { display: "inline-block", boxSize: 4, children: jsx(Image, { src: imageUrl, alt: "", maxWidth: "100%", maxHeight: "100%" }) }));
    }
    return (jsx(ChakraLinkButton, { ref: ref, as: as, colorScheme: colorScheme, size: size, variant: chakraVariant, iconSpacing: size === "sm" || size === "md" ? 1.5 : 2, leftIcon: leftIcon, rightIcon: directionIcon ? jsx(Icon, { as: directionIcon, boxSize: 4 }) : undefined, isDisabled: isDisabled, width: isJustified ? "100%" : undefined, borderRadius: shape === "circle" ? "full" : undefined, target: isExternal ? "_blank" : undefined, rel: isExternal ? "noopener" : undefined, ...props, children: children }));
});
LinkButton.displayName = "LinkButton";

const placementMap = {
    default: "bottom-start",
    center: "bottom",
    end: "bottom-end",
};
function Menu({ computePositionOnMount = true, closeOnSelect = true, placement = "default", isLazy = true, isOpen, onOpen, onClose, ...props }) {
    const initialFocusRef = useRef(null);
    return (jsx(MenuContextProvider, { value: { initialFocusRef }, children: jsx(Menu$1, { isLazy: isLazy, isOpen: isOpen, initialFocusRef: initialFocusRef, placement: placementMap[placement], computePositionOnMount: computePositionOnMount, closeOnSelect: closeOnSelect, onOpen: onOpen, onClose: onClose, ...props }) }));
}

function MenuBadgeButton(props) {
    return (jsx(MenuButton$1, { as: BadgeButton, rightIcon: ChevronDownIcon, ...props }));
}

const iconSize = {
    sm: 4,
    md: 5,
    lg: 6,
};
const MenuButton = forwardRef$1(function MenuButton_({ variant = "secondary", size = "md", ...props }, ref) {
    return (jsx(MenuButton$1, { ref: ref, as: Button, directionIcon: (props) => (jsx(ChevronDownIcon, { ...props, baseline: true })), directionIconSize: iconSize[size], variant: variant, size: size, ...props }));
});
MenuButton.displayName = "MenuButton";

function MenuDivider(props) {
    return jsx(MenuDivider$1, { mx: -2, ...props });
}

function MenuList(props) {
    return (jsx(Portal, { children: jsx(MenuList$1, { motionProps: dropdownVariants, ...props }) }));
}

function MinimalUpsellCard({ message, actionText, onAction, ...props }) {
    return (jsx(Box$1, { borderWidth: "hairline", borderStyle: "solid", borderColor: "upsell.border", borderRadius: "xl", bg: "upsell.background", ...props, children: jsxs(Box$1, { display: "flex", alignItems: "center", gap: 3, px: 4, py: 2, children: [jsxs(Box$1, { flex: "1", minWidth: 0, display: "flex", alignItems: "center", gap: 2, children: [jsx(Icon, { as: UpgradeIcon, flex: "none", color: "upsell.base", boxSize: 5 }), jsx(Paragraph, { children: message })] }), jsx(Button, { icon: UpgradeIcon, onClick: onAction, children: actionText })] }) }));
}

function MultiSelect({ headerLabel, headerDescription, isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", options, optionDescription = defaultOptionDescription, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionAccessories, placeholder = "", removePortal = false, size = "md", value, variant = "default", fontWeight = "normal", popoverWidth, width = "xs", onChange, onClose, onOpen, valueLabel = optionLabel, renderValue, selectRef, _internalRenderLabelContent, }) {
    const optionsContainer = useRef(null);
    const { virtualItems, virtualizer } = useVirtualItems({
        options,
        optionLabel,
        containerRef: optionsContainer,
    });
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            return option ? optionLabel(option) : "";
        },
        stateReducer(state, { type, changes }) {
            switch (type) {
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEnter:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick: {
                    return {
                        ...changes,
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex,
                    };
                }
                case useSelect.stateChangeTypes.ToggleButtonClick:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowDown:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownArrowUp:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownCharacter:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEscape:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownHome:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownEnd:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownPageUp:
                case useSelect.stateChangeTypes.ToggleButtonKeyDownPageDown:
                case useSelect.stateChangeTypes.ToggleButtonBlur:
                case useSelect.stateChangeTypes.MenuMouseLeave:
                case useSelect.stateChangeTypes.ItemMouseMove:
                case useSelect.stateChangeTypes.FunctionToggleMenu:
                case useSelect.stateChangeTypes.FunctionOpenMenu:
                case useSelect.stateChangeTypes.FunctionCloseMenu:
                case useSelect.stateChangeTypes.FunctionSetHighlightedIndex:
                case useSelect.stateChangeTypes.FunctionSelectItem:
                case useSelect.stateChangeTypes.FunctionSetInputValue:
                case useSelect.stateChangeTypes.FunctionReset: {
                    return changes;
                }
            }
        },
        selectedItem: null,
        onSelectedItemChange({ selectedItem }) {
            if (!selectedItem) {
                return;
            }
            if (isOptionDisabled(selectedItem)) {
                return;
            }
            const selectedValue = optionValue(selectedItem);
            const index = value.findIndex((valueItem) => {
                return isEqual(selectedValue, valueItem);
            });
            if (index > 0) {
                onChange([...value.slice(0, index), ...value.slice(index + 1)]);
            }
            else if (index === 0) {
                onChange(value.slice(1));
            }
            else {
                onChange([...value, selectedValue]);
            }
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen) {
                onOpen?.();
            }
            else {
                onClose?.();
            }
        },
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            scrollVirtualizerOnHighlightChange({
                highlightedIndex,
                numberOfOptions: virtualItems.length,
                scrollToIndex: virtualizer.scrollToIndex,
            });
        },
    }), [
        isOptionDisabled,
        onChange,
        onClose,
        onOpen,
        optionLabel,
        optionValue,
        value,
        virtualizer,
        virtualItems.length,
    ]);
    const select = useSelect({
        toggleButtonId: formControl.id,
        items: options,
        ...downshiftMemoizedArguments,
    });
    useEffect(() => {
        if (!select.isOpen) {
            return;
        }
        const keyDown = (event) => {
            if (event.key === "a" && event.metaKey) {
                event.preventDefault();
                const allValues = options.map((option) => optionValue(option));
                onChange(allValues);
            }
        };
        document.body.addEventListener("keydown", keyDown);
        return () => {
            document.body.removeEventListener("keydown", keyDown);
        };
    }, [select.isOpen, options, optionValue, onChange]);
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, select.isOpen);
    const selectedOptions = useMemo(() => {
        const result = [];
        for (const valueItem of value) {
            const option = options.find((option) => {
                return isEqual(optionValue(option), valueItem);
            });
            if (option) {
                result.push(option);
            }
        }
        return result;
    }, [options, optionValue, value]);
    const showClearButton = isClearable && value.length > 0;
    const colorScheme = select.isOpen ? "open" : "closed";
    const clear = useCallback(() => {
        select.reset();
        onChange([]);
        // TODO(eric.lovett): This deps array is missing `select` and therefore may be buggy.
        // Please consider adding it.
    }, [onChange]);
    const styles = useMultiStyleConfig("Select", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const valueLabelText = useMemo(() => value.length > 0
        ? selectedOptions.map((option) => valueLabel(option)).join(", ")
        : placeholder, [value.length, selectedOptions, valueLabel, placeholder]);
    const getSelectToggleButtonProps = select.getToggleButtonProps;
    const toggleButtonProps = useMemo(() => getSelectToggleButtonProps({
        ref: selectRef,
        "aria-label": valueLabelText,
        onFocus: formControl.onFocus,
        onBlur: formControl.onBlur,
    }), [
        getSelectToggleButtonProps,
        formControl.onFocus,
        formControl.onBlur,
        selectRef,
        valueLabelText,
    ]);
    const getSelectMenuProps = select.getMenuProps;
    const menuProps = useMemo(() => getSelectMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [getSelectMenuProps]);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused
            autoFocus: false, isOpen: select.isOpen, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], __css: styles["toggleButton"], "data-selected": value.length > 0 ? "true" : undefined, width: width, disabled: formControl.disabled, "data-testid": "multi-select", ...toggleButtonProps, children: [renderValue && selectedOptions.length > 0 ? (jsx(chakra.div, { __css: {
                                    flex: "1",
                                    minWidth: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    overflow: "hidden",
                                }, children: renderValue(selectedOptions) })) : (jsx(SelectValue, { __css: styles["value"], "data-placeholder": selectedOptions.length > 0 || formControl.disabled
                                    ? undefined
                                    : "true", children: valueLabelText })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: clear })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["icon"] })))] }) }), jsxs(SelectPopover, { isOpen: select.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "multi-select-popover", ...menuProps, children: [headerLabel && (jsxs(chakra.div, { __css: selectOptionsStyles["header"], children: [jsx(Text, { fontWeight: "medium", children: headerLabel }), headerDescription && (jsx(Text, { color: "text.secondary", children: headerDescription }))] })), virtualItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    if (virtualItem.type === "option") {
                                        const accessories = optionAccessories?.(virtualItem.option);
                                        const disabledMessageOrBoolean = virtualItem
                                            ? isOptionDisabled(virtualItem.option)
                                            : undefined;
                                        return (jsx(chakra.div, { __css: selectOptionsStyles["item"], style: {
                                                transform: `translateY(${start}px)`,
                                            }, children: jsx(SelectOption, { isHighlighted: select.highlightedIndex === virtualItem.index, isSelected: selectedOptions.includes(virtualItem.option), isPreviousSelected: selectedOptions.includes(get(virtualItems, [index - 1, "option"])), isNextSelected: selectedOptions.includes(get(virtualItems, [index + 1, "option"])), isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, ...accessories, ...select.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        select.setHighlightedIndex(-1);
                                                    },
                                                }), "aria-selected": selectedOptions.includes(virtualItem.option), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }) }, key));
                                    }
                                    return null;
                                }) }) }))] })] }) }));
}

const NumberInput = forwardRef$1(function NumberInput_({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, autoFocus = false, isDisabled, isReadOnly, isRequired, isInvalid, formatOptions, min, max, placeholder, step, value, width = "xs", size = "md", onChange, ...props }, ref) {
    const { locale } = useLocale();
    // Since `formatOptions` is an object, it will be a new reference on each render.
    // That leads to unenecessary re-rendering and unexpected behavior in regard to the `value`.
    // Instead of making the caller responsible for memoizing, we do it here to cover our bases.
    const { current: memoizedFormatOptions } = useRef(formatOptionsWithDefaults(formatOptions));
    const formControlContext = useFormControlContext();
    const formControl = useFormControl({
        isDisabled,
        isReadOnly,
        isRequired,
        isInvalid,
    });
    const handleChange = useCallback((value) => {
        onChange(Number.isNaN(value) ? undefined : value);
    }, [onChange]);
    const sharedProps = {
        isDisabled: formControl.disabled,
        isReadOnly: formControl.readOnly,
        isRequired: formControl.required,
        // react-aria reads the field's name from props, not the DOM, and joins an
        // `aria-label` with an `aria-labelledby` instead of preferring one, so only
        // the winning label is sent: a label prop, else the `FormField` context.
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabel
            ? undefined
            : (ariaLabelledby ?? formControlContext?.labelId),
        "aria-describedby": formControlContext?.helpTextId,
        id: formControlContext?.id,
        formatOptions: memoizedFormatOptions,
        minValue: min,
        maxValue: max,
        placeholder,
        step,
        value,
        validationState: formControl["aria-invalid"] ? "invalid" : "valid",
        onChange: handleChange,
    };
    const state = useNumberFieldState({
        ...sharedProps,
        locale,
    });
    // Programatically clear the input when using a controlled field
    useEffect(() => {
        if (value === undefined) {
            state.setInputValue("");
        }
        // TODO(eric.lovett): This deps array is missing `state` and therefore may be buggy.
        // Please consider adding it.
    }, [value, state.setInputValue]);
    const inputRef = useRef(null);
    const { groupProps, inputProps } = useNumberField(sharedProps, state, inputRef);
    const styles = useMultiStyleConfig("Input", { size });
    const mergedRef = useMergeRefs(ref, inputRef);
    const onKeyDown = useCallback((event) => {
        const { value, selectionStart, selectionEnd } = event.currentTarget;
        const backspaceFirstCharacter = event.key === "Backspace" &&
            selectionStart === 1 &&
            selectionEnd === 1;
        const deleteFirstCharacter = event.key === "Delete" && selectionStart === 0 && selectionEnd === 0;
        // Note: not handling the selection range case since it's rare
        if (typeof inputProps.onKeyDown === "function") {
            // Handles a specific edge case in a different way from react-aria default.
            // When deleting the number at the front of the value, if it would leave a
            // comma as the first character, react-aria blocks the change. We would
            // prefer to just delete the comma as well.
            // - example: 1,234 => ,234
            if ((backspaceFirstCharacter || deleteFirstCharacter) &&
                value[1] === ",") {
                event.preventDefault();
                const newValue = value.slice(2);
                state.setInputValue(newValue);
                // Move the cursor back to the front after the next react render
                setTimeout(() => {
                    inputRef.current?.setSelectionRange(0, 0);
                }, 0);
            }
            else {
                inputProps.onKeyDown(event);
            }
        }
    }, 
    // TODO(eric.lovett): This deps array is missing `inputProps` and `state` and therefore may be buggy.
    // Please consider adding them.
    [state.commit, inputProps?.onKeyDown, inputRef]);
    return (jsx(chakra.div, { ...groupProps, ...props, children: jsx(chakra.input, { ref: mergedRef, ...inputProps, autoFocus: autoFocus, width: width, maxWidth: "100%", __css: styles["field"], onKeyDown: onKeyDown }) }));
});
NumberInput.displayName = "NumberInput";
const formatOptionsWithDefaults = (formatOptions) => {
    // If not specified, the default style is "decimal"
    if (!formatOptions || formatOptions.style === "decimal") {
        return {
            maximumFractionDigits: 6, // Without this override, the default is 3
            ...formatOptions,
        };
    }
    return formatOptions;
};

const sizes$1 = {
    xs: 3,
    sm: 4,
    md: 6,
    lg: 12,
};
function ProgressCircle({ size = "md", ...props }) {
    return (jsx(CircularProgress, { ...props, size: sizes$1[size], color: "primary.base", thickness: "14px" }));
}

// The active ring. Raw scale: the `primary`/`warning` role groups have no
// `200` rung to alias.
const ringColors = {
    primary: "teal.200",
    warning: "yellow.200",
};
/**
 * The glyph slot's size as a spacing token (`5` = 20px): 20px glyph + 6px
 * padding (minus the hairline border, absorbed by border-box) = a 32px pill,
 * matching the md IconButton. Exported so a custom `leadingAccessory` can
 * size itself to the slot.
 */
const promptInputPillIconSize = 5;
// The clear X's fade gradient can't take a token name mid-string, so the
// active tint's background is read through its CSS variable per tone.
const toneBackgrounds = {
    primary: cssVar("chakra-colors-primary-background").reference,
    warning: cssVar("chakra-colors-warning-background").reference,
};
// No spacing token: 18px sits between `4` (16px) and `5` (20px).
const clearFadeWidth = "18px";
const promptInputPillTheme = {
    parts: [
        "container",
        "button",
        "revealClip",
        "labelRow",
        "icon",
        "accessory",
        "reveal",
        "label",
        "chevron",
        "clear",
        "clearIcon",
    ],
    baseStyle({ variant, tone, isActive, isExpanded, isDisabled, isPlaceholder, }) {
        const isPicker = variant === "picker";
        const toneKey = tone === "warning" ? "warning" : "primary";
        const tinted = !isPicker && Boolean(isActive) && !isDisabled;
        // Matches every menu item's hover (`base.background`), so triggers and the
        // items they open never disagree.
        const hoverBackground = tinted
            ? `${toneKey}.background`
            : "base.background";
        return {
            container: {
                // Anchors the absolutely-positioned clear X; shrink-wrapped (even in a
                // stretching flex parent) so the owned tooltip anchors to the pill.
                position: "relative",
                display: "inline-flex",
                width: "fit-content",
            },
            button: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: isDisabled ? "not-allowed" : "pointer",
                borderRadius: "full",
                // Fixed h/w (not auto): border-box absorbs the hairline border, and an
                // icon-only compact pill stays a 32px disc matching the md IconButton.
                // Width keys off `isExpanded` (active OR still exit-animating) so the
                // box never snaps shut around a label that's still collapsing.
                h: 8,
                w: isPicker || isExpanded ? "auto" : 8,
                minH: "unset",
                minW: "unset",
                py: 1.5,
                px: isPicker || isActive ? 2 : 1.5,
                gap: 0,
                color: tinted
                    ? `${toneKey}.base`
                    : isDisabled
                        ? "text.disabled"
                        : "text.secondary",
                bg: tinted ? `${toneKey}.background` : "transparent",
                // A constant-width border animating only color — a box-shadow ring
                // would pop, since the library never transitions box-shadow.
                borderWidth: "hairline",
                borderStyle: "solid",
                borderColor: tinted ? ringColors[toneKey] : "transparent",
                boxShadow: tinted ? "buttonShadowLight" : "none",
                // Padding transitions too: it relaxes at exit start while the width
                // change waits for the label collapse — nothing snaps.
                transitionProperty: "background-color, color, border-color, padding",
                transitionDuration: "normal",
                transitionTimingFunction: "easeOutQuad",
                outline: "none",
                _focusVisible: { boxShadow: "outline" },
                ...(isDisabled
                    ? {}
                    : {
                        _hover: { bg: hoverBackground },
                        "&[aria-expanded='true']": { bg: hoverBackground },
                    }),
            },
            icon: {
                boxSize: promptInputPillIconSize,
                color: "currentcolor",
                flexShrink: 0,
                mr: isPicker ? 1 : 0,
            },
            // A `leadingAccessory` sizes itself, so no fixed box.
            accessory: {
                display: "flex",
                flexShrink: 0,
                mr: isPicker ? 1 : 0,
            },
            // Clips the animated reveal; motion drives only its width and opacity.
            revealClip: {
                overflow: "hidden",
                display: "flex",
            },
            // The label reveal's gap is padding, not margin: it clips with the
            // animated width, and margins are layout properties — never animated.
            // Trailing `0.5`: icon glyphs are inset ~2px in their box and text ink
            // isn't, so equal padding reads lopsided without it.
            reveal: {
                display: "flex",
                pl: 1,
                pr: 0.5,
            },
            labelRow: {
                display: "flex",
                alignItems: "center",
                gap: 1,
            },
            label: {
                // The theme's 14px/1.45 line box would make the pill 32.5px, not 32.
                height: promptInputPillIconSize,
                overflow: "hidden",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                // `Text` reads this variable: a compact label inherits the tint, a
                // picker placeholder mutes, and disabled inherits the button's
                // `text.disabled`.
                ...(isPicker && !isDisabled
                    ? isPlaceholder
                        ? {
                            "--hightouch-text-color": cssVar("chakra-colors-text-placeholder").reference,
                        }
                        : {}
                    : { "--hightouch-text-color": "currentcolor" }),
            },
            chevron: {
                // 20px matches the md select's chevron.
                boxSize: promptInputPillIconSize,
                flexShrink: 0,
            },
            clear: {
                position: "absolute",
                // 1px insets keep the X's rounded edge inside the pill's hairline
                // border; no spacing token goes below `0.5` (2px).
                top: "1px",
                bottom: "1px",
                right: "1px",
                border: "none",
                display: "flex",
                alignItems: "center",
                pl: 2,
                pr: 2.5,
                borderRightRadius: "full",
                color: `${toneKey}.base`,
                cursor: "pointer",
                background: toneBackgrounds[toneKey],
                // The label fade-out lives in a click-transparent pseudo-element, so a
                // click on the fading label hits the pill, not the X.
                _before: {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: "100%",
                    width: clearFadeWidth,
                    background: `linear-gradient(to right, transparent, ${toneBackgrounds[toneKey]})`,
                    pointerEvents: "none",
                },
                opacity: 0,
                pointerEvents: "none",
                transitionProperty: "opacity",
                transitionDuration: "fast",
                transitionTimingFunction: "easeOutQuad",
                _groupHover: { opacity: 1, pointerEvents: "auto" },
                _focusVisible: {
                    opacity: 1,
                    pointerEvents: "auto",
                    outline: "none",
                    boxShadow: "outline",
                },
            },
            clearIcon: {
                boxSize: 3,
                flexShrink: 0,
            },
        };
    },
};

/** Matches the scroll-fade hook's fade width so fades read the same app-wide. */
const labelFadeWidthPx = 24;
const defaultMaxLabelWidth = "130px";
function PillLabel({ label, maxWidth = defaultMaxLabelWidth, styles, }) {
    // Checked undebounced: the hook's default 200ms lags the label width animation.
    const { contentFits, ref } = useContentFits(true, {
        debounceMs: -1,
    });
    return (jsx(chakra.div, { ref: ref, __css: styles.label, maxWidth: maxWidth, 
        // Measurement-driven, so it can't live in the theme. A mask, not
        // text-overflow: `Text` is a max-content flex item, nothing to ellipsise.
        sx: contentFits
            ? undefined
            : {
                maskImage: `linear-gradient(to right, black calc(100% - ${labelFadeWidthPx}px), transparent)`,
                WebkitMaskImage: `linear-gradient(to right, black calc(100% - ${labelFadeWidthPx}px), transparent)`,
            }, children: jsx(Text, { fontWeight: "medium", children: label }) }));
}
function PillContent({ variant, icon, leadingAccessory, label, isActive, isDisabled = false, maxLabelWidth, styles, onCollapseEnd, }) {
    // An animated width escapes the global `MotionConfig`, so reduced motion is honored by hand.
    const shouldReduceMotion = useReducedMotion();
    const revealTransition = {
        duration: shouldReduceMotion ? 0 : motionDurations.normal,
        ease: motionEasings.easeInOutQuad,
    };
    // Exits run shorter than entries and decelerate (`motion.easeout-exits`).
    const collapseTransition = {
        duration: shouldReduceMotion ? 0 : motionDurations.fast,
        ease: motionEasings.easeOutQuad,
    };
    const isCompact = variant === "compact";
    return (jsxs(Fragment, { children: [icon && jsx(Box, { as: icon, __css: styles.icon }), leadingAccessory && (jsx(chakra.div, { __css: styles.accessory, children: leadingAccessory })), isCompact ? (jsx(AnimatePresence, { initial: false, onExitComplete: onCollapseEnd, children: isActive && (jsx(MotionBox, { __css: styles.revealClip, initial: { width: 0, opacity: 0 }, animate: { width: "auto", opacity: 1 }, exit: { width: 0, opacity: 0, transition: collapseTransition }, transition: revealTransition, children: jsx(chakra.div, { __css: styles.reveal, children: jsx(PillLabel, { label: label, maxWidth: maxLabelWidth, styles: styles }) }) }, "prompt-input-pill-label")) })) : (jsxs(chakra.div, { __css: styles.labelRow, children: [jsx(PillLabel, { label: label, maxWidth: maxLabelWidth, styles: styles }), !isDisabled && jsx(Box, { as: ChevronDownIcon, __css: styles.chevron })] }))] }));
}
/** Sibling of the pill, not a child — nested buttons are invalid HTML. */
function PillClearButton({ onClear, ariaLabel, styles, }) {
    return (jsx(chakra.button, { type: "button", "aria-label": ariaLabel, "data-pill-clear": "", __css: styles.clear, onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            onClear();
        }, children: jsx(Box, { as: CloseIcon, __css: styles.clearIcon }) }));
}
/**
 * The styled prompt-input pill. Use it directly as a toggle or as a custom picker
 * trigger; `PromptInputMenuButton` and `PromptInputToggle` wrap it for the common
 * cases.
 */
const PromptInputPillButton = forwardRef$1(function PromptInputPillButton_(props, ref) {
    const { variant = "compact", label, icon, leadingAccessory, isActive = false, tone = "primary", tooltip, disabledMessage, isPlaceholder = false, maxLabelWidth = defaultMaxLabelWidth, onClear, clearAriaLabel = "Remove", isDisabled, isLoading, 
    // Chakra's `MenuButton` injects a pointer-events-none wrapper span as
    // children; the pill builds its own content from props.
    children, ...rest } = props;
    // Margins go to the wrapper (they position the clear-X sibling too); the
    // rest are native button attributes.
    const [marginProps, buttonProps] = splitMarginProps(rest);
    // Includes the native attribute so `disabled` and `isDisabled` style alike.
    const isDisabledPill = Boolean(isDisabled) || Boolean(buttonProps.disabled);
    // A reason to give keeps the pill focusable (`aria-disabled`), so keyboard and
    // screen-reader users reach it. Same split as `PromptInputSubmitButton`.
    const isNativeDisabled = isDisabledPill && disabledMessage === undefined;
    const isAriaDisabled = isDisabledPill && disabledMessage !== undefined;
    // Deactivating starts the label's exit animation; the pill keeps its
    // expanded geometry until it completes, so the box never snaps shut around
    // a still-collapsing label. Render-phase adjustment, not an effect: an
    // effect fires after paint, which would flash the snapped box one frame.
    const [isCollapsing, setIsCollapsing] = useState(false);
    const [wasActive, setWasActive] = useState(isActive);
    if (wasActive !== isActive) {
        setWasActive(isActive);
        setIsCollapsing(!isActive);
    }
    const styles = useMultiStyleConfig("PromptInputPill", {
        variant,
        tone,
        isActive,
        isExpanded: isActive || isCollapsing,
        isDisabled: isDisabledPill,
        isPlaceholder,
    });
    const pillRef = useRef(null);
    const pillButtonRef = useMergeRefs(pillRef, ref);
    const showClear = variant === "compact" && isActive && Boolean(onClear) && !isDisabledPill;
    const pill = (jsxs(chakra.div, { __css: styles.container, "data-group": "", ...marginProps, children: [jsx(chakra.button, { ref: pillButtonRef, type: "button", "aria-label": label, __css: styles.button, ...buttonProps, disabled: isNativeDisabled, "aria-disabled": isAriaDisabled || undefined, onClick: (event) => {
                    if (isDisabledPill) {
                        event.preventDefault();
                        return;
                    }
                    buttonProps.onClick?.(event);
                }, onKeyDown: (event) => {
                    if (isDisabledPill) {
                        return;
                    }
                    buttonProps.onKeyDown?.(event);
                }, children: jsx(PillContent, { variant: variant, icon: icon, leadingAccessory: leadingAccessory, label: label, isActive: isActive, isDisabled: isDisabledPill, maxLabelWidth: maxLabelWidth, styles: styles, onCollapseEnd: () => {
                        setIsCollapsing(false);
                    } }) }), showClear && onClear && (jsx(PillClearButton, { ariaLabel: clearAriaLabel, styles: styles, onClear: () => {
                    onClear();
                    // Clearing unmounts the X, so hand keyboard focus back to the pill.
                    pillRef.current?.focus();
                } }))] }));
    // Disabled, the pill only speaks when handed a reason — repeating a label for
    // an action you can't take is noise. Same contract as
    // `PromptInputSubmitButton`'s `disabledMessage`. The tooltip anchors the
    // wrapper, not the button, so hover still lands on a natively disabled pill.
    const tooltipMessage = isDisabledPill ? disabledMessage : tooltip;
    // Always mounted, never conditional on the props: a caller that clears
    // `disabledMessage` as the reason resolves would otherwise unmount the
    // wrapper, remounting the pill and dropping its focus. Inert with no message.
    return (jsx(Tooltip, { keepMountedWhileDisabled: true, message: tooltipMessage ?? "", placement: "bottom", isDisabled: tooltipMessage === undefined, children: pill }));
});
PromptInputPillButton.displayName = "PromptInputPillButton";

/**
 * A prompt-input pill that opens a menu. Must be rendered inside a `<Menu>`; the
 * caller supplies the `<MenuList>`.
 */
function PromptInputMenuButton({ label, ariaLabel, ...props }) {
    return (jsx(MenuButton$1, { as: PromptInputPillButton, "aria-label": ariaLabel ?? label, label: label, ...props }));
}

// Glyph, not "enter": Tooltip upper-cases non-modifier key names.
const submitShortcut = "⏎";
// Icon-shaped so loading renders inside the same persistent IconButton as
// send and stop — keeping one element alive is what preserves focus.
function SpinnerGlyph() {
    return jsx(Spinner, { size: "sm" });
}
/** Owns its tooltip so every prompt input describes sending the same way. */
function PromptInputSubmitButton({ hasContent, isDisabled = false, isLoading = false, onSubmit, onCancel, disabledMessage, ...marginProps }) {
    const isStop = isLoading && onCancel !== undefined;
    const canSubmit = hasContent && !isDisabled && !isLoading;
    // Only explain while actually blocked, even if a caller keeps `disabledMessage` set.
    const blockedReason = canSubmit || isLoading ? undefined : disabledMessage;
    let icon = ArrowUpIcon;
    let label = "Send prompt";
    if (isStop) {
        icon = StopIcon;
        label = "Stop";
    }
    else if (isLoading) {
        icon = SpinnerGlyph;
        label = "Sending";
    }
    // Blocked-with-reason and in-flight stay focusable (`aria-disabled`), so
    // keyboard and screen-reader users keep their place and reach the reason.
    const isNativeDisabled = !isLoading && !canSubmit && !blockedReason;
    const isAriaDisabled = Boolean(blockedReason) || (isLoading && !isStop);
    const isTooltipSilent = isLoading
        ? !isStop
        : !canSubmit && blockedReason === undefined;
    return (jsx(Tooltip
    // Toggling a plain disabled Tooltip remounts the button and drops focus.
    , { 
        // Toggling a plain disabled Tooltip remounts the button and drops focus.
        keepMountedWhileDisabled: true, message: isStop ? "Stop" : (blockedReason ?? "Send prompt"), keyboardShortcut: canSubmit ? submitShortcut : undefined, placement: "top", isDisabled: isTooltipSilent, children: jsx(Box, { display: "inline-flex", width: "fit-content", ...marginProps, children: jsx(IconButton, { "aria-label": label, icon: icon, 
                // Both loading forms are transparent (app parity) — the disc belongs
                // to send/idle only.
                variant: isLoading ? "tertiary" : "primary", size: "md", shape: "circle", isDisabled: isNativeDisabled, "aria-disabled": isAriaDisabled ? true : undefined, 
                // Keep focus in the textarea so sending (or stopping) doesn't blur it.
                onMouseDown: (event) => {
                    event.preventDefault();
                }, onClick: () => {
                    if (isStop) {
                        onCancel?.();
                        return;
                    }
                    if (canSubmit) {
                        onSubmit();
                    }
                } }) }) }));
}

/**
 * A prompt-input pill that toggles a setting on and off, expanding to reveal its label
 * while active.
 */
function PromptInputToggle({ label, icon, isActive, onToggle, ariaLabel, tooltip, isDisabled, disabledMessage, tone = "primary", ...marginProps }) {
    return (jsx(PromptInputPillButton, { variant: "compact", label: label, icon: icon, isActive: isActive, tone: tone, tooltip: tooltip, isDisabled: isDisabled, disabledMessage: disabledMessage, "aria-label": ariaLabel, "aria-pressed": isActive, onClick: onToggle, ...marginProps }));
}

function Radio({ isDisabled, label, badge, description, tooltip, value: realValue, id, ...inputProps }) {
    const group = useRadioGroupContext();
    const value = encode(realValue);
    const { getRootProps, getRadioProps, getLabelProps, getInputProps } = useRadio({
        id,
        isChecked: group.value === value,
        isFocusable: group.isFocusable,
        isDisabled: isDisabled || group.isDisabled,
        name: group.name,
        value,
        onChange: group.onChange,
    });
    const styles = useMultiStyleConfig("Radio");
    const tooltipProps = {
        message: null,
        ...tooltip,
    };
    return (jsxs(chakra.div, { children: [jsxs(chakra.div, { __css: styles["container"], children: [jsx(Tooltip, { isDisabled: !tooltip, ...tooltipProps, children: jsxs(chakra.label, { __css: styles["radio"], ...getRootProps(), children: [jsx(chakra.input, { __css: styles["input"], ...getInputProps(inputProps), style: {
                                        ...getInputProps().style,
                                    } }), jsxs(chakra.svg, { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", __css: styles["control"], ...getRadioProps(), children: [jsx("rect", { className: "control-bg", x: "0.5", y: "0.5", width: "15", height: "15", rx: "7.5" }), jsx("circle", { className: "control-dot", cx: "8", cy: "8", r: "3.2" }), jsx("rect", { className: "control-border", x: "0.5", y: "0.5", width: "15", height: "15", rx: "7.5", fill: "none" })] }), label && (jsx(chakra.span, { __css: styles["label"], ...getLabelProps(), children: label }))] }) }), label && badge] }), description && (jsx(chakra.p, { __css: styles["description"], children: description }))] }));
}

function SectionHeading({ as = "h3", isTruncated = false, color = "text.primary", children, ...props }) {
    const skeleton = useContext(SkeletonContext);
    return (jsxs(Heading$1, { as: as, position: skeleton ? "relative" : undefined, color: skeleton ? "transparent" : color, maxWidth: skeleton ? "max-content" : undefined, variant: "section", ...(isTruncated
            ? {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }
            : {}), ...props, children: [children, skeleton && jsx(SkeletonText, {})] }));
}

const IconMap = {
    empty: DottedCircleIcon,
    success: SuccessIcon,
    error: ErrorIcon,
};
const SegmentedControlSizeContext = createContext("md");
/**
 * SegmentedControl
 * A linear set of two or more segments, each of which functions as a mutually exclusive button.
 */
function SegmentedControl({ value, onChange, isDisabled, name, children, size = "md", width = "fit-content", ...props }) {
    const styles = useStyleConfig("SegmentedControl", { size });
    const handleChange = (newValue) => {
        onChange(decode(newValue));
    };
    return (jsx(RadioGroup$1, { name: name, value: encode(value), isDisabled: isDisabled, onChange: handleChange, width: width, children: jsx(SegmentedControlSizeContext.Provider, { value: size, children: jsx(chakra.div, { __css: styles, ...props, width: width, children: children }) }) }));
}
/**
 * SegmentedControlOption
 * An individual segment within the control.
 */
function SegmentedControlOption({ value: realValue, label, icon, children, isDisabled, status, tooltip, px = "md", "aria-label": ariaLabel, ...props }) {
    const group = useRadioGroupContext();
    const value = encode(realValue);
    const size = useContext(SegmentedControlSizeContext);
    // Icons follow the control size like Button's do: 16px at md, 20px at lg.
    const iconSize = size === "lg" ? 5 : 4;
    const { getRadioProps, getInputProps, getLabelProps } = useRadio({
        isChecked: group.value === value,
        isFocusable: group.isFocusable,
        isDisabled: isDisabled || group.isDisabled,
        name: group.name,
        value,
        onChange: group.onChange,
    });
    const isChecked = group.value === value;
    const styles = useMultiStyleConfig("SegmentedControlOption", {
        isChecked,
        status,
        px,
    });
    const hasVisibleText = Boolean(children || label);
    const option = (jsxs(chakra.label, { ...getLabelProps(), __css: styles.label, children: [jsx(chakra.input, { ...getInputProps(), ...props, "aria-label": ariaLabel }), jsxs(chakra.div, { __css: styles.item, ...getRadioProps(), "aria-hidden": undefined, sx: {
                    zIndex: 1,
                }, children: [icon && jsx(Icon, { "aria-hidden": true, as: icon, boxSize: iconSize }), status && jsx(Box$1, { "aria-hidden": true, as: IconMap[status], boxSize: iconSize }), hasVisibleText && (jsx(Box$1, { as: "span", __css: styles.text, children: children || label })), isChecked && (jsx(MotionBox, { "aria-hidden": true, __css: styles.indicator, layoutId: `segment-indicator-${group.name}`, 
                        // Deliberate overshoot: the thumb springs past the rail edge as it lands.
                        // Design-approved deviation from the bounce-0 default.
                        transition: {
                            type: "spring",
                            bounce: 0.2,
                            duration: motionDurations.slow,
                        } }))] })] }));
    return tooltip ? jsx(Tooltip, { message: tooltip, children: option }) : option;
}

function Select({ headerLabel, headerDescription, isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", options, optionLabel = defaultOptionLabel, optionDescription = defaultOptionDescription, optionValue = defaultOptionValue, optionAccessories, placeholder = "", removePortal = false, size = "md", value, variant = "default", fontWeight = "normal", popoverWidth, width = "xs", onChange, onClose, onOpen, valueLabel = optionLabel, showPlaceholderIcon = false, selectRef, _internalRenderLabelContent, ...props }) {
    const optionsContainer = useRef(null);
    const formControl = useFormControl({
        isDisabled,
        isInvalid,
    });
    const selectedOption = useMemo(() => {
        if (value === null || value === undefined) {
            return;
        }
        return options.find((option) => {
            return isEqual(optionValue(option), value);
        });
    }, [options, optionValue, value]);
    const { virtualItems, virtualizer } = useVirtualItems({
        options,
        optionLabel,
        containerRef: optionsContainer,
    });
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            return option ? optionLabel(option) : "";
        },
        stateReducer(state, { type, changes }) {
            // If it's an item click and the item is disabled, prevent the popover from closing
            if ((type === useSelect.stateChangeTypes.ItemClick ||
                type === useSelect.stateChangeTypes.ToggleButtonKeyDownEnter ||
                type ===
                    useSelect.stateChangeTypes.ToggleButtonKeyDownSpaceButton) &&
                changes.selectedItem) {
                const clickedItem = options.find((option) => changes.selectedItem &&
                    optionValue(option) === optionValue(changes.selectedItem));
                if (clickedItem && isOptionDisabled(clickedItem)) {
                    return state;
                }
            }
            return changes;
        },
        onSelectedItemChange({ selectedItem }) {
            if (selectedItem) {
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                onChange(optionValue(selectedItem));
                return;
            }
            if (isClearable) {
                onChange(undefined);
            }
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen) {
                onOpen?.();
            }
            else {
                onClose?.();
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        isClearable,
        isOptionDisabled,
        onChange,
        onClose,
        onOpen,
        options,
        optionLabel,
        optionValue,
        virtualizer,
        virtualItems.length,
    ]);
    const select = useSelect({
        toggleButtonId: formControl.id,
        items: options,
        selectedItem: selectedOption ?? null,
        ...downshiftMemoizedArguments,
    });
    // Force recalculation of measurements after dropdown opens
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, select.isOpen);
    const colorScheme = select.isOpen ? "open" : "closed";
    const showClearButton = isClearable && Boolean(selectedOption);
    const selectedOptionAccessories = selectedOption && typeof optionAccessories === "function"
        ? optionAccessories(selectedOption)
        : undefined;
    const styles = useMultiStyleConfig("Select", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const valueLabelText = useMemo(() => (selectedOption ? valueLabel(selectedOption) : placeholder), [selectedOption, valueLabel, placeholder]);
    const getSelectToggleButtonProps = select.getToggleButtonProps;
    const toggleButtonProps = useMemo(() => getSelectToggleButtonProps({
        ref: selectRef,
        "aria-label": valueLabelText,
        onFocus: formControl.onFocus,
        onBlur: formControl.onBlur,
    }), [
        getSelectToggleButtonProps,
        valueLabelText,
        formControl.onFocus,
        formControl.onBlur,
        selectRef,
    ]);
    const getSelectMenuProps = select.getMenuProps;
    const menuProps = useMemo(() => getSelectMenuProps({}, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [getSelectMenuProps]);
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    const valueLabelRenderer = _internalRenderLabelContent ?? valueLabel;
    return (
    // This div is necessary to ensure a single parent element when removePortal is true
    jsx("div", { children: jsxs(Popover$1, { isLazy: true, matchWidth: !popoverWidth, 
            // Accessibility: a11y specifies the toggle button must stay focused
            autoFocus: false, isOpen: select.isOpen, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-busy": isLoading ? "true" : undefined, __css: styles["toggleButton"], "data-selected": selectedOption ? "true" : undefined, disabled: formControl.disabled, width: width, "data-testid": "select", ...toggleButtonProps, ...props, children: [selectedOptionAccessories?.leftAccessory ? (jsx(IconAccessory, { accessory: selectedOptionAccessories.leftAccessory })) : showPlaceholderIcon && optionAccessories && !selectedOption ? (jsx(IconAccessory, { accessory: {
                                    type: "icon",
                                    icon: DottedCircleIcon,
                                    color: "text.secondary",
                                } })) : null, jsx(SelectValue, { __css: styles["value"], "data-placeholder": selectedOption || formControl.disabled ? undefined : "true", children: selectedOption
                                    ? valueLabelRenderer(selectedOption)
                                    : placeholder }), selectedOptionAccessories?.rightAccessory && (jsx(IconAccessory, { accessory: selectedOptionAccessories.rightAccessory })), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                                (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: select.reset })) : (jsx(chakra.div, { as: SelectorIcon, __css: styles["icon"] })))] }) }), jsxs(SelectPopover, { isOpen: select.isOpen, removePortal: removePortal, width: popoverWidth ?? width, "data-testid": "select-popover", ...menuProps, children: [headerLabel && (jsxs(chakra.div, { __css: selectOptionsStyles["header"], children: [jsx(Text, { fontWeight: "medium", children: headerLabel }), headerDescription && (jsx(Text, { color: "text.secondary", children: headerDescription }))] })), virtualItems.length === 0 && (jsx(SelectEmptyState, { children: emptyOptionsMessage })), virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                    height: `${totalHeight}px`,
                                }, children: visibleItems.map(({ key, index, start }) => {
                                    const virtualItem = virtualItems[index];
                                    if (virtualItem.type === "option") {
                                        const accessories = optionAccessories?.(virtualItem.option);
                                        const disabledMessageOrBoolean = virtualItem
                                            ? isOptionDisabled(virtualItem.option)
                                            : undefined;
                                        return (jsx(chakra.div, { __css: selectOptionsStyles["item"], style: {
                                                transform: `translateY(${start}px)`,
                                            }, children: jsx(SelectOption, { isHighlighted: select.highlightedIndex === virtualItem.index, isSelected: virtualItem.option === selectedOption, isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                    ? disabledMessageOrBoolean
                                                    : undefined, "data-index": index, ...accessories, ...select.getItemProps({
                                                    ref: virtualizer.measureElement,
                                                    item: virtualItem.option,
                                                    index: virtualItem.index,
                                                    onMouseLeave: () => {
                                                        select.setHighlightedIndex(-1);
                                                    },
                                                }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }) }, key));
                                    }
                                    return null;
                                }) }) }))] })] }) }));
}

function Slider(props) {
    return (jsxs(Slider$1, { focusThumbOnChange: false, ...props, children: [jsx(SliderThumb, {}), jsx(SliderTrack, {})] }));
}

const SlugInput = forwardRef$1(function SlugInput_({ isDisabled, isReadOnly, prefix, width = "xs", size = "md", validationState, ...props }, ref) {
    const styles = useMultiStyleConfig("Input", { size });
    return (jsxs(InputGroup, { size: size, width: width, children: [prefix && (jsx(chakra.div, { as: InputLeftAddon, __css: styles["leftAddon"], height: "auto", children: prefix })), jsx(Input, { ref: ref, isReadOnly: isReadOnly ?? isDisabled, isDisabled: isDisabled, isInvalid: validationState === "invalid", "data-testid": "slug-input", size: size, borderTopLeftRadius: prefix ? 0 : undefined, borderBottomLeftRadius: prefix ? 0 : undefined, ...props }), validationState && (jsxs(InputRightElement, { pointerEvents: "none", children: [validationState === "validating" && (jsx(Spinner, { size: size === "sm" ? "xs" : "sm" })), validationState === "valid" && (jsx(chakra.div, { as: SuccessIcon, __css: styles["validationIcon"], color: "success.base", "data-testid": "slug-input-success-icon" })), validationState === "invalid" && (jsx(chakra.div, { as: ErrorIcon, __css: styles["validationIcon"], color: "danger.base", "data-testid": "slug-input-error-icon" }))] }))] }));
});
SlugInput.displayName = "SlugInput";

// Border tokens from https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Styles-2?node-id=7500-2100&t=3tf6DG33KXUlIWWz-1
const $borderHairline = cssVar("border-hairline");
const borderWidths = {
    /**
     * The default border width — density-adaptive: 1px on standard displays, 0.5px on high-DPI
     * (≥2x) displays so borders stay crisp. Use for resting borders on surfaces (inputs, selects,
     * comboboxes, textareas, badges, cards, avatars, icon boxes) and dividers; pair with
     * `borderStyle="solid"` and a semantic `borderColor` (`base.border` by default). Menus and
     * popovers are generally borderless — they elevate with shadow instead. Not for focus rings
     * (use the `outline` shadow). A fixed literal `1px` / `2px` is a rare exception for emphasis
     * or density-independent alignment — never the default.
     */
    hairline: $borderHairline.reference,
};

/** Size of the chevron icon in the caret segment, per button size. */
const splitButtonCaretIconSize = {
    sm: 4,
    md: 5,
    lg: 6,
    xl: 6,
};
/** Horizontal padding of the caret segment, per button size. */
const caretPadding = {
    sm: 1.5,
    md: 2,
    lg: 2.5,
    xl: 3,
};
// Solid segments share no border, so draw a translucent divider between them.
const solidDivider = {
    borderInlineStartWidth: "hairline",
    borderInlineStartStyle: "solid",
    borderInlineStartColor: "rgba(255, 255, 255, 0.32)",
};
// Ghost segments have no border either; divide them with the standard border.
const ghostDivider = {
    borderInlineStartWidth: "hairline",
    borderInlineStartStyle: "solid",
    borderInlineStartColor: "base.border",
};
/**
 * Styles for the container that joins the primary and caret segments into a
 * single rounded rectangle.
 */
const splitButtonTheme = ({ variant, size, isJustified, }) => {
    const isSolid = variant === "primary" || variant === "danger";
    const hasBorder = variant === "secondary" || variant === "warning";
    return {
        "& > button:first-of-type": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            ...(isJustified ? { flex: 1 } : {}),
        },
        "& > button:last-of-type": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            paddingInlineStart: caretPadding[size],
            paddingInlineEnd: caretPadding[size],
            // The chevron is the button's only child; render it as a block so the
            // button's flex centering places it dead-center instead of on the
            // inherited text baseline (which floats it ~2px high).
            "& svg": { display: "block" },
            // Overlap the shared border, or draw a divider when there's none. Track
            // the hairline width the outline variants use so the seam collapses
            // cleanly at both standard and high-DPI densities.
            ...(hasBorder
                ? { marginInlineStart: `calc(-1 * ${$borderHairline.reference})` }
                : {}),
            ...(isSolid ? solidDivider : {}),
            ...(variant === "tertiary" ? ghostDivider : {}),
        },
    };
};

const SplitButton = forwardRef$1(function SplitButton_({ children, variant = "primary", size = "md", isDisabled = false, isLoading = false, isJustified = false, icon, onClick, menuAriaLabel = "More actions", menu, menuPlacement = "end", ...marginProps }, ref) {
    return (jsxs(Box$1, { display: "inline-flex", width: isJustified ? "100%" : "fit-content", sx: splitButtonTheme({ variant, size, isJustified }), ...marginProps, children: [jsx(Button, { ref: ref, variant: variant, size: size, isLoading: isLoading, isDisabled: isDisabled, icon: icon, onClick: onClick, children: children }), jsxs(Menu, { placement: menuPlacement, children: [jsx(MenuButton$1, { as: Button, variant: variant, size: size, isDisabled: isDisabled || isLoading, "aria-label": menuAriaLabel, children: jsx(Icon, { as: ChevronDownIcon, boxSize: splitButtonCaretIconSize[size] }) }), jsx(MenuList, { children: menu })] })] }));
});
SplitButton.displayName = "SplitButton";

function Stats(props) {
    return jsx(Box$1, { display: "flex", gap: 4, ...props });
}

function StatsItem(props) {
    return (jsx(Box$1, { flex: "1", minWidth: 0, pb: 1, _notLast: {
            borderRightWidth: "hairline",
            borderRightStyle: "solid",
            borderColor: "base.divider",
        }, ...props }));
}

function StatsItemTitle(props) {
    return (jsx(Text$1, { as: "span", fontSize: "sm", fontWeight: "semibold", color: "text.tertiary", ...props }));
}

function StatsItemValue(props) {
    return (jsx(Box$1, { mt: 1, children: jsx(Text$1, { as: "span", fontSize: "lg", fontWeight: "semibold", color: "text.primary", ...props }) }));
}

const colorByVariant = {
    success: "green.500",
    error: "danger.500",
    processing: "teal.500",
    warning: "warning.500",
    inactive: "gray.400",
};
function StatusIndicator({ variant, children, ...props }) {
    return (jsxs(Box$1, { display: "inline-flex", alignItems: "center", gap: 3, ...props, children: [jsx(Box$1, { flex: "none", boxSize: 2, borderRadius: "full", bg: colorByVariant[variant], className: "chakra-status-indicator-light" }), children && jsx(Text, { children: children })] }));
}

const Switch = forwardRef$1(function Switch_({ id, isDisabled = false, size = "md", "aria-label": ariaLabel, onChange, ...props }, ref) {
    const valueChanged = useCallback((event) => {
        onChange(event.target.checked);
    }, [onChange]);
    return (jsx(Box$1, { ref: ref, display: "flex", alignItems: "center", children: jsx(Switch$1, { isDisabled: isDisabled, id: id, "aria-label": ariaLabel, size: size, onChange: valueChanged, ...props }) }));
});
Switch.displayName = "Switch";

const numberFormatter$1 = new Intl.NumberFormat();
const Tab = forwardRef$1(function Tab_({ children, count, isDisabled = false, tooltip, statusIndicator, badgeVariant = "subtle", countFormatter, }, ref) {
    const tabProps = useTab({ ref });
    const styles = useMultiStyleConfig("Tabs", tabProps);
    const skeleton = useContext(SkeletonContext);
    if (skeleton) {
        return jsx(SkeletonBox, { __css: styles["skeleton"], children: children });
    }
    const tooltipProps = {
        message: null,
        ...tooltip,
    };
    return (jsx(Button$1, { isDisabled: isDisabled, __css: styles["tab"], ...tabProps, children: jsx(Tooltip, { isDisabled: !tooltip, ...tooltipProps, children: jsxs(Row, { align: "center", gap: 2, children: [children, typeof count === "number" && (jsx(Row, { as: "span", align: "center", children: jsx(Badge, { size: "sm", variant: badgeVariant, children: countFormatter?.(count) ?? numberFormatter$1.format(count) }) })), statusIndicator] }) }) }));
});
Tab.displayName = "Tab";

function TabList(props) {
    const { children, ...restProps } = props;
    const styles = useTabsStyles();
    const skeleton = useContext(SkeletonContext);
    // In skeleton mode each Tab renders a SkeletonBox without role="tab", so a
    // role="tablist" wrapper would have no valid children (axe aria-required-children)
    if (skeleton) {
        // Display: flex comes from Chakra's TabList component, not the theme styles
        return (jsx(Box$1, { display: "flex", __css: styles["tablist"], ...restProps, pos: "relative", children: children }));
    }
    return (jsxs(TabList$1, { ...restProps, pos: "relative", children: [children, jsx(TabIndicator, { bottom: "-1px", bg: "primary.base", height: "2px", transitionDuration: "normal", transitionTimingFunction: "easeInOutQuad" })] }));
}

function TabPanel(props) {
    return jsx(TabPanel$1, { ...props });
}

function TabPanels(props) {
    return jsx(TabPanels$1, { ...props });
}

const TabbedComboboxPopover = forwardRef$1(function TabbedComboboxPopover_({ isOpen, children, color: _color, "data-testid": dataTestId, removePortal, ...props }, ref) {
    const styles = useMultiStyleConfig("TabbedComboboxPopover");
    const Wrapper = removePortal ? Fragment$1 : Portal;
    return (jsx(Wrapper, { children: jsx(RemoveScroll, { enabled: isOpen, children: jsx(PopoverContent$1, { border: "none", "data-testid": dataTestId, borderRadius: "lg", boxShadow: "none !important", outline: "none !important", background: "transparent", opacity: isOpen ? 1 : 0, width: "inherit", "aria-label": "Options", height: "100%", rootProps: {
                    zIndex: "popover",
                    // https://github.com/chakra-ui/chakra-ui/issues/5865#issuecomment-1503817127
                    minWidth: "max-content",
                }, children: jsx(Box$1, { ref: ref, __css: styles, transition: isOpen ? openPopoverRepositionTransition : undefined, ...props, children: children }) }) }) }));
});
TabbedComboboxPopover.displayName = "TabbedComboboxPopover";

function TabbedComboboxTab({ onClick, isSelected = false, accessory, rightAccessory, id, ariaControls, colorScheme = "teal", ...props }) {
    const styles = useMultiStyleConfig("TabbedComboboxTab", {
        variant: isSelected ? "selected" : undefined,
        colorScheme: colorScheme,
    });
    return (jsxs(chakra.button, { __css: styles["button"], role: "tab", id: id, "aria-controls": ariaControls, "aria-selected": isSelected, onClick: onClick, children: [accessory && jsx(IconAccessory, { accessory: accessory }), jsx(chakra.span, { __css: styles["label"], ...props }), rightAccessory && jsx(IconAccessory, { accessory: rightAccessory })] }));
}

const labelToSlug = (label) => {
    return label.toLowerCase().replaceAll(" ", "-");
};
const AllTabLabel = "All";
const findSelected = ({ tabGroups, value, optionEquality, optionValue, valueLabel, }) => {
    for (const tabGroup of tabGroups) {
        for (const tab of tabGroup) {
            if (tab.label === AllTabLabel)
                continue;
            for (const optionGroup of tab.optionGroups) {
                for (const option of optionGroup.options) {
                    // This nested lookup over tab groups/tabs/option groups/options is straightforward despite its depth
                    if (optionEquality(optionValue(option), value)) {
                        return {
                            selectedOption: option,
                            selectedTabLabel: tab.label,
                        };
                    }
                }
            }
        }
    }
    return {
        selectedOption: undefined,
        selectedTabLabel: undefined,
    };
};
function TabbedCombobox({ isDisabled = false, isLoading = false, isInvalid = false, isClearable = false, isOptionDisabled = defaultIsOptionDisabled, emptyOptionsMessage = "No options", disableSortingAndFiltering = false, tabGroups, optionAccessory, optionDescription = defaultOptionDescription, optionEquality = defaultOptionEquality, optionLabel = defaultOptionLabel, optionValue = defaultOptionValue, optionFilterValue, placeholder = "", removePortal = false, size = "md", value, variant = "default", fontWeight = "normal", width = "xs", popoverWidth = "sm", onChange, onSearchUpdate, valueLabel = optionLabel, comboboxRef, showPlaceholderIcon = false, showAllTab = false, allTabAccessory, _internalRenderLabelContent, }) {
    const inputRef = useRef(null);
    const comboboxId = useId();
    const formControl = useFormControl({
        id: `combobox-${comboboxId}`,
        isDisabled,
        isInvalid,
    });
    const internalTabGroups = useMemo(() => {
        if (!showAllTab)
            return tabGroups;
        const optionGroups = tabGroups.flatMap((tabGroup) => tabGroup.flatMap((tab) => tab.optionGroups));
        const tabs = [
            [
                {
                    label: AllTabLabel,
                    accessory: allTabAccessory,
                    optionGroups,
                },
                ...tabGroups[0],
            ],
            ...tabGroups.slice(1),
        ];
        return tabs;
        // TODO(eric.lovett): This deps array is missing `allTabAccessory` and therefore may be buggy.
        // Please consider adding it.
    }, [showAllTab, tabGroups]);
    const tabLabels = useMemo(() => {
        return internalTabGroups.flatMap((tabGroup) => {
            return tabGroup.map((tab) => tab.label);
        });
    }, [internalTabGroups]);
    const { selectedOption, selectedTabLabel } = useMemo(() => {
        if (value === undefined || value === null) {
            return {
                selectedOption: undefined,
                selectedTabLabel: undefined,
            };
        }
        return findSelected({
            tabGroups: internalTabGroups,
            value,
            optionEquality,
            optionValue,
            valueLabel,
        });
    }, [internalTabGroups, value, optionEquality, optionValue, valueLabel]);
    const [currentTabLabel, setCurrentTabLabel] = useState(selectedTabLabel ?? tabLabels[0]);
    const { nextTabLabel, previousTabLabel } = useMemo(() => {
        const currentIndex = tabLabels.indexOf(currentTabLabel);
        return {
            nextTabLabel: tabLabels[currentIndex + 1],
            previousTabLabel: tabLabels[currentIndex - 1],
        };
    }, [currentTabLabel, tabLabels]);
    const optionGroups = useMemo(() => {
        for (const tabGroup of internalTabGroups) {
            for (const tab of tabGroup) {
                if (tab.label === currentTabLabel) {
                    return tab.optionGroups;
                }
            }
        }
        return [];
    }, [internalTabGroups, currentTabLabel]);
    const [isFiltering, setIsFiltering] = useState(false);
    // If optionFilterValue is provided, it will be used to build the value
    // used when filtering options. Otherwise, optionLabel will be used.
    const optionFilterRenderer = useMemo(() => {
        if (optionFilterValue)
            return optionFilterValue;
        return (option) => optionLabel(option);
    }, [optionFilterValue, optionLabel]);
    const [inputValue, setInputValue] = useState(() => {
        return selectedOption ? optionFilterRenderer(selectedOption) : "";
    });
    const updateSearch = useCallback((value) => {
        setInputValue(value);
        onSearchUpdate?.(value);
    }, [onSearchUpdate]);
    const filteredOptionGroups = useMemo(() => {
        if (!isFiltering || inputValue.length === 0 || disableSortingAndFiltering) {
            return optionGroups;
        }
        return optionGroups
            .map((optionGroup) => {
            return {
                ...optionGroup,
                options: matchSorter(optionGroup.options, inputValue, {
                    keys: [optionFilterRenderer],
                }),
            };
        })
            .filter((optionGroup) => optionGroup.options.length > 0);
    }, [
        disableSortingAndFiltering,
        isFiltering,
        optionGroups,
        optionFilterRenderer,
        inputValue,
    ]);
    const downshiftItems = useMemo(() => {
        const items = [];
        for (const optionGroup of filteredOptionGroups) {
            items.push(...optionGroup.options);
        }
        return items;
    }, [filteredOptionGroups]);
    const optionsContainer = useRef(null);
    const { virtualItems, getVirtualItemIndex, virtualizer } = useVirtualItems({
        optionGroups: filteredOptionGroups,
        optionLabel: optionFilterRenderer, // We use this function to generate the key for each item
        containerRef: optionsContainer,
    });
    const focusInput = useCallback(() => {
        inputRef.current?.focus();
    }, [inputRef]);
    const blurInput = useCallback(() => {
        if (inputRef.current) {
            inputRef.current.blur();
        }
    }, []);
    const downshiftMemoizedArguments = useMemo(() => ({
        itemToString(option) {
            if (!option) {
                return "";
            }
            return optionFilterRenderer(option);
        },
        onInputValueChange({ inputValue }) {
            updateSearch(inputValue?.trimStart() ?? "");
        },
        onSelectedItemChange({ selectedItem }) {
            if (selectedItem) {
                if (isOptionDisabled(selectedItem)) {
                    return;
                }
                onChange(optionValue(selectedItem));
            }
            else if (isClearable) {
                onChange(undefined);
            }
            blurInput();
        },
        onIsOpenChange({ isOpen }) {
            if (isOpen) {
                // Clear input value when combobox is opened
                updateSearch("");
                // Focus on the first tab
                setCurrentTabLabel(selectedTabLabel ?? tabLabels[0]);
            }
        },
        stateReducer(state, { type, changes }) {
            if (type === useCombobox.stateChangeTypes.InputClick) {
                return {
                    ...changes,
                    isOpen: state.isOpen,
                };
            }
            if (type === useCombobox.stateChangeTypes.InputChange) {
                return {
                    ...changes,
                    highlightedIndex: 0,
                };
            }
            // If it's an item click and the item is disabled, prevent the popover from closing
            if ((type === useCombobox.stateChangeTypes.ItemClick ||
                type === useCombobox.stateChangeTypes.InputKeyDownEnter) &&
                changes.selectedItem) {
                const clickedItem = downshiftItems.find((option) => typeof changes.selectedItem !== "symbol" &&
                    changes.selectedItem &&
                    optionValue(option) === optionValue(changes.selectedItem));
                if (clickedItem && isOptionDisabled(clickedItem)) {
                    return state;
                }
            }
            return changes;
        },
        onStateChange(changes) {
            if (changes.type === useCombobox.stateChangeTypes.InputChange) {
                setIsFiltering(true);
            }
            if (changes.type ===
                useCombobox.stateChangeTypes.ControlledPropUpdatedSelectedItem ||
                changes.type === useCombobox.stateChangeTypes.InputBlur) {
                setIsFiltering(false);
            }
        },
        // Unexpected undefined will be thrown if value pasted into input does not match to an item
        // https://github.com/hightouchio/hightouch-ui/issues/526
        onHighlightedIndexChange: ({ highlightedIndex }) => {
            if (typeof highlightedIndex !== "number") {
                return;
            }
            const virtualIndex = getVirtualItemIndex(highlightedIndex);
            try {
                scrollVirtualizerOnHighlightChange({
                    highlightedIndex: virtualIndex,
                    numberOfOptions: virtualItems.length,
                    scrollToIndex: virtualizer.scrollToIndex,
                });
            }
            catch (error) {
                if (error instanceof Error &&
                    error.message.includes("Unexpected undefined")) {
                    return;
                }
                throw error;
            }
        },
    }), [
        blurInput,
        downshiftItems,
        isClearable,
        isOptionDisabled,
        onChange,
        optionFilterRenderer,
        optionValue,
        selectedTabLabel,
        tabLabels,
        updateSearch,
        getVirtualItemIndex,
        virtualizer,
        virtualItems.length,
    ]);
    const combobox = useCombobox({
        inputId: formControl.id,
        items: downshiftItems,
        inputValue,
        selectedItem: selectedOption ?? null,
        ...downshiftMemoizedArguments,
    });
    // Dropdown animation causes items to miscalculate their size
    useDelayedCallback(virtualizer.measure, combobox.isOpen);
    const menuProps = useMemo(() => combobox.getMenuProps({
        // Don't apply role="listbox" to the popover container
        role: undefined,
        id: `${formControl.id}-popup`,
    }, {
        // https://github.com/downshift-js/downshift/issues/1272#issuecomment-1304575646
        suppressRefError: true,
    }), [combobox, formControl.id]);
    const colorScheme = combobox.isOpen ? "open" : "closed";
    // Reset combobox input value to selected option's label, if
    // user typed something else, but didn't select another option.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (combobox.selectedItem &&
            optionFilterRenderer(combobox.selectedItem) !== inputValue) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch(optionFilterRenderer(combobox.selectedItem));
        }
    }, [
        combobox.isOpen,
        inputValue,
        combobox.selectedItem,
        optionFilterRenderer,
        updateSearch,
    ]);
    // Reset combobox input value to empty string, if user hasn't
    // selected any option and there was no selected option before that.
    useEffect(() => {
        if (combobox.isOpen) {
            return;
        }
        if (!combobox.selectedItem) {
            // TODO(eric.lovett): This `updateSearch` call should probably be moved to a blur or close
            // event handler.
            updateSearch("");
        }
    }, [combobox.isOpen, combobox.selectedItem, updateSearch]);
    const showClearButton = isClearable && Boolean(selectedOption);
    const accessory = selectedOption && typeof optionAccessory === "function"
        ? optionAccessory(selectedOption)
        : undefined;
    const { isFocusVisible, focusProps } = useFocusRing({ isTextInput: true });
    const comboboxInputRef = useMergeRefs(comboboxRef, inputRef);
    const inputProps = combobox.getInputProps({
        ref: comboboxInputRef,
        "aria-controls": `${formControl.id}-listbox`,
        onFocus(event) {
            combobox.openMenu();
            formControl.onFocus(event);
            if (typeof focusProps.onFocus === "function") {
                focusProps.onFocus(event);
            }
        },
        onBlur(event) {
            formControl.onBlur(event);
            if (typeof focusProps.onBlur === "function") {
                focusProps.onBlur(event);
            }
        },
        onKeyDown(event) {
            if (event.key === "Escape" && combobox.isOpen) {
                event.stopPropagation();
            }
            // Return the focus to the combobox when the user presses Tab
            if (event.key === "Tab") {
                event.preventDefault();
                if (event.shiftKey) {
                    if (previousTabLabel) {
                        setCurrentTabLabel(previousTabLabel);
                        focusInput();
                    }
                    else {
                        // There is no previous tab, close the menu
                        combobox.closeMenu();
                    }
                }
                else {
                    if (nextTabLabel) {
                        setCurrentTabLabel(nextTabLabel);
                        focusInput();
                    }
                    else {
                        // There is no next tab, close the menu
                        combobox.closeMenu();
                    }
                }
            }
        },
    }, { suppressRefError: true });
    const handleChange = useComboboxImeSupport(updateSearch, inputProps.onChange);
    const tabbedComboboxStyles = useMultiStyleConfig("TabbedCombobox");
    const comboboxStyles = useMultiStyleConfig("Combobox", {
        colorScheme,
        size,
        variant,
        fontWeight,
    });
    const selectOptionsStyles = useMultiStyleConfig("SelectOptions");
    const totalHeight = virtualizer.getTotalSize();
    const visibleItems = virtualizer.getVirtualItems();
    const optionLabelRenderer = _internalRenderLabelContent ?? optionLabel;
    const handleSelectTab = useCallback((tab) => {
        // We scroll to the top of the list first, because we need to
        // ensure the virtualizer updates it's internal scroll offset
        // *before* we re-render the list. If we don't do this, the
        // list will sometimes render with the wrong scroll position.
        virtualizer.scrollToOffset(0);
        setTimeout(() => {
            setCurrentTabLabel(tab.label);
            updateSearch("");
            focusInput();
        }, 5);
    }, [virtualizer, focusInput, updateSearch]);
    return (jsxs(Popover$1, { autoFocus: true, returnFocusOnClose: true, matchWidth: !popoverWidth, isOpen: combobox.isOpen, initialFocusRef: inputRef, placement: "bottom-start", children: [jsx(PopoverTrigger$1, { children: jsxs(SelectToggleButton, { "aria-invalid": formControl["aria-invalid"], "aria-required": formControl["aria-required"], "aria-describedby": formControl["aria-describedby"], "aria-busy": isLoading ? "true" : undefined, "aria-haspopup": "dialog", __css: comboboxStyles["control"], "data-selected": selectedOption ? "true" : undefined, "data-disabled": formControl.disabled ? "true" : undefined, "data-focus-visible": isFocusVisible ? "true" : undefined, width: width, ...combobox.getToggleButtonProps({ tabIndex: 0 }), children: [accessory ? (jsx(IconAccessory, { accessory: accessory })) : showPlaceholderIcon && optionAccessory && !selectedOption ? (jsx(IconAccessory, { accessory: {
                                type: "icon",
                                icon: DottedCircleIcon,
                                color: "text.secondary",
                            } })) : null, jsx(chakra.span, { __css: comboboxStyles["value"], "data-placeholder": selectedOption || formControl.disabled ? undefined : "true", children: selectedOption
                                ? _internalRenderLabelContent
                                    ? _internalRenderLabelContent(selectedOption)
                                    : valueLabel(selectedOption)
                                : placeholder }), isLoading && jsx(Spinner, { size: "sm" }), !isLoading &&
                            (showClearButton ? (jsx(SelectClearButton, { disabled: formControl.disabled, onClick: combobox.reset })) : (jsx(chakra.div, { as: SelectorIcon, __css: comboboxStyles["toggleButtonIcon"] })))] }) }), jsxs(TabbedComboboxPopover, { isOpen: combobox.isOpen, removePortal: removePortal, width: popoverWidth, "data-testid": "tabbed-combobox-popover", ...menuProps, children: [jsx(chakra.div, { role: "tablist", __css: tabbedComboboxStyles["tabList"], onMouseUp: (event) => {
                            event.stopPropagation();
                        }, children: internalTabGroups.map((tabGroup, index) => {
                            const tabGroupId = labelToSlug(tabGroup[0].label);
                            return (jsxs(chakra.div, { children: [index > 0 && (jsx(Box, { borderBottomWidth: "hairline", borderBottomStyle: "solid", borderColor: "base.divider", my: 2, mx: -2 })), jsx(chakra.div, { __css: tabbedComboboxStyles["tabGroup"], children: tabGroup.map((tab) => {
                                            const tabId = labelToSlug(tab.label);
                                            const isSelected = tab.label === currentTabLabel;
                                            return (jsx(TabbedComboboxTab, { id: `${formControl.id}-tab-${tabId}`, isSelected: isSelected, ariaControls: `${formControl.id}-tabpanel`, colorScheme: tab.accessory?.type === "icon-box"
                                                    ? tab.accessory.color
                                                    : undefined, accessory: tab.accessory && {
                                                    ...tab.accessory,
                                                    ...(tab.accessory?.type === "icon-box"
                                                        ? { isSelected, size: "md" }
                                                        : undefined),
                                                }, rightAccessory: tab.rightAccessory && {
                                                    ...tab.rightAccessory,
                                                    ...(tab.rightAccessory?.type === "icon-box"
                                                        ? { isSelected, size: "md" }
                                                        : undefined),
                                                }, onClick: () => {
                                                    handleSelectTab(tab);
                                                }, children: tab.label }, `tab-${formControl.id}-${tabId}`));
                                        }) })] }, `${formControl.id}-tab-group-${tabGroupId}`));
                        }) }), jsx(chakra.div, { role: "tabpanel", "aria-labelledby": `${formControl.id}-tab-${labelToSlug(currentTabLabel)}`, id: `${formControl.id}-tabpanel`, width: "100%", children: jsxs(chakra.div, { __css: tabbedComboboxStyles["tabPanel"], children: [jsx(chakra.div, { __css: tabbedComboboxStyles["tabSearchContainer"], 
                                    // Prevent the popover from closing when the user clicks on the tab panel
                                    onMouseUp: (event) => {
                                        event.stopPropagation();
                                    }, children: jsx(SearchInput, { autoFocus: true, width: "auto", placeholder: placeholder, "aria-label": placeholder || "Search", "aria-invalid": formControl["aria-invalid"], "aria-describedby": formControl["aria-describedby"], "aria-required": formControl["aria-required"], "data-testid": "combobox-search-input", ...inputProps, onChange: handleChange }) }), downshiftItems.length === 0 && (jsx(SelectEmptyState, { hasBorder: false, children: emptyOptionsMessage })), downshiftItems.length > 0 && virtualItems.length > 0 && (jsx(chakra.div, { ref: optionsContainer, __css: selectOptionsStyles["container"], id: `${formControl.id}-listbox`, role: "listbox", onMouseDown: handleScrollbarMouseDown, children: jsx(chakra.div, { __css: selectOptionsStyles["list"], style: {
                                            height: `${totalHeight}px`,
                                        }, children: visibleItems.map(({ key, index, start }) => {
                                            const virtualItem = virtualItems[index];
                                            const isOption = virtualItem.type === "option";
                                            const accessory = isOption
                                                ? optionAccessory?.(virtualItem.option)
                                                : null;
                                            const isIconBox = accessory?.type === "icon-box";
                                            const isSelected = isOption &&
                                                selectedOption &&
                                                optionValue(selectedOption) ===
                                                    optionValue(virtualItem.option);
                                            const disabledMessageOrBoolean = isOption
                                                ? isOptionDisabled(virtualItem.option)
                                                : undefined;
                                            return (jsxs(chakra.div, { __css: selectOptionsStyles["item"], position: "absolute", style: {
                                                    transform: `translateY(${start}px)`,
                                                }, children: [virtualItem.type === "group" && (jsx(chakra.div, { ref: virtualizer.measureElement, "data-index": index, children: jsx(SelectGroup, { children: virtualItem.label }) })), isOption && (jsx(SelectOption, { isHighlighted: combobox.highlightedIndex === virtualItem.index, isSelected: isSelected, isDisabled: Boolean(disabledMessageOrBoolean), disabledMessage: typeof disabledMessageOrBoolean === "string"
                                                            ? disabledMessageOrBoolean
                                                            : undefined, "data-index": index, colorScheme: isIconBox ? accessory.color : undefined, leftAccessory: accessory
                                                            ? {
                                                                ...accessory,
                                                                ...(isIconBox
                                                                    ? { isSelected, size: "md" }
                                                                    : undefined),
                                                            }
                                                            : undefined, ...combobox.getItemProps({
                                                            ref: virtualizer.measureElement,
                                                            item: virtualItem.option,
                                                            index: virtualItem.index,
                                                            onMouseLeave: () => {
                                                                combobox.setHighlightedIndex(-1);
                                                            },
                                                        }), children: jsx(SelectOptionLabel, { description: optionDescription(virtualItem.option), children: optionLabelRenderer(virtualItem.option) }) }))] }, key));
                                        }) }) }))] }) })] })] }));
}

// Set by TabNav collapsible mode: "collapsibleTab" holds a strip tab's li at
// natural width for overflow measurement; "collapsedTab" is a "more"-menu row.
const TabNavLinkVariantContext = createContext("tab");

// Not the wrap-detection of badge-group/label-badge-group: that cuts in document
// order, but tabs must keep the active tab visible out of order (aria-current +
// the sliding layoutId indicator), so the cut is computed from measured widths.
/**
 * How many leading tabs fit beside a reserved overflow trigger.
 *
 * Takes each tab's right edge (gaps already included), not its width, so the fit
 * needs no gap term. `triggerReserve` is the measured gap-plus-width the trigger
 * adds after the last visible tab.
 */
function computeVisibleTabCount(itemRightEdges, containerWidth, triggerReserve) {
    const total = itemRightEdges.length;
    if (total === 0 || containerWidth <= 0) {
        return total;
    }
    if (itemRightEdges[total - 1] <= containerWidth) {
        return total;
    }
    // Overflowing, so the trigger competes for space. Edges are monotonic, so the
    // first tab whose edge plus the trigger overflows ends the visible run.
    let visible = 0;
    for (let index = 0; index < total; index++) {
        if (itemRightEdges[index] + triggerReserve > containerWidth) {
            break;
        }
        visible = index + 1;
    }
    return visible;
}
/**
 * Which tab indices are visible once the active tab is guaranteed a slot.
 *
 * An overflowing active tab replaces the last visible one, in document order, so
 * the `aria-current`/indicator tab stays mounted. The freed slot was sized from
 * a leading tab, so a much wider active tab (e.g. one with a count badge) can
 * push the row slightly past the container — the pin assumes roughly-equal widths.
 */
function resolveVisibleIndices(totalCount, visibleCount, activeIndex) {
    const all = Array.from({ length: totalCount }, (_, index) => index);
    if (visibleCount >= totalCount) {
        return { visible: all, overflow: [] };
    }
    const activeHidden = activeIndex >= visibleCount && activeIndex < totalCount;
    const cutoff = activeHidden ? Math.max(0, visibleCount - 1) : visibleCount;
    const visibleSet = new Set(all.slice(0, cutoff));
    if (activeHidden) {
        visibleSet.add(activeIndex);
    }
    const visible = [];
    const overflow = [];
    for (const index of all) {
        (visibleSet.has(index) ? visible : overflow).push(index);
    }
    return { visible, overflow };
}

const canObserveResize = typeof window !== "undefined" && typeof ResizeObserver !== "undefined";
/**
 * Navigation menu container for `TabNavLink` components.
 */
function TabNav({ children, collapsible = false, ...props }) {
    const styles = useMultiStyleConfig("TabNav");
    const layoutId = useId$1(undefined, "tab-nav");
    return (jsx(LayoutGroup, { id: layoutId, children: jsx(chakra.nav, { __css: styles["root"], ...props, children: collapsible ? (jsx(OverflowTablist, { children: children })) : (jsx(chakra.ul, { __css: styles["tablist"], children: children })) }) }));
}
function OverflowTablist({ children }) {
    const styles = useMultiStyleConfig("TabNav");
    const items = Children.toArray(children).filter((child) => isValidElement(child));
    const total = items.length;
    const activeIndex = items.findIndex((item) => item.props.isActive === true);
    const containerRef = useRef(null);
    const measureListRef = useRef(null);
    const triggerPlaceholderRef = useRef(null);
    const menuRef = useRef(null);
    // Focus the first link on open, not the container Chakra would autofocus. The
    // getter resolves lazily because isLazy mounts the menu only when opened.
    const initialFocusRef = useMemo(() => ({
        get current() {
            return (menuRef.current?.querySelector('a[href]:not([aria-hidden="true"])') ?? null);
        },
    }), []);
    // Seed with total = "unmeasured": the layout effect collapses before paint, so
    // no squished frame shows.
    const [visibleCount, setVisibleCount] = useState(total);
    const measure = useCallback(() => {
        const container = containerRef.current;
        const measureList = measureListRef.current;
        const placeholder = triggerPlaceholderRef.current;
        if (!container || !measureList || !placeholder)
            return;
        // Measure the hidden list, not the visible row: the visible row drops
        // overflow tabs, so it can't tell when a hidden tab would fit again.
        const listLeft = measureList.getBoundingClientRect().left;
        // Right edges relative to the strip start already include the flex gaps, so
        // the fit math never reads the gap value.
        const itemRightEdges = Array.from(measureList.children)
            .filter((child) => child instanceof HTMLElement && child !== placeholder)
            .map((child) => child.getBoundingClientRect().right - listLeft);
        const lastItemRight = itemRightEdges.at(-1) ?? 0;
        // The placeholder trails the tabs, so its extent past the last one is the
        // gap-plus-width the real trigger occupies — a real value on the first pass,
        // unlike the conditionally-mounted visible trigger.
        const triggerReserve = placeholder.getBoundingClientRect().right - listLeft - lastItemRight;
        setVisibleCount(computeVisibleTabCount(itemRightEdges, container.clientWidth, triggerReserve));
    }, []);
    useLayoutEffect(() => {
        if (!canObserveResize)
            return;
        measure();
        const container = containerRef.current;
        if (!container)
            return;
        const observer = new ResizeObserver(measure);
        observer.observe(container);
        return () => {
            observer.disconnect();
        };
    }, [measure]);
    const { visible, overflow } = resolveVisibleIndices(total, visibleCount, activeIndex);
    return (jsxs(chakra.div, { ref: containerRef, position: "relative", children: [jsxs(chakra.ul, { ref: measureListRef, __css: styles["tablist"], "aria-hidden": "true", position: "absolute", visibility: "hidden", pointerEvents: "none", width: "100%", children: [jsx(TabNavLinkVariantContext.Provider, { value: "collapsibleTab", children: items.map((item) => cloneElement(item, { isActive: false })) }), jsx(chakra.li, { ref: triggerPlaceholderRef, __css: styles["overflowTrigger"], children: jsx(Button, { variant: "tertiary", size: "sm", directionIcon: ChevronDownIcon, children: `${total} more` }) })] }), jsxs(chakra.ul, { __css: styles["tablist"], children: [jsx(TabNavLinkVariantContext.Provider, { value: "collapsibleTab", children: visible.map((index) => items[index]) }), overflow.length > 0 && (jsx(chakra.li, { __css: styles["overflowTrigger"], children: jsxs(Popover, { isLazy: true, placement: "bottom-end", initialFocusRef: initialFocusRef, children: [jsx(PopoverTrigger, { children: jsx(Button, { variant: "tertiary", size: "sm", directionIcon: ChevronDownIcon, "aria-haspopup": "true", children: `${overflow.length} more` }) }), jsx(Portal, { children: jsx(PopoverContent, { width: "max-content", maxWidth: "xs", children: jsx(PopoverBody, { p: 2, children: jsx(chakra.ul, { ref: menuRef, __css: styles["overflowMenu"], children: jsx(TabNavLinkVariantContext.Provider, { value: "collapsedTab", children: overflow.map((index) => items[index]) }) }) }) }) })] }) }))] })] }));
}

const numberFormatter = new Intl.NumberFormat();
const TabNavLink = forwardRef$1(function TabNavLink_({ isActive = false, asChild = false, children, count, isDisabled = false, tooltip, statusIndicator, badgeVariant = "subtle", countFormatter, ...props }, ref) {
    const styles = useMultiStyleConfig("TabNav", { isActive, isDisabled });
    const variant = useContext(TabNavLinkVariantContext);
    const linkStyle = variant === "collapsedTab" ? styles["collapsedTab"] : styles["tabLink"];
    const liStyle = variant === "collapsibleTab" ? styles["collapsibleTab"] : undefined;
    const skeleton = useContext(SkeletonContext);
    if (skeleton) {
        return (jsx(SkeletonBox, { as: "li", __css: styles["skeleton"], children: children }));
    }
    const tooltipProps = {
        message: null,
        ...tooltip,
    };
    const textContent = asChild && isValidElement(children)
        ? children.props.children
        : children;
    const linkContent = (jsx(Tooltip, { isDisabled: !tooltip, ...tooltipProps, children: jsxs(chakra.div, { __css: styles["tabLinkContent"], children: [jsx(chakra.span, { children: textContent }), typeof count === "number" && (jsx(chakra.span, { __css: styles["tabLinkCount"], children: jsx(Badge, { size: "sm", variant: badgeVariant, children: countFormatter?.(count) ?? numberFormatter.format(count) }) })), statusIndicator] }) }));
    const activeIndicator = isActive && variant !== "collapsedTab" && (jsx(MotionBox, { "aria-hidden": "true", layoutId: "tab-nav-indicator", __css: styles["tabIndicator"], transition: {
            default: { ease: motionEasings.easeInOutQuad },
            layout: { duration: motionDurations.normal },
        } }));
    const disabledProps = isDisabled
        ? {
            "aria-hidden": "true",
            tabIndex: -1,
            onClick: (event) => {
                event.preventDefault();
                event.stopPropagation();
            },
        }
        : {};
    const linkProps = {
        ...props,
        ...disabledProps,
        ...(isActive && { "aria-current": "page" }),
    };
    // Handle asChild pattern - merge props with child element
    if (asChild && isValidElement(children)) {
        const child = children;
        // For string element types (like "a", "div"), create a styled Chakra component
        if (typeof child.type === "string") {
            // @ts-expect-error - chakra accepts string types at runtime, but TypeScript types are strict
            const StyledChild = chakra(child.type);
            // Use tabLink styles - if child has __css, it will be overridden by our styles
            const mergedProps = {
                ...child.props,
                ...linkProps,
                ref,
                __css: linkStyle,
                children: (jsxs(Fragment, { children: [linkContent, activeIndicator] })),
            };
            return (jsx(chakra.li, { __css: liStyle, children: jsx(StyledChild, { ...mergedProps }) }));
        }
        // For component types, use chakra.div with 'as' prop to apply styles
        // This preserves the component's behavior while applying Chakra styles
        // Type assertion is needed because child.type is a complex React type that
        // Chakra's as prop doesn't accept directly, but ElementType is compatible
        const componentType = child.type;
        return (jsx(chakra.li, { __css: liStyle, children: jsxs(chakra.div, { ref: ref, as: componentType, __css: linkStyle, ...child.props, ...linkProps, children: [linkContent, activeIndicator] }) }));
    }
    return (jsx(chakra.li, { __css: liStyle, children: jsxs(chakra.a, { ref: ref, __css: linkStyle, ...linkProps, children: [linkContent, activeIndicator] }) }));
});
TabNavLink.displayName = "TabNavLink";

function Tabs(props) {
    return jsx(Tabs$1, { isLazy: true, ...props });
}

/** The theme's `leftElement` width at each size, so text starts past the icon. */
const ICON_INSET = { sm: 8, md: 9, lg: 10 };
/** Removes all non-integer characters from a string. Allows leading hyphen for negative numbers. */
const cleanBigintString = (value) => value
    // Only allow numerals and hyphens
    .replaceAll(/[^\d-]/gu, "")
    // Only allow a hyphen if it is at the beginning of the string
    .replaceAll(/(?<=.)-/gu, "");
const TextInput = forwardRef$1(function TextInput_({ isDisabled, isReadOnly, width = "xs", size = "md", onFocus, onBlur, type: typeFromProps, onChange, isWarning, icon, ...props }, ref) {
    const [isFocused, setIsFocused] = useState(false);
    const { isFocusVisible, focusProps } = useFocusRing({
        isTextInput: true,
    });
    const inputFocused = useCallback((event) => {
        setIsFocused(true);
        focusProps.onFocus?.(event);
        onFocus?.(event);
    }, [focusProps, onFocus]);
    const inputBlurred = useCallback((event) => {
        setIsFocused(false);
        focusProps.onBlur?.(event);
        onBlur?.(event);
    }, [focusProps, onBlur]);
    // Browser behavior for `type="number"` can be a bit weird, like completely clearing the input
    // if the user attempts to enter something invalid. Instead, use `inputMode` for a11y while
    // using `type="text"` to not conflict with custom state management.
    // This does lose some built-in functionality like increment on up arrow keydown.
    const type = typeFromProps === "integer" ? "text" : typeFromProps;
    const inputMode = typeFromProps === "integer" ? "numeric" : undefined;
    const styles = useMultiStyleConfig("Input", { size });
    const handleChange = useCallback((event) => {
        if (!onChange)
            return;
        if (typeFromProps === "integer") {
            event.target.value = cleanBigintString(event.target.value);
            onChange(event);
        }
        else {
            onChange(event);
        }
    }, [onChange, typeFromProps]);
    // With an icon the group is the outer box, so margins belong on it.
    const [marginProps, inputProps] = icon
        ? splitMarginProps(props)
        : [{}, props];
    const input = (jsx(Input, { ref: ref, type: type, inputMode: inputMode, isReadOnly: isReadOnly ?? isDisabled, isDisabled: isDisabled, size: size, boxShadow: isFocused && isFocusVisible ? "outline" : undefined, width: icon ? "100%" : width, 
        // Chakra only auto-pads for a left element it recognises as a direct
        // child; this is composed, so the room for the icon is made here.
        paddingInlineStart: icon ? ICON_INSET[size] : undefined, maxWidth: "100%", "data-warning": isWarning ? "true" : undefined, onFocus: inputFocused, onBlur: inputBlurred, onChange: handleChange, ...inputProps }));
    if (!icon)
        return input;
    return (jsxs(InputGroup, { width: width, size: size, ...marginProps, children: [jsx(chakra.div, { as: InputLeftElement, __css: styles["leftElement"], children: jsx(chakra.div, { as: icon, __css: styles["leftIcon"] }) }), input] }));
});
TextInput.displayName = "TextInput";

// background-position is cheap to animate and the glyphs never move.
const shimmer = keyframes `
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
`;
const agentActivityTheme = {
    parts: [
        "container",
        "shimmerLabel",
        "trigger",
        "summary",
        "summaryLabel",
        "chevron",
        "disclosure",
        "viewport",
        "content",
    ],
    baseStyle: {
        container: {
            width: "100%",
        },
        shimmerLabel: {
            fontWeight: "medium",
            color: "transparent",
            backgroundImage: "linear-gradient(110deg, var(--chakra-colors-text-tertiary) 30%, var(--chakra-colors-text-primary) 50%, var(--chakra-colors-text-tertiary) 70%)",
            backgroundSize: "200% 100%",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            animation: `${shimmer} 1.8s linear infinite`,
            "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
                color: "text.secondary",
            },
        },
        trigger: {
            display: "flex",
            alignItems: "center",
            height: 7,
            minWidth: 0,
            columnGap: 1.5,
            borderRadius: "md",
            textAlign: "left",
            fontWeight: "medium",
            color: "text.secondary",
            cursor: "pointer",
            // No log to open, so the row is plain text rather than a control.
            "&[data-static]": { cursor: "default" },
            outline: "none",
            transitionProperty: "color",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            _hover: {
                color: "text.primary",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        // The clip window for the label ticker; the inner label truncates.
        summary: {
            minWidth: 0,
            overflow: "hidden",
            fontVariantNumeric: "tabular-nums",
        },
        summaryLabel: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        chevron: {
            display: "inline-flex",
            flex: "none",
            svg: { boxSize: 3.5 },
            color: "icon.tertiary",
            transitionProperty: "color, opacity",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            _groupHover: {
                color: "icon.primary",
            },
            // Nested so the reveal outranks the hidden state on specificity alone,
            // rather than on declaration order.
            "&[data-peek]": {
                opacity: 0,
                _groupHover: { opacity: 1 },
                _groupFocusVisible: { opacity: 1 },
            },
        },
        disclosure: {
            overflow: "hidden",
            transformOrigin: "top",
            '&[aria-hidden="true"]': {
                pointerEvents: "none",
            },
        },
        viewport: {
            pr: 1,
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
                display: "none",
            },
            borderRadius: "sm",
            _focusVisible: {
                outline: "none",
                boxShadow: "outline",
            },
        },
        content: {
            display: "flex",
            flexDirection: "column",
            rowGap: 0.5,
            py: 2,
            fontSize: "sm",
            lineHeight: 4,
        },
    },
    // Only the trigger scales. Rows are already `sm`, so the small size reads as
    // one flat block instead of a headline over smaller detail.
    sizes: {
        sm: {
            container: {
                fontSize: "sm",
                lineHeight: 4,
            },
        },
        md: {
            container: {
                fontSize: "md",
                lineHeight: 5,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const agentCardTheme = {
    parts: [
        "container",
        "inner",
        "header",
        "titleRow",
        "swap",
        "titleSwap",
        "statusIcon",
        "heading",
        "title",
        "status",
        "subtext",
        "body",
        "content",
        "footer",
        "actions",
    ],
    baseStyle: {
        container: {
            width: "100%",
            borderRadius: "3xl",
            // Clip, not hidden: a hidden box still scrolls sideways when focus lands on a sliding question.
            overflow: "clip",
            // The nearest surface supplies its inverse, so the card stands out on a white or a gray chat.
            bg: $surfaceAgentCardBg.reference,
            boxShadow: $surfaceAgentCardShadow.reference,
            ...agentCardSurfaceVars,
            // Takes focus when a resolve removes the control that held it.
            outline: "none",
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        // Positioned so a leaving body can pop out of layout while it fades.
        inner: {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            py: 4,
        },
        header: {
            display: "flex",
            flexDirection: "column",
            px: 4,
        },
        titleRow: {
            display: "flex",
            alignItems: "center",
            gap: 2,
        },
        swap: {
            display: "flex",
            minWidth: 0,
        },
        titleSwap: {
            display: "flex",
            flex: 1,
            minWidth: 0,
        },
        statusIcon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSize: 5,
            flex: "none",
            color: "icon.secondary",
            "&[data-status=approved], &[data-status=answered]": {
                color: "icon.success",
            },
            "&[data-status=rejected]": {
                color: "icon.danger",
            },
            "&[data-status=changes-requested]": {
                color: "icon.warning",
            },
        },
        heading: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            flex: 1,
            minWidth: 0,
        },
        title: {
            display: "flex",
            flex: 1,
            minWidth: 0,
        },
        // Always mounted, so a screen reader announces the result when it arrives.
        // It takes space only once it holds a line.
        status: {
            "&:not(:empty)": {
                mt: 2,
            },
        },
        // Starts at the title's text: glyph (5) + title row gap (2).
        // Flex keeps the line at its own 20px line height.
        subtext: {
            display: "flex",
            pl: 7,
        },
        body: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            px: 4,
        },
        // Text content hangs from the title's left edge; interactive rows stay full width.
        content: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            pl: 7,
        },
        footer: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            px: 4,
        },
        // Quietest first, primary terminal-right — the confirmation-dialog order.
        actions: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 2,
            flexWrap: "wrap",
            flex: 1,
        },
    },
};

const approvalCardTheme = {
    parts: [
        "changes",
        "change",
        "marker",
        "item",
        "chip",
        "chipIcon",
        "chipLabel",
    ],
    baseStyle: {
        changes: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            listStyleType: "none",
            m: 0,
            p: 0,
        },
        change: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            minWidth: 0,
        },
        // The glyph carries the meaning; the tint only reinforces it.
        marker: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSize: 5,
            flex: "none",
            borderRadius: "md",
            "&[data-kind=add]": {
                bg: "success.background",
                color: "icon.success",
            },
            "&[data-kind=change]": {
                bg: "warning.background",
                color: "icon.warning",
            },
            "&[data-kind=remove]": {
                bg: "danger.background",
                color: "icon.danger",
            },
            svg: {
                boxSize: 3,
            },
        },
        // A detail that doesn't fit beside the chip wraps under it, clear of the marker.
        item: {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            columnGap: 2,
            rowGap: 1,
            flex: 1,
            minWidth: 0,
        },
        chip: {
            display: "flex",
            alignItems: "center",
            gap: 1,
            minWidth: 0,
            px: 1.5,
            py: 0.5,
            bg: "white",
            borderWidth: "hairline",
            borderStyle: "solid",
            borderColor: "base.border",
            borderRadius: "md",
        },
        chipIcon: {
            display: "flex",
            flex: "none",
            color: "icon.secondary",
            svg: {
                boxSize: 4,
            },
        },
        // Identifiers have no spaces, so a long one breaks anywhere rather than getting clipped.
        chipLabel: {
            minWidth: 0,
            overflowWrap: "anywhere",
            textStyle: "mono",
            fontSize: "sm",
            lineHeight: "4",
        },
    },
};

const pulse = keyframes `
  0% { opacity: 0.35; }
  50% { opacity: 0.8; }
  100% { opacity: 0.35; }
`;
const truncate = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};
const rowShell = {
    display: "grid",
    alignItems: "center",
    minHeight: 8,
    columnGap: 2.5,
    borderRadius: "md",
    px: 1.5,
    py: 0.5,
};
const rowIcon = {
    boxSize: 4,
    display: "grid",
    placeItems: "center",
    color: "icon.tertiary",
    svg: { boxSize: 4 },
};
const rowLabel = {
    fontWeight: "medium",
    color: "text.primary",
    ...truncate,
};
const agentActivityRowTheme = {
    parts: [
        "stepRow",
        "stepIcon",
        "stepPulse",
        "stepPulseHalo",
        "stepPulseDot",
        "stepLabel",
        "stepMeta",
        "textRow",
        "searchRow",
        "searchQuery",
        "searchQueryIcon",
        "searchQueryText",
        "searchResults",
        "searchResult",
        "searchResultIcon",
        "searchResultTitle",
        "searchResultDomain",
        "searchMore",
        "toolRow",
        "toolIcon",
        "toolAction",
        "toolDiff",
        "toolAdditions",
        "toolDeletions",
        "traceRow",
        "traceIcon",
        "traceLabel",
        "monoChip",
    ],
    baseStyle: {
        stepRow: {
            display: "flex",
            alignItems: "flex-start",
            minHeight: 7,
            columnGap: 2.5,
            borderRadius: "md",
            px: 1.5,
            py: 1,
        },
        stepIcon: {
            flex: "none",
            boxSize: 4,
            display: "grid",
            placeItems: "center",
            color: "icon.tertiary",
        },
        stepPulse: {
            position: "relative",
            boxSize: 3,
            display: "grid",
            placeItems: "center",
        },
        stepPulseHalo: {
            position: "absolute",
            inset: 0,
            borderRadius: "full",
            bg: "base.backgroundHover",
            animation: `${pulse} 1.5s ease-in-out infinite`,
            "@media (prefers-reduced-motion: reduce)": {
                animation: "none",
            },
        },
        stepPulseDot: {
            boxSize: 1.5,
            borderRadius: "full",
            bg: "icon.tertiary",
        },
        stepLabel: {
            minWidth: 0,
            flex: 1,
            color: "text.primary",
            '&[data-step-status="pending"]': {
                color: "text.tertiary",
            },
        },
        stepMeta: {
            flex: "none",
            color: "text.tertiary",
            fontVariantNumeric: "tabular-nums",
        },
        textRow: {
            borderRadius: "md",
            px: 1.5,
            py: 1,
            color: "text.secondary",
        },
        searchRow: {
            display: "flex",
            flexDirection: "column",
            rowGap: 0.5,
        },
        searchQueryIcon: {
            flex: "none",
            boxSize: 4,
        },
        searchQuery: {
            display: "flex",
            alignItems: "center",
            minHeight: 7,
            columnGap: 2.5,
            borderRadius: "md",
            px: 1.5,
            py: 1,
            color: "text.secondary",
        },
        searchQueryText: {
            minWidth: 0,
            ...truncate,
        },
        searchResults: {
            display: "flex",
            flexDirection: "column",
            rowGap: 0.5,
            pl: 4,
        },
        searchResult: {
            display: "flex",
            alignItems: "center",
            minHeight: 7,
            columnGap: 2,
            borderRadius: "md",
            px: 1.5,
            py: 1,
            textAlign: "left",
            textDecoration: "none",
            color: "inherit",
            outline: "none",
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        searchResultIcon: {
            flex: "none",
            boxSize: 5,
            display: "grid",
            placeItems: "center",
            color: "icon.tertiary",
        },
        searchResultTitle: {
            minWidth: 0,
            fontWeight: "medium",
            color: "text.primary",
            ...truncate,
        },
        searchResultDomain: {
            minWidth: 0,
            color: "text.tertiary",
            ...truncate,
        },
        searchMore: {
            px: 1.5,
            py: 1,
            pl: 8,
            color: "text.tertiary",
        },
        // Fixed tracks so verbs, targets, and trailing diffs align across rows;
        // the diff track is reserved even when a row has none.
        toolRow: {
            ...rowShell,
            gridTemplateColumns: "1rem 4.5rem minmax(0, 1fr) 4rem",
            minWidth: 0,
        },
        toolIcon: rowIcon,
        toolAction: rowLabel,
        toolDiff: {
            display: "flex",
            alignItems: "center",
            justifySelf: "end",
            columnGap: 2,
            textStyle: "mono",
            fontVariantNumeric: "tabular-nums",
        },
        toolAdditions: {
            color: "text.success",
        },
        toolDeletions: {
            color: "text.danger",
        },
        // The label track matches toolRow's verb track so both row kinds read as
        // one table.
        traceRow: {
            ...rowShell,
            gridTemplateColumns: "1rem 4.5rem minmax(0, 1fr)",
        },
        traceIcon: rowIcon,
        traceLabel: rowLabel,
        monoChip: {
            minWidth: 0,
            borderRadius: "lg",
            bg: "base.background",
            px: 2.5,
            py: 1,
            textStyle: "mono",
            fontSize: "sm",
            color: "text.tertiary",
            ...truncate,
        },
    },
};

const textTheme = {
    variants: {
        numeric: {
            textStyle: "numeric",
        },
        monospace: {
            textStyle: "mono",
        },
    },
    sizes: {
        lg: {
            fontSize: "lg",
            lineHeight: "6",
        },
        md: {
            fontSize: "md",
            lineHeight: "5",
        },
        sm: {
            fontSize: "sm",
            lineHeight: "4",
        },
    },
    defaultProps: {
        size: "md",
    },
};

const alertTheme = {
    parts: [
        "container",
        "innerContainer",
        "iconContainer",
        "contentContainer",
        "titleContainer",
        "title",
        "contextMessage",
        "message",
        "buttonGroup",
        "closeButton",
    ],
    baseStyle: ({ colorScheme, variant }) => {
        const isBanner = variant === "banner";
        const isSubtle = colorScheme === "subtle";
        return {
            container: {
                display: "flex",
                alignItems: isBanner ? "center" : "start",
                gap: 3,
                color: `${colorScheme}.text`,
                bg: `${colorScheme}.background`,
                border: `${$borderHairline.reference} solid`,
                borderColor: isSubtle ? "base.border" : `${colorScheme}.border`,
                borderRadius: "xl",
                px: 4,
                py: 4,
            },
            iconContainer: {
                display: "flex",
                fontSize: "3xl",
                flex: "none",
                svg: {
                    color: isSubtle ? "text.tertiary" : `${colorScheme}.base`,
                },
            },
            contentContainer: {
                display: "flex",
                flexDirection: isBanner ? "row" : "column",
                alignItems: isBanner ? "center" : "start",
                justifyContent: isBanner ? "space-between" : undefined,
                flex: "1",
                minWidth: 0,
                gap: 2,
            },
            titleContainer: {
                display: "flex",
                width: isBanner ? "auto" : "100%",
                justifyContent: "space-between",
                alignItems: "baseline",
            },
            title: {
                ...textTheme.sizes.md,
                fontWeight: "semibold",
                py: 0.5,
            },
            contextMessage: {
                fontSize: "sm",
            },
            message: {
                color: "inherit",
                flex: "1",
                minWidth: 0,
            },
            buttonGroup: {
                mt: isBanner ? 0 : 2,
                ml: isBanner ? 2 : 0,
            },
            closeButton: {
                button: {
                    svg: {
                        color: `${colorScheme}.base`,
                    },
                    _hover: {
                        bg: `${colorScheme}.backgroundHover`,
                        svg: {
                            color: `${colorScheme}.hover`,
                        },
                    },
                    _active: {
                        color: `${colorScheme}.900`,
                        bg: `${colorScheme}.200`,
                        svg: {
                            color: `${colorScheme}.hover`,
                        },
                    },
                    _focusVisible: {
                        shadow: colorScheme === "danger" ? "outlineRed" : "outline",
                    },
                },
            },
        };
    },
    variants: {
        inline: (props) => {
            return alertTheme.baseStyle(props);
        },
        banner: (props) => {
            return alertTheme.baseStyle(props);
        },
    },
    defaultProps: {
        variant: "inline",
        colorScheme: "info",
        justify: "left",
    },
};

const askUserCardTheme = {
    parts: ["nav", "navSlot", "counter", "question", "options", "skipAll"],
    baseStyle: {
        nav: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            flex: "none",
        },
        // Keeps its width when the chevron hides, so the counter never shifts.
        // Visibility drops the hidden button from the tab order.
        navSlot: {
            display: "flex",
            transitionProperty: "opacity, visibility",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            "&[data-hidden]": {
                opacity: 0,
                visibility: "hidden",
            },
        },
        counter: {
            display: "flex",
            alignItems: "center",
            flex: "none",
        },
        question: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
        },
        options: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
        },
        // Quietest action on the far left, apart from the advance action.
        // Flex, so the inline-flex button sets the height, not a line box.
        skipAll: {
            display: "flex",
            mr: "auto",
        },
    },
};

// box-shadow never transitions, so the selected shadow fades on a pseudo-element instead.
const selectedShadow = {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "inherit",
    boxShadow: "sm",
    opacity: 0,
    pointerEvents: "none",
    transitionProperty: "opacity",
    transitionDuration: "fast",
    transitionTimingFunction: "easeOutQuad",
};
const askUserCardOptionTheme = {
    parts: ["root", "row", "content", "check", "customRow", "customCheck"],
    baseStyle: {
        root: {
            display: "block",
            width: "100%",
        },
        // The hidden input projects its state here as data attributes.
        row: {
            position: "relative",
            display: "flex",
            alignItems: "flex-start",
            gap: 3,
            width: "100%",
            p: 3,
            borderRadius: "3xl",
            bg: $surfaceAgentCardRowBg.reference,
            cursor: "pointer",
            transitionProperty: "background-color",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            // Only enabled rows respond to hover.
            "&:not([data-disabled]):hover, &:not([data-disabled])[data-hover]": {
                bg: $surfaceAgentCardRowBgHover.reference,
            },
            _after: selectedShadow,
            _checked: {
                bg: "white",
                _hover: {
                    bg: "white",
                },
                _after: {
                    opacity: 1,
                },
            },
            _focusVisible: {
                boxShadow: "outline",
            },
            // Disabled keeps the fill and grays the text, like Figma's disabled custom answer row.
            _disabled: {
                cursor: "not-allowed",
            },
        },
        content: {
            display: "flex",
            flexDirection: "column",
            gap: 1,
            flex: 1,
            minWidth: 0,
            "[data-disabled] > & > *": {
                color: "text.disabled",
            },
        },
        check: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSize: 5,
            flex: "none",
            borderRadius: "full",
            // 1px fixed: a hairline selection ring reads invisible on 2x displays.
            border: "1px solid",
            borderColor: "base.borderHover",
            bg: "transparent",
            color: "white",
            transitionProperty: "border-color, background-color",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            "&[data-multiple]": {
                borderRadius: "md",
            },
            "&[data-checked]": {
                bg: "primary.base",
                borderColor: "primary.base",
            },
            // Gray only in a disabled card; a submitting card keeps the blue check.
            "[data-card-disabled] &[data-checked]": {
                bg: "icon.disabled",
                borderColor: "icon.disabled",
            },
            svg: {
                boxSize: 3,
            },
        },
        // The row is the input: the text area drops its chrome and the row carries the states, like a chosen option row.
        customRow: {
            position: "relative",
            width: "100%",
            // On the row, not the text area, so scrolled lines never reach the top or bottom edge.
            py: 2.5,
            cursor: "text",
            borderRadius: "3xl",
            bg: $surfaceAgentCardRowBg.reference,
            transitionProperty: "background-color",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            "&:not([data-disabled]):hover": {
                bg: $surfaceAgentCardRowBgHover.reference,
            },
            _after: selectedShadow,
            _checked: {
                bg: "white",
                _hover: {
                    bg: "white",
                },
                _after: {
                    opacity: 1,
                },
            },
            // White follows only the text area's focus, which is Figma's Focused state.
            "&:has(textarea:focus)": {
                bg: "white",
                _hover: {
                    bg: "white",
                },
            },
            // The reselect control draws its own ring.
            "&:has(textarea:focus-visible)": {
                boxShadow: "outline",
            },
            // Figma's Disabled row keeps its fill and grays only the text.
            _disabled: {
                cursor: "not-allowed",
            },
            // Room for the reselect control, so long text doesn't run under it.
            "&[data-reselect] textarea": {
                pr: 12,
            },
            // No height rules: the row governs; a forced height clips and scrolls.
            textarea: {
                width: "100%",
                px: 3,
                py: 0,
                lineHeight: 5,
                bg: "transparent",
                border: "none",
                boxShadow: "none",
                // Inherits the row's radius: an own background paints at the wrong radius inside the rounder row.
                borderRadius: "inherit",
                _hover: {
                    bg: "transparent",
                },
                _focus: {
                    bg: "transparent",
                    boxShadow: "none",
                    border: "none",
                },
                _focusVisible: {
                    bg: "transparent",
                    boxShadow: "none",
                    border: "none",
                },
                // The row carries the disabled look.
                _disabled: {
                    opacity: 1,
                    bg: "transparent",
                    color: "text.disabled",
                    _placeholder: {
                        color: "text.disabled",
                    },
                },
            },
        },
        // Sits over the text area's reserved gutter: puts retained text back in play.
        customCheck: {
            position: "absolute",
            top: 3,
            right: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "full",
            cursor: "pointer",
            outline: "none",
            "&[hidden]": {
                display: "none",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
    },
};

const headingTheme = {
    sizes: {
        "heading-md": {
            fontFamily: "heading",
            fontWeight: "semibold",
            fontSize: "xl",
            lineHeight: "6",
            letterSpacing: "-0.02em",
        },
        "heading-lg": {
            fontFamily: "heading",
            fontWeight: "semibold",
            fontSize: "2xl",
            lineHeight: "6",
            letterSpacing: "-0.02em",
        },
        "heading-xl": {
            fontFamily: "heading",
            fontWeight: "semibold",
            fontSize: "3xl",
            lineHeight: "8",
            letterSpacing: "-0.02em",
        },
        "heading-2xl": {
            fontFamily: "heading",
            fontWeight: "semibold",
            fontSize: "4xl",
            lineHeight: "12",
        },
        "upsell-md": {
            fontSize: "xl",
            lineHeight: "6",
        },
        "upsell-lg": {
            fontSize: "2xl",
            lineHeight: "6",
        },
        "upsell-xl": {
            fontSize: "3xl",
            lineHeight: "8",
        },
        "upsell-2xl": {
            fontSize: "4xl",
            lineHeight: "12",
        },
    },
    variants: {
        heading: {
            color: "text.primary",
        },
        numeric: {
            textStyle: "numeric",
        },
        monospace: {
            fontFamily: "mono",
            textStyle: "mono",
            fontWeight: "medium",
        },
        section: {
            fontFamily: "heading",
            fontSize: "lg",
            lineHeight: "6",
            fontWeight: "semibold",
            color: "text.primary",
        },
        upsell: {
            fontFamily: "heading",
            fontWeight: "medium",
            color: "upsell.dark",
        },
    },
};

// The auto-growth input and text area is a bit of a hack.
// `fieldSizing` is not supported on Firefox and Safari yet.
// To deal with this, we use a grid layout to handle the auto-sizing.
// By injecting the text in a pseudo element, we can use the `content` property
// to get the width of the text.
// These styles need to be the same so that the trick works.
// The `:after` pseudo element is used to get the width of the text,
// so the text's styles need to be the same.
const sharedStyles = {
    minWidth: "64px",
    maxWidth: "100%",
    borderBottom: "1px solid",
    borderColor: "primary.base",
    borderTop: "1px solid transparent", // Add top border for even displacement
    _placeholder: {
        color: "text.placeholder",
    },
    px: 0,
    outline: "none !important",
    overflow: "hidden",
    background: "transparent",
    // 'field-sizing' does not work on Firefox and Safari yet
    // Once Firefox and Safari support this, we can remove the special grid styling that
    // handles auto-sizing the input and textarea.
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1832409
    // https://bugs.webkit.org/show_bug.cgi?id=264720
    fieldSizing: "content",
    /* Place on top of each other */
    gridArea: "1 / 1 / 2 / 2",
};
const colorSchemeStyles = {
    warning: {
        borderColor: "warning.800",
        _placeholder: {
            color: "blackAlpha.40",
        },
        color: "warning.pressed",
    },
};
const autoWidthInputTheme = {
    baseStyle: ({ colorScheme, hideUnderline }) => {
        // Drop the color, keep the border: same box either way.
        const borderColor = hideUnderline
            ? "transparent"
            : colorScheme === "warning"
                ? colorSchemeStyles.warning.borderColor
                : sharedStyles.borderColor;
        return {
            display: "none",
            overflow: "hidden",
            _after: {
                /* Note the weird space! Needed to preventy jumpy behavior */
                content: `attr(data-replicated-value) " "`,
                whiteSpace: "nowrap",
                /* Hidden from view, clicks, and screen readers */
                visibility: "hidden",
                ...sharedStyles,
                ...(colorScheme === "warning" ? colorSchemeStyles.warning : {}),
                borderColor,
            },
            textarea: {
                resize: "none",
            },
            "input, textarea": {
                ...sharedStyles,
                borderColor,
            },
        };
    },
    variants: {
        textarea({ colorScheme, isEditing, width }) {
            const commonStyles = {
                ...textTheme.sizes.md,
                color: colorScheme === "warning"
                    ? colorSchemeStyles.warning.color
                    : "text.secondary",
                fontWeight: "normal",
            };
            return {
                display: isEditing ? "grid" : "none",
                width,
                _after: {
                    ...commonStyles,
                    /* This is how textarea text behaves */
                    whiteSpace: "pre-wrap",
                },
                textarea: {
                    ...commonStyles,
                    display: isEditing ? "inline-block" : "none",
                },
            };
        },
        text({ colorScheme, isEditing, fontWeight, size, width, }) {
            const commonStyles = {
                ...textTheme.sizes[size ?? "md"],
                fontWeight,
            };
            return {
                display: isEditing ? "grid" : "none",
                width,
                _after: commonStyles,
                input: {
                    ...commonStyles,
                    display: isEditing ? "inline-block" : "none",
                },
            };
        },
        heading({ colorScheme, isEditing, size, width, }) {
            const commonStyles = {
                ...headingTheme.sizes[size ? `heading-${size}` : "heading-md"],
                fontWeight: "semibold",
            };
            return {
                display: isEditing ? "grid" : "none",
                width,
                _after: commonStyles,
                input: {
                    ...commonStyles,
                    display: isEditing ? "inline-block" : "none",
                },
            };
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const avatarTheme = {
    parts: ["container", "expandedTooltip"],
    baseStyle: {
        container: {
            bg: "base.background",
            border: `${$borderHairline.reference} solid`,
            borderColor: "base.border!",
        },
        label: {
            color: "inherit",
            userSelect: "none",
            fontSize: "inherit",
            lineHeight: "normal",
        },
        expandedTooltip: {
            display: "flex",
            flexDirection: "column",
            gap: 2,
            justifyContent: "start",
            p: 0.5,
            ".tooltipContainer": {
                display: "flex",
                gap: 1,
                align: "center",
            },
            ".primaryLabel": {
                color: "white",
            },
            ".secondaryLabel": {
                color: "whiteAlpha.60",
            },
        },
    },
    variants: {
        teal: {
            container: {
                bg: "teal.100",
                borderColor: "teal.300!",
                color: "teal.700",
            },
        },
        indigo: {
            container: {
                bg: "indigo.100",
                borderColor: "indigo.300!",
                color: "indigo.700",
            },
        },
        orange: {
            container: {
                bg: "orange.100",
                borderColor: "orange.300!",
                color: "orange.700",
            },
        },
        blue: {
            container: {
                bg: "blue.100",
                borderColor: "blue.300!",
                color: "blue.700",
            },
        },
        green: {
            container: {
                bg: "green.100",
                borderColor: "green.300!",
                color: "green.700",
            },
        },
        pink: {
            container: {
                bg: "pink.100",
                borderColor: "pink.300!",
                color: "pink.700",
            },
        },
    },
    // Make sure line height updates are copied to the exported avatar variables in foundations!
    sizes: {
        sm: {
            container: {
                width: 5,
                height: 5,
                fontSize: "8px",
                lineHeight: 5,
            },
        },
        md: {
            container: {
                width: 6,
                height: 6,
                fontSize: "10px",
                lineHeight: 6,
            },
        },
        lg: {
            container: {
                width: 8,
                height: 8,
                fontSize: "13px",
                lineHeight: 8,
            },
        },
        xl: {
            container: {
                width: 10,
                height: 10,
                fontSize: "16px",
                // No "10" line-height token exists, so reuse the exported avatar value
                lineHeight: "avatarXl",
            },
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
// Not `base.backgroundDisabled` (gray.200) like the rest of the system: badge's disabled
// state is darker, and changing how it looks is a design call, not this file's.
const disabledBackground = "gray.300";
// `BadgeButton` renders `Badge as={Button}`, so the Button theme's interaction backgrounds reach it.
const keepVariantBackground = (styles) => ({
    ...styles,
    // Doubled selectors beat the Button theme's rules regardless of Emotion insertion order.
    "&&:hover, &&:focus, &&:active, &&[data-active]": {
        bg: styles.bg,
        // Interaction states serialize after the base `_disabled`, so each restates the guard.
        _disabled: { ...styles._disabled, bg: disabledBackground },
    },
    // A menu holds `data-active` while open; a real press is `:active`.
    "&&[data-active]": { transform: "none" },
});
const badgeTheme = {
    baseStyle: {
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        border: `${$borderHairline.reference} solid`,
        borderColor: "base.border",
        borderRadius: "full",
        maxW: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "none",
        whiteSpace: "nowrap",
        width: "fit-content",
        fontSize: "md",
        fontWeight: "medium",
        lineHeight: "5",
        justifyContent: "center",
        _disabled: {
            bg: disabledBackground,
        },
        _focus: {
            bg: disabledBackground,
        },
        "& > .chakra-text, & > .badgeLabel > .chakra-text": {
            color: "inherit",
        },
        ".rightIcon": {
            fontSize: "16px",
        },
        // The label keeps the badge's 4px rhythm; the X sits 1px after it.
        '&[data-has-right-action="true"]': {
            columnGap: "px",
            paddingInlineEnd: "calc(var(--chakra-space-1) - var(--chakra-space-px))",
            "& > .badgeLabel": {
                display: "inline-flex",
                alignItems: "center",
                columnGap: 1,
                minWidth: 0,
            },
            "& > button": {
                marginInlineStart: 0,
                // The badge clips overflow, so the ring is drawn inside the X.
                _after: {
                    content: '""',
                    position: "absolute",
                    inset: 0.5,
                    borderRadius: "full",
                    pointerEvents: "none",
                },
                _focusVisible: {
                    boxShadow: "none",
                    _after: { boxShadow: "outlineInset" },
                },
            },
        },
        '&[data-shape="circle"]': {
            px: 0,
        },
        '&[data-shape="rectangle"]': {
            borderRadius: "sm",
        },
        '&[data-pending="true"]': {
            borderStyle: "dashed",
            borderWidth: "1px",
        },
    },
    sizes: {
        sm: {
            height: "5",
            minWidth: "5",
            px: "6px",
            '&[data-has-right-action="true"]': {
                // A 2px inset leaves the 16px X too small a hole for its glyph.
                "& > button::after": { inset: "px" },
            },
            "& > .chakra-text, & > .badgeLabel > .chakra-text": {
                fontSize: "sm",
                fontWeight: "normal",
                lineHeight: "4",
            },
            ".rightIcon": {
                fontSize: "16px",
            },
            '&[data-shape="circle"]': {
                fontSize: "12px",
            },
        },
        md: {
            height: "6",
            minWidth: "6",
            px: 2,
            ".rightIcon": {
                fontSize: "20px",
            },
            '&[data-shape="circle"]': {
                fontSize: "16px",
            },
        },
        lg: {
            height: "7",
            minWidth: "7",
            px: 3,
            ".rightIcon": {
                fontSize: "24px",
            },
            '&[data-shape="circle"]': {
                fontSize: "20px",
            },
        },
    },
    variants: {
        subtle: keepVariantBackground({
            bg: "base.background",
            color: "text.secondary",
        }),
        info: keepVariantBackground({
            bg: "primary.background",
            color: "primary.base",
            borderColor: "primary.border",
        }),
        success: keepVariantBackground({
            bg: "success.background",
            color: "text.success",
            borderColor: "success.border",
        }),
        warning: keepVariantBackground({
            bg: "warning.background",
            color: "text.warning",
            borderColor: "warning.border",
        }),
        error: keepVariantBackground({
            bg: "danger.background",
            color: "text.danger",
            borderColor: "danger.border",
        }),
        upsell: keepVariantBackground({
            bg: "purple.100",
            color: "text.upsell",
            borderColor: "upsell.border",
        }),
        ghost: keepVariantBackground({
            bg: "white",
            color: "text.tertiary",
            borderColor: "base.border",
        }),
        accent: keepVariantBackground({
            bg: "pink.background",
            color: "pink.base",
            borderColor: "pink.border",
        }),
    },
    defaultProps: {
        size: "md",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const badgeInputTheme = {
    parts: [
        "badgeInput",
        "badges",
        "badgeGroupLabel",
        "badgeValueLabel",
        "input",
        "inputContainer",
        "toggleButton",
        "toggleButtonIcon",
        "spinnerContainer",
    ],
    baseStyle: {
        badgeInput: {
            display: "flex",
            gap: 2,
            backgroundColor: $surfaceBg.reference,
            borderWidth: "hairline",
            borderColor: "base.border",
            borderRadius: "lg",
            boxShadow: "buttonShadowLight",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, border-color, color",
            maxWidth: "100%",
            color: "text.primary",
            svg: {
                color: "text.placeholder",
            },
            _hover: {
                borderColor: $surfaceBorderHover.reference,
                backgroundColor: $surfaceBgHover.reference,
                svg: {
                    color: "text.secondary",
                },
            },
            _expanded: {
                backgroundColor: $surfaceBgHover.reference,
                borderColor: "primary.base",
                _hover: {
                    borderColor: "primary.base",
                },
            },
            _disabled: {
                backgroundColor: "base.backgroundDisabled",
                cursor: "not-allowed",
                color: "text.disabled",
                boxShadow: "none",
                borderColor: "base.borderDisabled",
                svg: {
                    color: "gray.400",
                },
                _selected: {
                    color: "text.disabled",
                },
                _hover: {
                    borderColor: "transparent",
                    backgroundColor: "base.backgroundDisabled",
                    svg: {
                        color: "gray.400",
                    },
                },
            },
            _loading: {
                cursor: "wait",
            },
            _invalid: {
                borderColor: "danger.base",
                _hover: {
                    borderColor: "danger.base",
                },
            },
            // Override app styles
            _focus: {
                outline: "none !important",
            },
            "&[data-focus-visible]": {
                boxShadow: "outline",
            },
        },
        badges: {
            flex: "1",
            minWidth: 0,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 1,
            px: 2,
            py: 1,
            '& [data-invalid="true"][data-has-right-action="true"] > button': {
                svg: { color: "icon.danger" },
                _hover: {
                    // The pill is already `danger.background`, so the X hover steps one rung up.
                    bg: "danger.backgroundHover",
                    svg: { color: "danger.hover" },
                },
                _focusVisible: {
                    // `outlineRed` spreads outward, and a 2px inset keeps it inside the clipped pill at both sizes.
                    _after: { inset: 0.5, boxShadow: "outlineRed" },
                },
            },
        },
        badgeGroupLabel: {
            color: "text.tertiary",
            fontWeight: "normal",
        },
        badgeValueLabel: {
            color: "text.primary",
            fontWeight: "medium",
        },
        inputContainer: {
            flex: "1",
            display: "flex",
            ml: -1,
        },
        input: {
            width: "100%",
            height: "100%",
            bg: "transparent",
            outline: "none",
            px: 2,
            color: "inherit",
            cursor: "inherit",
            _placeholder: {
                color: "text.placeholder",
            },
        },
        toggleButton: {
            display: "flex",
            alignItems: "center",
            pr: 2,
            // Override app styles
            _focus: {
                outline: "none !important",
            },
            _disabled: {
                cursor: "not-allowed",
            },
        },
        toggleButtonIcon: {
            color: "text.secondary",
        },
        spinnerContainer: {
            display: "flex",
            alignItems: "center",
            mr: 2,
        },
    },
    sizes: {
        sm: {
            badgeInput: {
                minHeight: 6,
            },
            badges: {
                // A 20px badge plus this inset plus the outer hairline border must equal the 24px
                // min-height, or the row overruns it and the control renders taller than its size.
                py: `calc(var(--chakra-space-0-5) - ${$borderHairline.reference})`,
            },
            inputContainer: {
                h: 5,
            },
            input: {
                fontSize: "sm",
            },
            toggleButtonIcon: {
                boxSize: 4,
            },
        },
        md: {
            badgeInput: {
                minHeight: 8,
            },
            badges: {
                // A 24px badge plus this inset plus the outer hairline border must equal the 32px
                // min-height, or the first selected badge grows the control by the border width.
                py: `calc(var(--chakra-space-1) - ${$borderHairline.reference})`,
            },
            inputContainer: {
                h: 5,
            },
            input: {
                fontSize: "md",
            },
            toggleButtonIcon: {
                boxSize: 5,
            },
        },
        lg: {
            badgeInput: {
                minHeight: 10,
            },
            inputContainer: {
                // The md badges' height, so the row the input shares keeps the 4px row gap.
                h: 6,
            },
            input: {
                // Matches the md badges the lg control renders, not the lg text input.
                fontSize: "md",
            },
            toggleButtonIcon: {
                boxSize: 6,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const item = {
    display: "flex",
    alignItems: "center",
    gap: 1,
    minWidth: 0,
    // A long page name shrinks before ancestors, so it cannot crush a short root.
    // The floor returns leftover deficit to ancestors, so a too-wide root still ellipsizes.
    "&[data-current]": {
        flexShrink: 9999,
        minWidth: 8,
    },
    "&[data-hidden]": {
        position: "absolute",
        visibility: "hidden",
        pointerEvents: "none",
        width: "max-content",
        maxWidth: "100%",
        overflow: "hidden",
    },
};
const label = {
    display: "flex",
    minWidth: 0,
    fontWeight: "normal",
    color: "text.primary",
};
const breadcrumbsTheme = {
    parts: [
        "container",
        "list",
        "item",
        "overflowItem",
        "label",
        "labelContent",
        "link",
        "iconContainer",
        "icon",
        "separator",
        "menuItems",
        "menuIcon",
    ],
    baseStyle: {
        container: {
            position: "relative",
            minWidth: 0,
            width: "100%",
            borderRadius: "sm",
            outline: "none",
            _focusVisible: { boxShadow: "outline" },
        },
        list: {
            display: "flex",
            alignItems: "center",
            gap: 1,
            listStyleType: "none",
            m: 0,
            p: 0,
        },
        item,
        overflowItem: { ...item, flexShrink: 0 },
        label,
        labelContent: {
            whiteSpace: "nowrap",
        },
        link: {
            ...label,
            color: "text.secondary",
            borderRadius: "sm",
            cursor: "pointer",
            textDecoration: "none",
            outline: "none",
            _hover: { color: "primary.text", textDecoration: "none" },
            _focusVisible: { boxShadow: "outline" },
        },
        iconContainer: {
            display: "inline-flex",
            alignItems: "center",
            height: "1lh",
            verticalAlign: "top",
            mr: 1,
        },
        icon: {
            boxSize: 3,
            flexShrink: 0,
            color: "text.tertiary",
            _groupHover: { color: "primary.text" },
        },
        separator: { boxSize: 3, flexShrink: 0, color: "text.disabled" },
        menuItems: { maxHeight: 64, overflowY: "auto" },
        menuIcon: {
            boxSize: 4,
            flexShrink: 0,
            color: "text.tertiary",
            _groupHover: { color: "text.primary" },
        },
    },
};

// @designs: https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Hightouch-UI?node-id=8434-30487
const iconButtonPrimary = {
    bg: "primary.base",
    color: "white",
    boxShadow: "buttonShadow",
    _hover: {
        bg: "primary.hover",
        _disabled: {
            bg: "base.backgroundDisabled",
            color: "text.disabled",
        },
    },
    _disabled: {
        bg: "base.backgroundDisabled",
        color: "text.disabled",
        boxShadow: "none",
        cursor: "not-allowed",
    },
    // `_active` serializes after `_disabled`, so keyboard-pressing an
    // aria-disabled button would otherwise flash primary.pressed.
    _active: {
        bg: "primary.pressed",
        _disabled: {
            bg: "base.backgroundDisabled",
        },
    },
    _focusVisible: {
        boxShadow: "outline",
    },
};
const buttonTheme = {
    sizes: {
        "2xs": {
            h: 4,
            fontSize: "sm",
            lineHeight: "2",
            px: 1.5,
            borderRadius: "xs",
        },
        xs: {
            h: 5,
            fontSize: "sm",
            lineHeight: "3",
            px: 2,
            borderRadius: "xs",
        },
        sm: {
            h: 6,
            fontSize: "sm",
            lineHeight: "4",
            px: 2,
            borderRadius: "md",
        },
        md: {
            h: 8,
            fontSize: "md",
            lineHeight: "5",
            px: 3,
            borderRadius: "lg",
        },
        lg: {
            h: 10,
            fontSize: "lg",
            lineHeight: "6",
            px: 3,
            borderRadius: "xl",
        },
        xl: {
            h: 12,
            fontSize: "lg",
            lineHeight: "6",
            px: 4,
            borderRadius: "2xl",
        },
    },
    baseStyle: {
        fontWeight: "medium",
        transitionDuration: "fast",
        transitionTimingFunction: "easeOutQuad",
        transitionProperty: "background-color, color, border-color, transform",
        svg: {
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "color",
        },
        '&[aria-expanded="true"]': {
            boxShadow: "outline",
        },
        _active: {
            transform: "scale(0.98)",
            _disabled: {
                transform: "none",
            },
        },
        _focus: {
            // Override app styles
            outline: "none !important",
        },
        _disabled: {
            opacity: 1,
        },
    },
    variants: {
        solid({ colorScheme }) {
            const background = `${colorScheme}.base`;
            const hoverBackground = `${colorScheme}.hover`;
            const disabledBackground = "base.backgroundDisabled";
            const activeBackground = `${colorScheme}.pressed`;
            return {
                bg: background,
                boxShadow: "buttonShadow",
                '&[aria-expanded="true"]': {
                    boxShadow: colorScheme === "danger"
                        ? "var(--chakra-shadows-outlineRed)"
                        : "outline",
                },
                _hover: {
                    bg: hoverBackground,
                    _disabled: {
                        bg: disabledBackground,
                        color: "text.disabled",
                    },
                },
                _disabled: {
                    bg: disabledBackground,
                    color: "text.disabled",
                    boxShadow: "none",
                    filter: "none",
                },
                // `_active` serializes after `_disabled`, so keyboard-pressing an
                // aria-disabled button would otherwise flash the pressed color.
                _active: {
                    bg: activeBackground,
                    _disabled: {
                        bg: disabledBackground,
                    },
                },
                _focusVisible: {
                    boxShadow: colorScheme === "danger"
                        ? "var(--chakra-shadows-outlineRed)"
                        : "outline",
                },
            };
        },
        upsell: {
            bg: "upsell.base",
            boxShadow: "buttonShadow",
            color: "white",
            _hover: {
                bg: "upsell.hover",
                _disabled: {
                    bg: "upsell.disabled",
                },
            },
            _disabled: {
                bg: "upsell.disabled",
            },
            _active: {
                bg: "upsell.dark",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        outline({ colorScheme }) {
            if (colorScheme === "clear") {
                return {
                    bg: "base.lightBackground",
                    color: "text.primary",
                    borderWidth: "hairline",
                    borderColor: "base.border",
                    boxShadow: "buttonShadowLight",
                    svg: { color: "icon.secondary" },
                    _hover: {
                        color: "text.primary",
                        borderColor: "base.borderHover",
                        bg: "white",
                        svg: { color: "icon.primary" },
                    },
                    _active: {
                        color: "text.primary",
                        borderColor: "base.borderHover",
                        bg: "base.background",
                        svg: { color: "icon.primary" },
                    },
                    _disabled: {
                        color: "text.disabled",
                        bg: "white",
                        boxShadow: "none",
                        filter: "none",
                        borderColor: "base.borderDisabled",
                        svg: { color: "icon.disabled" },
                        _hover: {
                            bg: "white",
                            color: "text.disabled",
                            borderColor: "base.borderDisabled",
                            cursor: "not-allowed",
                            svg: { color: "icon.disabled" },
                        },
                        _active: {
                            color: "text.disabled",
                            bg: "white",
                            borderColor: "base.borderDisabled",
                            cursor: "not-allowed",
                            svg: { color: "icon.disabled" },
                        },
                    },
                };
            }
            if (colorScheme === "danger") {
                return {
                    color: "danger.base",
                    borderColor: "danger.base",
                    bg: "danger.background",
                    borderWidth: "hairline",
                    boxShadow: "buttonShadowLight",
                    '&[aria-expanded="true"]': {
                        boxShadow: "outlineRed",
                    },
                    _hover: {
                        borderColor: "danger.hover",
                        color: "danger.hover",
                        bg: "danger.backgroundHover",
                    },
                    _active: {
                        borderColor: "danger.pressed",
                        color: "danger.hover",
                        bg: "danger.backgroundHover",
                    },
                    _disabled: {
                        filter: "none",
                        color: "text.disabled",
                        bg: "white",
                        boxShadow: "none",
                        borderColor: "base.borderDisabled",
                        _hover: {
                            borderColor: "base.borderDisabled",
                            color: "text.disabled",
                            bg: "white",
                        },
                        _active: {
                            borderColor: "base.borderDisabled",
                            color: "text.disabled",
                            bg: "white",
                        },
                    },
                    _focusVisible: {
                        boxShadow: "outlineRed",
                    },
                };
            }
            return {
                color: "text.primary",
                borderColor: "base.border",
                bg: "white",
                _hover: {
                    color: "text.primary",
                },
                _focusVisible: {
                    boxShadow: "outline",
                },
            };
        },
        ghost({ colorScheme }) {
            if (colorScheme === "clear") {
                return {
                    color: "text.primary",
                    bg: "transparent",
                    boxShadow: "none",
                    svg: {
                        color: "icon.secondary",
                    },
                    _hover: {
                        color: "text.primary",
                        bg: "base.backgroundHover",
                        svg: { color: "icon.primary" },
                    },
                    _active: {
                        color: "text.primary",
                        bg: "base.backgroundPressed",
                        svg: { color: "icon.primary" },
                    },
                    _disabled: {
                        color: "text.disabled",
                        bg: "transparent",
                        svg: { color: "icon.disabled" },
                        _hover: {
                            bg: "transparent",
                            color: "text.disabled",
                            cursor: "not-allowed",
                            boxShadow: "none",
                            svg: { color: "icon.disabled" },
                        },
                        _active: {
                            color: "text.disabled",
                            bg: "transparent",
                            boxShadow: "none",
                            cursor: "not-allowed",
                            svg: { color: "icon.disabled" },
                        },
                    },
                };
            }
            if (colorScheme === "danger") {
                return {
                    color: "danger.base",
                    bg: "transparent",
                    boxShadow: "none",
                    svg: {
                        color: "icon.danger",
                    },
                    '&[aria-expanded="true"]': {
                        boxShadow: "outlineRed",
                    },
                    _hover: {
                        color: "danger.hover",
                        bg: "danger.background",
                        svg: {
                            color: "danger.hover",
                        },
                    },
                    _active: {
                        color: "danger.pressed",
                        bg: "danger.backgroundHover",
                        svg: {
                            color: "danger.pressed",
                        },
                    },
                    _focusVisible: {
                        shadow: "outlineRed",
                    },
                    _disabled: {
                        color: "text.disabled",
                        bg: "transparent",
                        svg: { color: "icon.disabled" },
                        _hover: {
                            color: "text.disabled",
                            cursor: "not-allowed",
                            svg: { color: "icon.disabled" },
                        },
                        _active: {
                            color: "text.disabled",
                            bg: "transparent",
                            cursor: "not-allowed",
                            svg: { color: "icon.disabled" },
                        },
                    },
                };
            }
            return {
                boxShadow: "sm",
                _disabled: {
                    filter: "none",
                },
            };
        },
        iconButtonPrimary,
    },
};

const checkboxTheme = {
    parts: ["control"],
    sizes: {
        md: {
            control: {
                width: 4,
                height: 4,
            },
            icon: {
                fontSize: "9px",
            },
        },
    },
    baseStyle: {
        control: {
            borderRadius: "5px",
            borderWidth: "0.75px",
            borderColor: "gray.400",
            boxShadow: "xs",
            transitionProperty: "background-color, border-color, color",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutCubic",
            bg: "white",
            _focusVisible: {
                boxShadow: "outline",
            },
            _hover: {
                borderColor: "gray.500",
                bg: "gray.100",
                _disabled: {
                    borderColor: "gray.400",
                    bg: "gray.100",
                    boxShadow: "none",
                },
            },
            _checked: {
                bg: "primary.base",
                borderColor: "primary.base",
                color: "white",
                _disabled: {
                    bg: "gray.300",
                    color: "text.disabled",
                    borderColor: "gray.200",
                    boxShadow: "none",
                },
                _hover: {
                    bg: "primary.base",
                    _disabled: {
                        bg: "gray.300",
                        color: "text.disabled",
                        borderColor: "gray.200",
                        boxShadow: "none",
                    },
                },
            },
            _indeterminate: {
                bg: "primary.base",
                borderColor: "primary.base",
                color: "white",
                _disabled: {
                    bg: "gray.300",
                    color: "text.disabled",
                    borderColor: "gray.200",
                    boxShadow: "none",
                },
                _hover: {
                    bg: "primary.base",
                    _disabled: {
                        bg: "gray.background",
                        borderColor: "gray.background",
                    },
                },
            },
            _disabled: {
                bg: "base.background",
                borderColor: "gray.400",
                color: "text.disabled",
                boxShadow: "none",
            },
            _invalid: {
                borderColor: "danger.base",
            },
        },
        label: {
            fontWeight: "medium",
            color: "text.primary",
            ml: 2,
        },
    },
    defaultProps: {
        colorScheme: "teal",
    },
};

const codeTheme = {
    baseStyle: {
        display: "inline",
        paddingY: 0.5,
        paddingX: 1,
        textStyle: "mono",
    },
    variants: {
        subtle: {
            bg: "base.background",
            color: "text.primary",
            fontWeight: "medium",
        },
    },
};

const comboboxTheme = {
    parts: ["control", "input", "toggleButton", "toggleButtonIcon", "value"],
    baseStyle: ({ fontWeight }) => ({
        control: {
            display: "flex",
            alignItems: "center",
            ...(fontWeight === "medium" && { fontWeight: "medium" }),
            backgroundColor: $surfaceBg.reference,
            borderWidth: "hairline",
            borderColor: "base.border",
            borderRadius: "md",
            boxShadow: "buttonShadowLight",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, border-color, color",
            maxWidth: "100%",
            color: "text.primary",
            cursor: "pointer",
            svg: {
                color: "text.placeholder",
            },
            gap: 2,
            "& > :first-child": {
                // Needs to be padding so that the space next to the input
                // may be clicked to open the menu
                pl: 2,
            },
            "& > :last-child": {
                mr: 2,
            },
            _hover: {
                borderColor: $surfaceBorderHover.reference,
                backgroundColor: $surfaceBgHover.reference,
                svg: {
                    color: "text.secondary",
                },
            },
            _expanded: {
                backgroundColor: $surfaceBgHover.reference,
                borderColor: "primary.base",
                _hover: {
                    borderColor: "primary.base",
                },
            },
            _disabled: {
                backgroundColor: "base.backgroundDisabled",
                boxShadow: "none",
                cursor: "not-allowed",
                borderColor: "base.borderDisabled",
                color: "text.disabled",
                svg: {
                    color: "text.disabled",
                },
                _selected: {
                    color: "text.disabled",
                    cursor: "not-allowed",
                },
                _hover: {
                    cursor: "not-allowed",
                    backgroundColor: "base.backgroundDisabled",
                },
            },
            _loading: {
                cursor: "wait",
            },
            _invalid: {
                borderColor: "danger.base",
                _hover: {
                    borderColor: "danger.base",
                },
            },
            // Override app styles
            _focus: {
                outline: "none !important",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
            "&[data-focus-visible]": {
                boxShadow: "outline",
            },
            "&[aria-invalid]": {
                _focusVisible: {
                    boxShadow: "outlineRed",
                },
                "&[data-focus-visible]": {
                    boxShadow: "outlineRed",
                },
            },
        },
        input: {
            flex: "1",
            minWidth: 0,
            height: "100%",
            bg: "transparent",
            fontSize: "md",
            outline: "none",
            color: "inherit",
            cursor: "inherit",
            ...(fontWeight === "medium" && { fontWeight: "medium" }),
            _placeholder: {
                color: "text.placeholder",
            },
            _disabled: {
                cursor: "not-allowed",
            },
        },
        toggleButton: {
            display: "flex",
            alignItems: "center",
            height: "100%",
            // Override app styles
            _focus: {
                outline: "none !important",
            },
            _disabled: {
                cursor: "not-allowed",
            },
        },
        toggleButtonIcon: {
            flexShrink: 0,
            color: "text.secondary",
        },
        value: {
            flex: "1",
            minWidth: 0,
            overflow: "hidden",
            fontSize: "md",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "left",
            "&[data-placeholder]": {
                color: "text.placeholder",
            },
        },
    }),
    variants: {
        alternative: ({ colorScheme }) => ({
            control: {
                bg: "primary.background",
                borderColor: "primary.background",
                boxShadow: "none",
                color: "primary.base",
                svg: {
                    color: "primary.base",
                },
                _selected: {
                    color: colorScheme === "open" ? "text.primary" : "primary.base",
                },
                _hover: {
                    borderColor: "primary.border",
                    color: "primary.hover",
                    bg: "primary.background",
                    svg: {
                        color: "primary.hover",
                    },
                },
            },
            input: {
                _placeholder: {
                    color: colorScheme === "open" ? "text.placeholder" : "primary.base",
                },
                _disabled: {
                    _placeholder: {
                        color: "text.disabled",
                    },
                    color: "text.disabled",
                },
            },
        }),
        tertiary: () => ({
            control: {
                backgroundColor: "transparent",
                borderColor: "transparent",
                boxShadow: "none",
                _hover: {
                    borderColor: "transparent",
                    bg: "base.background",
                    boxShadow: "inputShadowLight",
                },
            },
        }),
    },
    sizes: {
        sm: {
            control: {
                height: 6,
                borderRadius: "md",
            },
            input: {
                fontSize: "sm",
            },
            toggleButton: {
                fontSize: "16px",
            },
            toggleButtonIcon: {
                fontSize: "16px",
            },
            value: {
                fontSize: "sm",
            },
        },
        md: {
            control: {
                height: 8,
                borderRadius: "lg",
            },
            input: {
                fontSize: "md",
            },
            icon: {
                boxSize: 4,
            },
            toggleButton: {
                fontSize: "20px",
            },
            toggleButtonIcon: {
                fontSize: "20px",
            },
            value: {
                fontSize: "md",
            },
        },
        lg: {
            control: {
                height: 10,
                borderRadius: "xl",
            },
            input: {
                fontSize: "lg",
            },
            toggleButton: {
                fontSize: "24px",
            },
            toggleButtonIcon: {
                fontSize: "24px",
            },
            value: {
                fontSize: "lg",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const dialogTheme = {
    parts: ["header", "icon"],
    baseStyle: {
        header: {
            display: "flex",
            alignItems: "center",
            gap: 2,
        },
        icon: {
            fontSize: "3xl",
        },
    },
    variants: {
        info: {
            icon: {
                color: "primary.base",
            },
        },
        warning: {
            icon: {
                color: "warning.base",
            },
        },
        danger: {
            icon: {
                color: "danger.base",
            },
        },
    },
};

const definitionTheme = {
    baseStyle: ({ color }) => ({
        color: color ?? "text.primary",
        display: "inline-block",
        width: "fit-content",
        textDecorationLine: "underline",
        textDecorationStyle: "dotted",
        // Mirror the text.primary → text.placeholder relationship (gray.800 → gray.600,
        // i.e. +0.20 in OKLCH lightness) so the underline reads as a muted echo of
        // whatever color the text resolves to.
        textDecorationColor: "oklch(from currentColor calc(l + 0.2) c h)",
        textDecorationThickness: "16%",
        textUnderlineOffset: "10%",
        textUnderlinePosition: "from-font",
    }),
    sizes: {
        lg: {
            fontSize: "lg",
            lineHeight: "6",
        },
        md: {
            fontSize: "md",
            lineHeight: "5",
        },
        sm: {
            fontSize: "sm",
            lineHeight: "4",
        },
    },
    defaultProps: {
        fontWeight: "normal",
        letterSpacing: "normal",
        size: "md",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const drawerTheme = {
    sizes: {
        "2xl": {
            dialog: {
                maxW: "1024px",
            },
        },
        "3xl": {
            dialog: {
                maxW: "1200px",
            },
        },
    },
    baseStyle: {
        dialogContainer: {
            zIndex: "modal",
        },
        overlay: {
            zIndex: "modal",
        },
        header: {
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            px: 6,
            py: 4,
            borderBottom: `${$borderHairline.reference} solid`,
            borderColor: "base.border",
            "* > span": {
                fontSize: undefined,
                lineHeight: undefined,
                color: undefined,
            },
        },
        body: {
            px: 6,
            py: 4,
            height: "100%",
            width: "100%",
        },
        footer: {
            display: "flex",
            minWidth: 0,
            gap: 4,
            justifyContent: "space-between",
            px: 6,
            py: 4,
            borderTop: `${$borderHairline.reference} solid`,
            borderColor: "base.border",
            boxShadow: "0px -2px 4px -2px rgba(16, 24, 40, 0.06)",
        },
    },
};

const ROW_HEIGHT$3 = 5;
const editableSharedTheme = {
    parts: ["container", "labelContainer", "actionContainer"],
    baseStyle: {
        container: {
            display: "flex",
            position: "relative",
            alignItems: "center",
            gap: 1,
            maxWidth: "100%",
            minWidth: 0,
            minHeight: ROW_HEIGHT$3,
        },
        labelContainer: {
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            borderRadius: "md",
            gap: 1,
            outline: "none",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            ":not([data-disabled='true'])": {
                cursor: "pointer",
            },
            ".editable-text-element": {
                borderBottom: "1px solid",
                borderTop: "1px solid",
                borderColor: "transparent",
            },
            ".editable-icon-container": {
                lineHeight: ROW_HEIGHT$3,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                overflow: "hidden",
                maxWidth: 0,
                transitionProperty: "max-width",
                transitionDuration: "fast",
                transitionTimingFunction: "easeOutQuad",
                svg: {
                    flexShrink: 0,
                    opacity: 0,
                    transitionProperty: "opacity",
                    transitionDuration: "fast",
                    transitionTimingFunction: "easeOutQuad",
                },
            },
            _hover: {
                ".editable-icon-container": {
                    maxWidth: "2rem",
                },
                svg: {
                    visibility: "visible",
                    opacity: 1,
                },
            },
            _focus: {
                boxShadow: "outline",
            },
            _focusWithin: {
                ".editable-icon-container": {
                    maxWidth: "2rem",
                },
                svg: {
                    visibility: "visible",
                    opacity: 1,
                    boxShadow: "none",
                },
            },
            _active: {
                boxShadow: "none",
            },
        },
        actionContainer: {
            display: "flex",
            alignItems: "center",
            gap: 1,
        },
    },
    variants: {
        default: {
            labelContainer: {
                display: "flex",
            },
        },
        editing: {
            labelContainer: {
                display: "none",
            },
        },
    },
};

const ROW_HEIGHT$2 = 6;
const editableDescriptionTheme = {
    ...editableSharedTheme,
    parts: [
        ...editableSharedTheme.parts,
        "contentRow",
        "inputAndActions",
        "expandButton",
        "skeleton",
    ],
    baseStyle({ colorScheme, width, }) {
        return {
            ...editableSharedTheme.baseStyle,
            container: {
                ...editableSharedTheme.baseStyle.container,
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
            },
            contentRow: {
                ...editableSharedTheme.baseStyle.labelContainer,
                width: "100%",
                overflow: "visible",
                ":not([data-disabled='true'])": {
                    cursor: undefined,
                },
            },
            labelContainer: {
                ...editableSharedTheme.baseStyle.labelContainer,
                whiteSpace: "wrap",
                minHeight: ROW_HEIGHT$2,
                ".editable-text-element": {
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    color: colorScheme === "warning" ? "warning.pressed" : undefined,
                },
                ".editable-icon-container": {
                    ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"],
                    height: ROW_HEIGHT$2,
                    width: ROW_HEIGHT$2,
                    svg: {
                        ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"].svg,
                        height: 4,
                        width: 4,
                    },
                },
                _focus: {
                    boxShadow: colorScheme === "warning" ? "outlineYellow" : "outline",
                },
            },
            inputAndActions: {
                display: "inline-flex",
                flexDirection: "column",
                width: width === "100%" ? "100%" : "auto",
                maxWidth: "100%",
            },
            expandButton: {
                fontSize: "sm",
                lineHeight: 4,
                color: colorScheme === "warning" ? "warning.base" : "primary.base",
                borderRadius: "md",
                outline: "none !important",
                mb: 2,
                _focus: {
                    boxShadow: colorScheme === "warning" ? "outlineYellow" : "outline",
                },
            },
            skeleton: {
                borderRadius: "xl",
                minHeight: 6,
                width: "100%",
                maxWidth: "400px",
            },
            usedLeftActionIcon: {
                height: 4,
                width: 4,
                flexShrink: 0,
            },
        };
    },
    variants: {
        ...editableSharedTheme.variants,
        default({ actionsPosition, lineClamp = 2 }) {
            return {
                ...editableSharedTheme.variants.default,
                contentRow: {
                    ...(actionsPosition === "bottom" && {
                        flexWrap: "wrap",
                    }),
                },
                labelContainer: {
                    ...editableSharedTheme.variants.default.labelContainer,
                    ".editable-text-element": {
                        WebkitLineClamp: lineClamp.toString(),
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                    },
                },
                actionContainer: {
                    ...(actionsPosition === "bottom" && {
                        width: "100%",
                        justifyContent: "flex-end",
                        ml: 0,
                    }),
                },
            };
        },
        editing({ actionsPosition }) {
            return {
                ...editableSharedTheme.variants.editing,
                contentRow: {
                    ...(actionsPosition === "bottom" && {
                        flexWrap: "wrap",
                    }),
                },
                labelContainer: {
                    ...editableSharedTheme.variants.editing.labelContainer,
                    maxH: "none",
                    whiteSpace: "wrap", // Ensure shifting calculations are correct
                },
                actionContainer: {
                    ...(actionsPosition === "bottom" && {
                        width: "100%",
                        justifyContent: "flex-end",
                        ml: 0,
                    }),
                },
            };
        },
        expanded: {
            labelContainer: {
                maxH: "none",
                whiteSpace: "wrap",
                wordBreak: "break-word",
            },
        },
    },
};

const ROW_HEIGHT$1 = 8;
const editableHeadingTheme = {
    ...editableSharedTheme,
    baseStyle: {
        ...editableSharedTheme.baseStyle,
        labelContainer: {
            ...editableSharedTheme.baseStyle.labelContainer,
            minH: ROW_HEIGHT$1,
            ".editable-icon-container": {
                ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"],
                height: ROW_HEIGHT$1,
                width: ROW_HEIGHT$1,
                svg: {
                    ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"].svg,
                    height: 5,
                    width: 5,
                },
            },
        },
    },
    defaultProps: { size: "md" },
};

const ROW_HEIGHT = 6;
const editableTextTheme = {
    ...editableSharedTheme,
    parts: [...editableSharedTheme.parts, "usedLeftActionIcon"],
    baseStyle: {
        ...editableSharedTheme.baseStyle,
        container: {
            ...editableSharedTheme.baseStyle.container,
            // Hold the row height while editing; the input alone is 2px shorter.
            minHeight: ROW_HEIGHT,
        },
        usedLeftActionIcon: {
            height: 4,
            width: 4,
            flexShrink: 0,
        },
        labelContainer: {
            ...editableSharedTheme.baseStyle.labelContainer,
            minH: ROW_HEIGHT,
            ".editable-icon-container": {
                ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"],
                height: ROW_HEIGHT,
                width: ROW_HEIGHT,
                svg: {
                    ...editableSharedTheme.baseStyle.labelContainer[".editable-icon-container"].svg,
                    height: 4,
                    width: 4,
                },
            },
        },
    },
};

const textColor$1 = cssVar("hightouch-text-color").variable;
const filterOptionListTheme = {
    parts: [
        "container",
        "header",
        "row",
        "optionRow",
        "checkboxLabel",
        "iconSlot",
        "optionText",
        "onlyButton",
    ],
    baseStyle: ({ showOnlyAffordance }) => ({
        container: {
            display: "flex",
            flexDirection: "column",
        },
        header: {
            px: 3,
            pt: 2,
            pb: 1,
            [textColor$1]: "colors.text.tertiary",
        },
        row: {
            display: "flex",
            alignItems: "center",
            gap: 3,
            px: 3,
            minH: 10,
            py: 2,
            borderRadius: "md",
            _hover: { bg: "base.lightBackground" },
        },
        optionRow: {
            display: "flex",
            alignItems: "center",
            gap: 3,
            position: "relative",
            pl: 3,
            // Gutter for the absolutely-positioned "Only" so long labels wrap before it.
            pr: showOnlyAffordance ? 12 : 3,
            minH: 10,
            py: 2,
            borderRadius: "md",
            cursor: "pointer",
            _hover: { bg: "base.lightBackground" },
        },
        checkboxLabel: {
            cursor: "pointer",
        },
        iconSlot: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSize: 5,
            flexShrink: 0,
            overflow: "hidden",
        },
        optionText: {
            minWidth: 0,
            overflowWrap: "anywhere",
            // A <label> takes cursor: default from the UA sheet, so the row's pointer
            // does not reach it.
            cursor: "pointer",
        },
        onlyButton: {
            position: "absolute",
            outline: "none !important",
            right: 3,
            top: "50%",
            transform: "translateY(-50%)",
            px: 1,
            borderRadius: "sm",
            opacity: 0,
            [textColor$1]: "colors.text.secondary",
            _groupHover: { opacity: 1 },
            // Not _groupFocusWithin: a checkbox click would pin "Only" after the pointer leaves.
            ".group:has(:focus-visible) &": { opacity: 1 },
            _focusVisible: { opacity: 1, boxShadow: "outline" },
        },
    }),
};

const textColor = cssVar("hightouch-text-color").variable;
const filterPillTheme = {
    parts: ["labelGroup", "content", "body"],
    baseStyle: {
        labelGroup: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            whiteSpace: "nowrap",
            fontWeight: "normal",
            [textColor]: "colors.text.tertiary",
        },
        content: {
            w: 60,
        },
        body: {
            p: 2,
        },
    },
};

const formTheme = {
    baseStyle: {
        helperText: {
            mt: 0,
            fontSize: "md",
            lineHeight: "5",
            maxWidth: "xl",
            // --form-control-color is defined by Chakra and is used in `FormHelperText` text
            [cssVar("form-control-color").variable]: "colors.text.secondary",
            // --hightouch-text-color makes nested `Text` components inherit this color
            [cssVar("hightouch-text-color").variable]: "colors.text.secondary",
        },
        addon: {
            h: 8,
            px: 2,
            borderRadius: "md",
        },
    },
};

const formErrorTheme = {
    baseStyle: {
        text: {
            color: "text.danger",
            fontSize: "sm",
            lineHeight: "5",
        },
    },
};

const formLabelTheme = {
    baseStyle: {
        color: "text.primary",
        mb: 0,
        me: 0,
        fontSize: "md",
        lineHeight: "5",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
// @designs: https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Hightouch-UI?node-id=8434-1496
const variantColors = {
    simple: {
        icon: "icon.secondary",
        text: "text.secondary",
        close: "icon.secondary",
    },
    info: {
        icon: "icon.accent",
        text: "text.accent",
        close: "icon.accent",
    },
    danger: {
        icon: "icon.danger",
        text: "text.danger",
        close: "icon.danger",
    },
    warning: {
        icon: "icon.warning",
        text: "text.warning",
        close: "icon.warning",
    },
    newFeature: {
        icon: "icon.upsell",
        text: "text.upsell",
        close: "icon.upsell",
    },
};
const globalAnnouncementTheme = {
    parts: ["chip", "icon", "textContainer", "text", "closeButton", "closeIcon"],
    baseStyle: ({ variant = "simple", isActive, hasDismiss, }) => {
        const colors = variantColors[variant] ??
            variantColors.simple;
        return {
            chip: {
                alignItems: "center",
                bg: isActive ? "blackAlpha.08" : "blackAlpha.04",
                border: `${$borderHairline.reference} solid`,
                borderColor: isActive ? "blackAlpha.08" : "blackAlpha.04",
                borderRadius: "md",
                cursor: "pointer",
                display: "inline-flex",
                h: 6,
                overflow: "hidden",
                pl: 1.5,
                pr: hasDismiss && isActive ? 7 : 1.5,
                position: "relative",
                transitionProperty: "background, border-color, padding-right",
                transitionDuration: "fast",
                transitionTimingFunction: "ease",
                transitionDelay: hasDismiss && !isActive ? "0ms, 0ms, 75ms" : "0ms, 0ms, 0ms",
                _focusVisible: {
                    outline: "1px solid",
                    outlineColor: "primary.border",
                    outlineOffset: "1px",
                },
            },
            icon: {
                boxSize: 4,
                color: colors.icon,
                flexShrink: 0,
                mr: 1,
            },
            textContainer: {
                alignItems: "center",
                display: "flex",
                maxW: "300px",
                minH: 4,
                overflow: "hidden",
            },
            text: {
                color: colors.text,
                fontSize: "sm",
            },
            closeButton: {
                alignItems: "center",
                bg: "transparent",
                border: "none",
                color: colors.close,
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                opacity: isActive ? 1 : 0,
                pointerEvents: isActive ? "auto" : "none",
                position: "absolute",
                right: 1.5,
                top: "50%",
                transitionProperty: "opacity, transform",
                transitionDuration: "fast",
                transitionTimingFunction: "ease",
                transitionDelay: isActive ? "90ms" : "0ms",
                transformOrigin: "center",
                transform: isActive
                    ? "translateY(-50%)"
                    : "translateY(-50%) scale(0.95)",
                boxSize: 4,
                borderRadius: "sm",
                _hover: { opacity: 0.8 },
                _focusVisible: {
                    opacity: 1,
                    outline: "1px solid",
                    outlineColor: "primary.border",
                    outlineOffset: "1px",
                },
            },
            closeIcon: {
                boxSize: 4,
                flexShrink: 0,
            },
        };
    },
    defaultProps: {
        variant: "simple",
    },
};

// @designs: https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Hightouch-UI?node-id=8860-85404
const variantTitleColors = {
    simple: "text.primary",
    info: "text.accent",
    danger: "text.danger",
    warning: "text.warning",
    newFeature: "text.upsell",
};
const variantTitleIconColors = {
    simple: "icon.primary",
    info: "icon.accent",
    danger: "icon.danger",
    warning: "icon.warning",
    newFeature: "icon.upsell",
};
const globalAnnouncementPopoverTheme = {
    parts: [
        "popover",
        "content",
        "titleContainer",
        "titleIcon",
        "title",
        "description",
        "actions",
    ],
    baseStyle: ({ variant = "simple" }) => {
        const titleColor = variantTitleColors[variant] ??
            variantTitleColors.simple;
        const titleIconColor = variantTitleIconColors[variant] ??
            variantTitleIconColors.simple;
        return {
            popover: {
                _focus: { outline: "none" },
                bg: "white",
                border: "none",
                borderRadius: "2xl",
                boxShadow: "md",
                p: 2,
                w: "320px",
            },
            content: {
                display: "flex",
                flexDirection: "column",
                gap: 1,
                maxW: "400px",
                minW: "240px",
                p: 2,
                w: "full",
            },
            titleContainer: {
                alignItems: "center",
                display: "flex",
                gap: 1.5,
                w: "full",
            },
            titleIcon: {
                boxSize: 4,
                color: titleIconColor,
                flexShrink: 0,
            },
            title: {
                color: titleColor,
                display: "block",
                fontWeight: "medium",
                fontSize: "md",
                lineHeight: 5,
            },
            description: {
                color: "text.secondary",
                display: "block",
                fontSize: "sm",
                lineHeight: 5,
                w: "full",
            },
            actions: {
                alignItems: "center",
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
                pt: 3,
                w: "full",
            },
        };
    },
    defaultProps: {
        variant: "simple",
    },
};

const hightouchIconTheme = {
    baseStyle: {
        fill: "currentColor",
        display: "inline-flex",
        alignSelf: "center",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const addonBaseStyle = {
    bg: $surfaceAddonBg.reference,
    color: $surfaceAddonColor.reference,
    border: `${$borderHairline.reference} solid`,
    borderColor: "base.border",
    boxShadow: "buttonShadowLight",
    px: 3,
};
const inputTheme = {
    parts: [
        "field",
        "validationIcon",
        "addon",
        "leftAddon",
        "rightAddon",
        "leftElement",
        "leftIcon",
    ],
    baseStyle: {
        field: {
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            "&[type='search']::-webkit-search-cancel-button": {
                WebkitAppearance: "none",
                backgroundRepeat: "no-repeat",
                position: "relative",
                left: "4px",
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundImage: "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22%23697786%22%20width%3D%221em%22%20height%3D%221em%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M5.293%205.293a1%201%200%200%201%201.414%200L12%2010.586l5.293-5.293a1%201%200%201%201%201.414%201.414L13.414%2012l5.293%205.293a1%201%200%200%201-1.414%201.414L12%2013.414l-5.293%205.293a1%201%200%200%201-1.414-1.414L10.586%2012%205.293%206.707a1%201%200%200%201%200-1.414Z%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E",
            },
        },
        leftElement: {
            pointerEvents: "none",
        },
        addon: addonBaseStyle,
        leftAddon: {
            ...addonBaseStyle,
            borderTopLeftRadius: "lg",
            borderBottomLeftRadius: "lg",
        },
        rightAddon: {
            ...addonBaseStyle,
            borderTopRightRadius: "lg",
            borderBottomRightRadius: "lg",
        },
        leftIcon: {
            color: "text.secondary",
        },
    },
    variants: {
        outline: {
            field: {
                borderColor: "base.border",
                bg: $surfaceBg.reference,
                boxShadow: "buttonShadowLight",
                color: "text.primary",
                border: `${$borderHairline.reference} solid`,
                _hover: {
                    borderColor: $surfaceBorderHover.reference,
                    bg: $surfaceBgHover.reference,
                    _disabled: {
                        borderColor: "transparent",
                        bg: "base.backgroundDisabled",
                        cursor: "not-allowed",
                        boxShadow: "none",
                    },
                    _invalid: {
                        borderColor: "danger.600",
                    },
                    "&[data-warning]": {
                        borderColor: "warning.500",
                    },
                },
                _disabled: {
                    opacity: 1,
                    bg: "base.backgroundDisabled",
                    color: "text.disabled",
                    borderColor: "transparent",
                },
                _invalid: {
                    borderColor: "danger.600",
                    boxShadow: "sm",
                },
                "&[data-warning]": {
                    borderColor: "warning.600",
                    boxShadow: "sm",
                },
                _focus: {
                    bg: $surfaceBgHover.reference,
                    borderColor: "primary.base",
                    _invalid: {
                        borderColor: "danger.base",
                    },
                    "&[data-warning]": {
                        borderColor: "warning.base",
                    },
                },
                _focusVisible: {
                    boxShadow: "outline",
                    _invalid: {
                        boxShadow: "outlineRed",
                    },
                    "&[data-warning]": {
                        boxShadow: "outlineYellow",
                    },
                },
                _placeholder: {
                    color: "text.placeholder",
                },
            },
            addon: addonBaseStyle,
            leftAddon: addonBaseStyle,
            rightAddon: addonBaseStyle,
        },
    },
    sizes: {
        sm: {
            field: {
                borderRadius: "md",
                fontSize: "sm",
                height: 6,
                px: 2,
                "&[type='search']": {
                    paddingLeft: 7,
                    "::-webkit-search-cancel-button": {
                        height: "16px",
                        width: "16px",
                    },
                },
            },
            validationIcon: {
                boxSize: 4,
            },
            leftAddon: {
                fontSize: "sm",
            },
            leftElement: {
                width: 8,
            },
            leftIcon: {
                boxSize: 4,
            },
        },
        md: {
            field: {
                borderRadius: "lg",
                fontSize: "md",
                height: 8,
                px: 2,
                "&[type='search']": {
                    paddingLeft: 8,
                    "::-webkit-search-cancel-button": {
                        height: "20px",
                        width: "20px",
                    },
                },
            },
            leftAddon: {
                fontSize: "md",
            },
            validationIcon: {
                boxSize: 5,
            },
            leftElement: {
                width: 9,
            },
            leftIcon: {
                boxSize: 5,
            },
        },
        lg: {
            field: {
                borderRadius: "xl",
                fontSize: "lg",
                height: 10,
                px: 2,
                "&[type='search']": {
                    paddingLeft: 9,
                    "::-webkit-search-cancel-button": {
                        height: "24px",
                        width: "24px",
                    },
                },
            },
            leftAddon: {
                fontSize: "lg",
            },
            validationIcon: {
                boxSize: 6,
            },
            leftElement: {
                width: 10,
            },
            leftIcon: {
                boxSize: 6,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const inputGroupTheme = {
    baseStyle: {
        position: "relative",
        maxWidth: "100%",
    },
    sizes: {
        sm: {
            fontSize: "md",
            height: 6,
            borderRadius: "md",
        },
        md: {
            fontSize: "md",
            height: 8,
            borderRadius: "lg",
        },
        lg: {
            fontSize: "lg",
            height: 10,
            borderRadius: "xl",
        },
    },
    defaultProps: {
        size: "md",
    },
};

const kbdTheme = {
    baseStyle: {
        "--kbd-bg": "var(--chakra-colors-gray-700)",
        border: "none",
        borderRadius: "sm",
        color: "gray.300",
        fontFamily: "inherit",
        fontSize: "sm",
        fontWeight: "normal",
        lineHeight: "4",
        minWidth: 5,
        height: 5,
        textAlign: "center",
        px: 1,
        py: 0.5,
    },
};

const linkTheme = {
    baseStyle: {
        color: "link.default",
        borderRadius: "sm",
        fontWeight: "medium",
        transitionDuration: "fast",
        transitionTimingFunction: "easeOutQuad",
        transitionProperty: "color, text-decoration",
        _hover: {
            color: "link.hover",
            textDecoration: "none",
        },
        _active: {
            color: "link.pressed",
        },
    },
    sizes: {
        sm: {
            fontSize: "sm",
            lineHeight: "4",
        },
        md: {
            fontSize: "md",
            lineHeight: "5",
        },
        lg: {
            fontSize: "lg",
            lineHeight: "6",
        },
    },
    defaultProps: {
        size: "md",
    },
    variants: {
        upsell: {
            color: "upsell.base",
            _hover: {
                color: "upsell.hover",
            },
            _active: {
                color: "upsell.dark",
            },
        },
    },
};

const linkTextButtonTheme = {
    baseStyle: {
        ...linkTheme.baseStyle,
        // Include disabled styles since this is a button
        _disabled: {
            color: "text.disabled",
            cursor: "not-allowed",
        },
        _focus: {
            outline: "none !important",
            boxShadow: "outline",
            borderRadius: "md",
        },
    },
    sizes: {
        ...textTheme.sizes,
    },
    defaultProps: {
        ...linkTheme.defaultProps,
    },
};

const space = {
    ...theme$1.space,
    "0.5": "2px",
    "1": "4px",
    "1.5": "6px",
    "2": "8px",
    "2.5": "10px",
    "3": "12px",
    "3.5": "14px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "7": "28px",
    "8": "32px",
    "9": "36px",
    "10": "40px",
    "12": "48px",
    "14": "56px",
    "16": "64px",
    "20": "80px",
    "24": "96px",
    "28": "112px",
    "32": "128px",
    "36": "144px",
    "40": "160px",
    "44": "176px",
    "48": "192px",
    "52": "208px",
    "56": "224px",
    "60": "240px",
    "64": "256px",
    "72": "288px",
    "80": "320px",
    "96": "384px",
};

// Widens a small control's hit area to the 24px WCAG inline minimum.
const hitArea = {
    position: "relative",
    _before: {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxSize: 6,
        minWidth: "100%",
    },
};
const labelBadgeGroupTheme = {
    parts: [
        "container",
        "group",
        "badge",
        "badgeName",
        "valueRun",
        "run",
        "valueItem",
        "overflowSlot",
        "overflowTrigger",
        "overflowPanel",
        "overflowPanelBody",
        "valueBubble",
        "valueTextClamp",
        "valueText",
        "dismissButton",
    ],
    baseStyle: ({ isRemovable }) => ({
        container: {
            display: "flex",
            minWidth: 0,
        },
        group: {
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            flex: 1,
            minWidth: 0,
        },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            width: "fit-content",
            maxWidth: "100%",
            minWidth: 0,
            whiteSpace: "nowrap",
            borderRadius: "full",
            borderWidth: "hairline",
            borderStyle: "solid",
            borderColor: "base.border",
            bg: "base.lightBackground",
            boxShadow: isRemovable ? "buttonShadowLight" : "none",
            outline: "none",
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        // The name yields before the values do: it ellipsizes rather than pushing
        // the value run past the badge's edge.
        badgeName: {
            display: "block",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        valueRun: {
            display: "inline-flex",
            alignItems: "center",
            // A floor, not 0: a name long enough to fill the badge has to give the
            // values their line back rather than shave them to a sliver.
            minWidth: "min-content",
        },
        // clip-margin lets the Xs' focus rings paint past the line box.
        run: {
            display: "flex",
            flexWrap: "wrap",
            flex: "0 1 auto",
            gap: isRemovable ? 0.5 : 0,
            minWidth: 0,
            // A flex parent can't shrink a pinned value run without this.
            maxWidth: "100%",
            height: "1lh",
            overflow: "clip",
            overflowClipMargin: space["1"],
        },
        // Read-only values are comma-joined. A pseudo-element keeps the separator
        // out of the run's children, which is what the wrap measurement counts.
        valueItem: {
            display: "inline-flex",
            alignItems: "center",
            minWidth: 0,
            height: "1lh",
            "&:not(:first-child)::before": {
                content: '","',
                mr: 1,
                color: "text.primary",
                fontWeight: "medium",
            },
        },
        overflowSlot: {
            display: "inline-flex",
            flexShrink: 0,
            pl: 1,
        },
        // Sized to the text's line box: a badge-height "+N" would overhang the badge.
        overflowTrigger: {
            ...hitArea,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            height: "1lh",
            lineHeight: "inherit",
            minWidth: 0,
            px: 1.5,
            borderRadius: "full",
            // Matches a value bubble: hairline border, no fill of its own, so the
            // badge shows through until the pointer is on it.
            borderWidth: "hairline",
            borderStyle: "solid",
            borderColor: "base.border",
            bg: "transparent",
            color: "text.primary",
            fontWeight: "medium",
            cursor: "pointer",
            outline: "none",
            _hover: { bg: "base.backgroundHover" },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        overflowPanel: {
            width: "max-content",
            maxWidth: "xs",
        },
        overflowPanelBody: {
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            p: 2,
        },
        valueBubble: {
            display: "inline-flex",
            alignItems: "center",
            minWidth: 0,
            // The border must not make the bubble taller than the one-line clip.
            height: "1lh",
            borderWidth: "hairline",
            borderStyle: "solid",
            borderColor: "base.border",
            borderRadius: "full",
        },
        valueTextClamp: {
            display: "inline-flex",
            minWidth: 0,
            // Per-value cap so one long value can't push every sibling into the +N.
            maxW: "2xs",
            overflow: "hidden",
        },
        valueText: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "text.primary",
            fontWeight: "medium",
        },
        dismissButton: {
            ...hitArea,
            ml: 1,
        },
    }),
    sizes: {
        sm: {
            // The four "1lh" parts resolve against these, so they have to be set here.
            badge: {
                height: 5,
                px: 1.5,
                gap: 1,
                fontSize: "sm",
                lineHeight: "4",
            },
            valueBubble: {
                px: 1.5,
            },
        },
        md: {
            badge: {
                height: 6,
                px: 2,
                gap: 1.5,
                fontSize: "md",
                lineHeight: "5",
            },
            valueBubble: {
                px: 2,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const menuTheme = {
    variants: {
        breadcrumb: {
            list: {
                width: "max-content",
                minWidth: 40,
                maxWidth: 72,
                p: 1,
                borderRadius: "lg",
            },
            item: {
                minHeight: 8,
                py: 1.5,
                alignItems: "center",
            },
        },
    },
    baseStyle: {
        list: {
            boxShadow: "md",
            borderRadius: "xl",
            px: 2,
            zIndex: "popover",
            border: "none",
        },
        item: {
            borderRadius: "lg",
            fontSize: "md",
            lineHeight: "5",
            px: 2,
            py: 2.5,
            gap: 2,
            alignItems: "flex-start",
            "> .chakra-menu__icon-wrapper": {
                display: "flex",
                margin: 0,
                h: 5,
                w: 5,
            },
            [cssVar("menu-bg").variable]: "base.background",
            _focus: {
                // Override app styles
                outline: "none !important",
            },
            _hover: {
                bg: "base.background",
            },
            _checked: {
                svg: {
                    fill: "text.secondary",
                    h: 5,
                    w: 5,
                },
            },
        },
        // Mirrors `SelectGroup` so section headers match across menus and selects
        groupTitle: {
            display: "flex",
            alignItems: "flex-end",
            minH: 8,
            m: 0,
            px: 2,
            py: 1,
            fontSize: "sm",
            lineHeight: "5",
            fontWeight: "semibold",
            color: "text.tertiary",
        },
        divider: {
            borderColor: "base.divider",
        },
    },
};

const modalTheme = {
    baseStyle: {
        overlay: {
            bg: "blackAlpha.40",
            backdropFilter: "blur(4px)",
            zIndex: "popover",
        },
        dialogContainer: {
            alignItems: "start",
            maxH: "100vh",
            overflow: "hidden", // Do not scroll the overlay container
            zIndex: "popover",
        },
        dialog: {
            my: "auto",
            py: 6,
            borderRadius: "xl",
            bg: "white",
        },
        header: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            color: "text.primary",
            fontSize: "xl",
            fontWeight: "medium",
            lineHeight: "6",
            mb: 6,
            py: 0,
            px: 6,
        },
        body: {
            mb: 0,
            py: 0,
            px: 6,
            color: "text.primary",
            fontSize: "md",
            lineHeight: "5",
            display: "flex",
            flexDir: "column",
            flex: 1,
            minH: 0,
            overflow: "auto",
            scrollbarWidth: "thin",
        },
        footer: {
            mt: 6,
            py: 0,
            px: 6,
            gap: 2,
        },
    },
    variants: {
        genericDialog: {
            header: {
                justifyContent: "space-between",
                mb: 5,
            },
            body: {
                py: 1,
            },
            footer: {
                mt: 5,
            },
        },
    },
    defaultProps: {
        size: "lg",
    },
};

const progressTheme = {
    baseStyle: {
        track: {
            bg: "gray.200",
            borderRadius: "lg",
        },
        filledTrack: {
            transitionDuration: "faster",
            transitionTimingFunction: "easeOutExpo",
            transitionProperty: "width",
        },
    },
    sizes: {
        sm: {
            track: {
                h: "8px",
            },
        },
    },
    defaultProps: {
        size: "sm",
    },
};

const radioTransitions = {
    transitionDuration: "fast",
    transitionTimingFunction: "easeOutCubic",
};
const radioTheme = {
    parts: ["container", "radio", "input", "control", "label", "description"],
    baseStyle: {
        container: {
            display: "flex",
            alignItems: "center",
            gap: 2,
        },
        radio: {
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            cursor: "pointer",
            _disabled: {
                cursor: "default",
            },
        },
        input: {
            height: "16px",
            width: "16px",
            margin: 0,
            clip: undefined,
            opacity: 0,
            cursor: "pointer",
        },
        control: {
            // Required for rounded outline shadow
            borderRadius: "full",
            flexShrink: 0,
            ".control-bg": {
                fill: cssVar("radio-background-color").reference,
                transitionProperty: "fill",
                ...radioTransitions,
            },
            ".control-border": {
                stroke: cssVar("radio-border-color").reference,
                transitionProperty: "stroke",
                ...radioTransitions,
            },
            ".control-dot": {
                fill: cssVar("radio-dot-color").reference,
                transitionProperty: "fill",
                ...radioTransitions,
            },
            [cssVar("radio-background-color").variable]: "white",
            [cssVar("radio-border-color").variable]: "colors.base.border",
            [cssVar("radio-dot-color").variable]: "transparent",
            _hover: {
                [cssVar("radio-background-color").variable]: "colors.primary.background",
                [cssVar("radio-border-color").variable]: "colors.primary.base",
            },
            _checked: {
                [cssVar("radio-background-color").variable]: "colors.primary.base",
                [cssVar("radio-border-color").variable]: "colors.primary.base",
                [cssVar("radio-dot-color").variable]: "colors.white",
            },
            _disabled: {
                [cssVar("radio-background-color").variable]: "colors.base.backgroundDisabled",
                [cssVar("radio-border-color").variable]: "colors.base.borderDisabled",
                [cssVar("radio-dot-color").variable]: "colors.base.backgroundDisabled",
                _checked: {
                    [cssVar("radio-border-color").variable]: "colors.gray.500",
                    [cssVar("radio-dot-color").variable]: "colors.white",
                    [cssVar("radio-background-color").variable]: "colors.gray.500",
                },
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        label: {
            fontWeight: "medium",
            color: "text.primary",
            ml: 2,
        },
        description: {
            mt: 1,
            color: "text.secondary",
            [cssVar("hightouch-text-color").variable]: "colors.text.secondary",
        },
    },
    sizes: {
        md: {
            control: {
                boxSize: 4,
            },
            label: {
                fontSize: "md",
                lineHeight: "5",
            },
            description: {
                fontSize: "sm",
                lineHeight: "5",
                pl: 6,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const segmentedControlTheme = {
    baseStyle() {
        return {
            // Grid 1fr columns size every option to the widest label, even at fit-content width.
            // Flex would size each option to its own content and cramp short labels.
            display: "inline-grid",
            gridAutoFlow: "column",
            gridAutoColumns: "1fr",
            position: "relative",
            gap: 0.5,
            // The rail is a flat pseudo-element inset 1px, so the full-height thumb stands proud of it.
            // Options paint above the rail in DOM order; the thumb is the only elevated element.
            _before: {
                content: '""',
                position: "absolute",
                inset: "1px",
                // The nearest surface sets the rail color, one step darker on grey so the rail stays visible.
                bg: $surfaceTrackBg.reference,
                borderRadius: "full",
            },
        };
    },
    sizes: {
        md: {
            height: "32px",
        },
        lg: {
            height: "40px",
        },
    },
};

const iconColorMap = {
    empty: "text.secondary",
    success: "success.base",
    error: "danger.base",
};
const segmentedControlOptionTheme = {
    parts: ["item", "label", "indicator", "text"],
    baseStyle({ isChecked, status, px, }) {
        return {
            label: {
                m: 0,
                p: 0,
                display: "flex",
                cursor: "pointer",
                position: "relative",
                userSelect: "none",
                _disabled: {
                    cursor: "not-allowed",
                    opacity: 0.6,
                },
            },
            item: {
                display: "flex",
                position: "relative",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                px: px === "sm" ? 2 : 3,
                borderRadius: "full",
                fontWeight: "medium",
                fontSize: "md",
                lineHeight: "5",
                color: "text.tertiary",
                transitionProperty: "common",
                transitionDuration: "fast",
                whiteSpace: "nowrap",
                bg: "transparent",
                gap: 0.5,
                svg: {
                    zIndex: 2,
                    color: "text.tertiary",
                },
                _checked: {
                    color: "text.primary",
                    svg: {
                        color: isChecked && status ? iconColorMap[status] : "text.secondary",
                    },
                },
                _focusVisible: {
                    boxShadow: "outline",
                    borderColor: "primary.border",
                },
                // Hover carries no background; it only darkens the label and icon.
                _hover: {
                    "&:not([data-disabled]):not([data-checked])": {
                        color: "text.primary",
                        svg: {
                            color: "text.primary",
                        },
                    },
                },
            },
            text: {
                px: 1,
                zIndex: 2,
                position: "relative",
            },
            indicator: {
                position: "absolute",
                inset: 0,
                bg: "white",
                boxShadow: "sm",
                borderRadius: "full",
                zIndex: 1,
            },
        };
    },
};

const selectTheme = {
    parts: ["toggleButton", "value", "icon"],
    baseStyle: ({ fontWeight }) => ({
        toggleButton: {
            display: "flex",
            alignItems: "center",
            ...(fontWeight === "medium" && { fontWeight: "medium" }),
            backgroundColor: $surfaceBg.reference,
            border: `${$borderHairline.reference} solid`,
            borderColor: "base.border",
            borderRadius: "lg",
            boxShadow: "buttonShadowLight",
            px: 2,
            gap: 2,
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, border-color, color",
            maxWidth: "100%",
            outline: "none !important",
            color: "text.placeholder",
            svg: {
                color: "text.placeholder",
            },
            _selected: {
                color: "text.primary",
            },
            _hover: {
                borderColor: $surfaceBorderHover.reference,
                bg: $surfaceBgHover.reference,
                svg: {
                    color: "text.secondary",
                },
            },
            _expanded: {
                backgroundColor: $surfaceBgHover.reference,
                borderColor: "primary.base",
                color: "text.primary",
                _hover: {
                    borderColor: "primary.base",
                },
            },
            _disabled: {
                backgroundColor: "base.backgroundDisabled",
                cursor: "not-allowed",
                boxShadow: "none",
                color: "text.disabled",
                borderColor: "base.borderDisabled",
                svg: {
                    color: "text.disabled",
                },
                _selected: {
                    color: "text.disabled",
                },
            },
            _loading: {
                cursor: "wait",
            },
            _invalid: {
                borderColor: "danger.base",
                _hover: {
                    borderColor: "danger.base",
                },
            },
            // Override app styles
            _focus: {
                outline: "none !important",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        value: {
            flex: "1",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            textAlign: "left",
            ...(fontWeight === "medium" && { fontWeight: "medium" }),
        },
        icon: {
            color: "text.secondary",
        },
    }),
    variants: {
        alternative: ({ colorScheme }) => ({
            toggleButton: {
                backgroundColor: "primary.background",
                borderColor: "primary.background",
                boxShadow: "none",
                color: "primary.base",
                svg: {
                    color: "primary.base",
                },
                _selected: {
                    color: colorScheme === "open" ? "text.primary" : "primary.base",
                },
                _hover: {
                    borderColor: "primary.border",
                    color: "primary.hover",
                    bg: "primary.background",
                    svg: {
                        color: "primary.hover",
                    },
                },
            },
            value: {
                "&[data-placeholder]": {
                    color: colorScheme === "open" ? "text.placeholder" : "primary.base",
                },
            },
        }),
        tertiary: () => ({
            toggleButton: {
                backgroundColor: "transparent",
                borderColor: "transparent",
                boxShadow: "none",
                _hover: {
                    borderColor: "transparent",
                    bg: "base.background",
                    boxShadow: "inputShadowLight",
                },
            },
        }),
    },
    sizes: {
        sm: {
            toggleButton: {
                height: 6,
                minHeight: 6,
                maxHeight: 6,
                fontSize: "sm",
                borderRadius: "md",
                lineHeight: 4,
            },
            icon: {
                fontSize: "16px",
            },
        },
        md: {
            toggleButton: {
                height: 8,
                minHeight: 8,
                maxHeight: 8,
                fontSize: "md",
                borderRadius: "lg",
                lineHeight: 5,
            },
            icon: {
                fontSize: "20px",
            },
        },
        lg: {
            toggleButton: {
                height: 10,
                minHeight: 10,
                maxHeight: 10,
                fontSize: "lg",
                borderRadius: "xl",
                lineHeight: 6,
            },
            icon: {
                fontSize: "24px",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const selectClearButtonTheme = {
    parts: ["button", "icon"],
    baseStyle: {
        button: {
            display: "flex",
            flexShrink: 0,
            outline: "none",
            borderRadius: "md",
            color: "text.primary",
            _focusVisible: {
                boxShadow: "outline",
            },
            _disabled: {
                color: "text.disabled",
                cursor: "not-allowed",
            },
        },
        icon: {
            boxSize: "100%",
            flex: "none",
            flexShrink: 0,
        },
    },
    sizes: {
        md: {
            button: {
                boxSize: 4,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const selectEmptyStateTheme = {
    baseStyle: ({ hasBorder }) => ({
        fontSize: "md",
        lineHeight: "5",
        color: "text.secondary",
        textAlign: "center",
        p: 3,
        borderRadius: hasBorder ? "2xl" : "0",
        boxShadow: hasBorder ? "lg" : "none",
        outline: "none",
    }),
};

const selectGroupTheme = {
    parts: ["root", "container", "label", "divider"],
    baseStyle: {
        root: {
            display: "flex",
            flexDirection: "column",
        },
        container: {
            bg: "white",
            display: "flex",
            alignItems: "flex-end",
            px: 2,
            py: 1,
        },
        label: {
            fontWeight: "semibold",
            color: "text.tertiary",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            userSelect: "none",
        },
        divider: {
            borderTopWidth: "hairline",
            borderTopStyle: "solid",
            borderColor: "base.divider",
            // Flex-item margins never collapse, so this spacing stays inside the
            // group row's box rather than escaping it. The row has to be measured for
            // the virtualizer to place the next row below it, not estimated.
            my: 2,
            // Cancels the row padding SelectOptions adds with `hasGroupDividers`, so the line spans the popover.
            mx: -2,
        },
    },
    sizes: {
        md: {
            container: {
                h: 8,
            },
            label: {
                fontSize: "sm",
                lineHeight: "5",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const disabledOptionStyles = {
    bg: "white",
    color: "text.disabled",
    cursor: "not-allowed",
    "& .select-option-description": {
        color: "text.disabled",
    },
};
const selectOptionTheme = {
    parts: [
        "option",
        "label",
        "checkIcon",
        "lockIcon",
        "labelContainer",
        "description",
    ],
    baseStyle: ({ isHighlighted }) => ({
        option: {
            backgroundColor: isHighlighted ? "base.background" : "white",
            borderRadius: "2xl",
            cursor: "pointer",
            p: 2,
            gap: 2,
            minH: 10,
            display: "flex",
            outline: "none",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, color",
            _disabled: disabledOptionStyles,
        },
        labelContainer: {
            display: "flex",
            flexDirection: "column",
            flex: "1",
            minWidth: 0,
            gap: 0.5,
        },
        label: {
            flex: "1",
            minWidth: 0,
            fontSize: "md",
            lineHeight: "6",
            fontWeight: "medium",
            userSelect: "none",
            my: "auto",
            overflowWrap: "break-word",
            whiteSpace: "pre-wrap",
        },
        description: {
            flex: "1",
            minWidth: 0,
            fontSize: "sm",
            lineHeight: "4",
            userSelect: "none",
            color: "text.secondary",
            fontWeight: "normal",
        },
        checkIcon: {
            color: "primary.base",
            svg: {
                color: "primary.base",
            },
            alignSelf: "center",
            opacity: 0,
        },
        lockIcon: {
            color: "text.disabled",
        },
    }),
    sizes: {
        md: {
            checkIcon: {
                boxSize: 4,
            },
        },
    },
    variants: {
        selected: ({ colorScheme }) => ({
            option: {
                bg: `${colorScheme}.background`,
                color: `${colorScheme}.base`,
                "& .select-option-description": {
                    color: `${colorScheme}.base`,
                },
                "&[data-previous-selected='true']": {
                    // If the option above this one is selected, keep the top border flat
                    borderTopRadius: 0,
                },
                "&[data-next-selected='true']": {
                    // If the option below this one is selected, keep the bottom border flat
                    borderBottomRadius: 0,
                },
                _disabled: disabledOptionStyles,
            },
            checkIcon: {
                opacity: 1,
            },
        }),
        action: {
            option: {
                color: "link.default",
                _disabled: disabledOptionStyles,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const htImageTheme = {
    parts: ["media", "error"],
    baseStyle: {
        media: {
            "&[data-skeleton]": {
                transitionProperty: "opacity",
                transitionDuration: "slow",
                transitionTimingFunction: "linear",
            },
            // Nested selector outranks a caller's height prop, so the loading media collapses under the skeleton.
            "&[data-loading]": {
                height: 0,
                opacity: 0,
            },
        },
        error: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            p: 4,
            bg: "white",
            borderRadius: "sm",
            boxShadow: "xs",
            overflow: "hidden",
            textAlign: "center",
        },
    },
};

const htVideoTheme = {
    baseStyle: {
        outline: "none",
        _focusVisible: {
            boxShadow: "outline",
        },
    },
};

const iconAccessoryTheme = {
    parts: ["container", "accessory", "swatch"],
    baseStyle: {
        container: {
            flex: "none",
            display: "flex",
            alignItems: "flex-start",
        },
        accessory: {
            flex: "none",
            my: "4px",
            alignSelf: "auto",
        },
        swatch: {
            display: "block",
            flex: "none",
            // Centered on the whole row, where an icon aligns with the first line: a swatch stands for the option, not its label.
            alignSelf: "center",
            borderRadius: "sm",
            borderWidth: "hairline",
            borderColor: "base.border",
        },
    },
    sizes: {
        md: {
            accessory: {
                boxSize: 4,
            },
            swatch: {
                boxSize: 4,
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const sharedTransitions = {
    transitionDuration: "faster",
    transitionTimingFunction: "easeOutQuad",
};
const iconBoxTheme = {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `${$borderHairline.reference} solid`,
        flexShrink: 0,
        boxShadow: "xs",
        transitionProperty: "border-color, background-color, color",
        ...sharedTransitions,
        svg: {
            color: "inherit !important", // Important is needed to ensure no other text hover or focus styles are applied.
            transitionProperty: "color",
            ...sharedTransitions,
        },
    },
    variants: {
        default({ isSelected, colorScheme }) {
            return {
                bg: isSelected ? `${colorScheme}.500` : `${colorScheme}.200`,
                borderColor: isSelected ? `${colorScheme}.500` : `${colorScheme}.300`,
                color: isSelected ? "white" : `${colorScheme}.600`,
            };
        },
        // Inverted variants do not support selected states
        inverted({ colorScheme }) {
            return {
                bg: "white",
                borderColor: `${colorScheme}.600`,
                color: `${colorScheme}.600`,
            };
        },
    },
    sizes: {
        xs: {
            boxSize: 4,
            borderRadius: "sm",
            svg: {
                boxSize: 3,
            },
        },
        sm: {
            boxSize: 5,
            borderRadius: "md",
            svg: {
                boxSize: 3,
            },
        },
        md: {
            boxSize: 6,
            borderRadius: "lg",
            svg: {
                boxSize: 4,
            },
        },
        lg: {
            boxSize: 8,
            borderRadius: "lg",
            svg: {
                boxSize: 5,
            },
        },
        xl: {
            boxSize: 10,
            borderRadius: "xl",
            svg: {
                boxSize: 6,
            },
        },
    },
    defaultProps: {
        size: "md",
        variant: "default",
    },
};

const selectOptionsTheme = {
    parts: ["listbox", "container", "list", "item", "footer"],
    baseStyle: ({ isEmpty, hasGroupDividers }) => ({
        listbox: {
            display: "flex",
            flexDirection: "column",
            // Lets the popover's max height reach the scrolling container inside.
            minHeight: 0,
            flex: "1 1 auto",
        },
        container: {
            // An empty listbox stays mounted so `aria-controls` still resolves, but
            // it must take up no room: the empty state renders beside it.
            height: isEmpty ? "auto" : "100%",
            overflowY: "auto",
            borderRadius: "lg",
            scrollbarWidth: "thin",
            py: isEmpty ? 0 : 2,
            // The list clips sideways, so rows carry the side padding for a divider to reach the edges.
            px: isEmpty || hasGroupDividers ? 0 : 2,
        },
        header: {
            display: "flex",
            flexDirection: "column",
            borderBottom: `${$borderHairline.reference} solid`,
            borderColor: "base.border",
            mx: 2,
            px: 2,
            py: 2,
            userSelect: "none",
        },
        list: {
            position: "relative",
            overflowY: "hidden",
        },
        item: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            px: hasGroupDividers ? 2 : 0,
        },
        footer: {
            flexShrink: 0,
            borderTopWidth: "hairline",
            borderTopStyle: "solid",
            borderColor: "base.divider",
            px: 2,
            py: 2,
        },
    }),
    variants: {
        withFooter: {
            container: {
                flex: "1 1 auto",
                minHeight: 0,
                height: "auto",
            },
        },
    },
};

const selectPopoverTheme = {
    baseStyle: ({ hasFooter }) => ({
        background: "white",
        borderRadius: "2xl",
        boxShadow: "lg",
        outline: "none",
        display: "flex",
        flexDirection: "column",
        overscrollBehavior: "contain",
        minWidth: "4xs",
        maxHeight: "320px",
        // A footer pins to the bottom, so the options region scrolls instead.
        overflow: hasFooter ? "hidden" : "auto",
        transform: "auto",
        transformOrigin: "top",
        flex: 1,
    }),
};

const sliderTheme = {
    parts: ["track", "thumb"],
    baseStyle: {
        container: {
            "--slider-thumb-size": "var(--chakra-sizes-4)",
        },
        track: {
            bg: "gray.200",
            height: 0.5,
        },
        thumb: {
            bg: "primary.base",
            _disabled: {
                bg: "base.backgroundDisabled",
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
/**
 * There are a few ways to avoid this, but they all involve weird misuses of the react dom,
 * and because this is a package we publish, this approach seems less prone to complications.
 * The icons are very small.
 */
const xIconURLEncoded = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><mask id="hole"><rect width="100%" height="100%" fill="white"/><path fill-rule="evenodd" fill="black" d="M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/></mask></defs><rect fill="white" width="100%" height="100%" mask="url(%23hole)" /></svg>');`;
const checkIconURLEncoded = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><mask id="hole"><rect width="100%" height="100%" fill="white"/><path fill-rule="evenodd" d="M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z" clip-rule="evenodd"/></mask></defs><rect fill="white" width="100%" height="100%" mask="url(%23hole)" /></svg>');`;
// Disabled variants use gray.500 fill (#8F8A8B) instead of white
const disabledXIconURLEncoded = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><mask id="hole"><rect width="100%" height="100%" fill="white"/><path fill-rule="evenodd" fill="black" d="M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414Z" clip-rule="evenodd"/></mask></defs><rect fill="%238F8A8B" width="100%" height="100%" mask="url(%23hole)" /></svg>');`;
const disabledCheckIconURLEncoded = `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><mask id="hole"><rect width="100%" height="100%" fill="white"/><path fill-rule="evenodd" d="M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z" clip-rule="evenodd"/></mask></defs><rect fill="%238F8A8B" width="100%" height="100%" mask="url(%23hole)" /></svg>');`;
const switchTheme = {
    sizes: {
        sm: {
            track: {
                "--switch-track-width": "24px",
                "--switch-track-height": "16px",
                "--switch-thumb-x": "8px",
            },
            thumb: {
                boxSize: 3,
                backgroundSize: "100%",
            },
        },
        md: {
            track: {
                "--switch-track-width": "40px",
                "--switch-track-height": "24px",
                "--switch-thumb-x": "16px",
            },
            thumb: {
                boxSize: 5,
            },
        },
    },
    baseStyle: {
        track: {
            bg: "gray.400",
            boxSizing: "border-box",
            _disabled: {
                opacity: 1,
                bg: "gray.200",
            },
            _hover: {
                bg: "gray.500",
                _disabled: {
                    bg: "gray.200",
                },
            },
            _checked: {
                bg: "primary.base",
                _disabled: {
                    bg: "gray.200",
                },
                _hover: {
                    bg: "primary.hover",
                    _disabled: {
                        bg: "gray.200",
                    },
                },
            },
            _focusVisible: {
                boxShadow: "outline",
            },
        },
        thumb: {
            transitionDuration: "fast",
            transitionTimingFunction: "easeInOutCubic",
            transitionProperty: "transform, background-image",
            boxShadow: "sm",
            bg: "transparent",
            // There's a super weird bug in chakra that forces us to use the kebab case here: https://github.com/chakra-ui/chakra-ui/issues/7548
            "background-image": xIconURLEncoded,
            backgroundSize: "90%",
            backgroundPosition: "center",
            _checked: {
                "background-image": checkIconURLEncoded,
            },
            // _disabled doesn't work on thumb because only the track gets data-disabled attribute.xw
            "[data-disabled] &": {
                "background-image": disabledXIconURLEncoded,
            },
            "[data-disabled][data-checked] &": {
                "background-image": disabledCheckIconURLEncoded,
            },
        },
    },
    defaultProps: {
        colorScheme: null,
    },
    variants: {
        upsell: {
            track: {
                bg: themeColors.gradients.upsell.background,
                _hover: {
                    bg: themeColors.gradients.upsell.backgroundHover,
                },
                _checked: {
                    _hover: {
                        bg: themeColors.gradients.upsell.hover,
                    },
                    bg: themeColors.gradients.upsell.primary,
                },
            },
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const tabListStyles = {
    borderBottom: `${$borderHairline.reference} solid`,
    borderColor: "base.divider",
    gap: 6,
};
const tabIndicatorStyles = {
    position: "absolute",
    bottom: "0px",
    left: "0.5px", // 0.5px prevents the border from extending beyond the `TabIndicator`
    right: "0.5px",
    h: "1px",
    bg: "transparent",
    transitionDuration: "fast",
    transitionTimingFunction: "easeOutQuad",
    transitionProperty: "background-color, height",
};
const tabDisabledStyles = {
    cursor: "not-allowed",
    color: "text.disabled",
    _hover: {
        color: "text.disabled",
        _before: {
            bg: "none",
        },
    },
};
const tabSelectedStyles = {
    color: "primary.base",
    _hover: {
        color: "primary.base",
        _before: {
            bg: "primary.base",
            h: "1.5px",
        },
    },
};
const tabStyles = {
    ...buttonTheme.baseStyle,
    display: "flex",
    position: "relative",
    outline: "none",
    fontWeight: "medium",
    h: 10,
    mb: "-0.5px",
    px: 0,
    py: 0,
    color: "text.secondary",
    border: "none",
    transitionDuration: "fast",
    transitionTimingFunction: "easeOutQuad",
    transitionProperty: "color",
    _before: {
        content: "''",
        ...tabIndicatorStyles,
    },
    _hover: {
        color: "text.primary",
        _before: {
            bg: "base.borderHover",
        },
    },
    _focus: {
        bg: "none",
        // Override app styles
        outline: "none !important",
    },
    _focusVisible: {
        boxShadow: "outline",
    },
    // Override button styles and ignore scaling on click for tabs.
    _active: { transform: "none" },
};
const tabSkeletonStyles = {
    h: 6,
    my: 2,
    minW: 10,
    borderRadius: "md",
};
const tabsTheme = {
    parts: ["root", "tabpanel", "tablist", "tab", "skeleton", "tabpanels"],
    baseStyle: {
        tabpanel: {
            px: 0,
        },
    },
    variants: {
        line: {
            tablist: tabListStyles,
            tab: {
                ...tabStyles,
                _disabled: tabDisabledStyles,
                _selected: tabSelectedStyles,
            },
            skeleton: tabSkeletonStyles,
        },
    },
};

const tablistStyles = {
    ...tabListStyles,
    borderBottom: "none",
    display: "flex",
    listStyleType: "none",
    p: 0,
};
const tabNavTheme = {
    parts: [
        "root",
        "tablist",
        "tabLink",
        "collapsibleTab",
        "collapsedTab",
        "overflowTrigger",
        "overflowMenu",
        "tabLinkContent",
        "tabLinkCount",
        "tabIndicator",
        "skeleton",
    ],
    baseStyle: ({ isActive, isDisabled }) => ({
        root: {
            borderBottom: `${$borderHairline.reference} solid`,
            borderColor: "base.divider",
        },
        tablist: tablistStyles,
        tabLink: {
            ...buttonTheme.sizes.md,
            ...tabStyles,
            ...(isDisabled ? tabDisabledStyles : {}),
            ...(isActive ? tabSelectedStyles : {}),
            cursor: isDisabled ? "not-allowed" : "pointer",
        },
        collapsibleTab: { flexShrink: 0, whiteSpace: "nowrap" },
        collapsedTab: {
            display: "flex",
            alignItems: "center",
            width: "100%",
            px: 2,
            py: 1.5,
            borderRadius: "lg",
            // Match tabLink's size (buttonTheme.sizes.md); without it the row inherits
            // the larger ambient popover font.
            fontSize: "md",
            fontWeight: "medium",
            color: isDisabled
                ? "text.disabled"
                : isActive
                    ? "primary.base"
                    : "text.primary",
            bg: isActive ? "primary.background" : "transparent",
            cursor: isDisabled ? "not-allowed" : "pointer",
            outline: "none",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, color",
            ...(isDisabled
                ? {}
                : { _hover: { bg: "base.background", color: "text.primary" } }),
            _focusVisible: { boxShadow: "outline" },
        },
        overflowTrigger: {
            flexShrink: 0,
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
        },
        overflowMenu: {
            listStyleType: "none",
            paddingInlineStart: 0,
            display: "flex",
            flexDirection: "column",
        },
        tabLinkContent: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            pos: "relative",
        },
        tabLinkCount: {
            display: "flex",
            alignItems: "center",
        },
        tabIndicator: {
            ...tabIndicatorStyles,
            bg: "primary.base",
            height: "2px",
            zIndex: 10,
        },
        skeleton: tabSkeletonStyles,
    }),
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const tabbedComboboxTheme = {
    parts: ["tabList", "tabPanel", "tabSearchContainer", "tabGroup", "divider"],
    baseStyle: {
        tabList: {
            padding: 2,
            width: "160px",
            flexShrink: 0,
            borderRight: `${$borderHairline.reference} solid`,
            borderColor: "base.divider",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            overflow: "auto",
        },
        tabGroup: {
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            "&:not(:first-of-type)": {
                mt: 2,
            },
        },
        tabPanel: {
            // Originally from the SelectPopover component
            display: "flex",
            flexDirection: "column",
            overscrollBehavior: "contain",
            minWidth: "4xs",
            maxHeight: "336px",
            overflow: "auto",
            transform: "auto",
            transformOrigin: "top",
            flex: 1,
            width: "100%",
        },
        tabSearchContainer: {
            px: 2,
            py: 3,
            borderBottom: `${$borderHairline.reference} solid`,
            borderColor: "base.divider",
        },
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};

const tabbedComboboxTabTheme = {
    parts: ["button", "label"],
    baseStyle: {
        button: {
            backgroundColor: "white",
            color: "text.primary",
            borderRadius: "2xl",
            cursor: "pointer",
            px: 2,
            py: 2,
            minH: 10,
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 2,
            outline: "none",
            transitionDuration: "fast",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color",
            _hover: {
                bg: "base.background",
            },
            _disabled: {
                color: "text.disabled",
                cursor: "not-allowed",
                "& .select-option-description": {
                    color: "text.disabled",
                },
            },
        },
        label: {
            fontSize: "md",
            fontWeight: "medium",
            lineHeight: 4,
            userSelect: "none",
            letterSpacing: "0",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
    },
    variants: {
        selected({ colorScheme }) {
            return {
                button: {
                    bg: `${colorScheme}.background`,
                    _hover: {
                        bg: `${colorScheme}.background`,
                    },
                },
                label: {
                    color: `${colorScheme}.base`,
                },
            };
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const tabbedComboboxPopoverTheme = {
    baseStyle: {
        background: "white",
        border: `${$borderHairline.reference} solid`,
        borderColor: "base.border",
        borderRadius: "2xl",
        boxShadow: "lg",
        outline: "none",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        height: "336px",
    },
};

const tableTheme = {
    sizes: {
        md: {
            th: {
                fontSize: "sm",
                ":first-of-type": {
                    pl: 0,
                },
            },
            td: {
                fontSize: "md",
                ":first-of-type": {
                    pl: 0,
                },
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

const textareaTheme = {
    baseStyle: {},
    variants: {
        outline: {
            borderColor: "base.border",
            borderRadius: "lg",
            borderWidth: "hairline",
            bg: $surfaceBg.reference,
            boxShadow: "buttonShadowLight",
            color: "text.primary",
            px: 2,
            py: 1.5,
            _hover: {
                borderColor: $surfaceBorderHover.reference,
                _disabled: {
                    borderColor: "base.borderDisabled",
                },
                _invalid: {
                    borderColor: "danger.border",
                },
            },
            _disabled: {
                opacity: 1,
                bg: "base.backgroundDisabled",
                color: "text.disabled",
            },
            _invalid: {
                borderColor: "danger.border",
                boxShadow: "buttonShadowLight",
            },
            _focus: {
                bg: $surfaceBgHover.reference,
                borderColor: "primary.base",
                boxShadow: "outline",
                _invalid: {
                    boxShadow: "outlineRed",
                    borderColor: "danger.border",
                },
            },
            _focusVisible: {
                boxShadow: "outline",
            },
            _placeholder: {
                color: "text.placeholder",
            },
        },
        addon: {
            bg: "base.lightBackground",
            color: "text.tertiary",
        },
    },
};

const tieredProgressBarTheme = {
    parts: ["container", "pill", "completedFill", "pendingFill"],
    baseStyle: {
        container: {
            display: "flex",
            gap: 1,
        },
        pill: {
            flex: "1",
            h: 2,
            bg: "base.backgroundDisabled",
            borderRadius: "lg",
            overflow: "hidden",
            position: "relative",
        },
        completedFill: {
            position: "absolute",
            inset: 0,
            bg: "primary.base",
            borderRadius: "lg",
        },
        pendingFill: {
            position: "absolute",
            inset: 0,
            bg: "teal.200",
            borderRadius: "lg",
        },
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const toggleButtonTheme = {
    parts: ["button", "icon", "label"],
    baseStyle: {
        button: {
            mt: "0",
            border: `${$borderHairline.reference} solid`,
            borderColor: "base.border",
            boxShadow: "buttonShadowLight",
            color: "text.tertiary",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontWeight: "medium",
            pos: "relative",
            transitionDuration: "faster",
            transitionTimingFunction: "easeOutQuad",
            transitionProperty: "background-color, color",
            _focusVisible: {
                boxShadow: "outline",
            },
            _hover: {
                background: "base.lightBackground",
            },
            _active: {
                color: "primary.hover",
                background: "primary.background",
                borderColor: "primary.border",
            },
            _checked: {
                color: "primary.base",
                background: "primary.background",
                borderColor: "primary.border",
            },
            _disabled: {
                color: "text.disabled",
                cursor: "not-allowed",
                background: "white",
                _hover: {
                    background: "white",
                },
                _checked: {
                    color: "text.primary",
                    background: "gray.200",
                },
                _active: {
                    background: "white",
                    _checked: {
                        background: "gray.200",
                    },
                },
                _focusVisible: {
                    boxShadow: "outline",
                },
                svg: {
                    color: "text.disabled",
                },
            },
        },
        icon: {
            color: "inherit",
        },
    },
    sizes: {
        sm: {
            button: {
                height: "6",
                fontSize: "sm",
                lineHeight: "4",
                gap: "1",
                px: "2",
            },
            icon: {
                boxSize: "4",
            },
        },
        md: {
            button: {
                height: "8",
                fontSize: "md",
                lineHeight: "5",
                gap: "2",
                px: "4",
            },
            icon: {
                boxSize: "6",
            },
        },
        lg: {
            button: {
                height: "16",
                fontSize: "md",
                px: "4",
                lineHeight: "5",
                gap: "2",
                flexDir: "column",
            },
        },
    },
    variants: {
        segmented: {
            button: {
                borderLeft: "none",
                _first: {
                    borderTopLeftRadius: "lg",
                    borderBottomLeftRadius: "lg",
                    borderLeft: `${$borderHairline.reference} solid`,
                    borderColor: "base.border",
                },
                _last: {
                    borderTopRightRadius: "lg",
                    borderBottomRightRadius: "lg",
                },
            },
        },
        separated: { button: { borderRadius: "md" } },
    },
    defaultProps: {
        size: "md",
    },
};

const tooltipTheme = {
    baseStyle: {
        "--tooltip-bg": "var(--chakra-colors-base-containerBackground)",
        px: 2.5,
        py: 1,
        backdropFilter: "blur(8px)",
        boxShadow: "darkPopover",
        borderRadius: "lg",
        fontSize: "sm",
        fontWeight: "medium",
        lineHeight: "4",
        textAlign: "center",
    },
};

const wizardStepTheme = {
    parts: ["container", "step"],
    baseStyle: {
        container: {
            display: "flex",
            alignItems: "center",
            gap: 2,
            outline: "none !important",
            _disabled: {
                cursor: "not-allowed",
            },
        },
        step: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: 8,
            height: 8,
            background: "base.background",
            borderRadius: "md",
        },
    },
    variants: {
        active: {
            step: {
                background: "primary.base",
                boxShadow: "buttonShadow",
            },
        },
    },
};

const wizardStepsTheme = {
    baseStyle: {
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const upsellCardTheme = {
    parts: [
        "container",
        "title",
        "actionContainer",
        "extendedContainer",
        "extendedContent",
        "extendedMediaWrapper",
        "extendedImage",
        "extendedVideoWrapper",
        "extendedVideoOverlay",
        "extendedVideoButton",
        "extendedVideo",
    ],
    baseStyle: {
        container: {
            border: `${$borderHairline.reference} solid`,
            borderColor: "purple.100",
            borderRadius: "xl",
            bg: "purple.50",
            px: 6,
            py: 4,
        },
        title: {
            color: "upsell.base",
            fontSize: "xl",
            lineHeight: "6",
            fontWeight: "medium",
            mt: 4,
            mb: 2,
        },
        actionContainer: {
            mt: 6,
        },
        extendedContainer: {
            display: "flex",
            alignItems: "center",
            gap: 12,
        },
        extendedContent: {
            flex: 1,
            minWidth: 0,
        },
        extendedMediaWrapper: {
            flex: "none",
            width: "sm",
            position: "relative",
        },
        extendedVideoOverlay: {
            position: "absolute",
            inset: 0,
            bg: "blackAlpha.60",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "xl",
        },
        extendedVideoButton: {
            boxSize: 12,
            borderRadius: "xl",
            pos: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "60px",
            color: "white",
            _focus: {
                outline: "none",
            },
            _focusVisible: {
                outline: "none",
                boxShadow: "outline",
            },
        },
        extendedVideo: {
            borderRadius: "xl",
            overflow: "hidden",
            _focus: {
                outline: "none !important",
            },
            _focusVisible: {
                outline: "none !important",
                boxShadow: "outline",
            },
        },
        extendedImage: {
            borderRadius: "xl",
            overflow: "hidden",
            maxWidth: "100%",
        },
    },
};

// Derive border + appended-cell background as translucent washes of the
// resolved text color, with chroma pumped so colored variants read as vibrant
// rather than washed-out (grays stay gray — chroma × n = 0). Contrast comes
// from whatever paint is behind the Variable, so the component stays readable
// on both light- and dark-themed surfaces.
const DERIVED_BORDER = "oklch(from currentColor l calc(c * 1.4) h / 0.4)";
// Alpha scales linearly with the text's lightness so light text on dark
// surfaces gets a stronger wash (~20% at L=1) than dark text on light
// surfaces (~13% at L=0.3, the typical text.primary).
const DERIVED_CELL_BG = "oklch(from currentColor l calc(c * 1.6) h / calc(0.1 + l * 0.1))";
const DASHED_BORDER = {
    borderLeft: "1px dashed",
    borderLeftColor: DERIVED_BORDER,
};
// Shared layout for every box inside the pill (the name, the filter group, and
// the individual filter cells).
const BOX_LAYOUT = {
    display: "inline-flex",
    alignItems: "center",
    overflow: "hidden",
    height: "100%",
};
const variableTheme = {
    baseStyle({ color }) {
        return {
            display: "inline-flex",
            alignItems: "center",
            border: "1px dashed",
            borderColor: DERIVED_BORDER,
            borderRadius: "sm",
            maxW: "100%",
            overflow: "hidden",
            textTransform: "none",
            whiteSpace: "nowrap",
            width: "fit-content",
            fontWeight: "medium",
            fontSize: "calc(1em - 1px)",
            lineHeight: 1.5,
            height: "1.71em",
            minWidth: "1.71em",
            color: color ?? "inherit",
            textStyle: "mono",
            "& .chakra-text": {
                color: "inherit",
                fontSize: "inherit",
                lineHeight: "inherit",
            },
            // Parts are targeted by class name (set by the component) rather than by
            // structural selectors. The name and each filter cell carry the padding.
            "& .variable-cell": {
                ...BOX_LAYOUT,
                // Linear scale: padding = 0.5 × fontSize − 4px
                // (children's em is 1px smaller than parent's, hence 3.5px offset)
                // 12px => 2px, 16px => 4px, 24px => 8px
                px: "calc(0.5em - 3.5px)",
            },
            // The appended filter group reads as filled; its cells own the padding.
            "& .variable-group": {
                ...BOX_LAYOUT,
                bg: DERIVED_CELL_BG,
            },
            // A dashed divider before the group (from the name) and before the `+N`
            // count (from the first filter).
            "& .variable-divider": DASHED_BORDER,
        };
    },
};

const components = {
    AgentActivity: agentActivityTheme,
    AgentCard: agentCardTheme,
    ApprovalCard: approvalCardTheme,
    AgentActivityRow: agentActivityRowTheme,
    Alert: alertTheme,
    AskUserCard: askUserCardTheme,
    AskUserCardOption: askUserCardOptionTheme,
    AutoWidthInput: autoWidthInputTheme,
    Avatar: avatarTheme,
    Badge: badgeTheme,
    BadgeInput: badgeInputTheme,
    Breadcrumbs: breadcrumbsTheme,
    Button: buttonTheme,
    Checkbox: checkboxTheme,
    Code: codeTheme,
    Combobox: comboboxTheme,
    Dialog: dialogTheme,
    Definition: definitionTheme,
    Drawer: drawerTheme,
    EditableDescription: editableDescriptionTheme,
    EditableHeading: editableHeadingTheme,
    EditableText: editableTextTheme,
    FilterOptionList: filterOptionListTheme,
    FilterPill: filterPillTheme,
    Form: formTheme,
    FormError: formErrorTheme,
    FormLabel: formLabelTheme,
    GlobalAnnouncement: globalAnnouncementTheme,
    GlobalAnnouncementPopover: globalAnnouncementPopoverTheme,
    Heading: headingTheme,
    HightouchIcon: hightouchIconTheme,
    Input: inputTheme,
    InputGroup: inputGroupTheme,
    Kbd: kbdTheme,
    LabelBadgeGroup: labelBadgeGroupTheme,
    Link: linkTheme,
    LinkTextButton: linkTextButtonTheme,
    Menu: menuTheme,
    Modal: modalTheme,
    Progress: progressTheme,
    PromptInputPill: promptInputPillTheme,
    Radio: radioTheme,
    SegmentedControl: segmentedControlTheme,
    SegmentedControlOption: segmentedControlOptionTheme,
    Select: selectTheme,
    SelectClearButton: selectClearButtonTheme,
    SelectEmptyState: selectEmptyStateTheme,
    SelectGroup: selectGroupTheme,
    SelectOption: selectOptionTheme,
    HtImage: htImageTheme,
    HtVideo: htVideoTheme,
    IconAccessory: iconAccessoryTheme,
    IconBox: iconBoxTheme,
    SelectOptions: selectOptionsTheme,
    SelectPopover: selectPopoverTheme,
    Slider: sliderTheme,
    Switch: switchTheme,
    TabNav: tabNavTheme,
    TabbedCombobox: tabbedComboboxTheme,
    TabbedComboboxTab: tabbedComboboxTabTheme,
    TabbedComboboxPopover: tabbedComboboxPopoverTheme,
    Table: tableTheme,
    Tabs: tabsTheme,
    Text: textTheme,
    Textarea: textareaTheme,
    TieredProgressBar: tieredProgressBarTheme,
    ToggleButton: toggleButtonTheme,
    Tooltip: tooltipTheme,
    UpsellCard: upsellCardTheme,
    Variable: variableTheme,
    WizardStep: wizardStepTheme,
    WizardSteps: wizardStepsTheme,
};

const breakpoints = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
};

// Radius scale from https://www.figma.com/design/VcoQ7yfQmwhXZqr8TwDzRC/Styles-2?node-id=7495-1951&t=3tf6DG33KXUlIWWz-1
/**
 * Radius scales with element height — smaller elements get tighter corners.
 * Nesting rounded containers: outer radius = inner radius + padding, so the curves stay concentric.
 */
const radii = {
    /** 2px — elements 8px tall and smaller. */
    xs: "2px",
    /** 4px — elements around 16px tall. */
    sm: "4px",
    /** 6px — elements around 20px tall. */
    md: "6px",
    /** 8px — elements around 24px tall. */
    lg: "8px",
    /** 10px — elements around 40px tall. */
    xl: "10px",
    /** 12px — elements 64px tall and larger. */
    "2xl": "12px",
    /** 16px — decorative, for surfaces that need more rounding than 2xl. */
    "3xl": "16px",
    /** 20px — decorative, for large surfaces or cards with extra rounding. */
    "4xl": "20px",
    /** 24px — decorative, for hero surfaces or prominent containers. */
    "5xl": "24px",
    /** 9999px — pills and circles. */
    full: "9999px",
};

/** Shadows convey elevation — pick by how far the surface sits above the canvas. Never transition or animate box-shadow. */
const shadows = {
    none: "none",
    /** Items that sit directly on top of the canvas (checkboxes, icon boxes, segmented controls); no white inset border like buttonShadowLight. */
    xs: `0 0 0 ${$borderHairline.reference} rgba(0,0,0, 0.08) inset,lch(0 0 0 / 0.020) 0px 3px 6px -2px, lch(0 0 0 / 0.040) 0px 2px 1px -1px;`,
    /** Cards and UI elements that hover or sit above the canvas. */
    sm: "0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.12);",
    /** Menus and popovers. */
    md: "0px 0px 1px 0px rgba(0, 0, 0, 0.20), 0px 1px 6px 0px rgba(0, 0, 0, 0.04), 0px 12px 20px -2px rgba(0, 0, 0, 0.06)",
    /** Modals and drawers. */
    lg: "0px 24px 32px 0px rgba(0, 0, 0, 0.04), 0px 16px 24px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 1px 0px rgba(0, 0, 0, 0.20)",
    /** The focus ring — apply via `_focusVisible={{ boxShadow: "outline" }}`; never signal focus with a border. */
    outline: "0px 0px 0px 1px rgba(255, 255, 255),0px 0px 0px 2px var(--chakra-colors-primary-background), 0px 0px 0px 3px var(--chakra-colors-primary-border)",
    /** Inset focus ring for compact controls whose parent clips an outward ring. */
    outlineInset: "inset 0 0 0 var(--chakra-space-px) var(--chakra-colors-primary-border), inset 0 0 0 var(--chakra-space-0-5) var(--chakra-colors-primary-background)",
    /** Focus ring for error states (e.g. an invalid field). */
    outlineRed: "0px 0px 0px 2px rgba(255, 255, 255), 0px 0px 0px 3px var(--chakra-colors-danger-base)",
    /** Focus ring for warning states. */
    outlineYellow: "0px 0px 0px 2px rgba(255, 255, 255), 0px 0px 0px 3px var(--chakra-colors-warning-base)",
    /** Primary and themed buttons. */
    buttonShadow: "0px 0px 0px 1px rgba(0, 0, 0, 0.32) inset, 0px 0px 0px 1.5px rgba(255, 255, 255, 0.16) inset, lch(0 0 0 / 0.022) 0px 3px 6px -2px, lch(0 0 0 / 0.044) 0px 1px 1px;",
    /** Inputs, forms, and secondary buttons. */
    buttonShadowLight: "lch(0 0 0 / 0.022) 0px 3px 6px -2px, lch(0 0 0 / 0.044) 0px 1px 1px;",
    /** Action bars, tooltips, and toasts. */
    darkPopover: "0 0 0 0.75px rgba(0, 0, 0, 0.40) inset, 0 0 0 1.5px rgba(255, 255, 255, 0.24) inset, 0 8px 24px 0 rgba(0, 0, 0, 0.20), 0 2px 8px 0 rgba(0, 0, 0, 0.08)",
    /** Sticky headers — fades content scrolling beneath a white header. */
    fadeDown: "0 16px 16px 0 rgba(255, 255, 255, 1), 0 12px 16px 4px rgba(255, 255, 255, 1)",
    /** Content overlays with a white background — fades content beneath a bottom overlay. */
    fadeUp: "0 -16px 16px 0 rgba(255, 255, 255, 1), 0 -12px 16px 4px rgba(255, 255, 255, 1)",
};

const sizes = {
    ...theme$1.sizes,
    "0.5": "2px",
    "1": "4px",
    "1.5": "6px",
    "2": "8px",
    "2.5": "10px",
    "3": "12px",
    "3.5": "14px",
    "4": "16px",
    "5": "20px",
    "6": "24px",
    "7": "28px",
    "8": "32px",
    "9": "36px",
    "10": "40px",
    "12": "48px",
    "14": "56px",
    "16": "64px",
    "20": "80px",
    "24": "96px",
    "28": "112px",
    "32": "128px",
    "36": "144px",
    "40": "160px",
    "44": "176px",
    "48": "192px",
    "52": "208px",
    "56": "224px",
    "60": "240px",
    "64": "256px",
    "72": "288px",
    "80": "320px",
    "96": "384px",
    "4xs": "192px",
    "3xs": "224px",
    "2xs": "256px",
    xs: "320px",
    sm: "384px",
    md: "448px",
    lg: "512px",
    xl: "576px",
    "2xl": "672px",
    "3xl": "768px",
    "4xl": "896px",
    "5xl": "1024px",
    "6xl": "1152px",
    "7xl": "1280px",
    "8xl": "1440px",
};

const typography = {
    /**
     * Lausanne (body/heading) registers each font cut one CSS weight step up: the
     * Lausanne-300 file is `normal` (400), Lausanne-400 is `medium` (500), and
     * Lausanne-500 is `semibold` (600). Figma reports the file cut as its numeric
     * weight, so CSS weight = Figma weight + 100 — map Figma text styles by name
     * (`sm medium` → `fontWeight="medium"`), never by copying the number.
     * DM Mono has no offset (Regular → 400, Medium → 500).
     * No bolder cut ships — `bold` (700) has no face of its own and falls back to
     * the semibold registration (or browser-synthesized fake bold), so `semibold`
     * is the heaviest designed weight.
     */
    fonts: {
        ...theme$1.fonts,
        body: "Lausanne, system-ui, sans-serif",
        heading: "Lausanne, system-ui, sans-serif",
        mono: "DM Mono, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    },
    fontSizes: {
        sm: "12px",
        md: "14px",
        lg: "16px",
        xl: "18px",
        "2xl": "20px",
        "3xl": "24px",
        "4xl": "32px",
    },
    lineHeights: {
        normal: "normal",
        none: 1,
        "4": "16px",
        "5": "20px",
        "6": "24px",
        "8": "32px",
        "12": "48px",
        avatarSm: "20px",
        avatarMd: "24px",
        avatarLg: "32px",
        avatarXl: "40px",
    },
    textStyles: {
        mono: {
            fontFamily: "mono",
            fontFeatureSettings: "'salt' on, 'ss01' on, 'ss02' on, 'ss03' on, 'ss04' on, 'ss05' on",
            WebkitFontFeatureSettings: "'salt' on, 'ss01' on, 'ss02' on, 'ss03' on, 'ss04' on, 'ss05' on",
            MozFontFeatureSettings: "'salt' on, 'ss01' on, 'ss02' on, 'ss03' on, 'ss04' on, 'ss05' on",
        },
        numeric: {
            fontFamily: "body",
            fontVariantNumeric: "lining-nums tabular-nums slashed-zero",
        },
    },
};

/**
 * Per-token when-to-use guidance lives in the individual foundation modules' JSDoc —
 * see colors, radius, borders, shadows, and transition (this aggregate carries none of it).
 */
const foundations = {
    ...typography,
    borderWidths,
    breakpoints,
    sizes,
    space,
    radii,
    shadows,
    transition,
    colors: {
        ...pick(theme$1.colors, ["white", "black", "current", "transparent"]),
        ...themeColors,
    },
};

// biome-ignore-all lint/plugin/no-relative-import-paths: this repo does not configure an import alias
const theme = {
    ...theme$1,
    ...foundations,
    components: mergeThemeOverride({}, omit(theme$1.components, "Radio", "Select"), {
        ...components,
    }),
    styles: {
        global: {
            ...theme$1.styles.global,
            body: {
                bg: "chakra-body-bg",
                color: "chakra-body-text",
                fontFamily: "body",
                transitionDuration: "normal",
                transitionProperty: "background-color",
                transitionTimingFunction: "easeOutQuad",
            },
            // Brand text selection (mirrors the app's global styles). Separate keys on
            // purpose: combining `::selection, ::-moz-selection` in one selector would
            // invalidate the whole rule in browsers that don't recognize the prefix.
            "::selection": {
                bg: "primary.background",
                color: "primary.hover",
            },
            "::-moz-selection": {
                bg: "primary.background",
                color: "primary.hover",
            },
            ":root": {
                "--chakra-colors-chakra-body-text": "var(--chakra-colors-text-primary) !important",
                "--chakra-colors-chakra-border-color": "var(--chakra-colors-gray-300) !important",
                ...surfaceVars.light,
                [$borderHairline.variable]: "1px",
            },
            "@media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi)": {
                ":root": {
                    [$borderHairline.variable]: "0.5px",
                },
            },
        },
    },
};

function ThemeProvider({ children }) {
    return (jsx(ChakraProvider, { theme: theme, children: jsx(MotionConfig, { reducedMotion: "user", children: jsx(MotionConfig$1, { reducedMotion: "user", children: jsxs(Provider, { children: [children, jsx(Toaster, {})] }) }) }) }));
}

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const fillTween = {
    duration: motionDurations.normal,
    ease: motionEasings.easeOutExpo,
};
const instantTween = { duration: 0 };
function TieredProgressBar({ segments, "aria-label": ariaLabel, ...props }) {
    const styles = useMultiStyleConfig("TieredProgressBar", {});
    const shouldReduceMotion = useReducedMotion();
    const fillTransition = shouldReduceMotion ? instantTween : fillTween;
    if (segments.length === 0) {
        return null;
    }
    return (jsx(Box$1, { __css: styles.container, role: "group", "aria-label": ariaLabel, ...props, children: segments.map((segment, index) => {
            const completed = clamp(segment.completed, 0, 100);
            const pending = clamp(segment.pending ?? 0, 0, 100 - completed);
            const total = completed + pending;
            const valueText = pending > 0
                ? `${completed}% complete, ${pending}% pending`
                : undefined;
            const hasTooltip = segment.tooltip !== undefined;
            const pill = (jsxs(Box$1, { __css: styles.pill, tabIndex: hasTooltip ? 0 : undefined, role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": completed, "aria-valuetext": valueText, "aria-label": `Segment ${index + 1}`, children: [pending > 0 && (jsx(MotionBox, { __css: styles.pendingFill, style: { willChange: "transform" }, initial: false, animate: { x: `-${100 - total}%` }, transition: fillTransition })), jsx(MotionBox, { __css: styles.completedFill, style: { willChange: "transform" }, initial: false, animate: { x: `-${100 - completed}%` }, transition: fillTransition })] }));
            if (hasTooltip) {
                return (
                // biome-ignore lint/suspicious/noArrayIndexKey: segments are a fixed-order list with no identity
                jsx(Tooltip, { message: segment.tooltip, children: pill }, index));
            }
            // biome-ignore lint/suspicious/noArrayIndexKey: segments are a fixed-order list with no identity
            return jsx(Fragment$1, { children: pill }, index);
        }) }));
}

const ToggleButtonGroupVariantContext = createContext("segmented");
// biome-ignore lint/style/useComponentExportOnlyModules: companion hook ships alongside the component
const useToggleButtonGroupVariant = () => useContext(ToggleButtonGroupVariantContext);
function ToggleButtonGroup({ isDisabled, children, width, variant = "segmented", ...props }) {
    return (jsx(ToggleButtonGroupVariantContext.Provider, { value: variant, children: jsx(RadioGroup$1, { isDisabled: isDisabled, width: width ?? "fit-content", ...props, children: variant === "segmented" ? (jsx(Stack, { align: "start", direction: "row", spacing: 0, children: children })) : (jsx(Row, { gap: 2, children: children })) }) }));
}

const ToggleButton = forwardRef$1(function ToggleButton_({ "aria-label": ariaLabel, accessory, isDisabled, label, value, tooltip }, ref) {
    const group = useRadioGroupContext();
    const variant = useToggleButtonGroupVariant();
    const styles = useMultiStyleConfig("ToggleButton", {
        size: group.size,
        variant,
    });
    const { getRadioProps, getLabelProps, getInputProps } = useRadio({
        isChecked: group.value === value,
        isFocusable: group.isFocusable,
        isDisabled: isDisabled || group.isDisabled,
        name: group.name,
        value,
        onChange: group.onChange,
    });
    const tooltipProps = {
        message: null,
        ...tooltip,
    };
    return (jsx(Tooltip, { isDisabled: !tooltip, ...tooltipProps, children: jsxs(chakra.label, { ref: ref, ...getRadioProps(), "aria-hidden": "false", "aria-label": ariaLabel, flex: "auto", __css: styles["button"], children: [jsx("input", { ...getInputProps() }), accessory && jsx(IconAccessory, { accessory: accessory }), label && jsx(chakra.span, { ...getLabelProps(), children: label })] }) }));
});
ToggleButton.displayName = "ToggleButton";

const UpsellButton = forwardRef$1(function UpsellButton_({ children, isLoading = false, isDisabled = false, isJustified = false, size = "md", icon, isExternal, ...props }, ref) {
    const isAnchor = Boolean(props.href);
    const sharedProps = {
        isLoading,
        disabled: isLoading || isDisabled,
        variant: "upsell",
        leftIcon: icon ? jsx(Icon, { as: icon, boxSize: 4 }) : undefined,
        width: isJustified ? "100%" : undefined,
        size,
        ...props,
    };
    if (isAnchor) {
        return (jsx(Button$1, { ref: ref, as: "a", href: props.href, target: isExternal ? "_blank" : undefined, rel: isExternal ? "noopener noreferrer" : undefined, ...sharedProps, children: children }));
    }
    return (jsx(Button$1, { ref: ref, ...sharedProps, children: children }));
});
UpsellButton.displayName = "UpsellButton";

function UpsellCard({ badgeText, title, children, actions, ...props }) {
    const styles = useMultiStyleConfig("UpsellCard");
    return (jsxs(Box$1, { __css: styles["container"], ...props, children: [jsx(Badge, { variant: "upsell", children: badgeText }), jsx(Box$1, { as: "h3", __css: styles["title"], children: title }), children, jsx(Box$1, { __css: styles["actionContainer"], children: actions })] }));
}

function UpsellHeading({ children, size = "md", ...props }) {
    return (jsx(Heading$1, { variant: "upsell", size: `upsell-${size}`, ...props, children: children }));
}

function UpsellSuccessDialog({ isOpen, title, children, buttonText, onClose, }) {
    const closeButton = useRef(null);
    return (jsx(AlertDialog, { isOpen: isOpen, leastDestructiveRef: closeButton, onClose: onClose, children: jsxs(AlertDialogOverlay, { children: [jsx(Box$1, { as: Fireworks, options: { opacity: 0.5, intensity: 15 }, position: "fixed", width: "100%", height: "100%", top: 0, left: 0 }), jsxs(AlertDialogContent, { w: "sm", motionProps: popoverVariants, children: [jsxs(Box$1, { boxSize: 16, position: "relative", mx: "auto", display: "flex", alignItems: "center", justifyContent: "center", children: [jsx(MotionBox, { position: "absolute", top: 0, left: 0, zIndex: 1, width: 16, height: 16, borderRadius: "full", bg: "green.200", initial: {
                                        scale: 0,
                                        opacity: 1,
                                    }, animate: {
                                        scale: 1.5,
                                        opacity: 0,
                                    }, transition: {
                                        scale: {
                                            type: "spring",
                                            damping: 30,
                                            stiffness: 50,
                                            delay: 0.3,
                                        },
                                        opacity: {
                                            type: "tween",
                                            duration: 1.8,
                                            delay: 0.3,
                                        },
                                    } }), jsx(MotionBox, { boxSize: 14, zIndex: 2, borderRadius: "full", bg: "green.200", display: "flex", alignItems: "center", justifyContent: "center", initial: {
                                        scale: 0.5,
                                        opacity: 0,
                                    }, animate: {
                                        scale: 1,
                                        opacity: 1,
                                    }, transition: {
                                        type: "spring",
                                        damping: 30,
                                        stiffness: 600,
                                        delay: 0.3,
                                    }, children: jsx(MotionSvg, { boxSize: 8, fill: "none", viewBox: "0 0 24 24", stroke: "green.600", strokeWidth: "2.5", strokeDasharray: "30", initial: {
                                            strokeDashoffset: 30,
                                        }, animate: {
                                            strokeDashoffset: 0,
                                        }, transition: {
                                            type: "spring",
                                            damping: 50,
                                            stiffness: 300,
                                            delay: 0.6,
                                        }, children: jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M4.5 12.75l6 6 9-13.5" }) }) })] }), jsx(AlertDialogHeader, { mt: 4, children: title }), jsx(AlertDialogBody, { children: children }), jsx(AlertDialogFooter, { children: jsx(UpsellButton, { ref: closeButton, isJustified: true, onClick: onClose, children: buttonText }) })] })] }) }));
}

const Variable = forwardRef$1(function Variable_({ children, filters, ...props }, ref) {
    const styles = useStyleConfig("Variable");
    if (filters === undefined || filters.length === 0) {
        return (jsx(chakra.span, { ref: ref, __css: styles, ...props, children: jsx(Text, { isTruncated: true, className: "variable-cell", children: children }) }));
    }
    const [firstFilter, ...restFilters] = filters;
    const hasHiddenFilters = restFilters.length > 0;
    // Grouping the appended cells lets the tooltip anchor to (and center on)
    // the filters rather than the whole variable.
    const filterGroup = (jsxs(chakra.span, { className: "variable-group variable-divider", ...(hasHiddenFilters && { tabIndex: 0, cursor: "pointer" }), children: [jsx(Text, { isTruncated: true, className: "variable-cell", children: firstFilter.label }), hasHiddenFilters && (jsx(Text, { className: "variable-cell variable-divider", children: `+${restFilters.length}` }))] }));
    return (jsxs(chakra.span, { ref: ref, __css: styles, ...props, children: [jsx(Text, { isTruncated: true, className: "variable-cell", children: children }), hasHiddenFilters ? (jsx(Tooltip, { message: 
                // Override the tooltip theme's centered text and bullet rows manually.
                jsxs(Column, { gap: 1, align: "flex-start", textAlign: "left", children: [jsx(Text, { fontWeight: "medium", color: "white", children: "Transformations" }), jsx(Column, { gap: 0.5, align: "flex-start", children: filters.map((filter) => (jsxs(Row, { gap: 2, align: "flex-start", children: [jsx(Text, { color: "white", children: "\u2022" }), jsx(Text, { color: "white", children: filter.description ?? filter.label })] }, `${filter.label} ${filter.description ?? ""}`))) })] }), children: filterGroup })) : (filterGroup)] }));
});
Variable.displayName = "Variable";

function WizardSteps({ activeIndex, steps, ...props }) {
    const styles = useStyleConfig("WizardSteps");
    return (jsx(Box$1, { __css: styles, ...props, children: steps.map((step, index) => (jsx(WizardStep, { active: activeIndex === index, stepNumber: index + 1, ...step }, step.label))) }));
}
function WizardStep({ active, isDisabled = false, label, stepNumber, onClick, }) {
    const styles = useMultiStyleConfig("WizardStep", {
        variant: active ? "active" : undefined,
    });
    return (jsxs(Box$1, { as: onClick ? "button" : undefined, __css: styles["container"], disabled: isDisabled, onClick: onClick, children: [jsx(Box$1, { __css: styles["step"], children: jsx(Text, { color: active ? "white" : "text.secondary", children: stepNumber }) }), jsx(Text, { color: active ? "text.primary" : "text.secondary", fontWeight: "medium", children: label })] }));
}

function WizardDrawer({ activeStep: controlledActiveStep, blockBackgroundInteraction = true, closeOnOverlayClick = false, closeButtonVariant = "text", isOpen, title, hasOverlay = false, steps, size = "md", topDisplacement = 0, onClose, onStepChange, }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeStep, setActiveStep] = useState(controlledActiveStep ?? 0);
    const isControlled = controlledActiveStep !== undefined;
    const currentStep = steps[activeStep];
    const showSteps = steps.length > 1;
    const closeButton = useRef(null);
    const goForward = async () => {
        if (currentStep?.submit) {
            setIsSubmitting(true);
            try {
                await currentStep.submit();
                // Increment the step if not controlled
                if (!isControlled && activeStep < steps.length - 1) {
                    setActiveStep(activeStep + 1);
                }
            }
            catch (error) {
                await currentStep?.error?.(error);
            }
            finally {
                setIsSubmitting(false);
            }
        }
        else if (!isControlled) {
            setActiveStep(activeStep + 1);
        }
    };
    const goBack = () => {
        if (!isControlled) {
            if (activeStep > 0) {
                setActiveStep(activeStep - 1);
            }
        }
        else if ("back" in currentStep) {
            currentStep.back?.();
        }
        else if (controlledActiveStep > 0) {
            onStepChange?.(controlledActiveStep - 1);
        }
    };
    const handleSubmit = async () => {
        if (currentStep?.submit) {
            setIsSubmitting(true);
            try {
                await currentStep.submit();
            }
            finally {
                setIsSubmitting(false);
            }
        }
    };
    // Set active step when changed externally
    useEffect(() => {
        if (isControlled) {
            setActiveStep(controlledActiveStep);
        }
    }, [isControlled, controlledActiveStep]);
    useEffect(() => {
        if (!isOpen) {
            // TODO(eric.lovett): This `setActiveStep` call should probably be moved to a close
            // event handler.
            setActiveStep(0);
        }
    }, [isOpen, setActiveStep]);
    return (jsxs(Drawer, { blockBackgroundInteraction: blockBackgroundInteraction, closeOnOverlayClick: closeOnOverlayClick, contentWrapperStyles: {
            top: topDisplacement,
        }, initialFocusRef: closeButton, isOpen: isOpen, size: size, showOverlay: hasOverlay, onClose: onClose, children: [jsxs(DrawerHeader, { children: [jsx(Box$1, { flex: "1", minWidth: 0, children: jsx(Heading, { isTruncated: true, children: title }) }), closeButtonVariant === "text" ? (jsx(Button, { ref: closeButton, onClick: onClose, children: "Exit" })) : (jsx(IconButton, { ref: closeButton, "aria-label": "Close", icon: CloseIcon, onClick: onClose }))] }), showSteps && (jsx(Box$1, { px: 6, py: 4, borderBottom: "0.5 solid", borderColor: "base.border", children: jsx(WizardSteps, { activeIndex: activeStep, steps: steps.map(({ label, isDisabled }, index) => ({
                        label,
                        isDisabled: isDisabled ?? index > activeStep,
                        onClick: async () => {
                            // Allow changing step if step is not disabled and if the step has been completed
                            const isStepComplete = index < activeStep;
                            if (!isDisabled && isStepComplete) {
                                if (isControlled) {
                                    onStepChange?.(index);
                                }
                                else {
                                    setActiveStep(index);
                                }
                            }
                        },
                    })) }) })), jsx(DrawerBody, { bg: currentStep?.bodyBackground, children: currentStep?.render({}) }), jsx(DrawerFooter, { children: jsxs(Row, { align: "center", width: "100%", justify: activeStep === 0 && !("back" in currentStep)
                        ? "end"
                        : "space-between", children: [(activeStep > 0 || "back" in currentStep) && (jsx(Button, { icon: ArrowLeftIcon, size: "lg", onClick: goBack, children: currentStep?.backLabel ?? "Go back" })), jsx(Tooltip, { message: currentStep?.tooltip ?? "", isDisabled: !currentStep?.tooltip, children: activeStep === steps.length - 1 ? (jsx(Button, { isDisabled: currentStep?.isDisabled, isLoading: isSubmitting, size: "lg", variant: "primary", onClick: handleSubmit, children: currentStep?.continue ?? "Save" })) : typeof currentStep.continue === "string" ||
                                currentStep.continue === undefined ? (jsx(Button, { directionIcon: ArrowRightIcon, isLoading: isSubmitting, isDisabled: currentStep?.isDisabled, variant: "primary", size: "lg", onClick: goForward, children: currentStep?.continue ?? "Continue" })) : (jsx(Column, { height: 10, justify: "center", children: currentStep.continue })) })] }) })] }));
}

/**
 * Raw SVG path for the variant glyph, for the rare case a consumer must build an
 * icon as an HTML string rather than a React node (e.g. markup injected into an
 * editor). Prefer the `VariantIcon` component everywhere else — do not add new
 * uses of this raw path.
 */
const VARIANT_ICON_PATH = "M12 15C12.5523 15 13 15.4477 13 16V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V16C11 15.4477 11.4477 15 12 15Z M6.79297 15.793C7.18349 15.4024 7.81651 15.4024 8.20703 15.793C8.59756 16.1835 8.59756 16.8165 8.20703 17.207L6.70703 18.707C6.31651 19.0976 5.68349 19.0976 5.29297 18.707C4.90244 18.3165 4.90244 17.6835 5.29297 17.293L6.79297 15.793Z M15.793 15.793C16.1835 15.4024 16.8165 15.4024 17.207 15.793L18.707 17.293C19.0976 17.6835 19.0976 18.3165 18.707 18.707C18.3165 19.0976 17.6835 19.0976 17.293 18.707L15.793 17.207C15.4024 16.8165 15.4024 16.1835 15.793 15.793Z M8 11C8.55228 11 9 11.4477 9 12C9 12.5523 8.55228 13 8 13H2C1.44772 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H8Z M22 11C22.5523 11 23 11.4477 23 12C23 12.5523 22.5523 13 22 13H16C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11H22Z M12 1C12.5523 1 13 1.44772 13 2V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V2C11 1.44772 11.4477 1 12 1Z M5.29297 5.29297C5.68349 4.90244 6.31651 4.90244 6.70703 5.29297L8.20703 6.79297C8.59756 7.18349 8.59756 7.81651 8.20703 8.20703C7.81651 8.59756 7.18349 8.59756 6.79297 8.20703L5.29297 6.70703C4.90244 6.31651 4.90244 5.68349 5.29297 5.29297Z M17.293 5.29297C17.6835 4.90244 18.3165 4.90244 18.707 5.29297C19.0976 5.68349 19.0976 6.31651 18.707 6.70703L17.207 8.20703C16.8165 8.59756 16.1835 8.59756 15.793 8.20703C15.4024 7.81651 15.4024 7.18349 15.793 6.79297L17.293 5.29297Z";

export { ActivityIcon, AddBoxIcon, AddFilterIcon, AddTimeRangeIcon, AdminConfigIcon, AgentActivity, AgentFileIcon, AgentsIcon, AgentsLineIcon, AiSummaryIcon, Alert, AlertIcon, AlertingIcon, AlignHorizontalBottomIcon, AlignHorizontalCenterIcon, AlignHorizontalTopIcon, AlignVerticalCenterIcon, AlignVerticalLeftIcon, AlignVerticalRightIcon, AlignmentCenterIcon, AlignmentLeftIcon, AlignmentRightIcon, AnalyticsIcon, AppleIcon, ApprovalCard, ApproveIcon, ArchiveIcon, ArrayIcon, ArrowDiagonalUpRightIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightCircleIcon, ArrowRightIcon, ArrowUpIcon, AskUserCard, AspectRatioIcon, AssetsIcon, AudienceIcon, AudienceTemplateIcon, Avatar, Badge, BadgeButton, BadgeGroup, BadgeInput, BidirectionalArrowIcon, BigIntegerIcon, BigModeIcon, BlendIcon, BlurIcon, BoldIcon, BookIcon, BooleanIcon, BorderRadiusAllIcon, BorderRadiusBottomLeftIcon, BorderRadiusBottomRightIcon, BorderRadiusTopLeftIcon, BorderRadiusTopRightIcon, Box, BrandCenterIcon, BrandIcon, Breadcrumbs, BreakdownIcon, BuildingIcon, BulbSuggestionIcon, Button, ButtonGroup, CalendarDynamicIcon, CampaignsIcon, CartIcon, ChangeIcon, ChatIcon, CheckIcon, Checkbox, CheckboxGroup, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, CleanUpIcon, ClickIcon, ClipboardButton, CloseIcon, Code, CodeBlockIcon, CodeIcon, CodeSnippet, Column, ColumnChartIcon, ColumnDataIcon, ColumnIcon, Combobox, CommentIcon, CompactModeIcon, ComponentIcon, ConceptsIcon, ConfirmationDialog, ConnectionIcon, CopyIcon, CreditIcon, CubeIcon, CumulativeIcon, DashboardsIcon, DbtIcon, DebuggerIcon, Definition, DeleteIcon, DescriptionAddIcon, DescriptionIcon, DestinationIcon, Dialog, DictationMicrophoneIcon, DictationMicrophoneOffIcon, DollarIcon, DotIcon, DottedCircleIcon, DownloadIcon, DraftIcon, DragIcon, Drawer, DynamicTableIcon, EditIcon, EditableDescription, EditableHeading, EditableText, EmailIcon, EmaileditorButtonEmojiIcon, EmaileditorButtonIcon, EmaileditorDividerIcon, EmaileditorGifIcon, EmaileditorMenuIcon, EmaileditorParagraphIcon, EmaileditorSocialIcon, EmaileditorSpacerIcon, EmaileditorStickerIcon, EmaileditorTitleIcon, EmaileditorVideoIcon, EmptyState, EnterIcon, ErrorIcon, ExitIcon, ExpandIcon, ExperimentIcon, ExtendedUpsellCard, ExtensionsIcon, ExternalLinkIcon, EyeIcon, FavoriteIcon, FavoritedIcon, FileIcon, FileInput, FileUploadError, FilterIcon, FilterMenu, FilterMenuButton, FilterMenuGroup, FilterMenuIconButton, FilterMenuList, FilterMenuOption, FilterOptionList, FilterPill, FilterPillButton, FilterPillMultiSelect, FlagIcon, FlipHorizontallyIcon, FlipVerticallyIcon, FlowsIcon, FocusIcon, FolderAddIcon, FolderIcon, FolderMoveIcon, FolderOpenIcon, FolderRemoveIcon, FoldersIcon, FormField, FrameIcon, FrameStackIcon, FullScreenModal, FunctionIcon, FunnelIcon, GalleryIcon, GlobalAnnouncement, GlobalAnnouncementPopover, GlobeIcon, GroupedBadgeInput, GroupedCombobox, GroupedMultiSelect, GroupedSelect, Heading, HeatmapIcon, HiddenFormLabel, HideIcon, HistoryIcon, HouseholdIcon, HtImage, HtVideo, IconBox, IconBubbleCheckIcon, IconButton, IdeaIcon, IdentityIcon, IgnoreIcon, ImageIcon, ImgRotate90Icon, InAppIcon, InformationIcon, InsightsAgentCloseIcon, InsightsAgentOpenIcon, InsightsIcon, ItalicIcon, JourneyIcon, JourneyTemplateIcon, KanbanIcon, KeyIcon, LabelBadgeGroup, LaunchAdIcon, LawGavelIcon, LawScaleIcon, LightningBoltIcon, LightningBoltWithSlashIcon, LimitIcon, LinearIcon, Link, LinkButton, LinkIcon, ListBulletedIcon, ListNumberedIcon, LocalizeIcon, LockAspectRatioIcon, LockIcon, LogoutIcon, MailBounceIcon, MailClickIcon, MailIcon, MailOpenIcon, MailSendIcon, ManagerIcon, MapIcon, MeetingIcon, Menu, MenuActionsButton, MenuBadgeButton, MenuButton, MenuDivider, MenuIconButton, MenuItem, MenuList, MergeIcon, MessagesIcon, MetricIcon, MinimalUpsellCard, MobilePhoneIcon, ModelIcon, MonitorIcon, MoonIcon, MoonStarIcon, MotionBox, MotionButton, MotionCircle, MotionLine, MotionPath, MotionRect, MotionSpan, MotionSvg, MotionText, MoveIcon, MultiSelect, MuseIcon, NeedsChangesIcon, NewChatIcon, NotificationCheckIcon, NullIcon, NumberIcon, NumberInput, NumberSignIcon, ObjectIcon, OrbitIcon, OverflowMenuIcon, OverlapIcon, PaddingIcon, PaperclipIcon, Paragraph, PauseIcon, PercentIcon, PerformanceIcon, PhoneIcon, PieIcon, PinIcon, PinnedIcon, PlanIcon, PlayIcon, PlusIcon, Popover, PopoverBody, PopoverContent, PopoverTrigger, Portal, ProgressBar, ProgressCircle, ProjectsIcon, PromptInputMenuButton, PromptInputPillButton, PromptInputSubmitButton, PromptInputToggle, PublishIcon, PushBouncedIcon, PushClickedIcon, PushDeliveredIcon, PushIcon, PushSentIcon, PushTappedIcon, QuestionIcon, Radio, RadioGroup, RedactedIcon, RedoIcon, ReferenceIcon, RefreshIcon, RemoveTimeRangeIcon, ResetIcon, RotateIcon, Row, SearchIcon, SearchInput, SectionHeading, SegmentedControl, SegmentedControlOption, Select, SelectToggleButton, SelectorIcon, SendMessageIcon, SendMessageLineIcon, SequencesIcon, SettingSliderIcon, SettingsIcon, ShortcutIcon, ShuffleIcon, Skeleton, SkeletonBox, Slider, SlugInput, SmsBouncedIcon, SmsIcon, SmsOpenedIcon, SmsSentIcon, SmsTappedIcon, SortVerticalDownIcon, SortVerticalIcon, SortVerticalUpIcon, SourceIcon, SparkleIcon, SparkleSquareIcon, Spinner, SplitButton, SplitIcon, SqlIcon, StarBadgeIcon, StarIcon, StarredIcon, Stats, StatsItem, StatsItemTitle, StatsItemValue, StatusIndicator, StopIcon, StrikethroughSIcon, StylesIcon, SubtractIcon, SuccessIcon, SunIcon, SunriseIcon, SunsetIcon, Switch, SyncIcon, SyncTemplateIcon, Tab, TabList, TabNav, TabNavLink, TabPanel, TabPanels, TabbedCombobox, TableIcon, Tabs, TagIcon, TelescopeIcon, TemplatesIcon, Text, TextAlignVerticalDownIcon, TextAlignVerticalUpIcon, TextAutoHeightIcon, TextAutoWidthIcon, TextFixedWidthIcon, TextInput, TextStringIcon, TextWithTooltip, Textarea, ThemeProvider, ThumbDownFilledIcon, ThumbDownIcon, ThumbUpFilledIcon, ThumbUpIcon, TieredProgressBar, TimeIcon, ToggleButton, ToggleButtonGroup, Tooltip, TraitIcon, TraitTemplateIcon, TrendDownIcon, TrendUpIcon, TrendsIcon, UnderConstructionIcon, UnderlineIcon, UndoIcon, UnionIcon, UnlinkIcon, UnlockedIcon, UnpinIcon, UpgradeIcon, UpsellButton, UpsellCard, UpsellHeading, UpsellSuccessDialog, UserIcon, VARIANT_ICON_PATH, Variable, VariableIcon, VariantIcon, VolumeIcon, VolumeOffIcon, WandIcon, WarningIcon, WhatsappIcon, WizardDrawer, dropdownVariants, fadeDownVariants, fadeUpVariants, fullScreenModalVariants, getSurfaceStyle, hoverDelayMs, isVideoSrc, motionDurations, motionEasings, popoverVariants, promptInputPillIconSize, resolveSurface, tooltipVariants, useSurfaceStyle, useToast, useToggleButtonGroupVariant, variantIcons, variantTextColors };
